import * as React from 'react';
import React__default, { Component, useState, useEffect, createContext, forwardRef, createElement, PureComponent, useRef, useImperativeHandle, useContext, createRef, cloneElement, Children, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import 'fbjs/lib/shallowEqual';
import hoistNonReactStatics from 'hoist-non-react-statics';
import 'change-emitter';
import styled, { ThemeContext as ThemeContext$2, css as css$4, createGlobalStyle, keyframes as keyframes$2 } from 'styled-components';
import { Flex, Box } from 'reflexbox';
import getDisplayName$1 from 'recompose/getDisplayName';
import assign from 'object-assign';
import AnimateHeight from 'react-animate-height';
import '@babel/runtime/helpers/slicedToArray';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/assertThisInitialized';
import _typeof$f from '@babel/runtime/helpers/typeof';
import '@babel/runtime/helpers/inheritsLoose';
import ReactDOM, { createPortal, findDOMNode as findDOMNode$3 } from 'react-dom';
import AutosizeInput from 'react-input-autosize';
import '@babel/runtime/helpers/taggedTemplateLiteral';
import Highlighter from 'react-highlight-words';
import { Tooltip as Tooltip$3 } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import classNames$1 from 'classnames';
import Axios from 'axios';
import Img$1 from 'react-image';
import moment from 'moment';
import includes from 'lodash/includes';
import MaskedInput from 'react-text-mask';
import OutsideClickHandler from 'react-outside-click-handler';
import DateTime from 'react-datetime';
import { DateRangePicker } from 'react-dates';
import InputMask from 'react-input-mask';
import shallowEqual from 'shallowequal';
import { isMemo } from 'react-is';
import raf from 'raf';
import FlagComp from 'react-world-flags';
import 'react-fast-compare';
import SwipeableViews from 'react-swipeable-views';
import ReactModal from 'react-modal';
import ReactDOMServer from 'react-dom/server';
import 'lodash';
import metadata$1 from 'libphonenumber-js/metadata.min.json';
import en from 'react-phone-number-input/locale/en.json';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { bindKeyboard, virtualize } from 'react-swipeable-views-utils';
import SlidingPanel from 'react-sliding-side-panel';
import _extends$h from 'babel-runtime/helpers/extends';
import _classCallCheck$k from 'babel-runtime/helpers/classCallCheck';
import _createClass$j from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn$d from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits$d from 'babel-runtime/helpers/inherits';
import warning$3 from 'warning';
import _defineProperty$l from 'babel-runtime/helpers/defineProperty';
import _objectWithoutProperties$d from 'babel-runtime/helpers/objectWithoutProperties';
import _get$1 from 'babel-runtime/helpers/get';
import addDOMEventListener from 'add-dom-event-listener';
import _toConsumableArray$3 from 'babel-runtime/helpers/toConsumableArray';
import { useTable, useSortBy, usePagination, useRowSelect } from 'react-table';
import ReactPaginate from 'react-paginate';

function _typeof$e(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$e = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof$e = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$e(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$j(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$h(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$i(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$h(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$h(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$k(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$g() {
  _extends$g = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$g.apply(this, arguments);
}

function ownKeys$d(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$d(Object(source), true).forEach(function (key) {
        _defineProperty$k(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$d(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits$c(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$b(subClass, superClass);
}

function _getPrototypeOf$b(o) {
  _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$b(o);
}

function _setPrototypeOf$b(o, p) {
  _setPrototypeOf$b = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$b(o, p);
}

function _isNativeReflectConstruct$b() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$d(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$c(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$d(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$b(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$c(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$b(self);
}

function _createSuper$b(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$b();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$b(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$b(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$c(this, result);
  };
}

function _taggedTemplateLiteral$1(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray$8(arr, i) {
  return _arrayWithHoles$8(arr) || _iterableToArrayLimit$8(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$8();
}

function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread$2();
}

function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$3(arr);
}

function _arrayWithHoles$8(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray$2(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit$8(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$3(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}

function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$8() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _extends$f() {
  _extends$f = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$f.apply(this, arguments);
}

function _setPrototypeOf$a(o, p) {
  _setPrototypeOf$a = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$a(o, p);
}

function _objectWithoutPropertiesLoose$c(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
}

/* global window */

var root$1;

if (typeof self !== 'undefined') {
  root$1 = self;
} else if (typeof window !== 'undefined') {
  root$1 = window;
} else if (typeof global !== 'undefined') {
  root$1 = global;
} else if (typeof module !== 'undefined') {
  root$1 = module;
} else {
  root$1 = Function('return this')();
}

symbolObservablePonyfill(root$1);

var compose$1 = function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  }, function (arg) {
    return arg;
  });
};

/**
 * General font styles
 */
var font = {
  fontFamily: '"Open Sans", sans-serif',
  titlesFont: '"Rajdhani", "Open Sans", sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  fontSizeBase: '14px'
};
var colors$1 = {
  darkNavy: '#232537',
  navy: '#002d41',
  dusk: '#3b3f4b',
  coolGrey: '#91929b',
  red: '#d53d4f',
  redLight: '#ff3e48',
  coralPink: '#d8271e',
  lightTan: '#fad8d8',
  skin: '#fef6cc',
  turquoise: '#00a6b8',
  turquoiseBlue: '#00a6b8',
  grass: '#028a3d',
  lightTanGreen: '#eafdea',
  grassGreen: '#028a3d',
  bluishGreen: '#14b158',
  algaeGreen: '#27d974',
  lightTeal: '#aef1cb',
  paleGreen: '#EAFDEA',
  night: '#0063a0',
  cerulean: '#007ecc',
  azure: '#0093EE',
  greyBlue: '#8dabc4',
  skyBlue: '#c8e6f4',
  silver: '#c6c7c7',
  iceBlue: '#f3fcff',
  offwhite: '#f6f6f6',
  offwhiteTwo: '#fafbfc',
  orange: '#f5a213',
  marigold: '#ffc300',
  eggBlue: '#ace8f0',
  lightNavy: '#125c9b',
  lightMint: '#bdf6c2',
  darkGreen: '#237957',
  lightViolet: '#e7d8fc',
  violet: '#715397',
  paleSalmon: '#fbbea4',
  rouge: '#9b0f1f',
  darkCream: '#fdea9a',
  rawSienna: '#9c6b02',
  white: '#fff',
  ice: '#e5e6e6',
  slateGrey: '#53575f',
  grey100: '#f8f9fa',
  grey200: '#e9ecef',
  grey300: '#dee2e6',
  grey400: '#c3cad2',
  grey500: '#a3aab0',
  grey600: '#6c757d',
  grey700: '#495057',
  grey800: '#343a40',
  grey900: '#212529',
  black: '#000'
};
var brand = {
  primary: '#2075bd',
  secondary: '#6c757d',
  success: '#28a745',
  info: '#17a2b8',
  warning: colors$1.marigold,
  danger: colors$1.coralPink,
  error: colors$1.coralPink,
  light: '#f8f9fa',
  dark: '#343a40'
};
var general = {
  space: [0, 6, 12, 18, 24, 32, 64],
  breakpoints: ['768px', '992px', '1200px', '1440px'],
  borderRadius: '4px',
  gutter: 24,
  errorBg: colors$1.lightTan,
  errorAccent: colors$1.coralPink,
  successBg: colors$1.lightTeal,
  successAccent: colors$1.bluishGreen,
  primaryBg: colors$1.skyBlue,
  primaryAccent: colors$1.azure,
  warningBg: colors$1.lightTan,
  warningAccent: colors$1.orange,
  textColor: colors$1.dusk,
  textLightColor: colors$1.greyBlue,
  addressMapHeight: '300px',
  anchorColor: null,
  anchorTextDecoration: 'none',
  focusOutline: '0 0 0 2px #92D9FC'
};
var input = {
  inputHeight_large: '40px',
  inputHeight_normal: '32px',
  inputHeight_small: '24px',
  inputPlaceholderColor: colors$1.greyBlue,
  inputLabelColor: colors$1.dusk,
  inputLabelColorDisabled: colors$1.grey400,
  inputRequiredIndicator: '*',
  inputRequiredIndicatorColor: colors$1.grey500,
  inputBackground: colors$1.white,
  inputBackgroundDisabled: colors$1.offwhite,
  inputBackgroundError: '#ffede1',
  inputPaddingY: '4px',
  inputPaddingX: '11px',
  inputLineHeight: 1.25,
  inputFontSize: font.fontSizeBase,
  inputFontWeight: 400,
  inputColor: colors$1.dusk,
  inputColorDisabled: '#8a8d8f',
  inputBorderColor: colors$1.silver,
  inputBorderDisabled: colors$1.ice,
  inputBorderWidth: '1px',
  inputFocusBorderColor: null,
  inputPresetBackground: colors$1.grey200,
  inputPresetBorderColor: colors$1.silver,
  inputHorizontalLabelWidth: '140px',
  inputButtonColor: null,
  inputClearColor: colors$1.greyBlue,
  inputClearHover: null,
  multiValueColor: null,
  multiValueBg: colors$1.eggBlue
};
var button = {
  buttonHeightSmall: '24px',
  buttonHeight: '32px',
  buttonHeightLarge: '40px',
  buttonHeightXLarge: '48px',
  buttonFontSm: '12px',
  buttonFont: '14px',
  buttonFontLg: '16px',
  buttonFontXl: '20px',
  buttonDefaultColor: null,
  buttonDefaultBackground: colors$1.white,
  buttonDefaultBackgroundHover: colors$1.offwhite,
  buttonPrimaryColor: colors$1.white,
  buttonPrimaryBackground: null,
  buttonSecondaryColor: colors$1.white,
  buttonSecondaryBackground: null,
  buttonSuccessColor: colors$1.white,
  buttonSuccessBackground: null,
  buttonWarningColor: colors$1.white,
  buttonWarningBackground: null,
  buttonDangerColor: colors$1.white,
  buttonDangerBackground: null,
  buttonDarkColor: colors$1.white,
  buttonDarkBackground: null,
  buttonLightColor: brand.primary,
  buttonLightBackground: null,
  buttonLinkColor: null,
  buttonLinkBackground: 'transparent',
  buttonBorderColor: null,
  buttonHoverShadow: 'none',
  buttonPaddingSm: '11px',
  buttonPadding: '15px',
  buttonPaddingLg: '23px',
  buttonPaddingXl: '60px',
  buttonsToolbarMarginRight: '5px',
  buttonsToolbarMarginBottom: '10px',
  richTextBackground: colors$1.white,
  richTextToolbarBackground: colors$1.white
};
var icon = {
  iconDefaultColor: null,
  iconDefaultSize: 24,
  iconHoverColor: null,
  iconDisabledColor: colors$1.grey400
};
var toggleButtons = {
  toggleButtonBg: colors$1.white,
  toggleButtonBgSelected: '#e1f5f9',
  toggleButtonBgDisabled: colors$1.grey100,
  toggleButtonBgSelectedDisabled: colors$1.grey300,
  toggleButtonColor: colors$1.slateGrey,
  toggleButtonColorSelected: null,
  toggleButtonColorDisabled: colors$1.grey400,
  toggleButtonColorSelectedDisabled: colors$1.grey500,
  toggleButtonBorder: colors$1.silver,
  toggleButtonBorderSelected: null,
  toggleButtonBorderDisabled: colors$1.grey200,
  toggleButtonBorderSelectedDisabled: colors$1.grey300,
  toggleButtonLineHeight: input.inputLineHeight,
  toggleButtonBorderRadius: general.borderRadius
};
var tooltip = {
  tooltipBg: '#232533',
  tooltipTextColor: '#FFF',
  tooltipBorderRadius: '4px',
  tooltipFontSize: '13px',
  tooltipMaxWidth: '200px',
  tooltipPadding: '10px 20px'
};
var calendar = {
  calendarDayFontSize: '1em',
  calendarInputHeight: '35px',
  calendarDaySelectionWidth: '27px',
  calendarDaySelectionHeight: '27px',
  calendarColor: colors$1.dusk,
  calendarDayActive: null,
  calendarColorActive: colors$1.white,
  calendarColorActiveHover: colors$1.white,
  calendarDayInactive: colors$1.silver,
  calendarDayHoverColor: colors$1.greyBlue,
  calendarRangeBg: '#29fc85',
  calendarRangeStartEndBg: colors$1.algaeGreen,
  reactDatesWidthDayPicker: '300px',
  calendarBg: colors$1.white,
  calendarBoxShadow: '0 1px 4px 0 rgba(43, 63, 89, 0.21)',
  calendarNavBtnColor: colors$1.greyBlue,
  calendarWeekColor: colors$1.greyBlue
};
var switchbox = {
  switchTrackHeight: 20,
  switchTrackWidth: 40,
  switchTrackBgColorOn: null,
  switchTrackBgColorOff: colors$1.grey300,
  switchNobColor: colors$1.white,
  switchNobShadow: '0 3px 2px 0 rgba(9, 11, 15, 0.06)'
};
var dropMenu = {
  dropmenuBackground: colors$1.white,
  dropmenuMaxHeight: '200px',
  dropmenuHeaderBg: colors$1.azure,
  dropmenuHeaderColor: colors$1.offwhite,
  menuItemColor: colors$1.dusk,
  menuItemColorDisabled: colors$1.greyBlue,
  menuItemBackground: colors$1.white,
  menuItemBackgroundHover: colors$1.iceBlue,
  menuItemSelectedBg: colors$1.skyBlue,
  menuItemPadding: '8px 16px'
};
var menus = {
  menuBackground: '#FFF',
  menuBorderColor: '#FFF',
  menuPopupBg: '#FFF',
  menuFontSize: '14px',
  menuItemColor: colors$1.dusk,
  menuItemColorHover: null,
  menuItemColorActive: null,
  menuItemActiveBg: colors$1.iceBlue,
  menuItemColorDisable: '#f5f5f5',
  menuItemBorderColor: '#f5f5f5',
  menuGroupColor: colors$1.dusk,
  menuGroupColorActive: null,
  menuGroupBorderColor: '#F5F5F5',
  subMenuOpenBg: '#F5F5F5',
  subMenuOpenColor: colors$1.dusk,
  subMenuItemBg: '#FAFAFA',
  subMenuItemBgHover: '#F5F5F5',
  subMenuItemColor: colors$1.dusk,
  menuArrowColor: colors$1.dusk,
  menuArrowColorActive: null,
  menuIconColor: colors$1.dusk,
  menuIconColorActive: null,
  menuDividerColor: '#e5e5e5',
  menuDividerHeight: '1px'
};
var zIndexes = {
  zIndexDropdown: 1000,
  zIndexSticky: 1020,
  zIndexFixed: 1030,
  zIndexModalBackdrop: 1040,
  zIndexModal: 1050,
  zIndexPopover: 1060,
  zIndexTooltip: 1070
};
var checkboxes = {
  checkboxSize: '18px',
  checkboxBg: colors$1.white,
  checkboxCheckedBg: brand.primary,
  checkboxCheckedBgDisabled: input.inputBackgroundDisabled,
  checkboxBorderWidth: '1px',
  checkboxOptionDescriptionColor: colors$1.greyBlue,
  checkboxBorderRadius: '2px',
  checkMarkColor: colors$1.white,
  checkMarkColorDisabled: colors$1.grey500
};
var radioButtons = {
  radioBg: colors$1.white,
  radioHoverColor: null,
  radioActiveColor: null,
  radioDisabledBorderColor: colors$1.ice,
  radioDisabledBackground: '#8a8d8f',
  radioOptionDescriptionColor: colors$1.greyBlue,
  radioColor: colors$1.silver,
  radioCircleSize: 16,
  radioCircleInnerSize: 8
};
var slider = {
  sliderHeight: 4,
  sliderRadius: general.borderRadius,
  sliderTrackBg: colors$1.grey200,
  sliderActiveColor: colors$1.skyBlue,
  sliderDotSize: 8,
  sliderHandleSize: 12,
  sliderHandleColor: null,
  sliderTipValueBackground: colors$1.dusk,
  sliderTipValueColor: colors$1.white,
  sliderValueColor: colors$1.greyBlue,
  sliderTooltipArrowWidth: 4,
  sliderTooltipDistance: 4,
  sliderTooltipArrowColor: colors$1.greyBlue,
  sliderTooltipBg: colors$1.dusk,
  sliderTooltipColor: colors$1.white
};
var stepper = {
  stepperBorderColor: colors$1.silver,
  stepperContentPadding: '10px 20px',
  stepColor: colors$1.greyBlue,
  stepColorActive: null,
  stepContentBackground: colors$1.white,
  stepTabBackground: colors$1.grey100
};
var accordion = {
  accordionTabBackground: colors$1.grey100,
  accordionTabContentBackground: colors$1.white,
  accordionTabColor: general.textColor,
  accordionTabPaddingY: general.space[3],
  accordionTabPaddingX: general.space[3],
  accordionTabFontSize: '15px',
  accordionBorderColor: colors$1.silver
};
var card = {
  cardBorderWidth: '0px',
  cardBorderColor: null,
  cardHeaderHeight: '40px',
  cardHeaderColor: colors$1.dusk,
  cardHeaderFontSize: '22px',
  cardHeaderFontWWeight: 600,
  cardHeaderBackground: colors$1.offwhiteTwo,
  cardHeaderPaddingY: general.space[1],
  cardHeaderPaddingX: general.space[4],
  cardHeaderBorderColor: general.space[4],
  cardBackground: colors$1.white,
  cardBodyColor: colors$1.dusk,
  cardShadow: '0 0 10px 0 rgba(35, 37, 55, 0.12)',
  cardBorderRadius: general.borderRadius,
  cardPaddingY: general.space[3],
  cardPaddingX: general.space[4],
  cardMarginBottom: '10px'
};
var alert = {
  alertPaddingSmall: '5px 15px',
  alertPaddingLarge: '16px 24px',
  alertBorderRadius: general.borderRadius,
  alertBorderColor: 'transparent',
  alertBorderWidth: '0px',
  alertIndentWidth: '4px',
  alertInfoBackground: colors$1.skyBlue,
  alertInfoAccent: colors$1.night,
  alertWarningBackground: colors$1.skin,
  alertWarningAccent: colors$1.orange,
  alertSuccessBackground: colors$1.lightTanGreen,
  alertSuccessAccent: colors$1.grassGreen,
  alertErrorBackground: colors$1.lightTan,
  alertErrorAccent: colors$1.redLight,
  alertTitleFontSize: '20px',
  alertBodyFontSize: '14px',
  alertTitleColor: general.darkNavy,
  alertBodyColor: general.darkNavy,
  alertIconColor: general.textColor,
  alertIconSize: '30px',
  alertCloseSize: '20px',
  alertCloseColor: general.darkNavy
};
var avatar = {
  avatarDefaultBg: colors$1.lightViolet,
  avatarDefaultColor: colors$1.violet,
  avatarInfoBg: colors$1.eggBlue,
  avatarInfoColor: colors$1.lightNavy,
  avatarDangerBg: colors$1.lightTanSalmon,
  avatarDangerColor: colors$1.rouge,
  avatarNeutralBg: colors$1.ice,
  avatarNeutralColor: colors$1.slateGrey,
  avatarSuccessBg: colors$1.lightMint,
  avatarSuccessColor: colors$1.darkGreen,
  avatarWarningBg: colors$1.darkCream,
  avatarWarningColor: colors$1.rawSienna
};
var modal = {
  modalBorderRadius: general.borderRadius,
  modalBorderColor: 'transparent',
  modalOverlayBackground: 'rgba(0,0,0,0.5)',
  modalHeaderBackground: colors$1.white,
  modalHeaderColor: colors$1.dusk,
  modalHeaderTextAlign: 'center',
  modalHeaderFontSize: '24px',
  modalHeaderLineHeight: 0.75,
  modalHeaderPaddingY: general.gutter / 2,
  modalHeaderPaddingX: general.gutter,
  modalBodyBackground: colors$1.white,
  modalInfoBodyBackground: colors$1.grey200,
  modalBodyColor: colors$1.dusk,
  modalBodyFontSize: '14px',
  modalBodyPaddingY: general.gutter,
  modalBodyPaddingX: general.gutter,
  minModalWidth: '400px',
  maxModalWidth: '85%',
  minInfoModalWidth: '400px',
  maxInfoModalWidth: '650px'
};
var toast = {
  toastMaxWidth: '350px',
  toastPaddingX: '.75em',
  toastPaddingY: '.25em',
  toastFontSize: '.875em',
  toastColor: 'transparent',
  toastBackgroundColor: "rgba(".concat(colors$1.white, ", .85)"),
  toastBorderWidth: '1px',
  toastBorderColor: 'rgba(0, 0, 0, .1)',
  toastBorderRadius: '.25em',
  toastBoxShadow: '0 .25em .75em rgba($black, .1)',
  toastHeaderColor: colors$1.grey600,
  toastHeaderBackground: "rgba(".concat(colors$1.white, ", .85)"),
  toastHeaderBorderColor: 'rgba(0, 0, 0, .05)',
  notificationInfoColor: brand.primary,
  notificationWarningColor: brand.warning,
  notificationSuccessColor: brand.success,
  notificationErrorColor: brand.error,
  notificationPadding: "".concat(general.gutter / 2, "px ").concat(general.gutter / 2, "px"),
  toastPadding: "".concat(general.gutter / 2, "px ").concat(general.gutter / 2, "px"),
  notificationBorderRadius: general.borderRadius
};
var chip = {
  chipFontSize: '12px',
  chipDefaultBg: colors$1.ice,
  chipDefaultColor: colors$1.slateGrey,
  chipPrimaryBg: colors$1.eggBlue,
  chipPrimaryColor: colors$1.lightNavy,
  chipDangerBg: colors$1.lightTanSalmon,
  chipDangerColor: colors$1.white,
  chipSuccessBg: colors$1.lightMint,
  chipSuccessColor: colors$1.darkGreen,
  chipWarningBg: colors$1.darkCream,
  chipWarningColor: colors$1.rawSienna,
  chipLightBg: colors$1.lightViolet,
  chipLightColor: colors$1.violet
};
var collapsingPanel = {
  collapseHeaderBackground: 'transparent',
  collapseHeaderColor: colors$1.dusk,
  collapseHeaderColorDisabled: colors$1.coolGrey,
  collapseHeaderBorderWidth: '1px',
  collapseHeaderBorderColor: 'transparent',
  collapseHeaderMarginBottom: '5px',
  collapseHeaderBorderRadius: general.borderRadius,
  collapseArrowColor: colors$1.greyBlue,
  collapseBadgeBackground: colors$1.skin,
  collapseBadgeColor: colors$1.orange,
  collapseBadgeBorderColor: colors$1.orange,
  collapseAdditionalInfoBackground: 'transparent',
  collapseAdditionalInfoBorderColor: 'transparent',
  collapseAdditionalInfoBorderWidth: '1px',
  collapseAdditionalInfoBorderRadius: general.borderRadius
};
var tabs = {
  tabsBackground: null,
  tabItemColor: colors$1.dusk,
  tabItemColorSelected: null,
  tabSpace: general.space[2],
  tabFontSize: '16px',
  tabContentPadding: general.gutter / 2,
  tabsBorderWidth: '1px',
  tabsBorderColor: '#c6c7c7',
  tabHighlightHeight: '2px',
  tabHighlightColor: null,
  tabHighlightAnimation: 'all 1s cubic-bezier(0.23, 1, 0.32, 1) 0ms'
};
var sidepanel = {
  sidepanelOverlayBgColor: 'rgba(0,0,0,0.2)',
  sidepanelContentBgColor: '#FFF',
  sidepanelHeaderBgColor: '#FFF'
};
var table = {
  tableHeaderBackground: "#fafafa",
  tableHeaderColor: general.textColor,
  tableHeaderCellPaddingY: "".concat(general.space[2], "px"),
  tableHeaderCellPaddingX: "".concat(general.space[2], "px"),
  tableHeaderWeight: '600',
  tableHeaderSize: '14px',
  tableCellPaddingY: "".concat(general.space[2], "px"),
  tableCellPaddingX: "".concat(general.space[2], "px"),
  tableCellSize: '14px',
  tableBorderColor: '#F0F0F0',
  tableSortIconsColor: '#91929b',
  tableSortIconsColorActive: general.textColor,
  tableMenuIconsColor: '#666',
  tableResizeColor: '#91929b',
  tableMenuIconsColorActive: general.textColor,
  tableRowTextColor: general.textColor,
  tableRowBorderColor: '#F0F0F0',
  tableRowDefaultBackground: colors$1.white,
  tableRowHoverColor: '#FAFAFA',
  tableRowSelectedColor: '#e6f7ff',
  paginationButtonColor: colors$1.grey600,
  paginationButtonBackground: '#FFF',
  paginationButtonActive: brand.primary,
  paginationButtonHover: brand.primary,
  paginationButtonPadding: '0px 5px',
  paginationButtonDisabled: colors$1.grey300,
  noDataFontSize: '15px',
  noDataColor: colors$1.grey500
};
var progress$1 = {
  progressBarHeight: 30,
  progressBarTrackColor: colors$1.grey300,
  progressBarLabelColor: colors$1.grey900,
  progressBarBorderRadius: general.borderRadius,
  progressLineTrackColor: colors$1.grey300,
  progressLineLabelColor: colors$1.grey900,
  progressLineBorderRadius: general.borderRadius,
  progressCircleTrackColor: colors$1.grey300,
  progressCircleLabelColor: colors$1.grey900,
  progressCircleBorderRadius: general.borderRadius
};
var theme = _objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, general), colors$1), font), input), button), icon), toggleButtons), brand), tooltip), calendar), switchbox), dropMenu), zIndexes), checkboxes), radioButtons), slider), stepper), card), alert), avatar), modal), toast), chip), collapsingPanel), tabs), menus), sidepanel), table), progress$1), accordion);

var ThemeContext$1 = /*#__PURE__*/React__default.createContext(theme);
/**
 *
 * Theme context for external components
 *
 */

ThemeContext$1.Extend = function (_ref) {
  var children = _ref.children,
      value = _ref.value;
  return /*#__PURE__*/React__default.createElement(ThemeContext$1.Consumer, null, function (theme) {
    return /*#__PURE__*/React__default.createElement(ThemeContext$1.Provider, {
      value: _objectSpread2$2(_objectSpread2$2({}, theme), value)
    }, children);
  });
};

ThemeContext$1.Extend.propTypes = {
  children: PropTypes.node.isRequired,
  providedTheme: PropTypes.shape({}).isRequired
};

/**
 *
 * HOC that merges the default theme with provided
 *
 */

var withTheme = function withTheme(WrappedComponent) {
  var ThemedComponent = /*#__PURE__*/function (_Component) {
    _inherits$c(ThemedComponent, _Component);

    var _super = _createSuper$b(ThemedComponent);

    function ThemedComponent() {
      _classCallCheck$j(this, ThemedComponent);

      return _super.apply(this, arguments);
    }

    _createClass$i(ThemedComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            withThemeRef = _this$props.withThemeRef,
            theme = _this$props.theme,
            rest = _objectWithoutProperties$c(_this$props, ["withThemeRef", "theme"]);

        return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends$g({
          ref: withThemeRef
        }, rest, {
          theme: theme
        }));
      }
    }]);

    return ThemedComponent;
  }(Component);

  var ForwardRef = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var providedTheme = React__default.useContext(ThemeContext$2);
    var _props$theme = props.theme,
        themeOverride = _props$theme === void 0 ? {} : _props$theme; // check if theme is passed directly to the component

    var consolidatedTheme = _objectSpread2$2(_objectSpread2$2({}, providedTheme), themeOverride);

    return /*#__PURE__*/React__default.createElement(ThemeContext$1.Consumer, null, function (theme) {
      return /*#__PURE__*/React__default.createElement(ThemedComponent, _extends$g({}, props, {
        theme: _objectSpread2$2(_objectSpread2$2({}, theme), consolidatedTheme),
        withThemeRef: ref
      }));
    });
  });
  ForwardRef.displayName = getDisplayName$1(WrappedComponent);
  ForwardRef.name = ForwardRef.displayName;
  return ForwardRef;
};

var withTransformers = function withTransformers(Component) {
  var Comp = /*#__PURE__*/function (_React$Component) {
    _inherits$c(Comp, _React$Component);

    var _super = _createSuper$b(Comp);

    function Comp() {
      var _this;

      _classCallCheck$j(this, Comp);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty$k(_assertThisInitialized$b(_this), "getTransformedValue", function (value) {
        var transformOut = _this.props.transformOut;
        if (transformOut) return transformOut(value);
        return value;
      });

      _defineProperty$k(_assertThisInitialized$b(_this), "transformChange", function (value) {
        var onChange = _this.props.onChange;
        onChange(_this.getTransformedValue(value));
      });

      _defineProperty$k(_assertThisInitialized$b(_this), "transformValueChange", function (value) {
        var onValueChange = _this.props.onValueChange;
        if (onValueChange) onValueChange(_this.getTransformedValue(value));
      });

      return _this;
    }

    _createClass$i(Comp, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            transformIn = _this$props.transformIn,
            transformOut = _this$props.transformOut,
            rest = _objectWithoutProperties$c(_this$props, ["transformIn", "transformOut"]);

        var newProps = _objectSpread2$2({}, rest);

        if (transformIn) newProps.value = transformIn(rest.value);

        if (transformOut) {
          newProps.onChange = this.transformChange;
          if (rest.onValueChange) newProps.onValueChange = this.transformValueChange; // if (rest.onBlur) newProps.onBlur = this.transformBlur;
        } // value: transformIn ? transformIn(value) : value,
        // onChange: transformOut ? this.transformChange : onChange,
        // onValueChange: transformOut ? this.transformValueChange : onValueChange,
        // onBlur: transformOut ? this.transformBlur : onBlur,
        // };
        // eslint-disable-next-line react/jsx-props-no-spreading


        return /*#__PURE__*/React__default.createElement(Component, newProps);
      }
    }]);

    return Comp;
  }(React__default.Component);

  Comp.displayName = Component.displayName;
  Comp.propTypes = Component.propTypes;
  Comp.defaultProps = Component.defaultProps;
  return Comp;
};

var Wrapper$12 = withTheme(Flex);

var Wrapper$11 = withTheme(Box);

var merge$1 = function merge(a, b) {
  var result = assign({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    assign(result, (_assign = {}, _assign[key] = assign(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults$4 = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue$1 = function getValue(n, scale) {
  return get$1(scale, n, n);
};

var get$1 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get$1(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get$1(props.theme, 'breakpoints', defaults$4.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge$1(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge$1(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      assign(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      assign(styles, style);
    } else {
      var _assign2;

      assign(styles, (_assign2 = {}, _assign2[media] = assign({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      assign(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      assign(styles, (_assign3 = {}, _assign3[media] = assign({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue$1 : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    assign(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};

var isNumber$1 = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth$1 = function getWidth(n, scale) {
  return get$1(scale, n, !isNumber$1(n) || n > 1 ? n : n * 100 + '%');
};

var config$7 = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth$1
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config$7);

var config$6 = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
config$6.bg = config$6.backgroundColor;
var color$1 = system(config$6);

var defaults$3 = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config$5 = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: defaults$3.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(config$5);

var config$4 = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
system(config$4);

var defaults$2 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$3 = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
system(config$3);

var config$2 = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
};
config$2.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
config$2.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
config$2.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
config$2.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
config$2.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
config$2.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
config$2.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
config$2.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
config$2.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
config$2.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
config$2.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
config$2.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
config$2.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
config$2.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
config$2.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
config$2.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
var border = system(config$2);

var config$1 = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config$1.bgImage = config$1.backgroundImage;
config$1.bgSize = config$1.backgroundSize;
config$1.bgPosition = config$1.backgroundPosition;
config$1.bgRepeat = config$1.backgroundRepeat;
system(config$1);

var defaults$1 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: defaults$1.space
  }
};
var position = system(config);

var defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!isNumber(n)) {
    return get$1(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get$1(scale, absolute, absolute);

  if (!isNumber(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space = compose(margin, padding);

system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

// based on https://github.com/developit/dlv
var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme$1 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends$e({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css$3 = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends$e({}, defaultTheme$1, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(get(theme, val))(theme);
        result = _extends$e({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = get(aliases, key, key);
      var scaleName = get(scales, prop);
      var scale = get(theme, scaleName, get(theme, prop, {}));
      var transform = get(transforms, prop, get);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};

var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css$3(get$1(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get$1(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = createParser(config);
  return parser;
};
variant({
  key: 'buttons'
});
variant({
  key: 'textStyles',
  prop: 'textStyle'
});
variant({
  key: 'colorStyles',
  prop: 'colors'
});

var _templateObject$K, _templateObject2$z, _templateObject3$t, _templateObject4$m, _templateObject5$g, _templateObject6$b, _templateObject7$6, _templateObject8$4, _templateObject9$3, _templateObject10$3;
var LAYOUT = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  ACCORDION: 'accordion'
};
var StepperContainer = styled(Wrapper$12)(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral$1(["\n\tmargin-bottom: ", "px;\n\n\t", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.space[2];
}, function (props) {
  return props.layout === LAYOUT.HORIZONTAL ? css$4(["border:1px solid ", ";border-radius:4px;"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.stepperBorderColor;
  }) : undefined;
});
var StepperWrapper$1 = styled(Wrapper$12)(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteral$1(["\n\t", "\n"])), function (props) {
  return props.layout === LAYOUT.HORIZONTAL ? css$4(["height:100%;border-right:1px solid ", ";"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.stepperBorderColor;
  }) : css$4(["justify-content:space-between;"]);
});
var Step$1 = styled(Wrapper$11)(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteral$1(["\n\tpadding: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\tcolor: ", ";\n\tposition: relative;\n\n\t", "\n\n\t", "\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.stepperContentPadding;
}, function (_ref5) {
  var theme = _ref5.theme,
      active = _ref5.active;
  return active ? theme.stepColorActive || theme.primary : theme.stepColor;
}, function (props) {
  return props.layout === LAYOUT.HORIZONTAL ? css$4(["background:", ";&:not(:last-child){border-bottom:1px solid ", ";}", ""], function (_ref6) {
    var theme = _ref6.theme;
    return theme.stepTabBackground;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.stepperBorderColor;
  }, function (props) {
    return props.active && props.current ? css$4(["&:before,&:after{content:'';display:block;position:absolute;right:-11px;top:50%;transform:translateY(-50%);z-index:1;}&:before{height:20px;width:20px;background:white;border:1px solid ", ";border-radius:20px;}&:after{border:3px solid transparent;border-top-color:", ";border-right-color:", ";height:0px;width:0px;transform:rotate(45deg);margin-top:-3px;right:-2px;}"], function (_ref8) {
      var theme = _ref8.theme;
      return theme.stepperBorderColor;
    }, function (_ref9) {
      var theme = _ref9.theme;
      return theme.stepColorActive;
    }, function (_ref10) {
      var theme = _ref10.theme;
      return theme.stepColorActive;
    }) : undefined;
  }) : undefined;
}, function (props) {
  return props.layout === LAYOUT.VERTICAL ? css$4(["padding-top:20px;&:before{content:'", "';top:0px;left:50%;transform:translateX(-50%);display:block;position:absolute;height:20px;width:20px;background:", ";color:white;text-align:center;line-height:20px;border-radius:20px;}"], function (_ref11) {
    var id = _ref11.id;
    return id;
  }, function (_ref12) {
    var theme = _ref12.theme,
        active = _ref12.active;
    return active ? theme.stepColorActive : theme.stepColor;
  }) : undefined;
});
var StepTitle = styled.div(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteral$1(["\n\tpadding: 4px;\n\tcursor: default;\n\tuser-select: none;\n"])));
var StepsContentContainer = styled(Wrapper$11)(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteral$1(["\n\tbackground: ", ";\n\t", "\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.stepContentBackground;
}, function (props) {
  return props.layout === LAYOUT.VERTICAL ? css$4(["border:1px solid ", ";border-radius:", ";"], function (_ref14) {
    var theme = _ref14.theme;
    return theme.stepperBorderColor;
  }, function (_ref15) {
    var theme = _ref15.theme;
    return theme.borderRadius;
  }) : undefined;
});
var StepContent = styled.div(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteral$1(["\n\tpadding: ", ";\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.stepperContentPadding;
});
/** Accordion */

var AccordionWrapper = styled.div(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteral$1(["\n\tborder-radius: 4px;\n\toverflow: hidden;\n\tmargin-bottom: ", ";\n\tborder: 1px solid ", ";\n\t", ";\n"])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.cardMarginBottom;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.accordionBorderColor;
}, space);
var AccordionTabTrigger = styled(Wrapper$12)(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral$1(["\n\tpadding: ", "px ", "px;\n\tbox-sizing: border-box;\n\tjustify-content: space-between;\n\talign-items: center;\n\tbackground: ", ";\n\tuser-select: none;\n\tcursor: ", ";\n\tfont-size: ", ";\n\tfont-family: ", ";\n\t", "\n"])), function (_ref19) {
  var theme = _ref19.theme;
  return theme.accordionTabPaddingY;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.accordionTabPaddingX;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.accordionTabBackground;
}, function (_ref22) {
  var controlled = _ref22.controlled;
  return controlled ? 'default' : 'pointer';
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.accordionTabFontSize;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.fontFamily;
}, function (_ref25) {
  var last = _ref25.last;
  return !last ? css$4(["border-bottom:1px solid ", ";"], function (_ref26) {
    var theme = _ref26.theme;
    return theme.accordionBorderColor;
  }) : undefined;
});
var AccordionTabContentInner = styled.div(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral$1(["\n\tborder-bottom: 1px solid ", ";\n\tpadding: ", "px ", "px;\n\tbackground: ", ";\n\tfont-family: ", ";\n"])), function (_ref27) {
  var theme = _ref27.theme;
  return theme.accordionBorderColor;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.accordionTabPaddingY;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.accordionTabPaddingX;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.accordionTabContentBackground;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.fontFamily;
});
var AccordionTabContent = styled.div(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteral$1(["\n\tbox-sizing: border-box;\n"])));

var _templateObject$J;
var FlexArrow = styled.span(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral$1(["\n\twidth: 14px;\n\theight: 14px;\n\tposition: relative;\n\tmargin-left: auto;\n\n\t&:after,\n\t&:before {\n\t\tcontent: '';\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\twidth: 2px;\n\t\theight: 9.5px;\n\t\tbackground: ", ";\n\t\ttransform-origin: center;\n\t\ttransition: all 250ms ease-in;\n\t\ttop: 3px;\n\t}\n\t&:before {\n\t\tleft: 3px;\n\t\ttransform: ", ";\n\t}\n\t&:after {\n\t\tright: 3px;\n\t\ttransform: ", ";\n\t}\n"])), function (_ref) {
  var disabled = _ref.disabled,
      color = _ref.color,
      theme = _ref.theme;
  return disabled ? theme.inputLabelColorDisabled : color || theme.primary;
}, function (_ref2) {
  var direction = _ref2.direction;
  return direction === 'up' ? 'rotate(-135deg)' : 'rotate(-45deg)';
}, function (_ref3) {
  var direction = _ref3.direction;
  return direction === 'up' ? 'rotate(135deg)' : 'rotate(45deg)';
});

var AccordionTab = function AccordionTab(_ref) {
  var title = _ref.title,
      children = _ref.children;
      _ref.controlled;
      var rest = _objectWithoutProperties$c(_ref, ["title", "children", "controlled"]);

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AccordionTabTrigger, rest, title, /*#__PURE__*/React__default.createElement(FlexArrow, _extends$g({}, rest, {
    direction: rest.active ? 'up' : 'down'
  }))), /*#__PURE__*/React__default.createElement(AnimateHeight, {
    duration: 250,
    height: rest.active === 'open' ? 'auto' : 0
  }, /*#__PURE__*/React__default.createElement(AccordionTabContent, rest, /*#__PURE__*/React__default.createElement(AccordionTabContentInner, rest, children))));
};

var Wrapper$10 = compose$1(withTheme)(AccordionTab);

var Accordion = function Accordion(props) {
  var _useState = useState(props.step),
      _useState2 = _slicedToArray$8(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var getInitList = function getInitList(listSize, step) {
    var arr = [];

    for (var i = 0; i < listSize; i++) {
      arr[i] = props.expand || step === i ? 'open' : 'close';
    }

    return arr;
  };

  var _useState3 = useState(getInitList(props.children.length, props.step)),
      _useState4 = _slicedToArray$8(_useState3, 2),
      opened = _useState4[0],
      setOpened = _useState4[1];

  useEffect(function () {
    if (props.step !== index) {
      setIndex(props.step);
      updateOpened(props.step);
    }
  }, [props]);
  useEffect(function () {
    if (props.expand) {
      setOpened(_toConsumableArray$2(Array(props.children.length)).map(function () {
        return 'open';
      }));
    }
  }, [props.expand]);

  var handleOpen = function handleOpen(i) {
    if (!props.controlled) {
      setIndex(i);
      updateOpened(i);
    }

    if (props.onTabChange) props.onTabChange(i);
  };

  var updateOpened = function updateOpened(i) {
    var newList = _toConsumableArray$2(opened);

    for (var j = 0; j < opened.length; j++) {
      if (j === i) {
        newList[j] = newList[j] === 'open' ? 'close' : 'open';
      } else if (props.allowOnlyOne || props.controlled) {
        newList[j] = 'close';
      }
    }

    setOpened(newList);
  };

  return /*#__PURE__*/React__default.createElement(AccordionWrapper, {
    theme: props.theme
  }, React__default.Children.map(props.children, function (child, i) {
    return /*#__PURE__*/React__default.createElement(Wrapper$10, {
      key: i,
      index: i,
      title: child.props.title,
      active: opened[i],
      last: i + 1 === props.children.length,
      onClick: function onClick() {
        return handleOpen(i);
      },
      controlled: props.controlled
    }, child.props.children);
  }));
};

Accordion.propTypes = {
  /** Forces all tabs to start opened */
  expand: PropTypes.bool,

  /** Defines whether the component is allowed to move next or is controlled by the step value */
  controlled: PropTypes.bool,

  /** When true, Once a tab is opened, others will be closed */
  allowOnlyOne: PropTypes.bool
};
var Wrapper$$ = compose$1(withTheme)(Accordion);

function _objectWithoutProperties$b(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$c(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck$i(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$g(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$h(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$g(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$g(Constructor, staticProps);
  return Constructor;
}

function _inherits$b(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$a(subClass, superClass);
}

function _assertThisInitialized$a(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$b(self, call) {
  if (call && (_typeof$f(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$a(self);
}

function _getPrototypeOf$a(o) {
  _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$a(o);
}

function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_min(stylisOptions);

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

var isBrowser$2 = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize$2(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize$2(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var hasOwnProperty$4 = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext = /*#__PURE__*/createContext({});
EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/createElement(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/forwardRef(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$4.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (process.env.NODE_ENV !== 'production') {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z$]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
      }

      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }

  return newProps;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$4.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/createElement(type, newProps);

  return ele;
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty$4.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement.apply(null, createElementArgArray);
};

var keyframes$1 = function keyframes() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = withEmotionCache(function (props, context) {
  return /*#__PURE__*/createElement(ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      {
        insertStyles(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    return ele;
  });
});

function _defineProperty$j(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof$d(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$d = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$d = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$d(obj);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

// ==============================
// NO OP
// ==============================
var noop$3 = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (_typeof$d(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement$1(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop$1(el) {
  if (isDocumentElement$1(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement$1(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop$3;
  var start = getScrollTop$1(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView$1(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice$1() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$c(Object(source), true).forEach(function (key) { _defineProperty$j(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop$1(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, _defineProperty$j(_ref3, alignToControl(placement), '100%'), _defineProperty$j(_ref3, "backgroundColor", colors.neutral0), _defineProperty$j(_ref3, "borderRadius", borderRadius), _defineProperty$j(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty$j(_ref3, "marginBottom", spacing.menuGutter), _defineProperty$j(_ref3, "marginTop", spacing.menuGutter), _defineProperty$j(_ref3, "position", 'absolute'), _defineProperty$j(_ref3, "width", '100%'), _defineProperty$j(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /*#__PURE__*/createContext({
  getPortalPlacement: null
}); // NOTE: internal only

var MenuPlacer = /*#__PURE__*/function (_Component) {
  _inherits$b(MenuPlacer, _Component);

  var _super = _createSuper$a(MenuPlacer);

  function MenuPlacer() {
    var _this;

    _classCallCheck$i(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };

    _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    };

    _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread$f(_objectSpread$f({}, _this.props), {}, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    };

    return _this;
  }

  _createClass$h(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(Component);
MenuPlacer.contextType = PortalPlacementContext;

var Menu$1 = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$f({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className)
  }, innerProps, {
    ref: innerRef
  }), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$f({
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$f({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$f({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /*#__PURE__*/function (_Component2) {
  _inherits$b(MenuPortal, _Component2);

  var _super2 = _createSuper$a(MenuPortal);

  function MenuPortal() {
    var _this2;

    _classCallCheck$i(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };

    _this2.getPortalPlacement = function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    };

    return _this2;
  }

  _createClass$h(MenuPortal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = jsx("div", {
        css: getStyles('menuPortal', state)
      }, children);
      return jsx(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /*#__PURE__*/createPortal(menuWrapper, appendTo) : menuWrapper);
    }
  }]);

  return MenuPortal;
}(Component);

var isArray$1 = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && _typeof$d(a) == 'object' && _typeof$d(b) == 'object') {
    var arrA = isArray$1(a),
        arrB = isArray$1(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // Custom handling for React


    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    } // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
}

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return jsx("div", _extends$f({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      isMulti = props.isMulti,
      getStyles = props.getStyles,
      hasValue = props.hasValue;
  return jsx("div", {
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, children);
}; // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
  return jsx("div", {
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, children);
};

function _templateObject$I() {
  var data = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);

  _templateObject$I = function _templateObject() {
    return data;
  };

  return data;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
} : {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGljYXRvcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JJIiwiZmlsZSI6ImluZGljYXRvcnMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyB0eXBlIE5vZGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3gsIGtleWZyYW1lcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuXG5pbXBvcnQgdHlwZSB7IENvbW1vblByb3BzLCBUaGVtZSB9IGZyb20gJy4uL3R5cGVzJztcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBEcm9wZG93biAmIENsZWFyIEljb25zXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuY29uc3QgU3ZnID0gKHsgc2l6ZSwgLi4ucHJvcHMgfTogeyBzaXplOiBudW1iZXIgfSkgPT4gKFxuICA8c3ZnXG4gICAgaGVpZ2h0PXtzaXplfVxuICAgIHdpZHRoPXtzaXplfVxuICAgIHZpZXdCb3g9XCIwIDAgMjAgMjBcIlxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgZm9jdXNhYmxlPVwiZmFsc2VcIlxuICAgIGNzcz17e1xuICAgICAgZGlzcGxheTogJ2lubGluZS1ibG9jaycsXG4gICAgICBmaWxsOiAnY3VycmVudENvbG9yJyxcbiAgICAgIGxpbmVIZWlnaHQ6IDEsXG4gICAgICBzdHJva2U6ICdjdXJyZW50Q29sb3InLFxuICAgICAgc3Ryb2tlV2lkdGg6IDAsXG4gICAgfX1cbiAgICB7Li4ucHJvcHN9XG4gIC8+XG4pO1xuXG5leHBvcnQgY29uc3QgQ3Jvc3NJY29uID0gKHByb3BzOiBhbnkpID0+IChcbiAgPFN2ZyBzaXplPXsyMH0gey4uLnByb3BzfT5cbiAgICA8cGF0aCBkPVwiTTE0LjM0OCAxNC44NDljLTAuNDY5IDAuNDY5LTEuMjI5IDAuNDY5LTEuNjk3IDBsLTIuNjUxLTMuMDMwLTIuNjUxIDMuMDI5Yy0wLjQ2OSAwLjQ2OS0xLjIyOSAwLjQ2OS0xLjY5NyAwLTAuNDY5LTAuNDY5LTAuNDY5LTEuMjI5IDAtMS42OTdsMi43NTgtMy4xNS0yLjc1OS0zLjE1MmMtMC40NjktMC40NjktMC40NjktMS4yMjggMC0xLjY5N3MxLjIyOC0wLjQ2OSAxLjY5NyAwbDIuNjUyIDMuMDMxIDIuNjUxLTMuMDMxYzAuNDY5LTAuNDY5IDEuMjI4LTAuNDY5IDEuNjk3IDBzMC40NjkgMS4yMjkgMCAxLjY5N2wtMi43NTggMy4xNTIgMi43NTggMy4xNWMwLjQ2OSAwLjQ2OSAwLjQ2OSAxLjIyOSAwIDEuNjk4elwiIC8+XG4gIDwvU3ZnPlxuKTtcbmV4cG9ydCBjb25zdCBEb3duQ2hldnJvbiA9IChwcm9wczogYW55KSA9PiAoXG4gIDxTdmcgc2l6ZT17MjB9IHsuLi5wcm9wc30+XG4gICAgPHBhdGggZD1cIk00LjUxNiA3LjU0OGMwLjQzNi0wLjQ0NiAxLjA0My0wLjQ4MSAxLjU3NiAwbDMuOTA4IDMuNzQ3IDMuOTA4LTMuNzQ3YzAuNTMzLTAuNDgxIDEuMTQxLTAuNDQ2IDEuNTc0IDAgMC40MzYgMC40NDUgMC40MDggMS4xOTcgMCAxLjYxNS0wLjQwNiAwLjQxOC00LjY5NSA0LjUwMi00LjY5NSA0LjUwMi0wLjIxNyAwLjIyMy0wLjUwMiAwLjMzNS0wLjc4NyAwLjMzNXMtMC41Ny0wLjExMi0wLjc4OS0wLjMzNWMwIDAtNC4yODctNC4wODQtNC42OTUtNC41MDJzLTAuNDM2LTEuMTcgMC0xLjYxNXpcIiAvPlxuICA8L1N2Zz5cbik7XG5cbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuLy8gRHJvcGRvd24gJiBDbGVhciBCdXR0b25zXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuZXhwb3J0IHR5cGUgSW5kaWNhdG9yUHJvcHMgPSBDb21tb25Qcm9wcyAmIHtcbiAgLyoqIFRoZSBjaGlsZHJlbiB0byBiZSByZW5kZXJlZCBpbnNpZGUgdGhlIGluZGljYXRvci4gKi9cbiAgY2hpbGRyZW46IE5vZGUsXG4gIC8qKiBQcm9wcyB0aGF0IHdpbGwgYmUgcGFzc2VkIG9uIHRvIHRoZSBjaGlsZHJlbi4gKi9cbiAgaW5uZXJQcm9wczogYW55LFxuICAvKiogVGhlIGZvY3VzZWQgc3RhdGUgb2YgdGhlIHNlbGVjdC4gKi9cbiAgaXNGb2N1c2VkOiBib29sZWFuLFxuICAvKiogV2hldGhlciB0aGUgdGV4dCBpcyByaWdodCB0byBsZWZ0ICovXG4gIGlzUnRsOiBib29sZWFuLFxufTtcblxuY29uc3QgYmFzZUNTUyA9ICh7XG4gIGlzRm9jdXNlZCxcbiAgdGhlbWU6IHtcbiAgICBzcGFjaW5nOiB7IGJhc2VVbml0IH0sXG4gICAgY29sb3JzLFxuICB9LFxufTogSW5kaWNhdG9yUHJvcHMpID0+ICh7XG4gIGxhYmVsOiAnaW5kaWNhdG9yQ29udGFpbmVyJyxcbiAgY29sb3I6IGlzRm9jdXNlZCA/IGNvbG9ycy5uZXV0cmFsNjAgOiBjb2xvcnMubmV1dHJhbDIwLFxuICBkaXNwbGF5OiAnZmxleCcsXG4gIHBhZGRpbmc6IGJhc2VVbml0ICogMixcbiAgdHJhbnNpdGlvbjogJ2NvbG9yIDE1MG1zJyxcblxuICAnOmhvdmVyJzoge1xuICAgIGNvbG9yOiBpc0ZvY3VzZWQgPyBjb2xvcnMubmV1dHJhbDgwIDogY29sb3JzLm5ldXRyYWw0MCxcbiAgfSxcbn0pO1xuXG5leHBvcnQgY29uc3QgZHJvcGRvd25JbmRpY2F0b3JDU1MgPSBiYXNlQ1NTO1xuZXhwb3J0IGNvbnN0IERyb3Bkb3duSW5kaWNhdG9yID0gKHByb3BzOiBJbmRpY2F0b3JQcm9wcykgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuLCBjbGFzc05hbWUsIGN4LCBnZXRTdHlsZXMsIGlubmVyUHJvcHMgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgICAgY3NzPXtnZXRTdHlsZXMoJ2Ryb3Bkb3duSW5kaWNhdG9yJywgcHJvcHMpfVxuICAgICAgY2xhc3NOYW1lPXtjeChcbiAgICAgICAge1xuICAgICAgICAgIGluZGljYXRvcjogdHJ1ZSxcbiAgICAgICAgICAnZHJvcGRvd24taW5kaWNhdG9yJzogdHJ1ZSxcbiAgICAgICAgfSxcbiAgICAgICAgY2xhc3NOYW1lXG4gICAgICApfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbiB8fCA8RG93bkNoZXZyb24gLz59XG4gICAgPC9kaXY+XG4gICk7XG59O1xuXG5leHBvcnQgY29uc3QgY2xlYXJJbmRpY2F0b3JDU1MgPSBiYXNlQ1NTO1xuZXhwb3J0IGNvbnN0IENsZWFySW5kaWNhdG9yID0gKHByb3BzOiBJbmRpY2F0b3JQcm9wcykgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuLCBjbGFzc05hbWUsIGN4LCBnZXRTdHlsZXMsIGlubmVyUHJvcHMgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgICAgY3NzPXtnZXRTdHlsZXMoJ2NsZWFySW5kaWNhdG9yJywgcHJvcHMpfVxuICAgICAgY2xhc3NOYW1lPXtjeChcbiAgICAgICAge1xuICAgICAgICAgIGluZGljYXRvcjogdHJ1ZSxcbiAgICAgICAgICAnY2xlYXItaW5kaWNhdG9yJzogdHJ1ZSxcbiAgICAgICAgfSxcbiAgICAgICAgY2xhc3NOYW1lXG4gICAgICApfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbiB8fCA8Q3Jvc3NJY29uIC8+fVxuICAgIDwvZGl2PlxuICApO1xufTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBTZXBhcmF0b3Jcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG50eXBlIFNlcGFyYXRvclN0YXRlID0geyBpc0Rpc2FibGVkOiBib29sZWFuIH07XG5cbmV4cG9ydCBjb25zdCBpbmRpY2F0b3JTZXBhcmF0b3JDU1MgPSAoe1xuICBpc0Rpc2FibGVkLFxuICB0aGVtZToge1xuICAgIHNwYWNpbmc6IHsgYmFzZVVuaXQgfSxcbiAgICBjb2xvcnMsXG4gIH0sXG59OiBDb21tb25Qcm9wcyAmIFNlcGFyYXRvclN0YXRlKSA9PiAoe1xuICBsYWJlbDogJ2luZGljYXRvclNlcGFyYXRvcicsXG4gIGFsaWduU2VsZjogJ3N0cmV0Y2gnLFxuICBiYWNrZ3JvdW5kQ29sb3I6IGlzRGlzYWJsZWQgPyBjb2xvcnMubmV1dHJhbDEwIDogY29sb3JzLm5ldXRyYWwyMCxcbiAgbWFyZ2luQm90dG9tOiBiYXNlVW5pdCAqIDIsXG4gIG1hcmdpblRvcDogYmFzZVVuaXQgKiAyLFxuICB3aWR0aDogMSxcbn0pO1xuXG5leHBvcnQgY29uc3QgSW5kaWNhdG9yU2VwYXJhdG9yID0gKHByb3BzOiBJbmRpY2F0b3JQcm9wcykgPT4ge1xuICBjb25zdCB7IGNsYXNzTmFtZSwgY3gsIGdldFN0eWxlcywgaW5uZXJQcm9wcyB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPHNwYW5cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgICAgY3NzPXtnZXRTdHlsZXMoJ2luZGljYXRvclNlcGFyYXRvcicsIHByb3BzKX1cbiAgICAgIGNsYXNzTmFtZT17Y3goeyAnaW5kaWNhdG9yLXNlcGFyYXRvcic6IHRydWUgfSwgY2xhc3NOYW1lKX1cbiAgICAvPlxuICApO1xufTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBMb2FkaW5nXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuY29uc3QgbG9hZGluZ0RvdEFuaW1hdGlvbnMgPSBrZXlmcmFtZXNgXG4gIDAlLCA4MCUsIDEwMCUgeyBvcGFjaXR5OiAwOyB9XG4gIDQwJSB7IG9wYWNpdHk6IDE7IH1cbmA7XG5cbmV4cG9ydCBjb25zdCBsb2FkaW5nSW5kaWNhdG9yQ1NTID0gKHtcbiAgaXNGb2N1c2VkLFxuICBzaXplLFxuICB0aGVtZToge1xuICAgIGNvbG9ycyxcbiAgICBzcGFjaW5nOiB7IGJhc2VVbml0IH0sXG4gIH0sXG59OiB7XG4gIGlzRm9jdXNlZDogYm9vbGVhbixcbiAgc2l6ZTogbnVtYmVyLFxuICB0aGVtZTogVGhlbWUsXG59KSA9PiAoe1xuICBsYWJlbDogJ2xvYWRpbmdJbmRpY2F0b3InLFxuICBjb2xvcjogaXNGb2N1c2VkID8gY29sb3JzLm5ldXRyYWw2MCA6IGNvbG9ycy5uZXV0cmFsMjAsXG4gIGRpc3BsYXk6ICdmbGV4JyxcbiAgcGFkZGluZzogYmFzZVVuaXQgKiAyLFxuICB0cmFuc2l0aW9uOiAnY29sb3IgMTUwbXMnLFxuICBhbGlnblNlbGY6ICdjZW50ZXInLFxuICBmb250U2l6ZTogc2l6ZSxcbiAgbGluZUhlaWdodDogMSxcbiAgbWFyZ2luUmlnaHQ6IHNpemUsXG4gIHRleHRBbGlnbjogJ2NlbnRlcicsXG4gIHZlcnRpY2FsQWxpZ246ICdtaWRkbGUnLFxufSk7XG5cbnR5cGUgRG90UHJvcHMgPSB7IGRlbGF5OiBudW1iZXIsIG9mZnNldDogYm9vbGVhbiB9O1xuY29uc3QgTG9hZGluZ0RvdCA9ICh7IGRlbGF5LCBvZmZzZXQgfTogRG90UHJvcHMpID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGFuaW1hdGlvbjogYCR7bG9hZGluZ0RvdEFuaW1hdGlvbnN9IDFzIGVhc2UtaW4tb3V0ICR7ZGVsYXl9bXMgaW5maW5pdGU7YCxcbiAgICAgIGJhY2tncm91bmRDb2xvcjogJ2N1cnJlbnRDb2xvcicsXG4gICAgICBib3JkZXJSYWRpdXM6ICcxZW0nLFxuICAgICAgZGlzcGxheTogJ2lubGluZS1ibG9jaycsXG4gICAgICBtYXJnaW5MZWZ0OiBvZmZzZXQgPyAnMWVtJyA6IG51bGwsXG4gICAgICBoZWlnaHQ6ICcxZW0nLFxuICAgICAgdmVydGljYWxBbGlnbjogJ3RvcCcsXG4gICAgICB3aWR0aDogJzFlbScsXG4gICAgfX1cbiAgLz5cbik7XG5cbmV4cG9ydCB0eXBlIExvYWRpbmdJY29uUHJvcHMgPSB7XG4gIC8qKiBQcm9wcyB0aGF0IHdpbGwgYmUgcGFzc2VkIG9uIHRvIHRoZSBjaGlsZHJlbi4gKi9cbiAgaW5uZXJQcm9wczogYW55LFxuICAvKiogVGhlIGZvY3VzZWQgc3RhdGUgb2YgdGhlIHNlbGVjdC4gKi9cbiAgaXNGb2N1c2VkOiBib29sZWFuLFxuICAvKiogV2hldGhlciB0aGUgdGV4dCBpcyByaWdodCB0byBsZWZ0ICovXG4gIGlzUnRsOiBib29sZWFuLFxufSAmIENvbW1vblByb3BzICYge1xuICAgIC8qKiBTZXQgc2l6ZSBvZiB0aGUgY29udGFpbmVyLiAqL1xuICAgIHNpemU6IG51bWJlcixcbiAgfTtcbmV4cG9ydCBjb25zdCBMb2FkaW5nSW5kaWNhdG9yID0gKHByb3BzOiBMb2FkaW5nSWNvblByb3BzKSA9PiB7XG4gIGNvbnN0IHsgY2xhc3NOYW1lLCBjeCwgZ2V0U3R5bGVzLCBpbm5lclByb3BzLCBpc1J0bCB9ID0gcHJvcHM7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICB7Li4uaW5uZXJQcm9wc31cbiAgICAgIGNzcz17Z2V0U3R5bGVzKCdsb2FkaW5nSW5kaWNhdG9yJywgcHJvcHMpfVxuICAgICAgY2xhc3NOYW1lPXtjeChcbiAgICAgICAge1xuICAgICAgICAgIGluZGljYXRvcjogdHJ1ZSxcbiAgICAgICAgICAnbG9hZGluZy1pbmRpY2F0b3InOiB0cnVlLFxuICAgICAgICB9LFxuICAgICAgICBjbGFzc05hbWVcbiAgICAgICl9XG4gICAgPlxuICAgICAgPExvYWRpbmdEb3QgZGVsYXk9ezB9IG9mZnNldD17aXNSdGx9IC8+XG4gICAgICA8TG9hZGluZ0RvdCBkZWxheT17MTYwfSBvZmZzZXQgLz5cbiAgICAgIDxMb2FkaW5nRG90IGRlbGF5PXszMjB9IG9mZnNldD17IWlzUnRsfSAvPlxuICAgIDwvZGl2PlxuICApO1xufTtcbkxvYWRpbmdJbmRpY2F0b3IuZGVmYXVsdFByb3BzID0geyBzaXplOiA0IH07XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties$b(_ref, ["size"]);

  return jsx("svg", _extends$f({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, _extends$f({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, _extends$f({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$f({}, innerProps, {
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$f({}, innerProps, {
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }), children || jsx(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("span", _extends$f({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes$1(_templateObject$I());
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return jsx("div", _extends$f({}, innerProps, {
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$f({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(Object(source), true).forEach(function (key) { _defineProperty$j(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return jsx("div", {
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, jsx(Heading, _extends$f({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), jsx("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme;
      props.selectProps;
      var cleanProps = _objectWithoutProperties$b(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

  return jsx("div", _extends$f({
    css: getStyles('groupHeading', _objectSpread$1$1({
      theme: theme
    }, cleanProps)),
    className: cx({
      'group-heading': true
    }, className)
  }, cleanProps));
};

function ownKeys$2$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2$2(Object(source), true).forEach(function (key) { _defineProperty$j(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    label: 'input',
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input$2 = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme;
      _ref2.selectProps;
      var props = _objectWithoutProperties$b(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

  return jsx("div", {
    css: getStyles('input', _objectSpread$2$2({
      theme: theme
    }, props))
  }, jsx(AutosizeInput, _extends$f({
    className: cx({
      input: true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};

function ownKeys$3$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3$1(Object(source), true).forEach(function (key) { _defineProperty$j(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
      innerProps = _ref5.innerProps;
  return jsx("div", innerProps, children || jsx(CrossIcon, {
    size: 14
  }));
}

var MultiValue = function MultiValue(props) {
  var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      data = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;
  return jsx(ClassNames, null, function (_ref6) {
    var css = _ref6.css,
        emotionCx = _ref6.cx;
    return jsx(Container, {
      data: data,
      innerProps: _objectSpread$3$1(_objectSpread$3$1({}, innerProps), {}, {
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }),
      selectProps: selectProps
    }, jsx(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), jsx(Remove, {
      data: data,
      innerProps: _objectSpread$3$1({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className))
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

MultiValue.defaultProps = {
  cropWithEllipsis: true
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$f({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder$1 = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$f({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css$1$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return jsx("div", _extends$f({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

function ownKeys$4$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4$1(Object(source), true).forEach(function (key) { _defineProperty$j(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input$2,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu$1,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder$1,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread$4$1(_objectSpread$4$1({}, components), props.components);
};

function _arrayWithHoles$7(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$7(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _nonIterableRest$7() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$7(arr, i) {
  return _arrayWithHoles$7(arr) || _iterableToArrayLimit$7(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$7();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$1();
}

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};

for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];

  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}

var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$b(Object(source), true).forEach(function (key) { _defineProperty$j(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _objectSpread$e({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
} : {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFJIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICA8c3BhblxuICAgIGNzcz17e1xuICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICB6SW5kZXg6IDk5OTksXG4gICAgICBib3JkZXI6IDAsXG4gICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgIGhlaWdodDogMSxcbiAgICAgIHdpZHRoOiAxLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBvdmVyZmxvdzogJ2hpZGRlbicsXG4gICAgICBwYWRkaW5nOiAwLFxuICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgfX1cbiAgICB7Li4ucHJvcHN9XG4gIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var A11yText = function A11yText(props) {
  return jsx("span", _extends$f({
    css: _ref
  }, props));
};

function DummyInput(_ref) {
  _ref.in;
      _ref.out;
      _ref.onExited;
      _ref.appear;
      _ref.enter;
      _ref.exit;
      var innerRef = _ref.innerRef;
      _ref.emotion;
      var props = _objectWithoutProperties$b(_ref, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

  return jsx("input", _extends$f({
    ref: innerRef
  }, props, {
    css: /*#__PURE__*/css$2({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      fontSize: 'inherit',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(0)'
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJNIiwiZmlsZSI6IkR1bW15SW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGluOiBpblByb3AsXG4gIG91dCxcbiAgb25FeGl0ZWQsXG4gIGFwcGVhcixcbiAgZW50ZXIsXG4gIGV4aXQsXG4gIGlubmVyUmVmLFxuICBlbW90aW9uLFxuICAuLi5wcm9wc1xufTogYW55KSB7XG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLnByb3BzfVxuICAgICAgY3NzPXt7XG4gICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgIC8vIGdldCByaWQgb2YgYW55IGRlZmF1bHQgc3R5bGVzXG4gICAgICAgIGJhY2tncm91bmQ6IDAsXG4gICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgZm9udFNpemU6ICdpbmhlcml0JyxcbiAgICAgICAgb3V0bGluZTogMCxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgLy8gaW1wb3J0YW50ISB3aXRob3V0IGB3aWR0aGAgYnJvd3NlcnMgd29uJ3QgYWxsb3cgZm9jdXNcbiAgICAgICAgd2lkdGg6IDEsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgIGNvbG9yOiAndHJhbnNwYXJlbnQnLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gbW9iaWxlIHdoaWxzdCBtYWludGFpbmluZyBcInNjcm9sbCBpbnRvIHZpZXdcIiBiZWhhdmlvdXJcbiAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgb3BhY2l0eTogMCxcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXG4gICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var NodeResolver = /*#__PURE__*/function (_Component) {
  _inherits$b(NodeResolver, _Component);

  var _super = _createSuper$9(NodeResolver);

  function NodeResolver() {
    _classCallCheck$i(this, NodeResolver);

    return _super.apply(this, arguments);
  }

  _createClass$h(NodeResolver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.innerRef(findDOMNode$3(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(Component);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice$1() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function _createSuper$1$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }

function _isNativeReflectConstruct$1$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var canUseDOM$2 = !!( window.document && window.document.createElement);
var activeScrollLocks = 0;

var ScrollLock = /*#__PURE__*/function (_Component) {
  _inherits$b(ScrollLock, _Component);

  var _super = _createSuper$1$1(ScrollLock);

  function ScrollLock() {
    var _this;

    _classCallCheck$i(this, ScrollLock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.originalStyles = {};
    _this.listenerOptions = {
      capture: false,
      passive: false
    };
    return _this;
  }

  _createClass$h(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM$2) return;
      var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      } // account for touch devices


      if (target && isTouchDevice$1()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM$2) return;
      var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice$1()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(Component);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function _createSuper$2$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }

function _isNativeReflectConstruct$2$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _ref$1 = process.env.NODE_ENV === "production" ? {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
} : {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var ScrollBlock = /*#__PURE__*/function (_PureComponent) {
  _inherits$b(ScrollBlock, _PureComponent);

  var _super = _createSuper$2$1(ScrollBlock);

  function ScrollBlock() {
    var _this;

    _classCallCheck$i(this, ScrollBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      touchScrollTarget: null
    };

    _this.getScrollTarget = function (ref) {
      if (ref === _this.state.touchScrollTarget) return;

      _this.setState({
        touchScrollTarget: ref
      });
    };

    _this.blurSelectInput = function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    };

    return _this;
  }

  _createClass$h(ScrollBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

      if (!isEnabled) return children;
      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */

      return jsx("div", null, jsx("div", {
        onClick: this.blurSelectInput,
        css: _ref$1
      }), jsx(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? jsx(ScrollLock, {
        touchScrollTarget: touchScrollTarget
      }) : null);
    }
  }]);

  return ScrollBlock;
}(PureComponent);

function _createSuper$3$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }

function _isNativeReflectConstruct$3$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ScrollCaptor = /*#__PURE__*/function (_Component) {
  _inherits$b(ScrollCaptor, _Component);

  var _super = _createSuper$3$1(ScrollCaptor);

  function ScrollCaptor() {
    var _this;

    _classCallCheck$i(this, ScrollCaptor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.isBottom = false;
    _this.isTop = false;
    _this.scrollTarget = void 0;
    _this.touchStart = void 0;

    _this.cancelScroll = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };

    _this.handleEventDelta = function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }

      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    };

    _this.onWheel = function (event) {
      _this.handleEventDelta(event, event.deltaY);
    };

    _this.onTouchStart = function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    };

    _this.onTouchMove = function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;

      _this.handleEventDelta(event, deltaY);
    };

    _this.getScrollTarget = function (ref) {
      _this.scrollTarget = ref;
    };

    return _this;
  }

  _createClass$h(ScrollCaptor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function startListening(el) {
      // bail early if no element is available to attach to
      if (!el) return; // all the if statements are to appease Flow 😢

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "stopListening",
    value: function stopListening(el) {
      if (!el) return; // all the if statements are to appease Flow 😢

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    }
  }]);

  return ScrollCaptor;
}(Component);

function ScrollCaptorSwitch(_ref) {
  var _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
      props = _objectWithoutProperties$b(_ref, ["isEnabled"]);

  return isEnabled ? /*#__PURE__*/React__default.createElement(ScrollCaptor, props) : props.children;
}

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label,
      isDisabled = context.isDisabled,
      tabSelectsValue = context.tabSelectsValue;

  switch (event) {
    case 'menu':
      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");

    case 'input':
      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

    case 'value':
      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
  }
};
var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value,
      isDisabled = context.isDisabled;
  if (!value) return;

  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return "option ".concat(value, ", deselected.");

    case 'select-option':
      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$1$1,
  valueContainer: valueContainerCSS
}; // Merge Utility

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

function ownKeys$2$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2$1(Object(source), true).forEach(function (key) { _defineProperty$j(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$4$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }

function _isNativeReflectConstruct$4$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$3 = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice$1(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};
var instanceId = 1;

var Select = /*#__PURE__*/function (_Component) {
  _inherits$b(Select, _Component);

  var _super = _createSuper$4$1(Select);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    _classCallCheck$i(this, Select);

    _this = _super.call(this, _props);
    _this.state = {
      ariaLiveSelection: '',
      ariaLiveContext: '',
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.clearFocusValueOnUpdate = false;
    _this.commonProps = void 0;
    _this.components = void 0;
    _this.hasGroups = false;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.inputIsHiddenAfterUpdate = void 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;

    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };

    _this.focusedOptionRef = null;

    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };

    _this.menuListRef = null;

    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };

    _this.inputRef = null;

    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };

    _this.cacheComponents = function (components) {
      _this.components = defaultComponents({
        components: components
      });
    };

    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;

    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onChange(newValue, _objectSpread$2$1(_objectSpread$2$1({}, actionMeta), {}, {
        name: name
      }));
    };

    _this.setValue = function (newValue) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.clearFocusValueOnUpdate = true;

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };

    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;
      var selectValue = _this.state.selectValue;

      if (isMulti) {
        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          }), 'deselect-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'deselect-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue([].concat(_toConsumableArray$1(selectValue), [newValue]), 'select-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
      } else {
        if (!_this.isOptionDisabled(newValue, selectValue)) {
          _this.setValue(newValue, 'select-option');

          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          // announce that option is disabled
          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue),
              isDisabled: true
            }
          });
        }
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };

    _this.removeValue = function (removedValue) {
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValue = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.announceAriaLiveSelection({
        event: 'remove-value',
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ''
        }
      });

      _this.focusInput();
    };

    _this.clearValue = function () {
      _this.onChange(null, {
        action: 'clear'
      });
    };

    _this.popValue = function () {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValue = selectValue.slice(0, selectValue.length - 1);

      _this.announceAriaLiveSelection({
        event: 'pop-value',
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
        }
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };

    _this.getValue = function () {
      return _this.state.selectValue;
    };

    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };

    _this.getOptionLabel = function (data) {
      return _this.props.getOptionLabel(data);
    };

    _this.getOptionValue = function (data) {
      return _this.props.getOptionValue(data);
    };

    _this.getStyles = function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };

    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };

    _this.getActiveDescendentId = function () {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen) return undefined;
      var index = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index];
      return option && option.key;
    };

    _this.announceAriaLiveSelection = function (_ref2) {
      var event = _ref2.event,
          context = _ref2.context;

      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    };

    _this.announceAriaLiveContext = function (_ref3) {
      var event = _ref3.event,
          context = _ref3.context;

      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, _objectSpread$2$1(_objectSpread$2$1({}, context), {}, {
          label: _this.props['aria-label']
        }))
      });
    };

    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    };

    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };

    _this.onControlMouseDown = function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if ( // $FlowFixMe
        event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }

      if ( // $FlowFixMe
      event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };

    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    };

    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };

    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement$1(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };

    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };

    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };

    _this.onTouchStart = function (_ref4) {
      var touches = _ref4.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };

    _this.onTouchMove = function (_ref5) {
      var touches = _ref5.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };

    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };

    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    };

    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    };

    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    };

    _this.handleInputChange = function (event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };

    _this.onInputFocus = function (event) {
      var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.inputIsHiddenAfterUpdate = false;

      _this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });

      _this.setState({
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    };

    _this.onInputBlur = function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };

    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    };

    _this.shouldHideSelectedOptions = function () {
      var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === undefined) return isMulti;
      return hideSelectedOptions;
    };

    _this.onKeyDown = function (event) {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    };

    _this.buildMenuOptions = function (props, selectValue) {
      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;

      var toOption = function toOption(option, id) {
        var isDisabled = _this.isOptionDisabled(option, selectValue);

        var isSelected = _this.isOptionSelected(option, selectValue);

        var label = _this.getOptionLabel(option);

        var value = _this.getOptionValue(option);

        if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
          label: label,
          value: value,
          data: option
        }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this.selectOption(option);
        };
        var optionId = "".concat(_this.getElementId('option'), "-").concat(id);
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this.hasGroups) _this.hasGroups = true;
          var items = item.options;
          var children = items.map(function (child, i) {
            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
            if (option) acc.focusable.push(child);
            return option;
          }).filter(Boolean);

          if (children.length) {
            var groupId = "".concat(_this.getElementId('group'), "-").concat(itemIndex);
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, "".concat(itemIndex));

          if (option) {
            acc.render.push(option);
            acc.focusable.push(item);
          }
        }

        return acc;
      }, {
        render: [],
        focusable: []
      });
    };

    var _value = _props.value;
    _this.cacheComponents = memoizeOne(_this.cacheComponents, exportedEqual).bind(_assertThisInitialized$a(_this));

    _this.cacheComponents(_props.components);

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var _selectValue = cleanValue(_value);

    _this.buildMenuOptions = memoizeOne(_this.buildMenuOptions, function (newArgs, lastArgs) {
      var _ref6 = newArgs,
          _ref7 = _slicedToArray$7(_ref6, 2),
          newProps = _ref7[0],
          newSelectValue = _ref7[1];

      var _ref8 = lastArgs,
          _ref9 = _slicedToArray$7(_ref8, 2),
          lastProps = _ref9[0],
          lastSelectValue = _ref9[1];

      return newSelectValue === lastSelectValue && newProps.inputValue === lastProps.inputValue && newProps.options === lastProps.options;
    }).bind(_assertThisInitialized$a(_this));

    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
      render: [],
      focusable: []
    };

    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }

  _createClass$h(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          menuIsOpen = _this$props8.menuIsOpen,
          inputValue = _this$props8.inputValue; // re-cache custom components

      this.cacheComponents(nextProps.components); // rebuild the menu options

      if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
        var selectValue = cleanValue(nextProps.value);
        var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
          render: [],
          focusable: []
        };
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions: menuOptions,
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue
        });
      } // some updates should toggle the state of the input visibility


      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programatically disabled while focused
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView$1(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    // ==============================
    // Consumer Handlers
    // ==============================
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;

      var _this$state3 = this.state,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
      var menuOptions = this.buildMenuOptions(this.props, selectValue);
      var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          tabSelectsValue = _this$props11.tabSelectsValue;
      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.setState({
        menuOptions: menuOptions,
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      }, function () {
        _this2.onMenuOpen();

        _this2.announceAriaLiveContext({
          event: 'menu',
          context: {
            tabSelectsValue: tabSelectsValue
          }
        });
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$props12 = this.props,
          isMulti = _this$props12.isMulti,
          isSearchable = _this$props12.isSearchable;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

      if (!isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'value'
        });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var _this$props13 = this.props,
          pageSize = _this$props13.pageSize,
          tabSelectsValue = _this$props13.tabSelectsValue;
      var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'menu',
          context: {
            tabSelectsValue: tabSelectsValue
          }
        });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
      this.announceAriaLiveContext({
        event: 'menu',
        context: {
          isDisabled: isOptionDisabled(options[nextFocus]),
          tabSelectsValue: tabSelectsValue
        }
      });
    }
  }, {
    key: "getTheme",
    // ==============================
    // Getters
    // ==============================
    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return _objectSpread$2$1(_objectSpread$2$1({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          cx = this.cx,
          getStyles = this.getStyles,
          getValue = this.getValue,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var hasValue = this.hasValue();
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }

      var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }

      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props14 = this.props,
          isClearable = _this$props14.isClearable,
          isMulti = _this$props14.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      var _this3 = this;

      if (selectValue.indexOf(option) > -1) return true;

      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }

      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this3.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    // ==============================
    // Composition Handlers
    // ==============================
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    // ==============================
    // Touch Handlers
    // ==============================
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "constructAriaLiveMessage",
    // ==============================
    // Renderers
    // ==============================
    value: function constructAriaLiveMessage() {
      var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
      var _this$props15 = this.props,
          options = _this$props15.options,
          menuIsOpen = _this$props15.menuIsOpen,
          inputValue = _this$props15.inputValue,
          screenReaderStatus = _this$props15.screenReaderStatus; // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : ''; // An aria live message representing the currently focused option in the select.

      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({
          count: this.countOptions()
        })
      });
      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isSearchable = _this$props16.isSearchable,
          inputId = _this$props16.inputId,
          inputValue = _this$props16.inputValue,
          tabIndex = _this$props16.tabIndex,
          form = _this$props16.form;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/React__default.createElement(DummyInput, _extends$f({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop$3,
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          form: form,
          value: ""
        }, ariaAttributes));
      }

      var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
      return /*#__PURE__*/React__default.createElement(Input, _extends$f({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        theme: theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props17 = this.props,
          controlShouldRenderValue = _this$props17.controlShouldRenderValue,
          isDisabled = _this$props17.isDisabled,
          isMulti = _this$props17.isMulti,
          inputValue = _this$props17.inputValue,
          placeholder = _this$props17.placeholder;
      var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/React__default.createElement(Placeholder, _extends$f({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          return /*#__PURE__*/React__default.createElement(MultiValue, _extends$f({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: "".concat(_this4.getOptionValue(opt)).concat(index),
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return /*#__PURE__*/React__default.createElement(SingleValue, _extends$f({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props18 = this.props,
          isDisabled = _this$props18.isDisabled,
          isLoading = _this$props18.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React__default.createElement(ClearIndicator, _extends$f({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props19 = this.props,
          isDisabled = _this$props19.isDisabled,
          isLoading = _this$props19.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React__default.createElement(LoadingIndicator, _extends$f({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/React__default.createElement(IndicatorSeparator, _extends$f({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React__default.createElement(DropdownIndicator, _extends$f({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this5 = this;

      var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu = _this$components3.Menu,
          MenuList = _this$components3.MenuList,
          MenuPortal = _this$components3.MenuPortal,
          LoadingMessage = _this$components3.LoadingMessage,
          NoOptionsMessage = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
      var _this$props20 = this.props,
          captureMenuScroll = _this$props20.captureMenuScroll,
          inputValue = _this$props20.inputValue,
          isLoading = _this$props20.isLoading,
          loadingMessage = _this$props20.loadingMessage,
          minMenuHeight = _this$props20.minMenuHeight,
          maxMenuHeight = _this$props20.maxMenuHeight,
          menuIsOpen = _this$props20.menuIsOpen,
          menuPlacement = _this$props20.menuPlacement,
          menuPosition = _this$props20.menuPosition,
          menuPortalTarget = _this$props20.menuPortalTarget,
          menuShouldBlockScroll = _this$props20.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props20.menuShouldScrollIntoView,
          noOptionsMessage = _this$props20.noOptionsMessage,
          onMenuScrollToTop = _this$props20.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props20.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
        return /*#__PURE__*/React__default.createElement(Option, _extends$f({}, commonProps, props, {
          isFocused: isFocused
        }), _this5.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            item.type;
                var group = _objectWithoutProperties$b(item, ["type"]);

            var headingId = "".concat(item.key, "-heading");
            return /*#__PURE__*/React__default.createElement(Group, _extends$f({}, commonProps, group, {
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this5.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option);
            }));
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/React__default.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = /*#__PURE__*/React__default.createElement(NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/React__default.createElement(MenuPlacer, _extends$f({}, commonProps, menuPlacementProps), function (_ref10) {
        var ref = _ref10.ref,
            _ref10$placerProps = _ref10.placerProps,
            placement = _ref10$placerProps.placement,
            maxHeight = _ref10$placerProps.maxHeight;
        return /*#__PURE__*/React__default.createElement(Menu, _extends$f({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this5.onMenuMouseDown,
            onMouseMove: _this5.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/React__default.createElement(ScrollCaptorSwitch, {
          isEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom
        }, /*#__PURE__*/React__default.createElement(ScrollBlock, {
          isEnabled: menuShouldBlockScroll
        }, /*#__PURE__*/React__default.createElement(MenuList, _extends$f({}, commonProps, {
          innerRef: _this5.getMenuListRef,
          isLoading: isLoading,
          maxHeight: maxHeight
        }), menuUI))));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/React__default.createElement(MenuPortal, _extends$f({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this6 = this;

      var _this$props21 = this.props,
          delimiter = _this$props21.delimiter,
          isDisabled = _this$props21.isDisabled,
          isMulti = _this$props21.isMulti,
          name = _this$props21.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/React__default.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/React__default.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            });
          }) : /*#__PURE__*/React__default.createElement("input", {
            name: name,
            type: "hidden"
          });
          return /*#__PURE__*/React__default.createElement("div", null, input);
        }
      } else {
        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return /*#__PURE__*/React__default.createElement("input", {
          name: name,
          type: "hidden",
          value: _value2
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return /*#__PURE__*/React__default.createElement(A11yText, {
        "aria-live": "polite"
      }, /*#__PURE__*/React__default.createElement("span", {
        id: "aria-selection-event"
      }, "\xA0", this.state.ariaLiveSelection), /*#__PURE__*/React__default.createElement("span", {
        id: "aria-context"
      }, "\xA0", this.constructAriaLiveMessage()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
      var _this$props22 = this.props,
          className = _this$props22.className,
          id = _this$props22.id,
          isDisabled = _this$props22.isDisabled,
          menuIsOpen = _this$props22.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/React__default.createElement(SelectContainer, _extends$f({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/React__default.createElement(Control, _extends$f({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/React__default.createElement(ValueContainer, _extends$f({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/React__default.createElement(IndicatorsContainer, _extends$f({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }]);

  return Select;
}(Component);

Select.defaultProps = defaultProps$3;

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$2 = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits$b(StateManager, _Component);

    var _super = _createSuper$8(StateManager);

    function StateManager() {
      var _this;

      _classCallCheck$i(this, StateManager);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.select = void 0;
      _this.state = {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      };

      _this.onChange = function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      };

      _this.onInputChange = function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      };

      _this.onMenuOpen = function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      };

      _this.onMenuClose = function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      };

      return _this;
    }

    _createClass$h(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any

    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any

    }, {
      key: "callProp",
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props;
            _this$props2.defaultInputValue;
            _this$props2.defaultMenuIsOpen;
            _this$props2.defaultValue;
            var props = _objectWithoutProperties$b(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return /*#__PURE__*/React__default.createElement(SelectComponent, _extends$f({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(Component), _class.defaultProps = defaultProps$2, _temp;
};

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$1 = {
  cacheOptions: false,
  defaultOptions: false,
  filterOption: null,
  isLoading: false
};
var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits$b(Async, _Component);

    var _super = _createSuper$7(Async);

    function Async(props) {
      var _this;

      _classCallCheck$i(this, Async);

      _this = _super.call(this);
      _this.select = void 0;
      _this.lastRequest = void 0;
      _this.mounted = false;
      _this.optionsCache = {};

      _this.handleInputChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange; // TODO

        var inputValue = handleInputChange(newValue, actionMeta, onInputChange);

        if (!inputValue) {
          delete _this.lastRequest;

          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });

          return;
        }

        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};

          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;

              if (options) {
                _this.optionsCache[inputValue] = options;
              }

              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;

              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }

        return inputValue;
      };

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
        isLoading: props.defaultOptions === true,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    _createClass$h(Async, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this.mounted = true;
        var defaultOptions = this.props.defaultOptions;
        var inputValue = this.state.inputValue;

        if (defaultOptions === true) {
          this.loadOptions(inputValue, function (options) {
            if (!_this2.mounted) return;
            var isLoading = !!_this2.lastRequest;

            _this2.setState({
              defaultOptions: options || [],
              isLoading: isLoading
            });
          });
        }
      }
    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        // if the cacheOptions prop changes, clear the cache
        if (nextProps.cacheOptions !== this.props.cacheOptions) {
          this.optionsCache = {};
        }

        if (nextProps.defaultOptions !== this.props.defaultOptions) {
          this.setState({
            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "loadOptions",
      value: function loadOptions(inputValue, callback) {
        var loadOptions = this.props.loadOptions;
        if (!loadOptions) return callback();
        var loader = loadOptions(inputValue, callback);

        if (loader && typeof loader.then === 'function') {
          loader.then(callback, function () {
            return callback();
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _this$props2 = this.props;
            _this$props2.loadOptions;
            var isLoadingProp = _this$props2.isLoading,
            props = _objectWithoutProperties$b(_this$props2, ["loadOptions", "isLoading"]);

        var _this$state = this.state,
            defaultOptions = _this$state.defaultOptions,
            inputValue = _this$state.inputValue,
            isLoading = _this$state.isLoading,
            loadedInputValue = _this$state.loadedInputValue,
            loadedOptions = _this$state.loadedOptions,
            passEmptyOptions = _this$state.passEmptyOptions;
        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return /*#__PURE__*/React__default.createElement(SelectComponent, _extends$f({}, props, {
          ref: function ref(_ref) {
            _this3.select = _ref;
          },
          options: options,
          isLoading: isLoading || isLoadingProp,
          onInputChange: this.handleInputChange
        }));
      }
    }]);

    return Async;
  }(Component), _class.defaultProps = defaultProps$1, _temp;
};
var SelectState = manageState(Select);
var Async = makeAsyncSelect(SelectState);

/**
 * 
 * @param {*} length 
 * @param {*} stringOnly 
 */
function RandomID(length, stringOnly) {
  var text = "";
  var chars = "abcdefghijklmnopqrstuvwxyz";
  if (!stringOnly) chars += "0123456789";

  while (text.length < length) {
    text += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return text;
}

var scriptjs = require('scriptjs');

var MapWrapper = function MapWrapper(AddressComponent) {
  var wrapper = /*#__PURE__*/function (_React$Component) {
    _inherits$c(wrapper, _React$Component);

    var _super = _createSuper$b(wrapper);

    function wrapper(props) {
      var _this;

      _classCallCheck$j(this, wrapper);

      _this = _super.call(this, props);
      _this.state = {
        google: undefined,
        ready: false
      };
      return _this;
    }

    _createClass$i(wrapper, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        if (!this.props.apiKey) throw new Error('Missing google maps API key');

        if (window.google && window.google.maps.places) {
          this.setState({
            google: window.google.maps,
            ready: true
          });
        } else {
          this.loadScript();
        }
      }
    }, {
      key: "onLoad",
      value: function onLoad(e) {
        if (window.google) {
          this.setState({
            google: window.google.maps,
            ready: true
          });
        }
      }
    }, {
      key: "loadScript",
      value: function loadScript() {
        window.googleMapsLoaded = function () {
          scriptjs.done('google-maps-places');
        };

        var maps_base = '//maps.googleapis.com/',
            maps_url = '/maps/api/js?v=3&libraries=places&callback=googleMapsLoaded&key=' + this.props.apiKey;

        if (window.userInfo && window.userInfo.country_code === 'CN') {
          maps_base = '//maps.google.cn/';
        }

        scriptjs(maps_base + maps_url);
        scriptjs.ready('google-maps-places', this.onLoad.bind(this));
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React__default.createElement(AddressComponent, _extends$g({}, this.props, {
          google: this.state.google,
          ready: this.state.ready
        }));
      }
    }]);

    return wrapper;
  }(React__default.Component);

  return wrapper;
};

function Add() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}

function AddPerson() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z"
  }));
}

function Air() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    style: {
      transform: 'rotate(45deg)'
    }
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    id: "a",
    d: "M23.713 29.132l1.85-1.851-2.775-12.161 5.155-5.155c.793-.794.793-1.983 0-2.776-.793-.793-1.983-.793-2.776 0l-5.155 5.155L7.851 9.568 6 11.418l9.782 5.156-5.155 5.155-3.305-.528-1.321 1.454 4.23 2.38 2.38 4.23 1.321-1.455-.528-3.304 5.155-5.155 5.155 9.782-.001-.001z"
  })), /*#__PURE__*/React__default.createElement("g", {
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/React__default.createElement("mask", {
    fill: "#fff"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React__default.createElement("use", {
    fillRule: "nonzero",
    xlinkHref: "#a"
  })));
}

function AirFreighter() {
  return /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 31 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M13.817.33l3.98 6.963c2.573.673 4.603 2.45 5.37 4.704h5.65c1.106 0 2 .893 2 2a1.997 1.997 0 01-1.85 1.994l-.15.006H23.17c-.766 2.257-2.8 4.038-5.378 4.711l-3.975 6.955H10.15l2.078-7.273c-2.108-.828-3.732-2.43-4.398-4.394H4.15l-2 2.667h-2l1.333-4.666L.15 9.33h2l2 2.667h3.682c.669-1.96 2.292-3.561 4.398-4.387L10.15.33h3.667zm4.093 9.42H13v8.566h1.787V14.93h2.906v-1.483h-2.906v-2.209h3.123V9.75z",
    fill: "#3b3f4b",
    fillRule: "evenodd"
  }));
}

function Alarm() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
  }));
}

function ArrowDown$1() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function Archive() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.81.97H5.44l.8-.97zM5 19V8h14v11H5zm8.45-9h-2.9v3H8l4 4 4-4h-2.55z"
  }));
}

function ArrowForward() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"
  }));
}

function ArrowBackword() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
  }));
}

function ArrowUp$1() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M7 14l5-5 5 5z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function Attach() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 015 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 005 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function BarChart() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5 9.2h3V19H5V9.2zM10.6 5h2.8v14h-2.8V5zm5.6 8H19v6h-2.8v-6z"
  }));
}

function BellOutline() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
  }));
}

function Bell() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
  }));
}

function billing() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    id: "2y9edirlda",
    d: "M20.898 3.375c1.087 0 1.977.913 1.977 2.03v13.19c0 1.117-.89 2.03-1.977 2.03H3.102c-1.087 0-1.977-.913-1.977-2.03V5.406c0-1.117.89-2.03 1.977-2.03zm-9.887 2.03H3.102v13.19h7.91V5.406zm9.887 0h-7.91v13.19h7.91V5.406zM7.828 7.5v1.095c.924.255 1.388 1.045 1.419 1.905H8.27c-.027-.625-.318-1.05-1.105-1.05-.747 0-1.194.38-1.194.925 0 .475.323.78 1.326 1.075 1.004.295 2.078.78 2.078 2.2 0 1.025-.685 1.59-1.547 1.775V16.5H6.502v-1.085c-.849-.205-1.574-.82-1.627-1.915h.972c.05.59.407 1.05 1.318 1.05.977 0 1.193-.55 1.193-.895 0-.465-.22-.905-1.326-1.205-1.233-.335-2.077-.91-2.077-2.065 0-.965.69-1.595 1.547-1.805V7.5h1.326zm12.081 6.53v1.521h-5.932V14.03h5.932zm0-2.537v1.522h-5.932v-1.522h5.932zm0-2.537v1.522h-5.932V8.956h5.932z"
  })), /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), /*#__PURE__*/React__default.createElement("use", {
    fill: "#3B3F4B",
    xlinkHref: "#2y9edirlda"
  })));
}

function Block() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"
  }));
}

function BrokenImage() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0zm0 0h24v24H0zm21 19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z"
  }));
}

function Bookmark() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
  }));
}

function Build() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
  }));
}

function Burger() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  }));
}

function Calendar() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function Call() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"
  }));
}

function Camera() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l1.83-2h4.24l1.83 2H20v12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
  }));
}

function CaretUp() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
  }));
}

function CaretDown() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 18"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
  }));
}

function CaretRight() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
}

function CaretLeft() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
}

function Check() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
  }));
}

function UncheckedCheckbox() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

var Checkmark = function Checkmark() {
  return /*#__PURE__*/React__default.createElement("svg", {
    className: "checkmark",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
  }));
};

function circleAdd() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  }));
}

function circleAddFilled() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
  }));
}

function CircleCheck() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }));
}

function CircleClose() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  }));
}

function CircleDash() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  }));
}

function CircleDashFilled() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
  }));
}

function CircleFilled() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M24 24H0V0h24v24z"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "8"
  }));
}

function CircleHelp() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
  }));
}

function CircleHelpFilled() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
  }));
}

function CircleInfo() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }));
}

function CirlcePeople() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36s-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function circleUser() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    id: "vjckdsf9aa",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20c-1.86 0-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"
  })), /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), /*#__PURE__*/React__default.createElement("use", {
    fill: "#3B3F4B",
    xlinkHref: "#vjckdsf9aa"
  })));
}

function circleUserFilled() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2a7.2 7.2 0 01-6-3.22c.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08a7.2 7.2 0 01-6 3.22z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function Close() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function Cog() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  }));
}

function Column() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4 5v13h17V5H4zm10 2v9h-3V7h3zM6 7h3v9H6V7zm13 9h-3V7h3v9z"
  }));
}

function CreditCard() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
  }));
}

function Dashboard() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"
  }));
}

function Doc() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
  }));
}

function documents() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "#000",
    d: "M5.66 5.215v14.23h11.068c0 .82-.635 1.5-1.438 1.574l-.143.006H5.653c-.822 0-1.495-.634-1.567-1.437l-.007-.144V6.796c0-.822.635-1.502 1.438-1.575l.143-.006zm9.29-2.965l4.743 4.743v9.487c0 .87-.712 1.58-1.582 1.58H8.617c-.87 0-1.573-.71-1.573-1.58V3.83c0-.87.711-1.581 1.581-1.581h6.324zm-.791 1.581H8.625V16.48h9.486V7.784H14.16V3.83zm2.371 9.487v1.58h-6.324v-1.58h6.324zm0-3.163v1.581h-6.324v-1.58h6.324z"
  })));
}

function DollarCircle() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function Dollar() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function FileDownload() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13 5v6h1.17L12 13.17 9.83 11H11V5h2m2-2H9v6H5l7 7 7-7h-4V3zm4 15H5v2h14v-2z"
  }));
}

function Eco() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    fill: "none",
    height: "24",
    width: "24"
  })), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
    d: "M6.05,8.05c-2.73,2.73-2.73,7.17,0,9.9C7.42,19.32,9.21,20,11,20s3.58-0.68,4.95-2.05C19.43,14.47,20,4,20,4 S9.53,4.57,6.05,8.05z M14.54,16.54C13.59,17.48,12.34,18,11,18c-0.89,0-1.73-0.25-2.48-0.68c0.92-2.88,2.62-5.41,4.88-7.32 c-2.63,1.36-4.84,3.46-6.37,6c-1.48-1.96-1.35-4.75,0.44-6.54C9.21,7.72,14.04,6.65,17.8,6.2C17.35,9.96,16.28,14.79,14.54,16.54z"
  })));
}

function Edit() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
  }));
}

function EllipsesH() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }));
}

function EllipsesV() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }));
}

function Entry() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    opacity: ".87"
  })), /*#__PURE__*/React__default.createElement("path", {
    d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3zM21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
  }));
}

function Envelope() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"
  }));
}

function express() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    style: {
      transform: 'rotate(-45deg)'
    }
  }, /*#__PURE__*/React__default.createElement("path", {
    stroke: "none",
    strokeWidth: "1",
    d: "M2.192 17.376c-.235-.235-.287-.711 0-.998l4.852-4.851 1.318.678-5.171 5.171c-.262.262-.763.235-.999 0zm1.784 7.202c-.236-.236-.288-.712 0-.999l1.606-1.606 1.31.686-1.918 1.919c-.262.261-.763.235-.998 0zm2.639 2.639c-.236-.236-.287-.712 0-.999l2.894-2.894.776.315.223.683-2.895 2.895c-.262.261-.763.235-.998 0zm2.647 2.648c-.235-.236-.287-.712 0-.999l1.92-1.918.685 1.31-1.606 1.607c-.262.261-.763.235-.999 0zm6.907 1.487c-.236-.235-.287-.71 0-.998l5.17-5.17.68 1.317-4.852 4.851c-.262.262-.763.236-.998 0zm7.4-4.432l.001.001-4.925-9.346-4.926 4.926.505 3.157-1.262 1.39-2.274-4.042-4.042-2.274 1.263-1.39 3.157.506 4.926-4.926-9.347-4.926 1.769-1.768 11.62 2.652 4.925-4.925c.758-.758 1.895-.758 2.652 0 .758.757.758 1.894 0 2.652l-4.925 4.925 2.652 11.62-1.768 1.768z",
    transform: "rotate(45 15.088 18.463)"
  }));
}

function Export() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
  }));
}

function Funnel() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
  }));
}

function GPSEmpty() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
  }));
}

function GPSFilled() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
  }));
}

function Graph() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
  }));
}

function History() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
  }));
}

function Home() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function Image$1() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
  }));
}

function ImageSearch() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18 13v7H4V6h5.02c.05-.71.22-1.38.48-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5l-2-2zm-1.5 5h-11l2.75-3.53 1.96 2.36 2.75-3.54L16.5 18zm2.8-9.11c.44-.7.7-1.51.7-2.39C20 4.01 17.99 2 15.5 2S11 4.01 11 6.5s2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21 13.42 22.42 12 19.3 8.89zM15.5 9C14.12 9 13 7.88 13 6.5S14.12 4 15.5 4 18 5.12 18 6.5 16.88 9 15.5 9z"
  }));
}

function Like() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
  }));
}

function LikeEmpty() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
  }));
}

function Location() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "12",
    cy: "9",
    r: "2.5"
  }));
}

function Lock() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    opacity: ".87"
  })), /*#__PURE__*/React__default.createElement("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
  }));
}

function Map$2() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM10 5.47l4 1.4v11.66l-4-1.4V5.47zm-5 .99l3-1.01v11.7l-3 1.16V6.46zm14 11.08l-3 1.01V6.86l3-1.16v11.84z"
  }));
}

function Messages() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h12v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
  }));
}

function Minus() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19 13H5v-2h14v2z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function People() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
  }));
}

function PlayCircle() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10 16.5l6-4.5-6-4.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  }));
}

function Printer() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 12v2H8v-4h8v2zm2-2v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "18",
    cy: "11.5",
    r: "1"
  }));
}

function RadioChecked() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function RadioUnchecked() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function rates() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    id: "wdjlnbs0fa",
    d: "M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zm-6.297-.5v1.095c.924.255 1.388 1.045 1.419 1.905h-.977c-.027-.625-.318-1.05-1.105-1.05-.747 0-1.194.38-1.194.925 0 .475.323.78 1.326 1.075 1.004.295 2.078.78 2.078 2.2 0 1.025-.685 1.59-1.547 1.775V16.5h-1.326v-1.085c-.849-.205-1.574-.82-1.627-1.915h.972c.05.59.407 1.05 1.318 1.05.977 0 1.193-.55 1.193-.895 0-.465-.22-.905-1.326-1.205-1.233-.335-2.077-.91-2.077-2.065 0-.965.69-1.595 1.547-1.805V7.5h1.326zM12 4c1.57 0 3.03.46 4.26 1.24L14.8 6.7c-.83-.45-1.79-.7-2.8-.7-3.31 0-6 2.69-6 6h3l-4 4-4-4h3c0-4.42 3.58-8 8-8z"
  })), /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z"
  }), /*#__PURE__*/React__default.createElement("use", {
    fill: "#2075BD",
    xlinkHref: "#wdjlnbs0fa"
  })));
}

function Receipt() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6zm0-4h12v2H6zm0-4h12v2H6z"
  }));
}

function Refresh() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
  }));
}

function Reload() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19 8l-4 4h3c0 3.31-2.69 6-6 6a5.87 5.87 0 01-2.8-.7l-1.46 1.46A7.93 7.93 0 0012 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46A7.93 7.93 0 0012 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function Review() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9.5-2H18v-2h-5.5zm3.86-5.87c.2-.2.2-.51 0-.71l-1.77-1.77c-.2-.2-.51-.2-.71 0L6 11.53V14h2.47l5.89-5.87z"
  }));
}

function Save() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z"
  }));
}

function Search() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function SectionCollapse() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M24 0v24H0V0h24z",
    fill: "none",
    opacity: ".87"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
  }));
}

function SectionExpand() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
  }));
}

function Share() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
  }));
}

function Shield() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11V11zm-11.59.59L6 13l4 4 8-8-1.41-1.42L10 14.17z"
  }));
}

function Ship() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13 3v1h-2V3h2m-1 7.11l5.38 1.77 2.39.78-1.12 3.97c-.54-.3-.94-.71-1.14-.94L16 13.96l-1.51 1.72c-.34.4-1.28 1.32-2.49 1.32s-2.15-.92-2.49-1.32L8 13.96l-1.51 1.72c-.2.23-.6.63-1.14.93l-1.13-3.96 2.4-.79L12 10.11M15 1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1zM6 9.97V6h12v3.97L12 8 6 9.97zm10 9.71c-1.22.85-2.61 1.28-4 1.28s-2.78-.43-4-1.28C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 1.26.64 2.63.97 4 .97s2.74-.32 4-.97c1.26.65 2.62.99 4 .99h2v-2h-2c-1.39 0-2.78-.47-4-1.32z"
  }));
}

function Star() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function StarFilled() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
}

function StarHalf() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    id: "ahalf",
    d: "M0 0h24v24H0V0z"
  })), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "halfb"
  }, /*#__PURE__*/React__default.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ahalf"
  })), /*#__PURE__*/React__default.createElement("path", {
    d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z",
    clipPath: "url(#halfb)"
  }));
}

function Subdirectory() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M24 24H0V0h24v24z",
    fill: "none",
    opacity: ".87"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
  }));
}

function Table$1() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v3H5V5h15zm-5 14h-5v-9h5v9zM5 10h3v9H5v-9zm12 9v-9h3v9h-3z"
  }));
}

function Tile() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none",
    opacity: ".87"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3 5v14h17V5H3zm4 2v2H5V7h2zm-2 6v-2h2v2H5zm0 2h2v2H5v-2zm13 2H9v-2h9v2zm0-4H9v-2h9v2zm0-4H9V7h9v2z"
  }));
}

function Time() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  }));
}

function Timer() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 007.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
  }));
}

function TimerOff() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.04 4.55l-1.42 1.42a9.012 9.012 0 00-10.57-.49l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45A8.878 8.878 0 0021 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03A8.905 8.905 0 003 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z"
  }));
}

function Total() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7V4z"
  }));
}

function Train() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "8.5",
    cy: "14.5",
    r: "1.5"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "15.5",
    cy: "14.5",
    r: "1.5"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2l2-2h4l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-4-4-8-4zm0 2c3.51 0 4.96.48 5.57 1H6.43c.61-.52 2.06-1 5.57-1zM6 7h5v3H6V7zm12 8.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5h-5V7h5v3z"
  }));
}

function Trash() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"
  }));
}

function TrendingDown() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z"
  }));
}

function TrendingUp() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z"
  }));
}

function TrendingFlat() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22 12l-4-4v3H3v2h15v3l4-4z"
  }));
}

function Trophy() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("rect", {
    fill: "none",
    height: "24",
    width: "24"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19,5h-2V3H7v2H5C3.9,5,3,5.9,3,7v1c0,2.55,1.92,4.63,4.39,4.94c0.63,1.5,1.98,2.63,3.61,2.96V19H7v2h10v-2h-4v-3.1 c1.63-0.33,2.98-1.46,3.61-2.96C19.08,12.63,21,10.55,21,8V7C21,5.9,20.1,5,19,5z M5,8V7h2v3.82C5.84,10.4,5,9.3,5,8z M12,14 c-1.65,0-3-1.35-3-3V5h6v6C15,12.65,13.65,14,12,14z M19,8c0,1.3-0.84,2.4-2,2.82V7h2V8z"
  }));
}

function Truck() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-.5 1.5l1.96 2.5H17V9.5h2.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9H8.22zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
  }));
}

function UploadCloud() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
  }));
}

function Unlock() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
  }));
}

function Verified() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11V11zm-11.59.59L6 13l4 4 8-8-1.41-1.42L10 14.17z"
  }));
}

function Visibility() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
  }));
}

function VisibilityOff() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"
  }));
}

function Warning() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
  }));
}

var IconsList = /*#__PURE__*/Object.freeze({
  __proto__: null,
  add: Add,
  addPerson: AddPerson,
  air: Air,
  airFreighter: AirFreighter,
  alarm: Alarm,
  arrowDown: ArrowDown$1,
  archive: Archive,
  arrowForward: ArrowForward,
  arrowBackword: ArrowBackword,
  arrowUp: ArrowUp$1,
  attach: Attach,
  barChart: BarChart,
  bell: BellOutline,
  billFilled: Bell,
  billing: billing,
  block: Block,
  brokenImage: BrokenImage,
  bookmark: Bookmark,
  build: Build,
  burgerButton: Burger,
  calendar: Calendar,
  call: Call,
  camera: Camera,
  caretUp: CaretUp,
  caretDown: CaretDown,
  caretRight: CaretRight,
  caretLeft: CaretLeft,
  check: Check,
  checkboxUnchecked: UncheckedCheckbox,
  checkmark: Checkmark,
  circleAdd: circleAdd,
  circleAddFilled: circleAddFilled,
  circleCheck: CircleCheck,
  circleClose: CircleClose,
  circleDash: CircleDash,
  circleDashFilled: CircleDashFilled,
  circleFilled: CircleFilled,
  circleHelp: CircleHelp,
  circleHelpFilled: CircleHelpFilled,
  circleInfo: CircleInfo,
  circlePeople: CirlcePeople,
  circleUser: circleUser,
  circleUserFilled: circleUserFilled,
  close: Close,
  cog: Cog,
  column: Column,
  creditCard: CreditCard,
  dashboard: Dashboard,
  document: Doc,
  documents: documents,
  dollar: DollarCircle,
  dollarCircle: Dollar,
  download: FileDownload,
  eco: Eco,
  edit: Edit,
  ellipsesH: EllipsesH,
  ellipsesV: EllipsesV,
  entry: Entry,
  envelope: Envelope,
  express: express,
  'export': Export,
  funnel: Funnel,
  gpsEmpty: GPSEmpty,
  gpsFilled: GPSFilled,
  graph: Graph,
  history: History,
  home: Home,
  image: Image$1,
  imageSearch: ImageSearch,
  like: Like,
  likeEmpty: LikeEmpty,
  location: Location,
  lock: Lock,
  map: Map$2,
  messages: Messages,
  minus: Minus,
  people: People,
  playCircle: PlayCircle,
  printer: Printer,
  radioChecked: RadioChecked,
  radioUnchecked: RadioUnchecked,
  rates: rates,
  receipt: Receipt,
  refresh: Refresh,
  reload: Reload,
  review: Review,
  save: Save,
  search: Search,
  sectionCollapse: SectionCollapse,
  sectionExpand: SectionExpand,
  share: Share,
  shield: Shield,
  ship: Ship,
  star: Star,
  starFilled: StarFilled,
  starHalf: StarHalf,
  subdirectory: Subdirectory,
  table: Table$1,
  tile: Tile,
  time: Time,
  timer: Timer,
  timerOff: TimerOff,
  total: Total,
  train: Train,
  trash: Trash,
  trendingDown: TrendingDown,
  trendingUp: TrendingUp,
  trendingFlat: TrendingFlat,
  trophy: Trophy,
  truck: Truck,
  uploadCloud: UploadCloud,
  unlock: Unlock,
  verified: Verified,
  visibility: Visibility,
  visibilityOff: VisibilityOff,
  warning: Warning
});

var _templateObject$H;
var TooltipStyle = createGlobalStyle(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral$1(["\n\t\t.tippy-tooltip{\n\t\t\ttext-align:'inherit';\n\t\t}\n\t\t.tippy-popper{\n\t\tfont-family: ", ";\n\t\tfont-size: 0.85em;\n\t\tline-height: 1.2;\n\t\t\n\t\t.tooltip-content{\n\t\t\tfont-family: ", ";\n\n\t\t\t& > div{\n\t\t\t\toverflow: ", ";\n\t\t\t\tmax-height: ", ";\n\t\t\t}\n\t\t\ta,\n\t\t\ta:visited {\n\t\t\t\tcolor: ", ";\n\t\t\t}\n\t\t}\n\t}\n\t.tippy-popper .tippy-tooltip.light-theme {\n\t\tpadding: 0px;\n\t\tbackground: #FFFF;\n\t\tbox-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n\t\ta,\n\t\t\ta:visited {\n\t\t\t\tcolor: ", ";\n\t\t\t}\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme ? theme.fontFamily : "Arial";
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme ? theme.fontFamily : "Arial";
}, function (_ref3) {
  var overflow = _ref3.overflow;
  return overflow || "hidden";
}, function (_ref4) {
  var overflow = _ref4.overflow;
  return overflow === "visible" ? "100%" : "200px";
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme ? theme.skyBlue : "#c8e6f4";
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme ? theme.primary : "#c8e6f4";
});

var Tooltip$2 = function Tooltip(_ref7) {
  var trigger = _ref7.trigger,
      mode = _ref7.mode,
      children = _ref7.children,
      placement = _ref7.placement,
      attachedTo = _ref7.attachedTo;
      _ref7.isMenu;
      var theme = _ref7.theme,
      overflow = _ref7.overflow,
      rest = _objectWithoutProperties$c(_ref7, ["trigger", "mode", "children", "placement", "attachedTo", "isMenu", "theme", "overflow"]);

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TooltipStyle, {
    theme: theme,
    overflow: overflow
  }), /*#__PURE__*/React__default.createElement(Tooltip$3, _extends$g({}, rest, {
    position: placement,
    role: "tooltip",
    html: /*#__PURE__*/React__default.createElement("div", {
      className: "tooltip-content"
    }, children),
    trigger: trigger,
    theme: mode
  }), attachedTo));
};

Tooltip$2.propTypes = {
  /** Tooltip content  */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,

  /** DOM element to will trigger the tooltip  */
  attachedTo: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,

  /** Controls when to show/hide the tooltip  */
  trigger: PropTypes.oneOf(["mouseenter", "focus", "click", "manual"]),

  /** Defines the location of the tooltip  */
  placement: PropTypes.oneOf(["top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "right", "right-start", "right-end", "left", "left-start", "left-end"]),

  /**  To customize the tooltip animation   */
  animation: PropTypes.oneOf(["shift", "perspective", "fade", "scale", "none"]),

  /** Controls whether this component can block mouse and touch events of covering other elements  */
  clickThrough: PropTypes.bool,

  /** Defines the delay for `showing` the tooltip in milliseconds  */
  delay: PropTypes.number,

  /** Defines the delay for `hiding` the tooltip in milliseconds  */
  hideDelay: PropTypes.number,

  /** useful if tooltip has a link or elements that needs user interaction  */
  interactive: PropTypes.bool,

  /** When set to true it allow using context in tooltip content like passing redux store data  */
  useContext: PropTypes.bool,

  /** passes additional className to component  */
  className: PropTypes.string,

  /** Calls a function if provided when the tooltip has just opened  */
  onShow: PropTypes.func,

  /** Calls a function if provided when the tooltip has just closed  */
  onHide: PropTypes.func,

  /** Manually controls visibility of this tooltip  */
  open: PropTypes.bool,

  /** Controls adding/removing the tooltip pointing arrow  */
  arrow: PropTypes.bool,
  arrowSize: PropTypes.oneOf(["regular", "small", "big"]),

  /** Specifies how big the tooltip is. */
  size: PropTypes.oneOf(["regular", "small", "big"]),

  /** Adds offset to the tooltip position (x or y based on the placement) */
  offset: PropTypes.number,

  /** Specifies whether to allow multiple tooltips open on the page (click trigger only). Useful if treated as popup menu */
  hideOnClick: PropTypes.bool,

  /** Controls the color mode of the tooltip */
  mode: PropTypes.oneOf(["dark", "light", "transparent"]),

  /** Additional style object passed to the container */
  style: PropTypes.object,

  /** Moves the tooltip with mouse over the component */
  sticky: PropTypes.bool
};
Tooltip$2.defaultProps = {
  trigger: "mouseenter",
  placement: "top",
  clickThrough: false,
  mode: "dark",
  arrow: true,
  arrowSize: "regular",
  size: "regular",
  delay: 200,
  distance: 20,
  interactive: false,
  useContext: false
};
var Wrapper$_ = withTheme(Tooltip$2);

var hexToRgb = function hexToRgb(hex) {
  if (!hex) return;

  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  } // convert 3-digit hex to 6-digits.


  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  if (hex.length !== 6) {
    console.warn("Invalid HEX color: ".concat(hex, ", reverting to white"));
    return '#FFF';
  }

  return {
    r: parseInt(hex.slice(0, 2), 16),
    g: parseInt(hex.slice(2, 4), 16),
    b: parseInt(hex.slice(4, 6), 16)
  };
};
var invert = function invert(hex) {
  var _hexToRgb = hexToRgb(hex),
      r = _hexToRgb.r,
      g = _hexToRgb.g,
      b = _hexToRgb.b;

  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
};
var opacity = function opacity(hex, _opacity) {
  var _hexToRgb2 = hexToRgb(hex),
      r = _hexToRgb2.r,
      g = _hexToRgb2.g,
      b = _hexToRgb2.b;

  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(_opacity, ")");
};
var tintColor = function tintColor(color) {
  var amt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // validate hex string
  color = String(color).replace(/[^0-9a-f]/gi, '');

  if (color.length < 6) {
    color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
  }

  amt = amt / 100; // convert to decimal and change luminosity

  var rgb = '#',
      c,
      i;

  for (i = 0; i < 3; i++) {
    c = parseInt(color.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * amt), 255)).toString(16);
    rgb += ('00' + c).substr(c.length);
  }

  return rgb;
};

var lightDark = function lightDark(color) {
  var r, g, b, hsp;

  if (color.match(/^rgb/)) {
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
    r = color >> 16;
    g = color >> 8 & 255;
    b = color & 255;
  }

  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
  return hsp > 127.5 ? 'light' : 'dark';
};

var isDark = function isDark(color) {
  return lightDark(color) === 'dark';
};
var isLight = function isLight(color) {
  return lightDark(color) === 'dark';
};

var snakeToCamelCase = function snakeToCamelCase(str) {
  if (typeof str !== 'string') return str;
  return str.replace(/([-_][a-z])/g, function (group) {
    return group.toUpperCase().replace('-', '').replace('_', '');
  });
};

var _templateObject$G;
var StyledIcon = styled.div(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral$1(["\n\twidth: ", "px;\n\theight: ", "px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tfill: ", ";\n\tbox-sizing: border-box;\n\tcursor: ", ";\n\n\t&:hover {\n\t\tfill: ", ";\n\t\ttransition: all 0.15s ease-in-out;\n\t}\n\n\tsvg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tfloat: left;\n\t\t&,\n\t\tuse {\n\t\t\tcursor: inherit;\n\t\t\tfill: ", ";\n\t\t\ttransition: all 0.15s ease-in-out;\n\t\t}\n\t\t&:hover,\n\t\tuse:hover {\n\t\t\tfill: ", ";\n\t\t}\n\t}\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), function (props) {
  return props.size || props.theme.iconDefaultSize;
}, function (props) {
  return props.size || props.theme.iconDefaultSize;
}, function (props) {
  return props.color || props.theme.iconDefaultColor;
}, function (_ref) {
  var cursor = _ref.cursor,
      onClick = _ref.onClick,
      disabled = _ref.disabled;
  return cursor || (onClick && !disabled ? 'pointer' : 'default');
}, function (props) {
  return props.hoverColor || props.theme.iconHoverColor || tintColor(props.theme.primary, 10);
}, function (props) {
  return props.color || props.theme.iconDefaultColor || props.theme.primary;
}, function (props) {
  return props.hoverColor || props.theme.iconHoverColor || tintColor(props.theme.primary, 10);
}, space, color$1, border, position);

var Icon = function Icon(_ref2) {
  var icon = _ref2.icon,
      id = _ref2.id;
      _ref2.title;
      var onClick = _ref2.onClick,
      size = _ref2.size,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      color = _ref2.color,
      cursor = _ref2.cursor,
      hoverColor = _ref2.hoverColor,
      tooltip = _ref2.tooltip,
      placement = _ref2.placement,
      rest = _objectWithoutProperties$c(_ref2, ["icon", "id", "title", "onClick", "size", "className", "color", "cursor", "hoverColor", "tooltip", "placement"]);

  var IconComponent = IconsList[snakeToCamelCase(icon)];
  var SVGIcon = /*#__PURE__*/React__default.createElement(StyledIcon, _extends$g({}, rest, {
    id: id,
    size: size,
    pointer: Boolean(onClick),
    onClick: onClick,
    color: color,
    hoverColor: hoverColor,
    cursor: cursor,
    className: className
  }), IconComponent && /*#__PURE__*/React__default.createElement(IconComponent, null));

  if (tooltip) {
    return /*#__PURE__*/React__default.createElement(Wrapper$_, {
      attachedTo: /*#__PURE__*/React__default.createElement("em", null, SVGIcon),
      placement: placement
    }, tooltip);
  }

  return SVGIcon;
};

Icon.propTypes = {
  /** icon name or icon SVG. If icon string name is passed, it will try to look it up from the available list. If svg icon is passed, it will render the SVG component directly.ssss  */
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** icon size in pixes. Defaults to 36 */
  size: PropTypes.number,

  /** icon css color */
  color: PropTypes.string,

  /** icon hover color */
  hoverColor: PropTypes.string,

  /** if provided, then this string gets added as a tooltip  */
  title: PropTypes.string,

  /** additional class names */
  className: PropTypes.string,

  /** function to call when icons is clicked */
  onClick: PropTypes.func,

  /** set the cursor attribute in css */
  cursor: PropTypes.string
};
Icon.defaultProps = {};
var Wrapper$Z = withTheme(Icon);

var _templateObject$F, _templateObject2$y, _templateObject3$s, _templateObject4$l, _templateObject5$f, _templateObject6$a, _templateObject7$5, _templateObject8$3, _templateObject9$2, _templateObject10$2, _templateObject11$1, _templateObject12$1;
var FormGroup = styled.div.attrs(function (props) {
  return {
    theme: props.theme,
    'data-error': props.error
  };
})(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral$1(["\n\tmargin-bottom: ", "px;\n\toutline: none;\n\tposition: relative;\n\n\t", "\n\t", ";\n\t", ";\n"])), function (_ref) {
  var theme = _ref.theme,
      nested = _ref.nested;
  return nested ? 0 : theme.space[2];
}, function (props) {
  return props.horizontal ? css$4(["display:flex;align-items:flex-start;"]) : undefined;
}, space, layout);
var FormLabel$1 = styled.label(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteral$1(["\n\tposition: relative;\n\tdisplay: inline-flex;\n\tmargin-bottom: ", ";\n\tline-height: ", ";\n\tfont-family: ", ";\n\tfont-size: ", ";\n\tcolor: ", ";\n\ttransition: all 250ms ease-in-out;\n\ttext-overflow: ellipsis;\n\t", "\n\n\t", ";\n\n\t", ";\n\t", ";\n"])), function (_ref2) {
  var marginBottom = _ref2.marginBottom;
  return marginBottom;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "calc(".concat(theme.fontSize, " * 1.6)");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize;
}, function (_ref6) {
  var disabled = _ref6.disabled,
      error = _ref6.error,
      theme = _ref6.theme;
  return disabled ? theme.inputLabelColorDisabled : error ? theme.error : theme.inputLabelColor;
}, function (props) {
  return props.horizontal ? css$4(["margin-bottom:0px;padding-right:", "px;padding-top:0px;padding-bottom:0px;min-width:", ";"], function (_ref7) {
    var theme = _ref7.theme;
    return theme.space[2];
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.inputHorizontalLabelWidth;
  }) : undefined;
}, function (_ref9) {
  var required = _ref9.required;
  return required && css$4(["&:after{content:\"", "\";color:", ";padding-left:2px;}"], function (_ref10) {
    var theme = _ref10.theme;
    return theme.inputRequiredIndicator;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.inputRequiredIndicatorColor;
  });
}, typography, color$1);
var InputGroup = styled.div(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteral$1(["\n\tposition: relative;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: stretch;\n\twidth: ", ";\n\theight: calc(1.25em + 1.2rem + 2px);\n"])), function (props) {
  return props.inline ? 'auto' : '100%';
});

var getInputHeight = function getInputHeight(_ref12) {
  var theme = _ref12.theme,
      _ref12$size = _ref12.size,
      size = _ref12$size === void 0 ? 'large' : _ref12$size,
      height = _ref12.height,
      isTextarea = _ref12.isTextarea;
  if (height) return height;
  if (isTextarea) return theme.textareaHeight;
  return theme["inputHeight_".concat(size)];
};

var getInputColor = function getInputColor(_ref13) {
  var theme = _ref13.theme,
      disabled = _ref13.disabled,
      error = _ref13.error;
  if (disabled) return theme.inputColorDisabled;
  if (error) return theme.error;
  return theme.inputColor;
};

var getBorderColor$1 = function getBorderColor(_ref14) {
  var theme = _ref14.theme,
      disabled = _ref14.disabled,
      error = _ref14.error,
      isValid = _ref14.isValid;
  if (disabled) return theme.inputBorderDisabled;
  if (error) return theme.error;
  if (isValid) return theme.success;
  return theme.inputBorderColor;
};

var FormControlStyled = css$4(["height:", ";height:", ";display:block;width:", ";width:100%;padding:", " ", ";font-size:", ";font-family:", ";font-weight:", ";line-height:", ";color:", ";background-color:", ";background-clip:padding-box;border:1px solid ", ";transition:border-color 0.3s ease;overflow:visible;margin:0;box-shadow:none;outline:none;box-sizing:border-box;border-radius:", ";&:disabled{background-color:", ";border-color:", ";}&::placeholder{color:", ";opacity:1;}&:hover:not(:disabled),&:focus:not(:disabled){border-color:", ";}&:focus{box-shadow:", ";}", " ", " ", ""], function (_ref15) {
  var theme = _ref15.theme,
      height = _ref15.height,
      isTextarea = _ref15.isTextarea;
  return height || (isTextarea ? theme.textareaHeight : theme.inputHeight);
}, getInputHeight, function (props) {
  return props.inline ? 'auto' : '100%';
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.inputPaddingY;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.inputPaddingX;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.inputFontSize;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontFamily;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.inputFontWeight;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.inputLineHeight;
}, getInputColor, function (_ref22) {
  var theme = _ref22.theme,
      error = _ref22.error;
  return error ? theme.inputBackgroundError : theme.inputBackground;
}, getBorderColor$1, function (_ref23) {
  var theme = _ref23.theme;
  return theme.borderRadius;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.inputBackgroundDisabled;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.inputBorderDisabled;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.inputPlaceholderColor;
}, function (_ref27) {
  var theme = _ref27.theme;
      _ref27.disabled;
  return theme.inputFocusBorderColor || theme.primary;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.focusOutline;
}, function (props) {
  return props.prefix || props.suffix ? css$4(["position:relative;flex:1 1 auto;width:1%;margin-bottom:0;"]) : undefined;
}, function (_ref29) {
  var prefix = _ref29.prefix;
  return prefix && css$4(["border-top-left-radius:0;border-bottom-left-radius:0;margin-left:-1px;"]);
}, function (_ref30) {
  var suffix = _ref30.suffix;
  return suffix && css$4(["border-top-right-radius:0;border-bottom-right-radius:0;margin-right:-1px;"]);
});
var FormControl = styled.input(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteral$1(["\n\t", "\n"])), FormControlStyled);
/** used to wrap the hint and form control and positioned absolute when in a row */

var FormHintAndFeedback = styled.div(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteral$1(["\n\tpadding-top: 4px;\n\tfont-family: ", ";\n"])), function (_ref31) {
  var theme = _ref31.theme;
  return theme.fontFamily;
});
var FormControlHint = styled.div(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteral$1(["\n\tcolor: ", ";\n\tdisplay: block;\n\tfont-family: ", ";\n\tfont-size: 0.8em;\n\tfont-weight: 400;\n\tline-height: 1em;\n"])), function (_ref32) {
  var theme = _ref32.theme;
  return theme.slateGrey;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.fontFamily;
});
var FormControlFeedback = styled(FormControlHint).attrs(function (props) {
  return {
    theme: props.theme
  };
})(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteral$1(["\n\tcolor: ", ";\n\tpadding: 2px 0px;\n\toutline: none;\n"])), function (_ref34) {
  var error = _ref34.error,
      theme = _ref34.theme;
  return error ? theme.coralPink : theme.greyBlue;
});
var DropListIndicator = styled.span(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral$1(["\n\tpadding-right: 7px;\n"])));
var InputPrependAppendBase = styled.div(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral$1(["\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: ", ";\n\tmargin-bottom: 0;\n\tfont-size: ", ";\n\tfont-family: ", ";\n\tfont-weight: ", ";\n\tline-height: 1em;\n\tcolor: ", ";\n\ttext-align: center;\n\twhite-space: nowrap;\n\tbackground-color: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: ", ";\n\tbox-sizing: border-box;\n\theight: ", ";\n"])), function (_ref35) {
  var theme = _ref35.theme;
  return "".concat(theme.inputPaddingY, " ").concat(theme.inputPaddingX);
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.inputFontSize;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.fontFamily;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.inputFontWeight;
}, function (_ref39) {
  var theme = _ref39.theme,
      disabled = _ref39.disabled,
      error = _ref39.error;
  return error ? theme.error : disabled ? theme.inputLabelColorDisabled : theme.inputColor;
}, function (_ref40) {
  var theme = _ref40.theme,
      error = _ref40.error;
  return error ? theme.inputBackgroundError : theme.inputPresetBackground;
}, function (_ref41) {
  var theme = _ref41.theme,
      disabled = _ref41.disabled,
      error = _ref41.error;
  return error ? theme.error : disabled ? theme.inputBorderDisabled : theme.inputBorderColor;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.borderRadius;
}, getInputHeight);
var InputPrepend = styled(InputPrependAppendBase)(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral$1(["\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n"])));
var InputAppend = styled(InputPrependAppendBase)(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral$1(["\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n"])));
var AddressMapContainer = styled.div(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral$1(["\n\theight: ", ";\n\tdisplay: ", ";\n\tborder-radius: ", ";\n\tmargin-top: 7px;\n"])), function (_ref43) {
  var withMap = _ref43.withMap,
      theme = _ref43.theme;
  return withMap ? theme.addressMapHeight || '300px' : '0px';
}, function (_ref44) {
  var withMap = _ref44.withMap;
  return withMap ? 'block' : 'none';
}, function (_ref45) {
  var theme = _ref45.theme;
  return theme.borderRadius;
});

var isGrouped = function isGrouped(options) {
  return options.filter(function (o) {
    return o.options;
  }).length > 0;
};

var valueContainerStyles = function valueContainerStyles(provided) {
  return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
    padding: '0px 5px'
  });
};

var groupHeadingStyles = function groupHeadingStyles(theme) {
  return function (provided) {
    return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
      color: theme.darkNavy,
      fontSize: '1em',
      fontFamily: theme.fontFamily,
      fontWeight: 500,
      textTransform: 'sentence'
    });
  };
};

var controlStyles = function controlStyles(error, theme, minWidth, size) {
  return function (provided, state) {
    var isDisabled = state.isDisabled,
        isFocused = state.isFocused,
        menuIsOpen = state.menuIsOpen;
    var borderColor = error ? theme.error : theme.inputBorderColor;
    var color = theme.inputColor;
    var shadow;
    var bg;

    if (!isDisabled && (isFocused || menuIsOpen)) {
      borderColor = theme.inputFocusBorderColor || theme.primary;
      shadow = theme.focusOutline;
    }

    if (isDisabled) {
      bg = theme.inputBackgroundDisabled;
      borderColor = theme.inputBorderDisabled;
      color = theme.inputColorDisabled;
    }

    if (error) bg = theme.inputBackgroundError;
    return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
      minHeight: theme["inputHeight_".concat(size)],
      fontSize: size === 'small' ? '12px' : theme.fontSize,
      fontFamily: theme.fontFamily,
      minWidth: minWidth || 155,
      color: color,
      borderColor: borderColor,
      background: bg,
      boxShadow: shadow,
      ':hover': {
        borderColor: theme.inputFocusBorderColor || theme.primary
      }
    });
  };
};

var placeholderStyles = function placeholderStyles(theme) {
  return function (provided) {
    return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
      color: theme.inputPlaceholderColor,
      fontSize: theme.fontSize,
      fontFamily: theme.fontFamily,
      whiteSpace: 'nowrap'
    });
  };
};

var noOptionsMessage = function noOptionsMessage(theme) {
  return function (provided) {
    return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
      textAlign: 'left',
      fontSize: theme.fontSize,
      fontFamily: theme.fontFamily
    });
  };
};

var loadingMessageStyles = function loadingMessageStyles(theme) {
  return function (provided) {
    return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
      textAlign: 'left',
      fontSize: theme.fontSize,
      fontFamily: theme.fontFamily
    });
  };
};

var menuStyles = function menuStyles(provided) {
  return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
    marginTop: '2px',
    marginBottom: '2px',
    marginLeft: '1px',
    width: 'calc(100% - 2px)'
  });
};

var menuPortalStyles = function menuPortalStyles(provided) {
  return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
    zIndex: 99
  });
};

var multiValueStyles = function multiValueStyles(theme) {
  return function (provided, state) {
    return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
      backgroundColor: state.isDisabled ? theme.grey300 : theme.multiValueBg,
      color: state.isDisabled ? theme.grey600 : theme.multiValueColor || theme.primary,
      borderRadius: '25px',
      alignItems: 'center',
      maxWidth: 'calc(100% - 10px)'
    });
  };
};

var multiValueLabelStyles = function multiValueLabelStyles(provided) {
  return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
    color: 'inherit',
    whiteSpace: 'nowrap',
    borderRadius: '25px'
  });
};

var multiValueRemoveStyles = function multiValueRemoveStyles(theme) {
  return function (provided) {
    return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
      cursor: 'pointer',
      ':hover': {
        color: theme.primary
      }
    });
  };
};

var singleValueStyles = function singleValueStyles(provided) {
  return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
    lineHeight: '1.2em',
    userSelect: 'none'
  });
};

var optionStyles = function optionStyles(theme) {
  return function (provided, state) {
    var color = theme.menuItemColor;
    var bgColor = theme.menuItemBackground;
    var bgHover = theme.menuItemBackgroundHover;

    if (state.isSelected) {
      color = theme.menuItemSelectedBg ? invert(theme.menuItemSelectedBg) : invert(theme.primary);
      bgColor = theme.menuItemSelectedBg || theme.primary;
      bgHover = theme.menuItemSelectedBg ? tintColor(theme.menuItemSelectedBg, -10) : tintColor(theme.primary, -10);
    }

    if (state.isFocused) {
      bgColor = bgHover;
    }

    if (state.isDisabled) {
      color = '#999';
      bgHover = theme.menuItemBackground;
      provided.cursor = 'not-allowed';
    }

    var padding = isGrouped(state.options) ? '8px 8px 8px 20px' : provided.padding;
    return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
      fontSize: theme.fontSize,
      fontFamily: theme.fontFamily,
      fontWeight: 400,
      color: color,
      padding: padding,
      lineHeight: '1.5em',
      background: bgColor,
      ':hover': {
        background: bgHover
      }
    });
  };
};

var clearIndicatorStyles = function clearIndicatorStyles(theme) {
  return function (provided) {
    return _objectSpread2$2(_objectSpread2$2({}, provided), {}, {
      padding: '5px 0px 5px 5px',
      background: 'none',
      cursor: 'pointer',
      ':hover': {
        color: theme.primary
      }
    });
  };
}; // eslint-disable-next-line import/prefer-default-export


var DropListStyles = function DropListStyles(error, theme, minWidth, size) {
  return {
    valueContainer: valueContainerStyles,
    groupHeading: groupHeadingStyles(theme),
    control: controlStyles(error, theme, minWidth, size),
    placeholder: placeholderStyles(theme),
    noOptionsMessage: noOptionsMessage(theme),
    loadingMessage: loadingMessageStyles(theme),
    menu: menuStyles,
    menuPortal: menuPortalStyles,
    multiValue: multiValueStyles(theme),
    multiValueLabel: multiValueLabelStyles,
    multiValueRemove: multiValueRemoveStyles(theme),
    singleValue: singleValueStyles,
    option: optionStyles(theme),
    clearIndicator: clearIndicatorStyles(theme)
  };
};

/**
 * Label with tooltip if provided
 */

var LabelWithTooltip = function LabelWithTooltip(props) {
  var label = props.label,
      tooltip = props.tooltip,
      className = props.className;
      props.id;
      var tooltipDelay = props.tooltipDelay,
      children = props.children,
      otherProps = _objectWithoutProperties$c(props, ["label", "tooltip", "className", "id", "tooltipDelay", "children"]);

  return /*#__PURE__*/React__default.createElement(Wrapper$_, {
    delay: tooltipDelay,
    className: classNames$1(className, 'label-tooltip'),
    distance: 8,
    attachedTo: /*#__PURE__*/React__default.createElement(FormLabel$1, _extends$g({
      className: classNames$1(className)
    }, otherProps), label, children)
  }, tooltip);
};

LabelWithTooltip.propTypes = {
  /** Initial/Current value, default is false */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Label is required from a UX perspective */
  tooltip: PropTypes.string
};
LabelWithTooltip.defaultProps = {
  label: '',
  tooltip: ''
};

var FormLabel = function FormLabel(_ref) {
  var label = _ref.label,
      tooltip = _ref.tooltip,
      tooltipDelay = _ref.tooltipDelay,
      required = _ref.required,
      htmlFor = _ref.htmlFor,
      rest = _objectWithoutProperties$c(_ref, ["label", "tooltip", "tooltipDelay", "required", "htmlFor"]);

  return tooltip ? /*#__PURE__*/React__default.createElement(LabelWithTooltip, _extends$g({}, rest, {
    required: required,
    label: label,
    tooltip: tooltip,
    tooltipDelay: tooltipDelay,
    htmlFor: htmlFor
  })) : /*#__PURE__*/React__default.createElement(FormLabel$1, _extends$g({}, rest, {
    required: required,
    htmlFor: htmlFor
  }), label);
};

FormLabel.propTypes = {
  /** Text in label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** text inside tooltip */
  tooltip: PropTypes.string,

  /** tooltip delay in ms */
  tooltipDelay: PropTypes.number,

  /** Adds a (*) after the label as indication */
  required: PropTypes.bool
};
FormLabel.defaultProps = {
  required: false
};
var Wrapper$Y = withTheme(FormLabel);

var BaseFieldWrapper = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var label = props.label,
      id = props.id;
      props.name;
      var hint = props.hint,
      required = props.required,
      disabled = props.disabled,
      error = props.error,
      validationState = props.validationState;
      props.className;
      var tooltip = props.tooltip,
      tooltipDelay = props.tooltipDelay;
      props.inactive;
      var children = props.children;
      props.onChange;
      props.onValueChange;
      var theme = props.theme;
      props.size;
      var width = props.width,
      rest = _objectWithoutProperties$c(props, ["label", "id", "name", "hint", "required", "disabled", "error", "validationState", "className", "tooltip", "tooltipDelay", "inactive", "children", "onChange", "onValueChange", "theme", "size", "width"]);

  rest.onMenuOpen;
      var cleanProps = _objectWithoutProperties$c(rest, ["onMenuOpen"]);

  return /*#__PURE__*/React__default.createElement(FormGroup, _extends$g({}, cleanProps, {
    ref: ref,
    theme: theme,
    error: error || validationState === 'danger',
    role: "presentation",
    tabIndex: error ? '0' : undefined,
    width: width
  }), label ? /*#__PURE__*/React__default.createElement(Wrapper$Y, {
    label: label,
    htmlFor: id,
    tooltip: tooltip,
    tooltipDelay: tooltipDelay,
    required: required,
    disabled: disabled,
    error: error || validationState === 'danger',
    theme: theme,
    marginBottom: "8px"
  }) : undefined, React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      id: id
    });
  }), hint || error ? /*#__PURE__*/React__default.createElement(FormHintAndFeedback, {
    theme: theme
  }, hint ? /*#__PURE__*/React__default.createElement(FormControlHint, {
    theme: theme,
    "aria-label": hint
  }, hint) : undefined, error ? /*#__PURE__*/React__default.createElement(FormControlFeedback, _extends$g({}, rest, {
    theme: theme,
    error: error || validationState === 'danger',
    role: "alert",
    "aria-live": "assertive"
  }), error) : undefined) : undefined);
});
var propTypes$1 = {
  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** adds a red star to the label if set to true and no value exists */
  required: PropTypes.bool,

  /** Adds a tooltip to the label */
  tooltip: PropTypes.string,

  /** Delays in seconds for showing to the tooltip on mouseenter */
  tooltipDelay: PropTypes.number,

  /** changes the look and feel of the component */
  theme: PropTypes.object,

  /** Disabled components and prevents input  */
  disabled: PropTypes.bool,

  /** Disables the component but with different styling */
  inactive: PropTypes.bool,

  /** Affects the border color  */
  validationState: PropTypes.oneOf(['', 'success', 'danger']),
  error: PropTypes.string,

  /** For horizontal forms, it allows components to sit next to it */
  inline: PropTypes.bool,

  /** Displays a small hint under the field */
  hint: PropTypes.node,

  /** Text to display for validation like error messages */
  feedback: PropTypes.node
};
BaseFieldWrapper.propTypes = propTypes$1;
BaseFieldWrapper.defaultProps = {
  required: false,
  tooltipDelay: 0.5
};
withTheme(BaseFieldWrapper);

var map_container_id = '';
var center = {
  lat: 40,
  lng: 0
}; // TODO center map to user location

var MapConfig = {
  zoom: 4,
  center: center,
  zoomControl: true,
  mapTypeControl: false,
  streetViewControl: false
};
/**
 *  Address component that lookup address from Google Places and can show a map
 */

var Address = /*#__PURE__*/function (_React$Component) {
  _inherits$c(Address, _React$Component);

  var _super = _createSuper$b(Address);

  function Address(props) {
    var _this;

    _classCallCheck$j(this, Address);

    _this = _super.call(this, props);

    _defineProperty$k(_assertThisInitialized$b(_this), "renderMap", function () {
      var map = new window.google.maps.Map(document.getElementById(map_container_id), MapConfig);

      _this.setState({
        map: map
      });
    });

    _defineProperty$k(_assertThisInitialized$b(_this), "handleFocus", function (event) {
      _this.setState({
        focused: true
      });

      if (_this.props.onFocus && _this.state.selected) _this.props.onFocus(_this.state.selected.label);
    });

    _defineProperty$k(_assertThisInitialized$b(_this), "handleBlur", function (event) {
      _this.setState({
        focused: false
      });

      if (_this.props.onBlur && _this.state.selected) _this.props.onBlur(_this.state.selected.label);
    });

    _defineProperty$k(_assertThisInitialized$b(_this), "renderOption", function (option) {
      var iconType = option.port ? option.value.length === 3 ? 'air' : 'ship' : 'location';
      return /*#__PURE__*/React__default.createElement("div", {
        className: "place-result",
        key: option.value
      }, /*#__PURE__*/React__default.createElement(Wrapper$Z, {
        icon: iconType
      }), /*#__PURE__*/React__default.createElement(Highlighter, {
        highlightClassName: "matching-highlight",
        searchWords: [_this.state.query],
        textToHighlight: option.label
      }));
    });

    _defineProperty$k(_assertThisInitialized$b(_this), "promiseOptions", function (input) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
          var options, cityLimit, autoService;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.setState({
                    query: input
                  }); // If input is less than 2 characters then hold off search


                  if (!(input.length < 2)) {
                    _context.next = 3;
                    break;
                  }

                  return _context.abrupt("return");

                case 3:
                  // Holder of results returned from google places
                  options = [];

                  if (_this.props.cityOnly) {
                    cityLimit = {
                      types: ['locality', 'political', 'geocode']
                    };
                  } //Check if we have ports to consider while searching


                  if (_this.props.ports && _this.props.ports.length) options = _this.getPorts(input);
                  autoService = new _this.props.google.places.AutocompleteService();
                  autoService.getPlacePredictions({
                    input: input,
                    cityLimit: cityLimit
                  }, function (suggestions) {
                    if (suggestions) {
                      suggestions.map(function (suggest) {
                        options.push({
                          value: suggest.place_id,
                          label: suggest.description
                        });
                      });
                    }
                  });
                  resolve(options);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty$k(_assertThisInitialized$b(_this), "searchLocation", function (input, callback) {
      _this.setState({
        query: input
      }); // If input is less than 2 characters then hold off search


      if (input.length < 2) {
        callback(null);
        return;
      } // Holder of results returned from google places


      var options = [];
      var cityLimit;

      if (_this.props.cityOnly) {
        cityLimit = {
          types: ['locality', 'political', 'geocode']
        };
      } //Check if we have ports to consider while searching


      if (_this.props.ports && _this.props.ports.length) options = _this.getPorts(input);
      var autoService = new _this.props.google.places.AutocompleteService();
      autoService.getPlacePredictions({
        input: input,
        cityLimit: cityLimit
      }, function (suggestions) {
        if (suggestions) {
          suggestions.map(function (suggest) {
            options.push({
              value: suggest.place_id,
              label: suggest.description
            });
          });
        }
      });
      var data = {
        options: options
      };
      setTimeout(function () {
        callback(null, data);
      }, 500);
    });

    _defineProperty$k(_assertThisInitialized$b(_this), "getPorts", function (query) {
      var results = [];

      _this.props.ports.map(function (option) {
        if (option.value.toLowerCase().indexOf(query.toLowerCase()) >= 0 || option.label.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
          results.push(option);
        }
      });

      return results;
    });

    _defineProperty$k(_assertThisInitialized$b(_this), "handleSelection", function (location) {
      if (location && location.value) {
        var placesService = new _this.props.google.places.PlacesService(_this.state.map);
        placesService.getDetails({
          placeId: location.value
        }, function (place, status) {
          if (_this.props.google.places.PlacesServiceStatus.OK === status) ;
        });
        if (_this.props.onChange) _this.props.onChange(_this.props.returnAddressObject ? location : location.label);

        _this.setState({
          selected: location,
          hasValue: true
        });
      } else {
        if (_this.props.onChange) _this.props.onChange('');

        _this.setState({
          selected: undefined,
          query: undefined,
          hasValue: false
        });
      }
    });

    _this.state = {
      query: '',
      options: _this.props.options || []
    };
    map_container_id = RandomID(6);
    return _this;
  }

  _createClass$i(Address, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.ready) {
        this.setState({
          geocoder: new nextProps.google.Geocoder()
        });
        this.renderMap();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.ready) {
        this.renderMap();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props;
          _this$props.label;
          _this$props.value;
          _this$props.hint;
          _this$props.inline;
          var withMap = _this$props.withMap;
          _this$props.required;
          _this$props.placeholder;
          _this$props.ready;
          var validationState = _this$props.validationState;
          _this$props.className;
          var disabled = _this$props.disabled,
          inactive = _this$props.inactive;
          _this$props.tooltip;
          _this$props.tooltipDelay;
          var optionRenderer = _this$props.optionRenderer;
          _this$props.error;
          var theme = _this$props.theme,
          rest = _objectWithoutProperties$c(_this$props, ["label", "value", "hint", "inline", "withMap", "required", "placeholder", "ready", "validationState", "className", "disabled", "inactive", "tooltip", "tooltipDelay", "optionRenderer", "error", "theme"]); // cloning props to clear unwanted props for input element


      var cleanProps = Object.assign({}, rest);
      delete cleanProps.required;
      return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, this.props, /*#__PURE__*/React__default.createElement(Async, _extends$g({}, cleanProps, {
        value: this.props.value || this.state.selected,
        options: this.state.options,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        placeholder: 'search ports, cities, or zipcodes...',
        styles: DropListStyles(validationState && validationState === 'danger', this.props.theme),
        clearable: this.props.clearable || false,
        optionRenderer: optionRenderer || this.renderOption,
        disabled: disabled || inactive,
        components: {
          DropdownIndicator: function DropdownIndicator() {
            return /*#__PURE__*/React__default.createElement("span", {
              className: "Select-arrow"
            });
          },
          IndicatorSeparator: undefined
        }
      })), /*#__PURE__*/React__default.createElement(AddressMapContainer, {
        id: map_container_id,
        withMap: withMap,
        theme: theme
      }));
    }
  }]);

  return Address;
}(React__default.Component);

Address.propTypes = {
  /** Optional title for the tooltip displayed on top of the content */
  label: PropTypes.string,

  /** Whether to show or hide the map, default is true */
  withMap: PropTypes.bool,

  /** Limits the search to cities only */
  cityOnly: PropTypes.bool,

  /** Optional list of values to include in the search (e.g. ports to filter */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })),

  /** When set to true, the full address object will be return instead of the label  */
  returnAddressObject: PropTypes.bool,

  /** Google Maps API Key */
  apiKey: PropTypes.string.isRequired
};
Address.defaultProps = {
  withMap: false
};
var Wrapper$X = compose$1(withTheme, withTransformers, MapWrapper)(Address);

var _templateObject$E, _templateObject2$x, _templateObject3$r, _templateObject4$k, _templateObject5$e;

var getBackground$1 = function getBackground(_ref) {
  var level = _ref.level,
      variation = _ref.variation,
      theme = _ref.theme;
  var mode = level || variation;

  switch (mode) {
    case 'info':
      return theme.alertInfoBackground;

    case 'success':
      return theme.alertSuccessBackground;

    case 'warning':
      return theme.alertWarningBackground;

    case 'danger':
    case 'error':
      return theme.alertErrorBackground;

    default:
      return theme.alertInfoBackground;
  }
};

var getAccent = function getAccent(_ref2) {
  var level = _ref2.level,
      variation = _ref2.variation,
      theme = _ref2.theme;
  var mode = level || variation;

  switch (mode) {
    case 'info':
      return theme.alertInfoAccent;

    case 'success':
      return theme.alertSuccessAccent;

    case 'warning':
      return theme.alertWarningAccent;

    case 'danger':
    case 'error':
      return theme.alertErrorAccent;

    default:
      return theme.alertInfoAccent;
  }
};

var StyledAlert = styled.div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral$1(["\n\tbackground: ", ";\n\tdisplay: flex;\n\tpadding: ", ";\n\tborder-radius: ", ";\n\tborder-width: ", ";\n\tborder-color: ", ";\n\tborder-style: solid;\n\tmargin-bottom: 5px;\n\tborder-left: ", " solid ", ";\n\t", ";\n\t", ";\n\t", ";\n"])), getBackground$1, function (_ref3) {
  var theme = _ref3.theme,
      isSmall = _ref3.isSmall;
  return isSmall ? theme.alertPaddingSmall : theme.alertPaddingLarge;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.alertBorderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.alertBorderWidth;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.alertBorderColor;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.alertIndentWidth;
}, getAccent, space, layout, color$1);
var AlertBody = styled.div(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteral$1(["\n\tflex-grow: 1;\n"])));
var AlertIcon = styled.div(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteral$1(["\n\tmargin-right: 8px;\n\tmargin-top: ", "px;\n"])), function (_ref8) {
  var title = _ref8.title;
  return title ? 2 : 0;
});
var AlertTitle = styled.div(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteral$1(["\n\tcolor: ", ";\n\tfont-size: ", ";\n\tfont-family: ", ";\n\tfont-weight: bold;\n\tline-height: 1.5em;\n\tpadding-bottom: 5px;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.alertTitleColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.alertTitleFontSize;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontFamily;
});
var AlertContent = styled.div(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteral$1(["\n\t& * {\n\t\tcolor: ", ";\n\t\tfont-size: ", ";\n\t\tfont-family: ", ";\n\t\tline-height: 1.5;\n\t}\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.alertBodyColor;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.alertBodyFontSize;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontFamily;
});

var Alert = function Alert(props) {
  var level = props.level,
      variation = props.variation,
      closable = props.closable,
      children = props.children,
      title = props.title,
      onClose = props.onClose,
      rest = _objectWithoutProperties$c(props, ["level", "variation", "closable", "children", "title", "onClose"]);

  var icon = '';
  var iconColor = '';
  var mode = level || variation;

  switch (mode) {
    case 'info':
      icon = 'circle-info';
      iconColor = props.theme.alertInfoAccent;
      break;

    case 'success':
      icon = 'check';
      iconColor = props.theme.alertSuccessAccent;
      break;

    case 'warning':
      icon = 'warning';
      iconColor = props.theme.alertWarningAccent;
      break;

    case 'danger':
    case 'error':
      icon = 'circle-close';
      iconColor = props.theme.alertErrorAccent;
      break;

    default:
      icon = 'circle-info';
      iconColor = props.theme.alertInfoAccent;
  }

  var isSmall = !title;
  return /*#__PURE__*/React__default.createElement(StyledAlert, _extends$g({}, rest, {
    variation: mode,
    role: "alert",
    isSmall: isSmall
  }), /*#__PURE__*/React__default.createElement(AlertIcon, null, rest.icon || /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    icon: icon,
    size: isSmall ? 16 : 24,
    color: iconColor,
    hoverColor: iconColor,
    onClick: onClose
  })), /*#__PURE__*/React__default.createElement(AlertBody, {
    "aria-live": "assertive"
  }, title && /*#__PURE__*/React__default.createElement(AlertTitle, rest, title), /*#__PURE__*/React__default.createElement(AlertContent, rest, children)), closable ? /*#__PURE__*/React__default.createElement(Wrapper$Z, _extends$g({}, rest, {
    onClick: onClose,
    icon: "close",
    color: props.theme.alertCloseColor,
    size: 14,
    mt: "4px"
  })) : undefined);
};

Alert.propTypes = {
  /** Child to be rendered inside. Can be any element */
  title: PropTypes.string,

  /** Child to be rendered inside. Can be any element */
  children: PropTypes.node.isRequired,

  /** Alert style determining the color  */
  variation: PropTypes.oneOf(['success', 'warning', 'danger', 'info', 'error']),

  /** Alias for variation  */
  level: PropTypes.oneOf(['success', 'warning', 'danger', 'info', 'error']),

  /** Boolean to render a close button that hides the alert */
  closable: PropTypes.bool,

  /** Called when the close icon is clicked */
  onClose: PropTypes.func
};
Alert.defaultProps = {
  variation: 'info',
  onClose: function onClose() {}
};
var Wrapper$W = compose$1(withTheme)(Alert);

var _templateObject$D;
var StyledLabel = styled.div(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral$1(["\n\tfont-size: ", ";\n\tfont-family: ", ";\n\ttransition: all 0.2s ease-in-out;\n\tdisplay: block;\n\tline-height: 1.3em;\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, space, typography, color$1, layout, border, position);

var Label$4 = function Label(props) {
  return props.tooltip ? /*#__PURE__*/React__default.createElement(LabelWithTooltip, props) : /*#__PURE__*/React__default.createElement(StyledLabel, props);
};

Label$4.propTypes = {
  // sets the underlying DOM element of this component (i.e. span, div, h1 ,etc...)
  as: PropTypes.string,
  // Font color
  color: PropTypes.string,
  // Background color
  bg: PropTypes.string,
  // Margin. Can be individually applied like ml (margin-left), or mx (margin for X axis) etc...
  m: PropTypes.string,
  // Padding. Can be individually applied like pl (padding-left), or px (padding for X axis) etc...
  p: PropTypes.string
};
Label$4.defaultProps = {
  as: 'label'
};
var Wrapper$V = withTheme(Label$4);

var _templateObject$C, _templateObject2$w, _templateObject3$q, _templateObject4$j;
var rotate = keyframes$2(["100%{transform:rotate(360deg);}"]);
var dash = keyframes$2(["0%{stroke-dasharray:1,200;stroke-dashoffset:0;}50%{stroke-dasharray:89,200;stroke-dashoffset:-15;}100%{stroke-dasharray:89,200;stroke-dashoffset:-124;}"]);
var loading = keyframes$2(["from{left:-200px;width:10%;}50%{width:40%;}70%{width:70%;}80%{left:60%;}95%{left:100%;}to{left:100%;}"]);

var getSize$2 = function getSize(props) {
  var size = props.size;

  switch (props.size) {
    case 'large':
      size = '100px';
      break;

    case 'medium':
      size = '50px';
      break;

    case 'small':
      size = '25px';
      break;
  }

  return size;
};

var getColor$5 = function getColor(props) {
  return props.color || props.theme[props.variation];
};

var StyledCircularLoader = styled.div(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral$1(["\n\t", ";\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: ", ";\n\theight: ", ";\n"])), space, getSize$2, getSize$2);
var StyledCircleWrapper = styled.span(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteral$1(["\n\tsvg {\n\t\tanimation: ", " 2s linear infinite;\n\t\tposition: relative;\n\t\tstroke: ", ";\n\t}\n\t.path {\n\t\tstroke-dasharray: 1, 200;\n\t\tstroke-dashoffset: 0;\n\t\tanimation: ", " 1.5s ease-in-out infinite;\n\t\tstroke-linecap: round;\n\t}\n"])), rotate, getColor$5, dash);
var StyledLinearLoader = styled.div(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteral$1(["\n\theight: ", ";\n\twidth: 100%;\n\tposition: relative;\n\toverflow: hidden;\n\t&:before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 0px;\n\t\topacity: 0.25;\n\t\tbackground-color: ", ";\n\t\twidth: 100%;\n\t\theight: ", ";\n\t}\n\n\t&:after {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tcontent: '';\n\t\tleft: -500px;\n\t\twidth: 100px;\n\t\theight: ", ";\n\t\tbackground-color: ", ";\n\t\tanimation: ", " 2s cubic-bezier(0.64, 0.84, 0.73, 0.37) infinite;\n\t}\n"])), function (props) {
  return props.height;
}, getColor$5, function (props) {
  return props.height;
}, function (props) {
  return props.height;
}, getColor$5, loading);
var StyledCircleContent = styled.div(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tdisplay: flex;\n"])));

var variations = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};

/**
 *
 * Extracts the values of af an object since Object.values is not supported in many browsers
 * Returns an array of values found in this object (first level only - no deep parse)
 * @param {*} object
 */
var objectValues = function objectValues(object) {
  if (!object || object === {}) return [];
  return Object.keys(object).map(function (k) {
    return object[k];
  });
};

var CircularLoader = function CircularLoader(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties$c(_ref, ["children"]);

  return /*#__PURE__*/React__default.createElement(StyledCircularLoader, props, /*#__PURE__*/React__default.createElement(StyledCircleWrapper, props, /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "25 25 50 50"
  }, /*#__PURE__*/React__default.createElement("circle", {
    className: "path",
    cx: 50,
    cy: 50,
    r: 20,
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React__default.createElement(StyledCircleContent, null, children));
};

CircularLoader.propTypes = {
  /** Can be predefined like: large, medium or small or specific like 30px */
  size: PropTypes.any,

  /** Defines the color of the loader 'primary', 'secondary', 'success', 'warning', 'danger','info'  */
  variation: PropTypes.oneOf(objectValues(variations)),

  /** CSS or HEX color  */
  color: PropTypes.string
};
CircularLoader.defaultProps = {
  size: 'medium',
  variation: 'primary'
};
var Wrapper$U = withTheme(CircularLoader);

var LinearLoader = function LinearLoader(props) {
  return /*#__PURE__*/React__default.createElement(StyledLinearLoader, props);
};

LinearLoader.propTypes = {
  /** Defines the color of the loader 'primary', 'secondary', 'success', 'warning', 'danger','info'   */
  variation: PropTypes.oneOf(objectValues(variations)),

  /** Loader height in px (e.g. 4px) */
  height: PropTypes.string,

  /** Specific CSS or HEX color */
  color: PropTypes.string
};
LinearLoader.defaultProps = {
  variation: 'primary',
  height: '5px'
};
var Wrapper$T = withTheme(LinearLoader);

var DropList = function DropList(props) {
  var name = props.name,
      id = props.id,
      creatable = props.creatable,
      async = props.async,
      multi = props.multi,
      value = props.value,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onChange = props.onChange,
      initialFocused = props.initialFocused,
      dropdownIndicator = props.dropdownIndicator,
      minWidth = props.minWidth,
      valueKey = props.valueKey,
      labelKey = props.labelKey,
      options = props.options;
      props.optionRenderer;
      props.transformIn;
      props.transformOut;
      var clearable = props.clearable,
      theme = props.theme,
      size = props.size,
      hideSelectedOptions = props.hideSelectedOptions,
      formatCreateLabel = props.formatCreateLabel,
      searchHintMessage = props.searchHintMessage,
      selectComponents = props.selectComponents,
      styles = props.styles,
      innerRef = props.innerRef,
      rest = _objectWithoutProperties$c(props, ["name", "id", "creatable", "async", "multi", "value", "onFocus", "onBlur", "onChange", "initialFocused", "dropdownIndicator", "minWidth", "valueKey", "labelKey", "options", "optionRenderer", "transformIn", "transformOut", "clearable", "theme", "size", "hideSelectedOptions", "formatCreateLabel", "searchHintMessage", "selectComponents", "styles", "innerRef"]);

  var disabled = rest.disabled,
      error = rest.error,
      validationState = rest.validationState;
  /**
   * Define which component to use
   */

  var Select = null;

  if (creatable) {
    Select = require(async ? 'react-select/async-creatable' : 'react-select/creatable')["default"];
  } else {
    Select = require(async ? 'react-select/async' : 'react-select')["default"];
  }
  /**
   * An ID to be used for accessibility
   */


  var componentId = id || name || RandomID(6);
  /**
   * return proper value structure
   */

  var getValue = function getValue(val) {
    if (!val) return null;

    if (Array.isArray(val)) {
      return val.map(function (v) {
        return getValue(v);
      });
    }

    if (typeof val === 'string' || typeof val === 'number') {
      var optionsList = options; // Check if options are grouped

      if (options.length && options[0].options) {
        optionsList = options.reduce(function (arr, current) {
          var prev = arr.options ? arr.options : Array.isArray(arr) ? arr : [arr]; // first option might not be an array

          var next = current.options || [current];
          return [].concat(_toConsumableArray$2(prev), _toConsumableArray$2(next));
        });
      }

      var valueFromOptions = optionsList.filter(function (option) {
        return "".concat(option[valueKey]) === "".concat(val);
      });

      if (valueFromOptions[0]) {
        var v = valueFromOptions[0];
        return _objectSpread2$2(_objectSpread2$2({}, v), {}, {
          value: v[valueKey],
          label: v[labelKey]
        });
      }
    }

    return _objectSpread2$2(_objectSpread2$2({}, val), {}, {
      value: val[valueKey],
      label: val[labelKey]
    });
  };
  /**
   * return the selected value
   */


  var handleChange = function handleChange(option) {
    onChange(option);
  };

  var isOptionDisabled = function isOptionDisabled(option) {
    return option.disabled;
  };
  /**
   * Generate themed styled for react-select component
   */


  var getStyles = function getStyles() {
    return DropListStyles(error || validationState && validationState === 'danger', theme, minWidth, size);
  };
  /**
   *
   *  Custom components
   *
   */


  var getDropIndicator = function getDropIndicator() {
    return /*#__PURE__*/React__default.createElement(DropListIndicator, null, dropdownIndicator || /*#__PURE__*/React__default.createElement(Wrapper$Z, {
      icon: "arrow-down",
      color: theme.grey300,
      hoverColor: theme.primary,
      size: size === 'small' ? 20 : 24
    }));
  };

  var getNoOptions = function getNoOptions(props) {
    return /*#__PURE__*/React__default.createElement(components.NoOptionsMessage, props, searchHintMessage);
  };

  var getLoading = function getLoading() {
    return /*#__PURE__*/React__default.createElement(Wrapper$U, {
      size: "20px"
    });
  };

  var getClearIndicator = function getClearIndicator(props) {
    props.cx;
        var rest = _objectWithoutProperties$c(props, ["cx"]);

    var _props$children = props.children,
        children = _props$children === void 0 ? /*#__PURE__*/React__default.createElement(Wrapper$Z, _extends$g({}, rest, {
      icon: "close",
      size: 14,
      cursor: "pointer",
      color: theme.inputClearColor || theme.greyBlue,
      hoverColor: theme.inputClearHover || theme.primary
    })) : _props$children,
        getStyles = props.getStyles,
        _props$innerProps = props.innerProps,
        ref = _props$innerProps.ref,
        restInnerProps = _objectWithoutProperties$c(_props$innerProps, ["ref"]);

    return /*#__PURE__*/React__default.createElement("div", _extends$g({}, restInnerProps, {
      ref: ref,
      style: getStyles('clearIndicator', props)
    }), /*#__PURE__*/React__default.createElement("div", {
      style: {
        lineHeight: '1'
      }
    }, children));
  };

  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, _extends$g({}, rest, {
    id: componentId,
    theme: theme,
    ref: innerRef
  }), /*#__PURE__*/React__default.createElement(Select, _extends$g({}, rest, {
    value: getValue(value),
    hideSelectedOptions: hideSelectedOptions,
    options: options,
    onChange: handleChange,
    onFocus: onFocus,
    onBlur: onBlur,
    isMulti: multi,
    "aria-labelledby": componentId,
    getOptionLabel: function getOptionLabel(option) {
      return option[labelKey];
    },
    getOptionValue: function getOptionValue(option) {
      return option[valueKey];
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
      var _ref;

      return _ref = {}, _defineProperty$k(_ref, labelKey, optionLabel), _defineProperty$k(_ref, valueKey, inputValue), _defineProperty$k(_ref, "isNew", true), _ref;
    },
    formatCreateLabel: formatCreateLabel,
    styles: styles || getStyles(),
    autoFocus: initialFocused,
    isClearable: clearable,
    isCreatable: creatable,
    escapeClearsValue: clearable,
    isOptionDisabled: isOptionDisabled,
    isDisabled: disabled,
    menuPlacement: "auto",
    menuShouldScrollIntoView: true,
    openMenuOnClick: options.length,
    components: _objectSpread2$2({
      DropdownIndicator: getDropIndicator,
      ClearIndicator: getClearIndicator,
      IndicatorSeparator: undefined,
      NoOptionsMessage: getNoOptions,
      LoadingIndicator: getLoading
    }, selectComponents)
  })));
};

DropList.propTypes = {
  /** fires when the the value of the field changes. If creatable, it returns the value entered by the user  */
  onChange: PropTypes.func,

  /** fires when the focus has left the field  */
  onBlur: PropTypes.func,

  /** fires when field is in focus  */
  onFocus: PropTypes.func,

  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Placeholder */
  placeholder: PropTypes.string,

  /** adds a red star to the label if set to true and no value exists  */
  required: PropTypes.bool,

  /** Adds a tooltip to the label  */
  tooltip: PropTypes.string,

  /** Delays in seconds for showing to the tooltip on mouseenter */
  tooltipDelay: PropTypes.number,

  /** changes the look and feel of the component */
  theme: PropTypes.object,

  /** Disabled components and prevents input */
  disabled: PropTypes.bool,

  /** Switches the component to pick up multiple options with autocomplete instead of a dropdown */
  multi: PropTypes.bool,

  /** * Required array of options  */
  // options: PropTypes.arrayOf(
  // 	PropTypes.oneOfType([
  // 		PropTypes.shape({
  // 			value: PropTypes.oneOf([PropTypes.string, PropTypes.number]).isRequired,
  // 			label: PropTypes.string.isRequired,
  // 		}),
  // 		PropTypes.shape({
  // 			groupValue: PropTypes.string.isRequired,
  // 			groupLabel: PropTypes.string.isRequired,
  // 			children: PropTypes.arrayOf(
  // 				PropTypes.shape({
  // 					value: PropTypes.oneOf([PropTypes.string, PropTypes.number]).isRequired,
  // 					label: PropTypes.string.isRequired,
  // 				})
  // 			),
  // 		}),
  // 	])
  // ).isRequired,

  /** To customize Option items in list. The option is passed as param to this function */
  optionRenderer: PropTypes.func,

  /** Defaults to false which means we always select first option  */
  allowEmpty: PropTypes.bool,

  /** Allows user to type in their own value if not found in the list.  */
  creatable: PropTypes.bool,

  /** Text showing when this is a creatable. A function that takes a value and should return node or string  */
  formatCreateLabel: PropTypes.func,

  /** Droplist indicator component */
  dropdownIndicator: PropTypes.node,

  /** Set the focus to this component immediately after it's mounted */
  initialFocused: PropTypes.bool,

  /** Useful if objects in the returned results from the API are not {value, label} */
  valueKey: PropTypes.string,

  /** Useful if objects in the returned results from the API are not {value, label} */
  labelKey: PropTypes.string,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func,

  /** Removed the selected options from the droplist */
  hideSelectedOptions: PropTypes.bool,

  /** Object of custom components replacing the default. Check react-select */
  selectComponents: PropTypes.object
};
DropList.defaultProps = {
  value: undefined,
  onChange: function onChange() {},
  onBlur: undefined,
  onFocus: undefined,
  valueKey: 'value',
  labelKey: 'label',
  placeholder: 'Select...',
  required: false,
  tooltip: undefined,
  tooltipDelay: 0.5,
  inactive: false,
  allowEmpty: true,
  multi: false,
  options: [],
  initialFocused: false,
  size: 'large',
  hideSelectedOptions: true,
  formatCreateLabel: function formatCreateLabel(value) {
    return /*#__PURE__*/React__default.createElement(Wrapper$V, null, "Create ", value);
  },
  searchHintMessage: 'Type to search'
};
DropList.displayName = 'DropList';
var Wrapper$S = compose$1(withTheme, withTransformers)(DropList);

var _templateObject$B, _templateObject2$v, _templateObject3$p, _templateObject4$i;
var SwitchWrapper = styled(Wrapper$Y)(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral$1(["\n\tposition: relative;\n\n\tinput:focus + span {\n\t\tbox-shadow: ", ";\n\t}\n\topacity: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.focusOutline;
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? '0.5' : 1;
});
var SwitchLabel = styled.span(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral$1(["\n\tpadding-right: ", "px;\n\tpadding-left: ", "px;\n"])), function (_ref3) {
  var flip = _ref3.flip,
      horizontal = _ref3.horizontal;
  return horizontal && !flip ? 10 : 0;
}, function (_ref4) {
  var flip = _ref4.flip,
      horizontal = _ref4.horizontal;
  return horizontal && flip ? 10 : 0;
});
var StyledSwitch = styled.span(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteral$1(["\n\tcursor: pointer;\n\theight: ", "px;\n\tbackground-color: ", ";\n\tborder-radius: ", "px;\n\twidth: ", "px;\n\tdisplay: inline-block;\n\tposition: relative;\n\ttransition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);\n\n\t&:after {\n\t\ttransition: all 0.2s linear;\n\t\tcontent: '';\n\t\tdisplay: inline-block;\n\t\tposition: absolute;\n\t\ttop: 2px;\n\t\twidth: ", "px;\n\t\theight: ", "px;\n\t\tbox-sizing: border-box;\n\t\tbackground: ", ";\n\t\tborder-radius: ", "px;\n\t\tbox-shadow: ", ";\n\t\ttransition: all 100ms cubic-bezier(0.4, 0, 0.2, 1);\n\t\ttransform: translateX(", ");\n\t}\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.switchTrackHeight;
}, function (_ref6) {
  var theme = _ref6.theme,
      checked = _ref6.checked;
  return checked ? theme.switchTrackBgColorOn || theme.primary : theme.switchTrackBgColorOff;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.switchTrackHeight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.switchTrackWidth;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.switchTrackHeight - 4;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.switchTrackHeight - 4;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.switchNobColor;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.switchTrackHeight - 2;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.switchNobShadow;
}, function (_ref14) {
  var theme = _ref14.theme,
      checked = _ref14.checked;
  return checked ? "".concat(theme.switchTrackHeight + 2, "px") : '2px';
});
var StyledSwitchInput = styled.input(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\tpointer-events: none;\n\topacity: 0;\n"])));

var Switch = function Switch(props) {
  var id = props.id,
      label = props.label,
      labelTrue = props.labelTrue,
      labelFalse = props.labelFalse,
      value = props.value,
      theme = props.theme;
      props.onChange;
      props.onValueChange;
      var horizontal = props.horizontal,
      flip = props.flip;
      props.className;
      var tooltip = props.tooltip,
      tooltipDelay = props.tooltipDelay,
      returnBinary = props.returnBinary,
      rest = _objectWithoutProperties$c(props, ["id", "label", "labelTrue", "labelFalse", "value", "theme", "onChange", "onValueChange", "horizontal", "flip", "className", "tooltip", "tooltipDelay", "returnBinary"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray$8(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  useEffect(function () {
    setChecked(value);
  }, [value]);

  var handleChange = function handleChange() {
    var newVal = returnBinary ? checked ? 0 : 1 : !checked;
    if (props.onChange) props.onChange(newVal);
    setChecked(newVal);
  };

  var caption = label || (value ? labelTrue : labelFalse);
  var componentId = id || RandomID(6);
  return /*#__PURE__*/React__default.createElement(FormGroup, _extends$g({}, rest, {
    theme: theme
  }), /*#__PURE__*/React__default.createElement(SwitchWrapper, {
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SwitchLabel, {
      horizontal: horizontal,
      flip: flip
    }, caption), /*#__PURE__*/React__default.createElement(StyledSwitchInput, _extends$g({}, rest, {
      id: componentId,
      type: "checkbox",
      onChange: handleChange,
      checked: checked
    })), /*#__PURE__*/React__default.createElement(StyledSwitch, {
      theme: theme,
      pose: checked ? 'on' : 'off',
      checked: checked,
      disabled: rest.disabled
    })),
    disabled: props.disabled,
    tooltip: tooltip,
    tooltipDelay: tooltipDelay,
    theme: theme,
    style: {
      display: 'inline-flex',
      alignItems: horizontal ? 'center' : 'flex-start',
      flexDirection: horizontal ? flip ? 'row-reverse' : 'row' : 'column',
      'input:focus + span': {
        border: '1px solid'
      }
    },
    htmlFor: componentId
  }));
};

Switch.propTypes = {
  /** Boolean value of the switch */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),

  /** Displayed label for the switch */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** If label when true is different */
  labelTrue: PropTypes.string,

  /** If label when false is different */
  labelFalse: PropTypes.string,

  /** Function executed onChange event */
  onChange: PropTypes.func,

  /** Displays the switch horizontally with the label */
  horizontal: PropTypes.bool,

  /** Flips direction of label and switch. Applied to row and column */
  flip: PropTypes.bool,

  /** If true, the switch will return 1/0 instead of true/false */
  returnBinary: PropTypes.bool,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
Switch.defaultProps = {
  horizontal: true,
  flip: true,
  returnBinary: false
};
var Wrapper$R = compose$1(withTheme, withTransformers)(Switch);

var _templateObject$A, _templateObject2$u, _templateObject3$o;
var OptionDescription$1 = styled.span(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral$1(["\n\tfont-size: 0.9em;\n\tcolor: ", ";\n\tdisplay: block;\n\tmargin-top: ", "px;\n\tpadding-left: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.checkboxOptionDescriptionColor;
}, function (_ref2) {
  var horizontal = _ref2.horizontal;
  return !horizontal ? -3 : 0;
}, function (_ref3) {
  var paddingLeft = _ref3.paddingLeft;
  return paddingLeft;
});
var CheckInput = styled.input(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\theight: ", ";\n\twidth: ", ";\n\tborder-radius: ", ";\n\tleft: 0px;\n\ttop: 0px;\n\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: ", ";\n\t}\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.checkboxSize;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.checkboxSize;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.checkboxBorderRadius;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.focusOutline;
});
var CheckOption$1 = styled.label(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteral$1(["\n\tdisplay: ", ";\n\tposition: relative;\n\tfont-size: ", ";\n\tuser-select: none;\n\twidth: ", ";\n\tmin-height: 20px;\n\t", "\n\n\t& input {\n\t\topacity: 0.0001;\n\n\t\t& + label {\n\t\t\t&::before {\n\t\t\t\tcontent: '';\n\t\t\t\theight: ", ";\n\t\t\t\twidth: ", ";\n\t\t\t\tcursor: ", ";\n\t\t\t\tborder-radius: ", ";\n\t\t\t\tborder: ", " solid\n\t\t\t\t\t", ";\n\t\t\t\tbackground: ", ";\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 2px;\n\t\t\t\tleft: 0px;\n\t\t\t}\n\t\t}\n\n\t\t&:checked + label::before {\n\t\t\tbackground: ", ";\n\t\t\tborder-color: ", ";\n\t\t}\n\t\t&:checked + label::after {\n\t\t\tcontent: '';\n\t\t\tcursor: pointer;\n\t\t\tdisplay: block;\n\t\t\ttransform: rotate(45deg) translateY(-50%) translateX(-50%);\n\t\t\ttransform-origin: center;\n\t\t\theight: 10px;\n\t\t\twidth: 5px;\n\t\t\tborder-bottom: 2px solid ", ";\n\t\t\tborder-right: 2px solid ", ";\n\t\t\tbox-sizing: border-box;\n\t\t\tposition: absolute;\n\t\t\ttop: ", ";\n\t\t\tleft: ", ";\n\t\t\tmargin-top: 1px;\n\t\t}\n\t\t&:focus + label::before {\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t}\n\tlabel {\n\t\toutline: none;\n\t}\n\t&:focus {\n\t\toutline: none;\n\t}\n"])), function (_ref8) {
  var inline = _ref8.inline,
      horizontal = _ref8.horizontal;
  return inline || horizontal ? 'inline-block' : 'block';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSize;
}, function (_ref10) {
  var columned = _ref10.columned;
  return columned ? '30%' : 'auto';
}, space, function (_ref11) {
  var theme = _ref11.theme;
  return theme.checkboxSize;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.checkboxSize;
}, function (_ref13) {
  var disabled = _ref13.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.checkboxBorderRadius;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.checkboxBorderWidth;
}, function (props) {
  return props.error ? props.theme.error : props.theme.inputBorderColor;
}, function (_ref16) {
  var theme = _ref16.theme,
      disabled = _ref16.disabled;
  return disabled ? theme.checkboxCheckedBgDisabled : theme.checkboxBg;
}, function (_ref17) {
  var theme = _ref17.theme,
      disabled = _ref17.disabled;
  return disabled ? theme.checkboxCheckedBgDisabled : theme.checkboxCheckedBg || theme.primary;
}, function (_ref18) {
  var theme = _ref18.theme,
      disabled = _ref18.disabled;
  return disabled ? theme.checkMarkColorDisabled : theme.checkboxCheckedBg || theme.primary;
}, function (_ref19) {
  var theme = _ref19.theme,
      disabled = _ref19.disabled;
  return disabled ? theme.checkMarkColorDisabled : theme.checkMarkColor;
}, function (_ref20) {
  var theme = _ref20.theme,
      disabled = _ref20.disabled;
  return disabled ? theme.checkMarkColorDisabled : theme.checkMarkColor;
}, function (_ref21) {
  var theme = _ref21.theme;
  return "calc((".concat(theme.checkboxSize, " / 2))");
}, function (_ref22) {
  var theme = _ref22.theme;
  return "calc((".concat(theme.checkboxSize, " / 2) - 4px)");
}, function (_ref23) {
  var theme = _ref23.theme,
      disabled = _ref23.disabled;
  return !disabled && theme.focusOutline;
});
var StyledCheckbox = function StyledCheckbox(_ref24) {
  var id = _ref24.id,
      label = _ref24.label;
      _ref24.value;
      var onChange = _ref24.onChange;
      _ref24.error;
      var isChecked = _ref24.isChecked,
      tooltip = _ref24.tooltip,
      description = _ref24.description,
      rest = _objectWithoutProperties$c(_ref24, ["id", "label", "value", "onChange", "error", "isChecked", "tooltip", "description"]);

  var labelStyle = {
    paddingLeft: "calc(".concat(rest.theme.checkboxSize, " + 8px)"),
    paddingRight: '10px',
    display: 'inline-block',
    verticalAlign: 'text-top'
  };
  if (!rest.columned) labelStyle.minWidth = 'auto';
  return /*#__PURE__*/React__default.createElement(CheckOption$1, rest, /*#__PURE__*/React__default.createElement(CheckInput, {
    type: "checkbox",
    checked: isChecked,
    id: id,
    onChange: onChange,
    ref: rest.ref,
    tabIndex: rest.tabIndex
  }), /*#__PURE__*/React__default.createElement(Wrapper$Y, {
    theme: rest.theme,
    htmlFor: id,
    label: label,
    tooltip: tooltip,
    style: labelStyle
  }), description && /*#__PURE__*/React__default.createElement(OptionDescription$1, {
    theme: rest.theme,
    paddingLeft: labelStyle.paddingLeft
  }, description));
};

/**
 * Simple checkbox that is very similar to a Switch in functionality
 */

var Checkbox = function Checkbox(props) {
  var id = props.id,
      label = props.label,
      value = props.value,
      tooltip = props.tooltip;
      props.className;
      props.tooltipDelay;
      var disabled = props.disabled,
      onChange = props.onChange,
      description = props.description;
      props.inactive;
      var theme = props.theme,
      returnBinary = props.returnBinary,
      rest = _objectWithoutProperties$c(props, ["id", "label", "value", "tooltip", "className", "tooltipDelay", "disabled", "onChange", "description", "inactive", "theme", "returnBinary"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray$8(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  useEffect(function () {
    setChecked(value);
  }, [value]);
  /**
   * Handle clicking and switch value to !value
   *
   */

  var handleSelect = function handleSelect(e) {
    if (!disabled) {
      var newVal = returnBinary ? checked ? 0 : 1 : !checked;
      onChange(newVal, e); // sending the event for editable table case

      setChecked(newVal);
    }
  };

  var componentId = id || RandomID(6);

  var cleanProps = _objectSpread2$2({}, rest);

  delete cleanProps.inactive;
  return /*#__PURE__*/React__default.createElement(StyledCheckbox, _extends$g({}, rest, {
    theme: theme,
    disabled: disabled,
    role: "checkbox",
    type: "checkbox",
    id: componentId,
    value: checked,
    isChecked: checked,
    onChange: handleSelect,
    tooltip: tooltip,
    label: label,
    description: description
  }));
};

Checkbox.propTypes = {
  /** Initial/Current value, default is false */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),

  /** Optional label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Tooltip to show on top of label */
  tooltip: PropTypes.string,

  /** Additional description next to the checkbox label */
  description: PropTypes.string,

  /** Function to call when this component is clicked */
  onChange: PropTypes.func,

  /** If true, the switch will return 1/0 instead of true/false */
  returnBinary: PropTypes.bool
};
Checkbox.defaultProps = {
  value: false,
  returnBinary: false,
  onChange: function onChange(v) {}
};
var Wrapper$Q = withTheme(Checkbox);

var SelectDropList = function SelectDropList(props) {
  var _allSelectedValue;

  var theme = props.theme,
      onChange = props.onChange,
      value = props.value,
      options = props.options,
      showSelectAll = props.showSelectAll,
      selectAllValue = props.selectAllValue,
      selectAllLabel = props.selectAllLabel,
      rest = _objectWithoutProperties$c(props, ["theme", "onChange", "value", "options", "showSelectAll", "selectAllValue", "selectAllLabel"]);

  var _useState = useState(),
      _useState2 = _slicedToArray$8(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var componentRef = useRef();

  var handleClickOutside = function handleClickOutside(e) {
    if (componentRef.current && !componentRef.current.contains(e.target)) {
      setOpen();
    }
  };

  useEffect(function () {
    document.addEventListener('mousedown', handleClickOutside, false);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside, false);
    };
  }, [componentRef]);
  var isAllSelected = value && options && value.length === options.length;
  var allSelectedValue = (_allSelectedValue = {}, _defineProperty$k(_allSelectedValue, props.valueKey, 'all'), _defineProperty$k(_allSelectedValue, props.labelKey, selectAllValue), _allSelectedValue);
  /**
   * return the selected value
   */

  var handleChange = function handleChange(option, checked) {
    if (!value || !value.length) {
      onChange([option]);
    }

    var valueKey = rest.valueKey;
    var newValue = value;

    if (checked) {
      newValue = [].concat(_toConsumableArray$2(newValue), [option]);
    } else {
      newValue = value.filter(function (o) {
        if (Object.keys(o).length) {
          return o[valueKey] !== option[valueKey];
        }

        return "".concat(o) !== "".concat(option[valueKey]);
      });
    }

    onChange(newValue);
  };
  /**
   * return the selected value
   */


  var handleSelectAll = function handleSelectAll(checked) {
    onChange(checked ? options : []);
  };
  /**
   * Handle inner droplist onChange
   */


  var handleDropListChange = function handleDropListChange(selected) {
    onChange(selected);
  };

  var SelectAll = function SelectAll(props) {
    return /*#__PURE__*/React__default.createElement(components.MenuList, props, /*#__PURE__*/React__default.createElement("div", {
      style: {
        padding: '12px'
      }
    }, showSelectAll && /*#__PURE__*/React__default.createElement(Wrapper$R, {
      label: selectAllLabel,
      flip: false,
      value: isAllSelected,
      onChange: handleSelectAll,
      mb: 2
    }), props.children));
  };

  var Option = function Option(props) {
    var isSelected = props.isSelected,
        options = props.options,
        label = props.label,
        theme = props.theme,
        value = props.value,
        data = props.data;
    var checked = isAllSelected || isSelected || options.find(function (o) {
      return o[rest.valueKey] === value[rest.valueKey];
    }) !== undefined;
    return /*#__PURE__*/React__default.createElement(Wrapper$Q, {
      label: label,
      theme: theme,
      value: checked,
      mb: 1,
      onChange: function onChange(val) {
        return handleChange(data, val);
      }
    });
  };

  return /*#__PURE__*/React__default.createElement(Wrapper$S, _extends$g({}, rest, {
    innerRef: componentRef,
    value: isAllSelected ? allSelectedValue : value,
    onChange: handleDropListChange,
    isSearchable: false,
    options: options,
    theme: theme,
    multi: value && Array.isArray(value) && value.length < options.length,
    closeMenuOnSelect: false,
    menuIsOpen: isOpen,
    onMenuOpen: function onMenuOpen() {
      return setOpen(true);
    },
    hideSelectedOptions: false,
    selectComponents: {
      MenuList: SelectAll,
      Option: Option
    }
  }));
};

SelectDropList.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])),

  /** Useful if objects in the returned results from the API are not {value, label} */
  valueKey: PropTypes.string,

  /** Useful if objects in the returned results from the API are not {value, label} */
  labelKey: PropTypes.string,

  /** fires when the the value of the field changes. If creatable, it returns the value entered by the user  */
  onChange: PropTypes.func,

  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Placeholder */
  placeholder: PropTypes.string,

  /** adds a red star to the label if set to true and no value exists  */
  required: PropTypes.bool,

  /** Adds a tooltip to the label  */
  tooltip: PropTypes.string,

  /** Delays in seconds for showing to the tooltip on mouseenter */
  tooltipDelay: PropTypes.number,

  /** changes the look and feel of the component */
  theme: PropTypes.object,

  /** Disabled components and prevents input */
  disabled: PropTypes.bool,

  /** To customize Option items in list. The option is passed as param to this function */
  optionRenderer: PropTypes.func,

  /** SelectDroplist indicator component */
  dropdownIndicator: PropTypes.node,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func,

  /** Controls whether to show the Select All Switch */
  showSelectAll: PropTypes.bool,

  /** Select all switch label */
  selectAllLabel: PropTypes.string,

  /** Displayed label when All are selected */
  selectAllValue: PropTypes.string
};
SelectDropList.defaultProps = {
  value: undefined,
  onChange: function onChange() {},
  placeholder: 'Select...',
  required: false,
  valueKey: 'value',
  labelKey: 'label',
  tooltip: undefined,
  tooltipDelay: 0.5,
  options: [],
  size: 'large',
  showSelectAll: true,
  selectAllLabel: 'Select all',
  selectAllValue: 'All'
};
SelectDropList.displayName = 'SelectDropList';
var Wrapper$P = compose$1(withTheme, withTransformers)(SelectDropList);

var AsyncAutocomplete = function AsyncAutocomplete(props) {
  var _useState = useState([]),
      _useState2 = _slicedToArray$8(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  var id = props.id,
      name = props.name,
      value = props.value,
      cacheOptions = props.cacheOptions,
      minCharsToSearch = props.minCharsToSearch,
      disabled = props.disabled,
      fetchOnce = props.fetchOnce,
      endpoint = props.endpoint,
      reqHeaders = props.reqHeaders,
      responseDataPath = props.responseDataPath,
      fetchDefault = props.fetchDefault;
      props.validationState;
      var onRequestError = props.onRequestError,
      searchKey = props.searchKey,
      rest = _objectWithoutProperties$c(props, ["id", "name", "value", "cacheOptions", "minCharsToSearch", "disabled", "fetchOnce", "endpoint", "reqHeaders", "responseDataPath", "fetchDefault", "validationState", "onRequestError", "searchKey"]);

  var resolvePath = function resolvePath(path, obj) {
    if (!path) return obj;
    return path.split('.').reduce(function (prev, curr) {
      return prev ? prev[curr] : null;
    }, obj || window.self);
  };

  var filter = function filter(opts, query) {
    if (!query) {
      return opts;
    }

    var filtered = [];
    filtered = opts.filter(function (option) {
      var isMatch = option[rest.labelKey].toLowerCase().includes(query.toLowerCase()) || (searchKey ? option[searchKey].toLowerCase().includes(query.toLowerCase()) : false);
      return isMatch;
    });
    return filtered;
  };

  var promiseOptions = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
      var resp, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(disabled || !fetchDefault && minCharsToSearch && q.length < minCharsToSearch)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!(fetchOnce && fetchDefault && options.length)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", filter(options, q));

            case 4:
              _context.next = 6;
              return Axios({
                method: 'GET',
                url: "".concat(endpoint).concat(q),
                headers: reqHeaders
              });

            case 6:
              resp = _context.sent;

              if (!(resp.status === 200)) {
                _context.next = 11;
                break;
              }

              data = resolvePath(responseDataPath, resp.data);
              setOptions(filter(data, q));
              return _context.abrupt("return", data || []);

            case 11:
              onRequestError(resp);
              return _context.abrupt("return", []);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function promiseOptions(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * An ID to be used for accessibility
   */


  var componentId = id || name || RandomID(6);
  return /*#__PURE__*/React__default.createElement(Wrapper$S, _extends$g({}, rest, {
    id: id,
    name: name,
    async: true,
    cacheOptions: cacheOptions,
    loadOptions: promiseOptions,
    value: value,
    "aria-labelledby": componentId,
    options: options,
    defaultOptions: fetchDefault,
    disabled: disabled
  }));
};

AsyncAutocomplete.propTypes = {
  /** AsyncAutocomplete label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Endpoint that the autocomplete will call to fetch data from */
  endpoint: PropTypes.string.isRequired,

  /** optional headers to pass along the request. Useful if the request required authentication */
  reqHeaders: PropTypes.object,

  /** guides the component where to look for the array of data if the response has other object delivered along */
  responseDataPath: PropTypes.string,

  /** return the response from the endpoint if request fails for any reason */
  onRequestError: PropTypes.func,

  /** Will fire a request to the endpoint upon render to fetch the default list of options before user starts typing */
  fetchDefault: PropTypes.bool,

  /** fires when the the value of the field changes. If creatable, it returns the value entered by the user  */
  onChange: PropTypes.func,

  /** Allows users to create options */
  creatable: PropTypes.bool,

  /** Useful if objects in the returned results from the API are not {value, label} */
  valueKey: PropTypes.string,

  /** Useful if objects in the returned results from the API are not {value, label} */
  labelKey: PropTypes.string,

  /** Adds a button to allow user to clear the value. It will fire null or an empty array to the onChange */
  isClearable: PropTypes.bool,

  /** Min characters allowed to perform a request */
  minCharsToSearch: PropTypes.number,

  /** If set to true, the component will only request data from endpoint only once. Usually used with fetch default to fetch all data at once  */
  fetchOnce: PropTypes.bool,

  /** Defines object field to filter the returned options from the API */
  searchKey: PropTypes.string,

  /** caches the lst fetched results to avoid requesting data if it finds it */
  cacheOptions: PropTypes.bool,

  /** Droplist indicator component */
  dropdownIndicator: PropTypes.node,

  /** Search hint message */
  searchHintMessage: PropTypes.string,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
AsyncAutocomplete.defaultProps = {
  valueKey: 'value',
  labelKey: 'label',
  fetchDefault: false,
  minCharsToSeach: 0,
  fetchOnce: false,
  searchKey: '',
  cacheOptions: true,
  searchHintMessage: 'Type to search'
};
AsyncAutocomplete.displayName = 'AsyncComponent';
var Wrapper$O = compose$1(withTheme, withTransformers)(AsyncAutocomplete);

var AVATAR_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge'
};
var SHAPES = {
  ROUNDED: 'rounded',
  SQUARE: 'square',
  CIRCLE: 'circle'
};
var VARIANTS = {
  DEFAULT: 'default',
  INFO: 'info',
  DANGER: 'danger',
  NEUTRAL: 'neutral',
  SUCCESS: 'success',
  WARNING: 'warning'
};

var _templateObject$z, _templateObject2$t, _templateObject3$n, _templateObject4$h, _templateObject5$d;
var getSize$1 = function getSize(size) {
  var sizeValue = null;

  switch (size) {
    case AVATAR_SIZES.XLARGE:
      sizeValue = 56;
      break;

    case AVATAR_SIZES.LARGE:
      sizeValue = 40;
      break;

    case AVATAR_SIZES.MEDIUM:
      sizeValue = 32;
      break;

    case AVATAR_SIZES.SMALL:
      sizeValue = 24;
      break;

    default:
      sizeValue = size;
      break;
  }

  return sizeValue;
};

var getSizeFromProps = function getSizeFromProps(props) {
  return getSize$1(props.size);
};

var getFontSize$2 = function getFontSize(props) {
  var sizeValue = props.size / 2;

  switch (props.size) {
    case AVATAR_SIZES.XLARGE:
      sizeValue = 24;
      break;

    case AVATAR_SIZES.LARGE:
      sizeValue = 18;
      break;

    case AVATAR_SIZES.MEDIUM:
      sizeValue = 16;
      break;

    case AVATAR_SIZES.SMALL:
      sizeValue = 12;
      break;
  }

  return sizeValue;
};

var getRadius = function getRadius(props) {
  var radius = 0;

  switch (props.shape) {
    case SHAPES.ROUNDED:
      radius = '5px';
      break;

    case SHAPES.CIRCLE:
      radius = '50%';
      break;
  }

  return radius;
};

var getBackground = function getBackground(_ref) {
  var bgColor = _ref.bgColor,
      variation = _ref.variation,
      theme = _ref.theme;
  if (bgColor) return bgColor;

  switch (variation) {
    case VARIANTS.INFO:
      return theme.avatarInfoBg;

    case VARIANTS.DANGER:
      return theme.avatarDangerBg;

    case VARIANTS.NEUTRAL:
      return theme.avatarNeutralBg;

    case VARIANTS.SUCCESS:
      return theme.avatarSuccessBg;

    case VARIANTS.WARNING:
      return theme.avatarWarningBg;

    default:
      return theme.avatarDefaultBg;
  }
};

var getColor$4 = function getColor(_ref2) {
  var fontColor = _ref2.fontColor,
      variation = _ref2.variation,
      theme = _ref2.theme;
  if (fontColor) return fontColor;

  switch (variation) {
    case VARIANTS.INFO:
      return theme.avatarInfoColor;

    case VARIANTS.DANGER:
      return theme.avatarDangerColor;

    case VARIANTS.NEUTRAL:
      return theme.avatarNeutralColor;

    case VARIANTS.SUCCESS:
      return theme.avatarSuccessColor;

    case VARIANTS.WARNING:
      return theme.avatarWarningColor;

    default:
      return theme.avatarDefaultColor;
  }
};

var AvatarWrapper = styled.div(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral$1(["\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\twidth: ", "px;\n\theight: ", "px;\n\toverflow: hidden;\n\tborder-radius: ", ";\n\tborder: 1px solid #eee;\n\tposition: relative;\n\ttransition: all 250ms ease-in-out;\n\tbox-shadow: 0 0 10px 1px #eee;\n\n\t&,\n\ta {\n\t\ttext-decoration: none !important;\n\t}\n"])), getBackground, getColor$4, getSizeFromProps, getSizeFromProps, getRadius);
var AvatarText = styled.div.attrs(function (props) {
  var size = getSizeFromProps(props);
  var shrinkFactor = 0.8;
  return {
    fontSize: "".concat(size * shrinkFactor, "px"),
    margin: "".concat(-(size * shrinkFactor) / 2 + 5, "px")
  };
})(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral$1(["\n\tcolor: inherit;\n\tdisplay: table;\n\twidth: 100%;\n\theight: 100%;\n\ttext-transform: uppercase;\n"])));
var AvatarIconWrapper = styled.div(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n"])));
var Initials = styled.span(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteral$1(["\n\tdisplay: table-cell;\n\tvertical-align: middle;\n\tfont-family: ", ";\n\tfont-size: ", "px;\n\tfont-weight: 600;\n\tcursor: default;\n\tpointer-events: none;\n\ttext-align: center;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.titlesFont;
}, getFontSize$2);
var ImgLoaderWrapper = styled.div(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\tmargin-top: -", "px;\n\tmargin-left: -", "px;\n"])), function (_ref4) {
  var size = _ref4.size;
  return size / 2;
}, function (_ref5) {
  var size = _ref5.size;
  return size / 2;
});
var Loader = function Loader(props) {
  var size = getFontSize$2(props);

  var Comp = function Comp() {
    return props.loader || /*#__PURE__*/React__default.createElement(Wrapper$U, {
      color: invert(props.bgColor || props.theme.primary),
      size: "".concat(size, "px")
    });
  };

  return /*#__PURE__*/React__default.createElement(ImgLoaderWrapper, {
    size: size
  }, /*#__PURE__*/React__default.createElement(Comp, null));
};

var Avatar = function Avatar(_ref) {
  var src = _ref.src,
      name = _ref.name,
      size = _ref.size,
      icon = _ref.icon,
      onClick = _ref.onClick,
      loadingComponent = _ref.loadingComponent,
      rest = _objectWithoutProperties$c(_ref, ["src", "name", "size", "icon", "onClick", "loadingComponent"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray$8(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$8(_useState3, 2),
      isLoaded = _useState4[0],
      setLoaded = _useState4[1];

  var getContent = function getContent() {
    if (icon) {
      return /*#__PURE__*/React__default.createElement(AvatarIconWrapper, null, icon);
    }

    var display = '';

    if (name.length <= 2) {
      display = name;
    } else {
      display += name.charAt(0);
      var parts = name.split(' ');

      if (parts.length > 1) {
        display += parts[parts.length - 1].charAt(0);
      }
    }

    return /*#__PURE__*/React__default.createElement(AvatarText, _extends$g({}, rest, {
      size: size
    }), /*#__PURE__*/React__default.createElement(Initials, _extends$g({}, rest, {
      size: size
    }), display));
  };

  var avatarStyle = {};

  if (!icon && src && !error) {
    avatarStyle.backgroundImage = "url(".concat(src, ")");
    avatarStyle.backgroundSize = "contain";
    avatarStyle.backgroundPosition = "center";
    avatarStyle.backgroundRepeat = "no-repeat";
  }

  return /*#__PURE__*/React__default.createElement(AvatarWrapper, _extends$g({}, rest, {
    size: size,
    onClick: onClick,
    as: rest.href ? 'a' : 'div',
    style: avatarStyle
  }), src && !isLoaded && !error ? /*#__PURE__*/React__default.createElement(Loader, _extends$g({}, rest, {
    size: size,
    loader: loadingComponent
  })) : undefined, src && !error ? /*#__PURE__*/React__default.createElement(Img$1, {
    src: src,
    onError: setError,
    onLoad: setLoaded,
    style: {
      display: 'none'
    }
  }) : getContent());
};

Avatar.propTypes = {
  /** Image url */
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  /** Alt text for the img */
  alt: PropTypes.string,

  /** Avatar size, can be 'xlarge', 'large', 'medium', 'small', or specific size  */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Profile name. The avatar will pick the initials out of this text */
  name: PropTypes.string,

  /** OnClick function of the avatar */
  onClick: PropTypes.func,

  /** OnClick function of the avatar */
  href: PropTypes.string,

  /** custom background color when Initials loaded */
  bgColor: PropTypes.string,

  /** custom font color when Initials loaded */
  fontColor: PropTypes.string,

  /** custom font color when Initials loaded */
  variation: PropTypes.oneOf(objectValues(VARIANTS)),

  /** set the shape of the Avatar */
  shape: PropTypes.oneOf(objectValues(SHAPES)),

  /** loading component that runs until the image is loaded */
  loadingComponent: PropTypes.node,

  /** icon component to render inside the avatar */
  icon: PropTypes.node
};
Avatar.defaultProps = {
  size: AVATAR_SIZES.MEDIUM,
  name: '',
  onClick: function onClick() {},
  variation: VARIANTS.DEFAULT,
  shape: SHAPES.ROUNDED
};
var Wrapper$N = withTheme(Avatar);

var _templateObject$y, _templateObject2$s, _templateObject3$m, _templateObject4$g;
/** **********************
 *  Style Helpers
 ********************** */

/** Get Button Background Color */

var getBackgroundColor$3 = function getBackgroundColor(props) {
  var bg = '';

  switch (props.variation) {
    case 'primary':
      bg = props.theme.buttonPrimaryBackground || props.theme.primary;
      break;

    case 'secondary':
      bg = props.theme.buttonSecondaryBackground || props.theme.secondary;
      break;

    case 'success':
      bg = props.theme.buttonSuccessBackground || props.theme.success;
      break;

    case 'warning':
      bg = props.theme.buttonWarningBackground || props.theme.warning;
      break;

    case 'danger':
      bg = props.theme.buttonDangerBackground || props.theme.error;
      break;

    case 'dark':
      bg = props.theme.buttonDarkBackground || props.theme.dark;
      break;

    case 'light':
      bg = props.theme.buttonLightBackground || props.theme.light;
      break;

    case 'link':
      bg = 'transparent';
      break;

    default:
      bg = props.theme.buttonDefaultBackground;
      break;
  }

  if (props.disabled && props.isInputButton) bg = props.theme.inputBackgroundDisabled;
  return bg;
};
/** Get Button text color */

var getColor$3 = function getColor(props) {
  var textColor;

  switch (props.variation) {
    case 'default':
    case 'light':
    case 'info':
      textColor = props.theme.buttonDefaultColor || props.theme.primary;
      break;

    case 'primary':
      textColor = props.theme.buttonPrimaryColor;
      break;

    case 'success':
      textColor = props.theme.buttonSuccessColor;
      break;

    case 'secondary':
      textColor = props.theme.buttonSecondaryColor;
      break;

    case 'warning':
      textColor = props.theme.buttonSecondaryColor;
      break;

    case 'danger':
      textColor = props.theme.buttonSecondaryColor;
      break;

    case 'dark':
      textColor = props.theme.buttonDarkColor;
      break;

    case 'link':
      textColor = props.theme.buttonLinkColor || props.theme.primary;
      break;

    default:
      textColor = props.theme.buttonDefaultColor || props.theme.primary;
      break;
  }

  return textColor;
};
/** Get button padding */

var getPadding$1 = function getPadding(_ref) {
  var size = _ref.size,
      theme = _ref.theme,
      iconOnly = _ref.iconOnly;
  var padding = '';
  var pX;

  switch (size) {
    case 'sm':
    case 'small':
      pX = theme.buttonPaddingSm;
      break;

    case 'lg':
    case 'large':
      pX = theme.buttonPaddingLg;
      break;

    case 'xl':
    case 'xlarge':
      pX = theme.buttonPaddingXl;
      break;

    default:
      pX = theme.buttonPadding;
  }

  if (iconOnly) {
    padding = '0';
  } else {
    padding = "0 ".concat(pX);
  }

  return padding;
};
/** Get Border Color */

var getBorderColor = function getBorderColor(props) {
  var borderColor = '';

  switch (props.variation) {
    case 'light':
    case 'link':
      borderColor = 'transparent';
      break;

    case 'default':
      borderColor = props.theme.buttonBorderColor || props.theme.primary;
      break;

    default:
      borderColor = getBackgroundColor$3(props);
      break;
  }

  if (props.isInputButton) borderColor = props.theme.inputBorderColor;
  return borderColor;
};
/** HOVER */

var getHoverBg = function getHoverBg(props) {
  var hoverColor = null;

  switch (props.variation) {
    case 'default':
      hoverColor = props.theme.buttonDefaultBackgroundHover;
      break;

    case 'link':
      hoverColor = 'transparent';
      break;

    case 'dark':
      hoverColor = '#23272b';
      break;

    default:
      hoverColor = tintColor(getBackgroundColor$3(props), -20);
      break;
  }

  return hoverColor;
};
var getHoverBorderColor = function getHoverBorderColor(props) {
  var hoverBorder;

  switch (props.variation) {
    case 'default':
      hoverBorder = tintColor(props.theme.buttonBorderColor || props.theme.primary, -20);
      break;

    default:
      hoverBorder = getHoverBg(props);
      break;
  }

  return hoverBorder;
};
/** Determine button height */

var getHeight = function getHeight(_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size;

  switch (size) {
    case 'sm':
    case 'small':
      return theme.buttonHeightSmall;

    case 'lg':
    case 'large':
      return theme.buttonHeightLarge;

    case 'xl':
    case 'xlarge':
      return theme.buttonHeightXLarge;

    default:
      return theme.buttonHeight;
  }
};
/** Determine button font size */

var getFontSize$1 = function getFontSize(_ref3) {
  var theme = _ref3.theme,
      size = _ref3.size;

  switch (size) {
    case 'sm':
    case 'small':
      return theme.buttonFontSm;

    case 'lg':
    case 'large':
      return theme.buttonFontLg;

    case 'xl':
    case 'xlarge':
      return theme.buttonFontXl;

    default:
      return theme.buttonFont;
  }
};
/** Determine spinner size based on Button size */

var getSpinnerSize = function getSpinnerSize(_ref4) {
  var size = _ref4.size;

  switch (size) {
    case 'sm':
    case 'small':
      return '16px';

    case 'lg':
    case 'large':
      return '24px';

    case 'xl':
    case 'xlarge':
      return '28px';

    default:
      return '24px';
  }
};
var StyledSpinner = styled.svg(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral$1(["\n\theight: ", ";\n\twidth: ", ";\n\tposition: absolute;\n\n\tleft: ", ";\n\tmargin-left: ", ";\n\n\ttop: 50%;\n\tmargin-top: calc(", " / -2);\n\n\tanimation: rotate 1s linear infinite;\n\tstroke: ", ";\n\t& .path {\n\t\tstroke: ", ";\n\t\tstroke-linecap: round;\n\t\tanimation: dash 2s ease-in-out infinite;\n\t}\n\n\t@keyframes rotate {\n\t\t100% {\n\t\t\ttransform: rotate(360deg);\n\t\t}\n\t}\n\t@keyframes dash {\n\t\t0% {\n\t\t\tstroke-dasharray: 1, 200;\n\t\t\tstroke-dashoffset: 0;\n\t\t}\n\t\t50% {\n\t\t\tstroke-dasharray: 89, 200;\n\t\t\tstroke-dashoffset: -35px;\n\t\t}\n\t\t100% {\n\t\t\tstroke-dasharray: 89, 200;\n\t\t\tstroke-dashoffset: -124px;\n\t\t}\n\t}\n"])), getSpinnerSize, getSpinnerSize, function (_ref5) {
  var iconOnly = _ref5.iconOnly;
  return iconOnly ? '50%' : '0px';
}, function (_ref6) {
  var iconOnly = _ref6.iconOnly,
      props = _objectWithoutProperties$c(_ref6, ["iconOnly"]);

  return iconOnly ? "calc(".concat(getSpinnerSize(props), " / -2)") : '0px';
}, getSpinnerSize, getColor$3, getColor$3); // exported for testing purposes

var Spinner = function Spinner(_ref7) {
  var variation = _ref7.variation,
      size = _ref7.size,
      theme = _ref7.theme,
      iconOnly = _ref7.iconOnly;
  return /*#__PURE__*/React__default.createElement(StyledSpinner, {
    viewBox: "25 25 50 50",
    theme: theme,
    variation: variation,
    size: size,
    iconOnly: iconOnly
  }, /*#__PURE__*/React__default.createElement("circle", {
    className: "path",
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }));
};
var transition$1 = 'all 200ms ease-in-out';
var ButtonContent = styled.div(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral$1(["\n\t", "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttransition: ", ";\n\tpadding-left: ", ";\n"])), function (_ref8) {
  var iconOnly = _ref8.iconOnly;
  return iconOnly ? css$4(["position:absolute;top:0;left:0;height:30px;width:30px;"]) : css$4(["position:relative;height:100%;"]);
}, transition$1, function (_ref9) {
  var isLoading = _ref9.isLoading,
      iconOnly = _ref9.iconOnly,
      props = _objectWithoutProperties$c(_ref9, ["isLoading", "iconOnly"]);

  return isLoading && "calc(".concat(getSpinnerSize(props), " + ").concat(iconOnly ? '0px' : '5px', ")");
});
var StyledButton = styled.button(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral$1(["\n    display: inline-block;\n    font-weight: 400;\n    font-family: ", ";\n    text-align: center;\n    vertical-align: middle;\n    user-select: none;\n    transition: ", ";\n    width: ", ";\n\theight: ", ";\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: ", ";\n\tcolor: ", ";\n    cursor: pointer;\n    margin-bottom: ", "px;\n    outline: none !important;\n    position: relative;\n    box-sizing: border-box;\n    padding: ", ";\n    font-size: ", ";\n    line-height: ", ";\n\ttext-decoration: none;\n\t\n\t> a {\n\t\t&, &:hover, &:visited, &:focus, &:active{\n\n\t\tcolor: inherit;\n\t\ttext-decoration: none;\n\t\toutline: none;\n\t\t}\n\t}\n\n\t", "\n\t\t\n    &:disabled{\n        opacity: 0.6;\n        cursor: default;\n    }\n\n\t&:focus{\n\t   box-shadow: ", ";\n   }\n    ", ";\n\n    ", "\n\t\t\n\t", "\n\t\t\t}\n\t\t\n\t\n    span{\n        vertical-align: middle;\n    }\n\n\t", "\n    ", "\n    ", "\n    ", "\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontFamily;
}, transition$1, function (_ref11) {
  var fullWidth = _ref11.fullWidth;
  return fullWidth ? '100%' : '';
}, getHeight, getBackgroundColor$3, getBorderColor, function (_ref12) {
  var theme = _ref12.theme,
      isCircle = _ref12.isCircle;
  return isCircle ? '50%' : theme.borderRadius;
}, getColor$3, function (_ref13) {
  var theme = _ref13.theme;
  return theme.space[2];
}, getPadding$1, getFontSize$1, function (props) {
  return "calc(".concat(getHeight(props), " - 2px)");
}, function (_ref14) {
  var disabled = _ref14.disabled;
  return !disabled && css$4(["&:hover,&:visited{background:", ";border-color:", ";color:", ";text-decoration:", ";box-shadow:", ";}"], getHoverBg, getHoverBorderColor, function (_ref15) {
    var variation = _ref15.variation,
        theme = _ref15.theme;
    return variation === 'default' ? tintColor(theme.buttonDefaultColor || theme.primary, -20) : getColor$3;
  }, function (props) {
    return props.variation === 'link' ? 'underline' : 'none';
  }, function (_ref16) {
    var theme = _ref16.theme,
        variation = _ref16.variation;
    return variation === 'link' ? 'none' : theme.buttonHoverShadow;
  });
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.focusOutline;
}, function (props) {
  return props.isSplit && css$4(["border-top-right-radius:0px;border-bottom-right-radius:0px;margin-right:0px;margin-bottom:0px;"]);
}, function (_ref18) {
  var iconOnly = _ref18.iconOnly,
      size = _ref18.size,
      theme = _ref18.theme;

  if (iconOnly) {
    var btnSize;

    switch (size) {
      case 'sm':
      case 'small':
        btnSize = theme.buttonHeightSmall;
        break;

      case 'lg':
      case 'large':
        btnSize = theme.buttonHeightLarge;
        break;

      case 'xl':
      case 'xlarge':
        btnSize = theme.buttonHeightXLarge;
        break;

      default:
        btnSize = theme.buttonHeight;
        break;
    }

    return css$4(["width:", ";height:", ";"], function () {
      return btnSize;
    }, function () {
      return btnSize;
    });
  }
}, function (_ref19) {
  var iconOnly = _ref19.iconOnly;
  return iconOnly && css$4(["& > div{top:50%;left:50%;transform:translate(-50%,-50%);}"]);
}, layout, space, typography, color$1);
var StyledButtonIcon = styled(Wrapper$Z)(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteral$1(["\n\tdisplay: ", ";\n\tsvg,\n\tsvg use {\n\t\t&,\n\t\t&:hover {\n\t\t\tfill: ", ";\n\t\t\tcolor: ", ";\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n"])), function (_ref20) {
  var isLoading = _ref20.isLoading;
  return isLoading ? 'none' : 'inline-block';
}, getColor$3, getColor$3);

var Button = function Button(props) {
  var children = props.children,
      fullWidth = props.fullWidth,
      className = props.className,
      variation = props.variation,
      disabled = props.disabled;
      props.bsStyle;
      var icon = props.icon,
      isLoading = props.isLoading,
      size = props.size,
      label = props.label,
      href = props.href,
      tooltip = props.tooltip,
      rest = _objectWithoutProperties$c(props, ["children", "fullWidth", "className", "variation", "disabled", "bsStyle", "icon", "isLoading", "size", "label", "href", "tooltip"]);

  var iconOnly = icon && !label && !children;
  var iconSize = '';

  switch (size) {
    case 'sm':
    case 'small':
      iconSize = 12;
      break;

    case 'lg':
    case 'large':
      iconSize = 20;
      break;

    case 'xl':
    case 'xlarge':
      iconSize = 26;
      break;

    default:
      iconSize = 20;
      break;
  }

  var Component = /*#__PURE__*/React__default.createElement(StyledButton, _extends$g({}, rest, {
    as: href ? 'a' : 'button',
    "aria-label": label,
    role: "button",
    href: href,
    className: className,
    variation: variation,
    size: size,
    fullWidth: fullWidth,
    disabled: disabled,
    isLoading: isLoading,
    icon: icon,
    iconOnly: iconOnly
  }), /*#__PURE__*/React__default.createElement(ButtonContent, {
    isLoading: isLoading,
    iconOnly: iconOnly
  }, isLoading ? /*#__PURE__*/React__default.createElement(Spinner, _extends$g({}, rest, {
    size: size,
    variation: variation,
    iconOnly: iconOnly
  })) : undefined, icon ? /*#__PURE__*/React__default.createElement(StyledButtonIcon, {
    theme: rest.theme,
    variation: variation,
    icon: icon,
    size: iconSize,
    isLoading: isLoading,
    mr: 1
  }) : undefined, label, children));
  return tooltip ? /*#__PURE__*/React__default.createElement(Wrapper$_, _extends$g({
    attachedTo: Component
  }, rest), tooltip) : Component;
};

Button.propTypes = {
  /** Button label */
  label: PropTypes.string,

  /** Fires when the the button clicked */
  onClick: PropTypes.func,

  /** Disabled the button */
  disabled: PropTypes.bool,

  /** Shows a loading circle inside the button */
  isLoading: PropTypes.bool,

  /** Add styles to make the button stretch to full width */
  fullWidth: PropTypes.bool,

  /** Defined the color of the button 'default', 'primary', 'secondary', 'success', 'warning', 'danger','info', 'link', 'light', 'dark' */
  variation: PropTypes.oneOf(['default', 'primary', 'secondary', 'success', 'warning', 'danger', 'info', 'link', 'light', 'dark']),

  /** `Deprecated`: Used to define the style of the button. Replaced with type. */
  bsStyle: PropTypes.oneOf(['default', 'primary', 'secondary', 'success', 'warning', 'danger', 'info', 'link', 'light', 'dark']),

  /** Defined the color of the button 'default', 'primary', 'secondary', 'success', 'warning', 'danger','info', 'link', 'light', 'dark' */
  size: PropTypes.oneOf(['sm', 'small', 'lg', 'normal', 'large', 'xl', 'xlarge']),

  /** Inserts an icon inside the button */
  icon: PropTypes.string,

  /** Turns the button into a circle */
  isCircle: PropTypes.bool,

  /** url to point to when this button is clicked  */
  href: PropTypes.string,

  /** Optional Tooltip for this button */
  tooltip: PropTypes.string
};
Button.defaultProps = {
  onClick: undefined,
  size: 'large',
  type: 'button',
  disabled: false,
  isLoading: false,
  fullWidth: false,
  variation: 'default'
};
var ButtonWrapper = compose$1(withTheme)(Button);

var _templateObject$x;
var StyledToolbar = styled.div(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral$1(["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-bottom: ", ";\n\n\t", " {\n\t\tmargin-right: ", ";\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.buttonsToolbarMarginBottom;
}, StyledButton, function (_ref2) {
  var theme = _ref2.theme;
  return theme.buttonsToolbarMarginRight;
});
var Wrapper$M = compose$1(withTheme)(StyledToolbar);

var _templateObject$w, _templateObject2$r, _templateObject3$l, _templateObject4$f, _templateObject5$c, _templateObject6$9;
var CardWrapper = styled.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral$1(["\n\tbackground-color: ", ";\n\tbackground-clip: border-box;\n\tborder: ", " solid ", ";\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-width: 0px;\n\tword-wrap: break-word;\n\tborder-radius: ", ";\n\tborder: ", " solid ", ";\n\tposition: relative;\n\tbox-shadow: ", ";\n\tfont-family: ", ";\n\n\t&,\n\t* {\n\t\tbox-sizing: border-box;\n\t}\n\tmargin-bottom: ", ";\n\n\t", "\n\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.cardBackground;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.cardBorderWidth;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.cardBorderColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.cardBorderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.cardBorderWidth;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.cardBorderColor;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.cardShadow;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontFamily;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.cardMarginBottom;
}, function (_ref10) {
  var stacked = _ref10.stacked;
  return stacked ? css$4(["border-radius:0px;&:first-child{border-top-left-radius:", ";border-top-right-radius:", ";}&:last-child{background:yellow;border-bottom-left-radius:", ";border-bottom-right-radius:", ";}&:not(:last-child){border-bottom-width:0px !important;}"], function (_ref11) {
    var theme = _ref11.theme;
    return theme.cardBorderRadius;
  }, function (_ref12) {
    var theme = _ref12.theme;
    return theme.cardBorderRadius;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.cardBorderRadius;
  }, function (_ref14) {
    var theme = _ref14.theme;
    return theme.cardBorderRadius;
  }) : undefined;
}, space, layout, typography, color$1);
var CardHeader = styled.div(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral$1(["\n\theight: ", ";\n\tbackground: ", ";\n\tcolor: ", ";\n\tpadding: ", ";\n\tborder-bottom: ", " solid ", ";\n\tborder-top-left-radius: ", ";\n\tborder-top-right-radius: ", ";\n\tfont-family: ", ";\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.cardHeaderHeight;
}, function (_ref16) {
  var headerBg = _ref16.headerBg,
      theme = _ref16.theme;
  return headerBg || theme.cardHeaderBackground;
}, function (_ref17) {
  var headerColor = _ref17.headerColor,
      theme = _ref17.theme;
  return headerColor || theme.cardHeaderColor;
}, function (_ref18) {
  var theme = _ref18.theme;
  return "".concat(theme.cardHeaderPaddingY, "px ").concat(theme.cardHeaderPaddingX, "px");
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.cardBorderWidth;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.cardBorderColor;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.borderRadius;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.borderRadius;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.fontFamily;
});
var CardHeaderLabel = styled.label(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral$1(["\n\tdisplay: inline-block;\n\tfont-size: ", ";\n\tfont-family: ", ";\n\tfont-weight: ", ";\n"])), function (_ref24) {
  var theme = _ref24.theme;
  return theme.cardHeaderFontSize;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.fontFamily;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.cardHeaderFontWWeight;
});
var CardHeaderChildren = styled.div(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteral$1(["\n\tdisplay: inline-block;\n"])));
var CardBlock = styled.div(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteral$1(["\n\tflex: 1 1 auto;\n\tcolor: ", ";\n\tpadding: ", "px ", "px;\n"])), function (_ref27) {
  var theme = _ref27.theme;
  return theme.cardBodyColor;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.cardPaddingY;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.cardPaddingX;
});
var ExpandTrigger = styled.button(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteral$1(["\n\tborder: none;\n\tdisplay: flex;\n\talign-items: center;\n\tuser-select: none;\n\twhite-space: nowrap;\n\tcolor: ", ";\n\tcursor: pointer;\n\toutline: none;\n\tbackground: transparent;\n\tborder-radius: ", ";\n\n\t&:focus {\n\t\tbox-shadow: ", ";\n\t}\n"])), function (_ref30) {
  var theme = _ref30.theme;
  return theme.primary;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.borderRadius;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.focusOutline;
});

var Card = function Card(_ref) {
  _ref.className;
      var children = _ref.children,
      title = _ref.title,
      headerChildren = _ref.headerChildren,
      collapsable = _ref.collapsable,
      isOpen = _ref.isOpen,
      rowsToShow = _ref.rowsToShow,
      expandTrigger = _ref.expandTrigger,
      style = _ref.style,
      contentStyle = _ref.contentStyle,
      rest = _objectWithoutProperties$c(_ref, ["className", "children", "title", "headerChildren", "collapsable", "isOpen", "rowsToShow", "expandTrigger", "style", "contentStyle"]);

  var _useState = useState(isOpen),
      _useState2 = _slicedToArray$8(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  useEffect(function () {
    setOpen(isOpen);
  }, [isOpen]);

  var toggle = function toggle() {
    return setOpen(!open);
  };

  var getCollapsingChildren = function getCollapsingChildren() {
    var rowsToShowArr = React__default.Children.toArray(children).slice(0, rowsToShow);
    var restArr = React__default.Children.toArray(children).slice(rowsToShow);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Wrapper$12, {
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Wrapper$11, {
      flex: '1 auto',
      onClick: function onClick() {
        if (!open) setOpen(true);
      }
    }, rowsToShowArr), /*#__PURE__*/React__default.createElement(ExpandTrigger, _extends$g({}, rest, {
      onClick: toggle,
      "aria-label": "click to expand",
      tabIndex: 0,
      "aria-pressed": "false",
      type: "button"
    }), expandTrigger ? /*#__PURE__*/React__default.createElement("span", {
      style: {
        paddingRight: 5
      }
    }, expandTrigger) : undefined, /*#__PURE__*/React__default.createElement(FlexArrow, _extends$g({}, rest, {
      direction: open ? 'up' : 'down'
    })))), /*#__PURE__*/React__default.createElement(AnimateHeight, {
      duration: 300,
      height: !open ? 0 : 'auto'
    }, restArr.map(function (row, i) {
      return row;
    })));
  };

  return /*#__PURE__*/React__default.createElement(CardWrapper, _extends$g({}, rest, {
    style: style
  }), title ? /*#__PURE__*/React__default.createElement(CardHeader, rest, /*#__PURE__*/React__default.createElement(CardHeaderLabel, rest, title), /*#__PURE__*/React__default.createElement(CardHeaderChildren, rest, headerChildren)) : undefined, /*#__PURE__*/React__default.createElement(CardBlock, _extends$g({}, rest, {
    style: contentStyle
  }), collapsable ? getCollapsingChildren() : children));
};

Card.propTypes = {
  /** Optional title for the card */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Additional ClassName */
  className: PropTypes.string,

  /** Any react component to render inside the header */
  headerChildren: PropTypes.node,

  /** Set to true to make the card collapsable */
  collapsable: PropTypes.bool,

  /** Only used with collapsable and if set to true the card with render open */
  isOpen: PropTypes.bool,

  /**  Number of rows to show when collapsed */
  rowsToShow: PropTypes.number,

  /** Optional text/component to as the trigger to expand the card */
  expandTrigger: PropTypes.node,

  /** Additional style object for the outer wrapper */
  style: PropTypes.object,

  /** Custom style  object passed to the child body component of the card */
  contentStyle: PropTypes.object
};
Card.defaultProps = {
  collapsable: false,
  isOpen: false,
  rowsToShow: 1
};
var Wrapper$L = withTheme(Card);

var _templateObject$v, _templateObject2$q, _templateObject3$k, _templateObject4$e;
var getBackgroundColor$2 = function getBackgroundColor(_ref) {
  var background = _ref.background,
      type = _ref.type,
      variation = _ref.variation,
      theme = _ref.theme;
  if (background) return background;
  var mode = type || variation;

  switch (mode) {
    case TYPES.PRIMARY:
      return theme.chipPrimaryBg || theme.primary;

    case TYPES.SUCCESS:
      return theme.chipSuccessBg || theme.success;

    case TYPES.WARNING:
      return theme.chipWarningBg || theme.warning;

    case TYPES.DANGER:
      return theme.chipDangerBg || theme.danger;

    case TYPES.LIGHT:
      return theme.chipLightBg || theme.light;

    default:
      return theme.chipDefaultBg || theme.primary;
  }
};
var getColor$2 = function getColor(_ref2) {
  var theme = _ref2.theme,
      type = _ref2.type,
      variation = _ref2.variation,
      color = _ref2.color;
  if (color) return color;
  var mode = type || variation;

  switch (mode) {
    case TYPES.PRIMARY:
      return theme.chipPrimaryColor;

    case TYPES.SUCCESS:
      return theme.chipSuccessColor;

    case TYPES.WARNING:
      return theme.chipWarningColor;

    case TYPES.DANGER:
      return theme.chipDangerColor;

    case TYPES.LIGHT:
      return theme.chipLightColor;

    default:
      return theme.chipDefauRltColor;
  }
};
var StyledChip = styled.div(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral$1(["\n    position: relative;\n    display: inline;\n    font-size: ", ";\n    font-family: ", ";\n    box-sizing: border-box;\n    background: ", ";\n    color: ", ";\n    padding: 1px ", " 2px 2px;\n    border-radius: 25px;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.chipFontSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily;
}, getBackgroundColor$2, getColor$2, function (_ref5) {
  var hasDelete = _ref5.hasDelete;
  return hasDelete ? "20px" : "8px";
});
var StyledChipLabel = styled.span(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral$1(["\n    cursor: default;\n    padding-left: ", "px;\n    white-space: nowrap;\n"])), function (_ref6) {
  var tag = _ref6.tag;
  return tag ? 4 : 4;
});
var ChipIcon = styled(Wrapper$Z).attrs(function (props) {
  return {
    color: getColor$2(props)
  };
})(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral$1(["\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: 4px;\n    margin-top: -1px;\n"])));
var ChipTag = styled.span(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteral$1(["\n    display: inline-block;\n    height: 16px;\n    line-height: 16px;\n    min-width: 16px;\n    border-radius: 20px;\n    background: ", ";\n    color: #fff;\n    text-align: center;\n    font-size: 12px;\n    padding: 0 2px;\n"])), function (props) {
  return tintColor(getBackgroundColor$2(props), -50);
});

var TYPES = {
  DEFAULT: "default",
  PRIMARY: "primary",
  SUCCESS: "success",
  WARNING: "warning",
  DANGER: "danger",
  LIGHT: "light"
};
var iconStyles = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  right: 4
};

var Chip = function Chip(_ref) {
  var label = _ref.label,
      onDelete = _ref.onDelete,
      children = _ref.children,
      icon = _ref.icon,
      tag = _ref.tag,
      rest = _objectWithoutProperties$c(_ref, ["label", "onDelete", "children", "icon", "tag"]);

  return /*#__PURE__*/React__default.createElement(Wrapper$11, rest, /*#__PURE__*/React__default.createElement(StyledChip, _extends$g({}, rest, {
    hasDelete: onDelete !== null
  }), icon ? /*#__PURE__*/React__default.createElement(ChipIcon, _extends$g({}, rest, {
    icon: icon,
    size: 14
  })) : undefined, tag ? /*#__PURE__*/React__default.createElement(ChipTag, rest, tag) : undefined, /*#__PURE__*/React__default.createElement(StyledChipLabel, _extends$g({}, rest, {
    tag: tag
  }), label, children), onDelete ? /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    type: rest.type,
    icon: "close",
    size: 15,
    onClick: onDelete,
    style: iconStyles,
    cursor: "pointer"
  }) : undefined));
};

Chip.propTypes = {
  /** Text to show */
  label: PropTypes.string,

  /** Value of chip to be returned if user click the chip */
  value: PropTypes.any,

  /** Function to fired when user click on the x */
  onDelete: PropTypes.func,

  /** Custom background color */
  background: PropTypes.string,

  /** Custom text color */
  color: PropTypes.string,

  /** Defined the color of the chip 'default', 'primary', 'secondary', 'success', 'warning', 'danger','light' */
  variation: PropTypes.oneOf(objectValues(TYPES)),

  /** alias for VARIATIONS */
  type: PropTypes.oneOf(objectValues(TYPES)),

  /** Icon to display inside the chip */
  icon: PropTypes.string,

  /** Highlighted label inside the chip (e.g numerical value of the chip) */
  tag: PropTypes.node
};
Chip.defaultProps = {
  onDelete: null,
  variation: "default"
};
var Wrapper$K = withTheme(Chip);

var _templateObject$u, _templateObject2$p, _templateObject3$j, _templateObject4$d;
var fadeInAnimation = keyframes$2(["from{opacity:0}to{opacity:1}"]);
var CollapsingPanel$1 = styled.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral$1(["\n\tposition: relative;\n\tmargin-bottom: 20px;\n\tfont-size: 14px;\n\tline-height: 1.5;\n\tfont-weight: normal;\n\tfont-family: ", ";\n\topacity: ", ";\n\tpadding: ", "px;\n\tbox-shadow: ", ";\n\tborder-radius: ", ";\n\t", ";\n\t", ";\n\t", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 0.5 : 1;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space[4];
}, function (_ref4) {
  var theme = _ref4.theme,
      isStyled = _ref4.isStyled;
  return isStyled ? theme.cardShadow : '';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius;
}, space, border, layout);
var CollapsingPanelTitle = styled.div(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral$1(["\n\tcursor: ", ";\n\tbackground-color: ", ";\n\tborder: ", " solid ", ";\n\tpadding: ", ";\n\tdisplay: flex;\n\tflex-direction: ", ";\n\talign-items: center;\n\tcolor: ", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), function (_ref6) {
  var disabled = _ref6.disabled,
      allowCollapse = _ref6.allowCollapse;
  return disabled || !allowCollapse ? 'default' : 'pointer';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.collapseHeaderBackground;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.collapseHeaderBorderWidth;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.collapseHeaderBorderColor;
}, function (_ref10) {
  var isStyled = _ref10.isStyled;
  return isStyled ? '0px' : '10px 0px';
}, function (_ref11) {
  var isStyled = _ref11.isStyled;
  return isStyled ? 'row-reverse' : 'row';
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.collapseHeaderColor;
}, space, layout, border, typography, color$1);
var CollapsingTitleText = styled.span(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral$1(["\n\tfont-weight: 500;\n\tfont-size: ", "px;\n\tline-height: 1.25;\n\tflex-grow: 1;\n\tcolor: ", ";\n\tpadding-left: ", "px;\n\tdisplay: inline-block;\n"])), function (_ref13) {
  var size = _ref13.size;
  return size === 'small' ? 18 : 24;
}, function (props) {
  return props.disabled ? props.theme.collapseHeaderColorDisabled : props.theme.collapseHeaderColor;
}, function (_ref14) {
  var isStyled = _ref14.isStyled;
  return isStyled ? 10 : 0;
});
var CollapsingChildren = styled.div(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteral$1(["\n\topacity: 0;\n\tpadding-top: ", "px;\n\tposition: relative;\n\t", ";\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.space[4];
}, function (props) {
  return !props.collapsed && css$4(["animation:", " 0.3s ease-in forwards;"], fadeInAnimation);
});

var CollapsingPanel = function CollapsingPanel(props) {
  var _useState = useState(props.isOpen || props.initialStateOpen),
      _useState2 = _slicedToArray$8(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  useEffect(function () {
    if (props.isOpen !== undefined) {
      setOpen(props.isOpen);
    }
  }, [props.isOpen]);

  var toggleCollapsingState = function toggleCollapsingState() {
    isOpen ? props.onClose() : props.onOpen(); // announuce a request to open/close

    if (!props.disabled && props.allowCollapse && props.isOpen === undefined) {
      setOpen(!isOpen);
    }
  };

  var title = props.title,
      children = props.children,
      disabled = props.disabled;
      props.onOpen;
      props.onClose;
      props.onClick;
      var collapsableStyles = props.collapsableStyles,
      contentStyles = props.contentStyles,
      rest = _objectWithoutProperties$c(props, ["title", "children", "disabled", "onOpen", "onClose", "onClick", "collapsableStyles", "contentStyles"]);

  return /*#__PURE__*/React__default.createElement(CollapsingPanel$1, _extends$g({}, rest, {
    disabled: disabled
  }), /*#__PURE__*/React__default.createElement(CollapsingPanelTitle, _extends$g({}, rest, collapsableStyles, {
    onClick: toggleCollapsingState,
    disabled: disabled
  }), /*#__PURE__*/React__default.createElement(CollapsingTitleText, {
    isStyled: rest.isStyled,
    size: rest.size,
    disabled: disabled
  }, title), /*#__PURE__*/React__default.createElement(FlexArrow, {
    color: rest.theme.collapseHeaderColor,
    direction: isOpen ? 'up' : 'down',
    disabled: disabled
  })), /*#__PURE__*/React__default.createElement(AnimateHeight, {
    duration: 300,
    height: isOpen ? 'auto' : 0
  }, /*#__PURE__*/React__default.createElement(CollapsingChildren, _extends$g({}, contentStyles, {
    theme: rest.theme,
    open: isOpen
  }), children)));
};

CollapsingPanel.propTypes = {
  /** Controls the state of the panel. If not passed, the panel will respond to user clicks */
  collapsed: PropTypes.bool,

  /** Sets the initial state of the collapsing panel */
  initialStateOpen: PropTypes.bool,

  /** String or component to render as title */
  title: PropTypes.node,

  /** Collapsign panel content */
  children: PropTypes.node.isRequired,

  /** Function called when the collasing panel has opened */
  onOpen: PropTypes.func,

  /** Function called when the collasing panel has closed */
  onClose: PropTypes.func,
  disabled: PropTypes.bool,

  /** if true, the collapsing panel will be wrapped by a card effect */
  isStyled: PropTypes.bool,
  size: PropTypes.oneOf(['large', 'small']),

  /** special styles passed the collapsable part */
  collapsableStyles: PropTypes.any,

  /** special styles passed the inner content part */
  contentStyles: PropTypes.any,

  /** If false, it locks the panel from either opening or closing */
  allowCollapse: PropTypes.bool
};
CollapsingPanel.defaultProps = {
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  allowCollapse: true,
  isStyled: true,
  size: 'large'
};
var Wrapper$J = withTheme(CollapsingPanel);

/* eslint-disable import/prefer-default-export */
/**
 *
 * Form stack is a layout helper to space out form elements
 *
 */

var FormStack = function FormStack(_ref) {
  var children = _ref.children,
      horizontal = _ref.horizontal,
      spacing = _ref.spacing;
  return /*#__PURE__*/React__default.createElement(Wrapper$12, {
    flexDirection: horizontal ? 'row' : 'column'
  }, React__default.Children.map(children, function (child, i) {
    if (child) {
      var props = {};

      if (i + 1 < children.length) {
        props[horizontal ? 'mr' : 'mb'] = spacing;
      }

      return /*#__PURE__*/React__default.cloneElement(child, props);
    }
  }));
};
FormStack.propTypes = {
  /** List of UIKit form elements */
  children: PropTypes.arrayOf(PropTypes.node),

  /** Desired spacing between components. Value can a simple number (representing the spacing schema from the theme),
   * or a string e.g. "20px", or an array for responsive spacing
   */
  spacing: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

  /** Control the direction of fields layout */
  horizontal: PropTypes.bool
};
FormStack.defaultProps = {
  spacing: 3
};

var _templateObject$t, _templateObject2$o, _templateObject3$i, _templateObject4$c, _templateObject5$b, _templateObject6$8;
var DropMenuStyles = css$4(["background:", ";border:1px solid ", ";border-radius:", ";position:absolute;z-index:", ";box-shadow:0px 2px 8px rgba(0,0,0,0.2);overflow:hidden;margin-top:2px;", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.dropmenuBackground;
}, function (_ref2) {
  var error = _ref2.error,
      theme = _ref2.theme;
  return error ? theme.error : theme.inputBorderColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.zIndexDropdown;
}, layout, color$1, space);
var DropMenuPanel = styled.div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral$1(["\n\t", ";\n"])), DropMenuStyles);
var DropMenuScrollPanel = styled.div(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral$1(["\n\tmax-height: ", ";\n\toverflow: auto;\n"])), function (_ref5) {
  var maxHeight = _ref5.maxHeight,
      theme = _ref5.theme;
  return maxHeight || theme.dropmenuMaxHeight;
});
var DropMenuInput = styled(FormControl)(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral$1(["\n\tborder-top-right-radius: 0px;\n\tborder-bottom-right-radius: 0px;\n\tdisplay: inline-block;\n"])));
styled.div(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteral$1(["\n\tpadding: ", ";\n\tbackground: ", ";\n\tcolor: ", ";\n\tborder-top-left-radius: ", ";\n\tborder-top-right-radius: ", ";\n\tbox-shadow: 0 2px 4px #ccc;\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.menuItemPadding;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.dropmenuHeaderBg;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.dropmenuHeaderColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.borderRadius;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.borderRadius;
});
var StyledMenuItem$1 = styled.button(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteral$1(["\n\tborder: 0;\n\tpadding: ", ";\n\tbackground: ", ";\n\tcursor: ", ";\n\ttransition: background-color 0.15s linear;\n\twhite-space: nowrap;\n\ttext-align: left;\n\tline-height: 1.5em;\n\twidth: 100%;\n\tcolor: ", ";\n\ttransition: all 0.3s ease-in-out;\n\n\t&:hover,\n\t&:focus {\n\t\toutline: none;\n\t\tbackground: ", ";\n\t\tbox-shadow: none;\n\t}\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.menuItemPadding;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.menuItemBackground;
}, function (_ref13) {
  var disabled = _ref13.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref14) {
  var theme = _ref14.theme,
      disabled = _ref14.disabled;
  return disabled ? theme.menuItemColorDisabled : theme.menuItemColor;
}, function (_ref15) {
  var theme = _ref15.theme,
      disabled = _ref15.disabled;
  return disabled ? theme.dropmenuBackground : theme.menuItemBackgroundHover;
});
var CustomDropButton = styled.button(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteral$1(["\n\tborder: 0;\n\toutline: none;\n\tborder-radius: ", ";\n\n\t&,\n\t&:hover,\n\t&:active {\n\t\tbackground: transparent;\n\t}\n\n\t&:focus {\n\t\tbox-shadow: ", ";\n\t}\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.borderRadius;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.focusOutline;
});

var CustomDropList = function CustomDropList(props) {
  var verticalAlign = props.verticalAlign,
      direction = props.direction,
      menuComponent = props.menuComponent,
      trigger = props.trigger,
      treatAsMenu = props.treatAsMenu,
      children = props.children,
      rest = _objectWithoutProperties$c(props, ["verticalAlign", "direction", "menuComponent", "trigger", "treatAsMenu", "children"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray$8(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var toggle = function toggle() {
    return setOpen(!isOpen);
  };

  var hide = function hide() {
    setOpen(false);
  };

  var TriggerComponent = /*#__PURE__*/React__default.createElement(CustomDropButton, {
    style: {
      cursor: 'pointer'
    },
    role: "menu",
    "aria-haspopup": "true",
    "aria-expanded": isOpen ? 'true' : 'false',
    tabIndex: 0,
    onClick: toggle
  }, trigger);
  var Menu = menuComponent || /*#__PURE__*/React__default.createElement(DropMenuScrollPanel, {
    maxHeight: props.maxHeight,
    theme: props.theme
  }, React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      tabIndex: 0,
      onClick: function onClick() {
        if (treatAsMenu) hide();
        if (child.props.onClick) child.props.onClick();
      }
    });
  }));
  var placement = "".concat(verticalAlign === 'auto' ? 'bottom' : verticalAlign);

  switch (direction) {
    case 'left':
      placement += '-end';
      break;

    case 'right':
      placement += '-start';
      break;
  }

  return /*#__PURE__*/React__default.createElement(Wrapper$_, _extends$g({
    open: isOpen,
    useContext: true,
    isMenu: true,
    trigger: "click",
    interactive: true,
    placement: placement,
    unmountHTMLWhenHide: false,
    animations: "shift",
    mode: "light",
    arrow: false,
    distance: 7,
    attachedTo: TriggerComponent,
    onHide: hide
  }, rest), Menu);
};

CustomDropList.propTypes = {
  /** Any node component to will trigger the dropdown */
  trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,

  /** List of item to render in the drop menu */
  children: PropTypes.node.isRequired,

  /** Direction of the dropdown. Left, right, center */
  direction: PropTypes.oneOf(['left', 'right', 'center']),

  /** Vertical Direction of the dropdown. top, bottom, auto */
  verticalAlign: PropTypes.oneOf(['top', 'bottom', 'auto']),

  /** When true, it closes the dropdown upon clicking each child */
  treatAsMenu: PropTypes.bool,

  /** Passing a component as the drop menu */
  menuComponent: PropTypes.node,

  /** Dropmenu max height */
  maxHeight: PropTypes.string
};
CustomDropList.defaultProps = {
  trigger: 'Custom Trigger',
  direction: 'center',
  verticalAlign: 'bottom',
  treatAsMenu: true,
  children: [/*#__PURE__*/React__default.createElement("div", null, "Menu Item")]
};
var Wrapper$I = withTheme(CustomDropList);

var _templateObject$s, _templateObject2$n, _templateObject3$h, _templateObject4$b, _templateObject5$a, _templateObject6$7, _templateObject7$4;
var DatePickerWrapper = styled.span(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral$1(["\n\t/* Calendar Day*/\n\t.CalendarDay__button {\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t\tfont-size: ", ";\n\t\twidth: ", ";\n\t\theight: ", ";\n\t\tline-height: ", ";\n\t\ttext-align: center;\n\t\tbackground: transparent;\n\t\tborder: none;\n\t\tborder-radius: 100px;\n\t\toutline: none;\n\t\tpadding: 0;\n\t}\n\n\t.CalendarDay--blocked-out-of-range:not(.CalendarDay--selected-end) button,\n\t.CalendarDay--blocked-out-of-range:not(.CalendarDay--selected-span) button,\n\t.CalendarDay--blocked:not(.CalendarDay--selected-end) button,\n\t.CalendarDay--blocked:not(.CalendarDay--selected-span) button {\n\t\tbackground: transparent;\n\t}\n\n\t.CalendarDay--blocked-out-of-range:not(.CalendarDay--selected-start) button,\n\t.CalendarDay--blocked-out-of-range:not(.CalendarDay--selected-end) button,\n\t.CalendarDay--blocked:not(.CalendarDay--selected-start) button,\n\t.CalendarDay--blocked:not(.CalendarDay--selected-end) button {\n\t\tcolor: ", ";\n\t}\n\n\t.CalendarDay--selected button {\n\t\tbackground: ", ";\n\t\tcolor: #fff;\n\t}\n\t.CalendarDay--hovered button {\n\t\tbackground: ", ";\n\t\tcolor: #fff;\n\t}\n\n\t/* Calendar Month*/\n\n\t.CalendarMonth {\n\t\ttext-align: center;\n\t\tpadding: 0 13px;\n\t\tvertical-align: top;\n\n\t\t&:first-of-type {\n\t\t\tposition: absolute;\n\t\t\tz-index: -1;\n\t\t\topacity: 0;\n\t\t}\n\n\t\ttable {\n\t\t\tborder-collapse: collapse;\n\t\t\tborder-spacing: 0;\n\t\t\twidth: 260px;\n\t\t\tmargin-left: 10px;\n\t\t}\n\t}\n\n\t.CalendarMonth--horizontal {\n\t\tdisplay: inline-block;\n\t\tmin-height: 100%;\n\t}\n\n\t.CalendarMonth--vertical {\n\t\tdisplay: block;\n\t}\n\n\t.CalendarMonth__caption {\n\t\tcolor: ", ";\n\t\tmargin-top: ", "px;\n\t\tfont-size: 1.25em;\n\t\tfont-weight: 300;\n\t\tpadding: ", "px 0 ", "px;\n\t\ttext-align: center;\n\t\tmargin-bottom: 2px;\n\t\tcaption-side: top;\n\t}\n\n\t/* This order is important.*/\n\t.CalendarMonth__day {\n\t\tpadding: 0;\n\t\tbox-sizing: border-box;\n\t\tcolor: ", ";\n\t\tcursor: pointer;\n\t\twidth: 39px;\n\t\theight: 38px;\n\t\ttext-align: center;\n\t}\n\n\t.CalendarMonth__day--outside {\n\t\tborder: 0;\n\t\tcursor: default;\n\n\t\t&:active {\n\t\t\tbackground: yellow;\n\t\t}\n\t}\n\n\t.CalendarMonth__day--hovered:not(.CalendarMonth__day--blocked-out-of-range) .CalendarDay__button {\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t\tcolor: inherit;\n\t}\n\n\t.CalendarMonth__day--selected-span .CalendarDay__button {\n\t\tbackground: ", ";\n\t\twidth: 100%;\n\t\tborder-radius: 0px;\n\t}\n\t.CalendarDay__button {\n\t\tline-height: 23px;\n\t\twhite-space: nowrap;\n\t}\n\t.CalendarDay--hovered {\n\t\tborder: none !important;\n\t}\n\t.CalendarDay--hovered-span button:after,\n\t.CalendarDay--hovered-span button:before,\n\t.CalendarDay--selected-span button:after,\n\t.CalendarDay--selected-span button:before,\n\t.CalendarDay--selected-end button:after,\n\t.CalendarDay--selected-end button:before {\n\t\tmargin-left: 0px !important;\n\t}\n\t.DateRangePicker__picker--valid-date-hovered .CalendarMonth__day--selected-start,\n\t.DateRangePicker__picker--valid-date-hovered .CalendarMonth__day--selected-end,\n\t.CalendarMonth__day--selected-start,\n\t.CalendarMonth__day--selected-end,\n\t.CalendarMonth__day--selected {\n\t\t.CalendarDay {\n\t\t\tbackground: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n\t.SingleDatePickerInput__clear-date {\n\t\t/* background: transparent;\n\t\tposition: absolute;\n\t\tright: ", "px;\n\t\tmargin-top: 2px;\n\t\tborder: none;\n\t\toutline: none;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\n\t\t.DateRangePickerInput__close {\n\t\t\twidth: 10px;\n\t\t\tfill: ", ";\n\t\t} */\n\t}\n\t.CalendarDay--hovered {\n\t\tborder: none;\n\t}\n\t.CalendarDay--selected-start,\n\t.CalendarDay--selected-end,\n\t.CalendarDay--selected,\n\t.CalendarDay--hovered-span,\n\t.CalendarDay--after-hovered-start,\n\t.CalendarDay--selected-span {\n\t\tbackground: none;\n\t}\n\n\t.CalendarDay--selected-span.CalendarDay--after-hovered-start {\n\t\tcolor: white;\n\t}\n\t.DateRangePicker__picker--valid-date-hovered {\n\t\t.CalendarMonth__day--hovered-span .CalendarDay button {\n\t\t\tbackground: ", ";\n\t\t\tborder-radius: 0px;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tborder-top-right-radius: 100px;\n\t\t\t\tborder-bottom-right-radius: 100px;\n\t\t\t}\n\t\t}\n\t}\n\t.DateRangePickerInput__clear-dates {\n\t\tright: 5px;\n\t\tpadding: 10px 5px;\n\t}\n\t.DateRangePicker__picker--open-down {\n\t\ttop: 32px;\n\t}\n\t.CalendarDay--selected-start.CalendarDay--hovered-span button:before,\n\t.CalendarDay--selected-start.CalendarDay--hovered-span button:after {\n\t\tdisplay: none;\n\t}\n\t.CalendarDay--valid.CalendarDay--hovered:not(.CalendarDay--selected-start),\n\t.CalendarDay--valid.CalendarDay--hovered-span:not(.CalendarDay--selected-start),\n\t.CalendarDay--selected-span:not(.CalendarDay--selected-start),\n\t.CalendarDay--selected-end {\n\t\tbutton:before {\n\t\t\tleft: -24px;\n\t\t}\n\t\tbutton {\n\t\t\tbackground: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n\t.CalendarDay--selected-start button,\n\t.CalendarDay--selected-end button {\n\t\tbackground: ", " !important;\n\t\tcolor: ", " !important;\n\t}\n\n\t.CalendarMonth__day--selected-span + .CalendarMonth__day--selected-end {\n\t\t.CalendarDay__button:before {\n\t\t\tmargin-left: -12px;\n\t\t\t\n\t\t}\n\t}\n\t.CalendarMonth__day--blocked-out-of-range,\n\t.CalendarMonth__day--blocked {\n\t\tcolor: ", ";\n\t\tcursor: not-allowed;\n\t\t&:hover .CalendarDay {\n\t\t\tbackground: transparent;\n\t\t}\n\t}\n\n\t/* Month Grid */\n\t.CalendarMonthGrid {\n\t\tz-index: 0;\n\t}\n\n\t.CalendarMonthGrid--animating {\n\t\ttransition: transform 0.2s ease-in-out;\n\t\tz-index: 1;\n\t}\n\n\t.CalendarMonthGrid--horizontal {\n\t\tposition: absolute;\n\t}\n\n\t.CalendarMonthGrid--vertical {\n\t\twidth: ", ";\n\t\tmargin: 0 auto;\n\t}\n\n\t/* Date input */\n\n\t.DateInput {\n\t\tfont-weight: 300;\n\t\tcolor: ", ";\n\t\tbackground: ", ";\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tline-height: 100%;\n\t}\n\n\t.DateInput--disabled {\n\t\tbackground: ", ";\n\t}\n\n\t.DateInput_label {\n\t\tborder: 0;\n\t\tclip: rect(0, 0, 0, 0);\n\t\theight: 1px;\n\t\tmargin: -1px;\n\t\toverflow: hidden;\n\t\tpadding: 0;\n\t\tposition: absolute;\n\t\twidth: 1px;\n\t}\n\n\t.DateInput__input {\n\t\topacity: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tborder: 0;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t}\n\n\t.DateInput__input__focused {\n\t\tborder-bottom: none;\n\t}\n\n\t.DateInput__display-text {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\tcolor: ", ";\n\t\tfont-weight: 400;\n\t\tpadding-left: 8px;\n\t\tline-height: ", ";\n\t}\n\t.DateInput__display-text.DateInput__display-text--has-input {\n\t\tcolor: ", ";\n\t\tline-height: ", ";\n\t\tpadding-left: 8px;\n\t\tfont-family: inherit;\n\t\tfont-size: ", ";\n\t}\n\t.DateInput__display-text--focused {\n\t\tcolor: ", ";\n\t}\n\n\t/* Date Range Picker*/\n\n\t.screen-reader-only {\n\t\tborder: 0;\n\t\tclip: rect(0, 0, 0, 0);\n\t\theight: 1px;\n\t\tmargin: -1px;\n\t\toverflow: hidden;\n\t\tpadding: 0;\n\t\tposition: absolute;\n\t\twidth: 1px;\n\t}\n\n\t.DateRangePicker {\n\t\tposition: relative;\n\n\t\t.DateInput {\n\t\t\twidth: 45%;\n\t\t}\n\t}\n\n\t.DateRangePicker__picker {\n\t\tz-index: 4;\n\t\ttransition: all 300ms ease-in;\n\t\tposition: absolute;\n\t}\n\n\t.DateRangePicker__picker--direction-left {\n\t\tleft: 0;\n\t}\n\n\t.DateRangePicker__picker--direction-right {\n\t\tright: 0;\n\t}\n\n\t.DateRangePicker__picker--show {\n\t\topacity: 1;\n\t}\n\n\t.DateRangePicker__picker--invisible {\n\t\topacity: 0;\n\t\tdisplay: none;\n\t}\n\n\t.DateRangePicker__picker--portal {\n\t\tbackground-color: rgba(0, 0, 0, 0.3);\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t}\n\n\t/* Date range picker input*/\n\n\t.DateRangePickerInput {\n\t\tbackground-color: ", ";\n\t\tborder: 1px solid ", ";\n\t\tpadding: ", " ", ";\n\t\tline-height: 1.2em;\n\t\tborder-radius: ", ";\n\t}\n\t.DateRangePickerInput--disabled {\n\t\tbackground: ", ";\n\t}\n\n\t.DateRangePickerInput__arrow {\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t\twidth: 14px;\n\t}\n\n\t.DateRangePickerInput__arrow svg {\n\t\tvertical-align: middle;\n\t}\n\n\t.DateRangePickerInput__clear-dates {\n\t\tbackground: none;\n\t\tborder: 0;\n\t\tcolor: inherit;\n\t\tfont: inherit;\n\t\tline-height: normal;\n\t\toverflow: visible;\n\t\tcursor: pointer;\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t\toutline: none;\n\t\tposition: absolute;\n\t\tright: ", "px;\n\t\ttop: -2px;\n\t}\n\n\t.DateRangePickerInput__clear-dates svg {\n\t\tfill: ", ";\n\t\theight: 10px;\n\t\twidth: 10px;\n\t\tvertical-align: middle;\n\t}\n\n\t.DateRangePickerInput__clear-dates--hide {\n\t\tvisibility: hidden;\n\t}\n\n\t.DateRangePickerInput__clear-dates:focus,\n\t.DateRangePickerInput__clear-dates--hover {\n\t\tborder-radius: 50%;\n\t}\n\t.DateRangePickerInput__clear-dates:focus,\n\t.DateRangePickerInput__clear-dates--hover {\n\t\tborder-radius: 50%;\n\t}\n\n\t/* Day Picker */\n\n\t.DayPicker {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tz-index: 1;\n\t\tfont-family: ", ";\n\t\tfont-size: ", ";\n\t}\n\n\t.DayPicker--horizontal {\n\t\tbackground: ", ";\n\t\tbox-shadow: ", ";\n\t\tborder: $border-width solid ", ";\n\n\t\t.DayPickerNavigation button {\n\t\t\tborder: none;\n\t\t}\n\t}\n\n\t.DayPicker--vertical.DayPicker--portal {\n\t\tposition: initial;\n\t}\n\n\t.DayPickerNavigation__prev,\n\t.DayPickerNavigation__next {\n\t\toutline: none;\n\t\tcolor: ", ";\n\t\tcursor: pointer;\n\t\tuser-select: none;\n\n\t\t&:hover {\n\t\t\tborder-color: ", ";\n\t\t}\n\t\tsvg {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&:before {\n\t\t\tcontent: ' ';\n\t\t\tdisplay: inline-block;\n\t\t\tborder: 5px solid transparent;\n\t\t}\n\t}\n\n\t.DayPickerNavigation__prev:before {\n\t\tborder-right-color: inherit;\n\t\tborder-left-width: 0;\n\n\t\t&:hover {\n\t\t\tbackground: yellow;\n\t\t}\n\t}\n\t.DayPickerNavigation__next:before {\n\t\tborder-left-color: inherit;\n\t\tborder-right-width: 0;\n\t}\n\n\t.DayPickerNavigation--horizontal {\n\t\t.DayPickerNavigation__nav {\n\t\t\tposition: relative;\n\t\t}\n\n\t\t.DayPickerNavigation__prev,\n\t\t.DayPickerNavigation__next {\n\t\t\tborder-radius: 3px;\n\t\t\ttop: 18px;\n\t\t\tz-index: 2;\n\t\t\tposition: absolute;\n\t\t\tbackground: ", ";\n\t\t}\n\n\t\t.DayPickerNavigation__prev {\n\t\t\tpadding: 6px 4px 6px 36px;\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t.DayPickerNavigation__next {\n\t\t\tpadding: 6px 36px 6px 4px;\n\t\t\tright: 0px;\n\t\t}\n\n\t\tsvg {\n\t\t\theight: 19px;\n\t\t\twidth: 19px;\n\t\t\tfill: ", ";\n\t\t}\n\t}\n\t.DayPicker__week-headers {\n\t\tposition: relative;\n\t}\n\n\t.DayPicker__week-header {\n\t\tcolor: ", ";\n\t\tposition: absolute;\n\t\ttop: 62px;\n\t\tz-index: 2;\n\t\ttext-align: left;\n\n\t\tul {\n\t\t\tlist-style: none;\n\t\t\tmargin: 1px 0;\n\t\t\tpadding-left: 0;\n\t\t}\n\n\t\tli {\n\t\t\tdisplay: inline-block;\n\t\t\twidth: 39px;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\n\t.DayPicker--horizontal .DayPicker__week-header {\n\t\tpadding: 0 22px 0 13px;\n\n\t\t&:first-of-type {\n\t\t\tpadding: 0 13px 0 22px;\n\t\t}\n\t}\n\t.transition-container {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tborder-radius: 3px;\n\t}\n\n\t.transition-container--horizontal {\n\t\ttransition: height 0.2s ease-in-out;\n\t}\n\n\t.transition-container--vertical {\n\t\twidth: 100%;\n\t}\n\n\t/* Single Date Picker*/\n\n\t.SingleDatePicker {\n\t\tposition: relative;\n\t\tdisplay: block;\n\t\tmin-width: 180px;\n\n\t\t.DateInput {\n\t\t\twidth: 100%;\n\t\t\tline-height: 0.9em;\n\t\t\tfont-size: ", ";\n\t\t\tposition: absolute;\n\t\t\ttop: 0px;\n\t\t\tleft: 0px;\n\t\t\tbackground: none;\n\t\t}\n\t}\n\n\t.SingleDatePicker__picker {\n\t\tmargin-top: -1px;\n\t\tz-index: 4;\n\t\ttransition: all 200ms ease-out;\n\t\tposition: absolute;\n\t}\n\t.DateInput--open-down.DateInput--with-caret::before,\n\t.DateInput--open-down.DateInput--with-caret::after {\n\t\tdisplay: none;\n\t}\n\t.DateInput__display-text--focused {\n\t\tbackground: none;\n\t}\n\t.SingleDatePicker__picker--direction-left {\n\t\tleft: 0;\n\t}\n\t.SingleDatePicker__picker--open-down {\n\t\ttop: 33px;\n\t}\n\t.SingleDatePicker__picker--direction-right {\n\t\tright: 0;\n\t}\n\n\t.SingleDatePicker__picker--show {\n\t\topacity: 1;\n\t}\n\n\t.SingleDatePicker__picker--invisible {\n\t\topacity: 0;\n\t\tdisplay: none;\n\t}\n\n\t.SingleDatePickerInput__calendar-icon {\n\t\tdisplay: none;\n\t}\n\n\t.SingleDatePicker__picker--portal {\n\t\tbackground-color: ", ";\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t}\n\t.SingleDatePicker_close {\n\t\tbackground: none;\n\t\tborder: 0;\n\t\tcolor: inherit;\n\t\tfont: inherit;\n\t\tline-height: normal;\n\t\toverflow: visible;\n\t\tpadding: 0;\n\t\tcursor: pointer;\n\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tpadding: 15px;\n\t\tz-index: 2;\n\n\t\tsvg {\n\t\t\theight: 15px;\n\t\t\twidth: 15px;\n\t\t\tfill: ", ";\n\t\t}\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tcolor: ", ";\n\t\t\ttext-decoration: none;\n\t\t}\n\t}\n\t.SingleDatePickerInput_clearDate {\n\t\t/* width: 20px;\n\t\theight: 20px;\n\t\tposition: absolute;\n\t\tright: 20px;\n\t\tbackground: none;\n\t\tborder: none;\n\t\tcursor: pointer;\n\t\tfont-size: 1em;\n\t\toutline: none !important; */\n\t}\n\t.CalendarDay {\n\t\tborder-color: transparent;\n\t}\n\t.CalendarDay:hover {\n\t\tbackground-color: transparent;\n\t}\n\t.DayPicker__week-header li {\n\t\twidth: 37.5px !important;\n\t}\n\n\t/*  Single Date Picker Input */\n\t.SingleDatePickerInput {\n\t\tdisplay: none;\n\n\t\t/* border: 1px solid ", ";\n\t\tborder-radius: ", ";\n\t\tpadding: ", " ", ";\n\t\tline-height: 1em;\n\t\theight: ", ";\n\t\tbackground: ", ";\n\t\tbox-sizing: border-box; */\n\t}\n\n\t.DateRangePicker {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tmin-width: 180px;\n\n\t\t.DateRangePickerInput {\n\t\t\tdisplay: none;\n\t\t\tline-height: 1em;\n\t\t\tfont-size: ", ";\n\t\t\tpadding: 0px;\n\t\t\twidth: 100%;\n\t\t\tborder-radius: ", ";\n\t\t\theight: ", ";\n\t\t\tborder: 1px solid ", ";\n\t\t\tbox-sizing: border-box;\n\n\t\t\t.DateInput {\n\t\t\t\tfont-size: ", ";\n\t\t\t\tpadding: 0px;\n\t\t\t\tbackground-color: transparent;\n\t\t\t}\n\t\t}\n\n\t\t.DateRangePickerInput__arrow svg {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.DateRangePickerInput__arrow:after {\n\t\t\tcontent: ' ';\n\t\t\tdisplay: inline-block;\n\t\t\twidth: 0px;\n\t\t\theight: 0px;\n\t\t\tborder: 5px solid transparent;\n\t\t\tborder-left-color: ", ";\n\t\t\tborder-right-width: 0px;\n\t\t\tmargin: 0 ", "px;\n\t\t}\n\t\t.DateRangePickerInput__clear-dates:focus,\n\t\t.DateRangePickerInput__clear-dates--hover {\n\t\t\tbackground: none;\n\t\t}\n\t}\n\n\t.SingleDatePicker__picker--open-up,\n\t.DateRangePicker__picker--open-up {\n\t\tbottom: 0px;\n\t}\n"])), function (props) {
  return props.theme.calendarDayFontSize;
}, function (props) {
  return props.theme.calendarDaySelectionWidth;
}, function (props) {
  return props.theme.calendarDaySelectionHeight;
}, function (props) {
  return props.theme.calendarDaySelectionHeight;
}, function (props) {
  return props.theme.silver;
}, function (props) {
  return props.theme.primary;
}, function (props) {
  return props.theme.bluishGreen;
}, function (props) {
  return props.theme.calendarColor;
}, function (props) {
  return props.theme.gutter / 4;
}, function (props) {
  return props.theme.gutter / 4;
}, function (props) {
  return props.theme.gutter * 1.5;
}, function (props) {
  return props.theme.calendarColor;
}, function (props) {
  return props.theme.calendarDayHoverColor;
}, function (props) {
  return props.theme.white;
}, function (props) {
  return props.theme.calendarRangeBg;
}, function (props) {
  return props.theme.calendarRangeStartEndBg;
}, function (props) {
  return props.theme.white;
}, function (props) {
  return props.theme.gutter / 4;
}, function (props) {
  return props.theme.greyBlue;
}, function (props) {
  return props.theme.calendarRangeBg;
}, function (props) {
  return props.theme.calendarRangeBg;
}, function (props) {
  return props.theme.calendarColor;
}, function (props) {
  return props.theme.calendarRangeStartEndBg;
}, function (props) {
  return props.theme.calendarColor;
}, function (props) {
  return props.theme.silver;
}, function (props) {
  return props.theme.reactDatesWidthDayPicker;
}, function (props) {
  return props.theme.inputColor;
}, function (props) {
  return props.theme.inputBackground;
}, function (props) {
  return props.theme.inputBackgroundDisabled;
}, function (props) {
  return props.theme.inputPlaceholderColor;
}, function (props) {
  return props.theme.calendarInputHeight;
}, function (props) {
  return props.theme.inputColor;
}, function (props) {
  return props.theme.calendarInputHeight;
}, function (props) {
  return props.theme.inputFontSize;
}, function (props) {
  return props.theme.inputColor;
}, function (props) {
  return props.theme.inputBackground;
}, function (props) {
  return props.theme.inputBorderColor;
}, function (props) {
  return props.theme.inputPaddingY;
}, function (props) {
  return props.theme.inputPaddingX;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.inputBackgroundDisabled;
}, function (props) {
  return props.theme.gutter / 2;
}, function (props) {
  return props.theme.greyBlue;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize;
}, function (props) {
  return props.theme.calendarBg;
}, function (props) {
  return props.theme.calendarBoxShadow;
}, function (props) {
  return props.theme.inputBorderColor;
}, function (props) {
  return props.theme.calendarNavBtnColor;
}, function (props) {
  return props.theme.dusk;
}, function (props) {
  return props.theme.calendarBg;
}, function (props) {
  return props.theme.silver;
}, function (props) {
  return props.theme.calendarWeekColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSize;
}, function (props) {
  return props.theme.inputBackground;
}, function (props) {
  return props.theme.silver;
}, function (props) {
  return props.theme.dusk;
}, function (props) {
  return props.error ? props.theme.error : props.theme.inputBorderColor;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.inputPaddingY;
}, function (props) {
  return props.theme.inputPaddingX;
}, function (props) {
  return props.theme.calendarInputHeight;
}, function (props) {
  return props.theme.inputBackground;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.calendarInputHeight;
}, function (props) {
  return props.theme.inputBorderColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize;
}, function (props) {
  return props.theme.calendarNavBtnColor;
}, function (props) {
  return props.theme.gutter / 3;
});
var DateTimeComp = styled(DateTime)(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral$1(["\n\tfont-family: ", ";\n\tfont-size: ", ";\n\n\tinput {\n\t\t", "\n\t}\n\n\t&.rdt {\n\t\t.rdtPicker {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t&.rdt.rdtOpen .rdtPicker {\n\t\tdisplay: block;\n\t\t", ";\n\t\tpadding: 10px 15px;\n\n\t\t", "\n\n\t\t", "\n\n\t\t.rdtSwitch {\n\t\t\tpadding: 20px;\n\t\t\ttext-align: center;\n\t\t\tcursor: pointer;\n\t\t}\n\t\t.dow {\n\t\t\tcolor: ", ";\n\t\t\tfont-size: ", ";\n\t\t\tfont-weight: 300;\n\t\t\tpadding: 6px 12px;\n\t\t}\n\t\t.rdtDay,\n\t\t.rdtYear {\n\t\t\t> table {\n\t\t\t\tborder-spacing: 5px;\n\t\t\t}\n\t\t\tcursor: pointer;\n\n\t\t\tcolor: ", ";\n\t\t\ttext-align: center;\n\t\t\tbox-sizing: border-box;\n\n\t\t\t&.rdtNew {\n\t\t\t\tcolor: ", ";\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t&.rdtOld {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tcolor: ", ";\n\t\t\t}\n\t\t}\n\n\t\t.rdtDay {\n\t\t\twidth: 34px;\n\t\t\theight: 34px;\n\t\t\tuser-select: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\n\t\t\t&.rdtActive {\n\t\t\t\tbackground: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t\tborder-radius: 100%;\n\t\t\t}\n\t\t\t&.rdtBlocked {\n\t\t\t\tcolor: ", ";\n\t\t\t\tcursor: default;\n\t\t\t}\n\t\t}\n\n\t\t.rdtPrev,\n\t\t.rdtNext {\n\t\t\tcolor: ", ";\n\t\t\tfont-size: 18px;\n\t\t\tcursor: pointer;\n\t\t\ttext-align: center;\n\t\t}\n\t\t.rdtCounters {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tuser-select: none;\n\n\t\t\t.rdtCounter {\n\t\t\t\tpadding: 0px 8px;\n\t\t\t\ttext-align: center;\n\t\t\t\t.rdtCount {\n\t\t\t\t\tfont-size: 2em;\n\t\t\t\t\tfont-weight: 300;\n\t\t\t\t\tmin-width: 33px;\n\t\t\t\t}\n\t\t\t\t.rdtBtn {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tcolor: ", ";\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.rdtTimeToggle,\n\t\t.rdtTime .rdtSwitch {\n\t\t\tfont-size: 1.5em;\n\t\t\tcursor: pointer;\n\t\t\tfont-weight: 300;\n\t\t\t&:hover {\n\t\t\t\tcolor: ", ";\n\t\t\t}\n\t\t}\n\t\t.rdtTimeToggle {\n\t\t\ttext-align: center;\n\t\t\tpadding: 10px;\n\n\t\t\tborder-top: 1px solid silver;\n\t\t}\n\n\t\t.rdtTime,\n\t\t.rdtMonths,\n\t\t.rdtYears {\n\t\t\t> table {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t\t.rdtMonths,\n\t\t.rdtYears {\n\t\t\t.rdtMonth,\n\t\t\t.rdtYear {\n\t\t\t\tpadding: 10px 20px;\n\t\t\t\tcursor: pointer;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: ", ";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize;
}, FormControlStyled, DropMenuStyles, function (_ref8) {
  var openDirection = _ref8.openDirection,
      size = _ref8.size,
      theme = _ref8.theme;
  return openDirection === 'up' && css$4(["bottom:calc(", " + 2px);"], theme["inputHeight_".concat(size)]);
}, function (_ref9) {
  var popupDirection = _ref9.popupDirection;
  return popupDirection === 'right' && css$4(["right:0px;left:auto;"]);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.calendarWeekColor;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.calendarDayFontSize;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.calendarColor;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.greyBlue;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.calendarDayHoverColor;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.calendarDayActive || theme.primary;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.calendarColorActive;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.calendarDayInactive;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.calendarNavBtnColor;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.greyBlue;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.primary;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.greyBlue;
});
var DateTimeInputWrapper = styled.div(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral$1(["\n\tposition: relative;\n\tmin-width: 150px;\n"])));
styled(Wrapper$Z)(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tright: 10px;\n\tcursor: pointer;\n"])));
var CalendarIcon = styled(Wrapper$Z)(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tright: 8px;\n\tpointer-events: none;\n"])));
var DateTimeClearIcon = styled(Wrapper$Z)(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tright: 8px;\n"])));
var DateRangeInputWrapper = styled.div(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral$1(["\n\tposition: relative;\n\t", ";\n\tdisplay: flex;\n\talign-items: center;\n\tmin-width: 240px;\n\n\t> input {\n\t\tborder: none;\n\t\toutline: none;\n\t\tfont-family: inherit;\n\t\tfont-size: inherit;\n\t\tcolor: inherit;\n\t\tbackground: transparent;\n\t\tbox-sizing: border-box;\n\t\tflex-grow: 1;\n\t\tmin-width: 85px;\n\t\t&::placeholder {\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n"])), FormControlStyled, function (props) {
  return props.theme.inputPlaceholderColor;
});

var useFocus = function useFocus() {
  var initialFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var _useState = useState(initialFocus),
      _useState2 = _slicedToArray$8(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var setInitialFocus = function setInitialFocus(param) {
    setFocus(typeof param === 'boolean' ? param : undefined);
  };

  return [setInitialFocus, {
    autoFocus: focus,
    key: "".concat(id).concat(focus),
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur() {
      return setFocus(false);
    }
  }];
};

var TIME_FORMAT = 'hh:mm';
var TIME_FORMAT_24 = 'HH:mm';
var OPEN_DIRECTIONS = ['up', 'down'];
var POPUP_DIRECTIONS = ['left', 'right'];
var RETURN_FORMATS$1 = {
  MOMENT: 'moment',
  FORMATTED: 'formatted',
  TIMESTAMP: 'timestamp'
};

var DatePicker = function DatePicker(props) {
  var randomID = RandomID(6);

  props.label;
      var name = props.name,
      id = props.id,
      locale = props.locale;
      props.hint;
      var error = props.error,
      placeholder = props.placeholder,
      disabled = props.disabled;
      props.inactive;
      var format = props.format,
      value = props.value,
      returnFormat = props.returnFormat,
      withTime = props.withTime,
      is24h = props.is24h,
      allowPastDays = props.allowPastDays;
      props.tooltip;
      props.tooltipDelay;
      var validationState = props.validationState,
      onChange = props.onChange,
      blockDays = props.blockDays,
      isBlockSaturdays = props.isBlockSaturdays,
      isBlockSundays = props.isBlockSundays,
      showClearDate = props.showClearDate;
      props.onValueChange;
      props.dateSeparator;
      var initialFocused = props.initialFocused,
      openDirection = props.openDirection,
      popupDirection = props.popupDirection,
      focused = props.focused,
      minDate = props.minDate,
      maxDate = props.maxDate,
      size = props.size,
      rest = _objectWithoutProperties$c(props, ["label", "name", "id", "locale", "hint", "error", "placeholder", "disabled", "inactive", "format", "value", "returnFormat", "withTime", "is24h", "allowPastDays", "tooltip", "tooltipDelay", "validationState", "onChange", "blockDays", "isBlockSaturdays", "isBlockSundays", "showClearDate", "onValueChange", "dateSeparator", "initialFocused", "openDirection", "popupDirection", "focused", "minDate", "maxDate", "size"]);

  var _useState = useState(props.withTime),
      _useState2 = _slicedToArray$8(_useState, 2),
      showTime = _useState2[0],
      setShowTime = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$8(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var _useFocus = useFocus(initialFocused),
      _useFocus2 = _slicedToArray$8(_useFocus, 2),
      setFocus = _useFocus2[0],
      focusProps = _useFocus2[1];

  useEffect(function () {
    setFocus(focused);
  }, [focused, setFocus]);
  useEffect(function () {
    setShowTime(props.withTime);
  }, [props.withTime]);

  var onDateChange = function onDateChange(date) {
    if (date) {
      switch (returnFormat) {
        case RETURN_FORMATS$1.TIMESTAMP:
          onChange(date.unix() * 1000);
          break;

        case RETURN_FORMATS$1.MOMENT:
          onChange(date);
          break;

        case RETURN_FORMATS$1.FORMATTED:
          var formatRegex = format;
          if (withTime) formatRegex += " ".concat(is24h ? TIME_FORMAT_24 : TIME_FORMAT);
          onChange(date.format(formatRegex));
          break;

        default:
          onChange(date.format(returnFormat));
          break;
      }
    } else {
      onChange(null);
    }

    if (!withTime) {
      setOpen(false);
    }
  };

  var isDayBlocked = function isDayBlocked(day) {
    if (isBlockSaturdays && day.isoWeekday() === 6) return true;
    if (isBlockSundays && day.isoWeekday() === 7) return true;

    if (minDate || maxDate) {
      if (minDate && day.isBefore(minDate)) return true;
      if (maxDate && day.isAfter(maxDate)) return true;
    } // Check blocked week days (weekend days)


    var blockedWeekDays = blockedWeekDays || [];

    if (includes(blockedWeekDays, day.isoWeekday())) {
      return true;
    }

    if (blockDays && blockDays.length > 0) {
      blockDays.map(function (d) {
        if (day.isSame(moment(d), 'day')) {
          return true;
        }
      });
    }

    if (!allowPastDays && day.isBefore(moment(), 'day')) {
      return true;
    }

    return false;
  };

  var manualInputChange = function manualInputChange(e) {
    var val = e.target ? e.target.value : e;

    if (moment.isMoment(val) && val.isValid() && !isDayBlocked(val)) {
      onDateChange(val);
    }
  };

  var clearDate = function clearDate() {
    onChange(null);
    setOpen(false);
  };

  var renderDay = function renderDay(props, currentDate) {
    var isBlocked = isDayBlocked(currentDate);
    var dayProps = props;

    if (isBlocked) {
      dayProps.className += ' rdtBlocked';
      delete dayProps.onClick;
    }

    return /*#__PURE__*/React__default.createElement("td", {
      key: props.key
    }, /*#__PURE__*/React__default.createElement("div", props, currentDate.date()));
  };

  var getMask = function getMask() {
    var mask = format.split('').map(function (_char) {
      return /[a-zA-Z]/.test(_char) ? /\d/ : _char;
    });

    if (showTime) {
      mask = mask.concat([' ', /\d/, /\d/, ':', /\d/, /\d/]);

      if (!is24h) {
        mask = mask.concat([' ', /[aA,pP]/, /[mM]/]);
      }
    }

    return mask;
  };

  var handleTab = function handleTab(event) {
    if (event.key === 'Tab') {
      setOpen(false);
    }
  };
  /**
   * Figure out an id to pass to the form label and aria-labelledby to the child input element
   */


  var componentId = name || id || randomID;

  var customInput = function customInput(props) {
    return /*#__PURE__*/React__default.createElement(MaskedInput, _extends$g({}, props, focusProps, {
      "aria-labelledby": componentId,
      mask: getMask(),
      guide: true,
      onFocus: function onFocus() {
        return setOpen(true);
      },
      onKeyDown: handleTab
    }));
  };

  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, _extends$g({}, props, {
    id: componentId
  }), /*#__PURE__*/React__default.createElement(DatePickerWrapper, _extends$g({}, rest, {
    error: validationState === 'danger' || error
  }), /*#__PURE__*/React__default.createElement(OutsideClickHandler, {
    onOutsideClick: function onOutsideClick() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React__default.createElement(DateTimeInputWrapper, null, /*#__PURE__*/React__default.createElement(DateTimeComp, {
    theme: rest.theme,
    required: rest.required,
    locale: locale,
    open: open,
    renderDay: renderDay,
    renderInput: customInput,
    value: moment(value, [returnFormat, format]),
    viewMode: "days",
    inputProps: {
      placeholder: placeholder,
      disabled: disabled,
      'aria-labelledby': componentId,
      'aria-required': props.required ? 'true' : 'false'
    },
    disabled: disabled,
    onChange: manualInputChange,
    onBlur: undefined,
    closeOnSelect: !withTime,
    closeOnTab: true,
    dateFormat: format,
    timeFormat: showTime ? is24h ? TIME_FORMAT_24 : TIME_FORMAT : null,
    error: error || validationState === 'danger',
    openDirection: openDirection,
    popupDirection: popupDirection,
    size: size
  }), value && showClearDate && !disabled ? /*#__PURE__*/React__default.createElement(DateTimeClearIcon, {
    icon: "close",
    disabled: disabled,
    onClick: clearDate,
    size: 16,
    color: props.theme.greyBlue,
    hoverColor: props.theme.primary
  }) : /*#__PURE__*/React__default.createElement(CalendarIcon, {
    icon: "calendar",
    size: rest.size === 'small' ? 14 : 20,
    color: "#ccc"
  })))));
};

DatePicker.propTypes = {
  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** adds a red star to the label if set to true and no value exists */
  required: PropTypes.bool,

  /** Adds a tooltip to the label */
  tooltip: PropTypes.string,

  /** Delays in seconds for showing to the tooltip on mouseenter */
  tooltipDelay: PropTypes.number,

  /** changes the look and feel of the component */
  theme: PropTypes.object,

  /** Disabled components and prevents input  */
  disabled: PropTypes.bool,

  /** Affects the border color  */
  validationState: PropTypes.oneOf(['success', 'danger']),

  /** For horizontal forms, it allows components to sit next to it */
  inline: PropTypes.bool,

  /** Displays a small hint under the field */
  hint: PropTypes.string,

  /** Date value, can be a string, timestamp or an actual momentjs object */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(moment), PropTypes.instanceOf(Date)]),

  /** Allows the user to choose days in the past */
  allowPastDays: PropTypes.bool,

  /** Days to block from selection (e.g. holidays) */
  blockDays: PropTypes.arrayOf(PropTypes.string),

  /** Disables all Saturdays */
  isBlockSaturdays: PropTypes.bool,

  /** Disables all Sundays */
  isBlockSundays: PropTypes.bool,

  /** Date value as a Moment.js object */
  date: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string]),

  /** Date format to display. A string like 'DD-MM-YYYY'  */
  format: PropTypes.string,

  /** Fires when date value is changed */
  onChange: PropTypes.func,

  /** Minimum Date allowed in the date picker. Defaults to yesterday */
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(moment), PropTypes.instanceOf(Date)]),

  /** Maximum Date allowed in the date picker */
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(moment), PropTypes.instanceOf(Date)]),

  /** Defines the nature of the returned value. `moment` will return a momentjs object; `timestamp` returns unix epoch timestamp value and `formatted` will bring back the formatted string of the date */
  returnFormat: PropTypes.string,

  /** Controls the vertical alignment of the calendar */
  openDirection: PropTypes.oneOf(OPEN_DIRECTIONS),

  /** Controls the horizontal alignment of the calendar */
  popupDirection: PropTypes.oneOf(POPUP_DIRECTIONS),

  /** Controls the calendar popup visibility */
  popupOpen: PropTypes.bool,

  /** Input placeholder */
  placeholder: PropTypes.string,

  /** Enable setting date and time */
  withTime: PropTypes.bool,

  /** Controls the time format between 24 and 12  */
  is24h: PropTypes.bool,

  /** Sets the date locale. Default will be the user's default  */
  locale: PropTypes.string,

  /** Character that separates formated date */
  dateSeparator: PropTypes.string,

  /** Initialized and focused immediately */
  initialFocused: PropTypes.bool,

  /** Pass true to force focus to this field */
  focused: PropTypes.bool,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func,

  /** Input field height  */
  size: PropTypes.oneOf(['large', 'normal', 'small'])
};
DatePicker.defaultProps = {
  format: 'DD-MM-YYYY',
  returnFormat: RETURN_FORMATS$1.FORMATTED,
  isBlockSaturdays: false,
  isBlockSundays: false,
  allowPastDays: false,
  is24h: true,
  onChange: function onChange() {},
  showClearDate: true,
  withTime: false,
  size: 'large',
  dateSeparator: '-'
};
DatePicker.displayName = 'DatePicker';
var Wrapper$H = compose$1(withTheme, withTransformers)(DatePicker);

var RETURN_FORMATS = {
  MOMENT: 'moment',
  FORMATTED: 'formatted',
  TIMESTAMP: 'timestamp'
};

var DateRangePickerComponent = function DateRangePickerComponent(props) {
  props.value;
      var startDate = props.startDate,
      endDate = props.endDate,
      label = props.label;
      props.hint;
      var format = props.format,
      disabled = props.disabled;
      props.required;
      var error = props.error;
      props.inline;
      var allowPastDays = props.allowPastDays;
      props.className;
      props.tooltip;
      props.tooltipDelay;
      var validationState = props.validationState;
      props.placeholder;
      var returnFormat = props.returnFormat;
      props.minDate;
      var onChange = props.onChange;
      props.maxDate;
      var openDirection = props.openDirection,
      popupDirection = props.popupDirection,
      showClearDate = props.showClearDate,
      startDatePlaceholder = props.startDatePlaceholder,
      endDatePlaceholder = props.endDatePlaceholder;
      props.isOutsideRange;
      var rest = _objectWithoutProperties$c(props, ["value", "startDate", "endDate", "label", "hint", "format", "disabled", "required", "error", "inline", "allowPastDays", "className", "tooltip", "tooltipDelay", "validationState", "placeholder", "returnFormat", "minDate", "onChange", "maxDate", "openDirection", "popupDirection", "showClearDate", "startDatePlaceholder", "endDatePlaceholder", "isOutsideRange"]);

  var formatDisplay = function formatDisplay(date) {
    return date ? moment(date, [returnFormat, format]).format(format) : '';
  };

  var _useState = useState(null),
      _useState2 = _slicedToArray$8(_useState, 2),
      focusedInput = _useState2[0],
      setFocusedInput = _useState2[1];

  var _useState3 = useState(formatDisplay(startDate)),
      _useState4 = _slicedToArray$8(_useState3, 2),
      start = _useState4[0],
      setStart = _useState4[1];

  var _useState5 = useState(formatDisplay(endDate)),
      _useState6 = _slicedToArray$8(_useState5, 2),
      end = _useState6[0],
      setEnd = _useState6[1];

  useEffect(function () {
    setStart(formatDisplay(startDate));
    setEnd(formatDisplay(endDate));
  }, [startDate, endDate]);
  /**
   * Required by react-dates and handles dateChange event
   * @param  {date object} startDate Moment.js
   * @param  {date object} endDate   [description]
   */

  var onDatesChange = function onDatesChange(_ref) {
    var startDate = _ref.startDate,
        endDate = _ref.endDate;
    var values = [startDate, endDate];
    /** Tells the date picker to control the dropdown */

    setFocusedInput(focusedInput === 'startDate' ? 'endDate' : null);

    if (startDate || endDate) {
      switch (returnFormat) {
        case RETURN_FORMATS.TIMESTAMP:
          values = [startDate ? startDate.unix() * 1000 : null, endDate ? endDate.unix() * 1000 : null];
          break;

        case RETURN_FORMATS.MOMENT:
          values = [startDate, endDate];
          break;

        case RETURN_FORMATS.FORMATTED:
          values = [startDate ? startDate.format(format) : null, endDate ? endDate.format(format) : null];
          break;

        default:
          values = [startDate ? startDate.format(returnFormat) : null, endDate ? endDate.format(returnFormat) : null];
          break;
      }
    }

    onChange(values);
  };

  var isDayBlocked = function isDayBlocked(day) {
    var minDate = props.minDate,
        maxDate = props.maxDate;

    if (minDate || maxDate) {
      if (minDate && day.isBefore(minDate)) return true;
      if (maxDate && day.isAfter(maxDate)) return true;
    }
  };

  var getMask = function getMask() {
    return format.split('').map(function (_char) {
      return /[a-zA-Z]/.test(_char) ? '9' : _char;
    }).join('');
  };

  var getDate = function getDate(date) {
    var dm = moment(date, [returnFormat, format]);
    return dm.isValid() ? dm : null;
  };

  var _props = {
    onDatesChange: onDatesChange,
    onFocusChange: function onFocusChange() {},
    focusedInput: focusedInput,
    startDate: getDate(startDate),
    endDate: getDate(endDate),
    minimumNights: 0,
    displayFormat: format,
    showClearDates: showClearDate,
    disabled: props.disabled,
    isDayBlocked: isDayBlocked,
    hideKeyboardShortcutsPanel: true,
    openDirection: openDirection,
    anchorDirection: popupDirection,
    isOutsideRange: allowPastDays ? function () {
      return false;
    } : undefined
  };

  var changeStart = function changeStart(e) {
    setStart(e.target.value);
    var startDate = moment(e.target.value, format, true);
    if (startDate.isValid()) onDatesChange({
      startDate: startDate,
      endDate: moment(endDate, format)
    });
    setFocusedInput('endDate');
  };

  var changeEnd = function changeEnd(e) {
    setEnd(e.target.value);
    var endDate;

    onDatesChange({
      startDate: moment(startDate, returnFormat),
      endDate: endDate
    });
  };

  var handleClear = function handleClear() {
    onChange();
    setFocusedInput();
  };

  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, props, /*#__PURE__*/React__default.createElement(DatePickerWrapper, _extends$g({}, rest, {
    error: error || validationState === 'danger'
  }), /*#__PURE__*/React__default.createElement(OutsideClickHandler, {
    onOutsideClick: function onOutsideClick() {
      return setFocusedInput();
    }
  }, /*#__PURE__*/React__default.createElement(DateRangePicker, _props), /*#__PURE__*/React__default.createElement(DateRangeInputWrapper, _extends$g({}, rest, {
    error: error
  }), /*#__PURE__*/React__default.createElement(InputMask, {
    value: start,
    disabled: disabled,
    onChange: changeStart,
    mask: getMask(),
    maskChar: null,
    tabIndex: 0,
    "aria-label": "".concat(label, " ").concat(startDatePlaceholder),
    onFocus: function onFocus() {
      return setFocusedInput('startDate');
    },
    placeholder: startDatePlaceholder
  }), /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    icon: "caret-right",
    size: 14,
    color: props.theme.greyBlue,
    mx: 3,
    role: "presentation",
    focusable: "false",
    "aria-hidden": "true"
  }), /*#__PURE__*/React__default.createElement(InputMask, {
    value: end,
    disabled: disabled,
    onChange: changeEnd,
    mask: getMask(),
    maskChar: null,
    tabIndex: 0,
    "aria-label": "".concat(label, " ").concat(endDatePlaceholder),
    onFocus: function onFocus() {
      return setFocusedInput('endDate');
    },
    placeholder: endDatePlaceholder
  }), (startDate || endDate) && showClearDate ? /*#__PURE__*/React__default.createElement(DateTimeClearIcon, {
    icon: "close",
    disabled: disabled,
    onClick: handleClear,
    size: 16,
    color: "silver"
  }) : undefined))));
};

DateRangePickerComponent.propTypes = {
  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Start Date value */
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(moment), PropTypes.instanceOf(Date)]),

  /** End Date value */
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(moment), PropTypes.instanceOf(Date)]),

  /** Placeholder for start date input */
  startDatePlaceholder: PropTypes.string,

  /** Placeholder for end date input */
  endDatePlaceholder: PropTypes.string,

  /** Date format to display. A string like 'YYYY-MM-DD' */
  format: PropTypes.string,

  /** Fires when date value is changed. Receives an array of two elements: [startDate, endDate] */
  onChange: PropTypes.func,

  /** Defines the nature of the returned value. `moment` will return a momentjs object; `timestamp` returns unix epoch timestamp value and `formatted` will bring back the formatted string of the date OR the desired format e.g. (YYYY-DD-MM) */
  returnFormat: PropTypes.string,

  /** Minimum Date allowed in the date picker. Defaults to yesterday */
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(moment), PropTypes.instanceOf(Date)]),

  /** Maximum Date allowed in the date picker */
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(moment), PropTypes.instanceOf(Date)]),

  /** Show clear dates icon to allow user to remove dates */
  showClearDate: PropTypes.bool,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
DateRangePickerComponent.defaultProps = {
  showClearDate: true,
  format: 'DD-MM-YYYY',
  returnFormat: RETURN_FORMATS.FORMATTED,
  startDatePlaceholder: 'Start date',
  endDatePlaceholder: 'End date',
  onChange: function onChange() {}
};
DateRangePickerComponent.displayName = 'DateRangePicker';
var Wrapper$G = compose$1(withTheme, withTransformers)(DateRangePickerComponent);

var _templateObject$r, _templateObject2$m, _templateObject3$g;
var DigitInputWrapper = styled.div(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral$1(["\n\tdisplay: flex;\n\tflex-direction: row;\n\tinput {\n\t\twidth: 100px;\n\t\tborder-top-right-radius: 0px;\n\t\tborder-bottom-right-radius: 0px;\n\t}\n"])));
var DigitInputButtonsWrapper = styled.div(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral$1(["\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 30px;\n\tflex-shrink: 0px;\n\tbox-sizing: border-box;\n\theight: ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
      size = _ref.size;
  return theme["inputHeight_".concat(size)];
});
var DigitInputButton = styled.div(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral$1(["\n\tborder: 1px solid\n\t\t", ";\n\theight: 50%;\n\tborder-left-width: 0px;\n\ttext-align: center;\n\tbackground: ", ";\n\tbox-sizing: border-box;\n\tposition: relative;\n\tcursor: pointer;\n\n\tsvg {\n\t\tposition: absolute;\n\t\tleft: 50%;\n\t\ttop: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t}\n\tsvg,\n\tsvg use {\n\t\tcursor: pointer;\n\t\tfill: ", " !important;\n\t}\n\n\t&:first-child {\n\t\tborder-top-right-radius: ", ";\n\t}\n\t&:last-child {\n\t\tborder-bottom-right-radius: ", ";\n\t\tborder-top-width: 0px;\n\t}\n\n\t&:hover {\n\t\tbackground: ", ";\n\t\tsvg,\n\t\tsvg use {\n\t\t\tfill: ", " !important;\n\t\t}\n\t}\n"])), function (_ref2) {
  var theme = _ref2.theme,
      disabled = _ref2.disabled,
      error = _ref2.error;
  return disabled ? theme.inputBorderDisabled : error ? theme.error : theme.inputBorderColor;
}, function (_ref3) {
  var theme = _ref3.theme,
      error = _ref3.error,
      disabled = _ref3.disabled;
  return disabled ? theme.inputBackgroundDisabled : error ? theme.inputBackgroundError : theme.inputBackgroundColor;
}, function (props) {
  return props.theme.silver;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.grey100;
}, function (props) {
  return props.theme.greyBlue;
});

var DigitInput = function DigitInput(props) {
  var value = props.value,
      max = props.max,
      min = props.min,
      onChange = props.onChange,
      size = props.size,
      rest = _objectWithoutProperties$c(props, ["value", "max", "min", "onChange", "size"]);

  var handleIncrement = function handleIncrement() {
    if (props.disabled || max && value === max) return;
    onChange(parseInt(value) + 1);
  };

  var handleDecrement = function handleDecrement() {
    if (value === min) return;
    onChange(parseInt(value) - 1);
  };

  var handleChange = function handleChange(e) {
    var number = parseInt(e.target.value);
    if (min && number < min || max && number > max) return;
    onChange(number);
  };

  var validateNumber = function validateNumber(e) {
    var key = e.key;

    if (key === 'ArrowUp') {
      handleIncrement();
      e.preventDefault();
      return;
    }

    if (key === 'ArrowDown') {
      handleDecrement();
      e.preventDefault();
      return;
    }

    var reg = /^[a-zA-Z$&+,:;=?@#|'<>.^*()%!-]+$/;
    if (!reg.test(key) || key !== 'Backspace' || key !== 'Shift' || key !== 'Delete') return;
    e.preventDefault();
  };

  var theme = rest.theme,
      error = rest.error,
      disabled = rest.disabled,
      validationState = rest.validationState;
  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, rest, /*#__PURE__*/React__default.createElement(DigitInputWrapper, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(FormControl, {
    value: value || min || 0,
    error: error,
    onChange: handleChange,
    onKeyDown: validateNumber,
    "aria-label": rest['aria-label'] || rest.label,
    "aria-required": rest.required ? 'true' : undefined,
    "aria-invalid": rest.error || rest.validationState === 'danger' ? 'true' : 'false',
    disabled: disabled,
    theme: theme,
    size: size
  }), /*#__PURE__*/React__default.createElement(DigitInputButtonsWrapper, {
    theme: theme,
    error: rest.error || rest.validationState === 'danger',
    size: size
  }, /*#__PURE__*/React__default.createElement(DigitInputButton, {
    onClick: handleIncrement,
    theme: theme,
    error: error || validationState === 'danger',
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    icon: "arrow-up",
    size: 24
  })), /*#__PURE__*/React__default.createElement(DigitInputButton, {
    onClick: handleDecrement,
    theme: theme,
    error: error || validationState === 'danger',
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    icon: "arrow-down",
    size: 24
  })))));
};

DigitInput.propTypes = {
  /** Value to show when component renders */
  value: PropTypes.number,

  /** fires when the the value of the field changes */
  onChange: PropTypes.func,
  max: PropTypes.number,
  min: PropTypes.number,

  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** adds a red star to the label if set to true and no value exists */
  required: PropTypes.bool,

  /** Adds a tooltip to the label */
  tooltip: PropTypes.string,

  /** Delays in seconds for showing to the tooptip on mouseenter */
  tooltipDelay: PropTypes.number,

  /** Disabled components and prevents input */
  disabled: PropTypes.bool,

  /** Affects the border color */
  validationState: PropTypes.oneOf(['success', 'danger']),

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
DigitInput.defaultProps = {
  value: undefined,
  onChange: undefined,
  min: 0,
  label: undefined,
  required: false,
  tooltip: undefined,
  tooltipDelay: 0.5,
  inactive: false,
  size: 'large',
  validationState: undefined
};
var Wrapper$F = compose$1(withTheme, withTransformers)(DigitInput);

var __extends$2 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var MiniStoreContext = React.createContext(null);
var Provider = /** @class */ (function (_super) {
    __extends$2(Provider, _super);
    function Provider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Provider.prototype.render = function () {
        return (React.createElement(MiniStoreContext.Provider, { value: this.props.store }, this.props.children));
    };
    return Provider;
}(React.Component));

var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$4 = (undefined && undefined.__assign) || function () {
    __assign$4 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$4.apply(this, arguments);
};
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
var defaultMapStateToProps = function () { return ({}); };
function connect(mapStateToProps, options) {
    if (options === void 0) { options = {}; }
    var shouldSubscribe = !!mapStateToProps;
    var finalMapStateToProps = mapStateToProps || defaultMapStateToProps;
    return function wrapWithConnect(WrappedComponent) {
        var Connect = /** @class */ (function (_super) {
            __extends$1(Connect, _super);
            function Connect(props, context) {
                var _this = _super.call(this, props, context) || this;
                _this.unsubscribe = null;
                _this.handleChange = function () {
                    if (!_this.unsubscribe) {
                        return;
                    }
                    var nextState = finalMapStateToProps(_this.store.getState(), _this.props);
                    _this.setState({ subscribed: nextState });
                };
                _this.store = _this.context;
                _this.state = {
                    subscribed: finalMapStateToProps(_this.store.getState(), props),
                    store: _this.store,
                    props: props,
                };
                return _this;
            }
            Connect.getDerivedStateFromProps = function (props, prevState) {
                // using ownProps
                if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
                    return {
                        subscribed: finalMapStateToProps(prevState.store.getState(), props),
                        props: props,
                    };
                }
                return { props: props };
            };
            Connect.prototype.componentDidMount = function () {
                this.trySubscribe();
            };
            Connect.prototype.componentWillUnmount = function () {
                this.tryUnsubscribe();
            };
            Connect.prototype.shouldComponentUpdate = function (nextProps, nextState) {
                return (!shallowEqual(this.props, nextProps) ||
                    !shallowEqual(this.state.subscribed, nextState.subscribed));
            };
            Connect.prototype.trySubscribe = function () {
                if (shouldSubscribe) {
                    this.unsubscribe = this.store.subscribe(this.handleChange);
                    this.handleChange();
                }
            };
            Connect.prototype.tryUnsubscribe = function () {
                if (this.unsubscribe) {
                    this.unsubscribe();
                    this.unsubscribe = null;
                }
            };
            Connect.prototype.render = function () {
                var props = __assign$4(__assign$4(__assign$4({}, this.props), this.state.subscribed), { store: this.store });
                return React.createElement(WrappedComponent, __assign$4({}, props, { ref: this.props.miniStoreForwardedRef }));
            };
            Connect.displayName = "Connect(" + getDisplayName(WrappedComponent) + ")";
            Connect.contextType = MiniStoreContext;
            return Connect;
        }(React.Component));
        if (options.forwardRef) {
            var forwarded = React.forwardRef(function (props, ref) {
                return React.createElement(Connect, __assign$4({}, props, { miniStoreForwardedRef: ref }));
            });
            return hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return hoistNonReactStatics(Connect, WrappedComponent);
    };
}

var __assign$3 = (undefined && undefined.__assign) || function () {
    __assign$3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};
function create(initialState) {
    var state = initialState;
    var listeners = [];
    function setState(partial) {
        state = __assign$3(__assign$3({}, state), partial);
        for (var i = 0; i < listeners.length; i++) {
            listeners[i]();
        }
    }
    function getState() {
        return state;
    }
    function subscribe(listener) {
        listeners.push(listener);
        return function unsubscribe() {
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
        };
    }
    return {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
    };
}

/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$a(Object(source), true).forEach(function (key) { _defineProperty$i(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$6(arr, i) { return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$6(); }

function _nonIterableRest$6() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$6(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$6(arr) { if (Array.isArray(arr)) return arr; }

// MIT License from https://github.com/kaimallea/isMobile
var applePhone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i; // Match 'Android' AND 'Mobile'

var androidTablet = /Android/i;
var amazonPhone = /\bAndroid(?:.+)SD4930UR\b/i;
var amazonTablet = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i; // Match 'Windows' AND 'ARM'

var otherBlackberry = /BlackBerry/i;
var otherBlackberry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i; // Match 'Mobile' AND 'Firefox'

function match(regex, userAgent) {
  return regex.test(userAgent);
}

function isMobile(userAgent) {
  var ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : ''); // Facebook mobile app's integrated browser adds a bunch of strings that
  // match everything. Strip it out if it exists.

  var tmp = ua.split('[FBAN');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp = tmp;

    var _tmp2 = _slicedToArray$6(_tmp, 1);

    ua = _tmp2[0];
  } // Twitter mobile app's integrated browser on iPad adds a "Twitter for
  // iPhone" string. Same probably happens on other tablet platforms.
  // This will confuse detection so strip it out if it exists.


  tmp = ua.split('Twitter');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp3 = tmp;

    var _tmp4 = _slicedToArray$6(_tmp3, 1);

    ua = _tmp4[0];
  }

  var result = {
    apple: {
      phone: match(applePhone, ua) && !match(windowsPhone, ua),
      ipod: match(appleIpod, ua),
      tablet: !match(applePhone, ua) && match(appleTablet, ua) && !match(windowsPhone, ua),
      device: (match(applePhone, ua) || match(appleIpod, ua) || match(appleTablet, ua)) && !match(windowsPhone, ua)
    },
    amazon: {
      phone: match(amazonPhone, ua),
      tablet: !match(amazonPhone, ua) && match(amazonTablet, ua),
      device: match(amazonPhone, ua) || match(amazonTablet, ua)
    },
    android: {
      phone: !match(windowsPhone, ua) && match(amazonPhone, ua) || !match(windowsPhone, ua) && match(androidPhone, ua),
      tablet: !match(windowsPhone, ua) && !match(amazonPhone, ua) && !match(androidPhone, ua) && (match(amazonTablet, ua) || match(androidTablet, ua)),
      device: !match(windowsPhone, ua) && (match(amazonPhone, ua) || match(amazonTablet, ua) || match(androidPhone, ua) || match(androidTablet, ua)) || match(/\bokhttp\b/i, ua)
    },
    windows: {
      phone: match(windowsPhone, ua),
      tablet: match(windowsTablet, ua),
      device: match(windowsPhone, ua) || match(windowsTablet, ua)
    },
    other: {
      blackberry: match(otherBlackberry, ua),
      blackberry10: match(otherBlackberry10, ua),
      opera: match(otherOpera, ua),
      firefox: match(otherFirefox, ua),
      chrome: match(otherChrome, ua),
      device: match(otherBlackberry, ua) || match(otherBlackberry10, ua) || match(otherOpera, ua) || match(otherFirefox, ua) || match(otherChrome, ua)
    },
    // Additional
    any: null,
    phone: null,
    tablet: null
  };
  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device; // excludes 'other' devices and ipods, targeting touchscreen phones

  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
  return result;
}

var defaultResult = _objectSpread$d(_objectSpread$d({}, isMobile()), {}, {
  isMobile: isMobile
});

function _typeof$c(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$c = function _typeof(obj) { return typeof obj; }; } else { _typeof$c = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$c(obj); }
function noop$2() {}
function getKeyFromChildrenIndex(child, menuEventKey, index) {
  var prefix = menuEventKey || '';
  return child.key || "".concat(prefix, "item_").concat(index);
}
function getMenuIdFromSubMenuEventKey(eventKey) {
  return "".concat(eventKey, "-menu-");
}
function loopMenuItem(children, cb) {
  var index = -1;
  React__default.Children.forEach(children, function (c) {
    index += 1;

    if (c && c.type && c.type.isMenuItemGroup) {
      React__default.Children.forEach(c.props.children, function (c2) {
        index += 1;
        cb(c2, index);
      });
    } else {
      cb(c, index);
    }
  });
}
function loopMenuItemRecursively(children, keys, ret) {
  /* istanbul ignore if */
  if (!children || ret.find) {
    return;
  }

  React__default.Children.forEach(children, function (c) {
    if (c) {
      var construct = c.type;

      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
        return;
      }

      if (keys.indexOf(c.key) !== -1) {
        ret.find = true;
      } else if (c.props.children) {
        loopMenuItemRecursively(c.props.children, keys, ret);
      }
    }
  });
}
var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements', 'overflowedIndicator', 'motion', // the following keys found need to be removed from test regression
'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme', 'itemIcon', 'expandIcon']; // ref: https://github.com/ant-design/ant-design/issues/14007
// ref: https://bugs.chromium.org/p/chromium/issues/detail?id=360889
// getBoundingClientRect return the full precision value, which is
// not the same behavior as on chrome. Set the precision to 6 to
// unify their behavior

var getWidth = function getWidth(elem) {
  var width = elem && typeof elem.getBoundingClientRect === 'function' && elem.getBoundingClientRect().width;

  if (width) {
    width = +width.toFixed(6);
  }

  return width || 0;
};
var setStyle = function setStyle(elem, styleProperty, value) {
  if (elem && _typeof$c(elem.style) === 'object') {
    elem.style[styleProperty] = value;
  }
};
var isMobileDevice = function isMobileDevice() {
  return defaultResult.any;
};

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser$1 || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser$1 || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser$1) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index$3 = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

function ownKeys$9(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$9(Object(source), true).forEach(function (key) {
        _defineProperty$j(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$9(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _isNativeReflectConstruct$6() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _createSuper$6(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$6();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$a(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$a(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$b(this, result);
  };
}

function contains$1(root, n) {
  if (!root) {
    return false;
  }

  return root.contains(n);
}

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */

function findDOMNode$2(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return ReactDOM.findDOMNode(node);
}

function fillRef$2(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (_typeof$d(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/**
 * Merge refs into one ref function to support ref passing.
 */

function composeRef$1() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      fillRef$2(ref, node);
    });
  };
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;

  var type = isMemo(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type; // Function component node

  if (typeof type === 'function' && !((_type$prototype = type.prototype) === null || _type$prototype === void 0 ? void 0 : _type$prototype.render)) {
    return false;
  } // Class component


  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) === null || _nodeOrComponent$prot === void 0 ? void 0 : _nodeOrComponent$prot.render)) {
    return false;
  }

  return true;
}
/* eslint-enable */

function addEventListenerWrap$2(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = ReactDOM.unstable_batchedUpdates ? function run(e) {
    ReactDOM.unstable_batchedUpdates(cb, e);
  } : cb;

  if (target.addEventListener) {
    target.addEventListener(eventType, callback, option);
  }

  return {
    remove: function remove() {
      if (target.removeEventListener) {
        target.removeEventListener(eventType, callback);
      }
    }
  };
}

function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

var Portal = forwardRef(function (props, ref) {
  var didUpdate = props.didUpdate,
      getContainer = props.getContainer,
      children = props.children;
  var containerRef = useRef(); // Ref return nothing, only for wrapper check exist

  useImperativeHandle(ref, function () {
    return {};
  }); // Create container in client side with sync to avoid useEffect not get ref

  var initRef = useRef(false);

  if (!initRef.current && canUseDom()) {
    containerRef.current = getContainer();
    initRef.current = true;
  } // [Legacy] Used by `rc-trigger`


  useEffect(function () {
    didUpdate === null || didUpdate === void 0 ? void 0 : didUpdate(props);
  });
  useEffect(function () {
    return function () {
      var _containerRef$current, _containerRef$current2;

      // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
      // Since some component use `Portal` directly, we have to keep the logic here.
      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : (_containerRef$current2 = _containerRef$current.parentNode) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.removeChild(containerRef.current);
    };
  }, []);
  return containerRef.current ? ReactDOM.createPortal(children, containerRef.current) : null;
});

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }

  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return _objectSpread2$1(_objectSpread2$1({}, baseAlign), align);
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements = Object.keys(builtinPlacements);

  for (var i = 0; i < placements.length; i += 1) {
    var placement = placements[i];

    if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }

  return '';
}

function fillRef$1(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (_typeof$d(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/**
 * Merge refs into one ref function to support ref passing.
 */

function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      fillRef$1(ref, node);
    });
  };
}
/* eslint-enable */

var isVisible = (function (element) {
  if (!element) {
    return false;
  }

  if (element.offsetParent) {
    return true;
  }

  if (element.getBBox) {
    var box = element.getBBox();

    if (box.width || box.height) {
      return true;
    }
  }

  if (element.getBoundingClientRect) {
    var _box = element.getBoundingClientRect();

    if (_box.width || _box.height) {
      return true;
    }
  }

  return false;
});

function _typeof$b(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$b = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof$b = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$b(obj);
}

function _defineProperty$h(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$8(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$8(source, true).forEach(function (key) {
        _defineProperty$h(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$8(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName$2() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName$2();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName$2()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof$b(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix$1(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix$1,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix$1(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); parent && parent !== body; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points; // 重置对应部分的翻转逻辑

      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }

      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }

      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2({}, align, {
    points: points
  }), pointInView);
}

function addEventListenerWrap$1(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = ReactDOM.unstable_batchedUpdates ? function run(e) {
    ReactDOM.unstable_batchedUpdates(cb, e);
  } : cb;

  if (target.addEventListener) {
    target.addEventListener(eventType, callback, option);
  }

  return {
    remove: function remove() {
      if (target.removeEventListener) {
        target.removeEventListener(eventType, callback);
      }
    }
  };
}

function contains(root, n) {
  if (!root) {
    return false;
  }

  return root.contains(n);
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}
function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && contains(container, activeElement) && typeof activeElement.focus === 'function') {
    activeElement.focus();
  }
}
function monitorResize(element, callback) {
  var prevWidth = null;
  var prevHeight = null;

  function onResize(_ref) {
    var _ref2 = _slicedToArray$7(_ref, 1),
        target = _ref2[0].target;

    if (!document.documentElement.contains(target)) return;

    var _target$getBoundingCl = target.getBoundingClientRect(),
        width = _target$getBoundingCl.width,
        height = _target$getBoundingCl.height;

    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);

    if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) {
      // https://webkit.org/blog/9997/resizeobserver-in-webkit/
      Promise.resolve().then(function () {
        callback({
          width: fixedWidth,
          height: fixedHeight
        });
      });
    }

    prevWidth = fixedWidth;
    prevHeight = fixedHeight;
  }

  var resizeObserver = new index$3(onResize);

  if (element) {
    resizeObserver.observe(element);
  }

  return function () {
    resizeObserver.disconnect();
  };
}

var useBuffer = (function (callback, buffer) {
  var calledRef = React__default.useRef(false);
  var timeoutRef = React__default.useRef(null);

  function cancelTrigger() {
    window.clearTimeout(timeoutRef.current);
  }

  function trigger(force) {
    if (!calledRef.current || force === true) {
      if (callback() === false) {
        // Not delay since callback cancelled self
        return;
      }

      calledRef.current = true;
      cancelTrigger();
      timeoutRef.current = window.setTimeout(function () {
        calledRef.current = false;
      }, buffer);
    } else {
      cancelTrigger();
      timeoutRef.current = window.setTimeout(function () {
        calledRef.current = false;
        trigger();
      }, buffer);
    }
  }

  return [trigger, function () {
    calledRef.current = false;
    cancelTrigger();
  }];
});

function getElement(func) {
  if (typeof func !== 'function') return null;
  return func();
}

function getPoint(point) {
  if (_typeof$d(point) !== 'object' || !point) return null;
  return point;
}

var Align = function Align(_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      target = _ref.target,
      align = _ref.align,
      onAlign = _ref.onAlign,
      monitorWindowResize = _ref.monitorWindowResize,
      _ref$monitorBufferTim = _ref.monitorBufferTime,
      monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
  var cacheRef = React__default.useRef({});
  var nodeRef = React__default.useRef();
  var childNode = React__default.Children.only(children); // ===================== Align ======================
  // We save the props here to avoid closure makes props ood

  var forceAlignPropsRef = React__default.useRef({});
  forceAlignPropsRef.current.disabled = disabled;
  forceAlignPropsRef.current.target = target;
  forceAlignPropsRef.current.onAlign = onAlign;

  var _useBuffer = useBuffer(function () {
    var _forceAlignPropsRef$c = forceAlignPropsRef.current,
        latestDisabled = _forceAlignPropsRef$c.disabled,
        latestTarget = _forceAlignPropsRef$c.target,
        latestOnAlign = _forceAlignPropsRef$c.onAlign;

    if (!latestDisabled && latestTarget) {
      var source = nodeRef.current;
      var result;
      var element = getElement(latestTarget);
      var point = getPoint(latestTarget);
      cacheRef.current.element = element;
      cacheRef.current.point = point; // IE lose focus after element realign
      // We should record activeElement and restore later

      var _document = document,
          activeElement = _document.activeElement; // We only align when element is visible

      if (element && isVisible(element)) {
        result = alignElement(source, element, align);
      } else if (point) {
        result = alignPoint(source, point, align);
      }

      restoreFocus(activeElement, source);

      if (latestOnAlign && result) {
        latestOnAlign(source, result);
      }

      return true;
    }

    return false;
  }, monitorBufferTime),
      _useBuffer2 = _slicedToArray$7(_useBuffer, 2),
      _forceAlign = _useBuffer2[0],
      cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
  // Listen for target updated


  var resizeMonitor = React__default.useRef({
    cancel: function cancel() {}
  }); // Listen for source updated

  var sourceResizeMonitor = React__default.useRef({
    cancel: function cancel() {}
  });
  React__default.useEffect(function () {
    var element = getElement(target);
    var point = getPoint(target);

    if (nodeRef.current !== sourceResizeMonitor.current.element) {
      sourceResizeMonitor.current.cancel();
      sourceResizeMonitor.current.element = nodeRef.current;
      sourceResizeMonitor.current.cancel = monitorResize(nodeRef.current, _forceAlign);
    }

    if (cacheRef.current.element !== element || !isSamePoint(cacheRef.current.point, point)) {
      _forceAlign(); // Add resize observer


      if (resizeMonitor.current.element !== element) {
        resizeMonitor.current.cancel();
        resizeMonitor.current.element = element;
        resizeMonitor.current.cancel = monitorResize(element, _forceAlign);
      }
    }
  }); // Listen for disabled change

  React__default.useEffect(function () {
    if (!disabled) {
      _forceAlign();
    } else {
      cancelForceAlign();
    }
  }, [disabled]); // Listen for window resize

  var winResizeRef = React__default.useRef(null);
  React__default.useEffect(function () {
    if (monitorWindowResize) {
      if (!winResizeRef.current) {
        winResizeRef.current = addEventListenerWrap$1(window, 'resize', _forceAlign);
      }
    } else if (winResizeRef.current) {
      winResizeRef.current.remove();
      winResizeRef.current = null;
    }
  }, [monitorWindowResize]); // Clear all if unmount

  React__default.useEffect(function () {
    return function () {
      resizeMonitor.current.cancel();
      sourceResizeMonitor.current.cancel();
      if (winResizeRef.current) winResizeRef.current.remove();
      cancelForceAlign();
    };
  }, []); // ====================== Ref =======================

  React__default.useImperativeHandle(ref, function () {
    return {
      forceAlign: function forceAlign() {
        return _forceAlign(true);
      }
    };
  }); // ===================== Render =====================

  if (React__default.isValidElement(childNode)) {
    childNode = React__default.cloneElement(childNode, {
      ref: composeRef(childNode.ref, nodeRef)
    });
  }

  return childNode;
};

var RefAlign = React__default.forwardRef(Align);
RefAlign.displayName = 'Align';

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */

function findDOMNode$1(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return ReactDOM.findDOMNode(node);
}

function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (_typeof$d(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/* eslint-enable */

var canUseDOM$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement); // ================= Transition =================
// Event wrapper. Copy from react source code

function makePrefixMap$1(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}

function getVendorPrefixes$1(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap$1('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap$1('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}
var vendorPrefixes$1 = getVendorPrefixes$1(canUseDOM$1, typeof window !== 'undefined' ? window : {});
var style$1 = {};

if (canUseDOM$1) {
  var _document$createEleme = document.createElement('div');

  style$1 = _document$createEleme.style;
}

var prefixedEventNames$1 = {};
function getVendorPrefixedEventName$1(eventName) {
  if (prefixedEventNames$1[eventName]) {
    return prefixedEventNames$1[eventName];
  }

  var prefixMap = vendorPrefixes$1[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;

    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];

      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style$1) {
        prefixedEventNames$1[eventName] = prefixMap[styleProp];
        return prefixedEventNames$1[eventName];
      }
    }
  }

  return '';
}
var animationEndName$1 = getVendorPrefixedEventName$1('animationend');
var transitionEndName$1 = getVendorPrefixedEventName$1('transitionend');
var supportTransition$1 = !!(animationEndName$1 && transitionEndName$1);
function getTransitionName$1(transitionName, transitionType) {
  if (!transitionName) return null;

  if (_typeof$d(transitionName) === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return "".concat(transitionName, "-").concat(transitionType);
}

var STATUS_NONE$1 = 'none';
var STATUS_APPEAR$1 = 'appear';
var STATUS_ENTER$1 = 'enter';
var STATUS_LEAVE$1 = 'leave';

/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */

function genCSSMotion$1(config) {
  var transitionSupport = config;
  var forwardRef = !!React.forwardRef;

  if (_typeof$d(config) === 'object') {
    transitionSupport = config.transitionSupport;
    forwardRef = 'forwardRef' in config ? config.forwardRef : forwardRef;
  }

  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }

  var CSSMotion = /*#__PURE__*/function (_React$Component) {
    _inherits$b(CSSMotion, _React$Component);

    var _super = _createSuper$6(CSSMotion);

    function CSSMotion() {
      var _this;

      _classCallCheck$i(this, CSSMotion);

      _this = _super.apply(this, arguments);
      _this.$cacheEle = null;
      _this.node = null;
      _this.raf = null;
      _this.destroyed = false;
      _this.deadlineId = null;
      _this.state = {
        status: STATUS_NONE$1,
        statusActive: false,
        newStatus: false,
        statusStyle: null
      };

      _this.onDomUpdate = function () {
        var _this$state = _this.state,
            status = _this$state.status,
            newStatus = _this$state.newStatus;
        var _this$props = _this.props,
            onAppearStart = _this$props.onAppearStart,
            onEnterStart = _this$props.onEnterStart,
            onLeaveStart = _this$props.onLeaveStart,
            onAppearActive = _this$props.onAppearActive,
            onEnterActive = _this$props.onEnterActive,
            onLeaveActive = _this$props.onLeaveActive,
            motionAppear = _this$props.motionAppear,
            motionEnter = _this$props.motionEnter,
            motionLeave = _this$props.motionLeave;

        if (!isSupportTransition(_this.props)) {
          return;
        } // Event injection


        var $ele = _this.getElement();

        if (_this.$cacheEle !== $ele) {
          _this.removeEventListener(_this.$cacheEle);

          _this.addEventListener($ele);

          _this.$cacheEle = $ele;
        } // Init status


        if (newStatus && status === STATUS_APPEAR$1 && motionAppear) {
          _this.updateStatus(onAppearStart, null, null, function () {
            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR$1);
          });
        } else if (newStatus && status === STATUS_ENTER$1 && motionEnter) {
          _this.updateStatus(onEnterStart, null, null, function () {
            _this.updateActiveStatus(onEnterActive, STATUS_ENTER$1);
          });
        } else if (newStatus && status === STATUS_LEAVE$1 && motionLeave) {
          _this.updateStatus(onLeaveStart, null, null, function () {
            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE$1);
          });
        }
      };

      _this.onMotionEnd = function (event) {
        if (event && !event.deadline && event.target !== _this.getElement()) {
          // event exists
          // not initiated by deadline
          // transitionend not fired by inner elements
          return;
        }

        var _this$state2 = _this.state,
            status = _this$state2.status,
            statusActive = _this$state2.statusActive;
        var _this$props2 = _this.props,
            onAppearEnd = _this$props2.onAppearEnd,
            onEnterEnd = _this$props2.onEnterEnd,
            onLeaveEnd = _this$props2.onLeaveEnd;

        if (status === STATUS_APPEAR$1 && statusActive) {
          _this.updateStatus(onAppearEnd, {
            status: STATUS_NONE$1
          }, event);
        } else if (status === STATUS_ENTER$1 && statusActive) {
          _this.updateStatus(onEnterEnd, {
            status: STATUS_NONE$1
          }, event);
        } else if (status === STATUS_LEAVE$1 && statusActive) {
          _this.updateStatus(onLeaveEnd, {
            status: STATUS_NONE$1
          }, event);
        }
      };

      _this.setNodeRef = function (node) {
        var internalRef = _this.props.internalRef;
        _this.node = node;
        fillRef(internalRef, node);
      };

      _this.getElement = function () {
        try {
          return findDOMNode$1(_this.node || _assertThisInitialized$a(_this));
        } catch (e) {
          /**
           * Fallback to cache element.
           * This is only happen when `motionDeadline` trigger but element removed.
           */
          return _this.$cacheEle;
        }
      };

      _this.addEventListener = function ($ele) {
        if (!$ele) return;
        $ele.addEventListener(transitionEndName$1, _this.onMotionEnd);
        $ele.addEventListener(animationEndName$1, _this.onMotionEnd);
      };

      _this.removeEventListener = function ($ele) {
        if (!$ele) return;
        $ele.removeEventListener(transitionEndName$1, _this.onMotionEnd);
        $ele.removeEventListener(animationEndName$1, _this.onMotionEnd);
      };

      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
        var statusStyle = styleFunc ? styleFunc(_this.getElement(), event) : null;
        if (statusStyle === false || _this.destroyed) return;
        var nextStep;

        if (callback) {
          nextStep = function nextStep() {
            _this.nextFrame(callback);
          };
        }

        _this.setState(_objectSpread2$1({
          statusStyle: _typeof$d(statusStyle) === 'object' ? statusStyle : null,
          newStatus: false
        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`

      };

      _this.updateActiveStatus = function (styleFunc, currentStatus) {
        // `setState` use `postMessage` to trigger at the end of frame.
        // Let's use requestAnimationFrame to update new state in next frame.
        _this.nextFrame(function () {
          var status = _this.state.status;
          if (status !== currentStatus) return;
          var motionDeadline = _this.props.motionDeadline;

          _this.updateStatus(styleFunc, {
            statusActive: true
          });

          if (motionDeadline > 0) {
            _this.deadlineId = setTimeout(function () {
              _this.onMotionEnd({
                deadline: true
              });
            }, motionDeadline);
          }
        });
      };

      _this.nextFrame = function (func) {
        _this.cancelNextFrame();

        _this.raf = raf(func);
      };

      _this.cancelNextFrame = function () {
        if (_this.raf) {
          raf.cancel(_this.raf);
          _this.raf = null;
        }
      };

      return _this;
    }

    _createClass$h(CSSMotion, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.onDomUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.onDomUpdate();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.destroyed = true;
        this.removeEventListener(this.$cacheEle);
        this.cancelNextFrame();
        clearTimeout(this.deadlineId);
      }
    }, {
      key: "render",
      value: function render() {
        var _classNames;

        var _this$state3 = this.state,
            status = _this$state3.status,
            statusActive = _this$state3.statusActive,
            statusStyle = _this$state3.statusStyle;
        var _this$props3 = this.props,
            children = _this$props3.children,
            motionName = _this$props3.motionName,
            visible = _this$props3.visible,
            removeOnLeave = _this$props3.removeOnLeave,
            leavedClassName = _this$props3.leavedClassName,
            eventProps = _this$props3.eventProps;
        if (!children) return null;

        if (status === STATUS_NONE$1 || !isSupportTransition(this.props)) {
          if (visible) {
            return children(_objectSpread2$1({}, eventProps), this.setNodeRef);
          }

          if (!removeOnLeave) {
            return children(_objectSpread2$1(_objectSpread2$1({}, eventProps), {}, {
              className: leavedClassName
            }), this.setNodeRef);
          }

          return null;
        }

        return children(_objectSpread2$1(_objectSpread2$1({}, eventProps), {}, {
          className: classNames$1(getTransitionName$1(motionName, status), (_classNames = {}, _defineProperty$j(_classNames, getTransitionName$1(motionName, "".concat(status, "-active")), statusActive), _defineProperty$j(_classNames, motionName, typeof motionName === 'string'), _classNames)),
          style: statusStyle
        }), this.setNodeRef);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props, _ref) {
        var prevProps = _ref.prevProps,
            prevStatus = _ref.status;
        if (!isSupportTransition(props)) return {};
        var visible = props.visible,
            motionAppear = props.motionAppear,
            motionEnter = props.motionEnter,
            motionLeave = props.motionLeave,
            motionLeaveImmediately = props.motionLeaveImmediately;
        var newState = {
          prevProps: props
        }; // Clean up status if prop set to false

        if (prevStatus === STATUS_APPEAR$1 && !motionAppear || prevStatus === STATUS_ENTER$1 && !motionEnter || prevStatus === STATUS_LEAVE$1 && !motionLeave) {
          newState.status = STATUS_NONE$1;
          newState.statusActive = false;
          newState.newStatus = false;
        } // Appear


        if (!prevProps && visible && motionAppear) {
          newState.status = STATUS_APPEAR$1;
          newState.statusActive = false;
          newState.newStatus = true;
        } // Enter


        if (prevProps && !prevProps.visible && visible && motionEnter) {
          newState.status = STATUS_ENTER$1;
          newState.statusActive = false;
          newState.newStatus = true;
        } // Leave


        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
          newState.status = STATUS_LEAVE$1;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        return newState;
      }
    }]);

    return CSSMotion;
  }(React.Component);

  CSSMotion.defaultProps = {
    visible: true,
    motionEnter: true,
    motionAppear: true,
    motionLeave: true,
    removeOnLeave: true
  };

  if (!forwardRef) {
    return CSSMotion;
  }

  return React.forwardRef(function (props, ref) {
    return React.createElement(CSSMotion, Object.assign({
      internalRef: ref
    }, props));
  });
}
var CSSMotion$1 = genCSSMotion$1(supportTransition$1);

var STATUS_ADD = 'add';
var STATUS_KEEP = 'keep';
var STATUS_REMOVE = 'remove';
var STATUS_REMOVED = 'removed';
function wrapKeyToObject(key) {
  var keyObj;

  if (key && _typeof$d(key) === 'object' && 'key' in key) {
    keyObj = key;
  } else {
    keyObj = {
      key: key
    };
  }

  return _objectSpread2$1(_objectSpread2$1({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return keys.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys); // Check prev keys to insert or keep

  prevKeyObjects.forEach(function (keyObj) {
    var hit = false;

    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];

      if (currentKeyObj.key === keyObj.key) {
        // New added keys should add before current key
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function (obj) {
            return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }

        list.push(_objectSpread2$1(_objectSpread2$1({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    } // If not hit, it means key is removed


    if (!hit) {
      list.push(_objectSpread2$1(_objectSpread2$1({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  }); // Add rest to the list

  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function (obj) {
      return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }
  /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */


  var keys = {};
  list.forEach(function (_ref) {
    var key = _ref.key;
    keys[key] = (keys[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys).filter(function (key) {
    return keys[key] > 1;
  });
  duplicatedKeys.forEach(function (matchKey) {
    // Remove `STATUS_REMOVE` node.
    list = list.filter(function (_ref2) {
      var key = _ref2.key,
          status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    }); // Update `STATUS_ADD` to `STATUS_KEEP`

    list.forEach(function (node) {
      if (node.key === matchKey) {
        // eslint-disable-next-line no-param-reassign
        node.status = STATUS_KEEP;
      }
    });
  });
  return list;
}

var MOTION_PROP_NAMES = ['eventProps', 'visible', 'children', 'motionName', 'motionAppear', 'motionEnter', 'motionLeave', 'motionLeaveImmediately', 'motionDeadline', 'removeOnLeave', 'leavedClassName', 'onAppearStart', 'onAppearActive', 'onAppearEnd', 'onEnterStart', 'onEnterActive', 'onEnterEnd', 'onLeaveStart', 'onLeaveActive', 'onLeaveEnd'];
function genCSSMotionList(transitionSupport) {
  var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CSSMotion$1;

  var CSSMotionList = /*#__PURE__*/function (_React$Component) {
    _inherits$b(CSSMotionList, _React$Component);

    var _super = _createSuper$6(CSSMotionList);

    function CSSMotionList() {
      var _this;

      _classCallCheck$i(this, CSSMotionList);

      _this = _super.apply(this, arguments);
      _this.state = {
        keyEntities: []
      };

      _this.removeKey = function (removeKey) {
        _this.setState(function (_ref) {
          var keyEntities = _ref.keyEntities;
          return {
            keyEntities: keyEntities.map(function (entity) {
              if (entity.key !== removeKey) return entity;
              return _objectSpread2$1(_objectSpread2$1({}, entity), {}, {
                status: STATUS_REMOVED
              });
            })
          };
        });
      };

      return _this;
    }

    _createClass$h(CSSMotionList, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var keyEntities = this.state.keyEntities;

        var _this$props = this.props,
            component = _this$props.component,
            children = _this$props.children,
            restProps = _objectWithoutProperties$b(_this$props, ["component", "children"]);

        var Component = component || React.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function (prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return React.createElement(Component, Object.assign({}, restProps), keyEntities.map(function (_ref2) {
          var status = _ref2.status,
              eventProps = _objectWithoutProperties$b(_ref2, ["status"]);

          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return React.createElement(CSSMotion, Object.assign({}, motionProps, {
            key: eventProps.key,
            visible: visible,
            eventProps: eventProps,
            onLeaveEnd: function onLeaveEnd() {
              if (motionProps.onLeaveEnd) {
                motionProps.onLeaveEnd.apply(motionProps, arguments);
              }

              _this2.removeKey(eventProps.key);
            }
          }), children);
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys); // Always as keep when motion not support

        if (!transitionSupport) {
          return {
            keyEntities: parsedKeyObjects.map(function (obj) {
              return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
                status: STATUS_KEEP
              });
            })
          };
        }

        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        var keyEntitiesLen = keyEntities.length;
        return {
          keyEntities: mixedKeyEntities.filter(function (entity) {
            // IE 9 not support Array.prototype.find
            var prevEntity = null;

            for (var i = 0; i < keyEntitiesLen; i += 1) {
              var currentEntity = keyEntities[i];

              if (currentEntity.key === entity.key) {
                prevEntity = currentEntity;
                break;
              }
            } // Remove if already mark as removed


            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }

            return true;
          })
        };
      }
    }]);

    return CSSMotionList;
  }(React.Component);

  CSSMotionList.defaultProps = {
    component: 'div'
  };
  return CSSMotionList;
}
genCSSMotionList(supportTransition$1);

var PopupInner = function PopupInner(props, ref) {
  var prefixCls = props.prefixCls,
      className = props.className,
      style = props.style,
      children = props.children,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onMouseDown = props.onMouseDown,
      onTouchStart = props.onTouchStart;
  var childNode = children;

  if (React.Children.count(children) > 1) {
    childNode = React.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  }

  return React.createElement("div", {
    ref: ref,
    className: className,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseDown: onMouseDown,
    onTouchStart: onTouchStart,
    style: style
  }, childNode);
};

var RefPopupInner = React.forwardRef(PopupInner);
RefPopupInner.displayName = 'PopupInner';

function getMotion$1(_ref) {
  var prefixCls = _ref.prefixCls,
      motion = _ref.motion,
      animation = _ref.animation,
      transitionName = _ref.transitionName;

  if (motion) {
    return motion;
  }

  if (animation) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation)
    };
  }

  if (transitionName) {
    return {
      motionName: transitionName
    };
  }

  return null;
}

function supportMotion(motion) {
  return motion && motion.motionName;
}

var Popup = /*#__PURE__*/function (_Component) {
  _inherits$b(Popup, _Component);

  var _super = _createSuper$6(Popup);

  function Popup() {
    var _this;

    _classCallCheck$i(this, Popup);

    _this = _super.apply(this, arguments);
    _this.state = {
      targetWidth: undefined,
      targetHeight: undefined,
      status: null,
      prevVisible: null,
      alignClassName: null,
      inMotion: false
    };
    _this.popupRef = React__default.createRef();
    _this.alignRef = React__default.createRef();
    _this.nextFrameState = null;
    _this.nextFrameId = null;

    _this.onAlign = function (popupDomNode, align) {
      var status = _this.state.status;
      var _this$props = _this.props,
          getClassNameFromAlign = _this$props.getClassNameFromAlign,
          onAlign = _this$props.onAlign;
      var alignClassName = getClassNameFromAlign(align);

      if (status === 'align') {
        _this.setState({
          alignClassName: alignClassName,
          status: 'aligned'
        }, function () {
          _this.alignRef.current.forceAlign();
        });
      } else if (status === 'aligned') {
        _this.setState({
          alignClassName: alignClassName,
          status: 'afterAlign'
        });

        onAlign(popupDomNode, align);
      } else {
        _this.setState({
          alignClassName: alignClassName
        });
      }
    };

    _this.onMotionEnd = function () {
      var visible = _this.props.visible;

      _this.setState({
        status: visible ? 'AfterMotion' : 'stable',
        inMotion: false
      });
    };

    _this.setStateOnNextFrame = function (state) {
      _this.cancelFrameState();

      _this.nextFrameState = _objectSpread2$1(_objectSpread2$1({}, _this.nextFrameState), state);
      _this.nextFrameId = raf(function () {
        var submitState = _objectSpread2$1({}, _this.nextFrameState);

        _this.nextFrameState = null;

        _this.setState(submitState);
      });
    };

    _this.getMotion = function () {
      return _objectSpread2$1({}, getMotion$1(_this.props));
    }; // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align


    _this.getAlignTarget = function () {
      var _this$props2 = _this.props,
          point = _this$props2.point,
          getRootDomNode = _this$props2.getRootDomNode;

      if (point) {
        return point;
      }

      return getRootDomNode;
    };

    _this.cancelFrameState = function () {
      raf.cancel(_this.nextFrameId);
    };

    _this.renderPopupElement = function () {
      var _this$state = _this.state,
          status = _this$state.status,
          targetHeight = _this$state.targetHeight,
          targetWidth = _this$state.targetWidth,
          alignClassName = _this$state.alignClassName;
      var _this$props3 = _this.props,
          prefixCls = _this$props3.prefixCls,
          className = _this$props3.className,
          style = _this$props3.style,
          stretch = _this$props3.stretch,
          visible = _this$props3.visible,
          align = _this$props3.align,
          destroyPopupOnHide = _this$props3.destroyPopupOnHide,
          onMouseEnter = _this$props3.onMouseEnter,
          onMouseLeave = _this$props3.onMouseLeave,
          onMouseDown = _this$props3.onMouseDown,
          onTouchStart = _this$props3.onTouchStart,
          children = _this$props3.children;
      var mergedClassName = classNames$1(prefixCls, className, alignClassName);
      var hiddenClassName = "".concat(prefixCls, "-hidden"); // ================== Style ==================

      var sizeStyle = {};

      if (stretch) {
        // Stretch with target
        if (stretch.indexOf('height') !== -1) {
          sizeStyle.height = targetHeight;
        } else if (stretch.indexOf('minHeight') !== -1) {
          sizeStyle.minHeight = targetHeight;
        }

        if (stretch.indexOf('width') !== -1) {
          sizeStyle.width = targetWidth;
        } else if (stretch.indexOf('minWidth') !== -1) {
          sizeStyle.minWidth = targetWidth;
        }
      }

      var mergedStyle = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, sizeStyle), _this.getZIndexStyle()), style), {}, {
        opacity: status === 'stable' || !visible ? undefined : 0,
        pointerEvents: status === 'stable' || !visible ? undefined : 'none'
      }); // ================= Motions =================


      var mergedMotion = _this.getMotion();

      var mergedMotionVisible = visible;

      if (visible && status !== 'beforeMotion' && status !== 'motion' && status !== 'stable') {
        mergedMotion.motionAppear = false;
        mergedMotion.motionEnter = false;
        mergedMotion.motionLeave = false;
      }

      if (status === 'afterAlign' || status === 'beforeMotion') {
        mergedMotionVisible = false;
      } // Update trigger to tell if is in motion


      ['onEnterStart', 'onAppearStart', 'onLeaveStart'].forEach(function (event) {
        var originFunc = mergedMotion === null || mergedMotion === void 0 ? void 0 : mergedMotion[event];

        mergedMotion[event] = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          originFunc === null || originFunc === void 0 ? void 0 : originFunc.apply(void 0, args);

          _this.setState({
            inMotion: true
          });
        };
      }); // ================== Align ==================

      var mergedAlignDisabled = !visible || status !== 'align' && status !== 'aligned' && status !== 'stable'; // ================== Popup ==================

      var mergedPopupVisible = true;

      if (status === 'stable') {
        mergedPopupVisible = visible;
      } // Only remove popup since mask may still need animation


      if (destroyPopupOnHide && !mergedPopupVisible) {
        return null;
      }

      return React__default.createElement(CSSMotion$1, Object.assign({
        visible: mergedMotionVisible
      }, mergedMotion, {
        removeOnLeave: false,
        onEnterEnd: _this.onMotionEnd,
        onLeaveEnd: _this.onMotionEnd,
        leavedClassName: hiddenClassName
      }), function (_ref, motionRef) {
        var motionStyle = _ref.style,
            motionClassName = _ref.className;
        return React__default.createElement(RefAlign, {
          target: _this.getAlignTarget(),
          key: "popup",
          ref: _this.alignRef,
          monitorWindowResize: true,
          disabled: mergedAlignDisabled,
          align: align,
          onAlign: _this.onAlign
        }, React__default.createElement(RefPopupInner, {
          prefixCls: prefixCls,
          className: classNames$1(mergedClassName, motionClassName),
          ref: composeRef$1(motionRef, _this.popupRef),
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          onMouseDown: onMouseDown,
          onTouchStart: onTouchStart,
          style: _objectSpread2$1(_objectSpread2$1({}, mergedStyle), motionStyle)
        }, children));
      });
    };

    _this.renderMaskElement = function () {
      var _this$props4 = _this.props,
          mask = _this$props4.mask,
          maskMotion = _this$props4.maskMotion,
          maskTransitionName = _this$props4.maskTransitionName,
          maskAnimation = _this$props4.maskAnimation,
          prefixCls = _this$props4.prefixCls,
          visible = _this$props4.visible;

      if (!mask) {
        return null;
      }

      var motion = {};

      if (maskMotion && maskMotion.motionName) {
        motion = _objectSpread2$1({
          motionAppear: true
        }, getMotion$1({
          motion: maskMotion,
          prefixCls: prefixCls,
          transitionName: maskTransitionName,
          animation: maskAnimation
        }));
      }

      return React__default.createElement(CSSMotion$1, Object.assign({}, motion, {
        visible: visible,
        removeOnLeave: true
      }), function (_ref2) {
        var className = _ref2.className;
        return React__default.createElement("div", {
          style: _this.getZIndexStyle(),
          key: "mask",
          className: classNames$1("".concat(prefixCls, "-mask"), className)
        });
      });
    };

    return _this;
  }

  _createClass$h(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var status = this.state.status;
      var _this$props5 = this.props,
          getRootDomNode = _this$props5.getRootDomNode,
          visible = _this$props5.visible,
          stretch = _this$props5.stretch; // If there is a pending state update, cancel it, a new one will be set if necessary

      this.cancelFrameState();

      if (visible && status !== 'stable') {
        switch (status) {
          case null:
            {
              this.setStateOnNextFrame({
                status: stretch ? 'measure' : 'align'
              });
              break;
            }

          case 'afterAlign':
            {
              this.setStateOnNextFrame({
                status: supportMotion(this.getMotion()) ? 'beforeMotion' : 'stable'
              });
              break;
            }

          case 'AfterMotion':
            {
              this.setStateOnNextFrame({
                status: 'stable'
              });
              break;
            }

          default:
            {
              // Go to next status
              var queue = ['measure', 'align', null, 'beforeMotion', 'motion'];
              var index = queue.indexOf(status);
              var nextStatus = queue[index + 1];

              if (index !== -1 && nextStatus) {
                this.setStateOnNextFrame({
                  status: nextStatus
                });
              }
            }
        }
      } // Measure stretch size


      if (status === 'measure') {
        var $ele = getRootDomNode();

        if ($ele) {
          this.setStateOnNextFrame({
            targetHeight: $ele.offsetHeight,
            targetWidth: $ele.offsetWidth
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelFrameState();
    }
  }, {
    key: "getZIndexStyle",
    value: function getZIndexStyle() {
      var zIndex = this.props.zIndex;
      return {
        zIndex: zIndex
      };
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement("div", null, this.renderMaskElement(), this.renderPopupElement());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref3, _ref4) {
      var visible = _ref3.visible,
          props = _objectWithoutProperties$b(_ref3, ["visible"]);

      var prevVisible = _ref4.prevVisible,
          status = _ref4.status,
          inMotion = _ref4.inMotion;
      var newState = {
        prevVisible: visible,
        status: status
      };
      var mergedMotion = getMotion$1(props);

      if (prevVisible === null && visible === false) {
        // Init render should always be stable
        newState.status = 'stable';
        newState.inMotion = false;
      } else if (visible !== prevVisible) {
        newState.inMotion = false;

        if (visible || supportMotion(mergedMotion) && inMotion) {
          newState.status = null;
        } else {
          newState.status = 'stable';
        }

        if (visible) {
          newState.alignClassName = null;
        }
      }

      return newState;
    }
  }]);

  return Popup;
}(Component);
/* eslint-enable */

var TriggerContext = React.createContext(null);

function noop$1() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
/**
 * Internal usage. Do not use in your code since this will be removed.
 */

function generateTrigger(PortalComponent) {
  var Trigger = /*#__PURE__*/function (_React$Component) {
    _inherits$b(Trigger, _React$Component);

    var _super = _createSuper$6(Trigger);

    function Trigger(props) {
      var _this;

      _classCallCheck$i(this, Trigger);

      _this = _super.call(this, props);
      _this.popupRef = React__default.createRef();
      _this.triggerRef = React__default.createRef();

      _this.onMouseEnter = function (e) {
        var mouseEnterDelay = _this.props.mouseEnterDelay;

        _this.fireEvents('onMouseEnter', e);

        _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
      };

      _this.onMouseMove = function (e) {
        _this.fireEvents('onMouseMove', e);

        _this.setPoint(e);
      };

      _this.onMouseLeave = function (e) {
        _this.fireEvents('onMouseLeave', e);

        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      };

      _this.onPopupMouseEnter = function () {
        _this.clearDelayTimer();
      };

      _this.onPopupMouseLeave = function (e) {
        // https://github.com/react-component/trigger/pull/13
        // react bug?
        if (e.relatedTarget && !e.relatedTarget.setTimeout && _this.popupRef.current && _this.popupRef.current.popupRef.current && contains$1(_this.popupRef.current.popupRef.current, e.relatedTarget)) {
          return;
        }

        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      };

      _this.onFocus = function (e) {
        _this.fireEvents('onFocus', e); // incase focusin and focusout


        _this.clearDelayTimer();

        if (_this.isFocusToShow()) {
          _this.focusTime = Date.now();

          _this.delaySetPopupVisible(true, _this.props.focusDelay);
        }
      };

      _this.onMouseDown = function (e) {
        _this.fireEvents('onMouseDown', e);

        _this.preClickTime = Date.now();
      };

      _this.onTouchStart = function (e) {
        _this.fireEvents('onTouchStart', e);

        _this.preTouchTime = Date.now();
      };

      _this.onBlur = function (e) {
        _this.fireEvents('onBlur', e);

        _this.clearDelayTimer();

        if (_this.isBlurToHide()) {
          _this.delaySetPopupVisible(false, _this.props.blurDelay);
        }
      };

      _this.onContextMenu = function (e) {
        e.preventDefault();

        _this.fireEvents('onContextMenu', e);

        _this.setPopupVisible(true, e);
      };

      _this.onContextMenuClose = function () {
        if (_this.isContextMenuToShow()) {
          _this.close();
        }
      };

      _this.onClick = function (event) {
        _this.fireEvents('onClick', event); // focus will trigger click


        if (_this.focusTime) {
          var preTime;

          if (_this.preClickTime && _this.preTouchTime) {
            preTime = Math.min(_this.preClickTime, _this.preTouchTime);
          } else if (_this.preClickTime) {
            preTime = _this.preClickTime;
          } else if (_this.preTouchTime) {
            preTime = _this.preTouchTime;
          }

          if (Math.abs(preTime - _this.focusTime) < 20) {
            return;
          }

          _this.focusTime = 0;
        }

        _this.preClickTime = 0;
        _this.preTouchTime = 0; // Only prevent default when all the action is click.
        // https://github.com/ant-design/ant-design/issues/17043
        // https://github.com/ant-design/ant-design/issues/17291

        if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) {
          event.preventDefault();
        }

        var nextVisible = !_this.state.popupVisible;

        if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) {
          _this.setPopupVisible(!_this.state.popupVisible, event);
        }
      };

      _this.onPopupMouseDown = function () {
        _this.hasPopupMouseDown = true;
        clearTimeout(_this.mouseDownTimeout);
        _this.mouseDownTimeout = window.setTimeout(function () {
          _this.hasPopupMouseDown = false;
        }, 0);

        if (_this.context) {
          var _this$context;

          (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
        }
      };

      _this.onDocumentClick = function (event) {
        if (_this.props.mask && !_this.props.maskClosable) {
          return;
        }

        var target = event.target;

        var root = _this.getRootDomNode();

        var popupNode = _this.getPopupDomNode();

        if (!contains$1(root, target) && !contains$1(popupNode, target) && !_this.hasPopupMouseDown) {
          _this.close();
        }
      };

      _this.getRootDomNode = function () {
        var getTriggerDOMNode = _this.props.getTriggerDOMNode;

        if (getTriggerDOMNode) {
          return getTriggerDOMNode(_this.triggerRef.current);
        }

        try {
          var domNode = findDOMNode$2(_this.triggerRef.current);

          if (domNode) {
            return domNode;
          }
        } catch (err) {// Do nothing
        }

        return ReactDOM.findDOMNode(_assertThisInitialized$a(_this));
      };

      _this.getPopupClassNameFromAlign = function (align) {
        var className = [];
        var _this$props = _this.props,
            popupPlacement = _this$props.popupPlacement,
            builtinPlacements = _this$props.builtinPlacements,
            prefixCls = _this$props.prefixCls,
            alignPoint = _this$props.alignPoint,
            getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;

        if (popupPlacement && builtinPlacements) {
          className.push(getAlignPopupClassName(builtinPlacements, prefixCls, align, alignPoint));
        }

        if (getPopupClassNameFromAlign) {
          className.push(getPopupClassNameFromAlign(align));
        }

        return className.join(' ');
      };

      _this.getComponent = function () {
        var _this$props2 = _this.props,
            prefixCls = _this$props2.prefixCls,
            destroyPopupOnHide = _this$props2.destroyPopupOnHide,
            popupClassName = _this$props2.popupClassName,
            onPopupAlign = _this$props2.onPopupAlign,
            popupMotion = _this$props2.popupMotion,
            popupAnimation = _this$props2.popupAnimation,
            popupTransitionName = _this$props2.popupTransitionName,
            popupStyle = _this$props2.popupStyle,
            mask = _this$props2.mask,
            maskAnimation = _this$props2.maskAnimation,
            maskTransitionName = _this$props2.maskTransitionName,
            maskMotion = _this$props2.maskMotion,
            zIndex = _this$props2.zIndex,
            popup = _this$props2.popup,
            stretch = _this$props2.stretch,
            alignPoint = _this$props2.alignPoint;
        var _this$state = _this.state,
            popupVisible = _this$state.popupVisible,
            point = _this$state.point;

        var align = _this.getPopupAlign();

        var mouseProps = {};

        if (_this.isMouseEnterToShow()) {
          mouseProps.onMouseEnter = _this.onPopupMouseEnter;
        }

        if (_this.isMouseLeaveToHide()) {
          mouseProps.onMouseLeave = _this.onPopupMouseLeave;
        }

        mouseProps.onMouseDown = _this.onPopupMouseDown;
        mouseProps.onTouchStart = _this.onPopupMouseDown;
        return React__default.createElement(Popup, Object.assign({
          prefixCls: prefixCls,
          destroyPopupOnHide: destroyPopupOnHide,
          visible: popupVisible,
          point: alignPoint && point,
          className: popupClassName,
          align: align,
          onAlign: onPopupAlign,
          animation: popupAnimation,
          getClassNameFromAlign: _this.getPopupClassNameFromAlign
        }, mouseProps, {
          stretch: stretch,
          getRootDomNode: _this.getRootDomNode,
          style: popupStyle,
          mask: mask,
          zIndex: zIndex,
          transitionName: popupTransitionName,
          maskAnimation: maskAnimation,
          maskTransitionName: maskTransitionName,
          maskMotion: maskMotion,
          ref: _this.popupRef,
          motion: popupMotion
        }), typeof popup === 'function' ? popup() : popup);
      };

      _this.getContainer = function () {
        var _assertThisInitialize = _assertThisInitialized$a(_this),
            props = _assertThisInitialize.props;

        var popupContainer = document.createElement('div'); // Make sure default popup container will never cause scrollbar appearing
        // https://github.com/react-component/trigger/issues/41

        popupContainer.style.position = 'absolute';
        popupContainer.style.top = '0';
        popupContainer.style.left = '0';
        popupContainer.style.width = '100%';
        var mountNode = props.getPopupContainer ? props.getPopupContainer(_this.getRootDomNode()) : props.getDocument().body;
        mountNode.appendChild(popupContainer);
        return popupContainer;
      };

      _this.setPoint = function (point) {
        var alignPoint = _this.props.alignPoint;
        if (!alignPoint || !point) return;

        _this.setState({
          point: {
            pageX: point.pageX,
            pageY: point.pageY
          }
        });
      };

      _this.handlePortalUpdate = function () {
        if (_this.state.prevPopupVisible !== _this.state.popupVisible) {
          _this.props.afterPopupVisibleChange(_this.state.popupVisible);
        }
      };

      var popupVisible;

      if ('popupVisible' in props) {
        popupVisible = !!props.popupVisible;
      } else {
        popupVisible = !!props.defaultPopupVisible;
      }

      _this.state = {
        prevPopupVisible: popupVisible,
        popupVisible: popupVisible
      };
      ALL_HANDLERS.forEach(function (h) {
        _this["fire".concat(h)] = function (e) {
          _this.fireEvents(h, e);
        };
      });
      return _this;
    }

    _createClass$h(Trigger, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var props = this.props;
        var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
        // https://github.com/ant-design/ant-design/issues/5804
        // https://github.com/react-component/calendar/issues/250
        // https://github.com/react-component/trigger/issues/50

        if (state.popupVisible) {
          var currentDocument;

          if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
            currentDocument = props.getDocument();
            this.clickOutsideHandler = addEventListenerWrap$2(currentDocument, 'mousedown', this.onDocumentClick);
          } // always hide on mobile


          if (!this.touchOutsideHandler) {
            currentDocument = currentDocument || props.getDocument();
            this.touchOutsideHandler = addEventListenerWrap$2(currentDocument, 'touchstart', this.onDocumentClick);
          } // close popup when trigger type contains 'onContextMenu' and document is scrolling.


          if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
            currentDocument = currentDocument || props.getDocument();
            this.contextMenuOutsideHandler1 = addEventListenerWrap$2(currentDocument, 'scroll', this.onContextMenuClose);
          } // close popup when trigger type contains 'onContextMenu' and window is blur.


          if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
            this.contextMenuOutsideHandler2 = addEventListenerWrap$2(window, 'blur', this.onContextMenuClose);
          }

          return;
        }

        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearDelayTimer();
        this.clearOutsideHandler();
        clearTimeout(this.mouseDownTimeout);
      }
    }, {
      key: "getPopupDomNode",
      value: function getPopupDomNode() {
        // for test
        if (this.popupRef.current && this.popupRef.current.popupRef.current) {
          return this.popupRef.current.popupRef.current;
        }

        return null;
      }
    }, {
      key: "getPopupAlign",
      value: function getPopupAlign() {
        var props = this.props;
        var popupPlacement = props.popupPlacement,
            popupAlign = props.popupAlign,
            builtinPlacements = props.builtinPlacements;

        if (popupPlacement && builtinPlacements) {
          return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
        }

        return popupAlign;
      }
      /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */

    }, {
      key: "setPopupVisible",
      value: function setPopupVisible(popupVisible, event) {
        var alignPoint = this.props.alignPoint;
        var prevPopupVisible = this.state.popupVisible;
        this.clearDelayTimer();

        if (prevPopupVisible !== popupVisible) {
          if (!('popupVisible' in this.props)) {
            this.setState({
              popupVisible: popupVisible,
              prevPopupVisible: prevPopupVisible
            });
          }

          this.props.onPopupVisibleChange(popupVisible);
        } // Always record the point position since mouseEnterDelay will delay the show


        if (alignPoint && event) {
          this.setPoint(event);
        }
      }
    }, {
      key: "delaySetPopupVisible",
      value: function delaySetPopupVisible(visible, delayS, event) {
        var _this2 = this;

        var delay = delayS * 1000;
        this.clearDelayTimer();

        if (delay) {
          var point = event ? {
            pageX: event.pageX,
            pageY: event.pageY
          } : null;
          this.delayTimer = window.setTimeout(function () {
            _this2.setPopupVisible(visible, point);

            _this2.clearDelayTimer();
          }, delay);
        } else {
          this.setPopupVisible(visible, event);
        }
      }
    }, {
      key: "clearDelayTimer",
      value: function clearDelayTimer() {
        if (this.delayTimer) {
          clearTimeout(this.delayTimer);
          this.delayTimer = null;
        }
      }
    }, {
      key: "clearOutsideHandler",
      value: function clearOutsideHandler() {
        if (this.clickOutsideHandler) {
          this.clickOutsideHandler.remove();
          this.clickOutsideHandler = null;
        }

        if (this.contextMenuOutsideHandler1) {
          this.contextMenuOutsideHandler1.remove();
          this.contextMenuOutsideHandler1 = null;
        }

        if (this.contextMenuOutsideHandler2) {
          this.contextMenuOutsideHandler2.remove();
          this.contextMenuOutsideHandler2 = null;
        }

        if (this.touchOutsideHandler) {
          this.touchOutsideHandler.remove();
          this.touchOutsideHandler = null;
        }
      }
    }, {
      key: "createTwoChains",
      value: function createTwoChains(event) {
        var childPros = this.props.children.props;
        var props = this.props;

        if (childPros[event] && props[event]) {
          return this["fire".concat(event)];
        }

        return childPros[event] || props[event];
      }
    }, {
      key: "isClickToShow",
      value: function isClickToShow() {
        var _this$props3 = this.props,
            action = _this$props3.action,
            showAction = _this$props3.showAction;
        return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
      }
    }, {
      key: "isContextMenuToShow",
      value: function isContextMenuToShow() {
        var _this$props4 = this.props,
            action = _this$props4.action,
            showAction = _this$props4.showAction;
        return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function isClickToHide() {
        var _this$props5 = this.props,
            action = _this$props5.action,
            hideAction = _this$props5.hideAction;
        return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function isMouseEnterToShow() {
        var _this$props6 = this.props,
            action = _this$props6.action,
            showAction = _this$props6.showAction;
        return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function isMouseLeaveToHide() {
        var _this$props7 = this.props,
            action = _this$props7.action,
            hideAction = _this$props7.hideAction;
        return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function isFocusToShow() {
        var _this$props8 = this.props,
            action = _this$props8.action,
            showAction = _this$props8.showAction;
        return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function isBlurToHide() {
        var _this$props9 = this.props,
            action = _this$props9.action,
            hideAction = _this$props9.hideAction;
        return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function forcePopupAlign() {
        if (this.state.popupVisible && this.popupRef.current && this.popupRef.current.alignRef.current) {
          this.popupRef.current.alignRef.current.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function fireEvents(type, e) {
        var childCallback = this.props.children.props[type];

        if (childCallback) {
          childCallback(e);
        }

        var callback = this.props[type];

        if (callback) {
          callback(e);
        }
      }
    }, {
      key: "close",
      value: function close() {
        this.setPopupVisible(false);
      }
    }, {
      key: "render",
      value: function render() {
        var popupVisible = this.state.popupVisible;
        var _this$props10 = this.props,
            children = _this$props10.children,
            forceRender = _this$props10.forceRender,
            alignPoint = _this$props10.alignPoint,
            className = _this$props10.className,
            autoDestroy = _this$props10.autoDestroy;
        var child = React__default.Children.only(children);
        var newChildProps = {
          key: 'trigger'
        };

        if (this.isContextMenuToShow()) {
          newChildProps.onContextMenu = this.onContextMenu;
        } else {
          newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
        }

        if (this.isClickToHide() || this.isClickToShow()) {
          newChildProps.onClick = this.onClick;
          newChildProps.onMouseDown = this.onMouseDown;
          newChildProps.onTouchStart = this.onTouchStart;
        } else {
          newChildProps.onClick = this.createTwoChains('onClick');
          newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
          newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
        }

        if (this.isMouseEnterToShow()) {
          newChildProps.onMouseEnter = this.onMouseEnter;

          if (alignPoint) {
            newChildProps.onMouseMove = this.onMouseMove;
          }
        } else {
          newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
        }

        if (this.isMouseLeaveToHide()) {
          newChildProps.onMouseLeave = this.onMouseLeave;
        } else {
          newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
        }

        if (this.isFocusToShow() || this.isBlurToHide()) {
          newChildProps.onFocus = this.onFocus;
          newChildProps.onBlur = this.onBlur;
        } else {
          newChildProps.onFocus = this.createTwoChains('onFocus');
          newChildProps.onBlur = this.createTwoChains('onBlur');
        }

        var childrenClassName = classNames$1(child && child.props && child.props.className, className);

        if (childrenClassName) {
          newChildProps.className = childrenClassName;
        }

        var cloneProps = _objectSpread2$1({}, newChildProps);

        if (supportRef(child)) {
          cloneProps.ref = composeRef$1(this.triggerRef, child.ref);
        }

        var trigger = React__default.cloneElement(child, cloneProps);
        var portal; // prevent unmounting after it's rendered

        if (popupVisible || this.popupRef.current || forceRender) {
          portal = React__default.createElement(PortalComponent, {
            key: "portal",
            getContainer: this.getContainer,
            didUpdate: this.handlePortalUpdate
          }, this.getComponent());
        }

        if (!popupVisible && autoDestroy) {
          portal = null;
        }

        return React__default.createElement(TriggerContext.Provider, {
          value: {
            onPopupMouseDown: this.onPopupMouseDown
          }
        }, trigger, portal);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref, prevState) {
        var popupVisible = _ref.popupVisible;
        var newState = {};

        if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
          newState.popupVisible = popupVisible;
          newState.prevPopupVisible = prevState.popupVisible;
        }

        return newState;
      }
    }]);

    return Trigger;
  }(React__default.Component);

  Trigger.contextType = TriggerContext;
  Trigger.defaultProps = {
    prefixCls: 'rc-trigger-popup',
    getPopupClassNameFromAlign: returnEmptyString,
    getDocument: returnDocument,
    onPopupVisibleChange: noop$1,
    afterPopupVisibleChange: noop$1,
    onPopupAlign: noop$1,
    popupClassName: '',
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: false,
    popupAlign: {},
    defaultPopupVisible: false,
    mask: false,
    maskClosable: true,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: false
  };
  return Trigger;
}
var Trigger = generateTrigger(Portal);

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */

function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return ReactDOM.findDOMNode(node);
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}

var vendorPrefixes = getVendorPrefixes(canUseDOM, typeof window !== 'undefined' ? window : {});

var style = {};

if (canUseDOM) {
  style = document.createElement('div').style;
}

var prefixedEventNames = {};

function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }

  var prefixMap = vendorPrefixes[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }

  return '';
}

var animationEndName = getVendorPrefixedEventName('animationend');
var transitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(animationEndName && transitionEndName);

function getTransitionName(transitionName, transitionType) {
  if (!transitionName) return null;

  if (typeof transitionName === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return transitionName + '-' + transitionType;
}

var _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$g = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty$g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$h(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$a(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';

/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */
function genCSSMotion(config) {
  var transitionSupport = config;
  var forwardRef = !!React__default.forwardRef;

  if (typeof config === 'object') {
    transitionSupport = config.transitionSupport;
    forwardRef = 'forwardRef' in config ? config.forwardRef : forwardRef;
  }

  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }

  var CSSMotion = function (_React$Component) {
    _inherits$a(CSSMotion, _React$Component);

    function CSSMotion() {
      _classCallCheck$h(this, CSSMotion);

      var _this = _possibleConstructorReturn$a(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));

      _this.onDomUpdate = function () {
        var _this$state = _this.state,
            status = _this$state.status,
            newStatus = _this$state.newStatus;
        var _this$props = _this.props,
            onAppearStart = _this$props.onAppearStart,
            onEnterStart = _this$props.onEnterStart,
            onLeaveStart = _this$props.onLeaveStart,
            onAppearActive = _this$props.onAppearActive,
            onEnterActive = _this$props.onEnterActive,
            onLeaveActive = _this$props.onLeaveActive,
            motionAppear = _this$props.motionAppear,
            motionEnter = _this$props.motionEnter,
            motionLeave = _this$props.motionLeave;


        if (!isSupportTransition(_this.props)) {
          return;
        }

        // Event injection
        var $ele = _this.getElement();
        if (_this.$cacheEle !== $ele) {
          _this.removeEventListener(_this.$cacheEle);
          _this.addEventListener($ele);
          _this.$cacheEle = $ele;
        }

        // Init status
        if (newStatus && status === STATUS_APPEAR && motionAppear) {
          _this.updateStatus(onAppearStart, null, null, function () {
            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
          });
        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
          _this.updateStatus(onEnterStart, null, null, function () {
            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
          });
        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
          _this.updateStatus(onLeaveStart, null, null, function () {
            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
          });
        }
      };

      _this.onMotionEnd = function (event) {
        var _this$state2 = _this.state,
            status = _this$state2.status,
            statusActive = _this$state2.statusActive;
        var _this$props2 = _this.props,
            onAppearEnd = _this$props2.onAppearEnd,
            onEnterEnd = _this$props2.onEnterEnd,
            onLeaveEnd = _this$props2.onLeaveEnd;

        if (status === STATUS_APPEAR && statusActive) {
          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_ENTER && statusActive) {
          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
        } else if (status === STATUS_LEAVE && statusActive) {
          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
        }
      };

      _this.setNodeRef = function (node) {
        var internalRef = _this.props.internalRef;

        _this.node = node;

        if (typeof internalRef === 'function') {
          internalRef(node);
        } else if (internalRef && 'current' in internalRef) {
          internalRef.current = node;
        }
      };

      _this.getElement = function () {
        try {
          return findDOMNode(_this.node || _this);
        } catch (e) {
          /**
           * Fallback to cache element.
           * This is only happen when `motionDeadline` trigger but element removed.
           */
          return _this.$cacheEle;
        }
      };

      _this.addEventListener = function ($ele) {
        if (!$ele) return;

        $ele.addEventListener(transitionEndName, _this.onMotionEnd);
        $ele.addEventListener(animationEndName, _this.onMotionEnd);
      };

      _this.removeEventListener = function ($ele) {
        if (!$ele) return;

        $ele.removeEventListener(transitionEndName, _this.onMotionEnd);
        $ele.removeEventListener(animationEndName, _this.onMotionEnd);
      };

      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
        var statusStyle = styleFunc ? styleFunc(_this.getElement(), event) : null;

        if (statusStyle === false || _this._destroyed) return;

        var nextStep = void 0;
        if (callback) {
          nextStep = function nextStep() {
            _this.nextFrame(callback);
          };
        }

        _this.setState(_extends$d({
          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
          newStatus: false
        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
      };

      _this.updateActiveStatus = function (styleFunc, currentStatus) {
        // `setState` use `postMessage` to trigger at the end of frame.
        // Let's use requestAnimationFrame to update new state in next frame.
        _this.nextFrame(function () {
          var status = _this.state.status;

          if (status !== currentStatus) return;

          var motionDeadline = _this.props.motionDeadline;


          _this.updateStatus(styleFunc, { statusActive: true });

          if (motionDeadline > 0) {
            _this.timer = setTimeout(function () {
              _this.onMotionEnd({
                deadline: true
              });
            }, motionDeadline);
          }
        });
      };

      _this.nextFrame = function (func) {
        _this.cancelNextFrame();
        _this.raf = raf(func);
      };

      _this.cancelNextFrame = function () {
        if (_this.raf) {
          raf.cancel(_this.raf);
          _this.raf = null;
        }
      };

      _this.state = {
        status: STATUS_NONE,
        statusActive: false,
        newStatus: false,
        statusStyle: null
      };
      _this.$cacheEle = null;
      _this.node = null;
      _this.raf = null;
      return _this;
    }

    _createClass$g(CSSMotion, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.onDomUpdate();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._destroyed = true;
        this.removeEventListener(this.$cacheEle);
        this.cancelNextFrame();
        clearTimeout(this.timer);
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _state = this.state,
            status = _state.status,
            statusActive = _state.statusActive,
            statusStyle = _state.statusStyle;
        var _props = this.props,
            children = _props.children,
            motionName = _props.motionName,
            visible = _props.visible,
            removeOnLeave = _props.removeOnLeave,
            leavedClassName = _props.leavedClassName,
            eventProps = _props.eventProps;


        if (!children) return null;

        if (status === STATUS_NONE || !isSupportTransition(this.props)) {
          if (visible) {
            return children(_extends$d({}, eventProps), this.setNodeRef);
          } else if (!removeOnLeave) {
            return children(_extends$d({}, eventProps, { className: leavedClassName }), this.setNodeRef);
          }

          return null;
        }

        return children(_extends$d({}, eventProps, {
          className: classNames$1((_classNames = {}, _defineProperty$g(_classNames, getTransitionName(motionName, status), status !== STATUS_NONE), _defineProperty$g(_classNames, getTransitionName(motionName, status + '-active'), status !== STATUS_NONE && statusActive), _defineProperty$g(_classNames, motionName, typeof motionName === 'string'), _classNames)),
          style: statusStyle
        }), this.setNodeRef);
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(props, _ref) {
        var prevProps = _ref.prevProps,
            prevStatus = _ref.status;

        if (!isSupportTransition(props)) return {};

        var visible = props.visible,
            motionAppear = props.motionAppear,
            motionEnter = props.motionEnter,
            motionLeave = props.motionLeave,
            motionLeaveImmediately = props.motionLeaveImmediately;

        var newState = {
          prevProps: props
        };

        // Clean up status if prop set to false
        if (prevStatus === STATUS_APPEAR && !motionAppear || prevStatus === STATUS_ENTER && !motionEnter || prevStatus === STATUS_LEAVE && !motionLeave) {
          newState.status = STATUS_NONE;
          newState.statusActive = false;
          newState.newStatus = false;
        }

        // Appear
        if (!prevProps && visible && motionAppear) {
          newState.status = STATUS_APPEAR;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Enter
        if (prevProps && !prevProps.visible && visible && motionEnter) {
          newState.status = STATUS_ENTER;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        // Leave
        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
          newState.status = STATUS_LEAVE;
          newState.statusActive = false;
          newState.newStatus = true;
        }

        return newState;
      }
    }]);

    return CSSMotion;
  }(React__default.Component);

  CSSMotion.defaultProps = {
    visible: true,
    motionEnter: true,
    motionAppear: true,
    motionLeave: true,
    removeOnLeave: true
  };


  if (!forwardRef) {
    return CSSMotion;
  }

  return React__default.forwardRef(function (props, ref) {
    return React__default.createElement(CSSMotion, _extends$d({ internalRef: ref }, props));
  });
}

var CSSMotion = genCSSMotion(supportTransition);

var autoAdjustOverflow$1 = {
  adjustX: 1,
  adjustY: 1
};
var placements$1 = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow$1,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow$1,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow$1,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow$1,
    offset: [4, 0]
  }
};
var placementsRtl = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow$1,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow$1,
    offset: [0, 7]
  },
  rightTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow$1,
    offset: [-4, 0]
  },
  leftTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow$1,
    offset: [4, 0]
  }
};

function _typeof$a(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$a = function _typeof(obj) { return typeof obj; }; } else { _typeof$a = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$a(obj); }

function _classCallCheck$g(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$f(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$f(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$f(Constructor.prototype, protoProps); if (staticProps) _defineProperties$f(Constructor, staticProps); return Constructor; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$9(subClass, superClass); }

function _setPrototypeOf$9(o, p) { _setPrototypeOf$9 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$9(o, p); }

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function () { var Super = _getPrototypeOf$9(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$9(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$9(this, result); }; }

function _possibleConstructorReturn$9(self, call) { if (call && (_typeof$a(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$9(self); }

function _assertThisInitialized$9(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$9(o) { _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$9(o); }

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty$f(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var guid = 0;
var popupPlacementMap = {
  horizontal: 'bottomLeft',
  vertical: 'rightTop',
  'vertical-left': 'rightTop',
  'vertical-right': 'leftTop'
};

var updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
  var menuId = getMenuIdFromSubMenuEventKey(eventKey);
  var state = store.getState();
  store.setState({
    defaultActiveFirst: _objectSpread$c(_objectSpread$c({}, state.defaultActiveFirst), {}, _defineProperty$f({}, menuId, defaultActiveFirst))
  });
};

var SubMenu = /*#__PURE__*/function (_React$Component) {
  _inherits$9(SubMenu, _React$Component);

  var _super = _createSuper$5(SubMenu);

  function SubMenu(props) {
    var _this;

    _classCallCheck$g(this, SubMenu);

    _this = _super.call(this, props);

    _this.onDestroy = function (key) {
      _this.props.onDestroy(key);
    };
    /**
     * note:
     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
     *  which need return code to check if this event is handled
     */


    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;
      var menu = _this.menuInstance;
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          store = _this$props.store;

      if (keyCode === KeyCode.ENTER) {
        _this.onTitleClick(e);

        updateDefaultActiveFirst(store, _this.props.eventKey, true);
        return true;
      }

      if (keyCode === KeyCode.RIGHT) {
        if (isOpen) {
          menu.onKeyDown(e);
        } else {
          _this.triggerOpenChange(true); // need to update current menu's defaultActiveFirst value


          updateDefaultActiveFirst(store, _this.props.eventKey, true);
        }

        return true;
      }

      if (keyCode === KeyCode.LEFT) {
        var handled;

        if (isOpen) {
          handled = menu.onKeyDown(e);
        } else {
          return undefined;
        }

        if (!handled) {
          _this.triggerOpenChange(false);

          handled = true;
        }

        return handled;
      }

      if (isOpen && (keyCode === KeyCode.UP || keyCode === KeyCode.DOWN)) {
        return menu.onKeyDown(e);
      }

      return undefined;
    };

    _this.onOpenChange = function (e) {
      _this.props.onOpenChange(e);
    };

    _this.onPopupVisibleChange = function (visible) {
      _this.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          key = _this$props2.eventKey,
          onMouseEnter = _this$props2.onMouseEnter,
          store = _this$props2.store;
      updateDefaultActiveFirst(store, _this.props.eventKey, false);
      onMouseEnter({
        key: key,
        domEvent: e
      });
    };

    _this.onMouseLeave = function (e) {
      var _this$props3 = _this.props,
          parentMenu = _this$props3.parentMenu,
          eventKey = _this$props3.eventKey,
          onMouseLeave = _this$props3.onMouseLeave;
      parentMenu.subMenuInstance = _assertThisInitialized$9(_this);
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onTitleMouseEnter = function (domEvent) {
      var _this$props4 = _this.props,
          key = _this$props4.eventKey,
          onItemHover = _this$props4.onItemHover,
          onTitleMouseEnter = _this$props4.onTitleMouseEnter;
      onItemHover({
        key: key,
        hover: true
      });
      onTitleMouseEnter({
        key: key,
        domEvent: domEvent
      });
    };

    _this.onTitleMouseLeave = function (e) {
      var _this$props5 = _this.props,
          parentMenu = _this$props5.parentMenu,
          eventKey = _this$props5.eventKey,
          onItemHover = _this$props5.onItemHover,
          onTitleMouseLeave = _this$props5.onTitleMouseLeave;
      parentMenu.subMenuInstance = _assertThisInitialized$9(_this);
      onItemHover({
        key: eventKey,
        hover: false
      });
      onTitleMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onTitleClick = function (e) {
      var _assertThisInitialize = _assertThisInitialized$9(_this),
          props = _assertThisInitialize.props;

      props.onTitleClick({
        key: props.eventKey,
        domEvent: e
      });

      if (props.triggerSubMenuAction === 'hover') {
        return;
      }

      _this.triggerOpenChange(!props.isOpen, 'click');

      updateDefaultActiveFirst(props.store, _this.props.eventKey, false);
    };

    _this.onSubMenuClick = function (info) {
      // in the case of overflowed submenu
      // onClick is not copied over
      if (typeof _this.props.onClick === 'function') {
        _this.props.onClick(_this.addKeyPath(info));
      }
    };

    _this.onSelect = function (info) {
      _this.props.onSelect(info);
    };

    _this.onDeselect = function (info) {
      _this.props.onDeselect(info);
    };

    _this.getPrefixCls = function () {
      return "".concat(_this.props.rootPrefixCls, "-submenu");
    };

    _this.getActiveClassName = function () {
      return "".concat(_this.getPrefixCls(), "-active");
    };

    _this.getDisabledClassName = function () {
      return "".concat(_this.getPrefixCls(), "-disabled");
    };

    _this.getSelectedClassName = function () {
      return "".concat(_this.getPrefixCls(), "-selected");
    };

    _this.getOpenClassName = function () {
      return "".concat(_this.props.rootPrefixCls, "-submenu-open");
    };

    _this.saveMenuInstance = function (c) {
      // children menu instance
      _this.menuInstance = c;
    };

    _this.addKeyPath = function (info) {
      return _objectSpread$c(_objectSpread$c({}, info), {}, {
        keyPath: (info.keyPath || []).concat(_this.props.eventKey)
      });
    };

    _this.triggerOpenChange = function (open, type) {
      var key = _this.props.eventKey;

      var openChange = function openChange() {
        _this.onOpenChange({
          key: key,
          item: _assertThisInitialized$9(_this),
          trigger: type,
          open: open
        });
      };

      if (type === 'mouseenter') {
        // make sure mouseenter happen after other menu item's mouseleave
        _this.mouseenterTimeout = setTimeout(function () {
          openChange();
        }, 0);
      } else {
        openChange();
      }
    };

    _this.isChildrenSelected = function () {
      var ret = {
        find: false
      };
      loopMenuItemRecursively(_this.props.children, _this.props.selectedKeys, ret);
      return ret.find;
    };

    _this.isOpen = function () {
      return _this.props.openKeys.indexOf(_this.props.eventKey) !== -1;
    };

    _this.adjustWidth = function () {
      /* istanbul ignore if */
      if (!_this.subMenuTitle || !_this.menuInstance) {
        return;
      }

      var popupMenu = ReactDOM.findDOMNode(_this.menuInstance);

      if (popupMenu.offsetWidth >= _this.subMenuTitle.offsetWidth) {
        return;
      }
      /* istanbul ignore next */


      popupMenu.style.minWidth = "".concat(_this.subMenuTitle.offsetWidth, "px");
    };

    _this.saveSubMenuTitle = function (subMenuTitle) {
      _this.subMenuTitle = subMenuTitle;
    };

    _this.getBaseProps = function () {
      var _assertThisInitialize2 = _assertThisInitialized$9(_this),
          props = _assertThisInitialize2.props;

      return {
        mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
        visible: _this.props.isOpen,
        level: props.level + 1,
        inlineIndent: props.inlineIndent,
        focusable: false,
        onClick: _this.onSubMenuClick,
        onSelect: _this.onSelect,
        onDeselect: _this.onDeselect,
        onDestroy: _this.onDestroy,
        selectedKeys: props.selectedKeys,
        eventKey: "".concat(props.eventKey, "-menu-"),
        openKeys: props.openKeys,
        motion: props.motion,
        onOpenChange: _this.onOpenChange,
        subMenuOpenDelay: props.subMenuOpenDelay,
        parentMenu: _assertThisInitialized$9(_this),
        subMenuCloseDelay: props.subMenuCloseDelay,
        forceSubMenuRender: props.forceSubMenuRender,
        triggerSubMenuAction: props.triggerSubMenuAction,
        builtinPlacements: props.builtinPlacements,
        defaultActiveFirst: props.store.getState().defaultActiveFirst[getMenuIdFromSubMenuEventKey(props.eventKey)],
        multiple: props.multiple,
        prefixCls: props.rootPrefixCls,
        id: _this.internalMenuId,
        manualRef: _this.saveMenuInstance,
        itemIcon: props.itemIcon,
        expandIcon: props.expandIcon,
        direction: props.direction
      };
    };

    _this.getMotion = function (mode, visible) {
      var _assertThisInitialize3 = _assertThisInitialized$9(_this),
          haveRendered = _assertThisInitialize3.haveRendered;

      var _this$props6 = _this.props,
          motion = _this$props6.motion,
          rootPrefixCls = _this$props6.rootPrefixCls; // don't show transition on first rendering (no animation for opened menu)
      // show appear transition if it's not visible (not sure why)
      // show appear transition if it's not inline mode

      var mergedMotion = _objectSpread$c(_objectSpread$c({}, motion), {}, {
        leavedClassName: "".concat(rootPrefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: haveRendered || !visible || mode !== 'inline'
      });

      return mergedMotion;
    };

    var store = props.store,
        eventKey = props.eventKey;

    var _store$getState = store.getState(),
        defaultActiveFirst = _store$getState.defaultActiveFirst;

    _this.isRootMenu = false;
    var value = false;

    if (defaultActiveFirst) {
      value = defaultActiveFirst[eventKey];
    }

    updateDefaultActiveFirst(store, eventKey, value);
    return _this;
  }

  _createClass$f(SubMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var _this$props7 = this.props,
          mode = _this$props7.mode,
          parentMenu = _this$props7.parentMenu,
          manualRef = _this$props7.manualRef; // invoke customized ref to expose component to mixin

      if (manualRef) {
        manualRef(this);
      }

      if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
        return;
      }

      this.minWidthTimeout = setTimeout(function () {
        return _this2.adjustWidth();
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props8 = this.props,
          onDestroy = _this$props8.onDestroy,
          eventKey = _this$props8.eventKey;

      if (onDestroy) {
        onDestroy(eventKey);
      }
      /* istanbul ignore if */


      if (this.minWidthTimeout) {
        clearTimeout(this.minWidthTimeout);
      }
      /* istanbul ignore if */


      if (this.mouseenterTimeout) {
        clearTimeout(this.mouseenterTimeout);
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      var _this3 = this;

      var baseProps = this.getBaseProps(); // [Legacy] getMotion must be called before `haveRendered`

      var mergedMotion = this.getMotion(baseProps.mode, baseProps.visible);
      this.haveRendered = true;
      this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender; // never rendered not planning to, don't render

      if (!this.haveOpened) {
        return React__default.createElement("div", null);
      }

      var direction = baseProps.direction;
      return React__default.createElement(CSSMotion, Object.assign({
        visible: baseProps.visible
      }, mergedMotion), function (_ref) {
        var className = _ref.className,
            style = _ref.style;
        var mergedClassName = classNames$1("".concat(baseProps.prefixCls, "-sub"), className, _defineProperty$f({}, "".concat(baseProps.prefixCls, "-rtl"), direction === 'rtl'));
        return React__default.createElement(connected$1, Object.assign({}, baseProps, {
          id: _this3.internalMenuId,
          className: mergedClassName,
          style: style
        }), children);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames2;

      var props = _objectSpread$c({}, this.props);

      var isOpen = props.isOpen;
      var prefixCls = this.getPrefixCls();
      var isInlineMode = props.mode === 'inline';
      var className = classNames$1(prefixCls, "".concat(prefixCls, "-").concat(props.mode), (_classNames2 = {}, _defineProperty$f(_classNames2, props.className, !!props.className), _defineProperty$f(_classNames2, this.getOpenClassName(), isOpen), _defineProperty$f(_classNames2, this.getActiveClassName(), props.active || isOpen && !isInlineMode), _defineProperty$f(_classNames2, this.getDisabledClassName(), props.disabled), _defineProperty$f(_classNames2, this.getSelectedClassName(), this.isChildrenSelected()), _classNames2));

      if (!this.internalMenuId) {
        if (props.eventKey) {
          this.internalMenuId = "".concat(props.eventKey, "$Menu");
        } else {
          guid += 1;
          this.internalMenuId = "$__$".concat(guid, "$Menu");
        }
      }

      var mouseEvents = {};
      var titleClickEvents = {};
      var titleMouseEvents = {};

      if (!props.disabled) {
        mouseEvents = {
          onMouseLeave: this.onMouseLeave,
          onMouseEnter: this.onMouseEnter
        }; // only works in title, not outer li

        titleClickEvents = {
          onClick: this.onTitleClick
        };
        titleMouseEvents = {
          onMouseEnter: this.onTitleMouseEnter,
          onMouseLeave: this.onTitleMouseLeave
        };
      }

      var style = {};
      var direction = props.direction;

      if (isInlineMode) {
        if (direction === 'rtl') {
          style.paddingRight = props.inlineIndent * props.level;
        } else {
          style.paddingLeft = props.inlineIndent * props.level;
        }
      }

      var ariaOwns = {}; // only set aria-owns when menu is open
      // otherwise it would be an invalid aria-owns value
      // since corresponding node cannot be found

      if (this.props.isOpen) {
        ariaOwns = {
          'aria-owns': this.internalMenuId
        };
      } // expand custom icon should NOT be displayed in menu with horizontal mode.


      var icon = null;

      if (props.mode !== 'horizontal') {
        icon = this.props.expandIcon; // ReactNode

        if (typeof this.props.expandIcon === 'function') {
          icon = React__default.createElement(this.props.expandIcon, _objectSpread$c({}, this.props));
        }
      }

      var title = React__default.createElement("div", Object.assign({
        ref: this.saveSubMenuTitle,
        style: style,
        className: "".concat(prefixCls, "-title"),
        role: "button"
      }, titleMouseEvents, titleClickEvents, {
        "aria-expanded": isOpen
      }, ariaOwns, {
        "aria-haspopup": "true",
        title: typeof props.title === 'string' ? props.title : undefined
      }), props.title, icon || React__default.createElement("i", {
        className: "".concat(prefixCls, "-arrow")
      }));
      var children = this.renderChildren(props.children);
      var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
        return triggerNode.parentNode;
      };
      var popupPlacement = popupPlacementMap[props.mode];
      var popupAlign = props.popupOffset ? {
        offset: props.popupOffset
      } : {};
      var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
      popupClassName += direction === 'rtl' ? " ".concat(prefixCls, "-rtl") : '';
      var disabled = props.disabled,
          triggerSubMenuAction = props.triggerSubMenuAction,
          subMenuOpenDelay = props.subMenuOpenDelay,
          forceSubMenuRender = props.forceSubMenuRender,
          subMenuCloseDelay = props.subMenuCloseDelay,
          builtinPlacements = props.builtinPlacements;
      menuAllProps.forEach(function (key) {
        return delete props[key];
      }); // Set onClick to null, to ignore propagated onClick event

      delete props.onClick;
      var placement = direction === 'rtl' ? Object.assign({}, placementsRtl, builtinPlacements) : Object.assign({}, placements$1, builtinPlacements);
      delete props.direction;
      return React__default.createElement("li", Object.assign({}, props, mouseEvents, {
        className: className,
        role: "menuitem"
      }), isInlineMode && title, isInlineMode && children, !isInlineMode && React__default.createElement(Trigger, {
        prefixCls: prefixCls,
        popupClassName: classNames$1("".concat(prefixCls, "-popup"), popupClassName),
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: isOpen,
        popupAlign: popupAlign,
        popup: children,
        action: disabled ? [] : [triggerSubMenuAction],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: this.onPopupVisibleChange,
        forceRender: forceSubMenuRender
      }, title));
    }
  }]);

  return SubMenu;
}(React__default.Component);
SubMenu.defaultProps = {
  onMouseEnter: noop$2,
  onMouseLeave: noop$2,
  onTitleMouseEnter: noop$2,
  onTitleMouseLeave: noop$2,
  onTitleClick: noop$2,
  manualRef: noop$2,
  mode: 'vertical',
  title: ''
};
var connected$2 = connect(function (_ref2, _ref3) {
  var openKeys = _ref2.openKeys,
      activeKey = _ref2.activeKey,
      selectedKeys = _ref2.selectedKeys;
  var eventKey = _ref3.eventKey,
      subMenuKey = _ref3.subMenuKey;
  return {
    isOpen: openKeys.indexOf(eventKey) > -1,
    active: activeKey[subMenuKey] === eventKey,
    selectedKeys: selectedKeys
  };
})(SubMenu);
connected$2.isSubMenu = true;

function _typeof$9(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$9 = function _typeof(obj) { return typeof obj; }; } else { _typeof$9 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$9(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty$e(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$a(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$b(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$b(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$f(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$e(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$e(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$e(Constructor.prototype, protoProps); if (staticProps) _defineProperties$e(Constructor, staticProps); return Constructor; }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$8(subClass, superClass); }

function _setPrototypeOf$8(o, p) { _setPrototypeOf$8 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$8(o, p); }

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function () { var Super = _getPrototypeOf$8(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$8(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$8(this, result); }; }

function _possibleConstructorReturn$8(self, call) { if (call && (_typeof$9(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$8(self); }

function _assertThisInitialized$8(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$8(o) { _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$8(o); }
var MENUITEM_OVERFLOWED_CLASSNAME = 'menuitem-overflowed';
var FLOAT_PRECISION_ADJUST = 0.5;

var DOMWrap = /*#__PURE__*/function (_React$Component) {
  _inherits$8(DOMWrap, _React$Component);

  var _super = _createSuper$4(DOMWrap);

  function DOMWrap() {
    var _this;

    _classCallCheck$f(this, DOMWrap);

    _this = _super.apply(this, arguments);
    _this.resizeObserver = null;
    _this.mutationObserver = null; // original scroll size of the list

    _this.originalTotalWidth = 0; // copy of overflowed items

    _this.overflowedItems = []; // cache item of the original items (so we can track the size and order)

    _this.menuItemSizes = [];
    _this.state = {
      lastVisibleIndex: undefined
    }; // get all valid menuItem nodes

    _this.getMenuItemNodes = function () {
      var prefixCls = _this.props.prefixCls;
      var ul = ReactDOM.findDOMNode(_assertThisInitialized$8(_this));

      if (!ul) {
        return [];
      } // filter out all overflowed indicator placeholder


      return [].slice.call(ul.children).filter(function (node) {
        return node.className.split(' ').indexOf("".concat(prefixCls, "-overflowed-submenu")) < 0;
      });
    };

    _this.getOverflowedSubMenuItem = function (keyPrefix, overflowedItems, renderPlaceholder) {
      var _this$props = _this.props,
          overflowedIndicator = _this$props.overflowedIndicator,
          level = _this$props.level,
          mode = _this$props.mode,
          prefixCls = _this$props.prefixCls,
          theme = _this$props.theme;

      if (level !== 1 || mode !== 'horizontal') {
        return null;
      } // put all the overflowed item inside a submenu
      // with a title of overflow indicator ('...')


      var copy = _this.props.children[0];

      var _copy$props = copy.props;
          _copy$props.children;
          _copy$props.title;
          var propStyle = _copy$props.style,
          rest = _objectWithoutProperties$a(_copy$props, ["children", "title", "style"]);

      var style = _objectSpread$b({}, propStyle);

      var key = "".concat(keyPrefix, "-overflowed-indicator");
      var eventKey = "".concat(keyPrefix, "-overflowed-indicator");

      if (overflowedItems.length === 0 && renderPlaceholder !== true) {
        style = _objectSpread$b(_objectSpread$b({}, style), {}, {
          display: 'none'
        });
      } else if (renderPlaceholder) {
        style = _objectSpread$b(_objectSpread$b({}, style), {}, {
          visibility: 'hidden',
          // prevent from taking normal dom space
          position: 'absolute'
        });
        key = "".concat(key, "-placeholder");
        eventKey = "".concat(eventKey, "-placeholder");
      }

      var popupClassName = theme ? "".concat(prefixCls, "-").concat(theme) : '';
      var props = {};
      menuAllProps.forEach(function (k) {
        if (rest[k] !== undefined) {
          props[k] = rest[k];
        }
      });
      return React__default.createElement(connected$2, Object.assign({
        title: overflowedIndicator,
        className: "".concat(prefixCls, "-overflowed-submenu"),
        popupClassName: popupClassName
      }, props, {
        key: key,
        eventKey: eventKey,
        disabled: false,
        style: style
      }), overflowedItems);
    }; // memorize rendered menuSize


    _this.setChildrenWidthAndResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }

      var ul = ReactDOM.findDOMNode(_assertThisInitialized$8(_this));

      if (!ul) {
        return;
      }

      var ulChildrenNodes = ul.children;

      if (!ulChildrenNodes || ulChildrenNodes.length === 0) {
        return;
      }

      var lastOverflowedIndicatorPlaceholder = ul.children[ulChildrenNodes.length - 1]; // need last overflowed indicator for calculating length;

      setStyle(lastOverflowedIndicatorPlaceholder, 'display', 'inline-block');

      var menuItemNodes = _this.getMenuItemNodes(); // reset display attribute for all hidden elements caused by overflow to calculate updated width
      // and then reset to original state after width calculation


      var overflowedItems = menuItemNodes.filter(function (c) {
        return c.className.split(' ').indexOf(MENUITEM_OVERFLOWED_CLASSNAME) >= 0;
      });
      overflowedItems.forEach(function (c) {
        setStyle(c, 'display', 'inline-block');
      });
      _this.menuItemSizes = menuItemNodes.map(function (c) {
        return getWidth(c);
      });
      overflowedItems.forEach(function (c) {
        setStyle(c, 'display', 'none');
      });
      _this.overflowedIndicatorWidth = getWidth(ul.children[ul.children.length - 1]);
      _this.originalTotalWidth = _this.menuItemSizes.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);

      _this.handleResize(); // prevent the overflowed indicator from taking space;


      setStyle(lastOverflowedIndicatorPlaceholder, 'display', 'none');
    };

    _this.handleResize = function () {
      if (_this.props.mode !== 'horizontal') {
        return;
      }

      var ul = ReactDOM.findDOMNode(_assertThisInitialized$8(_this));

      if (!ul) {
        return;
      }

      var width = getWidth(ul);
      _this.overflowedItems = [];
      var currentSumWidth = 0; // index for last visible child in horizontal mode

      var lastVisibleIndex; // float number comparison could be problematic
      // e.g. 0.1 + 0.2 > 0.3 =====> true
      // thus using FLOAT_PRECISION_ADJUST as buffer to help the situation

      if (_this.originalTotalWidth > width + FLOAT_PRECISION_ADJUST) {
        lastVisibleIndex = -1;

        _this.menuItemSizes.forEach(function (liWidth) {
          currentSumWidth += liWidth;

          if (currentSumWidth + _this.overflowedIndicatorWidth <= width) {
            lastVisibleIndex += 1;
          }
        });
      }

      _this.setState({
        lastVisibleIndex: lastVisibleIndex
      });
    };

    return _this;
  }

  _createClass$e(DOMWrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setChildrenWidthAndResize();

      if (this.props.level === 1 && this.props.mode === 'horizontal') {
        var menuUl = ReactDOM.findDOMNode(this);

        if (!menuUl) {
          return;
        }

        this.resizeObserver = new index$3(function (entries) {
          entries.forEach(_this2.setChildrenWidthAndResize);
        });
        [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
          _this2.resizeObserver.observe(el);
        });

        if (typeof MutationObserver !== 'undefined') {
          this.mutationObserver = new MutationObserver(function () {
            _this2.resizeObserver.disconnect();

            [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
              _this2.resizeObserver.observe(el);
            });

            _this2.setChildrenWidthAndResize();
          });
          this.mutationObserver.observe(menuUl, {
            attributes: false,
            childList: true,
            subTree: false
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      var _this3 = this;

      // need to take care of overflowed items in horizontal mode
      var lastVisibleIndex = this.state.lastVisibleIndex;
      return (children || []).reduce(function (acc, childNode, index) {
        var item = childNode;

        if (_this3.props.mode === 'horizontal') {
          var overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, []);

          if (lastVisibleIndex !== undefined && _this3.props.className.indexOf("".concat(_this3.props.prefixCls, "-root")) !== -1) {
            if (index > lastVisibleIndex) {
              item = React__default.cloneElement(childNode, // 这里修改 eventKey 是为了防止隐藏状态下还会触发 openkeys 事件
              {
                style: {
                  display: 'none'
                },
                eventKey: "".concat(childNode.props.eventKey, "-hidden"),

                /**
                 * Legacy code. Here `className` never used:
                 * https://github.com/react-component/menu/commit/4cd6b49fce9d116726f4ea00dda85325d6f26500#diff-e2fa48f75c2dd2318295cde428556a76R240
                 */
                className: "".concat(MENUITEM_OVERFLOWED_CLASSNAME)
              });
            }

            if (index === lastVisibleIndex + 1) {
              _this3.overflowedItems = children.slice(lastVisibleIndex + 1).map(function (c) {
                return React__default.cloneElement(c, // children[index].key will become '.$key' in clone by default,
                // we have to overwrite with the correct key explicitly
                {
                  key: c.props.eventKey,
                  mode: 'vertical-left'
                });
              });
              overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, _this3.overflowedItems);
            }
          }

          var ret = [].concat(_toConsumableArray(acc), [overflowed, item]);

          if (index === children.length - 1) {
            // need a placeholder for calculating overflowed indicator width
            ret.push(_this3.getOverflowedSubMenuItem(childNode.props.eventKey, [], true));
          }

          return ret;
        }

        return [].concat(_toConsumableArray(acc), [item]);
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props;
          _this$props2.visible;
          _this$props2.prefixCls;
          _this$props2.overflowedIndicator;
          _this$props2.mode;
          _this$props2.level;
          var tag = _this$props2.tag,
          children = _this$props2.children;
          _this$props2.theme;
          var rest = _objectWithoutProperties$a(_this$props2, ["visible", "prefixCls", "overflowedIndicator", "mode", "level", "tag", "children", "theme"]);

      var Tag = tag;
      return React__default.createElement(Tag, Object.assign({}, rest), this.renderChildren(children));
    }
  }]);

  return DOMWrap;
}(React__default.Component);

DOMWrap.defaultProps = {
  tag: 'div',
  className: ''
};

function _typeof$8(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$8 = function _typeof(obj) { return typeof obj; }; } else { _typeof$8 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$8(obj); }

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function _classCallCheck$e(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$d(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$d(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$d(Constructor.prototype, protoProps); if (staticProps) _defineProperties$d(Constructor, staticProps); return Constructor; }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$7(subClass, superClass); }

function _setPrototypeOf$7(o, p) { _setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$7(o, p); }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function () { var Super = _getPrototypeOf$7(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$7(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$7(this, result); }; }

function _possibleConstructorReturn$7(self, call) { if (call && (_typeof$8(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$7(self); }

function _assertThisInitialized$7(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$7(o) { _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$7(o); }

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function allDisabled(arr) {
  if (!arr.length) {
    return true;
  }

  return arr.every(function (c) {
    return !!c.props.disabled;
  });
}

function updateActiveKey(store, menuId, activeKey) {
  var state = store.getState();
  store.setState({
    activeKey: _objectSpread$a(_objectSpread$a({}, state.activeKey), {}, _defineProperty$d({}, menuId, activeKey))
  });
}

function getEventKey(props) {
  // when eventKey not available ,it's menu and return menu id '0-menu-'
  return props.eventKey || '0-menu-';
}

function getActiveKey(props, originalActiveKey) {
  var activeKey = originalActiveKey;
  var children = props.children,
      eventKey = props.eventKey;

  if (activeKey) {
    var found;
    loopMenuItem(children, function (c, i) {
      if (c && c.props && !c.props.disabled && activeKey === getKeyFromChildrenIndex(c, eventKey, i)) {
        found = true;
      }
    });

    if (found) {
      return activeKey;
    }
  }

  activeKey = null;

  if (props.defaultActiveFirst) {
    loopMenuItem(children, function (c, i) {
      if (!activeKey && c && !c.props.disabled) {
        activeKey = getKeyFromChildrenIndex(c, eventKey, i);
      }
    });
    return activeKey;
  }

  return activeKey;
}
function saveRef(c) {
  if (c) {
    var index = this.instanceArray.indexOf(c);

    if (index !== -1) {
      // update component if it's already inside instanceArray
      this.instanceArray[index] = c;
    } else {
      // add component if it's not in instanceArray yet;
      this.instanceArray.push(c);
    }
  }
}
var SubPopupMenu = /*#__PURE__*/function (_React$Component) {
  _inherits$7(SubPopupMenu, _React$Component);

  var _super = _createSuper$3(SubPopupMenu);

  function SubPopupMenu(props) {
    var _this;

    _classCallCheck$e(this, SubPopupMenu);

    _this = _super.call(this, props);
    /**
     * all keyboard events callbacks run from here at first
     *
     * note:
     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
     *  which need return code to check if this event is handled
     */

    _this.onKeyDown = function (e, callback) {
      var keyCode = e.keyCode;
      var handled;

      _this.getFlatInstanceArray().forEach(function (obj) {
        if (obj && obj.props.active && obj.onKeyDown) {
          handled = obj.onKeyDown(e);
        }
      });

      if (handled) {
        return 1;
      }

      var activeItem = null;

      if (keyCode === KeyCode.UP || keyCode === KeyCode.DOWN) {
        activeItem = _this.step(keyCode === KeyCode.UP ? -1 : 1);
      }

      if (activeItem) {
        e.preventDefault();
        updateActiveKey(_this.props.store, getEventKey(_this.props), activeItem.props.eventKey);

        if (typeof callback === 'function') {
          callback(activeItem);
        }

        return 1;
      }

      return undefined;
    };

    _this.onItemHover = function (e) {
      var key = e.key,
          hover = e.hover;
      updateActiveKey(_this.props.store, getEventKey(_this.props), hover ? key : null);
    };

    _this.onDeselect = function (selectInfo) {
      _this.props.onDeselect(selectInfo);
    };

    _this.onSelect = function (selectInfo) {
      _this.props.onSelect(selectInfo);
    };

    _this.onClick = function (e) {
      _this.props.onClick(e);
    };

    _this.onOpenChange = function (e) {
      _this.props.onOpenChange(e);
    };

    _this.onDestroy = function (key) {
      /* istanbul ignore next */
      _this.props.onDestroy(key);
    };

    _this.getFlatInstanceArray = function () {
      return _this.instanceArray;
    };

    _this.step = function (direction) {
      var children = _this.getFlatInstanceArray();

      var activeKey = _this.props.store.getState().activeKey[getEventKey(_this.props)];

      var len = children.length;

      if (!len) {
        return null;
      }

      if (direction < 0) {
        children = children.concat().reverse();
      } // find current activeIndex


      var activeIndex = -1;
      children.every(function (c, ci) {
        if (c && c.props.eventKey === activeKey) {
          activeIndex = ci;
          return false;
        }

        return true;
      });

      if (!_this.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
        return undefined;
      }

      var start = (activeIndex + 1) % len;
      var i = start;

      do {
        var child = children[i];

        if (!child || child.props.disabled) {
          i = (i + 1) % len;
        } else {
          return child;
        }
      } while (i !== start);

      return null;
    };

    _this.renderCommonMenuItem = function (child, i, extraProps) {
      var state = _this.props.store.getState();

      var _assertThisInitialize = _assertThisInitialized$7(_this),
          props = _assertThisInitialize.props;

      var key = getKeyFromChildrenIndex(child, props.eventKey, i);
      var childProps = child.props; // https://github.com/ant-design/ant-design/issues/11517#issuecomment-477403055

      if (!childProps || typeof child.type === 'string') {
        return child;
      }

      var isActive = key === state.activeKey;

      var newChildProps = _objectSpread$a(_objectSpread$a({
        mode: childProps.mode || props.mode,
        level: props.level,
        inlineIndent: props.inlineIndent,
        renderMenuItem: _this.renderMenuItem,
        rootPrefixCls: props.prefixCls,
        index: i,
        parentMenu: props.parentMenu,
        // customized ref function, need to be invoked manually in child's componentDidMount
        manualRef: childProps.disabled ? undefined : createChainedFunction(child.ref, saveRef.bind(_assertThisInitialized$7(_this))),
        eventKey: key,
        active: !childProps.disabled && isActive,
        multiple: props.multiple,
        onClick: function onClick(e) {
          (childProps.onClick || noop$2)(e);

          _this.onClick(e);
        },
        onItemHover: _this.onItemHover,
        motion: props.motion,
        subMenuOpenDelay: props.subMenuOpenDelay,
        subMenuCloseDelay: props.subMenuCloseDelay,
        forceSubMenuRender: props.forceSubMenuRender,
        onOpenChange: _this.onOpenChange,
        onDeselect: _this.onDeselect,
        onSelect: _this.onSelect,
        builtinPlacements: props.builtinPlacements,
        itemIcon: childProps.itemIcon || _this.props.itemIcon,
        expandIcon: childProps.expandIcon || _this.props.expandIcon
      }, extraProps), {}, {
        direction: props.direction
      }); // ref: https://github.com/ant-design/ant-design/issues/13943


      if (props.mode === 'inline' || isMobileDevice()) {
        newChildProps.triggerSubMenuAction = 'click';
      }

      return React__default.cloneElement(child, newChildProps);
    };

    _this.renderMenuItem = function (c, i, subMenuKey) {
      /* istanbul ignore if */
      if (!c) {
        return null;
      }

      var state = _this.props.store.getState();

      var extraProps = {
        openKeys: state.openKeys,
        selectedKeys: state.selectedKeys,
        triggerSubMenuAction: _this.props.triggerSubMenuAction,
        subMenuKey: subMenuKey
      };
      return _this.renderCommonMenuItem(c, i, extraProps);
    };

    props.store.setState({
      activeKey: _objectSpread$a(_objectSpread$a({}, props.store.getState().activeKey), {}, _defineProperty$d({}, props.eventKey, getActiveKey(props, props.activeKey)))
    });
    _this.instanceArray = [];
    return _this;
  }

  _createClass$d(SubPopupMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // invoke customized ref to expose component to mixin
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.visible || nextProps.visible || this.props.className !== nextProps.className || !shallowEqual(this.props.style, nextProps.style);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;
      var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
      var activeKey = getActiveKey(props, originalActiveKey);

      if (activeKey !== originalActiveKey) {
        updateActiveKey(props.store, getEventKey(props), activeKey);
      } else if ('activeKey' in prevProps) {
        // If prev activeKey is not same as current activeKey,
        // we should set it.
        var prevActiveKey = getActiveKey(prevProps, prevProps.activeKey);

        if (activeKey !== prevActiveKey) {
          updateActiveKey(props.store, getEventKey(props), activeKey);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = _extends$c({}, this.props);

      this.instanceArray = [];
      var className = classNames$1(props.prefixCls, props.className, "".concat(props.prefixCls, "-").concat(props.mode));
      var domProps = {
        className: className,
        // role could be 'select' and by default set to menu
        role: props.role || 'menu'
      };

      if (props.id) {
        domProps.id = props.id;
      }

      if (props.focusable) {
        domProps.tabIndex = 0;
        domProps.onKeyDown = this.onKeyDown;
      }

      var prefixCls = props.prefixCls,
          eventKey = props.eventKey,
          visible = props.visible,
          level = props.level,
          mode = props.mode,
          overflowedIndicator = props.overflowedIndicator,
          theme = props.theme;
      menuAllProps.forEach(function (key) {
        return delete props[key];
      }); // Otherwise, the propagated click event will trigger another onClick

      delete props.onClick;
      return React__default.createElement(DOMWrap, Object.assign({}, props, {
        prefixCls: prefixCls,
        mode: mode,
        tag: "ul",
        level: level,
        theme: theme,
        visible: visible,
        overflowedIndicator: overflowedIndicator
      }, domProps), React__default.Children.map(props.children, function (c, i) {
        return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
      }));
    }
  }]);

  return SubPopupMenu;
}(React__default.Component);
SubPopupMenu.defaultProps = {
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  level: 1,
  inlineIndent: 24,
  visible: true,
  focusable: true,
  style: {},
  manualRef: noop$2
};
var connected$1 = connect()(SubPopupMenu);

/* eslint-disable no-console */
var warned = {};
function warning$2(valid, message) {
  // Support uglify
  if (process.env.NODE_ENV !== 'production' && !valid && console !== undefined) {
    console.error("Warning: ".concat(message));
  }
}
function call$2(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call$2(warning$2, valid, message);
}
/* eslint-enable */

function _typeof$7(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$7 = function _typeof(obj) { return typeof obj; }; } else { _typeof$7 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$7(obj); }
function getMotion(_ref) {
  var prefixCls = _ref.prefixCls,
      motion = _ref.motion,
      openAnimation = _ref.openAnimation,
      openTransitionName = _ref.openTransitionName;

  if (motion) {
    return motion;
  }

  if (_typeof$7(openAnimation) === 'object' && openAnimation) {
    warningOnce(false, 'Object type of `openAnimation` is removed. Please use `motion` instead.');
  } else if (typeof openAnimation === 'string') {
    return {
      motionName: "".concat(prefixCls, "-open-").concat(openAnimation)
    };
  }

  if (openTransitionName) {
    return {
      motionName: openTransitionName
    };
  }

  return null;
}

function _typeof$6(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$c(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$c(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$c(Constructor.prototype, protoProps); if (staticProps) _defineProperties$c(Constructor, staticProps); return Constructor; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$6(subClass, superClass); }

function _setPrototypeOf$6(o, p) { _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$6(o, p); }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function () { var Super = _getPrototypeOf$6(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$6(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$6(this, result); }; }

function _possibleConstructorReturn$6(self, call) { if (call && (_typeof$6(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$6(self); }

function _assertThisInitialized$6(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$6(o) { _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$6(o); }

var Menu = /*#__PURE__*/function (_React$Component) {
  _inherits$6(Menu, _React$Component);

  var _super = _createSuper$2(Menu);

  function Menu(props) {
    var _this;

    _classCallCheck$d(this, Menu);

    _this = _super.call(this, props);

    _this.onSelect = function (selectInfo) {
      var _assertThisInitialize = _assertThisInitialized$6(_this),
          props = _assertThisInitialize.props;

      if (props.selectable) {
        // root menu
        var _this$store$getState = _this.store.getState(),
            _selectedKeys = _this$store$getState.selectedKeys;

        var selectedKey = selectInfo.key;

        if (props.multiple) {
          _selectedKeys = _selectedKeys.concat([selectedKey]);
        } else {
          _selectedKeys = [selectedKey];
        }

        if (!('selectedKeys' in props)) {
          _this.store.setState({
            selectedKeys: _selectedKeys
          });
        }

        props.onSelect(_objectSpread$9(_objectSpread$9({}, selectInfo), {}, {
          selectedKeys: _selectedKeys
        }));
      }
    };

    _this.onClick = function (e) {
      _this.props.onClick(e);
    }; // onKeyDown needs to be exposed as a instance method
    // e.g., in rc-select, we need to navigate menu item while
    // current active item is rc-select input box rather than the menu itself


    _this.onKeyDown = function (e, callback) {
      _this.innerMenu.getWrappedInstance().onKeyDown(e, callback);
    };

    _this.onOpenChange = function (event) {
      var _assertThisInitialize2 = _assertThisInitialized$6(_this),
          props = _assertThisInitialize2.props;

      var openKeys = _this.store.getState().openKeys.concat();

      var changed = false;

      var processSingle = function processSingle(e) {
        var oneChanged = false;

        if (e.open) {
          oneChanged = openKeys.indexOf(e.key) === -1;

          if (oneChanged) {
            openKeys.push(e.key);
          }
        } else {
          var index = openKeys.indexOf(e.key);
          oneChanged = index !== -1;

          if (oneChanged) {
            openKeys.splice(index, 1);
          }
        }

        changed = changed || oneChanged;
      };

      if (Array.isArray(event)) {
        // batch change call
        event.forEach(processSingle);
      } else {
        processSingle(event);
      }

      if (changed) {
        if (!('openKeys' in _this.props)) {
          _this.store.setState({
            openKeys: openKeys
          });
        }

        props.onOpenChange(openKeys);
      }
    };

    _this.onDeselect = function (selectInfo) {
      var _assertThisInitialize3 = _assertThisInitialized$6(_this),
          props = _assertThisInitialize3.props;

      if (props.selectable) {
        var _selectedKeys2 = _this.store.getState().selectedKeys.concat();

        var selectedKey = selectInfo.key;

        var index = _selectedKeys2.indexOf(selectedKey);

        if (index !== -1) {
          _selectedKeys2.splice(index, 1);
        }

        if (!('selectedKeys' in props)) {
          _this.store.setState({
            selectedKeys: _selectedKeys2
          });
        }

        props.onDeselect(_objectSpread$9(_objectSpread$9({}, selectInfo), {}, {
          selectedKeys: _selectedKeys2
        }));
      }
    };

    _this.getOpenTransitionName = function () {
      var _assertThisInitialize4 = _assertThisInitialized$6(_this),
          props = _assertThisInitialize4.props;

      var transitionName = props.openTransitionName;
      var animationName = props.openAnimation;

      if (!transitionName && typeof animationName === 'string') {
        transitionName = "".concat(props.prefixCls, "-open-").concat(animationName);
      }

      return transitionName;
    };

    _this.setInnerMenu = function (node) {
      _this.innerMenu = node;
    };

    _this.isRootMenu = true;
    var selectedKeys = props.defaultSelectedKeys;
    var openKeys = props.defaultOpenKeys;

    if ('selectedKeys' in props) {
      selectedKeys = props.selectedKeys || [];
    }

    if ('openKeys' in props) {
      openKeys = props.openKeys || [];
    }

    _this.store = create({
      selectedKeys: selectedKeys,
      openKeys: openKeys,
      activeKey: {
        '0-menu-': getActiveKey(props, props.activeKey)
      }
    });
    return _this;
  }

  _createClass$c(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateMiniStore();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateMiniStore();
    }
  }, {
    key: "updateMiniStore",
    value: function updateMiniStore() {
      if ('selectedKeys' in this.props) {
        this.store.setState({
          selectedKeys: this.props.selectedKeys || []
        });
      }

      if ('openKeys' in this.props) {
        this.store.setState({
          openKeys: this.props.openKeys || []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = _objectSpread$9({}, this.props);

      props.className += " ".concat(props.prefixCls, "-root");

      if (props.direction === 'rtl') {
        props.className += " ".concat(props.prefixCls, "-rtl");
      }

      props = _objectSpread$9(_objectSpread$9({}, props), {}, {
        onClick: this.onClick,
        onOpenChange: this.onOpenChange,
        onDeselect: this.onDeselect,
        onSelect: this.onSelect,
        parentMenu: this,
        motion: getMotion(this.props)
      });
      delete props.openAnimation;
      delete props.openTransitionName;
      return React__default.createElement(Provider, {
        store: this.store
      }, React__default.createElement(connected$1, Object.assign({}, props, {
        ref: this.setInnerMenu
      }), this.props.children));
    }
  }]);

  return Menu;
}(React__default.Component);

Menu.defaultProps = {
  selectable: true,
  onClick: noop$2,
  onSelect: noop$2,
  onOpenChange: noop$2,
  onDeselect: noop$2,
  defaultSelectedKeys: [],
  defaultOpenKeys: [],
  subMenuOpenDelay: 0.1,
  subMenuCloseDelay: 0.1,
  triggerSubMenuAction: 'hover',
  prefixCls: 'rc-menu',
  className: '',
  mode: 'vertical',
  style: {},
  builtinPlacements: {},
  overflowedIndicator: React__default.createElement("span", null, "\xB7\xB7\xB7")
};

function t(t){return "object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return (!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return !!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return !1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}function compute(e,i){var o=window,l=i.scrollMode,d=i.block,u=i.inline,h=i.boundary,a=i.skipOverflowHiddenElements,c="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var f=document.scrollingElement||document.documentElement,s=[],p=e;t(p)&&c(p);){if((p=p.parentElement)===f){s.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,a)&&s.push(p);}for(var m=o.visualViewport?o.visualViewport.width:innerWidth,g=o.visualViewport?o.visualViewport.height:innerHeight,w=window.scrollX||pageXOffset,v=window.scrollY||pageYOffset,W=e.getBoundingClientRect(),b=W.height,H=W.width,y=W.top,E=W.right,M=W.bottom,V=W.left,x="start"===d||"nearest"===d?y:"end"===d?M:y+b/2,I="center"===u?V+H/2:"end"===u?E:V,C=[],T=0;T<s.length;T++){var k=s[T],B=k.getBoundingClientRect(),D=B.height,O=B.width,R=B.top,X=B.right,Y=B.bottom,L=B.left;if("if-needed"===l&&y>=0&&V>=0&&M<=g&&E<=m&&y>=R&&M<=Y&&V>=L&&E<=X)return C;var S=getComputedStyle(k),j=parseInt(S.borderLeftWidth,10),q=parseInt(S.borderTopWidth,10),z=parseInt(S.borderRightWidth,10),A=parseInt(S.borderBottomWidth,10),F=0,G=0,J="offsetWidth"in k?k.offsetWidth-k.clientWidth-j-z:0,K="offsetHeight"in k?k.offsetHeight-k.clientHeight-q-A:0;if(f===k)F="start"===d?x:"end"===d?x-g:"nearest"===d?r(v,v+g,g,q,A,v+x,v+x+b,b):x-g/2,G="start"===u?I:"center"===u?I-m/2:"end"===u?I-m:r(w,w+m,m,j,z,w+I,w+I+H,H),F=Math.max(0,F+v),G=Math.max(0,G+w);else {F="start"===d?x-R-q:"end"===d?x-Y+A+K:"nearest"===d?r(R,Y,D,q,A+K,x,x+b,b):x-(R+D/2)+K/2,G="start"===u?I-L-j:"center"===u?I-(L+O/2)+J/2:"end"===u?I-X+z+J:r(L,X,O,j,z+J,I,I+H,H);var N=k.scrollLeft,P=k.scrollTop;x+=P-(F=Math.max(0,Math.min(P+F,k.scrollHeight-D+K))),I+=N-(G=Math.max(0,Math.min(N+G,k.scrollWidth-O+J)));}C.push({el:k,top:F,left:G});}return C}

function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}

function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }

  var canSmoothScroll = ('scrollBehavior' in document.body.style);
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;

    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}

function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }

  if (isOptionsObject(options)) {
    return options;
  }

  return {
    block: 'start',
    inline: 'nearest'
  };
}

function scrollIntoView(target, options) {
  var targetIsDetached = !target.ownerDocument.documentElement.contains(target);

  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(targetIsDetached ? [] : compute(target, options));
  }

  if (targetIsDetached) {
    return;
  }

  var computeOptions = getOptions(options);
  return defaultBehavior(compute(target, computeOptions), computeOptions.behavior);
}

function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$b(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$b(Constructor.prototype, protoProps); if (staticProps) _defineProperties$b(Constructor, staticProps); return Constructor; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$5(subClass, superClass); }

function _setPrototypeOf$5(o, p) { _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$5(o, p); }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function () { var Super = _getPrototypeOf$5(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$5(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$5(this, result); }; }

function _possibleConstructorReturn$5(self, call) { if (call && (_typeof$5(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$5(self); }

function _assertThisInitialized$5(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$5(o) { _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$5(o); }
var MenuItem$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$5(MenuItem, _React$Component);

  var _super = _createSuper$1(MenuItem);

  function MenuItem() {
    var _this;

    _classCallCheck$c(this, MenuItem);

    _this = _super.apply(this, arguments);

    _this.onKeyDown = function (e) {
      var keyCode = e.keyCode;

      if (keyCode === KeyCode.ENTER) {
        _this.onClick(e);

        return true;
      }

      return undefined;
    };

    _this.onMouseLeave = function (e) {
      var _this$props = _this.props,
          eventKey = _this$props.eventKey,
          onItemHover = _this$props.onItemHover,
          onMouseLeave = _this$props.onMouseLeave;
      onItemHover({
        key: eventKey,
        hover: false
      });
      onMouseLeave({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onMouseEnter = function (e) {
      var _this$props2 = _this.props,
          eventKey = _this$props2.eventKey,
          onItemHover = _this$props2.onItemHover,
          onMouseEnter = _this$props2.onMouseEnter;
      onItemHover({
        key: eventKey,
        hover: true
      });
      onMouseEnter({
        key: eventKey,
        domEvent: e
      });
    };

    _this.onClick = function (e) {
      var _this$props3 = _this.props,
          eventKey = _this$props3.eventKey,
          multiple = _this$props3.multiple,
          onClick = _this$props3.onClick,
          onSelect = _this$props3.onSelect,
          onDeselect = _this$props3.onDeselect,
          isSelected = _this$props3.isSelected;
      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: _assertThisInitialized$5(_this),
        domEvent: e
      };
      onClick(info);

      if (multiple) {
        if (isSelected) {
          onDeselect(info);
        } else {
          onSelect(info);
        }
      } else if (!isSelected) {
        onSelect(info);
      }
    };

    _this.saveNode = function (node) {
      _this.node = node;
    };

    return _this;
  }

  _createClass$b(MenuItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // invoke customized ref to expose component to mixin
      this.callRef();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          active = _this$props4.active,
          parentMenu = _this$props4.parentMenu,
          eventKey = _this$props4.eventKey; // 在 parentMenu 上层保存滚动状态，避免重复的 MenuItem key 导致滚动跳动
      // https://github.com/ant-design/ant-design/issues/16181

      if (!prevProps.active && active && (!parentMenu || !parentMenu["scrolled-".concat(eventKey)])) {
        if (this.node) {
          scrollIntoView(this.node, {
            scrollMode: 'if-needed',
            // eslint-disable-next-line react/no-find-dom-node
            boundary: ReactDOM.findDOMNode(parentMenu),
            block: 'nearest'
          });
          parentMenu["scrolled-".concat(eventKey)] = true;
        }
      } else if (parentMenu && parentMenu["scrolled-".concat(eventKey)]) {
        delete parentMenu["scrolled-".concat(eventKey)];
      }

      this.callRef();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var props = this.props;

      if (props.onDestroy) {
        props.onDestroy(props.eventKey);
      }
    }
  }, {
    key: "getPrefixCls",
    value: function getPrefixCls() {
      return "".concat(this.props.rootPrefixCls, "-item");
    }
  }, {
    key: "getActiveClassName",
    value: function getActiveClassName() {
      return "".concat(this.getPrefixCls(), "-active");
    }
  }, {
    key: "getSelectedClassName",
    value: function getSelectedClassName() {
      return "".concat(this.getPrefixCls(), "-selected");
    }
  }, {
    key: "getDisabledClassName",
    value: function getDisabledClassName() {
      return "".concat(this.getPrefixCls(), "-disabled");
    }
  }, {
    key: "callRef",
    value: function callRef() {
      if (this.props.manualRef) {
        this.props.manualRef(this);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var props = _objectSpread$8({}, this.props);

      var className = classNames$1(this.getPrefixCls(), props.className, (_classNames = {}, _defineProperty$b(_classNames, this.getActiveClassName(), !props.disabled && props.active), _defineProperty$b(_classNames, this.getSelectedClassName(), props.isSelected), _defineProperty$b(_classNames, this.getDisabledClassName(), props.disabled), _classNames));

      var attrs = _objectSpread$8(_objectSpread$8({}, props.attribute), {}, {
        title: props.title,
        className: className,
        // set to menuitem by default
        role: props.role || 'menuitem',
        'aria-disabled': props.disabled
      });

      if (props.role === 'option') {
        // overwrite to option
        attrs = _objectSpread$8(_objectSpread$8({}, attrs), {}, {
          role: 'option',
          'aria-selected': props.isSelected
        });
      } else if (props.role === null || props.role === 'none') {
        // sometimes we want to specify role inside <li/> element
        // <li><a role='menuitem'>Link</a></li> would be a good example
        // in this case the role on <li/> should be "none" to
        // remove the implied listitem role.
        // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
        attrs.role = 'none';
      } // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner


      var mouseEvent = {
        onClick: props.disabled ? null : this.onClick,
        onMouseLeave: props.disabled ? null : this.onMouseLeave,
        onMouseEnter: props.disabled ? null : this.onMouseEnter
      };

      var style = _objectSpread$8({}, props.style);

      if (props.mode === 'inline') {
        if (props.direction === 'rtl') {
          style.paddingRight = props.inlineIndent * props.level;
        } else {
          style.paddingLeft = props.inlineIndent * props.level;
        }
      }

      menuAllProps.forEach(function (key) {
        return delete props[key];
      });
      delete props.direction;
      var icon = this.props.itemIcon;

      if (typeof this.props.itemIcon === 'function') {
        // TODO: This is a bug which should fixed after TS refactor
        icon = React__default.createElement(this.props.itemIcon, this.props);
      }

      return React__default.createElement("li", Object.assign({}, props, attrs, mouseEvent, {
        style: style,
        ref: this.saveNode
      }), props.children, icon);
    }
  }]);

  return MenuItem;
}(React__default.Component);
MenuItem$1.isMenuItem = true;
MenuItem$1.defaultProps = {
  onSelect: noop$2,
  onMouseEnter: noop$2,
  onMouseLeave: noop$2,
  manualRef: noop$2
};
var connected = connect(function (_ref, _ref2) {
  var activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    active: activeKey[subMenuKey] === eventKey,
    isSelected: selectedKeys.indexOf(eventKey) !== -1
  };
})(MenuItem$1);

function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); if (staticProps) _defineProperties$a(Constructor, staticProps); return Constructor; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$4(subClass, superClass); }

function _setPrototypeOf$4(o, p) { _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$4(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf$4(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$4(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$4(this, result); }; }

function _possibleConstructorReturn$4(self, call) { if (call && (_typeof$4(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$4(self); }

function _assertThisInitialized$4(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$4(o) { _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$4(o); }

var MenuItemGroup = /*#__PURE__*/function (_React$Component) {
  _inherits$4(MenuItemGroup, _React$Component);

  var _super = _createSuper(MenuItemGroup);

  function MenuItemGroup() {
    var _this;

    _classCallCheck$b(this, MenuItemGroup);

    _this = _super.apply(this, arguments);

    _this.renderInnerMenuItem = function (item) {
      var _this$props = _this.props,
          renderMenuItem = _this$props.renderMenuItem,
          index = _this$props.index;
      return renderMenuItem(item, index, _this.props.subMenuKey);
    };

    return _this;
  }

  _createClass$a(MenuItemGroup, [{
    key: "render",
    value: function render() {
      var props = _extends$b({}, this.props);

      var _props$className = props.className,
          className = _props$className === void 0 ? '' : _props$className,
          rootPrefixCls = props.rootPrefixCls;
      var titleClassName = "".concat(rootPrefixCls, "-item-group-title");
      var listClassName = "".concat(rootPrefixCls, "-item-group-list");
      var title = props.title,
          children = props.children;
      menuAllProps.forEach(function (key) {
        return delete props[key];
      }); // Set onClick to null, to ignore propagated onClick event

      delete props.onClick;
      delete props.direction;
      return React__default.createElement("li", Object.assign({}, props, {
        className: "".concat(className, " ").concat(rootPrefixCls, "-item-group")
      }), React__default.createElement("div", {
        className: titleClassName,
        title: typeof title === 'string' ? title : undefined
      }, title), React__default.createElement("ul", {
        className: listClassName
      }, React__default.Children.map(children, this.renderInnerMenuItem)));
    }
  }]);

  return MenuItemGroup;
}(React__default.Component);

MenuItemGroup.isMenuItemGroup = true;
MenuItemGroup.defaultProps = {
  disabled: true
};

var Divider = function Divider(_ref) {
  var className = _ref.className,
      rootPrefixCls = _ref.rootPrefixCls,
      style = _ref.style;
  return React__default.createElement("li", {
    className: "".concat(className, " ").concat(rootPrefixCls, "-item-divider"),
    style: style
  });
};

Divider.defaultProps = {
  // To fix keyboard UX.
  disabled: true,
  className: '',
  style: {}
};

var _templateObject$q, _templateObject2$l, _templateObject3$f, _templateObject4$a, _templateObject5$9, _templateObject6$6, _templateObject7$3, _templateObject8$2;
/**
 *
 *  Keyframes
 *
 */

var rcMenuOpenSlideUpIn = keyframes$2(["0%{opacity:0;transform-origin:0% 0%;transform:scaleY(0);}100%{opacity:1;transform-origin:0% 0%;transform:scaleY(1);}"]);
var rcMenuOpenSlideUpOut = keyframes$2(["0%{opacity:1;transform-origin:0% 0%;transform:scaleY(1);}100%{opacity:0;transform-origin:0% 0%;transform:scaleY(0);}"]);
/**
 *
 * Returns the component specific className provided by styled-components
 *
 */

var prefix = function prefix(props) {
  return props.rootPrefixCls ? props.rootPrefixCls.split(' ')[1] : '';
};

var effect = function effect() {
  return css$4(["animation-duration:0.3s;animation-fill-mode:both;transform-origin:0 0;"]);
};

var StyledMenuLabel = styled.span(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral$1(["\n\tvertical-align: middle;\n"])));
var MenuIconPlaceholder = styled.span(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral$1(["\n\tvertical-align: middle;\n\tdisplay: inline-block;\n\twidth: ", ";\n\theight: ", ";\n"])), function (_ref) {
  var mode = _ref.mode;
  return mode === 'horizontal' ? '0px' : '24px';
}, function (_ref2) {
  var mode = _ref2.mode;
  return mode === 'horizontal' ? '0px' : '20px';
});
var MenuIcon = styled(Wrapper$Z).attrs(function (props) {
  return {
    color: props.theme.menuIconColor
  };
})(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral$1(["\n\tvertical-align: middle;\n\tdisplay: inline-block;\n\twidth: 20px;\n\theight: 20px;\n\tmargin-right: 6px;\n"])));
/**
 *
 * Menu Item
 *
 */

var StyledMenuItem = styled(connected)(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral$1(["\n\tcursor: pointer;\n\tmargin: 0;\n\tposition: relative;\n\tdisplay: ", ";\n\twhite-space: nowrap;\n\tpadding: 12px 15px 10px 15px;\n\tuser-select: none;\n\tcolor: ", ";\n\tborder-bottom: ", ";\n\tfont-family: ", ";\n\tfont-size: ", ";\n\n\tsvg,\n\tsvg use {\n\t\tfill: ", ";\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\ttransform: scaleY(0.0001);\n\t\topacity: 0;\n\t\ttransition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1),\n\t\t\t-webkit-transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);\n\t\tbox-sizing: border-box;\n\t\tborder-right: 3px solid #1890ff;\n\t}\n\n\t&.", "-item-disabled {\n\t\tcolor: #ccc !important;\n\t\tcursor: not-allowed;\n\t}\n\n\t&.", "-item-active {\n\t\tcolor: ", ";\n\t\tsvg,\n\t\tsvg use {\n\t\t\tfill: ", ";\n\t\t}\n\t}\n\n\t&.", "-item-selected {\n\t\tcolor: ", ";\n\t\ttransform: translateZ(0);\n\t\tbackground: ", ";\n\n\t\tsvg,\n\t\tsvg use {\n\t\t\tfill: ", ";\n\t\t}\n\t\t&::after {\n\t\t\topacity: 1;\n\t\t\ttransform: scaleY(1);\n\t\t\ttransition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1),\n\t\t\t\t-webkit-transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n\t\t}\n\t}\n\n\ta {\n\t\tcolor: inherit !important;\n\t\ttext-decoration: none;\n\t\tfont-size: inherit;\n\t\tfont-family: inherit;\n\t}\n"])), function (_ref3) {
  var mode = _ref3.mode;
  return mode === 'horizontal' ? 'inline-block' : 'block';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.menuItemColor;
}, function (_ref5) {
  var mode = _ref5.mode,
      theme = _ref5.theme;
  return mode === 'horizontal' ? 'none' : "1px solid ".concat(theme.menuItemBorderColor);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.menuFontSize;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.menuItemColor || theme.primary;
}, prefix, prefix, function (_ref9) {
  var theme = _ref9.theme;
  return theme.menuItemColorActive || theme.primary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.menuItemColorActive || theme.primary;
}, prefix, function (_ref11) {
  var theme = _ref11.theme;
  return theme.menuItemColorActive || theme.primary;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.menuItemActiveBg;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.menuItemColorActive || theme.primary;
});
/**
 *
 * Menu group
 *
 */

var StyledGroup = styled(MenuItemGroup)(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteral$1(["\n\tdisplay: ", ";\n\tcursor: default;\n\tmargin: 0;\n\tposition: relative;\n\tdisplay: block;\n\tpadding: 5px 0 0;\n\twhite-space: nowrap;\n\n\t& > .", "-item-group-list {\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t}\n\n\t& > .", "-item-group-title {\n\t\tcolor: ", ";\n\t\tline-height: 1.5;\n\t\tpadding: 0px 8px 8px 16px;\n\t\tborder-bottom: 1px solid ", ";\n\t\tuser-select: none;\n\t}\n\t& > .", "-submenu-active .", "-submenu-title {\n\t\tcolor: ", ";\n\t}\n"])), function (_ref14) {
  var mode = _ref14.mode;
  return mode === 'horizontal' ? 'inline-block' : 'block';
}, prefix, prefix, function (_ref15) {
  var theme = _ref15.theme;
  return theme.menuGroupColor;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.menuGroupBorderColor;
}, prefix, prefix, function (_ref17) {
  var theme = _ref17.theme;
  return theme.menuItemColorActive || theme.primary;
});
/**
 *
 *  Sub menu
 *
 */

var StyledSubMenu = styled(connected$2)(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteral$1(["\n\tmargin: 0;\n\tposition: relative;\n\tdisplay: ", ";\n\twhite-space: nowrap;\n\tfont-family: ", ";\n\tfont-size: ", ";\n\n\tsvg,\n\tsvg use {\n\t\tfill: ", ";\n\t}\n\n\t& > div.", "-submenu-title {\n\t\tpadding-top: 15px;\n\t\tpadding-bottom: 15px;\n\t\tpadding-right: 10px;\n\t\tpadding-left: 15px;\n\t\tcursor: pointer;\n\t\tborder-bottom: 1px solid ", ";\n\t\tcolor: ", ";\n\t\tposition: relative;\n\t\t&:hover {\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n\n\t.", "-sub {\n\t\tdisplay: block;\n\t\toverflow: hidden;\n\t}\n\t&.", "-submenu-disabled, &.", "-submenu-disabled .", "-submenu-title {\n\t\tcolor: ", ";\n\t\tcursor: not-allowed;\n\t\tposition: relative;\n\n\t\t& [class$='-submenu-arrow'] {\n\t\t\t&::before,\n\t\t\t&::after {\n\t\t\t\tbackground: ", ";\n\t\t\t}\n\t\t}\n\t}\n\n\t&.", "-submenu-vertical {\n\t\t[class$='-submenu-arrow'] {\n\t\t\ttransform: translateY(-2px);\n\n\t\t\t&::after {\n\t\t\t\ttransform: rotate(-45deg) translateY(2px);\n\t\t\t}\n\t\t\t&::before {\n\t\t\t\ttransform: rotate(45deg) translateY(-2px);\n\t\t\t}\n\t\t}\n\t}\n\n\t/**\n    *  Menu open styles\n    */\n\t&.", "-submenu-open {\n\t\t&.", "-submenu-inline {\n\t\t\tcolor: ", ";\n\n\t\t\t& > [class*='-title'] {\n\t\t\t\tcolor: ", ";\n\n\t\t\t\tsvg,\n\t\t\t\tsvg use {\n\t\t\t\t\tfill: ", ";\n\t\t\t\t}\n\t\t\t\t& > [class$='-submenu-arrow'] {\n\t\t\t\t\ttransform: translateY(-2px);\n\n\t\t\t\t\t&::after,\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t}\n\n\t\t\t\t\t&::after {\n\t\t\t\t\t\ttransform: rotate(-45deg) translateX(-2px);\n\t\t\t\t\t}\n\t\t\t\t\t&::before {\n\t\t\t\t\t\ttransform: rotate(45deg) translateX(2px);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"])), function (_ref18) {
  var mode = _ref18.mode;
  return mode === 'horizontal' ? 'inline-block' : 'block';
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontFamily;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.menuFontSize;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.menuItemColor || theme.primary;
}, prefix, function (_ref22) {
  var theme = _ref22.theme;
  return theme.menuItemBorderColor;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.menuItemColor;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.menuItemColorHover || theme.primary;
}, prefix, prefix, prefix, prefix, function (_ref25) {
  var theme = _ref25.theme;
  return theme.menuItemColorDisable;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.menuItemColorDisable;
}, prefix, prefix, prefix, function (_ref27) {
  var theme = _ref27.theme;
  return theme.subMenuOpenColor;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.menuItemColorActive || theme.primary;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.menuItemColorActive || theme.primary;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.menuArrowColorActive;
});
/**
 *
 *  Menu Divider
 *
 */

var StyledDivider = styled(Divider)(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral$1(["\n\tdisplay: ", ";\n\theight: ", ";\n\tmargin: 1px 0;\n\toverflow: hidden;\n\tpadding: 0;\n\tline-height: 0;\n\tbackground-color: ", ";\n"])), function (_ref31) {
  var mode = _ref31.mode;
  return mode === 'horizontal' ? 'inline-block' : 'block';
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.menuDividerHeight;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.menuDividerColor;
});
/**
 *
 * Menu
 *
 */

var MenuComp$1 = function MenuComp(_ref34) {
  var className = _ref34.className,
      children = _ref34.children,
      props = _objectWithoutProperties$c(_ref34, ["className", "children"]);

  var cleanedProps = props;
  delete cleanedProps.theme;
  return /*#__PURE__*/React__default.createElement(Menu, _extends$g({
    prefixCls: className
  }, cleanedProps), children);
};

var StyledMenu = styled(MenuComp$1)(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral$1(["\n\toutline: none;\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: 0;\n\tlist-style: none;\n\tdisplay: inline-block;\n\tuser-select: none;\n\tbackground: ", ";\n\n\t&:not([class*='sub']) {\n\t\tborder: 1px solid ", ";\n\t\tborder-radius: 3px;\n\t}\n\n\t&[class*='-hidden'] {\n\t\tdisplay: none;\n\t}\n\n\t", "\n"])), function (_ref35) {
  var theme = _ref35.theme;
  return theme.menuBackground;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.menuBorderColor;
}, function (_ref37) {
  var mode = _ref37.mode;
  return mode !== 'horizontal' && css$4(["& [class$='-submenu-arrow']{position:absolute;top:50%;right:15px;width:10px;transition:transform 0.3s cubic-bezier(0.645,0.045,0.355,1);&::before,&::after{content:'';position:absolute;box-sizing:border-box;height:1.5px;width:6px;height:1.5px;background:", ";border-radius:2px;transition:all 0.3s cubic-bezier(0.645,0.045,0.355,1);}&::before{transform:rotate(-45deg) translateX(2px);}&::after{transform:rotate(45deg) translateX(-2px);}}", ""], function (_ref38) {
    var theme = _ref38.theme;
    return theme.menuArrowColor;
  }, function (_ref39) {
    var mode = _ref39.mode;
    return mode === 'inline' && css$4(["& [class*='-open']{&[class*='-slide-up-enter'],&[class*='-slide-up-appear']{", ";opacity:0;animation-timing-function:cubic-bezier(0.08,0.82,0.17,1);animation-play-state:paused;}&[class*='-slide-up-leave']{", ";opacity:1;animation-timing-function:cubic-bezier(0.6,0.04,0.98,0.34);animation-play-state:paused;}&[class*='-slide-up-enter'][class*='-slide-up-enter-active'],&[class*='-slide-up-appear'][class*='-slide-up-appear-active']{animation-name:", ";animation-play-state:running;}&[class*='-slide-up-leave'][class*='-slide-up-leave-active']{animation-name:", ";animation-play-state:running;}}"], effect, effect, rcMenuOpenSlideUpIn, rcMenuOpenSlideUpOut);
  });
});

var _templateObject$p;
var GlobalRCStyled = createGlobalStyle(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral$1(["\n\n    [class*=-submenu-popup]{\n        position: absolute;\n        z-index: ", ";\n        background: ", ";\n        border-radius: ", ";\n        border: 1px solid ", ";\n\n        &::before {\n            position: absolute;\n            top: -7px;\n            right: 0;\n            bottom: 0;\n            left: 0;\n            opacity: .0001;\n            content: ' ';\n        }\n    }\n    \n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.zIndexDropdown;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.menuPopupBg;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.menuBorderColor;
});

function MenuComp(_ref5) {
  var children = _ref5.children,
      structure = _ref5.structure,
      props = _objectWithoutProperties$c(_ref5, ["children", "structure"]);

  var theme = props.theme;

  var getMenuComponent = function getMenuComponent(props, item) {
    var renderer = item.renderer,
        rest = _objectWithoutProperties$c(item, ["renderer"]);

    var label = renderer && typeof renderer === 'function' ? renderer(rest) : item.title;
    var iconComp;
    var labelComp = /*#__PURE__*/React__default.createElement(StyledMenuLabel, props, label);

    if (item.icon) {
      iconComp = /*#__PURE__*/React__default.createElement(MenuIcon, _extends$g({}, props, {
        icon: item.icon
      }));
    } else {
      iconComp = /*#__PURE__*/React__default.createElement(MenuIconPlaceholder, _extends$g({}, props, {
        mode: structure.mode
      }));
    }

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item.icon ? iconComp : undefined, labelComp);
  };

  var getSubmenu = function getSubmenu(submenu) {
    if (submenu) {
      return submenu.map(function (item, i) {
        var submenu = item.submenu;

        if (submenu && submenu.length) {
          if (item.type === 'group') {
            return /*#__PURE__*/React__default.createElement(StyledGroup, _extends$g({
              theme: theme
            }, item, {
              key: item.key || "group-".concat(i),
              title: /*#__PURE__*/React__default.createElement(StyledMenuLabel, null, item.icon ? /*#__PURE__*/React__default.createElement(MenuIcon, {
                theme: theme,
                icon: item.icon
              }) : undefined, item.title)
            }), getSubmenu(submenu));
          }

          return /*#__PURE__*/React__default.createElement(StyledSubMenu, _extends$g({}, item, {
            theme: theme,
            key: item.key || "submenu-".concat(i),
            title: /*#__PURE__*/React__default.createElement(StyledMenuLabel, {
              theme: theme,
              role: "submenu"
            }, item.icon ? /*#__PURE__*/React__default.createElement(MenuIcon, {
              theme: theme,
              icon: item.icon
            }) : undefined, item.title)
          }), getSubmenu(submenu));
        }

        item.renderer;
            var itemProps = _objectWithoutProperties$c(item, ["renderer"]);

        if (item.type === 'divider') {
          return /*#__PURE__*/React__default.createElement(StyledDivider, _extends$g({
            theme: theme
          }, itemProps, {
            key: item.key || "divider-".concat(i)
          }));
        }

        return /*#__PURE__*/React__default.createElement(StyledMenuItem, _extends$g({}, itemProps, {
          theme: theme,
          key: item.key || "item-".concat(i)
        }), getMenuComponent(props, item));
      });
    }
  };

  var getChildren = function getChildren(children) {
    if (children && children.length > 0) {
      return React__default.Children.map(children, function (child) {
        var children = child.props.children;

        if (children && Object.prototype.toString.call(children) === '[object Array]') {
          return /*#__PURE__*/React__default.cloneElement(child, {
            theme: theme
          }, getChildren(children));
        }

        return /*#__PURE__*/React__default.cloneElement(child, {
          theme: theme
        });
      });
    }

    return null;
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(GlobalRCStyled, {
    theme: theme
  }), /*#__PURE__*/React__default.createElement(StyledMenu, _extends$g({}, props, structure, {
    openAnimation: "slide-up"
  }), structure && structure.submenu ? getSubmenu(structure.submenu) : undefined, getChildren(children)));
}

MenuComp.propTypes = {
  structure: PropTypes.shape({
    mode: PropTypes.oneOf(['inline', 'horizontal', 'vertical', 'vertical-left', 'vertical-right']),
    activeKey: PropTypes.shape({}),
    defaultActiveFirst: PropTypes.bool,
    multiple: PropTypes.bool,
    selectable: PropTypes.bool,
    selectedKeys: PropTypes.arrayOf(PropTypes.string)
  })
};
MenuComp.defaultProps = {};
var Wrapper$E = withTheme(MenuComp);

var MenuItem = function MenuItem(props) {
  return /*#__PURE__*/React__default.createElement(StyledMenuItem$1, props, props.children);
};

MenuItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};
MenuItem.defaultProps = {};
var Wrapper$D = withTheme(MenuItem);

var DropdownButton = function DropdownButton(props) {
  props.style;
      props.label;
      var units = props.units,
      error = props.error;
      props.hint;
      var rest = _objectWithoutProperties$c(props, ["style", "label", "units", "error", "hint"]);

  rest.value;
      rest.name;
      var validationState = rest.validationState;
      rest.title;
      var theme = rest.theme,
      size = rest.size;
      _objectWithoutProperties$c(rest, ["value", "name", "validationState", "title", "theme", "size"]);

  var baseStyles = DropListStyles(error || validationState && validationState === 'danger', theme, 60, size);

  var dropStyles = _objectSpread2$2(_objectSpread2$2({}, baseStyles), {}, {
    control: function control(provided, state) {
      return _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, provided), baseStyles.control(provided, state)), {}, {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderLeft: 0
      });
    }
  });

  return /*#__PURE__*/React__default.createElement(Wrapper$S, _extends$g({}, rest, {
    options: units,
    isSearchable: false,
    styles: dropStyles,
    hideSelectedOptions: false,
    mb: 0
  }));
};

DropdownButton.propTypes = {};
DropdownButton.defaultProps = {
  size: 'large'
};
var Wrapper$C = withTheme(DropdownButton);

var _templateObject$o, _templateObject2$k, _templateObject3$e;
var DimsWrapper = styled(Wrapper$12)(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral$1(["\n\tborder: 1px solid\n\t\t", ";\n\tborder-top-left-radius: ", ";\n\tborder-bottom-left-radius: ", ";\n\tbackground: ", ";\n\theight: ", ";\n\tbox-sizing: border-box;\n\talign-items: center;\n\n\t& input:first-child {\n\t\tborder-top-left-radius: ", ";\n\t\tborder-bottom-left-radius: ", ";\n\t}\n"])), function (_ref) {
  var theme = _ref.theme,
      isFocused = _ref.isFocused,
      error = _ref.error;
  return error ? theme.error : isFocused ? theme.inputFocusBorderColor || theme.primary : theme.inputBorderColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var disabled = _ref4.disabled,
      theme = _ref4.theme;
  return disabled ? theme.inputBackgroundDisabled : theme.inputBackground;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.inputHeight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.borderRadius;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.borderRadius;
});
var Times = styled.div(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral$1(["\n\tcolor: ", ";\n"])), function (_ref8) {
  var disabled = _ref8.disabled,
      theme = _ref8.theme;
  return disabled ? theme.inputLabelColorDisabled : theme.greyBlue;
});
var ClearInput = styled.input(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral$1(["\n\tborder: none;\n\tbox-sizing: border-box;\n\ttext-align: center;\n\twidth: 100%;\n\theight: 100%;\n\tfont-size: ", ";\n\tfont-family: ", ";\n\tmargin: 0;\n\tbackground: ", ";\n\tcolor: ", ";\n\t&,\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t&,\n\t&:hover {\n\t\t-webkit-appearance: none;\n\t}\n\t&::placeholder {\n\t\tcolor: ", ";\n\t\topacity: 1;\n\t}\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.inputFontSize;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontFamily;
}, function (_ref11) {
  var disabled = _ref11.disabled,
      theme = _ref11.theme;
  return disabled ? theme.inputBackgroundDisabled : 'transparent';
}, function (_ref12) {
  var disabled = _ref12.disabled,
      theme = _ref12.theme;
  return disabled ? theme.inputLabelColorDisabled : theme.inputColor;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.inputPlaceholderColor;
});

var convert = function convert(value, fromUnit, toUnit) {
  if (value && fromUnit && toUnit) {
    switch (fromUnit.toLowerCase()) {
      case 'cm':
        switch (toUnit.toLowerCase()) {
          case 'in':
            return Number(value) / 0.393701;

          default:
            return value;
        }

      case 'in':
        switch (toUnit.toLowerCase()) {
          case 'cm':
            return Number(value) * 2.54;

          default:
            return value;
        }

      default:
        return value;
    }
  } else {
    return value;
  }
};

function Dimensions(props) {
  var value = props.value,
      min = props.min,
      max = props.max;
      props.label;
      var labels = props.labels;
      props.tooltip;
      props.tooltipDelay;
      props.required;
      var error = props.error,
      validationState = props.validationState;
      props.hint;
      var onChange = props.onChange,
      rest = _objectWithoutProperties$c(props, ["value", "min", "max", "label", "labels", "tooltip", "tooltipDelay", "required", "error", "validationState", "hint", "onChange"]);

  var _useState = useState(value.length || ''),
      _useState2 = _slicedToArray$8(_useState, 2),
      length = _useState2[0],
      setLength = _useState2[1];

  var _useState3 = useState(value.width || ''),
      _useState4 = _slicedToArray$8(_useState3, 2),
      width = _useState4[0],
      setWidth = _useState4[1];

  var _useState5 = useState(value.height || ''),
      _useState6 = _slicedToArray$8(_useState5, 2),
      height = _useState6[0],
      setHeight = _useState6[1];

  var _useState7 = useState(value.unit || 'cm'),
      _useState8 = _slicedToArray$8(_useState7, 2),
      unit = _useState8[0],
      setUnit = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray$8(_useState9, 2),
      focused = _useState10[0],
      setFocused = _useState10[1];

  useEffect(function () {
    setLength(value.length || '');
    setWidth(value.width || '');
    setHeight(value.height || '');
    setUnit(value.unit || 'cm');
  }, [value.length, value.height, value.width]);
  useEffect(function () {
    if (onChange && (length || width || height)) {
      var volume;
      var volumeUnit = null;

      if (length && width && height) {
        volume = height * length * width / (unit === 'cm' ? 1000000 : 1728);
        volumeUnit = unit === 'cm' ? 'CBM' : 'CFT';
      }

      onChange({
        length: checkLimit(length, 'length') || undefined,
        width: checkLimit(width, 'width') || undefined,
        height: checkLimit(height, 'height') || undefined,
        unit: unit,
        volume: volume,
        volumeUnit: volumeUnit
      });
    }
  }, [height, width, length, unit]);

  var checkLimit = function checkLimit(value, dim) {
    var minimum = convert(min[dim], min.unit, unit);
    var maximum = convert(max[dim], max.unit, unit);
    if (value <= minimum) return value;
    if (value >= maximum) return value;
    return value;
  };

  var handleChange = function handleChange(e, dim) {
    var val = e.target.value ? Number(e.target.value) : '';
    val = checkLimit(val, dim);

    switch (dim) {
      case 'length':
        setLength(val);
        break;

      case 'width':
        setWidth(val);
        break;

      case 'height':
        setHeight(val);
        break;
    }
  }; // const renderMenuOptions = () => {
  // 	return props.units.map((item, idx) => {
  // 		return (
  // 			<MenuItem value={item} key={idx} onClick={() => setUnit(item.value)}>
  // 				{item.label}
  // 			</MenuItem>
  // 		);
  // 	});
  // };


  var getInputField = function getInputField(value, field) {
    return /*#__PURE__*/React__default.createElement(ClearInput, _extends$g({}, rest, {
      value: value,
      "aria-label": field,
      onChange: function onChange(e) {
        return handleChange(e, field);
      },
      type: "number",
      min: 0,
      onFocus: function onFocus() {
        return setFocused(true);
      },
      onBlur: function onBlur() {
        return setFocused(false);
      },
      placeholder: labels[field]
    }));
  };

  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, props, /*#__PURE__*/React__default.createElement(Wrapper$12, {
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(DimsWrapper, _extends$g({}, rest, {
    isFocused: focused,
    error: error || validationState === 'danger'
  }), getInputField(length, 'length'), /*#__PURE__*/React__default.createElement(Times, rest, "\xD7"), getInputField(width, 'width'), /*#__PURE__*/React__default.createElement(Times, rest, "\xD7"), getInputField(height, 'height')), /*#__PURE__*/React__default.createElement(Wrapper$C, _extends$g({}, rest, {
    value: value.unit,
    id: RandomID(6),
    onChange: function onChange(val) {
      return setUnit(val.value);
    },
    error: error || validationState === 'danger'
  }))));
}

Dimensions.propTypes = {
  value: PropTypes.shape({
    length: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    unit: PropTypes.oneOf(['cm', 'in'])
  }).isRequired,
  min: PropTypes.shape({
    length: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number
  }),
  max: PropTypes.shape({
    length: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number
  }),
  units: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  labels: PropTypes.shape({
    length: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string
  }),

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
Dimensions.defaultProps = {
  value: {},
  min: {
    length: 0,
    height: 0,
    width: 0
  },
  max: {},
  units: [{
    value: 'cm',
    label: 'cm'
  }, {
    value: 'in',
    label: 'in'
  }],
  labels: {
    length: 'Length',
    width: 'Width',
    height: 'Height'
  }
};
var Wrapper$B = compose$1(withTheme, withTransformers)(Dimensions);

var Flag = function Flag(props) {
  return /*#__PURE__*/React__default.createElement(FlagComp, props);
};
Flag.propTypes = {
  /** Country code (2 or 3 digit code) */
  code: PropTypes.string.isRequired,

  /** Flag height */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Flag width */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

function Grid(props) {
  return /*#__PURE__*/React__default.createElement(Wrapper$12, props, React__default.Children.map(props.children, function (child, i) {
    var childProps = _objectSpread2$2(_objectSpread2$2({}, child.props), {}, {
      theme: props.theme,
      width: props.numOfColumns ? 1 / props.numOfColumns : child.props.width
    });

    var space = props.spaceItems; // remove margin from last item on each row if number of the columns is set

    if (props.numOfColumns) {
      if (i + 1 >= props.numOfColumns && (i + 1) % props.numOfColumns === 0) {
        space = 0;
      } //or remove margin from last item

    } else if (i + 1 === props.children.length) {
      space = 0;
    }

    var boxBaseStyle = {
      boxSizing: 'border-box'
    };
    return /*#__PURE__*/React__default.createElement(Wrapper$11, _extends$g({}, childProps, {
      style: boxBaseStyle,
      pr: space,
      pb: props.isRow ? 0 : space
    }), /*#__PURE__*/React__default.cloneElement(child, childProps));
  }));
}

Grid.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,

  /** Determines how many columns the grid will distribute its children on*/
  numOfColumns: PropTypes.number,

  /** By default, children will be spaced out using this value. Can be px or number based on style-system space array */
  spaceItems: PropTypes.number,

  /** Whether to allow children to break to next line or not */
  flexWrap: PropTypes.oneOf(['wrap', 'nowrap']),

  /** Controls the order of children */
  flexDirection: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /** Aligns items horizontally */
  justifyContent: PropTypes.oneOf(['flex-start', 'flow-end', 'center', 'space-between', 'space-around']),

  /** Aligns items vertically */
  alignContent: PropTypes.oneOf(['flex-start', 'flow-end', 'center', 'baseline', 'stretch'])
};
Grid.defaultProps = {
  flexWrap: 'wrap',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignContent: 'flex-start',
  spaceItems: 1
};
var Wrapper$A = withTheme(Grid);

/*eslint no-restricted-globals: ["warn"]*/

var resolvePath = function resolvePath(path, obj) {
  if (!path) return obj;
  return path.split('.').reduce(function (prev, curr) {
    return prev ? prev[curr] : null;
  }, obj || self);
};
/**
 *
 * @param {*} component
 * @param {*} endpoint
 * @param {*} dataParam
 * @param {*} dataPath
 * @param {*} componentProps
 * @param {*} requestOptions
 */


var withData = function withData(props) {
  if (!props.component) throw new Error('Missing `Component` provided to withData HOC');
  if (!props.endpoint) throw new Error('Missing `endpoint url` provided to withData HOC');
  if (!props.dataParam) throw new Error('Missing `data param` provided to withData HOC');

  var Wrapped = function Wrapped() {
    var _useState = useState(null),
        _useState2 = _slicedToArray$8(_useState, 2),
        data = _useState2[0],
        setData = _useState2[1];

    var _useState3 = useState(null),
        _useState4 = _slicedToArray$8(_useState3, 2),
        error = _useState4[0],
        setError = _useState4[1];

    useEffect(function () {
      var options = Object.assign({
        url: props.endpoint,
        method: 'GET'
      }, props.requestOptions);
      Axios(options).then(function (response) {
        setData(resolvePath(props.dataPath, response.data));
      })["catch"](function (err) {
        setError("Failed to fetch data from ".concat(props.endpoint));
      });
    }, []);

    if (data) {
      var passedProps = _objectSpread2$2(_objectSpread2$2({}, props.componentProps), {}, _defineProperty$k({}, props.dataParam, data));

      var WrappedComponent = props.component;
      return /*#__PURE__*/React__default.createElement(WrappedComponent, passedProps);
    } else if (error) {
      return /*#__PURE__*/React__default.createElement(Wrapper$L, null, error);
    } else {
      return props.loadingPlaceholder || null;
    }
  };

  return Wrapped;
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$3.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$3.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root, 'Map');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache),
    'string': new Hash
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize$1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

var isProduction = process.env.NODE_ENV === 'production';
function warning$1(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

function _objectWithoutPropertiesLoose$a(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = toPath(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}

var FormikContext = /*#__PURE__*/createContext(undefined);
FormikContext.Provider;
FormikContext.Consumer;
function useFormikContext() {
  var formik = useContext(FormikContext);
  !!!formik ? process.env.NODE_ENV !== "production" ? warning$1(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : warning$1(false) : void 0;
  return formik;
}

var Form = /*#__PURE__*/forwardRef(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose$a(props, ["action"]);

  var _action = action || '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return createElement("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';

var ErrorFocus = function ErrorFocus() {
  var formik = useFormikContext() || {};
  var errors = formik.errors;
  var ref = /*#__PURE__*/createRef();
  useEffect(function () {
    var parentForm = ref.current.closest('form');
    var errArr = parentForm.querySelectorAll('[data-error]');

    if (errArr && errArr.length) {
      for (var i = 0; i < errArr.length; i++) {
        var element = errArr[i];

        if (element.getAttribute('data-error') !== 'false') {
          // eslint-disable-next-line react/no-find-dom-node
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
          break;
        }
      }
    }
  }, [errors]);
  return /*#__PURE__*/React__default.createElement("em", {
    ref: ref
  });
};

var FormikHOC = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var field = _ref.field,
      form = _ref.form,
      uiComponent = _ref.uiComponent,
      props = _objectWithoutProperties$c(_ref, ["field", "form", "uiComponent"]);

  var name = field.name,
      fieldProps = _objectWithoutProperties$c(field, ["name"]);

  var errors = form.errors,
      touched = form.touched,
      submitCount = form.submitCount,
      setFieldValue = form.setFieldValue;
  var Component = uiComponent;

  var handleOnChange = function handleOnChange(value) {
    setFieldValue(name, value);
    if (props.onChange) props.onChange(value);
  };

  var errorText = getIn(errors, name);
  var isTouched = getIn(touched, name);
  var showError = errorText && isTouched || errorText && submitCount > 0;

  var propsToPass = _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, fieldProps), props), {}, {
    ref: ref,
    name: name,
    label: props.label,
    onChange: handleOnChange,
    error: showError ? errorText : undefined,
    disabled: props.disabled || form.isSubmitting
  });

  return /*#__PURE__*/React__default.createElement(Component, propsToPass);
});

var _templateObject$n, _templateObject2$j;
var Wrapper$z = styled.div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral$1(["\n\t", ";\n\twidth: 100%;\n\theight: ", ";\n\ttransition: all 0.3s ease;\n\n\tbackground: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\tcursor: ", ";\n"])), space, function (_ref) {
  var height = _ref.height;
  return height === 'auto' || typeof height === 'string' ? height : "".concat(height, "px");
}, function (_ref2) {
  var error = _ref2.error;
  return error ? '#efefef' : 'transparent';
}, function (_ref3) {
  var onClick = _ref3.onClick;
  return onClick ? 'pointer' : 'default';
});
var Img = styled.img(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral$1(["\n\tmax-width: 100%;\n\tmax-height: 100%;\n\theight: auto;\n"]))); // eslint-disable-next-line import/prefer-default-export

var Image = function Image(props) {
  var maxWidth = props.maxWidth,
      maxHeight = props.maxHeight,
      src = props.src,
      alt = props.alt,
      showLoading = props.showLoading,
      loadingComponent = props.loadingComponent,
      style = props.style,
      className = props.className,
      onClick = props.onClick,
      imageRenderer = props.imageRenderer,
      onLoadError = props.onLoadError,
      rest = _objectWithoutProperties$c(props, ["maxWidth", "maxHeight", "src", "alt", "showLoading", "loadingComponent", "style", "className", "onClick", "imageRenderer", "onLoadError"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray$8(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$8(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var handleOnLoad = function handleOnLoad(e) {
    setLoaded(true);
    setError(false);
    if (props.onLoad) props.onLoad();
  };

  var handleImageError = function handleImageError(e) {
    setError(true);
    if (onLoadError) onLoadError();
  };

  var renderImage = function renderImage() {
    if (imageRenderer) {
      return imageRenderer(src);
    }

    return /*#__PURE__*/React__default.createElement(Img, {
      src: src,
      alt: alt
    });
  };

  return /*#__PURE__*/React__default.createElement(Wrapper$z, _extends$g({}, rest, {
    width: maxWidth,
    height: maxHeight,
    error: error,
    className: className,
    style: style,
    onClick: onClick
  }), !loaded && /*#__PURE__*/React__default.createElement("img", {
    src: src,
    alt: alt,
    onError: handleImageError,
    onLoad: handleOnLoad,
    style: {
      display: 'none',
      width: 0,
      height: 0
    }
  }), !error && !loaded && showLoading ? loadingComponent || /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }, /*#__PURE__*/React__default.createElement(Wrapper$U, rest)) : undefined, loaded ? renderImage() : /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    icon: "broken-image",
    color: "#ccc"
  }));
};
Image.propTypes = {
  /** Image width limit. If set to `auto` the image will be displayed with original image width */
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Image height limit. If set to `auto` the image will be displayed with original image height */
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Image src */
  src: PropTypes.string.isRequired,

  /** Image alt text */
  alt: PropTypes.string,

  /** Displays a loading circle while the image is loading */
  showLoading: PropTypes.bool,

  /** Custom component to load instead of Loading circle. Only active if `showLoading` is true  */
  loadingComponent: PropTypes.node,

  /** Fired when the image is loaded */
  onLoad: PropTypes.func,

  /** Fired when the image fails to load */
  onLoadError: PropTypes.func,

  /** Style object */
  style: PropTypes.object,

  /** Additional className added to the wrapper of the image */
  className: PropTypes.string,

  /** Adds an onClick event to the wrapper and changed the cursor to pointer */
  onClick: PropTypes.func,

  /** To customize the image component, this function is called when the component tries to render the image. Passes the image data/url and expects node element in return */
  imageRenderer: PropTypes.func
};
Image.defaultProps = {
  maxWidth: 'auto',
  maxHeight: 'auto',
  showLoading: true
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var clamp$2 = function (min, max) { return function (v) {
    return Math.max(Math.min(v, max), min);
}; };
var sanitize = function (v) { return (v % 1 ? Number(v.toFixed(5)) : v); };
var floatRegex = /(-)?(\d[\d\.]*)/g;
var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
var singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;

var number = {
    test: function (v) { return typeof v === 'number'; },
    parse: parseFloat,
    transform: function (v) { return v; }
};
var alpha = __assign$2(__assign$2({}, number), { transform: clamp$2(0, 1) });
var scale = __assign$2(__assign$2({}, number), { default: 1 });

var createUnitType = function (unit) { return ({
    test: function (v) {
        return typeof v === 'string' && v.endsWith(unit) && v.split(' ').length === 1;
    },
    parse: parseFloat,
    transform: function (v) { return "" + v + unit; }
}); };
var degrees = createUnitType('deg');
var percent = createUnitType('%');
var px = createUnitType('px');
var vh = createUnitType('vh');
var vw = createUnitType('vw');
var progressPercentage = __assign$2(__assign$2({}, percent), { parse: function (v) { return percent.parse(v) / 100; }, transform: function (v) { return percent.transform(v * 100); } });

var getValueFromFunctionString = function (value) {
    return value.substring(value.indexOf('(') + 1, value.lastIndexOf(')'));
};
var clampRgbUnit = clamp$2(0, 255);
var isRgba = function (v) { return v.red !== undefined; };
var isHsla = function (v) { return v.hue !== undefined; };
function getValuesAsArray(value) {
    return getValueFromFunctionString(value)
        .replace(/(,|\/)/g, ' ')
        .split(/ \s*/);
}
var splitColorValues = function (terms) {
    return function (v) {
        if (typeof v !== 'string')
            return v;
        var values = {};
        var valuesArray = getValuesAsArray(v);
        for (var i = 0; i < 4; i++) {
            values[terms[i]] =
                valuesArray[i] !== undefined ? parseFloat(valuesArray[i]) : 1;
        }
        return values;
    };
};
var rgbaTemplate = function (_a) {
    var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha = _b === void 0 ? 1 : _b;
    return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
};
var hslaTemplate = function (_a) {
    var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha = _b === void 0 ? 1 : _b;
    return "hsla(" + hue + ", " + saturation + ", " + lightness + ", " + alpha + ")";
};
var rgbUnit = __assign$2(__assign$2({}, number), { transform: function (v) { return Math.round(clampRgbUnit(v)); } });
function isColorString(color, colorType) {
    return color.startsWith(colorType) && singleColorRegex.test(color);
}
var rgba = {
    test: function (v) { return (typeof v === 'string' ? isColorString(v, 'rgb') : isRgba(v)); },
    parse: splitColorValues(['red', 'green', 'blue', 'alpha']),
    transform: function (_a) {
        var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return rgbaTemplate({
            red: rgbUnit.transform(red),
            green: rgbUnit.transform(green),
            blue: rgbUnit.transform(blue),
            alpha: sanitize(alpha.transform(alpha$1))
        });
    }
};
var hsla = {
    test: function (v) { return (typeof v === 'string' ? isColorString(v, 'hsl') : isHsla(v)); },
    parse: splitColorValues(['hue', 'saturation', 'lightness', 'alpha']),
    transform: function (_a) {
        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return hslaTemplate({
            hue: Math.round(hue),
            saturation: percent.transform(sanitize(saturation)),
            lightness: percent.transform(sanitize(lightness)),
            alpha: sanitize(alpha.transform(alpha$1))
        });
    }
};
var hex = __assign$2(__assign$2({}, rgba), { test: function (v) { return typeof v === 'string' && isColorString(v, '#'); }, parse: function (v) {
        var r = '';
        var g = '';
        var b = '';
        if (v.length > 4) {
            r = v.substr(1, 2);
            g = v.substr(3, 2);
            b = v.substr(5, 2);
        }
        else {
            r = v.substr(1, 1);
            g = v.substr(2, 1);
            b = v.substr(3, 1);
            r += r;
            g += g;
            b += b;
        }
        return {
            red: parseInt(r, 16),
            green: parseInt(g, 16),
            blue: parseInt(b, 16),
            alpha: 1
        };
    } });
var color = {
    test: function (v) {
        return (typeof v === 'string' && singleColorRegex.test(v)) ||
            isRgba(v) ||
            isHsla(v);
    },
    parse: function (v) {
        if (rgba.test(v)) {
            return rgba.parse(v);
        }
        else if (hsla.test(v)) {
            return hsla.parse(v);
        }
        else if (hex.test(v)) {
            return hex.parse(v);
        }
        return v;
    },
    transform: function (v) {
        if (isRgba(v)) {
            return rgba.transform(v);
        }
        else if (isHsla(v)) {
            return hsla.transform(v);
        }
        return v;
    }
};

var COLOR_TOKEN = '${c}';
var NUMBER_TOKEN = '${n}';
var convertNumbersToZero = function (v) {
    return typeof v === 'number' ? 0 : v;
};
var complex = {
    test: function (v) {
        if (typeof v !== 'string' || !isNaN(v))
            return false;
        var numValues = 0;
        var foundNumbers = v.match(floatRegex);
        var foundColors = v.match(colorRegex);
        if (foundNumbers)
            numValues += foundNumbers.length;
        if (foundColors)
            numValues += foundColors.length;
        return numValues > 0;
    },
    parse: function (v) {
        var input = v;
        var parsed = [];
        var foundColors = input.match(colorRegex);
        if (foundColors) {
            input = input.replace(colorRegex, COLOR_TOKEN);
            parsed.push.apply(parsed, foundColors.map(color.parse));
        }
        var foundNumbers = input.match(floatRegex);
        if (foundNumbers) {
            parsed.push.apply(parsed, foundNumbers.map(number.parse));
        }
        return parsed;
    },
    createTransformer: function (prop) {
        var template = prop;
        var token = 0;
        var foundColors = prop.match(colorRegex);
        var numColors = foundColors ? foundColors.length : 0;
        if (foundColors) {
            for (var i = 0; i < numColors; i++) {
                template = template.replace(foundColors[i], COLOR_TOKEN);
                token++;
            }
        }
        var foundNumbers = template.match(floatRegex);
        var numNumbers = foundNumbers ? foundNumbers.length : 0;
        if (foundNumbers) {
            for (var i = 0; i < numNumbers; i++) {
                template = template.replace(foundNumbers[i], NUMBER_TOKEN);
                token++;
            }
        }
        return function (v) {
            var output = template;
            for (var i = 0; i < token; i++) {
                output = output.replace(i < numColors ? COLOR_TOKEN : NUMBER_TOKEN, i < numColors ? color.transform(v[i]) : sanitize(v[i]));
            }
            return output;
        };
    },
    getAnimatableNone: function (target) {
        var parsedTarget = complex.parse(target);
        var targetTransformer = complex.createTransformer(target);
        return targetTransformer(parsedTarget.map(convertNumbersToZero));
    }
};

var warning = function () { };
var invariant = function () { };
if (process.env.NODE_ENV !== 'production') {
    warning = function (check, message) {
        if (!check && typeof console !== 'undefined') {
            console.warn(message);
        }
    };
    invariant = function (check, message) {
        if (!check) {
            throw new Error(message);
        }
    };
}

var prevTime = 0;
var onNextFrame = typeof window !== 'undefined' && window.requestAnimationFrame !== undefined ? function (callback) {
    return window.requestAnimationFrame(callback);
} : function (callback) {
    var timestamp = Date.now();
    var timeToCall = Math.max(0, 16.7 - (timestamp - prevTime));
    prevTime = timestamp + timeToCall;
    setTimeout(function () {
        return callback(prevTime);
    }, timeToCall);
};

var createStep = function (setRunNextFrame) {
    var processToRun = [];
    var processToRunNextFrame = [];
    var numThisFrame = 0;
    var isProcessing = false;
    var i = 0;
    var cancelled = new WeakSet();
    var toKeepAlive = new WeakSet();
    var renderStep = {
        cancel: function (process) {
            var indexOfCallback = processToRunNextFrame.indexOf(process);
            cancelled.add(process);
            if (indexOfCallback !== -1) {
                processToRunNextFrame.splice(indexOfCallback, 1);
            }
        },
        process: function (frame) {
            var _a;
            isProcessing = true;
            _a = [processToRunNextFrame, processToRun], processToRun = _a[0], processToRunNextFrame = _a[1];
            processToRunNextFrame.length = 0;
            numThisFrame = processToRun.length;
            if (numThisFrame) {
                var process_1;
                for (i = 0; i < numThisFrame; i++) {
                    process_1 = processToRun[i];
                    process_1(frame);
                    if (toKeepAlive.has(process_1) === true && !cancelled.has(process_1)) {
                        renderStep.schedule(process_1);
                        setRunNextFrame(true);
                    }
                }
            }
            isProcessing = false;
        },
        schedule: function (process, keepAlive, immediate) {
            if (keepAlive === void 0) {
                keepAlive = false;
            }
            if (immediate === void 0) {
                immediate = false;
            }
            invariant(typeof process === "function", "Argument must be a function");
            var addToCurrentBuffer = immediate && isProcessing;
            var buffer = addToCurrentBuffer ? processToRun : processToRunNextFrame;
            cancelled.delete(process);
            if (keepAlive) toKeepAlive.add(process);
            if (buffer.indexOf(process) === -1) {
                buffer.push(process);
                if (addToCurrentBuffer) numThisFrame = processToRun.length;
            }
        }
    };
    return renderStep;
};

var maxElapsed = 40;
var defaultElapsed = 1 / 60 * 1000;
var useDefaultElapsed = true;
var willRunNextFrame = false;
var isProcessing = false;
var frame = {
    delta: 0,
    timestamp: 0
};
var stepsOrder = ["read", "update", "preRender", "render", "postRender"];
var setWillRunNextFrame = function (willRun) {
    return willRunNextFrame = willRun;
};
var steps$1 = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = createStep(setWillRunNextFrame);
    return acc;
}, {});
var sync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    var step = steps$1[key];
    acc[key] = function (process, keepAlive, immediate) {
        if (keepAlive === void 0) {
            keepAlive = false;
        }
        if (immediate === void 0) {
            immediate = false;
        }
        if (!willRunNextFrame) startLoop();
        step.schedule(process, keepAlive, immediate);
        return process;
    };
    return acc;
}, {});
var cancelSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
    acc[key] = steps$1[key].cancel;
    return acc;
}, {});
var processStep = function (stepId) {
    return steps$1[stepId].process(frame);
};
var processFrame = function (timestamp) {
    willRunNextFrame = false;
    frame.delta = useDefaultElapsed ? defaultElapsed : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
    if (!useDefaultElapsed) defaultElapsed = frame.delta;
    frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (willRunNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
var startLoop = function () {
    willRunNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing) onNextFrame(processFrame);
};
var getFrameData = function () {
    return frame;
};

var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var reversed = function (easing) {
    return function (p) {
        return 1 - easing(1 - p);
    };
};
var mirrored = function (easing) {
    return function (p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};
var createReversedEasing = reversed;
var createExpoIn = function (power) {
    return function (p) {
        return Math.pow(p, power);
    };
};
var createBackIn = function (power) {
    return function (p) {
        return p * p * ((power + 1) * p - power);
    };
};
var createAnticipateEasing = function (power) {
    var backEasing = createBackIn(power);
    return function (p) {
        return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
};
var linear = function (p) {
    return p;
};
var easeIn = /*#__PURE__*/createExpoIn(2);
var easeOut = /*#__PURE__*/reversed(easeIn);
var easeInOut = /*#__PURE__*/mirrored(easeIn);
var circIn = function (p) {
    return 1 - Math.sin(Math.acos(p));
};
var circOut = /*#__PURE__*/reversed(circIn);
var circInOut = /*#__PURE__*/mirrored(circOut);
var backIn = /*#__PURE__*/createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
var backOut = /*#__PURE__*/reversed(backIn);
var backInOut = /*#__PURE__*/mirrored(backIn);
var anticipate = /*#__PURE__*/createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH);
var NEWTON_ITERATIONS = 8;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var K_SPLINE_TABLE_SIZE = 11;
var K_SAMPLE_STEP_SIZE = 1.0 / (K_SPLINE_TABLE_SIZE - 1.0);
var FLOAT_32_SUPPORTED = typeof Float32Array !== 'undefined';
var a = function (a1, a2) {
    return 1.0 - 3.0 * a2 + 3.0 * a1;
};
var b = function (a1, a2) {
    return 3.0 * a2 - 6.0 * a1;
};
var c = function (a1) {
    return 3.0 * a1;
};
var getSlope = function (t, a1, a2) {
    return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
};
var calcBezier = function (t, a1, a2) {
    return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
};
function cubicBezier(mX1, mY1, mX2, mY2) {
    var sampleValues = FLOAT_32_SUPPORTED ? new Float32Array(K_SPLINE_TABLE_SIZE) : new Array(K_SPLINE_TABLE_SIZE);
    var binarySubdivide = function (aX, aA, aB) {
        var i = 0;
        var currentX;
        var currentT;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) {
                aB = currentT;
            } else {
                aA = currentT;
            }
        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    };
    var newtonRaphsonIterate = function (aX, aGuessT) {
        var i = 0;
        var currentSlope = 0;
        var currentX;
        for (; i < NEWTON_ITERATIONS; ++i) {
            currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) {
                return aGuessT;
            }
            currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    };
    var calcSampleValues = function () {
        for (var i = 0; i < K_SPLINE_TABLE_SIZE; ++i) {
            sampleValues[i] = calcBezier(i * K_SAMPLE_STEP_SIZE, mX1, mX2);
        }
    };
    var getTForX = function (aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = K_SPLINE_TABLE_SIZE - 1;
        var dist = 0.0;
        var guessForT = 0.0;
        var initialSlope = 0.0;
        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += K_SAMPLE_STEP_SIZE;
        }
        --currentSample;
        dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        guessForT = intervalStart + dist * K_SAMPLE_STEP_SIZE;
        initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= NEWTON_MIN_SLOPE) {
            return newtonRaphsonIterate(aX, guessForT);
        } else if (initialSlope === 0.0) {
            return guessForT;
        } else {
            return binarySubdivide(aX, intervalStart, intervalStart + K_SAMPLE_STEP_SIZE);
        }
    };
    calcSampleValues();
    var resolver = function (aX) {
        var returnValue;
        if (mX1 === mY1 && mX2 === mY2) {
            returnValue = aX;
        } else if (aX === 0) {
            returnValue = 0;
        } else if (aX === 1) {
            returnValue = 1;
        } else {
            returnValue = calcBezier(getTForX(aX), mY1, mY2);
        }
        return returnValue;
    };
    return resolver;
}

var zeroPoint = {
    x: 0,
    y: 0,
    z: 0
};
var isNum = function (v) { return typeof v === 'number'; };

var radiansToDegrees = (function (radians) { return (radians * 180) / Math.PI; });

var angle = (function (a, b) {
    if (b === void 0) { b = zeroPoint; }
    return radiansToDegrees(Math.atan2(b.y - a.y, b.x - a.x));
});

var applyOffset = (function (from, to) {
    var hasReceivedFrom = true;
    if (to === undefined) {
        to = from;
        hasReceivedFrom = false;
    }
    return function (v) {
        if (hasReceivedFrom) {
            return v - from + to;
        }
        else {
            from = v;
            hasReceivedFrom = true;
            return to;
        }
    };
});

var curryRange = (function (func) { return function (min, max, v) { return (v !== undefined ? func(min, max, v) : function (cv) { return func(min, max, cv); }); }; });

var clamp = function (min, max, v) {
    return Math.min(Math.max(v, min), max);
};
var clamp$1 = curryRange(clamp);

var conditional = (function (check, apply) { return function (v) {
    return check(v) ? apply(v) : v;
}; });

var isPoint = (function (point) {
    return point.hasOwnProperty('x') && point.hasOwnProperty('y');
});

var isPoint3D = (function (point) {
    return isPoint(point) && point.hasOwnProperty('z');
});

var distance1D = function (a, b) { return Math.abs(a - b); };
var distance = (function (a, b) {
    if (b === void 0) { b = zeroPoint; }
    if (isNum(a) && isNum(b)) {
        return distance1D(a, b);
    }
    else if (isPoint(a) && isPoint(b)) {
        var xDelta = distance1D(a.x, b.x);
        var yDelta = distance1D(a.y, b.y);
        var zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
    return 0;
});

var progress = (function (from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
});

var mix = (function (from, to, progress) {
    return -progress * from + progress * to + from;
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

var mixLinearColor = function (from, to, v) {
    var fromExpo = from * from;
    var toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
var colorTypes = [hex, rgba, hsla];
var getColorType = function (v) {
    return colorTypes.find(function (type) { return type.test(v); });
};
var notAnimatable = function (color$$1) {
    return "'" + color$$1 + "' is not an animatable color. Use the equivalent color code instead.";
};
var mixColor = (function (from, to) {
    var fromColorType = getColorType(from);
    var toColorType = getColorType(to);
    invariant(!!fromColorType, notAnimatable(from));
    invariant(!!toColorType, notAnimatable(to));
    invariant(fromColorType.transform === toColorType.transform, 'Both colors must be hex/RGBA, OR both must be HSLA.');
    var fromColor = fromColorType.parse(from);
    var toColor = toColorType.parse(to);
    var blended = __assign$1({}, fromColor);
    var mixFunc = fromColorType === hsla ? mix : mixLinearColor;
    return function (v) {
        for (var key in blended) {
            if (key !== 'alpha') {
                blended[key] = mixFunc(fromColor[key], toColor[key], v);
            }
        }
        blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
});

var combineFunctions = function (a, b) { return function (v) { return b(a(v)); }; };
var pipe = (function () {
    var transformers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        transformers[_i] = arguments[_i];
    }
    return transformers.reduce(combineFunctions);
});

function getMixer(origin, target) {
    if (isNum(origin)) {
        return function (v) { return mix(origin, target, v); };
    }
    else if (color.test(origin)) {
        return mixColor(origin, target);
    }
    else {
        return mixComplex(origin, target);
    }
}
var mixArray = function (from, to) {
    var output = from.slice();
    var numValues = output.length;
    var blendValue = from.map(function (fromThis, i) { return getMixer(fromThis, to[i]); });
    return function (v) {
        for (var i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
var mixObject = function (origin, target) {
    var output = __assign$1({}, origin, target);
    var blendValue = {};
    for (var key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer(origin[key], target[key]);
        }
    }
    return function (v) {
        for (var key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
function analyse(value) {
    var parsed = complex.parse(value);
    var numValues = parsed.length;
    var numNumbers = 0;
    var numRGB = 0;
    var numHSL = 0;
    for (var i = 0; i < numValues; i++) {
        if (numNumbers || typeof parsed[i] === 'number') {
            numNumbers++;
        }
        else {
            if (parsed[i].hue !== undefined) {
                numHSL++;
            }
            else {
                numRGB++;
            }
        }
    }
    return { parsed: parsed, numNumbers: numNumbers, numRGB: numRGB, numHSL: numHSL };
}
var mixComplex = function (origin, target) {
    var template = complex.createTransformer(target);
    var originStats = analyse(origin);
    var targetStats = analyse(target);
    invariant(originStats.numHSL === targetStats.numHSL &&
        originStats.numRGB === targetStats.numRGB &&
        originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
    return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
};

var mixNumber = function (from, to) { return function (p) { return mix(from, to, p); }; };
function detectMixerFactory(v) {
    if (typeof v === 'number') {
        return mixNumber;
    }
    else if (typeof v === 'string') {
        if (color.test(v)) {
            return mixColor;
        }
        else {
            return mixComplex;
        }
    }
    else if (Array.isArray(v)) {
        return mixArray;
    }
    else if (typeof v === 'object') {
        return mixObject;
    }
}
function createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || detectMixerFactory(output[0]);
    var numMixers = output.length - 1;
    for (var i = 0; i < numMixers; i++) {
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function fastInterpolate(_a, _b) {
    var from = _a[0], to = _a[1];
    var mixer = _b[0];
    return function (v) { return mixer(progress(from, to, v)); };
}
function slowInterpolate(input, mixers) {
    var inputLength = input.length;
    var lastInputIndex = inputLength - 1;
    return function (v) {
        var mixerIndex = 0;
        var foundMixerIndex = false;
        if (v <= input[0]) {
            foundMixerIndex = true;
        }
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            var i = 1;
            for (; i < inputLength; i++) {
                if (input[i] > v || i === lastInputIndex) {
                    break;
                }
            }
            mixerIndex = i - 1;
        }
        var progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function interpolate$1(input, output, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.clamp, clamp = _c === void 0 ? true : _c, ease = _b.ease, mixer = _b.mixer;
    var inputLength = input.length;
    invariant(inputLength === output.length, 'Both input and output ranges must be the same length');
    invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    var mixers = createMixers(output, ease, mixer);
    var interpolator = inputLength === 2
        ? fastInterpolate(input, mixers)
        : slowInterpolate(input, mixers);
    return clamp
        ? pipe(clamp$1(input[0], input[inputLength - 1]), interpolator)
        : interpolator;
}

var toDecimal = (function (num, precision) {
    if (precision === void 0) { precision = 2; }
    precision = Math.pow(10, precision);
    return Math.round(num * precision) / precision;
});

var smoothFrame = (function (prevValue, nextValue, duration, smoothing) {
    if (smoothing === void 0) { smoothing = 0; }
    return toDecimal(prevValue +
        (duration * (nextValue - prevValue)) / Math.max(smoothing, duration));
});

var smooth = (function (strength) {
    if (strength === void 0) { strength = 50; }
    var previousValue = 0;
    var lastUpdated = 0;
    return function (v) {
        var currentFramestamp = getFrameData().timestamp;
        var timeDelta = currentFramestamp !== lastUpdated ? currentFramestamp - lastUpdated : 0;
        var newValue = timeDelta
            ? smoothFrame(previousValue, v, timeDelta, strength)
            : previousValue;
        lastUpdated = currentFramestamp;
        previousValue = newValue;
        return newValue;
    };
});

var snap = (function (points) {
    if (typeof points === 'number') {
        return function (v) { return Math.round(v / points) * points; };
    }
    else {
        var i_1 = 0;
        var numPoints_1 = points.length;
        return function (v) {
            var lastDistance = Math.abs(points[0] - v);
            for (i_1 = 1; i_1 < numPoints_1; i_1++) {
                var point = points[i_1];
                var distance = Math.abs(point - v);
                if (distance === 0)
                    return point;
                if (distance > lastDistance)
                    return points[i_1 - 1];
                if (i_1 === numPoints_1 - 1)
                    return point;
                lastDistance = distance;
            }
        };
    }
});

var identity = function (v) { return v; };
var springForce = function (alterDisplacement) {
    if (alterDisplacement === void 0) { alterDisplacement = identity; }
    return curryRange(function (constant, origin, v) {
        var displacement = origin - v;
        var springModifiedDisplacement = -(0 - constant + 1) * (0 - alterDisplacement(Math.abs(displacement)));
        return displacement <= 0
            ? origin + springModifiedDisplacement
            : origin - springModifiedDisplacement;
    });
};
var springForceLinear = springForce();
var springForceExpo = springForce(Math.sqrt);

var velocityPerFrame = (function (xps, frameDuration) {
    return isNum(xps) ? xps / (1000 / frameDuration) : 0;
});

var velocityPerSecond = (function (velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
});

var wrap = function (min, max, v) {
    var rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};
var wrap$1 = curryRange(wrap);

clamp$1(0, 1);

var createStyler = function (_a) {
    var onRead = _a.onRead,
        onRender = _a.onRender,
        _b = _a.uncachedValues,
        uncachedValues = _b === void 0 ? new Set() : _b,
        _c = _a.useCache,
        useCache = _c === void 0 ? true : _c;
    return function (_a) {
        if (_a === void 0) {
            _a = {};
        }
        var props = __rest$1(_a, []);
        var state = {};
        var changedValues = [];
        var hasChanged = false;
        function setValue(key, value) {
            if (key.startsWith('--')) {
                props.hasCSSVariable = true;
            }
            var currentValue = state[key];
            state[key] = value;
            if (state[key] === currentValue) return;
            if (changedValues.indexOf(key) === -1) {
                changedValues.push(key);
            }
            if (!hasChanged) {
                hasChanged = true;
                sync.render(styler.render);
            }
        }
        var styler = {
            get: function (key, forceRead) {
                if (forceRead === void 0) {
                    forceRead = false;
                }
                var useCached = !forceRead && useCache && !uncachedValues.has(key) && state[key] !== undefined;
                return useCached ? state[key] : onRead(key, props);
            },
            set: function (values, value) {
                if (typeof values === 'string') {
                    setValue(values, value);
                } else {
                    for (var key in values) {
                        setValue(key, values[key]);
                    }
                }
                return this;
            },
            render: function (forceRender) {
                if (forceRender === void 0) {
                    forceRender = false;
                }
                if (hasChanged || forceRender === true) {
                    onRender(state, props, changedValues);
                    hasChanged = false;
                    changedValues.length = 0;
                }
                return this;
            }
        };
        return styler;
    };
};

var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = '$1-$2';
var camelToDash = function (str) {
    return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};

var camelCache = /*#__PURE__*/new Map();
var dashCache = /*#__PURE__*/new Map();
var prefixes = ['Webkit', 'Moz', 'O', 'ms', ''];
var numPrefixes = prefixes.length;
var isBrowser = typeof document !== 'undefined';
var testElement;
var setDashPrefix = function (key, prefixed) {
    return dashCache.set(key, camelToDash(prefixed));
};
var testPrefix = function (key) {
    testElement = testElement || document.createElement('div');
    for (var i = 0; i < numPrefixes; i++) {
        var prefix = prefixes[i];
        var noPrefix = prefix === '';
        var prefixedPropertyName = noPrefix ? key : prefix + key.charAt(0).toUpperCase() + key.slice(1);
        if (prefixedPropertyName in testElement.style || noPrefix) {
            if (noPrefix && key === 'clipPath' && dashCache.has(key)) {
                return;
            }
            camelCache.set(key, prefixedPropertyName);
            setDashPrefix(key, "" + (noPrefix ? '' : '-') + camelToDash(prefixedPropertyName));
        }
    }
};
var setServerProperty = function (key) {
    return setDashPrefix(key, key);
};
var prefixer = function (key, asDashCase) {
    if (asDashCase === void 0) {
        asDashCase = false;
    }
    var cache = asDashCase ? dashCache : camelCache;
    if (!cache.has(key)) {
        isBrowser ? testPrefix(key) : setServerProperty(key);
    }
    return cache.get(key) || key;
};

var axes = ['', 'X', 'Y', 'Z'];
var order = ['translate', 'scale', 'rotate', 'skew', 'transformPerspective'];
var transformProps = /*#__PURE__*/order.reduce(function (acc, key) {
    return axes.reduce(function (axesAcc, axesKey) {
        axesAcc.push(key + axesKey);
        return axesAcc;
    }, acc);
}, ['x', 'y', 'z']);
var transformPropDictionary = /*#__PURE__*/transformProps.reduce(function (dict, key) {
    dict[key] = true;
    return dict;
}, {});
function isTransformProp(key) {
    return transformPropDictionary[key] === true;
}
function sortTransformProps(a, b) {
    return transformProps.indexOf(a) - transformProps.indexOf(b);
}
var transformOriginProps = /*#__PURE__*/new Set(['originX', 'originY', 'originZ']);
function isTransformOriginProp(key) {
    return transformOriginProps.has(key);
}

var int = /*#__PURE__*/__assign$2( /*#__PURE__*/__assign$2({}, number), { transform: Math.round });
var valueTypes = {
    color: color,
    backgroundColor: color,
    outlineColor: color,
    fill: color,
    stroke: color,
    borderColor: color,
    borderTopColor: color,
    borderRightColor: color,
    borderBottomColor: color,
    borderLeftColor: color,
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    size: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    rotate: degrees,
    rotateX: degrees,
    rotateY: degrees,
    rotateZ: degrees,
    scale: scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees,
    skewX: degrees,
    skewY: degrees,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
    zIndex: int,
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: int
};
var getValueType$1 = function (key) {
    return valueTypes[key];
};
var getValueAsType = function (value, type) {
    return type && typeof value === 'number' ? type.transform(value) : value;
};

var SCROLL_LEFT = 'scrollLeft';
var SCROLL_TOP = 'scrollTop';
var scrollKeys = /*#__PURE__*/new Set([SCROLL_LEFT, SCROLL_TOP]);

var blacklist = /*#__PURE__*/new Set([SCROLL_LEFT, SCROLL_TOP, 'transform']);
var translateAlias = {
    x: 'translateX',
    y: 'translateY',
    z: 'translateZ'
};
function isCustomTemplate(v) {
    return typeof v === 'function';
}
function buildTransform(state, transform, transformKeys, transformIsDefault, enableHardwareAcceleration, allowTransformNone) {
    if (allowTransformNone === void 0) {
        allowTransformNone = true;
    }
    var transformString = '';
    var transformHasZ = false;
    transformKeys.sort(sortTransformProps);
    var numTransformKeys = transformKeys.length;
    for (var i = 0; i < numTransformKeys; i++) {
        var key = transformKeys[i];
        transformString += (translateAlias[key] || key) + "(" + transform[key] + ") ";
        transformHasZ = key === 'z' ? true : transformHasZ;
    }
    if (!transformHasZ && enableHardwareAcceleration) {
        transformString += 'translateZ(0)';
    } else {
        transformString = transformString.trim();
    }
    if (isCustomTemplate(state.transform)) {
        transformString = state.transform(transform, transformIsDefault ? '' : transformString);
    } else if (allowTransformNone && transformIsDefault) {
        transformString = 'none';
    }
    return transformString;
}
function buildStyleProperty(state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, isDashCase, allowTransformNone) {
    if (enableHardwareAcceleration === void 0) {
        enableHardwareAcceleration = true;
    }
    if (styles === void 0) {
        styles = {};
    }
    if (transform === void 0) {
        transform = {};
    }
    if (transformOrigin === void 0) {
        transformOrigin = {};
    }
    if (transformKeys === void 0) {
        transformKeys = [];
    }
    if (isDashCase === void 0) {
        isDashCase = false;
    }
    if (allowTransformNone === void 0) {
        allowTransformNone = true;
    }
    var transformIsDefault = true;
    var hasTransform = false;
    var hasTransformOrigin = false;
    for (var key in state) {
        var value = state[key];
        var valueType = getValueType$1(key);
        var valueAsType = getValueAsType(value, valueType);
        if (isTransformProp(key)) {
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            if (transformIsDefault) {
                if (valueType.default && value !== valueType.default || !valueType.default && value !== 0) {
                    transformIsDefault = false;
                }
            }
        } else if (isTransformOriginProp(key)) {
            transformOrigin[key] = valueAsType;
            hasTransformOrigin = true;
        } else if (!blacklist.has(key) || !isCustomTemplate(valueAsType)) {
            styles[prefixer(key, isDashCase)] = valueAsType;
        }
    }
    if (hasTransform || typeof state.transform === 'function') {
        styles.transform = buildTransform(state, transform, transformKeys, transformIsDefault, enableHardwareAcceleration, allowTransformNone);
    }
    if (hasTransformOrigin) {
        styles.transformOrigin = (transformOrigin.originX || '50%') + " " + (transformOrigin.originY || '50%') + " " + (transformOrigin.originZ || 0);
    }
    return styles;
}
function createStyleBuilder(_a) {
    var _b = _a === void 0 ? {} : _a,
        _c = _b.enableHardwareAcceleration,
        enableHardwareAcceleration = _c === void 0 ? true : _c,
        _d = _b.isDashCase,
        isDashCase = _d === void 0 ? true : _d,
        _e = _b.allowTransformNone,
        allowTransformNone = _e === void 0 ? true : _e;
    var styles = {};
    var transform = {};
    var transformOrigin = {};
    var transformKeys = [];
    return function (state) {
        transformKeys.length = 0;
        buildStyleProperty(state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, isDashCase, allowTransformNone);
        return styles;
    };
}

function onRead(key, options) {
    var element = options.element,
        preparseOutput = options.preparseOutput;
    var defaultValueType = getValueType$1(key);
    if (isTransformProp(key)) {
        return defaultValueType ? defaultValueType.default || 0 : 0;
    } else if (scrollKeys.has(key)) {
        return element[key];
    } else {
        var domValue = window.getComputedStyle(element, null).getPropertyValue(prefixer(key, true)) || 0;
        return preparseOutput && defaultValueType && defaultValueType.test(domValue) && defaultValueType.parse ? defaultValueType.parse(domValue) : domValue;
    }
}
function onRender(state, _a, changedValues) {
    var element = _a.element,
        buildStyles = _a.buildStyles,
        hasCSSVariable = _a.hasCSSVariable;
    Object.assign(element.style, buildStyles(state));
    if (hasCSSVariable) {
        var numChangedValues = changedValues.length;
        for (var i = 0; i < numChangedValues; i++) {
            var key = changedValues[i];
            if (key.startsWith('--')) {
                element.style.setProperty(key, state[key]);
            }
        }
    }
    if (changedValues.indexOf(SCROLL_LEFT) !== -1) {
        element[SCROLL_LEFT] = state[SCROLL_LEFT];
    }
    if (changedValues.indexOf(SCROLL_TOP) !== -1) {
        element[SCROLL_TOP] = state[SCROLL_TOP];
    }
}
var cssStyler = /*#__PURE__*/createStyler({
    onRead: onRead,
    onRender: onRender,
    uncachedValues: scrollKeys
});
function createCssStyler(element, _a) {
    if (_a === void 0) {
        _a = {};
    }
    var enableHardwareAcceleration = _a.enableHardwareAcceleration,
        allowTransformNone = _a.allowTransformNone,
        props = __rest$1(_a, ["enableHardwareAcceleration", "allowTransformNone"]);
    return cssStyler(__assign$2({ element: element, buildStyles: createStyleBuilder({
            enableHardwareAcceleration: enableHardwareAcceleration,
            allowTransformNone: allowTransformNone
        }), preparseOutput: true }, props));
}

var camelCaseAttributes = /*#__PURE__*/new Set(['baseFrequency', 'diffuseConstant', 'kernelMatrix', 'kernelUnitLength', 'keySplines', 'keyTimes', 'limitingConeAngle', 'markerHeight', 'markerWidth', 'numOctaves', 'targetX', 'targetY', 'surfaceScale', 'specularConstant', 'specularExponent', 'stdDeviation', 'tableValues']);

var defaultOrigin = 0.5;
var svgAttrsTemplate = function () {
    return {
        style: {}
    };
};
var progressToPixels = function (progress, length) {
    return px.transform(progress * length);
};
var unmeasured = { x: 0, y: 0, width: 0, height: 0 };
function calcOrigin(origin, offset, size) {
    return typeof origin === 'string' ? origin : px.transform(offset + size * origin);
}
function calculateSVGTransformOrigin(dimensions, originX, originY) {
    return calcOrigin(originX, dimensions.x, dimensions.width) + " " + calcOrigin(originY, dimensions.y, dimensions.height);
}
var svgStyleConfig = {
    enableHardwareAcceleration: false,
    isDashCase: false
};
function buildSVGAttrs(_a, dimensions, totalPathLength, cssBuilder, attrs, isDashCase) {
    if (dimensions === void 0) {
        dimensions = unmeasured;
    }
    if (cssBuilder === void 0) {
        cssBuilder = createStyleBuilder(svgStyleConfig);
    }
    if (attrs === void 0) {
        attrs = svgAttrsTemplate();
    }
    if (isDashCase === void 0) {
        isDashCase = true;
    }
    var attrX = _a.attrX,
        attrY = _a.attrY,
        originX = _a.originX,
        originY = _a.originY,
        pathLength = _a.pathLength,
        _b = _a.pathSpacing,
        pathSpacing = _b === void 0 ? 1 : _b,
        _c = _a.pathOffset,
        pathOffset = _c === void 0 ? 0 : _c,
        state = __rest$1(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
    var style = cssBuilder(state);
    for (var key in style) {
        if (key === 'transform') {
            attrs.style.transform = style[key];
        } else {
            var attrKey = isDashCase && !camelCaseAttributes.has(key) ? camelToDash(key) : key;
            attrs[attrKey] = style[key];
        }
    }
    if (originX !== undefined || originY !== undefined || style.transform) {
        attrs.style.transformOrigin = calculateSVGTransformOrigin(dimensions, originX !== undefined ? originX : defaultOrigin, originY !== undefined ? originY : defaultOrigin);
    }
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (totalPathLength !== undefined && pathLength !== undefined) {
        attrs[isDashCase ? 'stroke-dashoffset' : 'strokeDashoffset'] = progressToPixels(-pathOffset, totalPathLength);
        attrs[isDashCase ? 'stroke-dasharray' : 'strokeDasharray'] = progressToPixels(pathLength, totalPathLength) + " " + progressToPixels(pathSpacing, totalPathLength);
    }
    return attrs;
}
function createAttrBuilder(dimensions, totalPathLength, isDashCase) {
    if (isDashCase === void 0) {
        isDashCase = true;
    }
    var attrs = svgAttrsTemplate();
    var cssBuilder = createStyleBuilder(svgStyleConfig);
    return function (state) {
        return buildSVGAttrs(state, dimensions, totalPathLength, cssBuilder, attrs, isDashCase);
    };
}

var getDimensions = function (element) {
    return typeof element.getBBox === 'function' ? element.getBBox() : element.getBoundingClientRect();
};
var getSVGElementDimensions = function (element) {
    try {
        return getDimensions(element);
    } catch (e) {
        return { x: 0, y: 0, width: 0, height: 0 };
    }
};

var isPath = function (element) {
    return element.tagName === 'path';
};
var svgStyler = /*#__PURE__*/createStyler({
    onRead: function (key, _a) {
        var element = _a.element;
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        if (!isTransformProp(key)) {
            return element.getAttribute(key);
        } else {
            var valueType = getValueType$1(key);
            return valueType ? valueType.default || 0 : 0;
        }
    },
    onRender: function (state, _a) {
        var element = _a.element,
            buildAttrs = _a.buildAttrs;
        var attrs = buildAttrs(state);
        for (var key in attrs) {
            if (key === 'style') {
                Object.assign(element.style, attrs.style);
            } else {
                element.setAttribute(key, attrs[key]);
            }
        }
    }
});
var svg = function (element) {
    var dimensions = getSVGElementDimensions(element);
    var pathLength = isPath(element) && element.getTotalLength ? element.getTotalLength() : undefined;
    return svgStyler({
        element: element,
        buildAttrs: createAttrBuilder(dimensions, pathLength)
    });
};

var viewport = /*#__PURE__*/createStyler({
    useCache: false,
    onRead: function (key) {
        return key === 'scrollTop' ? window.pageYOffset : window.pageXOffset;
    },
    onRender: function (_a) {
        var _b = _a.scrollTop,
            scrollTop = _b === void 0 ? 0 : _b,
            _c = _a.scrollLeft,
            scrollLeft = _c === void 0 ? 0 : _c;
        return window.scrollTo(scrollLeft, scrollTop);
    }
});

var cache = /*#__PURE__*/new WeakMap();
var isHTMLElement = function (node) {
    return node instanceof HTMLElement || typeof node.click === 'function';
};
var isSVGElement = function (node) {
    return node instanceof SVGElement || 'ownerSVGElement' in node;
};
var createDOMStyler = function (node, props) {
    var styler;
    if (node === window) {
        styler = viewport(node);
    } else if (isHTMLElement(node)) {
        styler = createCssStyler(node, props);
    } else if (isSVGElement(node)) {
        styler = svg(node);
    }
    invariant(styler !== undefined, 'No valid node provided. Node must be HTMLElement, SVGElement or window.');
    cache.set(node, styler);
    return styler;
};
var getStyler = function (node, props) {
    return cache.has(node) ? cache.get(node) : createDOMStyler(node, props);
};
function index$2(nodeOrSelector, props) {
    var node = typeof nodeOrSelector === 'string' ? document.querySelector(nodeOrSelector) : nodeOrSelector;
    return getStyler(node, props);
}

var Chainable = /*#__PURE__*/function () {
    function Chainable(props) {
        if (props === void 0) {
            props = {};
        }
        this.props = props;
    }
    Chainable.prototype.applyMiddleware = function (middleware) {
        return this.create(__assign$2(__assign$2({}, this.props), { middleware: this.props.middleware ? __spreadArrays([middleware], this.props.middleware) : [middleware] }));
    };
    Chainable.prototype.pipe = function () {
        var funcs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            funcs[_i] = arguments[_i];
        }
        var pipedUpdate = funcs.length === 1 ? funcs[0] : pipe.apply(void 0, funcs);
        return this.applyMiddleware(function (update) {
            return function (v) {
                return update(pipedUpdate(v));
            };
        });
    };
    Chainable.prototype.while = function (predicate) {
        return this.applyMiddleware(function (update, complete) {
            return function (v) {
                return predicate(v) ? update(v) : complete();
            };
        });
    };
    Chainable.prototype.filter = function (predicate) {
        return this.applyMiddleware(function (update) {
            return function (v) {
                return predicate(v) && update(v);
            };
        });
    };
    return Chainable;
}();

var Observer = /*#__PURE__*/function () {
    function Observer(_a, observer) {
        var _this = this;
        var middleware = _a.middleware,
            onComplete = _a.onComplete;
        this.isActive = true;
        this.update = function (v) {
            if (_this.observer.update) _this.updateObserver(v);
        };
        this.complete = function () {
            if (_this.observer.complete && _this.isActive) _this.observer.complete();
            if (_this.onComplete) _this.onComplete();
            _this.isActive = false;
        };
        this.error = function (err) {
            if (_this.observer.error && _this.isActive) _this.observer.error(err);
            _this.isActive = false;
        };
        this.observer = observer;
        this.updateObserver = function (v) {
            return observer.update(v);
        };
        this.onComplete = onComplete;
        if (observer.update && middleware && middleware.length) {
            middleware.forEach(function (m) {
                return _this.updateObserver = m(_this.updateObserver, _this.complete);
            });
        }
    }
    return Observer;
}();
var createObserver = function (observerCandidate, _a, onComplete) {
    var middleware = _a.middleware;
    if (typeof observerCandidate === 'function') {
        return new Observer({ middleware: middleware, onComplete: onComplete }, { update: observerCandidate });
    } else {
        return new Observer({ middleware: middleware, onComplete: onComplete }, observerCandidate);
    }
};

var Action = /*#__PURE__*/function (_super) {
    __extends(Action, _super);
    function Action() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Action.prototype.create = function (props) {
        return new Action(props);
    };
    Action.prototype.start = function (observerCandidate) {
        if (observerCandidate === void 0) {
            observerCandidate = {};
        }
        var isComplete = false;
        var subscription = {
            stop: function () {
                return undefined;
            }
        };
        var _a = this.props,
            init = _a.init,
            observerProps = __rest$1(_a, ["init"]);
        var observer = createObserver(observerCandidate, observerProps, function () {
            isComplete = true;
            subscription.stop();
        });
        var api = init(observer);
        subscription = api ? __assign$2(__assign$2({}, subscription), api) : subscription;
        if (observerCandidate.registerParent) {
            observerCandidate.registerParent(subscription);
        }
        if (isComplete) subscription.stop();
        return subscription;
    };
    return Action;
}(Chainable);
var action = function (init) {
    return new Action({ init: init });
};

var BaseMulticast = /*#__PURE__*/function (_super) {
    __extends(BaseMulticast, _super);
    function BaseMulticast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.subscribers = [];
        return _this;
    }
    BaseMulticast.prototype.complete = function () {
        this.subscribers.forEach(function (subscriber) {
            return subscriber.complete();
        });
    };
    BaseMulticast.prototype.error = function (err) {
        this.subscribers.forEach(function (subscriber) {
            return subscriber.error(err);
        });
    };
    BaseMulticast.prototype.update = function (v) {
        for (var i = 0; i < this.subscribers.length; i++) {
            this.subscribers[i].update(v);
        }
    };
    BaseMulticast.prototype.subscribe = function (observerCandidate) {
        var _this = this;
        var observer = createObserver(observerCandidate, this.props);
        this.subscribers.push(observer);
        var subscription = {
            unsubscribe: function () {
                var index = _this.subscribers.indexOf(observer);
                if (index !== -1) _this.subscribers.splice(index, 1);
            }
        };
        return subscription;
    };
    BaseMulticast.prototype.stop = function () {
        if (this.parent) this.parent.stop();
    };
    BaseMulticast.prototype.registerParent = function (subscription) {
        this.stop();
        this.parent = subscription;
    };
    return BaseMulticast;
}(Chainable);

var stepProgress = function (steps, progress) {
    var segment = 1 / (steps - 1);
    var subsegment = 1 / (2 * (steps - 1));
    var percentProgressOfTarget = Math.min(progress, 1);
    var subsegmentProgressOfTarget = percentProgressOfTarget / subsegment;
    var segmentProgressOfTarget = Math.floor((subsegmentProgressOfTarget + 1) / 2);
    return segmentProgressOfTarget * segment;
};

var isValueList = function (v) {
    return Array.isArray(v);
};
var isSingleValue = function (v) {
    var typeOfV = typeof v;
    return typeOfV === 'string' || typeOfV === 'number';
};
var ValueReaction = /*#__PURE__*/function (_super) {
    __extends(ValueReaction, _super);
    function ValueReaction(props) {
        var _this = _super.call(this, props) || this;
        _this.scheduleVelocityCheck = function () {
            return sync.postRender(_this.velocityCheck);
        };
        _this.velocityCheck = function (_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
            }
        };
        _this.prev = _this.current = props.value || 0;
        if (isSingleValue(_this.current)) {
            _this.updateCurrent = function (v) {
                return _this.current = v;
            };
            _this.getVelocityOfCurrent = function () {
                return _this.getSingleVelocity(_this.current, _this.prev);
            };
        } else if (isValueList(_this.current)) {
            _this.updateCurrent = function (v) {
                return _this.current = __spreadArrays(v);
            };
            _this.getVelocityOfCurrent = function () {
                return _this.getListVelocity();
            };
        } else {
            _this.updateCurrent = function (v) {
                _this.current = {};
                for (var key in v) {
                    if (v.hasOwnProperty(key)) {
                        _this.current[key] = v[key];
                    }
                }
            };
            _this.getVelocityOfCurrent = function () {
                return _this.getMapVelocity();
            };
        }
        if (props.initialSubscription) _this.subscribe(props.initialSubscription);
        return _this;
    }
    ValueReaction.prototype.create = function (props) {
        return new ValueReaction(props);
    };
    ValueReaction.prototype.get = function () {
        return this.current;
    };
    ValueReaction.prototype.getVelocity = function () {
        return this.getVelocityOfCurrent();
    };
    ValueReaction.prototype.update = function (v) {
        _super.prototype.update.call(this, v);
        this.prev = this.current;
        this.updateCurrent(v);
        var _a = getFrameData(),
            delta = _a.delta,
            timestamp = _a.timestamp;
        this.timeDelta = delta;
        this.lastUpdated = timestamp;
        sync.postRender(this.scheduleVelocityCheck);
    };
    ValueReaction.prototype.subscribe = function (observerCandidate) {
        var sub = _super.prototype.subscribe.call(this, observerCandidate);
        this.subscribers[this.subscribers.length - 1].update(this.current);
        return sub;
    };
    ValueReaction.prototype.getSingleVelocity = function (current, prev) {
        return typeof current === 'number' && typeof prev === 'number' ? velocityPerSecond(current - prev, this.timeDelta) : velocityPerSecond(parseFloat(current) - parseFloat(prev), this.timeDelta) || 0;
    };
    ValueReaction.prototype.getListVelocity = function () {
        var _this = this;
        return this.current.map(function (c, i) {
            return _this.getSingleVelocity(c, _this.prev[i]);
        });
    };
    ValueReaction.prototype.getMapVelocity = function () {
        var velocity = {};
        for (var key in this.current) {
            if (this.current.hasOwnProperty(key)) {
                velocity[key] = this.getSingleVelocity(this.current[key], this.prev[key]);
            }
        }
        return velocity;
    };
    return ValueReaction;
}(BaseMulticast);
var value = function (value, initialSubscription) {
    return new ValueReaction({ value: value, initialSubscription: initialSubscription });
};

var multi = function (_a) {
    var getCount = _a.getCount,
        getFirst = _a.getFirst,
        getOutput = _a.getOutput,
        mapApi = _a.mapApi,
        setProp = _a.setProp,
        startActions = _a.startActions;
    return function (actions) {
        return action(function (_a) {
            var update = _a.update,
                complete = _a.complete,
                error = _a.error;
            var numActions = getCount(actions);
            var output = getOutput();
            var updateOutput = function () {
                return update(output);
            };
            var numCompletedActions = 0;
            var subs = startActions(actions, function (a, name) {
                var hasCompleted = false;
                return a.start({
                    complete: function () {
                        if (!hasCompleted) {
                            hasCompleted = true;
                            numCompletedActions++;
                            if (numCompletedActions === numActions) sync.update(complete);
                        }
                    },
                    error: error,
                    update: function (v) {
                        setProp(output, name, v);
                        sync.update(updateOutput, false, true);
                    }
                });
            });
            return Object.keys(getFirst(subs)).reduce(function (api, methodName) {
                api[methodName] = mapApi(subs, methodName);
                return api;
            }, {});
        });
    };
};

var composite = /*#__PURE__*/multi({
    getOutput: function () {
        return {};
    },
    getCount: function (subs) {
        return Object.keys(subs).length;
    },
    getFirst: function (subs) {
        return subs[Object.keys(subs)[0]];
    },
    mapApi: function (subs, methodName) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return Object.keys(subs).reduce(function (output, propKey) {
                var _a;
                if (subs[propKey][methodName]) {
                    args[0] && args[0][propKey] !== undefined ? output[propKey] = subs[propKey][methodName](args[0][propKey]) : output[propKey] = (_a = subs[propKey])[methodName].apply(_a, args);
                }
                return output;
            }, {});
        };
    },
    setProp: function (output, name, v) {
        return output[name] = v;
    },
    startActions: function (actions, starter) {
        return Object.keys(actions).reduce(function (subs, key) {
            subs[key] = starter(actions[key], key);
            return subs;
        }, {});
    }
});

var parallel = /*#__PURE__*/multi({
    getOutput: function () {
        return [];
    },
    getCount: function (subs) {
        return subs.length;
    },
    getFirst: function (subs) {
        return subs[0];
    },
    mapApi: function (subs, methodName) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return subs.map(function (sub, i) {
                if (sub[methodName]) {
                    return Array.isArray(args[0]) ? sub[methodName](args[0][i]) : sub[methodName].apply(sub, args);
                }
            });
        };
    },
    setProp: function (output, name, v) {
        return output[name] = v;
    },
    startActions: function (actions, starter) {
        return actions.map(function (action, i) {
            return starter(action, i);
        });
    }
});
var parallel$1 = function () {
    var actions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        actions[_i] = arguments[_i];
    }
    return parallel(actions);
};

var createVectorTests = function (typeTests) {
    var testNames = Object.keys(typeTests);
    var isVectorProp = function (prop, key) {
        return prop !== undefined && !typeTests[key](prop);
    };
    var getVectorKeys = function (props) {
        return testNames.reduce(function (vectorKeys, key) {
            if (isVectorProp(props[key], key)) vectorKeys.push(key);
            return vectorKeys;
        }, []);
    };
    var testVectorProps = function (props) {
        return props && testNames.some(function (key) {
            return isVectorProp(props[key], key);
        });
    };
    return { getVectorKeys: getVectorKeys, testVectorProps: testVectorProps };
};
var unitTypes = [px, percent, degrees, vh, vw];
var findUnitType = function (prop) {
    return unitTypes.find(function (type) {
        return type.test(prop);
    });
};
var isUnitProp = function (prop) {
    return Boolean(findUnitType(prop));
};
var createAction = function (action, props) {
    return action(props);
};
var reduceArrayValue = function (i) {
    return function (props, key) {
        props[key] = props[key][i];
        return props;
    };
};
var createArrayAction = function (action, props, vectorKeys) {
    var firstVectorKey = vectorKeys[0];
    var actionList = props[firstVectorKey].map(function (v, i) {
        var childActionProps = vectorKeys.reduce(reduceArrayValue(i), __assign$2({}, props));
        return getActionCreator(v)(action, childActionProps);
    });
    return parallel$1.apply(void 0, actionList);
};
var reduceObjectValue = function (key) {
    return function (props, propKey) {
        props[propKey] = props[propKey][key];
        return props;
    };
};
var createObjectAction = function (action, props, vectorKeys) {
    var firstVectorKey = vectorKeys[0];
    var actionMap = Object.keys(props[firstVectorKey]).reduce(function (map, key) {
        var childActionProps = vectorKeys.reduce(reduceObjectValue(key), __assign$2({}, props));
        map[key] = getActionCreator(props[firstVectorKey][key])(action, childActionProps);
        return map;
    }, {});
    return composite(actionMap);
};
var createUnitAction = function (action, _a) {
    var from = _a.from,
        to = _a.to,
        props = __rest$1(_a, ["from", "to"]);
    var unitType = findUnitType(from) || findUnitType(to);
    var transform = unitType.transform,
        parse = unitType.parse;
    return action(__assign$2(__assign$2({}, props), { from: typeof from === 'string' ? parse(from) : from, to: typeof to === 'string' ? parse(to) : to })).pipe(transform);
};
var createMixerAction = function (mixer) {
    return function (action, _a) {
        var from = _a.from,
            to = _a.to,
            props = __rest$1(_a, ["from", "to"]);
        return action(__assign$2(__assign$2({}, props), { from: 0, to: 1 })).pipe(mixer(from, to));
    };
};
var createColorAction = /*#__PURE__*/createMixerAction(mixColor);
var createComplexAction = /*#__PURE__*/createMixerAction(mixComplex);
var createVectorAction = function (action, typeTests) {
    var _a = createVectorTests(typeTests),
        testVectorProps = _a.testVectorProps,
        getVectorKeys = _a.getVectorKeys;
    var vectorAction = function (props) {
        var isVector = testVectorProps(props);
        if (!isVector) return action(props);
        var vectorKeys = getVectorKeys(props);
        var testKey = vectorKeys[0];
        var testProp = props[testKey];
        return getActionCreator(testProp)(action, props, vectorKeys);
    };
    return vectorAction;
};
var getActionCreator = function (prop) {
    if (typeof prop === 'number') {
        return createAction;
    } else if (Array.isArray(prop)) {
        return createArrayAction;
    } else if (isUnitProp(prop)) {
        return createUnitAction;
    } else if (color.test(prop)) {
        return createColorAction;
    } else if (complex.test(prop)) {
        return createComplexAction;
    } else if (typeof prop === 'object') {
        return createObjectAction;
    } else {
        return createAction;
    }
};

var decay = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var complete = _a.complete,
            update = _a.update;
        var _b = props.velocity,
            velocity = _b === void 0 ? 0 : _b,
            _c = props.from,
            from = _c === void 0 ? 0 : _c,
            _d = props.power,
            power = _d === void 0 ? 0.8 : _d,
            _e = props.timeConstant,
            timeConstant = _e === void 0 ? 350 : _e,
            _f = props.restDelta,
            restDelta = _f === void 0 ? 0.5 : _f,
            modifyTarget = props.modifyTarget;
        var elapsed = 0;
        var amplitude = power * velocity;
        var idealTarget = from + amplitude;
        var target = typeof modifyTarget === 'undefined' ? idealTarget : modifyTarget(idealTarget);
        if (target !== idealTarget) amplitude = target - from;
        var process = sync.update(function (_a) {
            var frameDelta = _a.delta;
            elapsed += frameDelta;
            var delta = -amplitude * Math.exp(-elapsed / timeConstant);
            var isMoving = delta > restDelta || delta < -restDelta;
            var current = isMoving ? target + delta : target;
            update(current);
            if (!isMoving) {
                cancelSync.update(process);
                complete();
            }
        }, true);
        return {
            stop: function () {
                return cancelSync.update(process);
            }
        };
    });
};
var vectorDecay = /*#__PURE__*/createVectorAction(decay, {
    from: number.test,
    modifyTarget: function (func) {
        return typeof func === 'function';
    },
    velocity: number.test
});

var spring = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var _b = props.velocity,
            velocity = _b === void 0 ? 0.0 : _b;
        var _c = props.from,
            from = _c === void 0 ? 0.0 : _c,
            _d = props.to,
            to = _d === void 0 ? 0.0 : _d,
            _e = props.stiffness,
            stiffness = _e === void 0 ? 100 : _e,
            _f = props.damping,
            damping = _f === void 0 ? 10 : _f,
            _g = props.mass,
            mass = _g === void 0 ? 1.0 : _g,
            _h = props.restSpeed,
            restSpeed = _h === void 0 ? 0.01 : _h,
            _j = props.restDelta,
            restDelta = _j === void 0 ? 0.01 : _j;
        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        var t = 0;
        var delta = to - from;
        var position = from;
        var prevPosition = position;
        var process = sync.update(function (_a) {
            var timeDelta = _a.delta;
            t += timeDelta;
            var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
            var angularFreq = Math.sqrt(stiffness / mass) / 1000;
            prevPosition = position;
            if (dampingRatio < 1) {
                var envelope = Math.exp(-dampingRatio * angularFreq * t);
                var expoDecay = angularFreq * Math.sqrt(1.0 - dampingRatio * dampingRatio);
                position = to - envelope * ((initialVelocity + dampingRatio * angularFreq * delta) / expoDecay * Math.sin(expoDecay * t) + delta * Math.cos(expoDecay * t));
            } else {
                var envelope = Math.exp(-angularFreq * t);
                position = to - envelope * (delta + (initialVelocity + angularFreq * delta) * t);
            }
            velocity = velocityPerSecond(position - prevPosition, timeDelta);
            var isBelowVelocityThreshold = Math.abs(velocity) <= restSpeed;
            var isBelowDisplacementThreshold = Math.abs(to - position) <= restDelta;
            if (isBelowVelocityThreshold && isBelowDisplacementThreshold) {
                position = to;
                update(position);
                cancelSync.update(process);
                complete();
            } else {
                update(position);
            }
        }, true);
        return {
            stop: function () {
                return cancelSync.update(process);
            }
        };
    });
};
var vectorSpring = /*#__PURE__*/createVectorAction(spring, {
    from: number.test,
    to: number.test,
    stiffness: number.test,
    damping: number.test,
    mass: number.test,
    velocity: number.test
});

var scrubber = function (_a) {
    var _b = _a.from,
        from = _b === void 0 ? 0 : _b,
        _c = _a.to,
        to = _c === void 0 ? 1 : _c,
        _d = _a.ease,
        ease = _d === void 0 ? linear : _d,
        _e = _a.reverseEase,
        reverseEase = _e === void 0 ? false : _e;
    if (reverseEase) {
        ease = createReversedEasing(ease);
    }
    return action(function (_a) {
        var update = _a.update;
        return {
            seek: function (progress) {
                return update(progress);
            }
        };
    }).pipe(ease, function (v) {
        return mix(from, to, v);
    });
};
var vectorScrubber = /*#__PURE__*/createVectorAction(scrubber, {
    ease: function (func) {
        return typeof func === 'function';
    },
    from: number.test,
    to: number.test
});

var clampProgress = /*#__PURE__*/clamp$1(0, 1);
var tween = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var _b = props.duration,
            duration = _b === void 0 ? 300 : _b,
            _c = props.ease,
            ease = _c === void 0 ? easeOut : _c,
            _d = props.flip,
            flip = _d === void 0 ? 0 : _d,
            _e = props.loop,
            loop = _e === void 0 ? 0 : _e,
            _f = props.yoyo,
            yoyo = _f === void 0 ? 0 : _f,
            _g = props.repeatDelay,
            repeatDelay = _g === void 0 ? 0 : _g;
        var _h = props.from,
            from = _h === void 0 ? 0 : _h,
            _j = props.to,
            to = _j === void 0 ? 1 : _j,
            _k = props.elapsed,
            elapsed = _k === void 0 ? 0 : _k,
            _l = props.flipCount,
            flipCount = _l === void 0 ? 0 : _l,
            _m = props.yoyoCount,
            yoyoCount = _m === void 0 ? 0 : _m,
            _o = props.loopCount,
            loopCount = _o === void 0 ? 0 : _o;
        var playhead = vectorScrubber({ from: from, to: to, ease: ease }).start(update);
        var currentProgress = 0;
        var process;
        var isActive = false;
        var reverseAnimation = function (reverseEase) {
            var _a;
            if (reverseEase === void 0) {
                reverseEase = false;
            }
            _a = [to, from], from = _a[0], to = _a[1];
            playhead = vectorScrubber({ from: from, to: to, ease: ease, reverseEase: reverseEase }).start(update);
        };
        var isTweenComplete = function () {
            var isComplete = isActive && elapsed > duration + repeatDelay;
            if (!isComplete) return false;
            if (isComplete && !loop && !flip && !yoyo) return true;
            elapsed = duration - (elapsed - repeatDelay);
            if (loop && loopCount < loop) {
                loopCount++;
                return false;
            } else if (flip && flipCount < flip) {
                flipCount++;
                reverseAnimation();
                return false;
            } else if (yoyo && yoyoCount < yoyo) {
                yoyoCount++;
                reverseAnimation(yoyoCount % 2 !== 0);
                return false;
            }
            return true;
        };
        var updateTween = function () {
            currentProgress = clampProgress(progress(0, duration, elapsed));
            playhead.seek(currentProgress);
        };
        var startTimer = function () {
            isActive = true;
            process = sync.update(function (_a) {
                var delta = _a.delta;
                elapsed += delta;
                updateTween();
                if (isTweenComplete()) {
                    cancelSync.update(process);
                    complete && sync.update(complete, false, true);
                }
            }, true);
        };
        var stopTimer = function () {
            isActive = false;
            if (process) cancelSync.update(process);
        };
        startTimer();
        return {
            isActive: function () {
                return isActive;
            },
            getElapsed: function () {
                return clamp$1(0, duration, elapsed);
            },
            getProgress: function () {
                return currentProgress;
            },
            stop: function () {
                stopTimer();
            },
            pause: function () {
                stopTimer();
                return this;
            },
            resume: function () {
                if (!isActive) startTimer();
                return this;
            },
            seek: function (newProgress) {
                elapsed = mix(0, duration, newProgress);
                sync.update(updateTween, false, true);
                return this;
            },
            reverse: function () {
                reverseAnimation();
                return this;
            }
        };
    });
};

var clampProgress$1 = /*#__PURE__*/clamp$1(0, 1);
var defaultEasings = function (values, easing) {
    return values.map(function () {
        return easing || easeOut;
    }).splice(0, values.length - 1);
};
var defaultTimings = function (values) {
    var numValues = values.length;
    return values.map(function (value, i) {
        return i !== 0 ? i / (numValues - 1) : 0;
    });
};
var interpolateScrubbers = function (input, scrubbers, update) {
    var rangeLength = input.length;
    var finalInputIndex = rangeLength - 1;
    var finalScrubberIndex = finalInputIndex - 1;
    var subs = scrubbers.map(function (scrub) {
        return scrub.start(update);
    });
    return function (v) {
        if (v <= input[0]) {
            subs[0].seek(0);
        }
        if (v >= input[finalInputIndex]) {
            subs[finalScrubberIndex].seek(1);
        }
        var i = 1;
        for (; i < rangeLength; i++) {
            if (input[i] > v || i === finalInputIndex) break;
        }
        var progressInRange = progress(input[i - 1], input[i], v);
        subs[i - 1].seek(clampProgress$1(progressInRange));
    };
};
var keyframes = function (_a) {
    var easings = _a.easings,
        _b = _a.ease,
        ease = _b === void 0 ? linear : _b,
        times = _a.times,
        values = _a.values,
        tweenProps = __rest$1(_a, ["easings", "ease", "times", "values"]);
    easings = Array.isArray(easings) ? easings : defaultEasings(values, easings);
    times = times || defaultTimings(values);
    var scrubbers = easings.map(function (easing, i) {
        return vectorScrubber({
            from: values[i],
            to: values[i + 1],
            ease: easing
        });
    });
    return tween(__assign$2(__assign$2({}, tweenProps), { ease: ease })).applyMiddleware(function (update) {
        return interpolateScrubbers(times, scrubbers, update);
    });
};

var physics = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var complete = _a.complete,
            update = _a.update;
        var _b = props.acceleration,
            acceleration = _b === void 0 ? 0 : _b,
            _c = props.friction,
            friction = _c === void 0 ? 0 : _c,
            _d = props.velocity,
            velocity = _d === void 0 ? 0 : _d,
            springStrength = props.springStrength,
            to = props.to;
        var _e = props.restSpeed,
            restSpeed = _e === void 0 ? 0.001 : _e,
            _f = props.from,
            from = _f === void 0 ? 0 : _f;
        var current = from;
        var process = sync.update(function (_a) {
            var delta = _a.delta;
            var elapsed = Math.max(delta, 16);
            if (acceleration) velocity += velocityPerFrame(acceleration, elapsed);
            if (friction) velocity *= Math.pow(1 - friction, elapsed / 100);
            if (springStrength !== undefined && to !== undefined) {
                var distanceToTarget = to - current;
                velocity += distanceToTarget * velocityPerFrame(springStrength, elapsed);
            }
            current += velocityPerFrame(velocity, elapsed);
            update(current);
            var isComplete = restSpeed !== false && (!velocity || Math.abs(velocity) <= restSpeed);
            if (isComplete) {
                cancelSync.update(process);
                complete();
            }
        }, true);
        return {
            set: function (v) {
                current = v;
                return this;
            },
            setAcceleration: function (v) {
                acceleration = v;
                return this;
            },
            setFriction: function (v) {
                friction = v;
                return this;
            },
            setSpringStrength: function (v) {
                springStrength = v;
                return this;
            },
            setSpringTarget: function (v) {
                to = v;
                return this;
            },
            setVelocity: function (v) {
                velocity = v;
                return this;
            },
            stop: function () {
                return cancelSync.update(process);
            }
        };
    });
};
var vectorPhysics = /*#__PURE__*/createVectorAction(physics, {
    acceleration: number.test,
    friction: number.test,
    velocity: number.test,
    from: number.test,
    to: number.test,
    springStrength: number.test
});

var listen = function (element, events, options) {
    return action(function (_a) {
        var update = _a.update;
        var eventNames = events.split(' ').map(function (eventName) {
            element.addEventListener(eventName, update, options);
            return eventName;
        });
        return {
            stop: function () {
                return eventNames.forEach(function (eventName) {
                    return element.removeEventListener(eventName, update, options);
                });
            }
        };
    });
};

var defaultPointerPos = function () {
    return {
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        x: 0,
        y: 0
    };
};
var eventToPoint = function (e, point) {
    if (point === void 0) {
        point = defaultPointerPos();
    }
    point.clientX = point.x = e.clientX;
    point.clientY = point.y = e.clientY;
    point.pageX = e.pageX;
    point.pageY = e.pageY;
    return point;
};

var points = [/*#__PURE__*/defaultPointerPos()];
var isTouchDevice = false;
if (typeof document !== 'undefined') {
    var updatePointsLocation = function (_a) {
        var touches = _a.touches;
        isTouchDevice = true;
        var numTouches = touches.length;
        points.length = 0;
        for (var i = 0; i < numTouches; i++) {
            var thisTouch = touches[i];
            points.push(eventToPoint(thisTouch));
        }
    };
    listen(document, 'touchstart touchmove', {
        passive: true,
        capture: true
    }).start(updatePointsLocation);
}
var multitouch = function (_a) {
    var _b = _a === void 0 ? {} : _a,
        _c = _b.preventDefault,
        preventDefault = _c === void 0 ? true : _c,
        _d = _b.scale,
        scale = _d === void 0 ? 1.0 : _d,
        _e = _b.rotate,
        rotate = _e === void 0 ? 0.0 : _e;
    return action(function (_a) {
        var update = _a.update;
        var output = {
            touches: points,
            scale: scale,
            rotate: rotate
        };
        var initialDistance = 0.0;
        var initialRotation = 0.0;
        var isGesture = points.length > 1;
        if (isGesture) {
            var firstTouch = points[0],
                secondTouch = points[1];
            initialDistance = distance(firstTouch, secondTouch);
            initialRotation = angle(firstTouch, secondTouch);
        }
        var updatePoint = function () {
            if (isGesture) {
                var firstTouch = points[0],
                    secondTouch = points[1];
                var newDistance = distance(firstTouch, secondTouch);
                var newRotation = angle(firstTouch, secondTouch);
                output.scale = scale * (newDistance / initialDistance);
                output.rotate = rotate + (newRotation - initialRotation);
            }
            update(output);
        };
        var onMove = function (e) {
            if (preventDefault || e.touches.length > 1) e.preventDefault();
            sync.update(updatePoint);
        };
        var updateOnMove = listen(document, 'touchmove', {
            passive: !preventDefault
        }).start(onMove);
        if (isTouchDevice) sync.update(updatePoint);
        return {
            stop: function () {
                cancelSync.update(updatePoint);
                updateOnMove.stop();
            }
        };
    });
};
var getIsTouchDevice = function () {
    return isTouchDevice;
};

var point = /*#__PURE__*/defaultPointerPos();
var isMouseDevice = false;
if (typeof document !== 'undefined') {
    var updatePointLocation = function (e) {
        isMouseDevice = true;
        eventToPoint(e, point);
    };
    listen(document, 'mousedown mousemove', true).start(updatePointLocation);
}
var mouse = function (_a) {
    var _b = (_a === void 0 ? {} : _a).preventDefault,
        preventDefault = _b === void 0 ? true : _b;
    return action(function (_a) {
        var update = _a.update;
        var updatePoint = function () {
            return update(point);
        };
        var onMove = function (e) {
            if (preventDefault) e.preventDefault();
            sync.update(updatePoint);
        };
        var updateOnMove = listen(document, 'mousemove').start(onMove);
        if (isMouseDevice) sync.update(updatePoint);
        return {
            stop: function () {
                cancelSync.update(updatePoint);
                updateOnMove.stop();
            }
        };
    });
};

var getFirstTouch = function (_a) {
    var firstTouch = _a[0];
    return firstTouch;
};
var pointer = function (props) {
    if (props === void 0) {
        props = {};
    }
    return getIsTouchDevice() ? multitouch(props).pipe(function (_a) {
        var touches = _a.touches;
        return touches;
    }, getFirstTouch) : mouse(props);
};
var index$1 = function (_a) {
    if (_a === void 0) {
        _a = {};
    }
    var x = _a.x,
        y = _a.y,
        props = __rest$1(_a, ["x", "y"]);
    if (x !== undefined || y !== undefined) {
        var applyXOffset_1 = applyOffset(x || 0);
        var applyYOffset_1 = applyOffset(y || 0);
        var delta_1 = { x: 0, y: 0 };
        return pointer(props).pipe(function (point) {
            delta_1.x = applyXOffset_1(point.x);
            delta_1.y = applyYOffset_1(point.y);
            return delta_1;
        });
    } else {
        return pointer(props);
    }
};

var chain = function () {
    var actions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        actions[_i] = arguments[_i];
    }
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var i = 0;
        var current;
        var playCurrent = function () {
            current = actions[i].start({
                complete: function () {
                    i++;
                    i >= actions.length ? complete() : playCurrent();
                },
                update: update
            });
        };
        playCurrent();
        return {
            stop: function () {
                return current && current.stop();
            }
        };
    });
};

var delay = function (timeToDelay) {
    return action(function (_a) {
        var complete = _a.complete;
        var timeout = setTimeout(complete, timeToDelay);
        return {
            stop: function () {
                return clearTimeout(timeout);
            }
        };
    });
};

var appendUnit = function (unit) {
    return function (v) {
        return "" + v + unit;
    };
};
var steps = function (st, min, max) {
    if (min === void 0) {
        min = 0;
    }
    if (max === void 0) {
        max = 1;
    }
    return function (v) {
        var current = progress(min, max, v);
        return mix(min, max, stepProgress(st, current));
    };
};
var transformMap = function (childTransformers) {
    return function (v) {
        var output = __assign$2({}, v);
        for (var key in childTransformers) {
            if (childTransformers.hasOwnProperty(key)) {
                var childTransformer = childTransformers[key];
                output[key] = childTransformer(v[key]);
            }
        }
        return output;
    };
};

var transformers = /*#__PURE__*/Object.freeze({
    __proto__: null,
    applyOffset: applyOffset,
    clamp: clamp$1,
    conditional: conditional,
    interpolate: interpolate$1,
    blendArray: mixArray,
    blendColor: mixColor,
    pipe: pipe,
    smooth: smooth,
    snap: snap,
    generateStaticSpring: springForce,
    nonlinearSpring: springForceExpo,
    linearSpring: springForceLinear,
    wrap: wrap$1,
    appendUnit: appendUnit,
    steps: steps,
    transformMap: transformMap
});

var getPoseValues = function (_a) {
    _a.transition;
        _a.flip;
        _a.delay;
        _a.delayChildren;
        _a.staggerChildren;
        _a.staggerDirection;
        _a.afterChildren;
        _a.beforeChildren;
        _a.preTransition;
        _a.applyAtStart;
        _a.applyAtEnd;
        var props = __rest$1(_a, ["transition", "flip", "delay", "delayChildren", "staggerChildren", "staggerDirection", "afterChildren", "beforeChildren", "preTransition", "applyAtStart", "applyAtEnd"]);
    return props;
};
var selectPoses = function (_a) {
    _a.label;
        _a.props;
        _a.values;
        _a.parentValues;
        _a.ancestorValues;
        _a.onChange;
        _a.passive;
        _a.initialPose;
        var poses = __rest$1(_a, ["label", "props", "values", "parentValues", "ancestorValues", "onChange", "passive", "initialPose"]);
    return poses;
};
var selectAllValues = function (values, selectValue) {
    var allValues = {};
    values.forEach(function (value, key) {
        return allValues[key] = selectValue(value);
    });
    return allValues;
};

var resolveProp$1 = function (target, props) {
    return typeof target === 'function' ? target(props) : target;
};
var poseDefault = function (pose, prop, defaultValue, resolveProps) {
    return pose && pose[prop] !== undefined ? resolveProp$1(pose[prop], resolveProps) : defaultValue;
};
var startChildAnimations = function (children, next, pose, props) {
    var animations = [];
    var delay = poseDefault(pose, 'delayChildren', 0, props);
    var stagger = poseDefault(pose, 'staggerChildren', 0, props);
    var staggerDirection = poseDefault(pose, 'staggerDirection', 1, props);
    var maxStaggerDuration = (children.size - 1) * stagger;
    var generateStaggerDuration = staggerDirection === 1 ? function (i) {
        return i * stagger;
    } : function (i) {
        return maxStaggerDuration - i * stagger;
    };
    Array.from(children).forEach(function (child, i) {
        animations.push(child.set(next, {
            delay: delay + generateStaggerDuration(i)
        }));
    });
    return animations;
};
var resolveTransition = function (transition, key, value, props, convertTransitionDefinition, getInstantTransition) {
    var resolvedTransition;
    if (typeof transition === 'function') {
        var resolvedTransitionMap = transition(props);
        resolvedTransition = resolveTransition(resolvedTransitionMap, key, value, props, convertTransitionDefinition, getInstantTransition);
    } else if (transition[key] || transition.default) {
        var keyTransition = transition[key] || transition.default;
        if (typeof keyTransition === 'function') {
            resolvedTransition = keyTransition(props);
        } else {
            resolvedTransition = keyTransition;
        }
    } else {
        resolvedTransition = transition;
    }
    return resolvedTransition === false ? getInstantTransition(value, props) : convertTransitionDefinition(value, resolvedTransition, props);
};
var findInsertionIndex = function (poseList, priorityList, priorityIndex) {
    var insertionIndex = 0;
    for (var i = priorityIndex - 1; i >= 0; i--) {
        var nextHighestPriorityIndex = poseList.indexOf(priorityList[i]);
        if (nextHighestPriorityIndex !== -1) {
            insertionIndex = nextHighestPriorityIndex + 1;
            break;
        }
    }
    return insertionIndex;
};
var applyValues = function (toApply, values, props, setValue, setValueNative) {
    invariant(typeof toApply === 'object', 'applyAtStart and applyAtEnd must be of type object');
    return Object.keys(toApply).forEach(function (key) {
        var valueToSet = resolveProp$1(toApply[key], props);
        values.has(key) ? setValue(values.get(key), valueToSet) : setValueNative(key, valueToSet, props);
    });
};
var createPoseSetter = function (setterProps) {
    var state = setterProps.state,
        poses = setterProps.poses,
        startAction = setterProps.startAction,
        stopAction = setterProps.stopAction,
        getInstantTransition = setterProps.getInstantTransition,
        addActionDelay = setterProps.addActionDelay,
        getTransitionProps = setterProps.getTransitionProps,
        resolveTarget = setterProps.resolveTarget,
        transformPose = setterProps.transformPose,
        posePriority = setterProps.posePriority,
        convertTransitionDefinition = setterProps.convertTransitionDefinition,
        setValue = setterProps.setValue,
        setValueNative = setterProps.setValueNative,
        forceRender = setterProps.forceRender;
    return function (next, nextProps, propagate) {
        if (nextProps === void 0) {
            nextProps = {};
        }
        if (propagate === void 0) {
            propagate = true;
        }
        var children = state.children,
            values = state.values,
            props = state.props,
            activeActions = state.activeActions,
            activePoses = state.activePoses;
        var _a = nextProps.delay,
            delay = _a === void 0 ? 0 : _a;
        var hasChildren = children.size;
        var baseTransitionProps = __assign$2(__assign$2({}, props), nextProps);
        var nextPose = poses[next];
        var getChildAnimations = function () {
            return hasChildren && propagate ? startChildAnimations(children, next, nextPose, baseTransitionProps) : [];
        };
        var getParentAnimations = function () {
            if (!nextPose) return [];
            var applyAtStart = nextPose.applyAtStart;
            if (applyAtStart) {
                applyValues(applyAtStart, values, baseTransitionProps, setValue, setValueNative);
                if (forceRender) forceRender(baseTransitionProps);
            }
            if (transformPose) nextPose = transformPose(nextPose, next, state);
            var preTransition = nextPose.preTransition,
                getTransition = nextPose.transition,
                applyAtEnd = nextPose.applyAtEnd;
            if (preTransition) preTransition(baseTransitionProps);
            var animations = Object.keys(getPoseValues(nextPose)).map(function (key) {
                var valuePoses = activePoses.has(key) ? activePoses.get(key) : (activePoses.set(key, []), activePoses.get(key));
                var existingIndex = valuePoses.indexOf(next);
                if (existingIndex !== -1) valuePoses.splice(existingIndex, 1);
                var priority = posePriority ? posePriority.indexOf(next) : 0;
                var insertionIndex = priority <= 0 ? 0 : findInsertionIndex(valuePoses, posePriority, priority);
                valuePoses.splice(insertionIndex, 0, next);
                return insertionIndex === 0 ? new Promise(function (complete) {
                    var value = values.get(key);
                    var transitionProps = __assign$2(__assign$2({}, baseTransitionProps), { key: key,
                        value: value });
                    var target = resolveTarget(value, resolveProp$1(nextPose[key], transitionProps));
                    if (activeActions.has(key)) stopAction(activeActions.get(key));
                    var resolveTransitionProps = __assign$2(__assign$2({ to: target }, transitionProps), getTransitionProps(value, target, transitionProps));
                    var transition = resolveTransition(getTransition, key, value, resolveTransitionProps, convertTransitionDefinition, getInstantTransition);
                    var poseDelay = delay || resolveProp$1(nextPose.delay, transitionProps);
                    if (poseDelay) {
                        transition = addActionDelay(poseDelay, transition);
                    }
                    activeActions.set(key, startAction(value, transition, complete));
                }) : Promise.resolve();
            });
            return applyAtEnd ? [Promise.all(animations).then(function () {
                applyValues(applyAtEnd, values, baseTransitionProps, setValue, setValueNative);
            })] : animations;
        };
        if (nextPose && hasChildren) {
            if (resolveProp$1(nextPose.beforeChildren, baseTransitionProps)) {
                return Promise.all(getParentAnimations()).then(function () {
                    return Promise.all(getChildAnimations());
                });
            } else if (resolveProp$1(nextPose.afterChildren, baseTransitionProps)) {
                return Promise.all(getChildAnimations()).then(function () {
                    return Promise.all(getParentAnimations());
                });
            }
        }
        return Promise.all(__spreadArrays(getParentAnimations(), getChildAnimations()));
    };
};

var DEFAULT_INITIAL_POSE = 'init';
var isScale = function (key) {
    return key.includes('scale');
};
var defaultReadValueFromSource = function (key) {
    return isScale(key) ? 1 : 0;
};
var readValueFromPose = function (pose, key, props) {
    var valueToResolve = pose.applyAtEnd && pose.applyAtEnd[key] !== undefined ? pose.applyAtEnd[key] : pose[key] !== undefined ? pose[key] : pose.applyAtStart && pose.applyAtStart[key] !== undefined ? pose.applyAtStart[key] : 0;
    return resolveProp$1(valueToResolve, props);
};
var getPosesToSearch = function (pose) {
    var posesToSearch = Array.isArray(pose) ? pose : [pose];
    posesToSearch.push(DEFAULT_INITIAL_POSE);
    return posesToSearch;
};
var getInitialValue = function (poses, key, initialPose, props, readValueFromSource, activePoses) {
    if (readValueFromSource === void 0) {
        readValueFromSource = defaultReadValueFromSource;
    }
    var posesToSearch = getPosesToSearch(initialPose);
    var pose = posesToSearch.filter(Boolean).find(function (name) {
        var thisPose = poses[name];
        return thisPose && (thisPose[key] !== undefined || thisPose.applyAtStart && thisPose.applyAtStart[key] !== undefined || thisPose.applyAtEnd && thisPose.applyAtEnd[key] !== undefined);
    });
    activePoses.set(key, [pose || DEFAULT_INITIAL_POSE]);
    return pose ? readValueFromPose(poses[pose], key, props) : readValueFromSource(key, props);
};
var createValues = function (values, _a) {
    var userSetValues = _a.userSetValues,
        createValue = _a.createValue,
        convertValue = _a.convertValue,
        readValueFromSource = _a.readValueFromSource,
        initialPose = _a.initialPose,
        poses = _a.poses,
        activePoses = _a.activePoses,
        props = _a.props;
    return function (key) {
        if (values.has(key)) return;
        var value;
        if (userSetValues && userSetValues[key] !== undefined) {
            value = convertValue(userSetValues[key], key, props);
        } else {
            var initValue = getInitialValue(poses, key, initialPose, props, readValueFromSource, activePoses);
            value = createValue(initValue, key, props);
        }
        values.set(key, value);
    };
};
var scrapeValuesFromPose = function (values, props) {
    return function (key) {
        var pose = props.poses[key];
        Object.keys(getPoseValues(pose)).forEach(createValues(values, props));
    };
};
var getAncestorValue = function (key, fromParent, ancestors) {
    if (fromParent === true) {
        return ancestors[0] && ancestors[0].values.get(key);
    } else {
        var foundAncestor = ancestors.find(function (_a) {
            var label = _a.label;
            return label === fromParent;
        });
        return foundAncestor && foundAncestor.values.get(key);
    }
};
var bindPassiveValues = function (values, _a) {
    var passive = _a.passive,
        ancestorValues = _a.ancestorValues,
        createValue = _a.createValue,
        readValue = _a.readValue,
        props = _a.props;
    return function (key) {
        var _a = passive[key],
            valueKey = _a[0],
            passiveProps = _a[1],
            fromParent = _a[2];
        var valueToBind = fromParent && ancestorValues.length ? getAncestorValue(valueKey, fromParent, ancestorValues) : values.has(valueKey) ? values.get(valueKey) : false;
        if (!valueToBind) return;
        var newValue = createValue(readValue(valueToBind), key, props, {
            passiveParentKey: valueKey,
            passiveParent: valueToBind,
            passiveProps: passiveProps
        });
        values.set(key, newValue);
    };
};
var setNativeValues = function (_a) {
    var setValueNative = _a.setValueNative,
        initialPose = _a.initialPose,
        props = _a.props,
        poses = _a.poses;
    var valuesHaveSet = new Set();
    var setValues = function (pose, propKey) {
        if (pose[propKey]) {
            for (var key in pose[propKey]) {
                if (!valuesHaveSet.has(key)) {
                    valuesHaveSet.add(key);
                    setValueNative(key, resolveProp$1(pose[propKey][key], props), props);
                }
            }
        }
    };
    getPosesToSearch(initialPose).forEach(function (poseKey) {
        var pose = poses[poseKey];
        if (pose) {
            setValues(pose, 'applyAtEnd');
            setValues(pose, 'applyAtStart');
        }
    });
};
var createValueMap = function (props) {
    var poses = props.poses,
        passive = props.passive;
    var values = new Map();
    Object.keys(poses).forEach(scrapeValuesFromPose(values, props));
    setNativeValues(props);
    if (passive) Object.keys(passive).forEach(bindPassiveValues(values, props));
    return values;
};

var applyDefaultTransition = function (pose, key, defaultTransitions) {
    return __assign$2(__assign$2({}, pose), { transition: defaultTransitions.has(key) ? defaultTransitions.get(key) : defaultTransitions.get('default') });
};
var generateTransitions = function (poses, defaultTransitions) {
    Object.keys(poses).forEach(function (key) {
        var pose = poses[key];
        invariant(typeof pose === 'object', "Pose '" + key + "' is of invalid type. All poses should be objects.");
        poses[key] = pose.transition !== undefined ? pose : applyDefaultTransition(pose, key, defaultTransitions);
    });
    return poses;
};

var sortByReversePriority = function (priorityOrder) {
    return function (a, b) {
        var aP = priorityOrder.indexOf(a);
        var bP = priorityOrder.indexOf(b);
        if (aP === -1 && bP !== -1) return -1;
        if (aP !== -1 && bP === -1) return 1;
        return aP - bP;
    };
};

var poseFactory = function (_a) {
    var getDefaultProps = _a.getDefaultProps,
        defaultTransitions = _a.defaultTransitions,
        bindOnChange = _a.bindOnChange,
        startAction = _a.startAction,
        stopAction = _a.stopAction,
        readValue = _a.readValue,
        readValueFromSource = _a.readValueFromSource,
        resolveTarget = _a.resolveTarget,
        setValue = _a.setValue,
        setValueNative = _a.setValueNative,
        createValue = _a.createValue,
        convertValue = _a.convertValue,
        getInstantTransition = _a.getInstantTransition,
        getTransitionProps = _a.getTransitionProps,
        addActionDelay = _a.addActionDelay,
        selectValueToRead = _a.selectValueToRead,
        convertTransitionDefinition = _a.convertTransitionDefinition,
        transformPose = _a.transformPose,
        posePriority = _a.posePriority,
        forceRender = _a.forceRender,
        extendAPI = _a.extendAPI;
    return function (config) {
        var parentValues = config.parentValues,
            _a = config.ancestorValues,
            ancestorValues = _a === void 0 ? [] : _a;
        if (parentValues) ancestorValues.unshift({ values: parentValues });
        var activeActions = new Map();
        var activePoses = new Map();
        var children = new Set();
        var poses = generateTransitions(selectPoses(config), defaultTransitions);
        var _b = config.props,
            props = _b === void 0 ? {} : _b;
        if (getDefaultProps) props = __assign$2(__assign$2({}, getDefaultProps(config)), props);
        var passive = config.passive,
            userSetValues = config.values,
            _c = config.initialPose,
            initialPose = _c === void 0 ? DEFAULT_INITIAL_POSE : _c;
        var values = createValueMap({
            poses: poses,
            passive: passive,
            ancestorValues: ancestorValues,
            readValue: readValue,
            setValueNative: setValueNative,
            createValue: createValue,
            convertValue: convertValue,
            readValueFromSource: readValueFromSource,
            userSetValues: userSetValues,
            initialPose: initialPose,
            activePoses: activePoses,
            props: props
        });
        var state = {
            activeActions: activeActions,
            activePoses: activePoses,
            children: children,
            props: props,
            values: values
        };
        var onChange = config.onChange;
        if (onChange) Object.keys(onChange).forEach(bindOnChange(values, onChange));
        var set = createPoseSetter({
            state: state,
            poses: poses,
            getInstantTransition: getInstantTransition,
            getTransitionProps: getTransitionProps,
            convertTransitionDefinition: convertTransitionDefinition,
            setValue: setValue,
            setValueNative: setValueNative,
            startAction: startAction,
            stopAction: stopAction,
            resolveTarget: resolveTarget,
            addActionDelay: addActionDelay,
            transformPose: transformPose,
            posePriority: posePriority,
            forceRender: forceRender
        });
        var has = function (poseName) {
            return !!poses[poseName];
        };
        var api = {
            set: set,
            unset: function (poseName, poseProps) {
                var posesToSet = [];
                activePoses.forEach(function (valuePoses) {
                    var poseIndex = valuePoses.indexOf(poseName);
                    if (poseIndex === -1) return;
                    var currentPose = valuePoses[0];
                    valuePoses.splice(poseIndex, 1);
                    var nextPose = valuePoses[0];
                    if (nextPose === currentPose) return;
                    if (posesToSet.indexOf(nextPose) === -1) {
                        posesToSet.push(nextPose);
                    }
                });
                var animationsToResolve = posesToSet.sort(sortByReversePriority(posePriority)).map(function (poseToSet) {
                    return set(poseToSet, poseProps, false);
                });
                children.forEach(function (child) {
                    return animationsToResolve.push(child.unset(poseName));
                });
                return Promise.all(animationsToResolve);
            },
            get: function (valueName) {
                return valueName ? selectValueToRead(values.get(valueName)) : selectAllValues(values, selectValueToRead);
            },
            has: has,
            setProps: function (newProps) {
                return state.props = __assign$2(__assign$2({}, state.props), newProps);
            },
            _addChild: function (childConfig, factory) {
                var child = factory(__assign$2(__assign$2({ initialPose: initialPose }, childConfig), { ancestorValues: __spreadArrays([{ label: config.label, values: values }], ancestorValues) }));
                children.add(child);
                return child;
            },
            removeChild: function (child) {
                return children.delete(child);
            },
            clearChildren: function () {
                children.forEach(function (child) {
                    return child.destroy();
                });
                children.clear();
            },
            destroy: function () {
                activeActions.forEach(stopAction);
                children.forEach(function (child) {
                    return child.destroy();
                });
            }
        };
        return extendAPI(api, state, config);
    };
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}

var BoundingBoxDimension;
(function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));

var measureWithoutTransform = function (element) {
    var transform$$1 = element.style.transform;
    element.style.transform = '';
    var bbox = element.getBoundingClientRect();
    element.style.transform = transform$$1;
    return bbox;
};
var resolveProp = function (target, props) {
    return typeof target === 'function' ? target(props) : target;
};

var interpolate = transformers.interpolate;
var singleAxisPointer = function (axis) {
    return function (from) {
        var _a;
        return index$1((_a = {}, _a[axis] = typeof from === 'string' ? parseFloat(from) : from, _a)).pipe(function (v) {
            return v[axis];
        });
    };
};
var pointerX = /*#__PURE__*/singleAxisPointer('x');
var pointerY = /*#__PURE__*/singleAxisPointer('y');
var createPointer = function (axisPointerCreator, min, max, measurement) {
    return function (transitionProps) {
        var from = transitionProps.from,
            type = transitionProps.type,
            dimensions = transitionProps.dimensions,
            dragBounds = transitionProps.dragBounds;
        var axisPointer = axisPointerCreator(dimensions.measurementAsPixels(measurement, from, type));
        var transformQueue = [];
        if (dragBounds) {
            var resolvedDragBounds_1 = resolveProp(dragBounds, transitionProps);
            if (resolvedDragBounds_1[min] !== undefined) {
                transformQueue.push(function (v) {
                    return Math.max(v, dimensions.measurementAsPixels(measurement, resolvedDragBounds_1[min], type));
                });
            }
            if (resolvedDragBounds_1[max] !== undefined) {
                transformQueue.push(function (v) {
                    return Math.min(v, dimensions.measurementAsPixels(measurement, resolvedDragBounds_1[max], type));
                });
            }
        }
        if (type === percent) {
            transformQueue.push(interpolate([0, dimensions.get(measurement)], [0, 100], { clamp: false }), function (v) {
                return v + '%';
            });
        }
        return transformQueue.length ? axisPointer.pipe.apply(axisPointer, transformQueue) : axisPointer;
    };
};
var just = function (from) {
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        update(from);
        complete();
    });
};
var underDampedSpring = function (_a) {
    var from = _a.from,
        velocity = _a.velocity,
        to = _a.to;
    return vectorSpring({
        from: from,
        to: to,
        velocity: velocity,
        stiffness: 500,
        damping: 25,
        restDelta: 0.5,
        restSpeed: 10
    });
};
var overDampedSpring = function (_a) {
    var from = _a.from,
        velocity = _a.velocity,
        to = _a.to;
    return vectorSpring({ from: from, to: to, velocity: velocity, stiffness: 700, damping: to === 0 ? 100 : 35 });
};
var linearTween = function (_a) {
    var from = _a.from,
        to = _a.to;
    return tween({ from: from, to: to, ease: linear });
};
var intelligentTransition = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: overDampedSpring,
    scaleY: overDampedSpring,
    scale: overDampedSpring,
    opacity: linearTween,
    default: tween
};
var dragAction = /*#__PURE__*/__assign( /*#__PURE__*/__assign({}, intelligentTransition), { x: /*#__PURE__*/createPointer(pointerX, 'left', 'right', BoundingBoxDimension.width), y: /*#__PURE__*/createPointer(pointerY, 'top', 'bottom', BoundingBoxDimension.height) });
var justAxis = function (_a) {
    var from = _a.from;
    return just(from);
};
var intelligentDragEnd = /*#__PURE__*/__assign( /*#__PURE__*/__assign({}, intelligentTransition), { x: justAxis, y: justAxis });
var defaultTransitions = /*#__PURE__*/new Map([['default', intelligentTransition], ['drag', dragAction], ['dragEnd', intelligentDragEnd]]);

var animationLookup = {
    tween: tween,
    spring: vectorSpring,
    decay: vectorDecay,
    keyframes: keyframes,
    physics: vectorPhysics
};
var easingLookup = {
    linear: linear,
    easeIn: easeIn,
    easeOut: easeOut,
    easeInOut: easeInOut,
    circIn: circIn,
    circOut: circOut,
    circInOut: circInOut,
    backIn: backIn,
    backOut: backOut,
    backInOut: backInOut,
    anticipate: anticipate
};

var auto = {
    test: function (v) {
        return v === 'auto';
    },
    parse: function (v) {
        return v;
    }
};
var valueTypeTests = [number, degrees, percent, px, vw, vh, auto];
var testValueType = function (v) {
    return function (type) {
        return type.test(v);
    };
};
var getValueType = function (v) {
    return valueTypeTests.find(testValueType(v));
};

var createPassiveValue = function (init, parent, transform$$1) {
    var raw = value(transform$$1(init));
    parent.raw.subscribe(function (v) {
        return raw.update(transform$$1(v));
    });
    return { raw: raw };
};
var createValue = function (init) {
    var type = getValueType(init);
    var raw = value(init);
    return { raw: raw, type: type };
};
var addActionDelay = function (delay$$1, transition) {
    if (delay$$1 === void 0) {
        delay$$1 = 0;
    }
    return chain(delay(delay$$1), transition);
};
var isCubicBezierArgs = function (args) {
    return typeof args[0] === 'number';
};
var getAction = function (v, _a, _b) {
    var from = _b.from,
        to = _b.to,
        velocity = _b.velocity;
    var _c = _a.type,
        type = _c === void 0 ? 'tween' : _c,
        definedEase = _a.ease,
        def = __rest(_a, ["type", "ease"]);
    invariant(animationLookup[type] !== undefined, "Invalid transition type '" + type + "'. Valid transition types are: tween, spring, decay, physics and keyframes.");
    var ease;
    if (type === 'tween') {
        if (typeof definedEase !== 'function') {
            if (typeof definedEase === 'string') {
                invariant(easingLookup[definedEase] !== undefined, "Invalid easing type '" + definedEase + "'. popmotion.io/pose/api/config");
                ease = easingLookup[definedEase];
            } else if (Array.isArray(definedEase) && isCubicBezierArgs(definedEase)) {
                invariant(definedEase.length === 4, "Cubic bezier arrays must contain four numerical values.");
                var x1 = definedEase[0],
                    y1 = definedEase[1],
                    x2 = definedEase[2],
                    y2 = definedEase[3];
                ease = cubicBezier(x1, y1, x2, y2);
            }
        }
    }
    ease = ease || definedEase;
    var baseProps = type !== 'keyframes' ? {
        from: from,
        to: to,
        velocity: velocity,
        ease: ease
    } : { ease: ease };
    return animationLookup[type](__assign(__assign({}, baseProps), def));
};
var isAction = function (action$$1) {
    return typeof action$$1.start !== 'undefined';
};
var pose = function (_a) {
    var transformPose = _a.transformPose,
        addListenerToValue = _a.addListenerToValue,
        extendAPI = _a.extendAPI,
        readValueFromSource = _a.readValueFromSource,
        posePriority = _a.posePriority,
        setValueNative = _a.setValueNative;
    return poseFactory({
        bindOnChange: function (values, onChange) {
            return function (key) {
                if (!values.has(key)) return;
                var raw = values.get(key).raw;
                raw.subscribe(onChange[key]);
            };
        },
        readValue: function (_a) {
            var raw = _a.raw;
            return raw.get();
        },
        setValue: function (_a, to) {
            var raw = _a.raw;
            return raw.update(to);
        },
        createValue: function (init, key, _a, _b) {
            var elementStyler = _a.elementStyler;
            var _c = _b === void 0 ? {} : _b,
                passiveParent = _c.passiveParent,
                passiveProps = _c.passiveProps;
            var val = passiveParent ? createPassiveValue(init, passiveParent, passiveProps) : createValue(init);
            val.raw.subscribe(addListenerToValue(key, elementStyler));
            return val;
        },
        convertValue: function (raw, key, _a) {
            var elementStyler = _a.elementStyler;
            raw.subscribe(addListenerToValue(key, elementStyler));
            return {
                raw: raw,
                type: getValueType(raw.get())
            };
        },
        getTransitionProps: function (_a, to) {
            var raw = _a.raw,
                type = _a.type;
            return {
                from: raw.get(),
                velocity: raw.getVelocity(),
                to: to,
                type: type
            };
        },
        resolveTarget: function (_, to) {
            return to;
        },
        selectValueToRead: function (_a) {
            var raw = _a.raw;
            return raw;
        },
        startAction: function (_a, action$$1, complete) {
            var raw = _a.raw;
            var reaction = {
                update: function (v) {
                    return raw.update(v);
                },
                complete: complete
            };
            return action$$1.start(reaction);
        },
        stopAction: function (action$$1) {
            return action$$1.stop();
        },
        getInstantTransition: function (_, _a) {
            var to = _a.to;
            return just(to);
        },
        convertTransitionDefinition: function (val, def, props) {
            if (isAction(def)) return def;
            var delay$$1 = def.delay,
                min = def.min,
                max = def.max,
                round = def.round,
                remainingDef = __rest(def, ["delay", "min", "max", "round"]);
            var action$$1 = getAction(val, remainingDef, props);
            var outputPipe = [];
            if (delay$$1) action$$1 = addActionDelay(delay$$1, action$$1);
            if (min !== undefined) outputPipe.push(function (v) {
                return Math.max(v, min);
            });
            if (max !== undefined) outputPipe.push(function (v) {
                return Math.min(v, max);
            });
            if (round) outputPipe.push(Math.round);
            return outputPipe.length ? action$$1.pipe.apply(action$$1, outputPipe) : action$$1;
        },
        setValueNative: setValueNative,
        addActionDelay: addActionDelay,
        defaultTransitions: defaultTransitions,
        transformPose: transformPose,
        readValueFromSource: readValueFromSource,
        posePriority: posePriority,
        extendAPI: extendAPI
    });
};

var createDimensions = function (element) {
    var hasMeasured = false;
    var current = {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
    return {
        get: function (measurement) {
            return measurement ? current[measurement] : current;
        },
        measure: function () {
            current = element.getBoundingClientRect();
            hasMeasured = true;
            return current;
        },
        measurementAsPixels: function (measurement, value$$1, type) {
            return type === percent ? (typeof value$$1 === 'string' ? parseFloat(value$$1) : value$$1) / 100 * current[measurement] : value$$1;
        },
        has: function () {
            return hasMeasured;
        }
    };
};

var makeUIEventApplicator = function (_a) {
    var startEvents = _a.startEvents,
        endEvents = _a.endEvents,
        startPose = _a.startPose,
        endPose = _a.endPose,
        startCallback = _a.startCallback,
        endCallback = _a.endCallback,
        useDocumentToEnd = _a.useDocumentToEnd,
        preventScroll = _a.preventScroll;
    return function (element, activeActions, poser, config) {
        var startListener = startPose + 'Start';
        var endListener = startPose + 'End';
        var moveListener = startPose + 'Move';
        if (preventScroll) {
            var touchMoveListener = listen(element, 'touchmove', {
                passive: false
            }).start(function (e) {
                e.preventDefault();
            });
            activeActions.set(moveListener, touchMoveListener);
        }
        var eventStartListener = listen(element, startEvents).start(function (startEvent) {
            poser.unset(endPose);
            poser.set(startPose);
            if (startCallback && config[startCallback]) config[startCallback](startEvent);
            var eventEndListener = listen(useDocumentToEnd ? document.documentElement : element, endEvents + (useDocumentToEnd ? ' mouseenter' : '')).start(function (endEvent) {
                if (useDocumentToEnd && endEvent.type === 'mouseenter' && endEvent.buttons === 1) {
                    return;
                }
                activeActions.get(endListener).stop();
                poser.unset(startPose);
                poser.set(endPose);
                if (endCallback && config[endCallback]) config[endCallback](endEvent);
            });
            activeActions.set(endListener, eventEndListener);
        });
        activeActions.set(startListener, eventStartListener);
    };
};
var events = {
    draggable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'mousedown touchstart',
        endEvents: 'mouseup touchend',
        startPose: 'drag',
        endPose: 'dragEnd',
        startCallback: 'onDragStart',
        endCallback: 'onDragEnd',
        useDocumentToEnd: true,
        preventScroll: true
    }),
    hoverable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'mouseenter',
        endEvents: 'mouseleave',
        startPose: 'hover',
        endPose: 'hoverEnd'
    }),
    focusable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'focus',
        endEvents: 'blur',
        startPose: 'focus',
        endPose: 'blur'
    }),
    pressable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'mousedown touchstart',
        endEvents: 'mouseup touchend',
        startPose: 'press',
        endPose: 'pressEnd',
        startCallback: 'onPressStart',
        endCallback: 'onPressEnd',
        useDocumentToEnd: true
    })
};
var eventKeys = /*#__PURE__*/Object.keys(events);
var appendEventListeners = function (element, activeActions, poser, _a) {
    var props = _a.props;
    return eventKeys.forEach(function (key) {
        if (props[key]) events[key](element, activeActions, poser, props);
    });
};

var ORIGIN_START = 0;
var ORIGIN_CENTER = '50%';
var ORIGIN_END = '100%';
var findCenter = function (_a) {
    var top = _a.top,
        right = _a.right,
        bottom = _a.bottom,
        left = _a.left;
    return {
        x: (left + right) / 2,
        y: (top + bottom) / 2
    };
};
var positionalProps = ['width', 'height', 'top', 'left', 'bottom', 'right'];
var positionalPropsDict = /*#__PURE__*/new Set(positionalProps);
var checkPositionalProp = function (key) {
    return positionalPropsDict.has(key);
};
var hasPositionalProps = function (pose) {
    return Object.keys(pose).some(checkPositionalProp);
};
var isFlipPose = function (flip, key, state) {
    return state.props.element instanceof HTMLElement && (flip === true || key === 'flip');
};
var setValue = function (_a, key, to) {
    var values = _a.values,
        props = _a.props;
    if (values.has(key)) {
        var raw = values.get(key).raw;
        raw.update(to);
        raw.update(to);
    } else {
        values.set(key, {
            raw: value(to, function (v) {
                return props.elementStyler.set(key, v);
            })
        });
    }
};
var explicitlyFlipPose = function (state, nextPose) {
    var _a = state.props,
        dimensions = _a.dimensions,
        elementStyler = _a.elementStyler;
    dimensions.measure();
    nextPose.width;
        nextPose.height;
        nextPose.top;
        nextPose.left;
        nextPose.bottom;
        nextPose.right;
        nextPose.position;
        var remainingPose = __rest(nextPose, ["width", "height", "top", "left", "bottom", "right", "position"]);
    var propsToSet = positionalProps.concat('position').reduce(function (acc, key) {
        if (nextPose[key] !== undefined) {
            acc[key] = resolveProp(nextPose[key], state.props);
        }
        return acc;
    }, {});
    elementStyler.set(propsToSet).render();
    return implicitlyFlipPose(state, remainingPose);
};
var implicitlyFlipPose = function (state, nextPose) {
    var _a = state.props,
        dimensions = _a.dimensions,
        element = _a.element,
        elementStyler = _a.elementStyler;
    if (!dimensions.has()) return {};
    var prev = dimensions.get();
    var next = measureWithoutTransform(element);
    var originX = prev.left === next.left ? ORIGIN_START : prev.right === next.right ? ORIGIN_END : ORIGIN_CENTER;
    var originY = prev.top === next.top ? ORIGIN_START : prev.bottom === next.bottom ? ORIGIN_END : ORIGIN_CENTER;
    elementStyler.set({ originX: originX, originY: originY });
    if (prev.width !== next.width) {
        setValue(state, 'scaleX', prev.width / next.width);
        nextPose.scaleX = 1;
    }
    if (prev.height !== next.height) {
        setValue(state, 'scaleY', prev.height / next.height);
        nextPose.scaleY = 1;
    }
    var prevCenter = findCenter(prev);
    var nextCenter = findCenter(next);
    if (originX === ORIGIN_CENTER) {
        setValue(state, 'x', prevCenter.x - nextCenter.x);
        nextPose.x = 0;
    }
    if (originY === ORIGIN_CENTER) {
        setValue(state, 'y', prevCenter.y - nextCenter.y);
        nextPose.y = 0;
    }
    elementStyler.render();
    return nextPose;
};
var flipPose = function (props, nextPose) {
    return hasPositionalProps(nextPose) ? explicitlyFlipPose(props, nextPose) : implicitlyFlipPose(props, nextPose);
};

var getPosFromMatrix = function (matrix, pos) {
    return parseFloat(matrix.split(', ')[pos]);
};
var getTranslateFromMatrix = function (pos2, pos3) {
    return function (element, bbox, _a) {
        var transform$$1 = _a.transform;
        if (!transform$$1 || transform$$1 === 'none') return 0;
        var matrix3d = transform$$1.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return getPosFromMatrix(matrix3d[1], pos3);
        return getPosFromMatrix(transform$$1.match(/^matrix\((.+)\)$/)[1], pos2);
    };
};
var positionalValues = {
    width: function (element, _a) {
        var width = _a.width;
        return width;
    },
    height: function (element, _a) {
        var height = _a.height;
        return height;
    },
    top: function (element, bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function (element, bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function (element, _a, _b) {
        var height = _a.height;
        var top = _b.top;
        return parseFloat(top) + height;
    },
    right: function (element, _a, _b) {
        var width = _a.width;
        var left = _b.left;
        return parseFloat(left) + width;
    },
    x: /*#__PURE__*/getTranslateFromMatrix(4, 13),
    y: /*#__PURE__*/getTranslateFromMatrix(5, 14)
};
var isPositionalKey = function (v) {
    return positionalValues[v] !== undefined;
};
var isPositional = function (pose) {
    return Object.keys(pose).some(isPositionalKey);
};
var convertPositionalUnits = function (state, nextPose) {
    var values = state.values,
        props = state.props;
    var element = props.element,
        elementStyler = props.elementStyler;
    var positionalPoseKeys = Object.keys(nextPose).filter(isPositionalKey);
    var changedPositionalKeys = [];
    var elementComputedStyle = getComputedStyle(element);
    var applyAtEndHasBeenCopied = false;
    positionalPoseKeys.forEach(function (key) {
        var value$$1 = values.get(key);
        var fromValueType = getValueType(value$$1.raw.get());
        var to = resolveProp(nextPose[key], props);
        var toValueType = getValueType(to);
        if (fromValueType !== toValueType) {
            changedPositionalKeys.push(key);
            if (!applyAtEndHasBeenCopied) {
                applyAtEndHasBeenCopied = true;
                nextPose.applyAtEnd = nextPose.applyAtEnd ? __assign({}, nextPose.applyAtEnd) : {};
            }
            nextPose.applyAtEnd[key] = nextPose.applyAtEnd[key] || nextPose[key];
            setValue(state, key, to);
        }
    });
    if (!changedPositionalKeys.length) return nextPose;
    var originBbox = element.getBoundingClientRect();
    var top = elementComputedStyle.top,
        left = elementComputedStyle.left,
        bottom = elementComputedStyle.bottom,
        right = elementComputedStyle.right,
        transform$$1 = elementComputedStyle.transform;
    var originComputedStyle = { top: top, left: left, bottom: bottom, right: right, transform: transform$$1 };
    elementStyler.render();
    var targetBbox = element.getBoundingClientRect();
    changedPositionalKeys.forEach(function (key) {
        setValue(state, key, positionalValues[key](element, originBbox, originComputedStyle));
        nextPose[key] = positionalValues[key](element, targetBbox, elementComputedStyle);
    });
    elementStyler.render();
    return nextPose;
};

var getCurrent = function (prop) {
    return function (_a) {
        var elementStyler = _a.elementStyler;
        return elementStyler.get(prop);
    };
};
var dragPoses = function (draggable) {
    var drag = {
        preTransition: function (_a) {
            var dimensions = _a.dimensions;
            return dimensions.measure();
        }
    };
    var dragEnd = {};
    if (draggable === true || draggable === 'x') {
        drag.x = dragEnd.x = getCurrent('x');
    }
    if (draggable === true || draggable === 'y') {
        drag.y = dragEnd.y = getCurrent('y');
    }
    return { drag: drag, dragEnd: dragEnd };
};
var createPoseConfig = function (element, _a) {
    var onDragStart = _a.onDragStart,
        onDragEnd = _a.onDragEnd,
        onPressStart = _a.onPressStart,
        onPressEnd = _a.onPressEnd,
        draggable = _a.draggable,
        hoverable = _a.hoverable,
        focusable = _a.focusable,
        pressable = _a.pressable,
        dragBounds = _a.dragBounds,
        config = __rest(_a, ["onDragStart", "onDragEnd", "onPressStart", "onPressEnd", "draggable", "hoverable", "focusable", "pressable", "dragBounds"]);
    var poseConfig = __assign(__assign({ flip: {} }, config), { props: __assign(__assign({}, config.props), { onDragStart: onDragStart,
            onDragEnd: onDragEnd,
            onPressStart: onPressStart,
            onPressEnd: onPressEnd,
            dragBounds: dragBounds,
            draggable: draggable,
            hoverable: hoverable,
            focusable: focusable,
            pressable: pressable,
            element: element, elementStyler: index$2(element, { preparseOutput: false }), dimensions: createDimensions(element) }) });
    if (draggable) {
        var _b = dragPoses(draggable),
            drag = _b.drag,
            dragEnd = _b.dragEnd;
        poseConfig.drag = __assign(__assign({}, drag), poseConfig.drag);
        poseConfig.dragEnd = __assign(__assign({}, dragEnd), poseConfig.dragEnd);
    }
    return poseConfig;
};
var domPose = /*#__PURE__*/pose({
    posePriority: ['drag', 'press', 'focus', 'hover'],
    transformPose: function (_a, name, state) {
        var flip = _a.flip,
            pose$$1 = __rest(_a, ["flip"]);
        if (isFlipPose(flip, name, state)) {
            return flipPose(state, pose$$1);
        } else if (isPositional(pose$$1)) {
            return convertPositionalUnits(state, pose$$1);
        }
        return pose$$1;
    },
    forceRender: function (_a) {
        var elementStyler = _a.elementStyler;
        elementStyler.render();
    },
    addListenerToValue: function (key, elementStyler) {
        return function (v) {
            return elementStyler.set(key, v);
        };
    },
    readValueFromSource: function (key, _a) {
        var elementStyler = _a.elementStyler,
            dragBounds = _a.dragBounds;
        var value$$1 = elementStyler.get(key);
        if (dragBounds && (key === 'x' || key === 'y')) {
            var bound = key === 'x' ? dragBounds.left || dragBounds.right : dragBounds.top || dragBounds.bottom;
            if (bound) {
                var boundType = getValueType(bound);
                value$$1 = boundType.transform(value$$1);
            }
        }
        return isNaN(value$$1) ? value$$1 : parseFloat(value$$1);
    },
    setValueNative: function (key, to, _a) {
        var elementStyler = _a.elementStyler;
        return elementStyler.set(key, to);
    },
    extendAPI: function (api, _a, config) {
        var props = _a.props,
            activeActions = _a.activeActions;
        var measure = props.dimensions.measure;
        var poserApi = __assign(__assign({}, api), { addChild: function (element, childConfig) {
                return api._addChild(createPoseConfig(element, childConfig), domPose);
            }, measure: measure, flip: function (op) {
                if (op) {
                    measure();
                    op();
                }
                return api.set('flip');
            } });
        props.elementStyler.render();
        appendEventListeners(props.element, activeActions, poserApi, config);
        return poserApi;
    }
});
var domPose$1 = function (element, config) {
    return domPose(createPoseConfig(element, config));
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var hasChanged = function (prev, next) {
    if (prev === next)
        return false;
    var prevIsArray = Array.isArray(prev);
    var nextIsArray = Array.isArray(next);
    if (prevIsArray !== nextIsArray || (!prevIsArray && !nextIsArray)) {
        return true;
    }
    else if (prevIsArray && nextIsArray) {
        var numPrev = prev.length;
        var numNext = next.length;
        if (numPrev !== numNext)
            return true;
        for (var i = 0; i < numPrev; i++) {
            if (prev[i] !== next[i])
                return true;
        }
    }
    return false;
};

var pickAssign = function (shouldPick, sources) {
    return sources.reduce(function (picked, source) {
        for (var key in source) {
            if (shouldPick(key)) {
                picked[key] = source[key];
            }
        }
        return picked;
    }, {});
};

var _a = createContext({}), PoseParentConsumer = _a.Consumer, PoseParentProvider = _a.Provider;
var calcPopFromFlowStyle = function (el) {
    var offsetTop = el.offsetTop, offsetLeft = el.offsetLeft, offsetWidth = el.offsetWidth, offsetHeight = el.offsetHeight;
    return {
        position: 'absolute',
        top: offsetTop,
        left: offsetLeft,
        width: offsetWidth,
        height: offsetHeight
    };
};
var hasPose = function (pose, key) {
    return Array.isArray(pose) ? pose.indexOf(key) !== -1 : pose === key;
};
var objectToMap = function (obj) {
    return Object.keys(obj).reduce(function (map, key) {
        map.set(key, { raw: obj[key] });
        return map;
    }, new Map());
};
var testAlwaysTrue = function () { return true; };
var filterProps = function (_a) {
    _a.elementType; _a.poseConfig; _a.onValueChange; _a.innerRef; _a._pose; _a.pose; _a.initialPose; _a.poseKey; _a.onPoseComplete; _a.getParentPoseConfig; _a.registerChild; _a.onUnmount; _a.getInitialPoseFromParent; _a.popFromFlow; _a.values; _a.parentValues; _a.onDragStart; _a.onDragEnd; _a.onPressStart; _a.onPressEnd; var props = __rest$1(_a, ["elementType", "poseConfig", "onValueChange", "innerRef", "_pose", "pose", "initialPose", "poseKey", "onPoseComplete", "getParentPoseConfig", "registerChild", "onUnmount", "getInitialPoseFromParent", "popFromFlow", "values", "parentValues", "onDragStart", "onDragEnd", "onPressStart", "onPressEnd"]);
    return props;
};
var PoseElement = (function (_super) {
    __extends(PoseElement, _super);
    function PoseElement(props) {
        var _this = _super.call(this, props) || this;
        _this.children = new Set();
        _this.childrenHandlers = {
            registerChild: function (props) {
                _this.children.add(props);
                if (_this.poser)
                    _this.flushChildren();
            },
            onUnmount: function (child) { return _this.poser.removeChild(child); },
            getParentPoseConfig: function () { return _this.poseConfig; },
            getInitialPoseFromParent: function () { return _this.getInitialPose(); }
        };
        _this.setRef = function (ref) {
            warning(ref === null || (ref instanceof Element && _this.ref === undefined), 'ref must be provided to the same DOM component for the entire lifecycle of a posed component.');
            _this.ref = ref;
            var innerRef = _this.props.innerRef;
            if (!innerRef)
                return;
            if (typeof innerRef === 'function') {
                innerRef(ref);
            }
            else {
                innerRef.current = ref;
            }
        };
        _this.shouldForwardProp =
            typeof _this.props.elementType === 'string' ? index : testAlwaysTrue;
        var poseConfig = _this.props.poseConfig;
        _this.poseConfig =
            typeof poseConfig === 'function'
                ? poseConfig(filterProps(props))
                : poseConfig;
        return _this;
    }
    PoseElement.prototype.getInitialPose = function () {
        var _a = this.props, getInitialPoseFromParent = _a.getInitialPoseFromParent, pose = _a.pose, _pose = _a._pose, initialPose = _a.initialPose;
        if (initialPose) {
            return initialPose;
        }
        else {
            var parentPose = getInitialPoseFromParent && getInitialPoseFromParent();
            var initialPoses = (Array.isArray(parentPose)
                ? parentPose
                : [parentPose])
                .concat(pose, _pose)
                .filter(Boolean);
            return initialPoses.length > 0 ? initialPoses : undefined;
        }
    };
    PoseElement.prototype.getFirstPose = function () {
        var _a = this.props, initialPose = _a.initialPose, pose = _a.pose, _pose = _a._pose;
        if (!initialPose)
            return;
        var firstPose = (Array.isArray(pose) ? pose : [pose])
            .concat(_pose)
            .filter(Boolean);
        return firstPose.length === 1 ? firstPose[0] : firstPose;
    };
    PoseElement.prototype.getSetProps = function () {
        var props = filterProps(this.props);
        if (this.props.popFromFlow && this.ref && this.ref instanceof HTMLElement) {
            if (!this.popStyle) {
                props.style = __assign$2(__assign$2({}, props.style), calcPopFromFlowStyle(this.ref));
                this.popStyle = props.style;
            }
            else {
                props.style = this.popStyle;
            }
        }
        else {
            this.popStyle = null;
        }
        return props;
    };
    PoseElement.prototype.componentDidMount = function () {
        var _this = this;
        invariant(this.ref instanceof Element, "No valid DOM ref found. If you're converting an existing component via posed(Component), you must ensure you're passing the ref to the host DOM node via the React.forwardRef function.");
        var _a = this.props, onValueChange = _a.onValueChange, registerChild = _a.registerChild, values = _a.values, parentValues = _a.parentValues, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, onPressStart = _a.onPressStart, onPressEnd = _a.onPressEnd;
        var config = __assign$2(__assign$2({}, this.poseConfig), { initialPose: this.getInitialPose(), values: values || this.poseConfig.values, parentValues: parentValues ? objectToMap(parentValues) : undefined, props: this.getSetProps(), onDragStart: onDragStart,
            onDragEnd: onDragEnd,
            onPressStart: onPressStart,
            onPressEnd: onPressEnd, onChange: onValueChange });
        if (!registerChild) {
            this.initPoser(domPose$1(this.ref, config));
        }
        else {
            registerChild({
                element: this.ref,
                poseConfig: config,
                onRegistered: function (poser) { return _this.initPoser(poser); }
            });
        }
    };
    PoseElement.prototype.getSnapshotBeforeUpdate = function () {
        var _a = this.props, pose = _a.pose, _pose = _a._pose;
        if (hasPose(pose, 'flip') || hasPose(_pose, 'flip'))
            this.poser.measure();
        return null;
    };
    PoseElement.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, pose = _a.pose, _pose = _a._pose, poseKey = _a.poseKey;
        this.poser.setProps(this.getSetProps());
        if (poseKey !== prevProps.poseKey ||
            hasChanged(prevProps.pose, pose) ||
            pose === 'flip') {
            this.setPose(pose);
        }
        if (_pose !== prevProps._pose || _pose === 'flip')
            this.setPose(_pose);
    };
    PoseElement.prototype.componentWillUnmount = function () {
        if (!this.poser)
            return;
        var onUnmount = this.props.onUnmount;
        if (onUnmount)
            onUnmount(this.poser);
        this.poser.destroy();
    };
    PoseElement.prototype.initPoser = function (poser) {
        this.poser = poser;
        this.flushChildren();
        var firstPose = this.getFirstPose();
        if (firstPose)
            this.setPose(firstPose);
    };
    PoseElement.prototype.setPose = function (pose) {
        var _this = this;
        var onPoseComplete = this.props.onPoseComplete;
        var poseList = Array.isArray(pose) ? pose : [pose];
        Promise.all(poseList.map(function (key) { return key && _this.poser.set(key); })).then(function () { return onPoseComplete && onPoseComplete(pose); });
    };
    PoseElement.prototype.flushChildren = function () {
        var _this = this;
        this.children.forEach(function (_a) {
            var element = _a.element, poseConfig = _a.poseConfig, onRegistered = _a.onRegistered;
            return onRegistered(_this.poser.addChild(element, poseConfig));
        });
        this.children.clear();
    };
    PoseElement.prototype.render = function () {
        var elementType = this.props.elementType;
        return (React__default.createElement(PoseParentProvider, { value: this.childrenHandlers }, createElement(elementType, pickAssign(this.shouldForwardProp, [
            this.getSetProps(),
            { ref: this.setRef }
        ]))));
    };
    return PoseElement;
}(PureComponent));

var supportedElements = [
    'a',
    'article',
    'aside',
    'audio',
    'b',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dialog',
    'div',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'i',
    'iframe',
    'img',
    'input',
    'label',
    'legend',
    'li',
    'nav',
    'object',
    'ol',
    'option',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'section',
    'select',
    'span',
    'strong',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'ul',
    'video',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];

var componentCache = new Map();
var createComponentFactory = function (key) {
    var componentFactory = function (poseConfig) {
        if (poseConfig === void 0) { poseConfig = {}; }
        return forwardRef(function (_a, ref) {
            var _b = _a.withParent, withParent = _b === void 0 ? true : _b, props = __rest$1(_a, ["withParent"]);
            warning(props.innerRef === undefined, 'innerRef is deprecated. Please use ref instead.');
            return !withParent || props.parentValues ? (React__default.createElement(PoseElement, __assign$2({ poseConfig: poseConfig, innerRef: ref, elementType: key }, props))) : (React__default.createElement(PoseParentConsumer, null, function (parentCtx) { return (React__default.createElement(PoseElement, __assign$2({ poseConfig: poseConfig, elementType: key, innerRef: ref }, props, parentCtx))); }));
        });
    };
    componentCache.set(key, componentFactory);
    return componentFactory;
};
var getComponentFactory = function (key) {
    return componentCache.has(key)
        ? componentCache.get(key)
        : createComponentFactory(key);
};
var posed = (function (component) {
    return getComponentFactory(component);
});
supportedElements.reduce(function (acc, key) {
    acc[key] = createComponentFactory(key);
    return acc;
}, posed);

var getKey = function (child) {
    invariant(child && child.key !== null, 'Every child of Transition must be given a unique key');
    var childKey = typeof child.key === 'number' ? child.key.toString() : child.key;
    return childKey.replace('.$', '');
};
var prependProps = function (element, props) {
    return createElement(element.type, __assign$2(__assign$2({ key: element.key, ref: element.ref }, props), element.props));
};
var handleTransition = function (_a, _b) {
    var displayedChildren = _b.displayedChildren, finishedLeaving = _b.finishedLeaving, hasInitialized = _b.hasInitialized, indexedChildren = _b.indexedChildren, scheduleChildRemoval = _b.scheduleChildRemoval;
    var incomingChildren = _a.children, preEnterPose = _a.preEnterPose, enterPose = _a.enterPose, exitPose = _a.exitPose, animateOnMount = _a.animateOnMount; _a.enterAfterExit; var flipMove = _a.flipMove; _a.onRest; var propsForChildren = __rest$1(_a, ["children", "preEnterPose", "enterPose", "exitPose", "animateOnMount", "enterAfterExit", "flipMove", "onRest"]);
    var targetChildren = makeChildList(incomingChildren);
    var nextState = {
        displayedChildren: []
    };
    if (process.env.NODE_ENV !== 'production') {
        warning(!propsForChildren.onPoseComplete, "<Transition/> (or <PoseGroup/>) doesn't accept onPoseComplete prop.");
    }
    var prevKeys = displayedChildren.map(getKey);
    var nextKeys = targetChildren.map(getKey);
    var hasPropsForChildren = Object.keys(propsForChildren).length !== 0;
    var entering = new Set(nextKeys.filter(function (key) { return finishedLeaving.hasOwnProperty(key) || prevKeys.indexOf(key) === -1; }));
    entering.forEach(function (key) { return delete finishedLeaving[key]; });
    var leaving = [];
    var newlyLeaving = {};
    prevKeys.forEach(function (key) {
        if (entering.has(key)) {
            return;
        }
        var isLeaving = finishedLeaving.hasOwnProperty(key);
        if (!isLeaving && nextKeys.indexOf(key) !== -1) {
            return;
        }
        leaving.push(key);
        if (!isLeaving) {
            finishedLeaving[key] = false;
            newlyLeaving[key] = true;
        }
    });
    var moving = new Set(prevKeys.filter(function (key, i) {
        return !entering.has(key) || leaving.indexOf(key) === -1;
    }));
    targetChildren.forEach(function (child) {
        var newChildProps = {};
        if (entering.has(child.key)) {
            if (hasInitialized || animateOnMount) {
                newChildProps.initialPose = preEnterPose;
            }
            newChildProps._pose = enterPose;
        }
        else if (moving.has(child.key) && flipMove) {
            newChildProps._pose = [enterPose, 'flip'];
        }
        else {
            newChildProps._pose = enterPose;
        }
        var newChild = cloneElement(child, newChildProps);
        indexedChildren[child.key] = newChild;
        nextState.displayedChildren.push(hasPropsForChildren ? prependProps(newChild, propsForChildren) : newChild);
    });
    leaving.forEach(function (key) {
        var child = indexedChildren[key];
        var newChild = newlyLeaving[key]
            ? cloneElement(child, {
                _pose: exitPose,
                onPoseComplete: function (pose) {
                    if (pose === exitPose)
                        scheduleChildRemoval(key);
                    var onPoseComplete = child.props.onPoseComplete;
                    if (onPoseComplete)
                        onPoseComplete(pose);
                },
                popFromFlow: flipMove
            })
            : child;
        var insertionIndex = prevKeys.indexOf(key);
        indexedChildren[child.key] = newChild;
        nextState.displayedChildren.splice(insertionIndex, 0, hasPropsForChildren ? prependProps(newChild, propsForChildren) : newChild);
    });
    return nextState;
};
var handleChildrenTransitions = (function (props, state) {
    var newState = handleTransition(props, state);
    newState.hasInitialized = true;
    return newState;
});
var makeChildList = function (children) {
    var list = [];
    Children.forEach(children, function (child) { return child && list.push(child); });
    return list;
};

var Transition = (function (_super) {
    __extends(Transition, _super);
    function Transition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            displayedChildren: [],
            finishedLeaving: {},
            hasInitialized: false,
            indexedChildren: {},
            scheduleChildRemoval: function (key) { return _this.removeChild(key); }
        };
        return _this;
    }
    Transition.prototype.removeChild = function (key) {
        var _a = this.state, displayedChildren = _a.displayedChildren, finishedLeaving = _a.finishedLeaving;
        var _b = this.props, enterAfterExit = _b.enterAfterExit, onRest = _b.onRest;
        if (!finishedLeaving.hasOwnProperty(key))
            return;
        finishedLeaving[key] = true;
        if (!Object.keys(finishedLeaving).every(function (leavingKey) { return finishedLeaving[leavingKey]; })) {
            return;
        }
        var targetChildren = displayedChildren.filter(function (child) { return !finishedLeaving.hasOwnProperty(child.key); });
        var newState = enterAfterExit
            ? __assign$2({ finishedLeaving: {} }, handleChildrenTransitions(__assign$2(__assign$2({}, this.props), { enterAfterExit: false }), __assign$2(__assign$2({}, this.state), { displayedChildren: targetChildren }))) : {
            finishedLeaving: {},
            displayedChildren: targetChildren
        };
        this.setState(newState, onRest);
    };
    Transition.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return this.state !== nextState;
    };
    Transition.prototype.render = function () {
        return this.state.displayedChildren;
    };
    Transition.defaultProps = {
        flipMove: false,
        enterAfterExit: false,
        preEnterPose: 'exit',
        enterPose: 'enter',
        exitPose: 'exit'
    };
    Transition.getDerivedStateFromProps = handleChildrenTransitions;
    return Transition;
}(Component));

((function (_super) {
    __extends(PoseGroup, _super);
    function PoseGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PoseGroup.prototype.render = function () {
        return createElement(Transition, __assign$2({}, this.props));
    };
    PoseGroup.defaultProps = {
        flipMove: true
    };
    return PoseGroup;
})(Component));

var _templateObject$m, _templateObject2$i, _templateObject3$d, _templateObject4$9, _templateObject5$8, _templateObject6$5, _templateObject7$2;
var StyledWrapper = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral$1(["\n\twidth: 100%;\n\theight: ", ";\n\toverflow-x: hidden;\n\tdisplay: flex;\n\tposition: relative;\n\ttext-align: center;\n\t.imageloader {\n\t\twidth: 100%;\n\t}\n"])), function (props) {
  return props.height || '100%';
});
styled.div(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral$1(["\n\twidth: 100%;\n\theight: 100%;\n\tbackground-image: ", ";\n\tbackground-size: cover;\n"])), function (_ref) {
  var background = _ref.background;
  return "url(".concat(background, ")");
});
var StyledNavBtn = styled.div(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral$1(["\n\twidth: 24px;\n\theight: 24px;\n\tposition: absolute;\n\ttop: 50%;\n\tmargin-top: -12px;\n\tcursor: pointer;\n\tz-index: 1;\n"])));
var Title$1 = styled.div(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\tleft: 20px;\n\ttop: 20px;\n"])));
var Description = styled.div(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\tright: 20px;\n\tbottom: 20px;\n"])));
var StyledPrev = styled(StyledNavBtn)(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral$1(["\n\tleft: 0px;\n"])));
var StyledNext = styled(StyledNavBtn)(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral$1(["\n\tright: 0px;\n"])));
var PrevBtn = posed(StyledPrev)({
  show: {
    x: '0px'
  },
  hide: {
    x: '-24px'
  }
});
var NextBtn = posed(StyledNext)({
  show: {
    x: '-10px'
  },
  hide: {
    x: '4vw'
  }
});

var ImageSlider = function ImageSlider(props) {
  var _useState = useState(0),
      _useState2 = _slicedToArray$8(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$8(_useState3, 2),
      isHover = _useState4[0],
      setHover = _useState4[1];

  var next = function next() {
    if (!props.disabled) {
      setCurrent(props.images[current + 1] ? current + 1 : 0);
    }
  };

  var previous = function previous() {
    if (!props.disabled) {
      setCurrent(current === 0 ? props.images.length - 1 : current - 1);
    }
  };

  var title = props.title,
      description = props.description;
      props.animateArrows;
      var height = props.height,
      images = props.images,
      rest = _objectWithoutProperties$c(props, ["title", "description", "animateArrows", "height", "images"]);

  return /*#__PURE__*/React__default.createElement(StyledWrapper, {
    flipMove: false,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    height: height
  }, /*#__PURE__*/React__default.createElement(PrevBtn, {
    pose: isHover ? 'show' : 'hide'
  }, /*#__PURE__*/React__default.createElement(Wrapper$Z, _extends$g({}, rest, {
    color: props.iconsColor,
    icon: "caret-left",
    onClick: previous
  }))), /*#__PURE__*/React__default.createElement(SwipeableViews, {
    index: current,
    style: {
      width: '100%'
    },
    enableMouseEvents: true
  }, images.map(function (img, i) {
    return /*#__PURE__*/React__default.createElement(Image, {
      key: "img-".concat(i),
      src: img,
      width: "auto",
      height: "auto",
      mx: "auto",
      style: {
        height: props.height
      }
    });
  })), title ? /*#__PURE__*/React__default.createElement(Title$1, null, title) : undefined, description ? /*#__PURE__*/React__default.createElement(Description, null, description) : undefined, /*#__PURE__*/React__default.createElement(NextBtn, {
    pose: isHover ? 'show' : 'hide'
  }, /*#__PURE__*/React__default.createElement(Wrapper$Z, _extends$g({}, rest, {
    color: props.iconsColor,
    icon: "caret-right",
    onClick: next
  }))));
};

ImageSlider.propTypes = {
  /** List of image urls */
  images: PropTypes.arrayOf(PropTypes.string).isRequired,

  /** customize the arrows color */
  iconsColor: PropTypes.string,

  /** customize the background color */
  backgroundColor: PropTypes.string,

  /** Adds a title to the slider */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Adds a description */
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
ImageSlider.defaultProps = {
  images: [],
  iconsColor: '#999',
  backgroundColor: '#f9f9f9'
};
var Wrapper$y = withTheme(ImageSlider);

/**
 * InputField is a component that provides an input element wrapped with a label, hint and other helpers to form a basic molecule in a form
 */

var InputField = function InputField(props) {
  var randomID = RandomID(6);

  props.label;
      var name = props.name,
      id = props.id;
      props.hint;
      var value = props.value,
      type = props.type,
      required = props.required,
      disabled = props.disabled,
      error = props.error,
      validationState = props.validationState;
      props.className;
      props.tooltip;
      props.tooltipDelay;
      var prefix = props.prefix,
      suffix = props.suffix;
      props.inactive;
      var onFocus = props.onFocus,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      initialFocused = props.initialFocused,
      focused = props.focused,
      inputStyles = props.inputStyles,
      rest = _objectWithoutProperties$c(props, ["label", "name", "id", "hint", "value", "type", "required", "disabled", "error", "validationState", "className", "tooltip", "tooltipDelay", "prefix", "suffix", "inactive", "onFocus", "onBlur", "onChange", "onValueChange", "initialFocused", "focused", "inputStyles"]);

  var _useFocus = useFocus(initialFocused),
      _useFocus2 = _slicedToArray$8(_useFocus, 2),
      setFocus = _useFocus2[0],
      focusProps = _useFocus2[1];

  var _useState = useState(),
      _useState2 = _slicedToArray$8(_useState, 2),
      lastAnnounced = _useState2[0],
      setLastAnnounced = _useState2[1];

  useEffect(function () {
    setFocus(focused);
  }, [focused, setFocus]);
  /**
   * Updates the states value and then fires onChange for listeners
   * @param  {event} event the event from the html input
   */

  var handleChange = function handleChange(event) {
    event.stopPropagation();
    var value = event.target.value;

    if (value) {
      if (type === 'text') ; else if (type === 'number') {
        value = Number(value);
      }
    }

    onChange(value);
  };
  /**
   * Sets the focused value to true ir order add proper class to parent
   * @param  {event} event input event
   */


  var handleFocus = function handleFocus(event) {
    event.stopPropagation();
    onFocus(event.target.value);
  };
  /**
   * Sets the focused value to false
   * @param  {event} event input event
   */


  var handleBlur = function handleBlur(event) {
    event.stopPropagation();
    onBlur(event.target.value);

    if (onValueChange && event.target.value !== lastAnnounced) {
      setLastAnnounced(event.target.value);
      onValueChange(event.target.value);
    }
  };
  /**
   * Fires on each keypress and checks if onValueChange is passed
   * @param  {event} event input event
   */


  var onKeyPress = function onKeyPress(event) {
    event.stopPropagation();
    if (props.onKeyPress) props.onKeyPress(event.target.value);

    if (event.key === 'Enter') {
      setLastAnnounced(event.target.value);
      onValueChange(event.target.value);
    }
  };

  var CompWrapper = prefix || suffix ? InputGroup : React__default.Fragment;
  /**
   * Figure out an id to pass to the form label and aria-labelledby to the child input element
   */

  var componentId = name || id || randomID;
  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, _extends$g({}, props, {
    id: componentId
  }), /*#__PURE__*/React__default.createElement(CompWrapper, null, prefix && /*#__PURE__*/React__default.createElement(InputPrepend, _extends$g({}, rest, {
    disabled: disabled
  }), prefix), /*#__PURE__*/React__default.createElement(FormControl, _extends$g({}, rest, focusProps, {
    as: props.isTextarea ? 'textarea' : 'input',
    "aria-labelledby": componentId,
    value: value,
    name: name,
    style: inputStyles,
    ref: props.inputRef,
    "aria-required": required ? 'true' : undefined,
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyPress: onKeyPress,
    type: type || 'text',
    error: error || validationState === 'danger',
    "aria-invalid": error || validationState === 'danger' ? 'true' : 'false',
    isValid: validationState === 'success',
    prefix: prefix,
    suffix: suffix,
    disabled: disabled
  })), suffix && /*#__PURE__*/React__default.createElement(InputAppend, _extends$g({}, rest, {
    size: rest.size,
    disabled: disabled
  }), suffix)));
};

InputField.propTypes = {
  /** Type of input e.g. `text`, `number`, `email`, `password`  */
  type: PropTypes.string,

  /** Value to show when component renders */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** fires when the the value of the field changes */
  onChange: PropTypes.func,

  /** if on value change is provided, the regular `onChange` event
   * will not fire on each character but only when the user hits enter or the component looses focus */
  onValueChange: PropTypes.func,

  /** fires when the focus has left the field */
  onBlur: PropTypes.func,

  /** fires when field is in focus */
  onFocus: PropTypes.func,

  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** adds a red star to the label if set to true and no value exists */
  required: PropTypes.bool,

  /** Adds a tooltip to the label */
  tooltip: PropTypes.string,

  /** Delays in seconds for showing to the tooltip on mouseenter */
  tooltipDelay: PropTypes.number,

  /** Adds a visual prefix to the field */
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Adds a visual suffix to the field  */
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Disabled components and prevents input  */
  disabled: PropTypes.bool,

  /** Disables the component but with different styling */
  inactive: PropTypes.bool,

  /** Affects the border color  */
  validationState: PropTypes.oneOf(['', 'success', 'danger']),

  /** Input field height  */
  size: PropTypes.oneOf(['large', 'normal', 'small']),

  /** For horizontal forms, it allows components to sit next to it */
  inline: PropTypes.bool,

  /** Displays a small hint under the field */
  hint: PropTypes.string,

  /** Set the focus to this component immediately after it's mounted */
  initialFocused: PropTypes.bool,

  /** Pass true to force focus to this field */
  focused: PropTypes.bool,

  /** Any valid style object passed to the inner input component */
  inputStyles: PropTypes.object
};
InputField.defaultProps = {
  type: 'text',
  value: undefined,
  onChange: function onChange() {},
  onValueChange: function onValueChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  size: 'large',
  label: undefined,
  required: false,
  tooltip: undefined,
  tooltipDelay: 0.5,
  prefix: undefined,
  inactive: false,
  validationState: undefined,
  inline: false
};
InputField.displayName = 'InputField';
var Wrapper$x = compose$1(withTheme, withTransformers)(InputField);

var Layout = function Layout(props) {
  var wrapperStyles = {
    width: '100%',
    height: '100%',
    direction: props.orientation,
    position: 'relative'
  };
  var headerStyles = {
    width: '100%',
    boxSizing: 'border-box'
  };
  var sidebarStyles = {
    overflow: 'auto'
  };
  var contentStyles = {
    height: '100%',
    position: 'relative'
  };
  var innerContentStyles = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    overflow: 'auto'
  };
  return /*#__PURE__*/React__default.createElement(Wrapper$12, {
    flexDirection: 'column',
    style: wrapperStyles
  }, /*#__PURE__*/React__default.createElement(Wrapper$11, {
    style: headerStyles
  }, props.header), /*#__PURE__*/React__default.createElement(Wrapper$12, {
    flex: "1 1 auto",
    flexDirection: "row"
  }, /*#__PURE__*/React__default.createElement(Wrapper$11, {
    style: sidebarStyles
  }, props.sidebar), /*#__PURE__*/React__default.createElement(Wrapper$12, {
    flexDirection: "column",
    flex: "1 1 auto"
  }, /*#__PURE__*/React__default.createElement(Wrapper$11, {
    style: contentStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    style: innerContentStyles
  }, props.content || props.children)), /*#__PURE__*/React__default.createElement(Wrapper$11, null, props.footer))));
};
Layout.propTypes = {
  /** Header component */
  header: PropTypes.node,

  /** Content component. If not present and component has children, they will be render instead */
  content: PropTypes.node,

  /** Layout component can either render `content` component or inner children */
  children: PropTypes.node,

  /** Sidebar component if present */
  sidebar: PropTypes.node,

  /** Footer component */
  footer: PropTypes.node,

  /** Determine the orientation of the layout. Accepts ['ltr', 'rtl']. With RTL, the sidebar will be on the right */
  orientation: PropTypes.oneOf(['rtl', 'ltr'])
};
Layout.defaultProps = {
  orientation: 'ltr'
};

var _templateObject$l, _templateObject2$h, _templateObject3$c, _templateObject4$8, _templateObject5$7;
var StyledModal = styled(ReactModal).attrs(function (props) {
  return {
    theme: props.theme,
    minWidth: props.width || (props.isInfo ? props.theme.minInfoModalWidth : props.theme.minModalWidth),
    maxWidth: props.width || (props.isInfo ? props.theme.maxInfoModalWidth : props.theme.maxModalWidth)
  };
})(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral$1(["\n\tborder-radius: ", ";\n\tmin-width: ", ";\n\tmax-width: ", ";\n\tmax-height: 95%;\n\tposition: relative;\n\tborder: solid 1px ", ";\n\tbox-shadow: 0 1px 4px 0 rgba(43, 63, 89, 0.21), inset 0px 0 0 #7e95a7;\n\talign-self: center;\n\ttransition: all 0.2s ease-out;\n\tz-index: ", ";\n\toutline: none;\n\ttransform: translate(0, -50px);\n\topacity: 0;\n\n\t&.ReactModal__Content--after-open {\n\t\ttransform: none;\n\t\topacity: 1;\n\t}\n\t&.ReactModal__Content--before-close {\n\t\ttransform: translate(0, -50%) !important;\n\t\topacity: 0;\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.modalBorderRadius;
}, function (_ref2) {
  var minWidth = _ref2.minWidth;
  return minWidth;
}, function (_ref3) {
  var maxWidth = _ref3.maxWidth;
  return maxWidth;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.modalBorderColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.zIndexModal;
});
var StyledModalHeader = styled.div(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral$1(["\n\tpadding: ", ";\n\tbackground: ", ";\n\ttext-align: ", ";\n\tborder-top-left-radius: ", ";\n\tborder-top-right-radius: ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.modalHeaderPaddingY, "px ").concat(theme.modalHeaderPaddingX, "px ").concat(theme.modalHeaderPaddingY, "px");
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.modalHeaderBackground;
}, function (_ref8) {
  var theme = _ref8.theme,
      isInfo = _ref8.isInfo;
  return isInfo ? theme.modalHeaderTextAlign : 'left';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.modalBorderRadius;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.modalBorderRadius;
});
var StyledModalTitle = styled.h2(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral$1(["\n\tfont-size: ", ";\n\tline-height: ", ";\n\tflex-grow: 1;\n\tdisplay: flex;\n\tjustify-content: ", ";\n\tfont-family: ", ";\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.modalHeaderFontSize;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.modalHeaderFontSize;
}, function (_ref13) {
  var theme = _ref13.theme,
      isLevel = _ref13.isLevel;
  return isLevel ? 'flex-start' : theme.modalHeaderTextAlign;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.titlesFont;
});
var StyledModalBody = styled.div(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral$1(["\n\ttext-align: ", ";\n\tbackground: ", ";\n\tpadding: ", ";\n\tfont-family: ", ";\n\tfont-size: ", ";\n\tline-height: 1.5;\n\tmax-height: calc(100vh - 160px);\n\toverflow-y: auto;\n"])), function (_ref15) {
  var isInfo = _ref15.isInfo;
  return isInfo ? 'center' : 'inherit';
}, function (_ref16) {
  var theme = _ref16.theme,
      isInfo = _ref16.isInfo;
  return isInfo ? theme.modalInfoBodyBackground : theme.modalBodyBackground;
}, function (_ref17) {
  var theme = _ref17.theme,
      isInfo = _ref17.isInfo;
  return "".concat(isInfo ? theme.modalBodyPaddingY : 0, "px ").concat(theme.modalBodyPaddingX, "px 0px");
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontFamily;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.modalBodyFontSize;
});
var StyledModalFooter = styled.div(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral$1(["\n\tpadding: 20px;\n\ttext-align: center;\n\tbackground: ", ";\n\tdisplay: flex;\n\tflex-direction: column;\n\tborder-bottom-left-radius: ", ";\n\tborder-bottom-right-radius: ", ";\n\n\tbutton {\n\t\talign-self: center;\n\t}\n"])), function (_ref20) {
  var theme = _ref20.theme,
      isInfo = _ref20.isInfo;
  return isInfo ? theme.modalInfoBodyBackground : theme.modalBodyBackground;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.modalBorderRadius;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.modalBorderRadius;
});

var ModalDialog = function ModalDialog(props) {
  var title = props.title;
      props.className;
      var level = props.level;
      props.primaryButton;
      props.secondaryButton;
      props.hideOnClickOutside;
      props.overlay;
      var children = props.children,
      closable = props.closable,
      image = props.image,
      isOpen = props.isOpen,
      onHide = props.onHide,
      theme = props.theme,
      shouldCloseOnEsc = props.shouldCloseOnEsc,
      shouldCloseOnOverlayClick = props.shouldCloseOnOverlayClick,
      info = props.info,
      width = props.width,
      rest = _objectWithoutProperties$c(props, ["title", "className", "level", "primaryButton", "secondaryButton", "hideOnClickOutside", "overlay", "children", "closable", "image", "isOpen", "onHide", "theme", "shouldCloseOnEsc", "shouldCloseOnOverlayClick", "info", "width"]);

  var _useState = useState(isOpen),
      _useState2 = _slicedToArray$8(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  useEffect(function () {
    setOpen(isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : 'visible';
  }, [isOpen]);
  useEffect(function () {
    return function () {
      return document.body.style.overflow = 'visible';
    };
  }, []);

  var handlOnClose = function handlOnClose() {
    if (onHide) onHide();
    setOpen(false);
  };

  var getModalFooter = function getModalFooter() {
    var info = props.info,
        primaryButton = props.primaryButton,
        secondaryButton = props.secondaryButton,
        footer = props.footer,
        theme = props.theme;
    if (footer) return footer;

    if (primaryButton || secondaryButton) {
      return /*#__PURE__*/React__default.createElement(Wrapper$12, {
        flexDirection: props.info ? 'column' : 'row-reverse',
        justifyContent: info ? 'space-around' : 'flex-start'
      }, primaryButton ? /*#__PURE__*/React__default.createElement(ButtonWrapper, {
        variation: primaryButton.variation || 'primary',
        onClick: primaryButton.onClick,
        theme: theme
      }, primaryButton.label) : undefined, secondaryButton ? /*#__PURE__*/React__default.createElement(ButtonWrapper, {
        variation: secondaryButton.variation,
        onClick: secondaryButton.onClick,
        theme: theme,
        mr: 2
      }, secondaryButton.label) : undefined);
    }
  };

  var iconStyle = {
    position: 'absolute',
    top: 15,
    right: 15,
    cursor: 'pointer'
  };
  var close = closable ? /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    theme: theme,
    className: "close",
    icon: "close",
    onClick: handlOnClose,
    size: 24,
    color: "#ccc",
    hoverColor: "#999",
    style: iconStyle,
    tabIndex: 0,
    role: "button",
    "aria-label": "close dialog"
  }) : undefined;
  var modalWidth = typeof width === 'number' ? "".concat(width, "px") : width;
  var icon = '';
  var iconColor = '';

  switch (level) {
    case 'info':
      icon = 'circle-info';
      iconColor = theme.alertInfoAccent;
      break;

    case 'success':
      icon = 'circle-check';
      iconColor = theme.alertSuccessAccent;
      break;

    case 'warning':
      icon = 'warning';
      iconColor = theme.alertWarningAccent;
      break;

    case 'danger':
    case 'error':
      icon = 'circle-close';
      iconColor = theme.alertErrorAccent;
      break;
  }

  return /*#__PURE__*/React__default.createElement(StyledModal, {
    isOpen: open,
    ariaHideApp: false,
    width: modalWidth,
    isInfo: info ? 1 : 0,
    theme: theme,
    closeTimeoutMS: 200,
    shouldCloseOnEsc: shouldCloseOnEsc,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    onRequestClose: handlOnClose,
    "aria-label": title,
    style: {
      overlay: {
        position: 'fixed',
        backgroundColor: theme.modalOverlayBackground || 'rgba(0, 0, 0, 0, 0.5)',
        overflowX: 'hidden',
        overflowY: 'auto',
        outline: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: theme.zIndexModalBackdrop
      }
    }
  }, /*#__PURE__*/React__default.createElement(StyledModalHeader, _extends$g({}, rest, {
    isInfo: info ? 1 : 0,
    theme: theme
  }), title && /*#__PURE__*/React__default.createElement(StyledModalTitle, {
    theme: theme,
    isLevel: level
  }, icon && /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    icon: icon,
    color: iconColor,
    hoverColor: iconColor,
    size: 26,
    role: "presentation",
    "aria-hidden": "true",
    mr: 1
  }), title), image), /*#__PURE__*/React__default.createElement(StyledModalBody, {
    theme: theme,
    isInfo: props.info ? 1 : 0
  }, children), /*#__PURE__*/React__default.createElement(StyledModalFooter, {
    theme: theme,
    isInfo: props.info ? 1 : 0
  }, getModalFooter()), close);
};

ModalDialog.propTypes = {
  /** Modal title */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Modal level: info (default), success, danger, warning  */
  level: PropTypes.string,

  /** Controls the appearance of the Modal  */
  isOpen: PropTypes.bool,

  /** Primary button */
  primaryButton: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func
  }),

  /** Secondary button if exists */
  secondaryButton: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func
  }),

  /** Image to display  */
  image: PropTypes.node,

  /** Specify custom width for the modal */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Custom footer to render at the bottom */
  footer: PropTypes.node,

  /** Styles the modal as info modal */
  info: PropTypes.bool,

  /** Controls whether hitting esc button should close the popup */
  shouldCloseOnEsc: PropTypes.bool,

  /** Controls whether clicking on the overlay background should close the popup */
  shouldCloseOnOverlayClick: PropTypes.bool,

  /** Called when the Modal is closed */
  onHide: PropTypes.func,

  /** Adds a close button */
  closable: PropTypes.bool
};
ModalDialog.defaultProps = {
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true
};
var Wrapper$w = withTheme(ModalDialog);

var bounceInUp = keyframes$2(["from,60%,75%,90%,to{animation-timing-function:cubic-bezier(0.215,0.610,0.355,1.000);}from{opacity:0;transform:translate3d(0,3000px,0);}60%{opacity:1;transform:translate3d(0,-20px,0);}75%{transform:translate3d(0,10px,0);}90%{transform:translate3d(0,-5px,0);}to{transform:translate3d(0,0,0);}"]);
var fadeOutDown = keyframes$2(["from{opacity:1;}to{opacity:0;transform:translate3d(0,100%,0);}"]);
var bounceInRight = keyframes$2(["from,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(0.215,0.610,0.355,1.000);animation-timing-function:cubic-bezier(0.215,0.610,0.355,1.000);}from{opacity:0;-webkit-transform:translate3d(3000px,0,0);transform:translate3d(3000px,0,0);}60%{opacity:1;-webkit-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0);}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0);}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0);}to{-webkit-transform:none;transform:none;}"]);
var bounceOutRight = keyframes$2(["20%{opacity:1;transform:translate3d(-20px,0,0);}to{opacity:0;transform:translate3d(2000px,0,0);}"]);

var _templateObject$k, _templateObject2$g, _templateObject3$b;

var getBackgroundColor$1 = function getBackgroundColor(props) {
  var bg = '';

  switch (props.level) {
    case 'info':
      bg = props.theme.notificationInfoColor;
      break;

    case 'success':
      bg = props.theme.notificationSuccessColor;
      break;

    case 'warning':
      bg = props.theme.notificationWarningColor;
      break;

    case 'error':
    case 'danger':
      bg = props.theme.notificationErrorColor;
      break;

    default:
      bg = props.theme.notificationInfoColor;
      break;
  }

  return bg;
};

var NotificationsContainer = styled.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral$1(["\n\tposition: fixed;\n\tz-index: 10001;\n\n\t", "\n\t.notification, .toast {\n\t\topacity: 0;\n\t\tfont-size: 15px;\n\t\tright: 0px;\n\t}\n\n\t.notification {\n\t\t&.in {\n\t\t\tanimation: ", " 1s ease;\n\t\t\topacity: 1;\n\t\t}\n\n\t\t&.out {\n\t\t\tanimation: ", " 1s ease;\n\t\t}\n\t}\n\t.toast {\n\t\t&.in {\n\t\t\tanimation: ", " 1s;\n\t\t\topacity: 1;\n\t\t}\n\n\t\t&.out {\n\t\t\tanimation: ", " 1s;\n\t\t}\n\t}\n"])), function (props) {
  return props.type === 'toast' ? css$4(["width:400px;right:20px;top:20px;"]) : css$4(["width:100%;bottom:0%;"]);
}, bounceInUp, fadeOutDown, bounceInRight, bounceOutRight);
var NotificationContent = styled.div(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral$1(["\n\tbackground: ", ";\n\tpadding: ", ";\n\tborder-radius: ", ";\n\tmargin-bottom: ", ";\n\tfont-size: ", ";\n\tfont-family: ", ";\n"])), getBackgroundColor$1, function (props) {
  return props.type === 'toast' ? props.theme.toastPadding : props.theme.notificationPadding;
}, function (props) {
  return props.type === 'toast' && props.theme.notificationBorderRadius;
}, function (props) {
  return props.type === 'toast' && '5px';
}, function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
});
var NotificationMessage = styled.div(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral$1(["\n\tdisplay: flex;\n\tflex: auto;\n\talign-items: center;\n\tcolor: #fff;\n"])));

var current_notification;

var NotificationComponent = function NotificationComponent(props) {
  var handleClose = function handleClose(triggerOnClose) {
    props.close(triggerOnClose);
  };

  var level = props.level,
      icon = props.icon;

  if (!icon) {
    switch (level) {
      case 'info':
        icon = 'bell';
        break;

      case 'success':
        icon = 'check';
        break;

      case 'warning':
        icon = 'circle-info';
        break;

      case 'danger':
        icon = 'close';
        break;

      default:
        icon = 'bell';
        break;
    }
  }

  return /*#__PURE__*/React__default.createElement(NotificationContent, _extends$g({}, props, {
    role: "alert",
    "aria-live": "assertive"
  }), /*#__PURE__*/React__default.createElement(NotificationMessage, null, props.icon || /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    icon: props.iconName || icon,
    color: "#FFF",
    hoverColor: "#FFF",
    size: 30
  }), /*#__PURE__*/React__default.createElement(NotificationMessage, null, props.children), props.autoClose === false || props.closeIcon || props.type === 'toast' ? props.closeIcon || /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    theme: props.theme,
    icon: "close",
    onClick: handleClose,
    size: 30,
    color: "#FFF",
    hoverColor: "#efefef"
  }) : undefined));
};

var NotificationComp = withTheme(NotificationComponent);
/**
 * Handler to REMOVE the notification
 */

function remove(wrapper) {
  wrapper.className += ' out';
  setTimeout(function () {
    if (wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
  }, 500);
}
/**
 * Called when clicking on close button
 */


function dismiss(wrapper, onClose, autoClose) {
  remove(wrapper);
  clearTimeout(autoClose);
  if (onClose) onClose();
}
/**
 *
 */


var getContainer = function getContainer(type) {
  var id = "".concat(type, "-container");
  var container = document.getElementById(id);

  if (!container) {
    container = document.createElement('div');
    container.setAttribute('id', id);
    container.innerHTML = ReactDOMServer.renderToString( /*#__PURE__*/React__default.createElement(NotificationsContainer, {
      type: type
    }));
    container.className = container.children[0].getAttribute('class');
    container.innerHTML = '';
    document.body.appendChild(container);
  }

  return container;
};

var Notify = {
  show: function show(options) {
    var type = options.type || 'notification';
    var notifications_container = getContainer('notification');
    var toasts_container = getContainer('toast');
    var wrapper = document.createElement('div');
    wrapper.className = type;

    if (type === 'notification') {
      notifications_container.appendChild(wrapper);
    } else {
      toasts_container.appendChild(wrapper);
    }

    var show_duration = options.duration || 4000; // default 4 seconds
    // wait after the component is called to animate toast.

    setTimeout(function () {
      wrapper.className = "".concat(type, " in");
    }, 150); // wait after the component is called to animate toast.

    var autoClose = setTimeout(function () {
      if (options.autoClose !== undefined || options.autoClose === false || options.closeIcon) ; else {
        if (options.onClose) options.onClose();
        remove(wrapper);
      }
    }, show_duration);
    ReactDOM.render( /*#__PURE__*/React__default.createElement(NotificationComp, {
      ref: function ref(notification) {
        current_notification = notification;
      },
      className: options.className,
      close: function close(triggerOnClose) {
        return dismiss(wrapper, triggerOnClose ? options.onClose : undefined, autoClose);
      },
      icon: options.icon,
      closeIcon: options.closeIcon,
      level: options.level,
      autoClose: options.autoClose,
      onClose: options.onClose,
      type: type
    }, options.message), wrapper);
  },
  hide: function hide(triggerOnClose) {
    if (triggerOnClose === undefined) triggerOnClose = true; // true if nothing is passed

    current_notification.handleClose(triggerOnClose);
  }
};
NotificationComp.propTypes = {
  /** Notification message */
  message: PropTypes.string,

  /** Notification level which is on of 'info', 'success','warning', 'danger' */
  level: PropTypes.oneOf(['info', 'success', 'warning', 'danger']),

  /** Notification icon */
  icon: PropTypes.node,

  /** Notification icon name from the Icons list */
  iconName: PropTypes.string,

  /** Notification close icon */
  closeIcon: PropTypes.node,

  /** Check if the Notification should be auto closed */
  autoClose: PropTypes.bool,

  /** Defined the type of the Notification which is either Notification or Toast */
  type: PropTypes.oneOf(['notification', 'toast'])
};
NotificationComp.defaultProps = {
  type: 'notification',
  autoClose: true
};

var _templateObject$j, _templateObject2$f, _templateObject3$a, _templateObject4$7, _templateObject5$6, _templateObject6$4;
/********************
 * Color helpers
 ******************/

var getRadioButtonColor$1 = function getRadioButtonColor(_ref) {
  var theme = _ref.theme,
      checked = _ref.checked,
      disabled = _ref.disabled;
      _objectWithoutProperties$c(_ref, ["theme", "checked", "disabled"]);

  if (disabled) return theme.radioDisabledColor;

  if (checked) {
    return theme.radioActiveColor || theme.primary;
  }

  return theme.radioColor;
};

var getCheckMarkColor = function getCheckMarkColor(_ref2) {
  var theme = _ref2.theme,
      disabled = _ref2.disabled;
  if (disabled) return theme.checkMarkColorDisabl;
  return theme.checkMarkColor || theme.primary;
};
/******************************************************
 *
 *  RADIO BUTTON
 *
 ******************************************************/


styled.input(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\topacity: 0;\n\theight: ", "px;\n\twidth: ", "px;\n\tleft: 0;\n\ttop: 0;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.radioCircleSize - 2;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.radioCircleSize - 2;
});
var StyledRadioWrapper$1 = styled.span(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral$1(["\n\tdisplay: ", ";\n\tposition: relative;\n\tfont-size: ", ";\n\tuser-select: none;\n\twidth: ", ";\n\tmin-width: ", "px;\n\tmin-height: ", "px;\n\n\t", "\n\n\t", "\n\t\t\n\n\t& input {\n\t\t& + label {\n\t\t\t&::before {\n\t\t\t\tcontent: '';\n\t\t\t\twidth: ", "px;\n\t\t\t\theight: ", "px;\n\t\t\t\tflex-basis: ", "px;\n\t\t\t\tflex-grow: 0;\n\t\t\t\tflex-shrink: 0;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tborder: 1px solid ", ";\n\t\t\t\tposition: absolute;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tbackground: ", ";\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tvertical-align: middle;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 3px;\n\t\t\t\ttransition: all 250ms ease-in-out;\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tbackground: ", ";\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tposition: absolute;\n\t\t\t\theight: 0;\n\t\t\t\twidth: 0;\n\t\t\t\ttransition: all 250ms ease-in-out;\n\t\t\t\tleft: ", "px;\n\t\t\t\ttop: ", "px;\n\t\t\t}\n\t\t}\n\t\t&:hover:not(:disabled) + label::before {\n\t\t\tborder-color: ", ";\n\t\t}\n\n\t\t&:checked + label {\n\t\t\t&::before {\n\t\t\t\tborder-color: ", ";\n\t\t\t}\n\t\t\t&::after {\n\t\t\t\tbackground: ", ";\n\t\t\t\theight: ", "px;\n\t\t\t\twidth: ", "px;\n\t\t\t\tleft: ", "px;\n\t\t\t\ttop: ", "px;\n\t\t\t}\n\t\t}\n\t\t&:disabled + label {\n\t\t\t&::before {\n\t\t\t\tborder-color: ", ";\n\t\t\t\tbackground: ", ";\n\t\t\t}\n\t\t\t&::after {\n\t\t\t\tbackground: ", ";\n\t\t\t}\n\t\t}\n\t\t&:focus + label::before {\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t}\n\tlabel {\n\t\toutline: none;\n\t}\n"])), function (_ref5) {
  var inline = _ref5.inline,
      horizontal = _ref5.horizontal;
  return inline || horizontal ? 'inline-block' : 'block';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSize;
}, function (_ref7) {
  var columned = _ref7.columned;
  return columned ? '30%' : 'auto';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.radioCircleSize;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.radioCircleSize;
}, space, function (props) {
  return props.inline ? css$4(["margin-right:6px;"]) : undefined;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.radioCircleSize;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.radioCircleSize;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.radioCircleSize;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.radioColor;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.radioBg;
}, getRadioButtonColor$1, function (_ref15) {
  var radioCircleSize = _ref15.theme.radioCircleSize;
  return radioCircleSize / 2;
}, function (_ref16) {
  var radioCircleSize = _ref16.theme.radioCircleSize;
  return radioCircleSize / 2 + 3;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.radioHoverColor || theme.primary;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.radioActiveColor || theme.primary;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.radioActiveColor || theme.primary;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.radioCircleInnerSize;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.radioCircleInnerSize;
}, function (_ref22) {
  var _ref22$theme = _ref22.theme,
      radioCircleSize = _ref22$theme.radioCircleSize,
      radioCircleInnerSize = _ref22$theme.radioCircleInnerSize;
  return radioCircleSize / 2 - radioCircleInnerSize / 2;
}, function (_ref23) {
  var _ref23$theme = _ref23.theme,
      radioCircleSize = _ref23$theme.radioCircleSize,
      radioCircleInnerSize = _ref23$theme.radioCircleInnerSize;
  return radioCircleSize / 2 - radioCircleInnerSize / 2 + 3;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.radioDisabledBorderColor;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.offwhite;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.radioDisabledBackground;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.focusOutline;
});
styled.span(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral$1(["\n\tfont-size: 0.9em;\n\tcolor: ", ";\n\tdisplay: block;\n\tmargin-top: ", "px;\n\tpadding-left: ", ";\n"])), function (_ref28) {
  var theme = _ref28.theme;
  return theme.checkboxOptionDescriptionColor;
}, function (_ref29) {
  var horizontal = _ref29.horizontal;
  return !horizontal ? -3 : 0;
}, function (_ref30) {
  var paddingLeft = _ref30.paddingLeft;
  return paddingLeft;
});
/***********************************************************
 *
 *    CHECKBOX
 *
 ***********************************************************/

styled.input(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\theight: ", ";\n\twidth: ", ";\n\tborder-radius: ", ";\n\tleft: 0px;\n\ttop: 0px;\n\n\t&:focus {\n\t\toutline: none;\n\t\tbox-shadow: ", ";\n\t}\n"])), function (_ref31) {
  var theme = _ref31.theme;
  return theme.checkboxSize;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.checkboxSize;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.checkboxBorderRadius;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.focusOutline;
});
var CheckOption = styled.label(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral$1(["\n\tdisplay: ", ";\n\tposition: relative;\n\tfont-size: ", ";\n\tuser-select: none;\n\twidth: ", ";\n\tmin-height: 20px;\n\t", "\n\n\t& input {\n\t\topacity: 0.0001;\n\n\t\t& + label {\n\t\t\t&::before {\n\t\t\t\tcontent: '';\n\t\t\t\theight: ", ";\n\t\t\t\twidth: ", ";\n\t\t\t\tborder-radius: ", ";\n\t\t\t\tborder: ", " solid\n\t\t\t\t\t", ";\n\t\t\t\tbackground: ", ";\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 2px;\n\t\t\t\tleft: 0px;\n\t\t\t}\n\t\t}\n\n\t\t&:checked + label::before {\n\t\t\tbackground: ", ";\n\t\t}\n\t\t&:checked + label::after {\n\t\t\tcontent: '';\n\t\t\tdisplay: block;\n\t\t\ttransform: rotate(45deg) translateY(-50%) translateX(-50%);\n\t\t\ttransform-origin: center;\n\t\t\theight: 10px;\n\t\t\twidth: 5px;\n\t\t\tborder-bottom: 2px solid ", ";\n\t\t\tborder-right: 2px solid ", ";\n\t\t\tbox-sizing: border-box;\n\t\t\tposition: absolute;\n\t\t\ttop: ", ";\n\t\t\tleft: ", ";\n\t\t\tmargin-top: 1px;\n\t\t}\n\t\t&:focus + label::before {\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t}\n\tlabel {\n\t\toutline: none;\n\t}\n\t&:focus {\n\t\toutline: none;\n\t}\n"])), function (_ref35) {
  var inline = _ref35.inline,
      horizontal = _ref35.horizontal;
  return inline || horizontal ? 'inline-block' : 'block';
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.fontSize;
}, function (_ref37) {
  var columned = _ref37.columned;
  return columned ? '30%' : 'auto';
}, space, function (_ref38) {
  var theme = _ref38.theme;
  return theme.checkboxSize;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.checkboxSize;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.checkboxBorderRadius;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.checkboxBorderWidth;
}, function (props) {
  return props.error ? props.theme.error : props.theme.inputBorderColor;
}, function (_ref42) {
  var theme = _ref42.theme,
      disabled = _ref42.disabled;
  return disabled ? theme.checkboxCheckedBgDisabled : theme.checkboxBg;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.checkboxCheckedBg;
}, getCheckMarkColor, getCheckMarkColor, function (_ref44) {
  var theme = _ref44.theme;
  return "calc((".concat(theme.checkboxSize, " / 2))");
}, function (_ref45) {
  var theme = _ref45.theme;
  return "calc((".concat(theme.checkboxSize, " / 2) - 4px)");
}, function (_ref46) {
  var theme = _ref46.theme,
      disabled = _ref46.disabled;
  return !disabled && theme.focusOutline;
});
var OptionsListWrapper = styled(Wrapper$12)(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral$1(["\n\tflex-direction: ", ";\n\tflex-wrap: wrap;\n\n\t", ",", "  {\n\t\tmargin-bottom: 5px;\n\t}\n"])), function (_ref47) {
  var inline = _ref47.inline,
      horizontal = _ref47.horizontal;
  return inline || horizontal ? 'row' : 'column';
}, StyledRadioWrapper$1, CheckOption);

var _templateObject$i, _templateObject2$e, _templateObject3$9;
/** ******************
 * Color helpers
 ***************** */

var getRadioButtonColor = function getRadioButtonColor(_ref) {
  var theme = _ref.theme,
      checked = _ref.checked,
      disabled = _ref.disabled;
      _objectWithoutProperties$c(_ref, ["theme", "checked", "disabled"]);

  if (disabled) return theme.radioDisabledColor;

  if (checked) {
    return theme.radioActiveColor || theme.primary;
  }

  return theme.radioColor;
};
/** ****************************************************
 *
 *  RADIO BUTTON STYLES
 *
 ***************************************************** */


var RadioInput = styled.input(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\topacity: 0;\n\theight: ", "px;\n\twidth: ", "px;\n\tleft: 0;\n\ttop: 0;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.radioCircleSize - 2;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radioCircleSize - 2;
});
var StyledRadioWrapper = styled.span(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral$1(["\n\tdisplay: ", ";\n\tposition: relative;\n\tfont-size: ", ";\n\tuser-select: none;\n\twidth: ", ";\n\tmin-width: ", "px;\n\tmin-height: ", "px;\n\n\t", "\n\n\t", "\n\t\t\n\n\t& input {\n\t\t& + label {\n\t\t\t&::before {\n\t\t\t\tcontent: '';\n\t\t\t\twidth: ", "px;\n\t\t\t\theight: ", "px;\n\t\t\t\tflex-basis: ", "px;\n\t\t\t\tflex-grow: 0;\n\t\t\t\tflex-shrink: 0;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tborder: 1px solid ", ";\n\t\t\t\tposition: absolute;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tbackground: ", ";\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tvertical-align: middle;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 3px;\n\t\t\t\ttransition: all 250ms ease-in-out;\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tbackground: ", ";\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tposition: absolute;\n\t\t\t\theight: 0;\n\t\t\t\twidth: 0;\n\t\t\t\ttransition: all 250ms ease-in-out;\n\t\t\t\tleft: ", "px;\n\t\t\t\ttop: ", "px;\n\t\t\t}\n\t\t}\n\t\t&:hover:not(:disabled) + label::before {\n\t\t\tborder-color: ", ";\n\t\t}\n\n\t\t&:checked + label {\n\t\t\t&::before {\n\t\t\t\tborder-color: ", ";\n\t\t\t}\n\t\t\t&::after {\n\t\t\t\tbackground: ", ";\n\t\t\t\theight: ", "px;\n\t\t\t\twidth: ", "px;\n\t\t\t\tleft: ", "px;\n\t\t\t\ttop: ", "px;\n\t\t\t}\n\t\t}\n\t\t&:disabled + label {\n\t\t\t&::before {\n\t\t\t\tborder-color: ", ";\n\t\t\t\tbackground: ", ";\n\t\t\t}\n\t\t\t&::after {\n\t\t\t\tbackground: ", ";\n\t\t\t}\n\t\t}\n\t\t&:focus + label::before {\n\t\t\tbox-shadow: ", ";\n\t\t}\n\t}\n\tlabel {\n\t\toutline: none;\n\t}\n"])), function (_ref4) {
  var inline = _ref4.inline,
      horizontal = _ref4.horizontal;
  return inline || horizontal ? 'inline-block' : 'block';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize;
}, function (_ref6) {
  var columned = _ref6.columned;
  return columned ? '30%' : 'auto';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.radioCircleSize;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.radioCircleSize;
}, space, function (props) {
  return props.inline ? css$4(["margin-right:6px;"]) : undefined;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.radioCircleSize;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.radioCircleSize;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.radioCircleSize;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.radioColor;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.radioBg;
}, getRadioButtonColor, function (_ref14) {
  var radioCircleSize = _ref14.theme.radioCircleSize;
  return radioCircleSize / 2;
}, function (_ref15) {
  var radioCircleSize = _ref15.theme.radioCircleSize;
  return radioCircleSize / 2 + 3;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.radioHoverColor || theme.primary;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.radioActiveColor || theme.primary;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.radioActiveColor || theme.primary;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.radioCircleInnerSize;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.radioCircleInnerSize;
}, function (_ref21) {
  var _ref21$theme = _ref21.theme,
      radioCircleSize = _ref21$theme.radioCircleSize,
      radioCircleInnerSize = _ref21$theme.radioCircleInnerSize;
  return radioCircleSize / 2 - radioCircleInnerSize / 2;
}, function (_ref22) {
  var _ref22$theme = _ref22.theme,
      radioCircleSize = _ref22$theme.radioCircleSize,
      radioCircleInnerSize = _ref22$theme.radioCircleInnerSize;
  return radioCircleSize / 2 - radioCircleInnerSize / 2 + 3;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.radioDisabledBorderColor;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.offwhite;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.radioDisabledBackground;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.focusOutline;
});
var OptionDescription = styled.span(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral$1(["\n\tfont-size: 0.9em;\n\tcolor: ", ";\n\tdisplay: block;\n\tmargin-top: ", "px;\n\tpadding-left: ", ";\n"])), function (_ref27) {
  var theme = _ref27.theme;
  return theme.checkboxOptionDescriptionColor;
}, function (_ref28) {
  var horizontal = _ref28.horizontal;
  return !horizontal ? -3 : 0;
}, function (_ref29) {
  var paddingLeft = _ref29.paddingLeft;
  return paddingLeft;
});
var StyledRadio = function StyledRadio(_ref30) {
  var disabled = _ref30.disabled,
      name = _ref30.name,
      label = _ref30.label,
      value = _ref30.value,
      description = _ref30.description,
      isChecked = _ref30.isChecked,
      tooltip = _ref30.tooltip,
      _onChange = _ref30.onChange;
      _ref30.onValueChange;
      var rest = _objectWithoutProperties$c(_ref30, ["disabled", "name", "label", "value", "description", "isChecked", "tooltip", "onChange", "onValueChange"]);

  var labelStyle = {
    paddingLeft: rest.theme.radioCircleSize + 10,
    paddingRight: 8
  };
  return /*#__PURE__*/React__default.createElement(StyledRadioWrapper, _extends$g({}, rest, {
    role: "radio",
    "aria-checked": isChecked
  }), /*#__PURE__*/React__default.createElement(RadioInput, _extends$g({}, rest, {
    disabled: disabled,
    type: "radio",
    name: name,
    id: "option-".concat(name, "-").concat(value),
    value: value,
    checked: isChecked,
    onChange: function onChange() {
      return _onChange(value);
    },
    theme: rest.theme
  })), /*#__PURE__*/React__default.createElement(Wrapper$Y, {
    disabled: disabled,
    htmlFor: "option-".concat(name, "-").concat(value),
    label: label,
    tooltip: tooltip,
    style: labelStyle,
    theme: rest.theme
  }), description ? /*#__PURE__*/React__default.createElement(OptionDescription, _extends$g({}, labelStyle.paddingLeft, {
    theme: rest.theme
  }), description) : undefined);
};

/**
 * Single Radio button
 */

var RadioButton = function RadioButton(props) {
  props.id;
      var label = props.label,
      value = props.value,
      name = props.name,
      tooltip = props.tooltip;
      props.className;
      props.tooltipDelay;
      var isChecked = props.isChecked,
      onChange = props.onChange,
      disabled = props.disabled,
      description = props.description;
      props.inactive;
      var rest = _objectWithoutProperties$c(props, ["id", "label", "value", "name", "tooltip", "className", "tooltipDelay", "isChecked", "onChange", "disabled", "description", "inactive"]);

  return /*#__PURE__*/React__default.createElement(StyledRadio, _extends$g({}, rest, {
    role: "radio",
    disabled: disabled,
    name: name,
    value: value,
    label: label,
    description: description,
    isChecked: isChecked,
    tooltip: tooltip,
    onChange: onChange
  }));
};

RadioButton.propTypes = {
  /** Enabled or disables the component */
  disabled: PropTypes.bool,

  /** Initial/Current value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),

  /** Optional label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Tooltip to show on top of label */
  tooltip: PropTypes.string,

  /** Additional description next to the checkbox label */
  description: PropTypes.string,

  /** Function to call when this component is clicked */
  onChange: PropTypes.func,

  /** Changes the component visually when true */
  isChecked: PropTypes.bool
};
RadioButton.defaultProps = {
  onChange: function onChange() {}
};
var Wrapper$v = withTheme(RadioButton);

/**
 * Options list component renders a group of checkboxes or radio buttons
 * based on `multiSelect` boolean parameter
 */

var OptionsList = function OptionsList(props) {
  var value = props.value,
      multiSelect = props.multiSelect,
      keepEmpty = props.keepEmpty,
      options = props.options,
      onChange = props.onChange,
      _props$name = props.name,
      name = _props$name === void 0 ? RandomID(6) : _props$name,
      renderCheckboxes = props.renderCheckboxes;
      props.onClick;
      var rest = _objectWithoutProperties$c(props, ["value", "multiSelect", "keepEmpty", "options", "onChange", "name", "renderCheckboxes", "onClick"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray$8(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  if (value && multiSelect && typeof value === 'string') {
    console.warn('Wrong value type passed to OptionsList. Expecting an `array` and for `string` instead');
  }

  useEffect(function () {
    if (keepEmpty === false && !multiSelect && options.length) {
      var defaultSelected = value === undefined ? options[0].value : undefined;

      if (defaultSelected) {
        onChange(defaultSelected); // this.setState({ selected: defaultSelected });
      }
    }
  }, []);
  useEffect(function () {
    // if (value === undefined && keepEmpty === false && options.length) {
    // 		value = nextProps.options[0].value;
    setSelected(value); // }
  }, [value]);
  /**
   * Handle the selected value by the user. If multiSelect is true
   * the returned value will be an Array of the selected choices.
   * Otherwise, the selected object will be returned
   *
   * @param  {object} val selected object {value, label}
   * @return {value, label} or [{value, label}]  return value is either an
   * object or an array.
   *
   */

  var handleSelect = function handleSelect(val) {
    /*
     * IF this is multiSelect (i.e. checkboxes)
     */
    var newValue = val;

    if (multiSelect) {
      if (!!selected.find(function (option) {
        return option.value == val.value;
      })) {
        newValue = selected.filter(function (option) {
          return option.value != val.value;
        });
      } else {
        newValue = [].concat(_toConsumableArray$2(selected), [val]);
      }
      /*
       * If a radio group
       */

    } else if (val === 'true' || val === 'false') {
      newValue = newValue === 'true';
      setSelected(val === 'true');
    }

    setSelected(newValue);
    onChange(newValue);
  };
  /**
   * Render the list of options
   * @return {<input/>} an input element of type `checkbox` or `radio`
   */


  var getOptions = function getOptions() {
    var optionsList = rest.sorted ? options.sort(function (a, b) {
      return a.label > b.label ? 1 : -1;
    }) : options;
    return optionsList.map(function (option, i) {
      var isDisabled = option.isDisabled || rest.disabled;
      var isChecked = selected.value ? selected.value === option.value : "".concat(selected) === "".concat(option.value);

      if (multiSelect && selected.length) {
        var found = selected.filter(function (o) {
          return o === option.value || o.value === option.value;
        });
        isChecked = found !== undefined && found.length > 0;
      }

      if (multiSelect || renderCheckboxes) {
        return /*#__PURE__*/React__default.createElement(Wrapper$Q, _extends$g({}, rest, {
          disabled: isDisabled,
          multiSelect: multiSelect,
          mr: 2,
          py: 0,
          key: i,
          value: isChecked,
          onChange: function onChange() {
            return handleSelect(option);
          },
          label: option.label,
          description: option.description
        }));
      }

      return /*#__PURE__*/React__default.createElement(Wrapper$v, _extends$g({}, rest, {
        key: i,
        multiSelect: multiSelect,
        disabled: isDisabled,
        name: name,
        value: option.value,
        label: option.label,
        isChecked: isChecked,
        tooltip: rest.tooltip,
        description: option.description,
        onChange: function onChange() {
          return handleSelect(option);
        }
      }));
    });
  };

  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, rest, /*#__PURE__*/React__default.createElement(OptionsListWrapper, _extends$g({}, rest, {
    role: !multiSelect ? 'radiogroup' : undefined
  }), getOptions()));
};

OptionsList.propTypes = {
  /** Field label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Array of options to display as {`value`,`label`} pairs */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.any,
    image: PropTypes.string
  })).isRequired,

  /** switches the display to a checkbox list */
  multiSelect: PropTypes.bool,

  /** if true, the first option is not selected by default */
  keepEmpty: PropTypes.bool,

  /** Provided value of the options list */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array]),

  /** Fires when the component changes its value */
  onChange: PropTypes.func,

  /** Treats it as inline field */
  inline: PropTypes.bool,

  /** Displays the checkboxes or radio group horizontally */
  horizontal: PropTypes.bool,

  /** Displays the checkboxes in columns rather than a flow. Subject to label length. */
  columned: PropTypes.bool,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
OptionsList.defaultProps = {
  value: [],
  onChange: function onChange() {}
};
var Wrapper$u = compose$1(withTheme, withTransformers)(OptionsList);

// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
//
// Example:
//
// value - '88005553535'
// caret - 2 // starting from 0; is positioned before the first zero
// operation - 'Backspace'
//
// Returns
// {
// 	value: '8005553535'
// 	caret: 1
// }
//
// Currently supports just 'Delete' and 'Backspace' operations
//
function edit(value, caret, operation) {
  switch (operation) {
    case 'Backspace':
      // If there exists the previous character,
      // then erase it and reposition the caret.
      if (caret > 0) {
        // Remove the previous character
        value = value.slice(0, caret - 1) + value.slice(caret); // Position the caret where the previous (erased) character was

        caret--;
      }

      break;

    case 'Delete':
      // Remove current digit (if any)
      value = value.slice(0, caret) + value.slice(caret + 1);
      break;
  }

  return {
    value: value,
    caret: caret
  };
}

// Parses the `text`.
//
// Returns `{ value, caret }` where `caret` is
// the caret position inside `value`
// corresponding to the `caret_position` inside `text`.
//
// The `text` is parsed by feeding each character sequentially to
// `parse_character(character, value)` function
// and appending the result (if it's not `undefined`) to `value`.
//
// Example:
//
// `text` is `8 (800) 555-35-35`,
// `caret_position` is `4` (before the first `0`).
// `parse_character` is `(character, value) =>
//   if (character >= '0' && character <= '9') { return character }`.
//
// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
//
function parse$1(text, caret_position, parse_character) {
  var value = '';
  var focused_input_character_index = 0;
  var index = 0;

  while (index < text.length) {
    var character = parse_character(text[index], value);

    if (character !== undefined) {
      value += character;

      if (caret_position !== undefined) {
        if (caret_position === index) {
          focused_input_character_index = value.length - 1;
        } else if (caret_position > index) {
          focused_input_character_index = value.length;
        }
      }
    }

    index++;
  } // If caret position wasn't specified


  if (caret_position === undefined) {
    // Then set caret position to "after the last input character"
    focused_input_character_index = value.length;
  }

  var result = {
    value: value,
    caret: focused_input_character_index
  };
  return result;
}

// Counts all occurences of a symbol in a string
function count_occurences(symbol, string) {
  var count = 0; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes)
  // but template placeholder characters don't fall into that range
  // so skipping such miscellaneous "exotic" characters
  // won't matter here for just counting placeholder character occurrences.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;

    if (character === symbol) {
      count++;
    }
  }

  return count;
}

function closeBraces(retained_template, template) {
  var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
  var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
  var cut_before = retained_template.length;
  var opening_braces = count_occurences('(', retained_template);
  var closing_braces = count_occurences(')', retained_template);
  var dangling_braces = opening_braces - closing_braces;

  while (dangling_braces > 0 && cut_before < template.length) {
    retained_template += template[cut_before].replace(placeholder, empty_placeholder);

    if (template[cut_before] === ')') {
      dangling_braces--;
    }

    cut_before++;
  }

  return retained_template;
}

// are denoted by 'x'es (e.g. 'x (xxx) xxx-xx-xx').
//
// Returns a function which takes `value` characters
// and returns the `template` filled with those characters.
// If the `template` can only be partially filled
// then it is cut off.
//
// If `should_close_braces` is `true`,
// then it will also make sure all dangling braces are closed,
// e.g. "8 (8" -> "8 (8  )" (iPhone style phone number input).
//

function template_formatter (template) {
  var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
  var should_close_braces = arguments.length > 2 ? arguments[2] : undefined;

  if (!template) {
    return function (value) {
      return {
        text: value
      };
    };
  }

  var characters_in_template = count_occurences(placeholder, template);
  return function (value) {
    if (!value) {
      return {
        text: '',
        template: template
      };
    }

    var value_character_index = 0;
    var filled_in_template = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes)
    // but template placeholder characters don't fall into that range
    // and appending UTF-8 characters to a string in parts still works.

    for (var _iterator = template.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var character = _ref;

      if (character !== placeholder) {
        filled_in_template += character;
        continue;
      }

      filled_in_template += value[value_character_index];
      value_character_index++; // If the last available value character has been filled in,
      // then return the filled in template
      // (either trim the right part or retain it,
      //  if no more character placeholders in there)

      if (value_character_index === value.length) {
        // If there are more character placeholders
        // in the right part of the template
        // then simply trim it.
        if (value.length < characters_in_template) {
          break;
        }
      }
    }

    if (should_close_braces) {
      filled_in_template = closeBraces(filled_in_template, template);
    }

    return {
      text: filled_in_template,
      template: template
    };
  };
}

//
// `{ value, caret }` attribute is the result of `parse()` function call.
//
// Returns `{ text, caret }` where the new `caret` is the caret position
// inside `text` text corresponding to the original `caret` position inside `value`.
//
// `formatter(value)` is a function returning `{ text, template }`.
//
// `text` is the `value` value formatted using `template`.
// It may either cut off the non-filled right part of the `template`
// or it may fill the non-filled character placeholders
// in the right part of the `template` with `spacer`
// which is a space (' ') character by default.
//
// `template` is the template used to format the `value`.
// It can be either a full-length template or a partial template.
//
// `formatter` can also be a string — a `template`
// where character placeholders are denoted by 'x'es.
// In this case `formatter` function is automatically created.
//
// Example:
//
// `value` is '880',
// `caret` is `2` (before the first `0`)
//
// `formatter` is `'880' =>
//   { text: '8 (80 )', template: 'x (xxx) xxx-xx-xx' }`
//
// The result is `{ text: '8 (80 )', caret: 4 }`.
//

function format$1(value, caret, formatter) {
  if (typeof formatter === 'string') {
    formatter = template_formatter(formatter);
  }

  var _ref = formatter(value) || {},
      text = _ref.text,
      template = _ref.template;

  if (text === undefined) {
    text = value;
  }

  if (template) {
    if (caret === undefined) {
      caret = text.length;
    } else {
      var index = 0;
      var found = false;
      var possibly_last_input_character_index = -1;

      while (index < text.length && index < template.length) {
        // Character placeholder found
        if (text[index] !== template[index]) {
          if (caret === 0) {
            found = true;
            caret = index;
            break;
          }

          possibly_last_input_character_index = index;
          caret--;
        }

        index++;
      } // If the caret was positioned after last input character,
      // then the text caret index is just after the last input character.


      if (!found) {
        caret = possibly_last_input_character_index + 1;
      }
    }
  }

  return {
    text: text,
    caret: caret
  };
}

// Gets <input/> selection bounds
function getSelection(element) {
  // If no selection, return nothing
  if (element.selectionStart === element.selectionEnd) {
    return;
  }

  return {
    start: element.selectionStart,
    end: element.selectionEnd
  };
} // Key codes

var Keys = {
  Backspace: 8,
  Delete: 46
}; // Finds out the operation to be intercepted and performed
// based on the key down event `keyCode`.

function getOperation(event) {
  switch (event.keyCode) {
    case Keys.Backspace:
      return 'Backspace';

    case Keys.Delete:
      return 'Delete';
  }
} // Gets <input/> caret position

function getCaretPosition(element) {
  return element.selectionStart;
} // Sets <input/> caret position

function setCaretPosition(element, caret_position) {
  // Sanity check
  if (caret_position === undefined) {
    return;
  } // Set caret position.
  // There has been an issue with caret positioning on Android devices.
  // https://github.com/catamphetamine/input-format/issues/2
  // I was revisiting this issue and looked for similar issues in other libraries.
  // For example, there's [`text-mask`](https://github.com/text-mask/text-mask) library.
  // They've had exactly the same issue when the caret seemingly refused to be repositioned programmatically.
  // The symptoms were the same: whenever the caret passed through a non-digit character of a mask (a whitespace, a bracket, a dash, etc), it looked as if it placed itself one character before its correct position.
  // https://github.com/text-mask/text-mask/issues/300
  // They seem to have found a basic fix for it: calling `input.setSelectionRange()` in a timeout rather than instantly for Android devices.
  // https://github.com/text-mask/text-mask/pull/400/files
  // I've implemented the same workaround here.


  if (isAndroid()) {
    setTimeout(function () {
      return element.setSelectionRange(caret_position, caret_position);
    }, 0);
  } else {
    element.setSelectionRange(caret_position, caret_position);
  }
}

function isAndroid() {
  // `navigator` is not defined when running mocha tests.
  if (typeof navigator !== 'undefined') {
    return ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
  }
}

var ANDROID_USER_AGENT_REG_EXP = /Android/i;

function onChange(event, input, _parse, _format, on_change) {
  formatInputText(input, _parse, _format, undefined, on_change);
} // "Delete" and "Backspace" keys are special
// in a way that they're not handled by the regular `onChange()` handler
// and instead are intercepted and re-applied manually.
// The reason is that normally hitting "Backspace" or "Delete"
// results in erasing a character, but that character might be any character,
// while it would be a better "user experience" if it erased not just any character
// but the closest "meaningful" character.
// For example, if a template is `(xxx) xxx-xxxx`,
// and the `<input/>` value is `(111) 222-3333`,
// then, if a user begins erasing the `3333` part via "Backspace"
// and reaches the "-" character, then it would just erase the "-" character.
// Nothing wrong with that, but it would be a better "user experience"
// if hitting "Backspace" at that position would erase the closest "meaningful"
// character, which would be the rightmost `2`.
// So, what this `onKeyDown()` handler does is it intercepts
// "Backspace" and "Delete" keys and re-applies those operations manually
// following the logic described above.

function onKeyDown(event, input, _parse, _format, on_change) {
  var operation = getOperation(event);

  switch (operation) {
    case 'Delete':
    case 'Backspace':
      // Intercept this operation and perform it manually.
      event.preventDefault();
      var selection = getSelection(input); // If a selection is made, just erase the selected text.

      if (selection) {
        eraseSelection(input, selection);
        return formatInputText(input, _parse, _format, undefined, on_change);
      } // Else, perform the (character erasing) operation manually.


      return formatInputText(input, _parse, _format, operation, on_change);

  }
}
/**
 * Erases the selected text inside an `<input/>`.
 * @param  {DOMElement} input
 * @param  {Selection} selection
 */

function eraseSelection(input, selection) {
  var text = input.value;
  text = text.slice(0, selection.start) + text.slice(selection.end);
  input.value = text;
  setCaretPosition(input, selection.start);
}
/**
 * Parses and re-formats `<input/>` textual value.
 * E.g. when a user enters something into the `<input/>`
 * that raw input must first be parsed and the re-formatted properly.
 * Is called either after some user input (e.g. entered a character, pasted something)
 * or after the user performed an `operation` (e.g. "Backspace", "Delete").
 * @param  {DOMElement} input
 * @param  {Function} parse
 * @param  {Function} format
 * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
 * @param  {Function} onChange
 */


function formatInputText(input, _parse, _format, operation, on_change) {
  // Parse `<input/>` textual value.
  // Get the `value` and `caret` position.
  var _parse2 = parse$1(input.value, getCaretPosition(input), _parse),
      value = _parse2.value,
      caret = _parse2.caret; // If a user performed an operation ("Backspace", "Delete")
  // then apply that operation and get the new `value` and `caret` position.


  if (operation) {
    var newValueAndCaret = edit(value, caret, operation);
    value = newValueAndCaret.value;
    caret = newValueAndCaret.caret;
  } // Format the `value`.
  // (and reposition the caret accordingly)


  var formatted = format$1(value, caret, _format);
  var text = formatted.text;
  caret = formatted.caret; // Set `<input/>` textual value manually
  // to prevent React from resetting the caret position
  // later inside a subsequent `render()`.
  // Doesn't work for custom `inputComponent`s for some reason.

  input.value = text; // Position the caret properly.

  setCaretPosition(input, caret); // If the `<input/>` textual value did change,
  // then the parsed `value` may have changed too.

  on_change(value);
}

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function _objectWithoutProperties$9(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$9(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$9(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
//
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//

function Input(_ref, ref) {
  var value = _ref.value,
      parse = _ref.parse,
      format = _ref.format,
      InputComponent = _ref.inputComponent,
      onChange$1 = _ref.onChange,
      onKeyDown$1 = _ref.onKeyDown,
      rest = _objectWithoutProperties$9(_ref, ["value", "parse", "format", "inputComponent", "onChange", "onKeyDown"]);

  var internalRef = useRef();
  var setRef = useCallback(function (instance) {
    internalRef.current = instance;

    if (ref) {
      if (typeof ref === 'function') {
        ref(instance);
      } else {
        ref.current = instance;
      }
    }
  }, []);

  var _onChange = useCallback(function (event) {
    return onChange(event, internalRef.current, parse, format, onChange$1);
  }, [internalRef, parse, format, onChange$1]);

  var _onKeyDown = useCallback(function (event) {
    if (onKeyDown$1) {
      onKeyDown$1(event);
    }

    return onKeyDown(event, internalRef.current, parse, format, onChange$1);
  }, [internalRef, parse, format, onChange$1, onKeyDown$1]);

  return React__default.createElement(InputComponent, _extends$a({}, rest, {
    ref: setRef,
    value: format(isEmptyValue(value) ? '' : value).text,
    onKeyDown: _onKeyDown,
    onChange: _onChange
  }));
}

Input = React__default.forwardRef(Input);
Input.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: PropTypes.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: PropTypes.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: PropTypes.elementType.isRequired,
  // `<input/>` `type` attribute.
  type: PropTypes.string.isRequired,
  // Is parsed from <input/> text.
  value: PropTypes.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: PropTypes.func.isRequired,
  // Passthrough
  onKeyDown: PropTypes.func,
  onCut: PropTypes.func,
  onPaste: PropTypes.func
};
Input.defaultProps = {
  // Renders `<input/>` by default.
  inputComponent: 'input',
  // `<input/>` `type` attribute.
  type: 'text'
};
var Input$1 = Input;

function isEmptyValue(value) {
  return value === undefined || value === null;
}

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://stackoverflow.com/a/46971044/970769
var ParseError = function ParseError(code) {
  _classCallCheck$a(this, ParseError);

  this.name = this.constructor.name;
  this.message = code;
  this.stack = new Error(code).stack;
};
ParseError.prototype = Object.create(Error.prototype);
ParseError.prototype.constructor = ParseError;

// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function compare (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

function _typeof$3(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); if (staticProps) _defineProperties$9(Constructor, staticProps); return Constructor; }

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata =
/*#__PURE__*/
function () {
  function Metadata(metadata) {
    _classCallCheck$9(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass$9(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();

var NumberingPlan =
/*#__PURE__*/
function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck$9(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass$9(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format =
/*#__PURE__*/
function () {
  function Format(format, metadata) {
    _classCallCheck$9(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass$9(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type =
/*#__PURE__*/
function () {
  function Type(type, metadata) {
    _classCallCheck$9(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass$9(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!is_object(metadata) || !is_object(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var is_object = function is_object(_) {
  return _typeof$3(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var type_of = function type_of(_) {
  return _typeof$3(_);
};
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode$2(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries[country] !== undefined;
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*';
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}

// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}

/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}

/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = b, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var element = _ref;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
      return 'INVALID_LENGTH';
    }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  }

  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}

function _slicedToArray$5(arr, i) { return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _nonIterableRest$5(); }

function _nonIterableRest$5() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$5(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$5(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */

function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var part = _ref;

    var _part$split = part.split('='),
        _part$split2 = _slicedToArray$5(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!isViablePhoneNumber(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref2) {
  var number = _ref2.number,
      ext = _ref2.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returned `{}`
  // meaning that the phone number is not a valid one.

  if (!input.country) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // v1 metadata.
    // Legacy.
    // Deprecated.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _i = 0, _NON_FIXED_LINE_PHONE = NON_FIXED_LINE_PHONE_TYPES; _i < _NON_FIXED_LINE_PHONE.length; _i++) {
    var type = _NON_FIXED_LINE_PHONE[_i];

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}

/**
 * Checks if a given phone number is valid.
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // This is just to support `isValidNumber({})`
  // for cases when `parseNumber()` returns `{}`.

  if (!input.country) {
    return false;
  }

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(national_number, metadata.nationalNumberPattern());
}

//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}

// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix;
      _ref.carrierCode;
      _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }

  return countryMetadata.defaultIDDPrefix();
}

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$a(target, key, source[key]); }); } return target; }

function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  } // Formats a phone number
  //
  // Example use cases:
  //
  // ```js
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL')
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
  // formatNumber('+78005553535', 'NATIONAL')
  // formatNumber('+78005553535', 'NATIONAL', metadata)
  // ```
  //

};
function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread$7({}, DEFAULT_OPTIONS, options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber$1(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber$1(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber$1(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = availableFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var format = _ref;

    // Validate leading digits
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode$2(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber$1(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber$1(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$9(target, key, source[key]); }); } return target; }

function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); if (staticProps) _defineProperties$8(Constructor, staticProps); return Constructor; }

var PhoneNumber =
/*#__PURE__*/
function () {
  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
    _classCallCheck$8(this, PhoneNumber);

    if (!countryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    var _metadata = new Metadata(metadata); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.


    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;

      _metadata.country(countryCallingCode);

      countryCallingCode = _metadata.countryCallingCode();
    }

    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata;
  }

  _createClass$8(PhoneNumber, [{
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.metadata);
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // // Is just an alias for `this.isValid() && this.country === country`.
    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
    // isValidForRegion(country) {
    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$6({}, options, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();

var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};

var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}

/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
          // `prefixBeforeNationalNumber` is the whole substring matched by
          // the `national_prefix_for_parsing` regular expression.
          // There seem to be no guarantees that it's just a national prefix.
          // For example, if there's a carrier code, it's gonna be a
          // part of `prefixBeforeNationalNumber` too.
          var prefixBeforeNationalNumber = prefixMatch[0];
          nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
          // then carrier code is the first one.

          if (hasCapturedGroups) {
            carrierCode = prefixMatch[1];
          }
        } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}

/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode;

  if (!shouldExtractNationalPrefix(number, nationalNumber, metadata)) {
    // Don't strip the national prefix.
    return {
      nationalNumber: number
    };
  } // If a national prefix has been extracted, check to see
  // if the resultant number isn't too short.
  // Same code in Google's `libphonenumber`:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3291-L3302
  // For some reason, they do this check right after the `national_number_pattern` check
  // this library does in `shouldExtractNationalPrefix()` function.
  // Why is there a second "resultant" number validity check?
  // They don't provide an explanation.
  // This library just copies the behavior.


  if (number.length !== nationalNumber.length + (carrierCode ? carrierCode.length : 0)) {
    // If not using legacy generated metadata (before version `1.0.18`)
    // then it has "possible lengths", so use those to validate the number length.
    if (metadata.possibleLengths()) {
      // "We require that the NSN remaining after stripping the national prefix and
      // carrier code be long enough to be a possible length for the region.
      // Otherwise, we don't do the stripping, since the original number could be
      // a valid short number."
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      switch (checkNumberLength(nationalNumber, metadata)) {
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
          // case 'IS_POSSIBLE_LOCAL_ONLY':
          // Don't strip the national prefix.
          return {
            nationalNumber: number
          };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldExtractNationalPrefix(number, nationalSignificantNumber, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(number, metadata.nationalNumberPattern()) && !matchesEntirely(nationalSignificantNumber, metadata.nationalNumberPattern())) {
    return false;
  } // Just "possible" number check would be more relaxed, so it's not used.
  // if (isPossibleNumber(number, metadata) &&
  // 	!isPossibleNumber(numberWithNationalPrefixExtracted, metadata)) {
  // 	return false
  // }


  return true;
}

/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode$2(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}

/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  } // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376


  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
}

function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata) {


  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
}

function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata);

  for (var _iterator = possibleCountries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var country = _ref;
    metadata.country(country); // Leading digits check would be the simplest one

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
        phone: nationalPhoneNumber,
        country: country
      }, undefined, metadata.metadata)) {
        return country;
      }
  }
}

// This is a port of Google Android `libphonenumber`'s
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber$3(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function extractFormattedPhoneNumber$1(text, extract, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  }

  if (extract === false) {
    return text;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2, extract) {
  // Parse RFC 3966 phone number URI.
  if (text && text.indexOf('tel:') === 0) {
    return parseRFC3966(text);
  }

  var number = extractFormattedPhoneNumber$1(text, extract, v2); // If the phone number is not viable, then abort.

  if (!number || !isViablePhoneNumber(number)) {
    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber$3(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is in "national" format
  // then `number` is defined and `countryCallingCode` isn't.
  else if (number && (defaultCountry || defaultCallingCode)) {
      metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

      if (defaultCountry) {
        country = defaultCountry;
      }

      countryCallingCode = defaultCallingCode || getCountryCallingCode$2(defaultCountry, metadata.metadata);
    } else return {};

  if (!number) {
    return {
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = getCountryByCallingCode(countryCallingCode, nationalNumber, metadata);

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') ; else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$8(target, key, source[key]); }); } return target; }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumber$2(text, options, metadata) {
  return parse(text, _objectSpread$5({}, options, {
    v2: true
  }), metadata);
}

function _typeof$2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$7(target, key, source[key]); }); } return target; }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$4(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _nonIterableRest$4(); }

function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$4(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray$4(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = _objectSpread$4({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject(arg_2)) {
      if (arg_3) {
        options = arg_2;
        metadata = arg_3;
      } else {
        metadata = arg_2;
      }
    } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
} // Otherwise istanbul would show this as "branch not covered".

/* istanbul ignore next */

var isObject = function isObject(_) {
  return _typeof$2(_) === 'object';
};

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$6(target, key, source[key]); }); } return target; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumberFromString$1(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = _objectSpread$3({}, options, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return parsePhoneNumber$2(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof ParseError) ; else {
      throw error;
    }
  }
}

function parsePhoneNumberFromString() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parsePhoneNumberFromString$1(text, options, metadata);
}

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); if (staticProps) _defineProperties$7(Constructor, staticProps); return Constructor; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AsYouTypeState =
/*#__PURE__*/
function () {
  function AsYouTypeState(_ref) {
    var _this = this;

    var onCountryChange = _ref.onCountryChange,
        onCallingCodeChange = _ref.onCallingCodeChange;

    _classCallCheck$7(this, AsYouTypeState);

    _defineProperty$5(this, "update", function (properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        _this[key] = properties[key];
      }
    });

    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }

  _createClass$7(AsYouTypeState, [{
    key: "reset",
    value: function reset(defaultCountry, defaultCallingCode) {
      this.international = false;
      this.IDDPrefix = undefined;
      this.missingPlus = undefined;
      this.callingCode = undefined;
      this.digits = '';
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberMatchesInput = true;
      this.nationalPrefix = undefined;
      this.carrierCode = undefined;
      this.complexPrefixBeforeNationalSignificantNumber = undefined;
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      return this.onCallingCodeChange(this.country, callingCode);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber() {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.initCountryAndCallingCode();
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */

  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }

      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }

      return this.digits;
    }
  }]);

  return AsYouTypeState;
}();

// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
// http://stackoverflow.com/questions/202605/repeat-string-javascript

function repeat(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i2 = 0, _dangling_braces = dangling_braces; _i2 < _dangling_braces.length; _i2++) {
    var index = _dangling_braces[_i2];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}
function populateTemplateWithDigits(template, position, digits) {
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for `digits` it is safe.
  // for (const digit of digits)
  for (var _iterator2 = digits.split(''), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i3 >= _iterator2.length) break;
      _ref2 = _iterator2[_i3++];
    } else {
      _i3 = _iterator2.next();
      if (_i3.done) break;
      _ref2 = _i3.value;
    }

    var digit = _ref2;

    // If there is room for more digits in current `template`,
    // then set the next digit in the `template`,
    // and return the formatted digits so far.
    // If more digits are entered than the current format could handle.
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }

    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }

  return [template, position];
}

function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata,
      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

  if (matcher.test(state.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata: metadata,
      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
  }
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return checkNumberLength(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}

function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata,
      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  // `format` has already been checked for `nationalPrefix` requirement.
  state.nationalSignificantNumber;
      state.international;
      state.nationalPrefix;
      state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
  // If the resulting formatted number is a valid formatted number, then return it.
  //
  // Google's AsYouType formatter is different in a way that it doesn't try
  // to format using the "national prefix formatting rule", and instead it
  // simply prepends a national prefix followed by a " " character.
  // This code does that too, but as a fallback.
  // The reason is that "national prefix formatting rule" may use parentheses,
  // which wouldn't be included has it used the simpler Google's way.
  //

  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber(state, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
      metadata: metadata
    });

    if (formattedNumber) {
      return formattedNumber;
    }
  } // Format the number without using `national_prefix_formatting_rule`.


  return formatNationalNumber(state, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
    metadata: metadata
  });
}

function formatNationalNumber(state, format, _ref3) {
  var metadata = _ref3.metadata,
      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata
  });

  if (!useNationalPrefixFormattingRule) {
    if (state.nationalPrefix) {
      // If a national prefix was extracted, then just prepend it,
      // followed by a " " character.
      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
  }

  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
    return formattedNationalNumber;
  }
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//


function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
}

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); return Constructor; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// Could be any digit, I guess.

var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN = function () {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN = function () {
  return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//


var NON_ALTERING_FORMAT_REG_EXP = new RegExp('^' + '[' + VALID_PUNCTUATION + ']*' + '(\\$\\d[' + VALID_PUNCTUATION + ']*)+' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;

var AsYouTypeFormatter =
/*#__PURE__*/
function () {
  function AsYouTypeFormatter(_ref) {
    var _this = this;

    _ref.state;
        var metadata = _ref.metadata;

    _classCallCheck$6(this, AsYouTypeFormatter);

    _defineProperty$4(this, "getSeparatorAfterNationalPrefix", function (format) {
      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
      // so the `if` condition below doesn't apply to `US`,
      // but in reality there shoudl be a separator
      // between a national prefix and a national (significant) number.
      // So `US` national prefix separator is a "special" "hardcoded" case.
      if (_this.isNANP) {
        return ' ';
      } // If a `format` has a `national_prefix_formatting_rule`
      // and that rule has a separator after a national prefix,
      // then it means that there should be a separator
      // between a national prefix and a national (significant) number.


      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      } // At this point, there seems to be no clear evidence that
      // there should be a separator between a national prefix
      // and a national (significant) number. So don't insert one.


      return '';
    });

    _defineProperty$4(this, "shouldTryNationalPrefixFormattingRule", function (format, _ref2) {
      var international = _ref2.international,
          nationalPrefix = _ref2.nationalPrefix;

      if (format.nationalPrefixFormattingRule()) {
        // In some countries, `national_prefix_formatting_rule` is `($1)`,
        // so it applies even if the user hasn't input a national prefix.
        // `format.usesNationalPrefix()` detects such cases.
        var usesNationalPrefix = format.usesNationalPrefix();

        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    });

    this.metadata = metadata;
    this.resetFormat();
  }

  _createClass$6(AsYouTypeFormatter, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.nationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state) {
      this.resetFormat();

      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === '1';
        this.matchingFormats = numberingPlan.formats();

        if (state.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state);
        }
      } else {
        this.isNANP = undefined;
        this.matchingFormats = [];
      }
    }
  }, {
    key: "format",
    value: function format(nextDigits, state) {
      var _this2 = this;

      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNationalNumberWithNextDigits()`,
      // which formats based on the chosen formatting pattern.
      //
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`, so this library just follows it.
      // Google's `libphonenumber` code doesn't explain in detail why does it
      // attempt to format digits as a complete phone number
      // instead of just going with a previoulsy (or newly) chosen `format`:
      //
      // "Checks to see if there is an exact pattern match for these digits.
      //  If so, we should use this instead of any other formatting template
      //  whose leadingDigitsPattern also matches the input."
      //
      if (canFormatCompleteNumber(state.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = this.matchingFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref3;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref3 = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref3 = _i.value;
          }

          var format = _ref3;
          var formattedCompleteNumber = formatCompleteNumber(state, format, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
              return _this2.shouldTryNationalPrefixFormattingRule(format, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: this.getSeparatorAfterNationalPrefix
          });

          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = format;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state);
            this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
            // using the old template needs to be reset.

            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER);
            return formattedCompleteNumber;
          }
        }
      } // Format the digits as a partial (incomplete) phone number
      // using the previously chosen formatting pattern (or a newly chosen one).


      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    } // Formats the next phone number digits.

  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat(state);

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If it can format the next (current) digits
          // using the previously chosen phone number format
          // then return the updated formatted number.
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then re-format the national phone number part
          // using the newly selected format.
          return this.formatNextNationalNumberDigits(state.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref4) {
      var _this3 = this;

      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
          nationalPrefix = _ref4.nationalPrefix,
          international = _ref4.international;
      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.

      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        return _this3.formatSuits(format, international, nationalPrefix) && _this3.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      // When a prefix before a national (significant) number is
      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
      // In more complex cases, a prefix before national (significant) number
      // could include a national prefix as well as some "capturing groups",
      // and in that case there's no info whether a national prefix has been parsed.
      // If national prefix is not used when formatting a phone number
      // using this format, but a national prefix has been entered by the user,
      // and was extracted, then discard such phone number format.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      } // If national prefix is mandatory for this phone number format
      // and there're no guarantees that a national prefix is present in user input
      // then discard this phone number format as not suitable.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193


      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }

      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
      // leading digits pattern then it fits.

      if (leadingDigitsPatternsCount === 0) {
        return true;
      } // Start excluding any non-matching formats only when the
      // national number entered so far is at least 3 digits long,
      // otherwise format matching would give false negatives.
      // For example, when the digits entered so far are `2`
      // and the leading digits pattern is `21` –
      // it's quite obvious in this case that the format could be the one
      // but due to the absence of further digits it would give false negative.


      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        return true;
      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are available
      // then format matching starts narrowing down the list of possible formats
      // (only previously matched formats are considered for next digits).


      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Brackets are required for `^` to be applied to
      // all or-ed (`|`) parts, not just the first one.

      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state) {
      var _this4 = this;

      var _loop2 = function _loop2() {
        if (_isArray2) {
          if (_i2 >= _iterator2.length) return "break";
          _ref5 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) return "break";
          _ref5 = _i2.value;
        }

        var format = _ref5;

        // If this format is currently being used
        // and is still suitable, then stick to it.
        if (_this4.chosenFormat === format) {
          return "break";
        } // Sometimes, a formatting rule inserts additional digits in a phone number,
        // and "as you type" formatter can't do that: it should only use the digits
        // that the user has input.
        //
        // For example, in Argentina, there's a format for mobile phone numbers:
        //
        // {
        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
        //    "leading_digits_patterns": ["91"],
        //    "national_prefix_formatting_rule": "0$1",
        //    "format": "$2 15-$3-$4",
        //    "international_format": "$1 $2 $3-$4"
        // }
        //
        // In that format, `international_format` is used instead of `format`
        // because `format` inserts `15` in the formatted number,
        // and `AsYouType` formatter should only use the digits
        // the user has actually input, without adding any extra digits.
        // In this case, it wouldn't make a difference, because the `15`
        // is first stripped when applying `national_prefix_for_parsing`
        // and then re-added when using `format`, so in reality it doesn't
        // add any new digits to the number, but to detect that, the code
        // would have to be more complex: it would have to try formatting
        // the digits using the format and then see if any digits have
        // actually been added or removed, and then, every time a new digit
        // is input, it should re-check whether the chosen format doesn't
        // alter the digits.
        //
        // Google's code doesn't go that far, and so does this library:
        // it simply requires that a `format` doesn't add any additonal
        // digits to user's input.
        //
        // Also, people in general should move from inputting phone numbers
        // in national format (possibly with national prefixes)
        // and use international phone number format instead:
        // it's a logical thing in the modern age of mobile phones,
        // globalization and the internet.
        //

        /* istanbul ignore if */


        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this4.getFormatFormat(format, state.international))) {
          return "continue";
        }

        if (!_this4.createTemplateForFormat(format, state)) {
          // Remove the format if it can't generate a template.
          _this4.matchingFormats = _this4.matchingFormats.filter(function (_) {
            return _ !== format;
          });
          return "continue";
        }

        _this4.chosenFormat = format;
        return "break";
      };

      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      _loop: for (var _iterator2 = this.matchingFormats.slice(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref5;

        var _ret = _loop2();

        switch (_ret) {
          case "break":
            break _loop;

          case "continue":
            continue;
        }
      }

      if (!this.chosenFormat) {
        // No format matches the national (significant) phone number.
        this.resetFormat();
      }

      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if (format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
      // for any phone number format, then abort.

      if (template) {
        this.setNationalNumberTemplate(template, state);
        return true;
      }
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref6, options) {
      var IDDPrefix = _ref6.IDDPrefix,
          missingPlus = _ref6.missingPlus;

      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
      }

      if (missingPlus) {
        return '';
      }

      return '+';
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state) {
      if (!this.template) {
        return;
      } // `this.template` holds the template for a "complete" phone number.
      // The currently entered phone number is most likely not "complete",
      // so trim all non-populated digits.


      var index = -1;
      var i = 0;
      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
        spacing: false
      }) : '';

      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
        index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
        i++;
      }

      return cutAndStripNonPairedParens(this.template, index + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
      // using the old template needs to be reset.

      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (state.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, state.callingCode.length) + ' ' + template;
      } else {
        this.template = template;
      }
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref7) {
      var nationalSignificantNumber = _ref7.nationalSignificantNumber,
          international = _ref7.international,
          nationalPrefix = _ref7.nationalPrefix,
          complexPrefixBeforeNationalSignificantNumber = _ref7.complexPrefixBeforeNationalSignificantNumber;
      var pattern = format.pattern();
      /* istanbul ignore else */

      {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //


      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (nationalSignificantNumber.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalSignificantNumber : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
      // and if a `format` does have a national prefix formatting rule,
      // then see if that national prefix formatting rule
      // prepends exactly the same national prefix the user has input.
      // If that's the case, then use the `format` with the national prefix formatting rule.
      // Otherwise, use  the `format` without the national prefix formatting rule,
      // and prepend a national prefix manually to it.

      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international: international,
        nationalPrefix: nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
        // national prefix at the start of a national (significant) number,
        // then such formatting can be used with `AsYouType` formatter.
        // There seems to be no `else` case: everywhere in metadata,
        // national prefix formatting rule is national prefix + $1,
        // or `($1)`, in which case such format isn't even considered
        // when the user has input a national prefix.

        /* istanbul ignore else */

        if (parseDigits(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + parseDigits('$1')) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
          // with `DIGIT_PLACEHOLDER`s.

          if (nationalPrefix) {
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER); // If a prefix of a national (significant) number is not as simple
      // as just a basic national prefix, then just prepend such prefix
      // before the national (significant) number, optionally spacing
      // the two with a whitespace.

      if (!nationalPrefixIncludedInTemplate) {
        if (complexPrefixBeforeNationalSignificantNumber) {
          // Prepend the prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
        } else if (nationalPrefix) {
          // Prepend national prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      if (international) {
        template = applyInternationalSeparatorStyle(template);
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);

      if (!result) {
        // Reset the format.
        this.resetFormat();
        return;
      }

      this.populatedNationalNumberTemplate = result[0];
      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.

      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }]);

  return AsYouTypeFormatter;
}();

function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _nonIterableRest$3(); }

function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$3(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+';
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var VALID_FORMATTED_PHONE_NUMBER_PART = '(?:' + '[' + PLUS_CHARS + ']' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*' + '|' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.

var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;

var AsYouTypeParser =
/*#__PURE__*/
function () {
  function AsYouTypeParser(_ref) {
    var defaultCountry = _ref.defaultCountry,
        defaultCallingCode = _ref.defaultCallingCode,
        metadata = _ref.metadata,
        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;

    _classCallCheck$5(this, AsYouTypeParser);

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }

  _createClass$5(AsYouTypeParser, [{
    key: "input",
    value: function input(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
          _extractFormattedDigi2 = _slicedToArray$3(_extractFormattedDigi, 2),
          formattedDigits = _extractFormattedDigi2[0],
          hasPlus = _extractFormattedDigi2[1];

      var digits = parseDigits(formattedDigits); // Checks for a special case: just a leading `+` has been entered.

      var justLeadingPlus;

      if (hasPlus) {
        if (!state.digits) {
          state.startInternationalNumber();

          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }

      if (digits) {
        this.inputDigits(digits, state);
      }

      return {
        digits: digits,
        justLeadingPlus: justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state) {
      var digits = state.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.

      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
      // Some users input their phone number in international format,
      // but in an "out-of-country" dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers as soon as there're at least 3 digits.
      // Google's library attempts to extract IDD prefix at 3 digits,
      // so this library just copies that behavior.
      // I guess that's because the most commot IDD prefixes are
      // `00` (Europe) and `011` (US).
      // There exist really long IDD prefixes too:
      // for example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      // An IDD prefix is extracted here, and then every time when
      // there's a new digit and the number couldn't be formatted.

      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state);
      }

      if (this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state)) {
          return;
        }
      } else {
        state.appendNationalSignificantNumberDigits(nextDigits);
      } // If a phone number is being input in international format,
      // then it's not valid for it to have a national prefix.
      // Still, some people incorrectly input such numbers with a national prefix.
      // In such cases, only attempt to strip a national prefix if the number becomes too long.
      // (but that is done later, not here)


      if (!state.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international,
          callingCode = _ref2.callingCode;
      return international && !callingCode;
    } // Extracts a country calling code from a number
    // being entered in internatonal format.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode$1(state) {
      var _extractCountryCallin = extractCountryCallingCode('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (countryCallingCode) {
        state.setCallingCode(countryCallingCode);
        state.update({
          nationalSignificantNumber: number
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;

        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();

        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = undefined;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
      }
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */

  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }

      var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe.nationalPrefix,
          nationalNumber = _extractNationalNumbe.nationalNumber,
          carrierCode = _extractNationalNumbe.carrierCode;

      if (nationalNumber === nationalDigits) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */

  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }

      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }

      var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
          nationalNumber = _extractNationalNumbe2.nationalNumber,
          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
      // then it's always extracted as additional digits are added.
      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
      // doesn't do anything different from what it currently does.
      // So, just in case, here's this check, though it doesn't occur.

      /* istanbul ignore if */


      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber;
      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.

      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
      // last substring of the `digits`, then it means that it hasn't been altered:
      // no digits have been removed from the national (significant) number
      // while applying `national_prefix_transform_rule`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule

      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
        // as just a basic national prefix, then such prefix is stored in
        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
        // prepended "as is" to the national (significant) number to produce
        // a formatted result.

        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
        // because `onExtractedNationalNumber()` isn't called
        // when a national (significant) number hasn't been actually "extracted":
        // when a national (significant) number is equal to the national part of `digits`,
        // then `onExtractedNationalNumber()` doesn't get called.

        if (prefixBeforeNationalNumber !== nationalPrefix) {
          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
        }
      }

      setState({
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode,
        nationalSignificantNumber: nationalSignificantNumber,
        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
      }); // `onExtractedNationalNumber()` is only called when
      // the national (significant) number actually did change.

      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state) {
      // Attempt to extract a national prefix.
      //
      // Some people incorrectly input national prefix
      // in an international phone number.
      // For example, some people write British phone numbers as `+44(0)...`.
      //
      // Also, in some rare cases, it is valid for a national prefix
      // to be a part of an international phone number.
      // For example, mobile phone numbers in Mexico are supposed to be
      // dialled internationally using a `1` national prefix,
      // so the national prefix will be part of an international number.
      //
      // Quote from:
      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
      //
      // "Dialing a Mexican cell phone from abroad
      // When you are calling a cell phone number in Mexico from outside Mexico,
      // it’s necessary to dial an additional “1” after Mexico’s country code
      // (which is “52”) and before the area code.
      // You also ignore the 045, and simply dial the area code and the
      // cell phone’s number.
      //
      // If you don’t add the “1”, you’ll receive a recorded announcement
      // asking you to redial using it.
      //
      // For example, if you are calling from the USA to a cell phone
      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
      // (Note that this is different to calling a land line in Mexico City
      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
      //
      // Google's demo output:
      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
      //
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, state.update)) {
        return true;
      } // If no format matches the phone number, then it could be
      // "a really long IDD" (quote from a comment in Google's library).
      // An IDD prefix is first extracted when the user has entered at least 3 digits,
      // and then here — every time when there's a new digit and the number
      // couldn't be formatted.
      // For example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      //
      // Could also check `!hasReceivedThreeLeadingDigits` here
      // to filter out the case when this check duplicates the one
      // already performed when there're 3 leading digits,
      // but it's not a big deal, and in most cases there
      // will be a suitable `format` when there're 3 leading digits.
      //


      if (this.extractIddPrefix(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
      // when it "autocorrects" numbers that have been input for a country
      // with that country's calling code.
      // Such "autocorrection" feature looks weird, but different people have been requesting it:
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      // https://github.com/catamphetamine/libphonenumber-js/issues/375
      // https://github.com/catamphetamine/libphonenumber-js/issues/316


      if (this.fixMissingPlus(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state) {
      // An IDD prefix can't be present in a number written with a `+`.
      // Also, don't re-extract an IDD prefix if has already been extracted.
      var international = state.international,
          IDDPrefix = state.IDDPrefix,
          digits = state.digits;
          state.nationalSignificantNumber;

      if (international || IDDPrefix) {
        return;
      } // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.


      var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
        // If an IDD prefix was stripped then convert the IDD-prefixed number
        // to international number for subsequent parsing.
        state.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state);
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state) {
      if (!state.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            newCallingCode = _extractCountryCallin2.countryCallingCode;
            _extractCountryCallin2.number;

        if (newCallingCode) {
          state.update({
            missingPlus: true
          });
          this.startInternationalNumber(state);
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state) {
      state.startInternationalNumber(); // If a national (significant) number has been extracted before, reset it.

      if (state.nationalSignificantNumber) {
        state.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = undefined;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state) {
      if (this.extractCountryCallingCode(state)) {
        // `this.extractCallingCode()` is currently called when the number
        // couldn't be formatted during the standard procedure.
        // Normally, the national prefix would be re-extracted
        // for an international number if such number couldn't be formatted,
        // but since it's already not able to be formatted,
        // there won't be yet another retry, so also extract national prefix here.
        this.extractNationalSignificantNumber(state.getNationalDigits(), state.update);
      }
    }
  }]);

  return AsYouTypeParser;
}();

function extractFormattedPhoneNumber(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function _extractFormattedDigitsAndPlus(text) {
  // Extract a formatted phone number part from text.
  var extractedNumber = extractFormattedPhoneNumber(text) || ''; // Trim a `+`.

  if (extractedNumber[0] === '+') {
    return [extractedNumber.slice('+'.length), true];
  }

  return [extractedNumber];
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
      _extractFormattedDigi4 = _slicedToArray$3(_extractFormattedDigi3, 2),
      formattedDigits = _extractFormattedDigi4[0],
      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
  // can possibly be a part of some valid phone number
  // then parse phone number characters from a formatted phone number.


  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = '';
  }

  return [formattedDigits, hasPlus];
}

function _typeof$1(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$2(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }

var AsYouType =
/*#__PURE__*/
function () {
  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    _classCallCheck$4(this, AsYouType);

    this.metadata = new Metadata(metadata);

    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
        _this$getCountryAndCa2 = _slicedToArray$2(_this$getCountryAndCa, 2),
        defaultCountry = _this$getCountryAndCa2[0],
        defaultCallingCode = _this$getCountryAndCa2[1];

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }

  _createClass$4(AsYouType, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      // Set `defaultCountry` and `defaultCallingCode` options.
      var defaultCountry;
      var defaultCallingCode; // Turns out `null` also has type "object". Weird.

      if (optionsOrDefaultCountry) {
        if (_typeof$1(optionsOrDefaultCountry) === 'object') {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }

      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = undefined;
      }

      return [defaultCountry, defaultCallingCode];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state),
          digits = _this$parser$input.digits,
          justLeadingPlus = _this$parser$input.justLeadingPlus;

      if (justLeadingPlus) {
        this.formattedOutput = '+';
      } else if (digits) {
        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.

        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }

        var formattedNationalNumber;

        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }

        if (formattedNationalNumber === undefined) {
          // See if another national (significant) number could be re-extracted.
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.

            var nationalDigits = this.state.getNationalDigits();

            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }

        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }

      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;

      this.state = new AsYouTypeState({
        onCountryChange: function onCountryChange(country) {
          // Before version `1.6.0`, the official `AsYouType` formatter API
          // included the `.country` property of an `AsYouType` instance.
          // Since that property (along with the others) have been moved to
          // `this.state`, `this.country` property is emulated for compatibility
          // with the old versions.
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(country, callingCode) {
          _this.metadata.selectNumberingPlan(country, callingCode);

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);

          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset(this.defaultCountry, this.defaultCallingCode);
      this.formattedOutput = '';
      return this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }
    /**
     * Returns the "country calling code" part of the phone number.
     * Returns `undefined` if the number is not being input in international format.
     * Returns "country calling code" for "non-geographic" phone numbering plans too.
     * @return {string} [callingCode]
     */

  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      return this.state.callingCode;
    } // A legacy alias.

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      var _this$state = this.state,
          digits = _this$state.digits,
          country = _this$state.country; // If no digits have been input yet,
      // then `this.country` is the `defaultCountry`.
      // Won't return the `defaultCountry` in such case.

      if (!digits) {
        return;
      }

      var countryCode = country;

      return countryCode;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      // Suppose a user enters a phone number in international format,
      // and there're several countries corresponding to that country calling code,
      // and a country has been derived from the number, and then
      // a user enters one more digit and the number is no longer
      // valid for the derived country, so the country should be re-derived
      // on every new digit in those cases.
      //
      // If the phone number is being input in national format,
      // then it could be a case when `defaultCountry` wasn't specified
      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
      // and that "calling code" could correspond to a "non-geographic entity",
      // or there could be several countries corresponding to that country calling code.
      // In those cases, `this.country` is `undefined` and should be derived
      // from the number. Again, if country calling code is ambiguous, then
      // `this.country` should be re-derived with each new digit.
      //
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;

      if (this.isInternational()) {
        var prefix = function prefix(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };

        var callingCode = this.state.callingCode;

        if (!callingCode) {
          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }

        if (!formattedNationalNumber) {
          return prefix(callingCode);
        }

        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state2 = this.state,
          nationalSignificantNumber = _this$state2.nationalSignificantNumber,
          complexPrefixBeforeNationalSignificantNumber = _this$state2.complexPrefixBeforeNationalSignificantNumber,
          nationalPrefix = _this$state2.nationalPrefix;
      var number = nationalSignificantNumber;
      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;

      if (prefix) {
        number = prefix + number;
      }

      return number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number = this.getNonFormattedNumber();

      if (number) {
        return number.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state,
          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
          carrierCode = _this$state3.carrierCode;

      if (this.isInternational()) {
        if (!this.state.callingCode) {
          return;
        }
      } else {
        if (!this.state.country && !this.defaultCallingCode) {
          return;
        }
      }

      if (!nationalSignificantNumber) {
        return;
      }

      var countryCode = this.getCountry();
      var callingCode = this.getCountryCallingCode() || this.defaultCallingCode;
      var phoneNumber = new PhoneNumber(countryCode || callingCode, nationalSignificantNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */

  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? '+' : '') + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
    }
  }]);

  return AsYouType;
}();

function getCountries$1(metadata) {
  return new Metadata(metadata).getCountries();
}

/**
 * Formats a (possibly incomplete) phone number.
 * The phone number can be either in E.164 format
 * or in a form of national number digits.
 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
 * @param {string?} country - Two-letter ("ISO 3166-1 alpha-2") country code.
 * @return {string} Formatted (possibly incomplete) phone number.
 */

function formatIncompletePhoneNumber(value, country, metadata) {
  if (!metadata) {
    metadata = country;
    country = undefined;
  }

  return new AsYouType(country, metadata).input(value);
}

function getInputValuePrefix(_ref) {
  var country = _ref.country,
      international = _ref.international,
      withCountryCallingCode = _ref.withCountryCallingCode,
      metadata = _ref.metadata;
  return country && international && !withCountryCallingCode ? "+".concat(getCountryCallingCode$2(country, metadata)) : '';
}
function removeInputValuePrefix(value, prefix) {
  if (prefix) {
    value = value.slice(prefix.length);

    if (value[0] === ' ') {
      value = value.slice(1);
    }
  }

  return value;
}

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function _objectWithoutProperties$8(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$8(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * This input uses `input-format` library
 * for "smart" caret positioning.
 */

function createInput$2(defaultMetadata) {
  function InputSmart(_ref, ref) {
    var country = _ref.country,
        international = _ref.international,
        withCountryCallingCode = _ref.withCountryCallingCode,
        metadata = _ref.metadata,
        rest = _objectWithoutProperties$8(_ref, ["country", "international", "withCountryCallingCode", "metadata"]);

    var format = useCallback(function (value) {
      // "As you type" formatter.
      var formatter = new AsYouType(country, metadata);
      var prefix = getInputValuePrefix({
        country: country,
        international: international,
        withCountryCallingCode: withCountryCallingCode,
        metadata: metadata
      }); // Format the number.

      var text = formatter.input(prefix + value);
      var template = formatter.getTemplate();

      if (prefix) {
        text = removeInputValuePrefix(text, prefix); // `AsYouType.getTemplate()` can be `undefined`.

        if (template) {
          template = removeInputValuePrefix(template, prefix);
        }
      }

      return {
        text: text,
        template: template
      };
    }, [country, metadata]);
    return React__default.createElement(Input$1, _extends$9({}, rest, {
      ref: ref,
      parse: parsePhoneNumberCharacter,
      format: format
    }));
  }

  InputSmart = React__default.forwardRef(InputSmart);
  InputSmart.propTypes = {
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: PropTypes.string,

    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: PropTypes.bool,

    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: PropTypes.bool,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes.object.isRequired
  };
  InputSmart.defaultProps = {
    metadata: defaultMetadata
  };
  return InputSmart;
}
var InputSmart = createInput$2();

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function _objectWithoutProperties$7(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$7(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createInput$1(defaultMetadata) {
  /**
   * `InputBasic`'s caret is not as "smart" as the default `inputComponent`'s
   * but still works good enough. When erasing or inserting digits in the middle
   * of a phone number the caret usually jumps to the end: this is the expected
   * behaviour and it's the workaround for the [Samsung Galaxy smart caret positioning bug](https://github.com/catamphetamine/react-phone-number-input/issues/75).
   */
  function InputBasic(_ref, ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        country = _ref.country,
        international = _ref.international,
        withCountryCallingCode = _ref.withCountryCallingCode,
        metadata = _ref.metadata,
        Input = _ref.inputComponent,
        rest = _objectWithoutProperties$7(_ref, ["value", "onChange", "country", "international", "withCountryCallingCode", "metadata", "inputComponent"]);

    var prefix = getInputValuePrefix({
      country: country,
      international: international,
      withCountryCallingCode: withCountryCallingCode,
      metadata: metadata
    });

    var _onChange = useCallback(function (event) {
      var newValue = parseIncompletePhoneNumber(event.target.value); // By default, if a value is something like `"(123)"`
      // then Backspace would only erase the rightmost brace
      // becoming something like `"(123"`
      // which would give the same `"123"` value
      // which would then be formatted back to `"(123)"`
      // and so a user wouldn't be able to erase the phone number.
      // Working around this issue with this simple hack.

      if (newValue === value) {
        var newValueFormatted = format(prefix, newValue, country, metadata);

        if (newValueFormatted.indexOf(event.target.value) === 0) {
          // Trim the last digit (or plus sign).
          newValue = newValue.slice(0, -1);
        }
      }

      onChange(newValue);
    }, [prefix, value, onChange, country, metadata]);

    return React__default.createElement(Input, _extends$8({}, rest, {
      ref: ref,
      value: format(prefix, value, country, metadata),
      onChange: _onChange
    }));
  }

  InputBasic = React__default.forwardRef(InputBasic);
  InputBasic.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: PropTypes.string.isRequired,

    /**
     * Updates the `value`.
     */
    onChange: PropTypes.func.isRequired,

    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: PropTypes.string,

    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: PropTypes.bool,

    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: PropTypes.bool,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes.object.isRequired,

    /**
     * The `<input/>` component.
     */
    inputComponent: PropTypes.elementType.isRequired
  };
  InputBasic.defaultProps = {
    metadata: defaultMetadata,
    inputComponent: 'input'
  };
  return InputBasic;
}
var InputBasic = createInput$1();

function format(prefix, value, country, metadata) {
  return removeInputValuePrefix(formatIncompletePhoneNumber(prefix + value, country, metadata), prefix);
}

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$6(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// `<img/>` is wrapped in a `<div/>` to prevent SVGs from exploding in size in IE 11.
// https://github.com/catamphetamine/react-phone-number-input/issues/111

function FlagComponent(_ref) {
  var country = _ref.country,
      countryName = _ref.countryName,
      flags = _ref.flags,
      flagUrl = _ref.flagUrl,
      rest = _objectWithoutProperties$6(_ref, ["country", "countryName", "flags", "flagUrl"]);

  if (flags && flags[country]) {
    return flags[country]({
      title: countryName
    });
  }

  return React__default.createElement("img", _extends$7({}, rest, {
    alt: countryName,
    role: countryName ? undefined : "presentation",
    src: flagUrl.replace('{XX}', country).replace('{xx}', country.toLowerCase())
  }));
}
FlagComponent.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: PropTypes.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: PropTypes.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` gitlab pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: PropTypes.objectOf(PropTypes.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` gitlab pages website.
  flagUrl: PropTypes.string.isRequired
};

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function InternationalIcon(_ref) {
  var aspectRatio = _ref.aspectRatio,
      rest = _objectWithoutProperties$5(_ref, ["aspectRatio"]);

  if (aspectRatio === 1) {
    return React__default.createElement(InternationalIcon1x1, rest);
  } else {
    return React__default.createElement(InternationalIcon3x2, rest);
  }
}
InternationalIcon.propTypes = {
  title: PropTypes.string.isRequired,
  aspectRatio: PropTypes.number
}; // 3x2.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title

function InternationalIcon3x2(_ref2) {
  var title = _ref2.title,
      rest = _objectWithoutProperties$5(_ref2, ["title"]);

  return React__default.createElement("svg", _extends$6({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), React__default.createElement("title", null, title), React__default.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, React__default.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), React__default.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), React__default.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), React__default.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), React__default.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), React__default.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), React__default.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}

InternationalIcon3x2.propTypes = {
  title: PropTypes.string.isRequired
}; // 1x1.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title

function InternationalIcon1x1(_ref3) {
  var title = _ref3.title,
      rest = _objectWithoutProperties$5(_ref3, ["title"]);

  return React__default.createElement("svg", _extends$6({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), React__default.createElement("title", null, title), React__default.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, React__default.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), React__default.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), React__default.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), React__default.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), React__default.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), React__default.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), React__default.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}

InternationalIcon1x1.propTypes = {
  title: PropTypes.string.isRequired
};

/**
 * Sorts country `<select/>` options.
 * Can move some country `<select/>` options
 * to the top of the list, for example.
 * @param  {object[]} countryOptions — Country `<select/>` options.
 * @param  {string[]} [countryOptionsOrder] — Country `<select/>` options order. Example: `["US", "CA", "AU", "|", "..."]`.
 * @return {object[]}
 */

function sortCountryOptions(options, order) {
  if (!order) {
    return options;
  }

  var optionsOnTop = [];
  var optionsOnBottom = [];
  var appendTo = optionsOnTop;

  for (var _iterator = order, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var element = _ref;

    if (element === '|') {
      appendTo.push({
        divider: true
      });
    } else if (element === '...' || element === '…') {
      appendTo = optionsOnBottom;
    } else {
      (function () {
        var countryCode = void 0;

        if (element === '🌐') {
          countryCode = undefined;
        } else {
          countryCode = element;
        } // Find the position of the option.


        var index = options.indexOf(options.filter(function (option) {
          return option.value === countryCode;
        })[0]); // Get the option.

        var option = options[index]; // Remove the option from its default position.

        options.splice(index, 1); // Add the option on top.

        appendTo.push(option);
      })();
    }
  }

  return optionsOnTop.concat(options).concat(optionsOnBottom);
}
function getSupportedCountryOptions(countryOptions, metadata) {
  if (countryOptions) {
    countryOptions = countryOptions.filter(function (option) {
      switch (option) {
        case '🌐':
        case '|':
        case '...':
        case '…':
          return true;

        default:
          return isCountrySupportedWithError(option, metadata);
      }
    });

    if (countryOptions.length > 0) {
      return countryOptions;
    }
  }
}
function isCountrySupportedWithError(country, metadata) {
  if (isSupportedCountry(country, metadata)) {
    return true;
  } else {
    console.error("Country not found: ".concat(country));
    return false;
  }
}
function getSupportedCountries(countries, metadata) {
  if (countries) {
    countries = countries.filter(function (country) {
      return isCountrySupportedWithError(country, metadata);
    });

    if (countries.length === 0) {
      countries = undefined;
    }
  }

  return countries;
}

function createCountryIconComponent(_ref) {
  var flags = _ref.flags,
      flagUrl = _ref.flagUrl,
      FlagComponent = _ref.flagComponent,
      InternationalIcon$1 = _ref.internationalIcon;

  function CountryIcon(_ref2) {
    var country = _ref2.country,
        label = _ref2.label,
        aspectRatio = _ref2.aspectRatio;

    // `aspectRatio` is currently a hack for the default "International" icon
    // to render it as a square when Unicode flag icons are used.
    // So `aspectRatio` property is only used with the default "International" icon.
    var _aspectRatio = InternationalIcon$1 === InternationalIcon ? aspectRatio : undefined;

    return React__default.createElement("div", {
      className: classNames$1('PhoneInputCountryIcon', {
        'PhoneInputCountryIcon--square': _aspectRatio === 1,
        'PhoneInputCountryIcon--border': country
      })
    }, country ? React__default.createElement(FlagComponent, {
      country: country,
      countryName: label,
      flags: flags,
      flagUrl: flagUrl,
      className: "PhoneInputCountryIconImg"
    }) : React__default.createElement(InternationalIcon$1, {
      title: label,
      aspectRatio: _aspectRatio,
      className: "PhoneInputCountryIconImg"
    }));
  }

  CountryIcon.propTypes = {
    country: PropTypes.string,
    label: PropTypes.string.isRequired,
    aspectRatio: PropTypes.number
  };
  return CountryIcon;
}
createCountryIconComponent({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
  flagComponent: FlagComponent,
  internationalIcon: InternationalIcon
});

var metadata = PropTypes.shape({
  country_calling_codes: PropTypes.object.isRequired,
  countries: PropTypes.object.isRequired
});
var labels$1 = PropTypes.objectOf(PropTypes.string);

var ONLY_DIGITS_REGEXP = /^\d+$/;
function getInternationalPhoneNumberPrefix(country, metadata) {
  // Standard international phone number prefix: "+" and "country calling code".
  var prefix = '+' + getCountryCallingCode$2(country, metadata); // Get "leading digits" for a phone number of the country.
  // If there're "leading digits" then they can be part of the prefix too.

  metadata = new Metadata(metadata);
  metadata.country(country);

  if (metadata.numberingPlan.leadingDigits() && ONLY_DIGITS_REGEXP.test(metadata.numberingPlan.leadingDigits())) {
    prefix += metadata.numberingPlan.leadingDigits();
  }

  return prefix;
}

/**
 * Decides which country should be pre-selected
 * when the phone number input component is first mounted.
 * @param  {object?} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {string?} country - Pre-defined country (two-letter code).
 * @param  {string[]?} countries - A list of countries available.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string?}
 */

function getPreSelectedCountry(_ref) {
  var phoneNumber = _ref.phoneNumber,
      defaultCountry = _ref.defaultCountry,
      countries = _ref.countries,
      required = _ref.required;
      _ref.metadata;
  var country = defaultCountry; // If can get country from E.164 phone number
  // then it overrides the `country` passed (or not passed).

  if (phoneNumber && phoneNumber.country) {
    // `country` will be left `undefined` in case of non-detection.
    country = phoneNumber.country;
  } // Only pre-select a country if it's in the available `countries` list.


  if (countries && countries.indexOf(country) < 0) {
    country = undefined;
  } // If there will be no "International" option
  // then some `country` must be selected.
  // It will still be the wrong country though.
  // But still country `<select/>` can't be left in a broken state.


  if (!country && required && countries && countries.length > 0) {
    country = countries[0];
  }

  return country;
}
/**
 * Generates a sorted list of country `<select/>` options.
 * @param  {string[]} countries - A list of two-letter ("ISO 3166-1 alpha-2") country codes.
 * @param  {object} labels - Custom country labels. E.g. `{ RU: 'Россия', US: 'США', ... }`.
 * @param  {boolean} addInternationalOption - Whether should include "International" option at the top of the list.
 * @return {object[]} A list of objects having shape `{ value : string, label : string }`.
 */

function getCountrySelectOptions(_ref2) {
  var countries = _ref2.countries,
      countryNames = _ref2.countryNames,
      addInternationalOption = _ref2.addInternationalOption,
      compareStringsLocales = _ref2.compareStringsLocales,
      _compareStrings = _ref2.compareStrings;

  // Default country name comparator uses `String.localeCompare()`.
  if (!_compareStrings) {
    _compareStrings = compareStrings;
  } // Generates a `<Select/>` option for each country.


  var countrySelectOptions = countries.map(function (country) {
    return {
      value: country,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: countryNames[country] || country
    };
  }); // Sort the list of countries alphabetically.

  countrySelectOptions.sort(function (a, b) {
    return _compareStrings(a.label, b.label, compareStringsLocales);
  }); // Add the "International" option to the country list (if suitable)

  if (addInternationalOption) {
    countrySelectOptions.unshift({
      label: countryNames.ZZ
    });
  }

  return countrySelectOptions;
}
/**
 * Parses a E.164 phone number to an instance of `PhoneNumber` class.
 * @param {string?} value = E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {object} Object having shape `{ country: string?, countryCallingCode: string, number: string }`. `PhoneNumber`: https://gitlab.com/catamphetamine/libphonenumber-js#phonenumber.
 * @example
 * parsePhoneNumber('+78005553535')
 */

function parsePhoneNumber$1(value, metadata) {
  return parsePhoneNumberFromString(value || '', metadata);
}
/**
 * Generates national number digits for a parsed phone.
 * May prepend national prefix.
 * The phone number must be a complete and valid phone number.
 * @param  {object} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string}
 * @example
 * getNationalNumberDigits({ country: 'RU', phone: '8005553535' })
 * // returns '88005553535'
 */

function generateNationalNumberDigits(phoneNumber) {
  return phoneNumber.formatNational().replace(/\D/g, '');
}
/**
 * Migrates parsed `<input/>` `value` for the newly selected `country`.
 * @param {string?} phoneDigits - Phone number digits (and `+`) parsed from phone number `<input/>` (it's not the same as the `value` property).
 * @param {string?} prevCountry - Previously selected country.
 * @param {string?} newCountry - Newly selected country. Can't be same as previously selected country.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @param {boolean} useNationalFormat - whether should attempt to convert from international to national number for the new country.
 * @return {string?}
 */

function getPhoneDigitsForNewCountry(phoneDigits, _ref3) {
  var prevCountry = _ref3.prevCountry,
      newCountry = _ref3.newCountry,
      metadata = _ref3.metadata,
      useNationalFormat = _ref3.useNationalFormat;

  // If `parsed_input` is empty
  // then no need to migrate anything.
  if (!phoneDigits) {
    if (useNationalFormat) {
      return '';
    } else {
      // If `phoneDigits` is empty then set `phoneDigits` to
      // `+{getCountryCallingCode(newCountry)}`.
      return getInternationalPhoneNumberPrefix(newCountry, metadata);
    }
  } // If switching to some country.
  // (from "International" or another country)
  // If switching from "International" then `phoneDigits` starts with a `+`.
  // Otherwise it may or may not start with a `+`.


  if (newCountry) {
    // If the phone number was entered in international format
    // then migrate it to the newly selected country.
    // The phone number may be incomplete.
    // The phone number entered not necessarily starts with
    // the previously selected country phone prefix.
    if (phoneDigits[0] === '+') {
      // If the international phone number is for the new country
      // then convert it to local if required.
      if (useNationalFormat) {
        // // If a phone number is being input in international form
        // // and the country can already be derived from it,
        // // and if it is the new country, then format as a national number.
        // const derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(phoneDigits, metadata)
        // if (derived_country === newCountry) {
        // 	return stripCountryCallingCode(phoneDigits, derived_country, metadata)
        // }
        // Actually, the two countries don't necessarily need to match:
        // the condition could be looser here, because several countries
        // might share the same international phone number format
        // (for example, "NANPA" countries like US, Canada, etc).
        // The looser condition would be just "same nternational phone number format"
        // which would mean "same country calling code" in the context of `libphonenumber-js`.
        if (phoneDigits.indexOf('+' + getCountryCallingCode$2(newCountry, metadata)) === 0) {
          return stripCountryCallingCode(phoneDigits, newCountry, metadata);
        } // Simply discard the previously entered international phone number,
        // because otherwise any "smart" transformation like getting the
        // "national (significant) number" part and then prepending the
        // newly selected country's "country calling code" to it
        // would just be confusing for a user without being actually useful.


        return ''; // // Simply strip the leading `+` character
        // // therefore simply converting all digits into a "local" phone number.
        // // https://github.com/catamphetamine/react-phone-number-input/issues/287
        // return phoneDigits.slice(1)
      }

      if (prevCountry) {
        var newCountryPrefix = getInternationalPhoneNumberPrefix(newCountry, metadata);

        if (phoneDigits.indexOf(newCountryPrefix) === 0) {
          return phoneDigits;
        } else {
          return newCountryPrefix;
        }
      } else {
        var defaultValue = getInternationalPhoneNumberPrefix(newCountry, metadata); // If `phoneDigits`'s country calling code part is the same
        // as for the new `country`, then leave `phoneDigits` as is.

        if (phoneDigits.indexOf(defaultValue) === 0) {
          return phoneDigits;
        } // If `phoneDigits`'s country calling code part is not the same
        // as for the new `country`, then set `phoneDigits` to
        // `+{getCountryCallingCode(newCountry)}`.


        return defaultValue;
      } // // If the international phone number already contains
      // // any country calling code then trim the country calling code part.
      // // (that could also be the newly selected country phone code prefix as well)
      // // `phoneDigits` doesn't neccessarily belong to `prevCountry`.
      // // (e.g. if a user enters an international number
      // //  not belonging to any of the reduced `countries` list).
      // phoneDigits = stripCountryCallingCode(phoneDigits, prevCountry, metadata)
      // // Prepend country calling code prefix
      // // for the newly selected country.
      // return e164(phoneDigits, newCountry, metadata) || `+${getCountryCallingCode(newCountry, metadata)}`

    }
  } // If switching to "International" from a country.
  else {
      // If the phone number was entered in national format.
      if (phoneDigits[0] !== '+') {
        // Format the national phone number as an international one.
        // The phone number entered not necessarily even starts with
        // the previously selected country phone prefix.
        // Even if the phone number belongs to whole another country
        // it will still be parsed into some national phone number.
        return e164(phoneDigits, prevCountry, metadata) || '';
      }
    }

  return phoneDigits;
}
/**
 * Converts phone number digits to a (possibly incomplete) E.164 phone number.
 * @param  {string?} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string?} country
 * @param  {[object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */

function e164(number, country, metadata) {
  if (!number) {
    return;
  } // If the phone number is being input in international format.


  if (number[0] === '+') {
    // If it's just the `+` sign then return nothing.
    if (number === '+') {
      return;
    } // If there are any digits then the `value` is returned as is.


    return number;
  } // For non-international phone numbers
  // an accompanying country code is required.


  if (!country) {
    return;
  }

  var partial_national_significant_number = getNationalSignificantNumberDigits(number, country, metadata);

  if (partial_national_significant_number) {
    return "+".concat(getCountryCallingCode$2(country, metadata)).concat(partial_national_significant_number);
  }
}
/**
 * Trims phone number digits if they exceed the maximum possible length
 * for a national (significant) number for the country.
 * @param  {string} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string} country
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string} Can be empty.
 */

function trimNumber(number, country, metadata) {
  var nationalSignificantNumberPart = getNationalSignificantNumberDigits(number, country, metadata);

  if (nationalSignificantNumberPart) {
    var overflowDigitsCount = nationalSignificantNumberPart.length - getMaxNumberLength(country, metadata);

    if (overflowDigitsCount > 0) {
      return number.slice(0, number.length - overflowDigitsCount);
    }
  }

  return number;
}

function getMaxNumberLength(country, metadata) {
  // Get "possible lengths" for a phone number of the country.
  metadata = new Metadata(metadata);
  metadata.country(country); // Return the last "possible length".

  return metadata.numberingPlan.possibleLengths()[metadata.numberingPlan.possibleLengths().length - 1];
} // If the phone number being input is an international one
// then tries to derive the country from the phone number.
// (regardless of whether there's any country currently selected)

/**
 * @param {string} partialE164Number - A possibly incomplete E.164 phone number.
 * @param {string?} country - Currently selected country.
 * @param {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */


function getCountryForPartialE164Number(partialE164Number, _ref4) {
  var country = _ref4.country,
      countries = _ref4.countries,
      required = _ref4.required,
      metadata = _ref4.metadata;

  if (partialE164Number === '+') {
    // Don't change the currently selected country yet.
    return country;
  }

  var derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(partialE164Number, metadata); // If a phone number is being input in international form
  // and the country can already be derived from it,
  // then select that country.

  if (derived_country && (!countries || countries.indexOf(derived_country) >= 0)) {
    return derived_country;
  } // If "International" country option has not been disabled
  // and the international phone number entered doesn't correspond
  // to the currently selected country then reset the currently selected country.
  else if (country && !required && !couldNumberBelongToCountry(partialE164Number, country, metadata)) {
      return undefined;
    } // Don't change the currently selected country.


  return country;
}
/**
 * Parses `<input/>` value. Derives `country` from `input`. Derives an E.164 `value`.
 * @param  {string?} phoneDigits — Parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} prevPhoneDigits — Previous parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} country - Currently selected country.
 * @param  {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param  {boolean} international - Set to `true` to force international phone number format (leading `+`). Set to `false` to force "national" phone number format. Is `undefined` by default.
 * @param  {boolean} limitMaxLength — Whether to enable limiting phone number max length.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {object} An object of shape `{ input, country, value }`.
 */

function onPhoneDigitsChange(phoneDigits, _ref5) {
  var prevPhoneDigits = _ref5.prevPhoneDigits,
      country = _ref5.country,
      defaultCountry = _ref5.defaultCountry,
      countries = _ref5.countries,
      international = _ref5.international,
      limitMaxLength = _ref5.limitMaxLength,
      countryCallingCodeEditable = _ref5.countryCallingCodeEditable,
      metadata = _ref5.metadata;

  if (international && countryCallingCodeEditable === false) {
    var prefix = getInternationalPhoneNumberPrefix(country, metadata); // The `<input/>` value must start with the country calling code.

    if (phoneDigits.indexOf(prefix) !== 0) {
      // If a user tabs into a phone number input field
      // that is `international` and `withCountryCallingCode`,
      // and then starts inputting local phone number digits,
      // the first digit would get "swallowed" without this `appendDigits` fix.
      // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43
      if (phoneDigits && phoneDigits[0] !== '+') {
        phoneDigits = prefix + phoneDigits;
      } else {
        phoneDigits = prefix;
      }

      return {
        phoneDigits: phoneDigits,
        value: undefined,
        country: country
      };
    }
  } // If `international` property is `false`, then it means
  // "enforce national-only format during input",
  // so, if that's the case, then remove all `+` characters,
  // but only if some country is currently selected.
  // (not if "International" country is selected).


  if (international === false && country && phoneDigits && phoneDigits[0] === '+') {
    phoneDigits = convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata);
  } // Trim the input to not exceed the maximum possible number length.


  if (phoneDigits && country && limitMaxLength) {
    phoneDigits = trimNumber(phoneDigits, country, metadata);
  } // If this `onChange()` event was triggered
  // as a result of selecting "International" country,
  // then force-prepend a `+` sign if the phone number
  // `<input/>` value isn't in international format.
  // Also, force-prepend a `+` sign if international
  // phone number input format is set.


  if (phoneDigits && phoneDigits[0] !== '+' && (!country || international)) {
    phoneDigits = '+' + phoneDigits;
  } // If the previously entered phone number
  // has been entered in international format
  // and the user decides to erase it,
  // then also reset the `country`
  // because it was most likely automatically selected
  // while the user was typing in the phone number
  // in international format.
  // This fixes the issue when a user is presented
  // with a phone number input with no country selected
  // and then types in their local phone number
  // then discovers that the input's messed up
  // (a `+` has been prepended at the start of their input
  //  and a random country has been selected),
  // decides to undo it all by erasing everything
  // and then types in their local phone number again
  // resulting in a seemingly correct phone number
  // but in reality that phone number has incorrect country.
  // https://github.com/catamphetamine/react-phone-number-input/issues/273


  if (!phoneDigits && prevPhoneDigits && prevPhoneDigits[0] === '+') {
    if (international) {
      country = undefined;
    } else {
      country = defaultCountry;
    }
  } // Also resets such "randomly" selected country
  // as soon as the user erases the number
  // digit-by-digit up to the leading `+` sign.


  if (phoneDigits === '+' && prevPhoneDigits && prevPhoneDigits[0] === '+' && prevPhoneDigits.length > '+'.length) {
    country = undefined;
  } // Generate the new `value` property.


  var value;

  if (phoneDigits) {
    if (phoneDigits[0] === '+') {
      if (phoneDigits === '+') {
        value = undefined;
      } else if (country && getInternationalPhoneNumberPrefix(country, metadata).indexOf(phoneDigits) === 0) {
        value = undefined;
      } else {
        value = phoneDigits;
      }
    } else {
      value = e164(phoneDigits, country, metadata);
    }
  } // Derive the country from the phone number.
  // (regardless of whether there's any country currently selected,
  //  because there could be several countries corresponding to one country calling code)


  if (value) {
    country = getCountryForPartialE164Number(value, {
      country: country,
      countries: countries,
      metadata: metadata
    }); // If `international` property is `false`, then it means
    // "enforce national-only format during input",
    // so, if that's the case, then remove all `+` characters,
    // but only if some country is currently selected.
    // (not if "International" country is selected).

    if (international === false && country && phoneDigits && phoneDigits[0] === '+') {
      phoneDigits = convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata); // Re-calculate `value` because `phoneDigits` has changed.

      value = e164(phoneDigits, country, metadata);
    }
  }

  return {
    phoneDigits: phoneDigits,
    country: country,
    value: value
  };
}

function convertInternationalPhoneDigitsToNational(input, country, metadata) {
  // Handle the case when a user might have pasted
  // a phone number in international format.
  if (input.indexOf(getInternationalPhoneNumberPrefix(country, metadata)) === 0) {
    // Create "as you type" formatter.
    var formatter = new AsYouType(country, metadata); // Input partial national phone number.

    formatter.input(input); // Return the parsed partial national phone number.

    var phoneNumber = formatter.getNumber();

    if (phoneNumber) {
      // Transform the number to a national one,
      // and remove all non-digits.
      return phoneNumber.formatNational().replace(/\D/g, '');
    } else {
      return '';
    }
  } else {
    // Just remove the `+` sign.
    return input.replace(/\D/g, '');
  }
}
/**
 * Determines the country for a given (possibly incomplete) E.164 phone number.
 * @param  {string} number - A possibly incomplete E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */


function getCountryFromPossiblyIncompleteInternationalPhoneNumber(number, metadata) {
  var formatter = new AsYouType(null, metadata);
  formatter.input(number); // // `001` is a special "non-geograpical entity" code
  // // in Google's `libphonenumber` library.
  // if (formatter.getCountry() === '001') {
  // 	return
  // }

  return formatter.getCountry();
}
/**
 * Compares two strings.
 * A helper for `Array.sort()`.
 * @param {string} a — First string.
 * @param {string} b — Second string.
 * @param {(string[]|string)} [locales] — The `locales` argument of `String.localeCompare`.
 */

function compareStrings(a, b, locales) {
  // Use `String.localeCompare` if it's available.
  // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
  // Which means everyone except IE <= 10 and Safari <= 10.
  // `localeCompare()` is available in latest Node.js versions.

  /* istanbul ignore else */
  if (String.prototype.localeCompare) {
    return a.localeCompare(b, locales);
  }
  /* istanbul ignore next */


  return a < b ? -1 : a > b ? 1 : 0;
}
/**
 * Strips `+${countryCallingCode}` prefix from an E.164 phone number.
 * @param {string} number - (possibly incomplete) E.164 phone number.
 * @param {string?} country - A possible country for this phone number.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string}
 */

function stripCountryCallingCode(number, country, metadata) {
  // Just an optimization, so that it
  // doesn't have to iterate through all country calling codes.
  if (country) {
    var countryCallingCodePrefix = '+' + getCountryCallingCode$2(country, metadata); // If `country` fits the actual `number`.

    if (number.length < countryCallingCodePrefix.length) {
      if (countryCallingCodePrefix.indexOf(number) === 0) {
        return '';
      }
    } else {
      if (number.indexOf(countryCallingCodePrefix) === 0) {
        return number.slice(countryCallingCodePrefix.length);
      }
    }
  } // If `country` doesn't fit the actual `number`.
  // Try all available country calling codes.


  for (var _i = 0, _Object$keys = Object.keys(metadata.country_calling_codes); _i < _Object$keys.length; _i++) {
    var country_calling_code = _Object$keys[_i];

    if (number.indexOf(country_calling_code) === '+'.length) {
      return number.slice('+'.length + country_calling_code.length);
    }
  }

  return '';
}
/**
 * Parses a partially entered national phone number digits
 * (or a partially entered E.164 international phone number)
 * and returns the national significant number part.
 * National significant number returned doesn't come with a national prefix.
 * @param {string} number - National number digits. Or possibly incomplete E.164 phone number.
 * @param {string?} country
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string} [result]
 */

function getNationalSignificantNumberDigits(number, country, metadata) {
  // Create "as you type" formatter.
  var formatter = new AsYouType(country, metadata); // Input partial national phone number.

  formatter.input(number); // Return the parsed partial national phone number.

  var phoneNumber = formatter.getNumber();
  return phoneNumber && phoneNumber.nationalNumber;
}
/**
 * Checks if a partially entered E.164 phone number could belong to a country.
 * @param  {string} number
 * @param  {string} country
 * @return {boolean}
 */

function couldNumberBelongToCountry(number, country, metadata) {
  var intlPhoneNumberPrefix = getInternationalPhoneNumberPrefix(country, metadata);
  var i = 0;

  while (i < number.length && i < intlPhoneNumberPrefix.length) {
    if (number[i] !== intlPhoneNumberPrefix[i]) {
      return false;
    }

    i++;
  }

  return true;
}
/**
 * Gets initial "phone digits" (including `+`, if using international format).
 * @return {string} [phoneDigits] Returns `undefined` if there should be no initial "phone digits".
 */

function getInitialPhoneDigits(_ref6) {
  var value = _ref6.value,
      phoneNumber = _ref6.phoneNumber,
      defaultCountry = _ref6.defaultCountry,
      international = _ref6.international,
      useNationalFormat = _ref6.useNationalFormat,
      metadata = _ref6.metadata;

  // If the `value` (E.164 phone number)
  // belongs to the currently selected country
  // and `useNationalFormat` is `true`
  // then convert `value` (E.164 phone number)
  // to a local phone number digits.
  // E.g. '+78005553535' -> '88005553535'.
  if ((international === false || useNationalFormat) && phoneNumber && phoneNumber.country) {
    return generateNationalNumberDigits(phoneNumber);
  } // If `international` property is `true`,
  // meaning "enforce international phone number format",
  // then always show country calling code in the input field.


  if (!value && international && defaultCountry) {
    return getInternationalPhoneNumberPrefix(defaultCountry, metadata);
  }

  return value;
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function getPhoneInputWithCountryStateUpdateFromNewProps(props, prevProps, state) {
  var metadata = props.metadata,
      countries = props.countries,
      newDefaultCountry = props.defaultCountry,
      newValue = props.value,
      newReset = props.reset,
      international = props.international,
      displayInitialValueAsLocalNumber = props.displayInitialValueAsLocalNumber,
      initialValueFormat = props.initialValueFormat;
  var prevDefaultCountry = prevProps.defaultCountry,
      prevValue = prevProps.value,
      prevReset = prevProps.reset;
  state.country;
      var value = state.value,
      hasUserSelectedACountry = state.hasUserSelectedACountry;

  var _getInitialPhoneDigits = function _getInitialPhoneDigits(parameters) {
    return getInitialPhoneDigits(_objectSpread$2({}, parameters, {
      international: international,
      useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
      metadata: metadata
    }));
  }; // Some users requested a way to reset the component
  // (both number `<input/>` and country `<select/>`).
  // Whenever `reset` property changes both number `<input/>`
  // and country `<select/>` are reset.
  // It's not implemented as some instance `.reset()` method
  // because `ref` is forwarded to `<input/>`.
  // It's also not replaced with just resetting `country` on
  // external `value` reset, because a user could select a country
  // and then not input any `value`, and so the selected country
  // would be "stuck", if not using this `reset` property.
  // https://github.com/catamphetamine/react-phone-number-input/issues/300


  if (newReset !== prevReset) {
    return {
      phoneDigits: _getInitialPhoneDigits({
        value: undefined,
        defaultCountry: newDefaultCountry
      }),
      value: undefined,
      country: newDefaultCountry,
      hasUserSelectedACountry: undefined
    };
  } // `value` is the value currently shown in the component:
  // it's stored in the component's `state`, and it's not the `value` property.
  // `prevValue` is "previous `value` property".
  // `newValue` is "new `value` property".
  // If the default country changed
  // (e.g. in case of ajax GeoIP detection after page loaded)
  // then select it, but only if the user hasn't already manually
  // selected a country, and no phone number has been manually entered so far.
  // Because if the user has already started inputting a phone number
  // then they're okay with no country being selected at all ("International")
  // and they don't want to be disturbed, don't want their input to be screwed, etc.


  if (newDefaultCountry !== prevDefaultCountry) {
    var isNewDefaultCountrySupported = !newDefaultCountry || isCountrySupportedWithError(newDefaultCountry, metadata);

    var noValueHasBeenEnteredByTheUser = // By default, "no value has been entered" means `value` is `undefined`.
    !value || // When `international` is `true`, and some country has been pre-selected,
    // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
    // so in case of `international` being `true`, "the user hasn't entered anything" situation
    // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
    international && value === _getInitialPhoneDigits({
      value: undefined,
      defaultCountry: prevDefaultCountry
    }); // Only update the `defaultCountry` property if no phone number
    // has been entered by the user or pre-set by the application.


    var noValueHasBeenEntered = !newValue && noValueHasBeenEnteredByTheUser;

    if (!hasUserSelectedACountry && isNewDefaultCountrySupported && noValueHasBeenEntered) {
      return {
        country: newDefaultCountry,
        // If `phoneDigits` is empty, then automatically select the new `country`
        // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
        // The code assumes that "no phone number has been entered by the user",
        // and no `value` property has been passed, so the `phoneNumber` parameter
        // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
        phoneDigits: _getInitialPhoneDigits({
          value: undefined,
          defaultCountry: newDefaultCountry
        }),
        // `value` is `undefined` and it stays so.
        value: undefined
      };
    }
  } // If a new `value` is set externally.
  // (e.g. as a result of an ajax API request
  //  to get user's phone after page loaded)
  // The first part — `newValue !== prevValue` —
  // is basically `props.value !== prevProps.value`
  // so it means "if value property was changed externally".
  // The second part — `newValue !== value` —
  // is for ignoring the `getDerivedStateFromProps()` call
  // which happens in `this.onChange()` right after `this.setState()`.
  // If this `getDerivedStateFromProps()` call isn't ignored
  // then the country flag would reset on each input.


  if (newValue !== prevValue && newValue !== value) {
    var phoneNumber;
    var parsedCountry;

    if (newValue) {
      phoneNumber = parsePhoneNumber$1(newValue, metadata);
      var supportedCountries = getSupportedCountries(countries, metadata);

      if (phoneNumber && phoneNumber.country) {
        // Ignore `else` because all countries are supported in metadata.

        /* istanbul ignore next */
        if (!supportedCountries || supportedCountries.indexOf(phoneNumber.country) >= 0) {
          parsedCountry = phoneNumber.country;
        }
      } else {
        parsedCountry = getCountryForPartialE164Number(newValue, {
          country: undefined,
          countries: supportedCountries,
          metadata: metadata
        });
      }
    }

    var hasUserSelectedACountryUpdate;

    if (!newValue) {
      // Reset `hasUserSelectedACountry` flag in `state`.
      hasUserSelectedACountryUpdate = {
        hasUserSelectedACountry: undefined
      };
    }

    return _objectSpread$2({}, hasUserSelectedACountryUpdate, {
      phoneDigits: _getInitialPhoneDigits({
        phoneNumber: phoneNumber,
        value: newValue,
        defaultCountry: newDefaultCountry
      }),
      value: newValue,
      country: newValue ? parsedCountry : newDefaultCountry
    });
  } // `defaultCountry` didn't change.
  // `value` didn't change.
  // `phoneDigits` didn't change, because `value` didn't change.
  //
  // So no need to update state.

}

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$3(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$3(self); }

function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }

function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$3(subClass, superClass); }

function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PhoneNumberInput_ =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits$3(PhoneNumberInput_, _React$PureComponent);

  function PhoneNumberInput_(props) {
    var _this;

    _classCallCheck$3(this, PhoneNumberInput_);

    _this = _possibleConstructorReturn$3(this, _getPrototypeOf$3(PhoneNumberInput_).call(this, props));

    _defineProperty$2(_assertThisInitialized$3(_this), "inputRef", React__default.createRef());

    _defineProperty$2(_assertThisInitialized$3(_this), "setInputRef", function (instance) {
      _this.inputRef.current = instance;
      var ref = _this.props.inputRef;

      if (ref) {
        if (typeof ref === 'function') {
          ref(instance);
        } else {
          ref.current = instance;
        }
      }
    });

    _defineProperty$2(_assertThisInitialized$3(_this), "isCountrySupportedWithError", function (country) {
      var metadata = _this.props.metadata;
      return isCountrySupportedWithError(country, metadata);
    });

    _defineProperty$2(_assertThisInitialized$3(_this), "onCountryChange", function (newCountry) {
      var _this$props = _this.props,
          international = _this$props.international,
          metadata = _this$props.metadata,
          onChange = _this$props.onChange,
          focusInputOnCountrySelection = _this$props.focusInputOnCountrySelection;
      var _this$state = _this.state,
          prevPhoneDigits = _this$state.phoneDigits,
          prevCountry = _this$state.country; // After the new `country` has been selected,
      // if the phone number `<input/>` holds any digits
      // then migrate those digits for the new `country`.

      var newPhoneDigits = getPhoneDigitsForNewCountry(prevPhoneDigits, {
        prevCountry: prevCountry,
        newCountry: newCountry,
        metadata: metadata,
        // Convert the phone number to "national" format
        // when the user changes the selected country by hand.
        useNationalFormat: !international
      });
      var newValue = e164(newPhoneDigits, newCountry, metadata); // Focus phone number `<input/>` upon country selection.

      if (focusInputOnCountrySelection) {
        _this.inputRef.current.focus();
      } // If the user has already manually selected a country
      // then don't override that already selected country
      // if the `defaultCountry` property changes.
      // That's what `hasUserSelectedACountry` flag is for.


      _this.setState({
        country: newCountry,
        hasUserSelectedACountry: true,
        phoneDigits: newPhoneDigits,
        value: newValue
      }, function () {
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        onChange(newValue);
      });
    });

    _defineProperty$2(_assertThisInitialized$3(_this), "onChange", function (_phoneDigits) {
      var _this$props2 = _this.props,
          defaultCountry = _this$props2.defaultCountry,
          onChange = _this$props2.onChange;
          _this$props2.addInternationalOption;
          var international = _this$props2.international,
          limitMaxLength = _this$props2.limitMaxLength,
          countryCallingCodeEditable = _this$props2.countryCallingCodeEditable,
          metadata = _this$props2.metadata;
      var _this$state2 = _this.state,
          countries = _this$state2.countries,
          prevPhoneDigits = _this$state2.phoneDigits,
          currentlySelectedCountry = _this$state2.country;

      var _onPhoneDigitsChange = onPhoneDigitsChange(_phoneDigits, {
        prevPhoneDigits: prevPhoneDigits,
        country: currentlySelectedCountry,
        defaultCountry: defaultCountry,
        countries: countries,
        international: international,
        limitMaxLength: limitMaxLength,
        countryCallingCodeEditable: countryCallingCodeEditable,
        metadata: metadata
      }),
          phoneDigits = _onPhoneDigitsChange.phoneDigits,
          country = _onPhoneDigitsChange.country,
          value = _onPhoneDigitsChange.value;

      var stateUpdate = {
        phoneDigits: phoneDigits,
        value: value,
        country: country
      };

      if (countryCallingCodeEditable === false) {
        // If it simply did `setState({ phoneDigits: intlPrefix })` here,
        // then it would have no effect when erasing an inital international prefix
        // via Backspace, because `phoneDigits` in `state` wouldn't change
        // as a result, because it was `prefix` and it became `prefix`,
        // so the component wouldn't rerender, and the user would be able
        // to erase the country calling code part, and that part is
        // assumed to be non-eraseable. That's why the component is
        // forcefully rerendered here.
        // https://github.com/catamphetamine/react-phone-number-input/issues/367#issuecomment-721703501
        if (!value && phoneDigits === _this.state.phoneDigits) {
          // Force a re-render of the `<input/>` in order to reset its value.
          stateUpdate.forceRerender = {};
        }
      }

      _this.setState(stateUpdate, // Update the new `value` property.
      // Doing it after the `state` has been updated
      // because `onChange()` will trigger `getDerivedStateFromProps()`
      // with the new `value` which will be compared to `state.value` there.
      function () {
        return onChange(value);
      });
    });

    _defineProperty$2(_assertThisInitialized$3(_this), "_onFocus", function () {
      return _this.setState({
        isFocused: true
      });
    });

    _defineProperty$2(_assertThisInitialized$3(_this), "_onBlur", function () {
      return _this.setState({
        isFocused: false
      });
    });

    _defineProperty$2(_assertThisInitialized$3(_this), "onFocus", function (event) {
      _this._onFocus();

      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus(event);
      }
    });

    _defineProperty$2(_assertThisInitialized$3(_this), "onBlur", function (event) {
      var onBlur = _this.props.onBlur;

      _this._onBlur();

      if (onBlur) {
        onBlur(event);
      }
    });

    _defineProperty$2(_assertThisInitialized$3(_this), "onCountryFocus", function (event) {
      _this._onFocus(); // this.setState({ countrySelectFocused: true })


      var countrySelectProps = _this.props.countrySelectProps;

      if (countrySelectProps) {
        var onFocus = countrySelectProps.onFocus;

        if (onFocus) {
          onFocus(event);
        }
      }
    });

    _defineProperty$2(_assertThisInitialized$3(_this), "onCountryBlur", function (event) {
      _this._onBlur(); // this.setState({ countrySelectFocused: false })


      var countrySelectProps = _this.props.countrySelectProps;

      if (countrySelectProps) {
        var onBlur = countrySelectProps.onBlur;

        if (onBlur) {
          onBlur(event);
        }
      }
    });

    var _this$props3 = _this.props,
        _value = _this$props3.value;
        _this$props3.labels;
        var _international = _this$props3.international,
        addInternationalOption = _this$props3.addInternationalOption,
        displayInitialValueAsLocalNumber = _this$props3.displayInitialValueAsLocalNumber,
        initialValueFormat = _this$props3.initialValueFormat,
        _metadata = _this$props3.metadata;
    var _this$props4 = _this.props,
        _defaultCountry = _this$props4.defaultCountry,
        _countries = _this$props4.countries; // Validate `defaultCountry`.

    if (_defaultCountry) {
      if (!_this.isCountrySupportedWithError(_defaultCountry)) {
        _defaultCountry = undefined;
      }
    } // Validate `countries`.


    _countries = getSupportedCountries(_countries, _metadata);
    var phoneNumber = parsePhoneNumber$1(_value, _metadata);
    _this.CountryIcon = createCountryIconComponent(_this.props);
    _this.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: _this.props,
      // The country selected.
      country: getPreSelectedCountry({
        phoneNumber: phoneNumber,
        defaultCountry: _defaultCountry,
        countries: _countries || getCountries$1(_metadata),
        required: !addInternationalOption,
        metadata: _metadata
      }),
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: _countries,
      // `phoneDigits` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value` is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `phoneDigits` are `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
      phoneDigits: getInitialPhoneDigits({
        value: _value,
        phoneNumber: phoneNumber,
        defaultCountry: _defaultCountry,
        international: _international,
        useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
        metadata: _metadata
      }),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `phoneDigits` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `phoneDigits` and `country` should be updated.
      value: _value
    };
    return _this;
  }

  _createClass$3(PhoneNumberInput_, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onCountryChange = this.props.onCountryChange;
      var defaultCountry = this.props.defaultCountry;
      var selectedCountry = this.state.country;

      if (onCountryChange) {
        if (defaultCountry) {
          if (!this.isCountrySupportedWithError(defaultCountry)) {
            defaultCountry = undefined;
          }
        }

        if (selectedCountry !== defaultCountry) {
          onCountryChange(selectedCountry);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onCountryChange = this.props.onCountryChange;
      var country = this.state.country; // Call `onCountryChange` when user selects another country.

      if (onCountryChange && country !== prevState.country) {
        onCountryChange(country);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          name = _this$props5.name,
          disabled = _this$props5.disabled,
          autoComplete = _this$props5.autoComplete,
          style = _this$props5.style,
          className = _this$props5.className;
          _this$props5.inputRef;
          var inputComponent = _this$props5.inputComponent,
          numberInputProps = _this$props5.numberInputProps,
          smartCaret = _this$props5.smartCaret,
          CountrySelectComponent = _this$props5.countrySelectComponent,
          countrySelectProps = _this$props5.countrySelectProps,
          ContainerComponent = _this$props5.containerComponent;
          _this$props5.defaultCountry;
          var countries = _this$props5.countries,
          countryOptionsOrder = _this$props5.countryOptionsOrder,
          labels = _this$props5.labels;
          _this$props5.flags;
          _this$props5.flagComponent;
          _this$props5.flagUrl;
          var addInternationalOption = _this$props5.addInternationalOption;
          _this$props5.internationalIcon;
          _this$props5.displayInitialValueAsLocalNumber;
          _this$props5.initialValueFormat;
          _this$props5.onCountryChange;
          _this$props5.limitMaxLength;
          var countryCallingCodeEditable = _this$props5.countryCallingCodeEditable;
          _this$props5.focusInputOnCountrySelection;
          _this$props5.reset;
          var metadata = _this$props5.metadata,
          international = _this$props5.international,
          locales = _this$props5.locales,
          rest = _objectWithoutProperties$4(_this$props5, ["name", "disabled", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"]);

      var _this$state3 = this.state,
          country = _this$state3.country,
          phoneDigits = _this$state3.phoneDigits,
          isFocused = _this$state3.isFocused;
      var InputComponent = smartCaret ? InputSmart : InputBasic;
      var countrySelectOptions = useMemoCountrySelectOptions(function () {
        return sortCountryOptions(getCountrySelectOptions({
          countries: countries || getCountries$1(metadata),
          countryNames: labels,
          addInternationalOption: international && countryCallingCodeEditable === false ? false : addInternationalOption,
          compareStringsLocales: locales // compareStrings

        }), getSupportedCountryOptions(countryOptionsOrder, metadata));
      }, [countries, countryOptionsOrder, addInternationalOption, labels, metadata]);
      return React__default.createElement(ContainerComponent, {
        style: style,
        className: classNames$1(className, 'PhoneInput', {
          'PhoneInput--focus': isFocused
        })
      }, React__default.createElement(CountrySelectComponent, _extends$5({
        name: name ? "".concat(name, "Country") : undefined,
        "aria-label": labels.country
      }, countrySelectProps, {
        value: country,
        options: countrySelectOptions,
        onChange: this.onCountryChange,
        onFocus: this.onCountryFocus,
        onBlur: this.onCountryBlur,
        disabled: disabled || countrySelectProps && countrySelectProps.disabled,
        iconComponent: this.CountryIcon
      })), React__default.createElement(InputComponent, _extends$5({
        ref: this.setInputRef,
        type: "tel",
        autoComplete: autoComplete
      }, numberInputProps, rest, {
        name: name,
        metadata: metadata,
        country: country,
        value: phoneDigits || '',
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        disabled: disabled,
        inputComponent: inputComponent,
        className: classNames$1('PhoneInputInput', numberInputProps && numberInputProps.className, rest.className)
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    // `state` holds previous props as `props`, and also:
    // * `country` — The currently selected country, e.g. `"RU"`.
    // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
    // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
    // (and a couple of other less significant properties)
    value: function getDerivedStateFromProps(props, state) {
      return _objectSpread$1({
        // Emulate `prevProps` via `state.props`.
        props: props
      }, getPhoneInputWithCountryStateUpdateFromNewProps(props, state.props, state));
    }
  }]);

  return PhoneNumberInput_;
}(React__default.PureComponent); // This wrapper is only to `.forwardRef()` to the `<input/>`.


var PhoneNumberInput = React__default.forwardRef(function (props, ref) {
  return React__default.createElement(PhoneNumberInput_, _extends$5({}, props, {
    inputRef: ref
  }));
});
PhoneNumberInput.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   */
  value: PropTypes.string,

  /**
   * Updates the `value` as the user inputs the phone number.
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * `onKeyDown` handler (e.g. to handle Enter key press).
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * Set to `true` to disable both the phone number `<input/>`
   * and the country `<select/>`.
   */
  disabled: PropTypes.bool,

  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: PropTypes.string.isRequired,

  /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `undefined` by default)
  initialValueFormat: PropTypes.oneOf(['national']),
  // `displayInitialValueAsLocalNumber` property has been
  // superceded by `initialValueFormat` property.
  displayInitialValueAsLocalNumber: PropTypes.bool,

  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: PropTypes.string,

  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: PropTypes.arrayOf(PropTypes.string),

  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels: labels$1.isRequired,

  /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */
  locales: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */

  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: PropTypes.string.isRequired,

  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: PropTypes.objectOf(PropTypes.elementType),

  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: PropTypes.elementType.isRequired,

  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: PropTypes.bool.isRequired,

  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: PropTypes.elementType.isRequired,

  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: PropTypes.arrayOf(PropTypes.string),

  /**
   * `<Phone/>` component CSS style object.
   */
  style: PropTypes.object,

  /**
   * `<Phone/>` component CSS class.
   */
  className: PropTypes.string,

  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: PropTypes.elementType.isRequired,

  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: PropTypes.object,

  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: PropTypes.elementType.isRequired,

  /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */
  containerComponent: PropTypes.elementType.isRequired,

  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: PropTypes.object,

  /**
   * By default, the caret position is being "intelligently" managed
   * while a user inputs a phone number.
   * This "smart" caret behavior can be turned off
   * by passing `smartCaret={false}` property.
   * This is just an "escape hatch" for any possible caret position issues.
   */
  // Is `true` by default.
  smartCaret: PropTypes.bool.isRequired,

  /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format.
   */
  international: PropTypes.bool,

  /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: PropTypes.bool.isRequired,

  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: PropTypes.bool.isRequired,

  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata: metadata.isRequired,

  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: PropTypes.func,

  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: PropTypes.bool.isRequired
};
PhoneNumberInput.defaultProps = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: 'tel',

  /**
   * Flag icon component.
   */
  flagComponent: FlagComponent,

  /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',

  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: InternationalIcon,

  /**
   * Phone number `<input/>` component.
   */
  inputComponent: 'input',

  /**
   * Wrapping `<div/>` component.
   */
  containerComponent: 'div',

  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: PropTypes.any,

  /**
   *
   */

  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: true,

  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: true,

  /**
   * If set to `true` the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: false,

  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: true,

  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: true
};
var countrySelectOptionsMemo;
var countrySelectOptionsMemoDependencies;

function useMemoCountrySelectOptions(generator, dependencies) {
  if (!countrySelectOptionsMemoDependencies || !areEqualArrays(dependencies, countrySelectOptionsMemoDependencies)) {
    countrySelectOptionsMemo = generator();
    countrySelectOptionsMemoDependencies = dependencies;
  }

  return countrySelectOptionsMemo;
}

function areEqualArrays(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  var i = 0;

  while (i < a.length) {
    if (a[i] !== b[i]) {
      return false;
    }

    i++;
  }

  return true;
}

var ext = "ext.";
var country = "Phone number country";
var phone = "Phone";
var AB = "Abkhazia";
var AC = "Ascension Island";
var AD = "Andorra";
var AE = "United Arab Emirates";
var AF = "Afghanistan";
var AG = "Antigua and Barbuda";
var AI = "Anguilla";
var AL = "Albania";
var AM = "Armenia";
var AO = "Angola";
var AQ = "Antarctica";
var AR = "Argentina";
var AS = "American Samoa";
var AT = "Austria";
var AU = "Australia";
var AW = "Aruba";
var AX = "Åland Islands";
var AZ = "Azerbaijan";
var BA = "Bosnia and Herzegovina";
var BB = "Barbados";
var BD = "Bangladesh";
var BE = "Belgium";
var BF = "Burkina Faso";
var BG = "Bulgaria";
var BH = "Bahrain";
var BI = "Burundi";
var BJ = "Benin";
var BL = "Saint Barthélemy";
var BM = "Bermuda";
var BN = "Brunei Darussalam";
var BO = "Bolivia";
var BQ = "Bonaire, Sint Eustatius and Saba";
var BR = "Brazil";
var BS = "Bahamas";
var BT = "Bhutan";
var BV = "Bouvet Island";
var BW = "Botswana";
var BY = "Belarus";
var BZ = "Belize";
var CA = "Canada";
var CC = "Cocos (Keeling) Islands";
var CD = "Congo, Democratic Republic of the";
var CF = "Central African Republic";
var CG = "Congo";
var CH = "Switzerland";
var CI = "Cote d'Ivoire";
var CK = "Cook Islands";
var CL = "Chile";
var CM = "Cameroon";
var CN = "China";
var CO = "Colombia";
var CR = "Costa Rica";
var CU = "Cuba";
var CV = "Cape Verde";
var CW = "Curaçao";
var CX = "Christmas Island";
var CY = "Cyprus";
var CZ = "Czech Republic";
var DE = "Germany";
var DJ = "Djibouti";
var DK = "Denmark";
var DM = "Dominica";
var DO = "Dominican Republic";
var DZ = "Algeria";
var EC = "Ecuador";
var EE = "Estonia";
var EG = "Egypt";
var EH = "Western Sahara";
var ER = "Eritrea";
var ES = "Spain";
var ET = "Ethiopia";
var FI = "Finland";
var FJ = "Fiji";
var FK = "Falkland Islands";
var FM = "Federated States of Micronesia";
var FO = "Faroe Islands";
var FR = "France";
var GA = "Gabon";
var GB = "United Kingdom";
var GD = "Grenada";
var GE = "Georgia";
var GF = "French Guiana";
var GG = "Guernsey";
var GH = "Ghana";
var GI = "Gibraltar";
var GL = "Greenland";
var GM = "Gambia";
var GN = "Guinea";
var GP = "Guadeloupe";
var GQ = "Equatorial Guinea";
var GR = "Greece";
var GS = "South Georgia and the South Sandwich Islands";
var GT = "Guatemala";
var GU = "Guam";
var GW = "Guinea-Bissau";
var GY = "Guyana";
var HK = "Hong Kong";
var HM = "Heard Island and McDonald Islands";
var HN = "Honduras";
var HR = "Croatia";
var HT = "Haiti";
var HU = "Hungary";
var ID = "Indonesia";
var IE = "Ireland";
var IL = "Israel";
var IM = "Isle of Man";
var IN = "India";
var IO = "British Indian Ocean Territory";
var IQ = "Iraq";
var IR = "Iran";
var IS = "Iceland";
var IT = "Italy";
var JE = "Jersey";
var JM = "Jamaica";
var JO = "Jordan";
var JP = "Japan";
var KE = "Kenya";
var KG = "Kyrgyzstan";
var KH = "Cambodia";
var KI = "Kiribati";
var KM = "Comoros";
var KN = "Saint Kitts and Nevis";
var KP = "North Korea";
var KR = "South Korea";
var KW = "Kuwait";
var KY = "Cayman Islands";
var KZ = "Kazakhstan";
var LA = "Laos";
var LB = "Lebanon";
var LC = "Saint Lucia";
var LI = "Liechtenstein";
var LK = "Sri Lanka";
var LR = "Liberia";
var LS = "Lesotho";
var LT = "Lithuania";
var LU = "Luxembourg";
var LV = "Latvia";
var LY = "Libya";
var MA = "Morocco";
var MC = "Monaco";
var MD = "Moldova";
var ME = "Montenegro";
var MF = "Saint Martin (French Part)";
var MG = "Madagascar";
var MH = "Marshall Islands";
var MK = "North Macedonia";
var ML = "Mali";
var MM = "Burma";
var MN = "Mongolia";
var MO = "Macao";
var MP = "Northern Mariana Islands";
var MQ = "Martinique";
var MR = "Mauritania";
var MS = "Montserrat";
var MT = "Malta";
var MU = "Mauritius";
var MV = "Maldives";
var MW = "Malawi";
var MX = "Mexico";
var MY = "Malaysia";
var MZ = "Mozambique";
var NA = "Namibia";
var NC = "New Caledonia";
var NE = "Niger";
var NF = "Norfolk Island";
var NG = "Nigeria";
var NI = "Nicaragua";
var NL = "Netherlands";
var NO = "Norway";
var NP = "Nepal";
var NR = "Nauru";
var NU = "Niue";
var NZ = "New Zealand";
var OM = "Oman";
var OS = "South Ossetia";
var PA = "Panama";
var PE = "Peru";
var PF = "French Polynesia";
var PG = "Papua New Guinea";
var PH = "Philippines";
var PK = "Pakistan";
var PL = "Poland";
var PM = "Saint Pierre and Miquelon";
var PN = "Pitcairn";
var PR = "Puerto Rico";
var PS = "Palestine";
var PT = "Portugal";
var PW = "Palau";
var PY = "Paraguay";
var QA = "Qatar";
var RE = "Reunion";
var RO = "Romania";
var RS = "Serbia";
var RU = "Russia";
var RW = "Rwanda";
var SA = "Saudi Arabia";
var SB = "Solomon Islands";
var SC = "Seychelles";
var SD = "Sudan";
var SE = "Sweden";
var SG = "Singapore";
var SH = "Saint Helena";
var SI = "Slovenia";
var SJ = "Svalbard and Jan Mayen";
var SK = "Slovakia";
var SL = "Sierra Leone";
var SM = "San Marino";
var SN = "Senegal";
var SO = "Somalia";
var SR = "Suriname";
var SS = "South Sudan";
var ST = "Sao Tome and Principe";
var SV = "El Salvador";
var SX = "Sint Maarten";
var SY = "Syria";
var SZ = "Swaziland";
var TA = "Tristan da Cunha";
var TC = "Turks and Caicos Islands";
var TD = "Chad";
var TF = "French Southern Territories";
var TG = "Togo";
var TH = "Thailand";
var TJ = "Tajikistan";
var TK = "Tokelau";
var TL = "Timor-Leste";
var TM = "Turkmenistan";
var TN = "Tunisia";
var TO = "Tonga";
var TR = "Turkey";
var TT = "Trinidad and Tobago";
var TV = "Tuvalu";
var TW = "Taiwan";
var TZ = "Tanzania";
var UA = "Ukraine";
var UG = "Uganda";
var UM = "United States Minor Outlying Islands";
var US = "United States";
var UY = "Uruguay";
var UZ = "Uzbekistan";
var VA = "Holy See (Vatican City State)";
var VC = "Saint Vincent and the Grenadines";
var VE = "Venezuela";
var VG = "Virgin Islands, British";
var VI = "Virgin Islands, U.S.";
var VN = "Vietnam";
var VU = "Vanuatu";
var WF = "Wallis and Futuna";
var WS = "Samoa";
var XK = "Kosovo";
var YE = "Yemen";
var YT = "Mayotte";
var ZA = "South Africa";
var ZM = "Zambia";
var ZW = "Zimbabwe";
var ZZ = "International";
var labels = {
	ext: ext,
	country: country,
	phone: phone,
	AB: AB,
	AC: AC,
	AD: AD,
	AE: AE,
	AF: AF,
	AG: AG,
	AI: AI,
	AL: AL,
	AM: AM,
	AO: AO,
	AQ: AQ,
	AR: AR,
	AS: AS,
	AT: AT,
	AU: AU,
	AW: AW,
	AX: AX,
	AZ: AZ,
	BA: BA,
	BB: BB,
	BD: BD,
	BE: BE,
	BF: BF,
	BG: BG,
	BH: BH,
	BI: BI,
	BJ: BJ,
	BL: BL,
	BM: BM,
	BN: BN,
	BO: BO,
	BQ: BQ,
	BR: BR,
	BS: BS,
	BT: BT,
	BV: BV,
	BW: BW,
	BY: BY,
	BZ: BZ,
	CA: CA,
	CC: CC,
	CD: CD,
	CF: CF,
	CG: CG,
	CH: CH,
	CI: CI,
	CK: CK,
	CL: CL,
	CM: CM,
	CN: CN,
	CO: CO,
	CR: CR,
	CU: CU,
	CV: CV,
	CW: CW,
	CX: CX,
	CY: CY,
	CZ: CZ,
	DE: DE,
	DJ: DJ,
	DK: DK,
	DM: DM,
	DO: DO,
	DZ: DZ,
	EC: EC,
	EE: EE,
	EG: EG,
	EH: EH,
	ER: ER,
	ES: ES,
	ET: ET,
	FI: FI,
	FJ: FJ,
	FK: FK,
	FM: FM,
	FO: FO,
	FR: FR,
	GA: GA,
	GB: GB,
	GD: GD,
	GE: GE,
	GF: GF,
	GG: GG,
	GH: GH,
	GI: GI,
	GL: GL,
	GM: GM,
	GN: GN,
	GP: GP,
	GQ: GQ,
	GR: GR,
	GS: GS,
	GT: GT,
	GU: GU,
	GW: GW,
	GY: GY,
	HK: HK,
	HM: HM,
	HN: HN,
	HR: HR,
	HT: HT,
	HU: HU,
	ID: ID,
	IE: IE,
	IL: IL,
	IM: IM,
	IN: IN,
	IO: IO,
	IQ: IQ,
	IR: IR,
	IS: IS,
	IT: IT,
	JE: JE,
	JM: JM,
	JO: JO,
	JP: JP,
	KE: KE,
	KG: KG,
	KH: KH,
	KI: KI,
	KM: KM,
	KN: KN,
	KP: KP,
	KR: KR,
	KW: KW,
	KY: KY,
	KZ: KZ,
	LA: LA,
	LB: LB,
	LC: LC,
	LI: LI,
	LK: LK,
	LR: LR,
	LS: LS,
	LT: LT,
	LU: LU,
	LV: LV,
	LY: LY,
	MA: MA,
	MC: MC,
	MD: MD,
	ME: ME,
	MF: MF,
	MG: MG,
	MH: MH,
	MK: MK,
	ML: ML,
	MM: MM,
	MN: MN,
	MO: MO,
	MP: MP,
	MQ: MQ,
	MR: MR,
	MS: MS,
	MT: MT,
	MU: MU,
	MV: MV,
	MW: MW,
	MX: MX,
	MY: MY,
	MZ: MZ,
	NA: NA,
	NC: NC,
	NE: NE,
	NF: NF,
	NG: NG,
	NI: NI,
	NL: NL,
	NO: NO,
	NP: NP,
	NR: NR,
	NU: NU,
	NZ: NZ,
	OM: OM,
	OS: OS,
	PA: PA,
	PE: PE,
	PF: PF,
	PG: PG,
	PH: PH,
	PK: PK,
	PL: PL,
	PM: PM,
	PN: PN,
	PR: PR,
	PS: PS,
	PT: PT,
	PW: PW,
	PY: PY,
	QA: QA,
	RE: RE,
	RO: RO,
	RS: RS,
	RU: RU,
	RW: RW,
	SA: SA,
	SB: SB,
	SC: SC,
	SD: SD,
	SE: SE,
	SG: SG,
	SH: SH,
	SI: SI,
	SJ: SJ,
	SK: SK,
	SL: SL,
	SM: SM,
	SN: SN,
	SO: SO,
	SR: SR,
	SS: SS,
	ST: ST,
	SV: SV,
	SX: SX,
	SY: SY,
	SZ: SZ,
	TA: TA,
	TC: TC,
	TD: TD,
	TF: TF,
	TG: TG,
	TH: TH,
	TJ: TJ,
	TK: TK,
	TL: TL,
	TM: TM,
	TN: TN,
	TO: TO,
	TR: TR,
	TT: TT,
	TV: TV,
	TW: TW,
	TZ: TZ,
	UA: UA,
	UG: UG,
	UM: UM,
	US: US,
	UY: UY,
	UZ: UZ,
	VA: VA,
	VC: VC,
	VE: VE,
	VG: VG,
	VI: VI,
	VN: VN,
	VU: VU,
	WF: WF,
	WS: WS,
	XK: XK,
	YE: YE,
	YT: YT,
	ZA: ZA,
	ZM: ZM,
	ZW: ZW,
	ZZ: ZZ
};

/**
 * Creates Unicode flag from a two-letter ISO country code.
 * https://stackoverflow.com/questions/24050671/how-to-put-japan-flag-character-in-a-string
 * @param  {string} country — A two-letter ISO country code (case-insensitive).
 * @return {string}
 */
function getCountryFlag(country) {
  return getRegionalIndicatorSymbol(country[0]) + getRegionalIndicatorSymbol(country[1]);
}
/**
 * Converts a letter to a Regional Indicator Symbol.
 * @param  {string} letter
 * @return {string}
 */

function getRegionalIndicatorSymbol(letter) {
  return String.fromCodePoint(0x1F1E6 - 65 + letter.toUpperCase().charCodeAt(0));
}

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function CountrySelect$1(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      rest = _objectWithoutProperties$3(_ref, ["value", "onChange", "options"]);

  var onChange_ = useCallback(function (event) {
    var value = event.target.value;
    onChange(value === 'ZZ' ? undefined : value);
  }, [onChange]);
  useMemo(function () {
    return getSelectedOption(options, value);
  }, [options, value]); // "ZZ" means "International".
  // (HTML requires each `<option/>` have some string `value`).

  return React__default.createElement("select", _extends$4({}, rest, {
    value: value || 'ZZ',
    onChange: onChange_
  }), options.map(function (_ref2) {
    var value = _ref2.value,
        label = _ref2.label,
        divider = _ref2.divider;
    return React__default.createElement("option", {
      key: divider ? '|' : value || 'ZZ',
      value: divider ? '|' : value || 'ZZ',
      disabled: divider ? true : false,
      style: divider ? DIVIDER_STYLE : undefined
    }, label);
  }));
}
CountrySelect$1.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: PropTypes.string,

  /**
   * Updates the `value`.
   */
  onChange: PropTypes.func.isRequired,
  // `<select/>` options.
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    divider: PropTypes.bool
  })).isRequired
};
var DIVIDER_STYLE = {
  fontSize: '1px',
  backgroundColor: 'currentColor',
  color: 'inherit'
};
function CountrySelectWithIcon(_ref3) {
  var value = _ref3.value,
      options = _ref3.options,
      className = _ref3.className,
      Icon = _ref3.iconComponent;
      _ref3.getIconAspectRatio;
      var Arrow = _ref3.arrowComponent,
      unicodeFlags = _ref3.unicodeFlags,
      rest = _objectWithoutProperties$3(_ref3, ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"]);

  var selectedOption = useMemo(function () {
    return getSelectedOption(options, value);
  }, [options, value]);
  return React__default.createElement("div", {
    className: "PhoneInputCountry"
  }, React__default.createElement(CountrySelect$1, _extends$4({}, rest, {
    value: value,
    options: options,
    className: classNames$1('PhoneInputCountrySelect', className)
  })), unicodeFlags && value && React__default.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, getCountryFlag(value)), !(unicodeFlags && value) && React__default.createElement(Icon, {
    country: value,
    label: selectedOption && selectedOption.label,
    aspectRatio: unicodeFlags ? 1 : undefined
  }), React__default.createElement(Arrow, null));
}
CountrySelectWithIcon.propTypes = {
  // Country flag component.
  iconComponent: PropTypes.elementType,
  // Select arrow component.
  arrowComponent: PropTypes.elementType.isRequired,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: PropTypes.bool
};
CountrySelectWithIcon.defaultProps = {
  // Is "International" icon square?
  arrowComponent: function arrowComponent() {
    return React__default.createElement("div", {
      className: "PhoneInputCountrySelectArrow"
    });
  }
};

function getSelectedOption(options, value) {
  for (var _iterator = options, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref4;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref4 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref4 = _i.value;
    }

    var option = _ref4;

    if (!option.divider && option.value === value) {
      return option;
    }
  }
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
function createPhoneInput(defaultMetadata) {
  var PhoneInputDefault = React__default.forwardRef(function (props, ref) {
    return React__default.createElement(PhoneNumberInput, _extends$3({
      ref: ref
    }, props));
  });
  PhoneInputDefault.propTypes = {
    metadata: metadata.isRequired,
    labels: labels$1.isRequired,
    countrySelectComponent: PropTypes.elementType.isRequired
  };
  PhoneInputDefault.defaultProps = {
    metadata: defaultMetadata,
    labels: labels,
    countrySelectComponent: CountrySelectWithIcon
  };
  return PhoneInputDefault;
}
createPhoneInput();

function call$1(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments);
	args.push(metadata$1);
	return func.apply(this, args)
}

createPhoneInput(metadata$1);

function parsePhoneNumber() {
	return call$1(parsePhoneNumberFromString, arguments)
}

function getCountryCallingCode$1() {
	return call$1(getCountryCallingCode$2, arguments)
}

var Globe = function Globe() {
  return /*#__PURE__*/React__default.createElement("svg", {
    width: "20px",
    height: "20px",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356.926 356.926",
    fill: "#8dabc4"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
    d: "M211.89,213.669c0-10.475-8.521-18.997-18.996-18.997c-0.401,0-0.799,0.017-1.193,0.041v2.406\r c0.396-0.028,0.79-0.061,1.193-0.061c9.158,0,16.608,7.452,16.608,16.611s-7.45,16.61-16.608,16.61\r c-0.269,0-0.53-0.027-0.795-0.041v0.897v1.509v4.723H186.2v3.182h13.388v-3.182h-5.104v-4.774\r C204.218,231.781,211.89,223.607,211.89,213.669z"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    points: "260.072,79.408 260.398,82.045 256.447,82.882 255.913,88.517 260.677,88.517 266.998,87.913 270.251,84.021\r 266.788,82.678 264.883,80.488 262.024,75.858 260.677,69.329 255.286,70.409 253.799,72.721 253.799,75.312 256.378,77.084\r "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    points: "255.495,81.569 255.773,78.037 252.637,76.683 248.233,77.706 244.945,82.94 244.945,86.344 248.768,86.344\r "
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M164.852,96.598l-0.976,2.498h-4.7v2.428h1.121c0,0,0.07,0.511,0.168,1.191l2.876-0.238l1.783-1.121l0.465-2.248\r l2.335-0.204l0.912-1.888l-2.138-0.442L164.852,96.598z"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    points: "152.739,101.001 152.565,103.366 155.976,103.081 156.324,100.705 154.279,99.096 \t\t\t"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M356.868,176.633c-0.047-5.223-0.313-10.398-0.802-15.505c-1.662-17.01-5.717-33.311-11.828-48.589\r c-0.441-1.127-0.859-2.283-1.336-3.41c-8.121-19.183-19.531-36.646-33.474-51.721c-0.906-0.987-1.835-1.952-2.765-2.916\r c-2.649-2.736-5.333-5.415-8.156-7.971C266.788,17.631,224.642,0,178.463,0C131.896,0,89.447,17.957,57.635,47.271\r c-7.413,6.832-14.221,14.303-20.408,22.285C13.919,99.717,0,137.49,0,178.463c0,98.398,80.059,178.463,178.463,178.463\r c69.225,0,129.316-39.643,158.897-97.399c6.32-12.327,11.247-25.491,14.569-39.294c0.837-3.486,1.58-7.018,2.208-10.585\r c1.801-10.137,2.788-20.56,2.788-31.196C356.902,177.859,356.868,177.249,356.868,176.633z M323.278,105.306l1.022-1.162\r c1.359,2.637,2.649,5.304,3.846,8.028l-1.708-0.07l-3.172,0.436v-7.233H323.278z M297.484,74.156l0.023-7.971\r c2.812,2.975,5.508,6.036,8.087,9.214l-3.207,4.781l-11.247-0.111l-0.696-2.341L297.484,74.156z M82.214,54.364v-0.302h3.567\r l0.325-1.226h5.838v2.55l-1.691,2.236h-8.052v-3.259H82.214z M87.925,62.323c0,0,3.578-0.61,3.892-0.61c0.296,0,0,3.573,0,3.573\r l-8.081,0.511l-1.534-1.847L87.925,62.323z M334.642,133.156h-13.06l-7.971-5.92l-8.365,0.808v5.112h-2.648l-2.848-2.033\r l-14.512-3.671v-9.4l-18.38,1.423l-5.705,3.062h-7.285l-3.59-0.36l-8.854,4.926v9.254l-18.097,13.065l1.5,5.583h3.677\r l-0.964,5.315l-2.58,0.953l-0.133,13.884l15.633,17.823h6.819l0.407-1.081h12.246l3.531-3.265h6.948l3.812,3.811l10.328,1.069\r l-1.359,13.757l11.503,20.28l-6.064,11.572l0.406,5.438l4.775,4.752v13.095l6.251,8.412v10.897h5.391\r c-30.046,36.913-75.823,60.534-127.026,60.534c-90.312,0-163.783-73.454-163.783-163.777c0-22.732,4.665-44.401,13.077-64.089\r v-5.106l5.855-7.11c2.033-3.846,4.212-7.582,6.542-11.235l0.25,2.974l-6.791,8.261c-2.108,3.985-4.084,8.052-5.855,12.217v9.312\r l6.791,3.276v12.955l6.535,11.136l5.316,0.808l0.68-3.817l-6.245-9.661l-1.237-9.388h3.677l1.557,9.673l9.051,13.193l-2.33,4.27\r l5.734,8.795l14.291,3.532v-2.306l5.711,0.808l-0.534,4.078l4.484,0.825l6.948,1.888l9.8,11.171l12.507,0.941l1.237,10.207\r l-8.58,5.984l-0.39,9.115l-1.237,5.588l12.386,15.5l0.947,5.32c0,0,4.49,1.209,5.048,1.209c0.535,0,10.062,7.227,10.062,7.227\r v28.024l3.393,0.964l-2.294,12.92l5.71,7.634l-1.068,12.827l7.563,13.269l9.696,8.47l9.731,0.197l0.952-3.148l-7.163-6.029\r l0.418-2.986l1.272-3.684l0.273-3.741l-4.839-0.14l-2.44-3.066l4.021-3.881l0.546-2.916l-4.496-1.29l0.261-2.719l6.402-0.976\r l9.73-4.672l3.265-6.006l10.196-13.06l-2.312-10.213l3.131-5.438l9.399,0.278l6.327-5.02l2.051-19.693l7.04-8.877l1.237-5.704\r l-6.39-2.045l-4.224-6.942l-14.419-0.145l-11.444-4.351l-0.534-8.162l-3.811-6.675l-10.335-0.145l-5.995-9.382l-5.298-2.585\r l-0.273,2.858l-9.672,0.569l-3.532-4.926l-10.079-2.045l-8.302,9.603l-13.065-2.23l-0.953-14.727l-9.527-1.632l3.805-7.221\r l-1.092-4.148l-12.531,8.371l-7.877-0.964l-2.817-6.158l1.737-6.355l4.339-8.005l9.998-5.072h19.322l-0.064,5.891l6.948,3.235\r l-0.558-10.062l5.007-5.037l10.103-6.64l0.703-4.659l10.068-10.486l10.707-5.937l-0.941-0.773l7.256-6.826l2.655,0.703\r l1.214,1.522l2.76-3.062l0.68-0.296l-3.021-0.43l-3.084-0.987v-2.963l1.632-1.33h3.579l1.655,0.726l1.418,2.858l1.737-0.267\r v-0.244l0.5,0.163l5.02-0.772l0.714-2.463l2.852,0.726v2.667l-2.666,1.818h0.018l0.377,2.928l9.115,2.794c0,0,0,0.035,0.023,0.11\r l2.079-0.18l0.146-3.939l-7.209-3.282l-0.396-1.894l5.972-2.033l0.273-5.722l-6.245-3.805l-0.412-9.667l-8.581,4.218h-3.143\r l0.837-7.355l-11.688-2.748l-4.816,3.654v11.119l-8.673,2.754l-3.486,7.244l-3.758,0.604v-9.277l-8.162-1.133l-4.096-2.667\r l-1.639-6.007l14.611-8.54l7.14-2.179l0.72,4.804l3.991-0.215l0.308-2.411l4.166-0.599l0.07-0.842l-1.784-0.738l-0.407-2.544\r l5.118-0.43l3.091-3.213l0.18-0.238l0.035,0.012l0.941-0.976l10.753-1.354l4.746,4.032l-12.467,6.64l15.871,3.747l2.045-5.31\r h6.948l2.44-4.625l-4.903-1.226v-5.856l-15.359-6.803l-10.62,1.226l-6.001,3.125l0.407,7.628l-6.257-0.953l-0.964-4.212\r l6.007-5.449l-10.898-0.535l-3.125,0.953l-1.359,3.677l4.084,0.686l-0.813,4.084l-6.936,0.406l-1.092,2.725L118.987,52.4\r c0,0-0.273-5.711-0.703-5.711c-0.389,0,7.901-0.145,7.901-0.145l5.995-5.85l-3.271-1.632l-4.339,4.223l-7.222-0.406l-4.403-6.019\r h-9.254L94.03,44.07h8.848l0.796,2.597l-2.307,2.172l9.807,0.279l1.487,3.532l-11.032-0.407l-0.546-2.725l-6.925-1.499\r l-3.689-2.033l-8.255,0.069c27.043-19.699,60.284-31.358,96.226-31.358c41.403,0,79.263,15.476,108.124,40.915l-1.929,3.474\r l-7.564,2.962l-3.194,3.462l0.743,4.02l3.893,0.546l2.358,5.867l6.704-2.713l1.127,7.86h-2.045l-5.519-0.819l-6.111,1.022\r l-5.926,8.377l-8.458,1.319l-1.221,7.25l3.579,0.842l-1.046,4.665l-8.412-1.69l-7.703,1.69l-1.639,4.293l1.325,9.01l4.531,2.115\r l7.61-0.046l5.123-0.465l1.58-4.078l8.018-10.422l5.264,1.081l5.193-4.7l0.976,3.678l12.78,8.621l-1.557,2.108l-5.763-0.308\r l2.23,3.137l3.556,0.79l4.159-1.737l-0.093-5.002l1.859-0.923l-1.487-1.575l-8.528-4.758l-2.254-6.314h7.099l2.243,2.248\r l6.134,5.257l0.244,6.367l6.332,6.733l2.348-9.231l4.392-2.394l0.802,7.552l4.287,4.7l8.54-0.139\r c1.661,4.247,3.148,8.563,4.427,12.978L334.642,133.156z M97.324,81.092l4.27-2.044l3.881,0.929l-1.324,5.211l-4.183,1.319\r L97.324,81.092z M120.073,93.35v3.37h-9.783l-3.689-1.028l0.918-2.341l4.7-1.94h6.437v1.94H120.073z M124.582,98.05v3.259\r l-2.463,1.58l-3.044,0.575c0,0,0-4.903,0-5.415H124.582z M121.822,96.72v-3.893l3.363,3.067L121.822,96.72z M123.355,104.568\r v3.178l-2.347,2.347h-5.211l0.813-3.573l2.463-0.215l0.5-1.226L123.355,104.568z M110.39,98.05h5.408l-6.948,9.696l-2.852-1.534\r l0.616-4.084L110.39,98.05z M132.529,103.464v3.166h-5.211l-1.417-2.062v-2.951h0.406L132.529,103.464z M127.748,99.096\r l1.475-1.557l2.498,1.557l-1.999,1.656L127.748,99.096z M337.291,141.428l0.511-0.61c0.232,0.93,0.441,1.859,0.662,2.789\r L337.291,141.428z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M27.734,109.268v5.106c1.771-4.177,3.747-8.231,5.855-12.223L27.734,109.268z"
  })))));
};

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$1(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Returns `[phoneDigits, setPhoneDigits]`.
 * "Phone digits" includes not only "digits" but also a `+` sign.
 */

function usePhoneDigits(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      country = _ref.country,
      defaultCountry = _ref.defaultCountry,
      international = _ref.international,
      withCountryCallingCode = _ref.withCountryCallingCode,
      useNationalFormatForDefaultCountryValue = _ref.useNationalFormatForDefaultCountryValue,
      metadata = _ref.metadata;
  var countryMismatchDetected = useRef();

  var onCountryMismatch = function onCountryMismatch(value, country, actualCountry) {
    console.error("[react-phone-number-input] Expected phone number ".concat(value, " to correspond to country ").concat(country, " but ").concat(actualCountry ? 'in reality it corresponds to country ' + actualCountry : 'it doesn\'t', "."));
    countryMismatchDetected.current = true;
  };

  var getInitialPhoneDigits = function getInitialPhoneDigits() {
    return getPhoneDigitsForValue(value, country, international, withCountryCallingCode, defaultCountry, useNationalFormatForDefaultCountryValue, metadata, onCountryMismatch);
  }; // This is only used to detect `country` property change.


  var _useState = useState(country),
      _useState2 = _slicedToArray$1(_useState, 2),
      prevCountry = _useState2[0],
      setPrevCountry = _useState2[1]; // This is only used to detect `defaultCountry` property change.


  var _useState3 = useState(defaultCountry),
      _useState4 = _slicedToArray$1(_useState3, 2),
      prevDefaultCountry = _useState4[0],
      setPrevDefaultCountry = _useState4[1]; // `phoneDigits` is the `value` passed to the `<input/>`.


  var _useState5 = useState(getInitialPhoneDigits()),
      _useState6 = _slicedToArray$1(_useState5, 2),
      phoneDigits = _useState6[0],
      setPhoneDigits = _useState6[1]; // This is only used to detect `value` property changes.


  var _useState7 = useState(value),
      _useState8 = _slicedToArray$1(_useState7, 2),
      valueForPhoneDigits = _useState8[0],
      setValueForPhoneDigits = _useState8[1]; // Rerender hack.


  var _useState9 = useState(),
      _useState10 = _slicedToArray$1(_useState9, 2);
      _useState10[0];
      var setRerenderTrigger = _useState10[1];

  var rerender = useCallback(function () {
    return setRerenderTrigger({});
  }, [setRerenderTrigger]); // If `value` property has been changed externally
  // then re-initialize the component.

  useEffect(function () {
    if (value !== valueForPhoneDigits) {
      setValueForPhoneDigits(value);
      setPhoneDigits(getInitialPhoneDigits());
    }
  }, [value]); // If the `country` has been changed then re-initialize the component.

  useEffect(function () {
    if (country !== prevCountry) {
      setPrevCountry(country);
      setPhoneDigits(getInitialPhoneDigits());
    }
  }, [country]); // If the `defaultCountry` has been changed then re-initialize the component.

  useEffect(function () {
    if (defaultCountry !== prevDefaultCountry) {
      setPrevDefaultCountry(defaultCountry);
      setPhoneDigits(getInitialPhoneDigits());
    }
  }, [defaultCountry]); // Update the `value` after `valueForPhoneDigits` has been updated.

  useEffect(function () {
    if (valueForPhoneDigits !== value) {
      onChange(valueForPhoneDigits);
    }
  }, [valueForPhoneDigits]);
  var onSetPhoneDigits = useCallback(function (phoneDigits) {
    var value;

    if (country) {
      if (international && withCountryCallingCode) {
        // The `<input/>` value must start with the country calling code.
        var prefix = getInternationalPhoneNumberPrefix(country, metadata);

        if (phoneDigits.indexOf(prefix) !== 0) {
          // If a user tabs into a phone number input field
          // that is `international` and `withCountryCallingCode`,
          // and then starts inputting local phone number digits,
          // the first digit would get "swallowed" if the fix below wasn't implemented.
          // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43
          if (phoneDigits && phoneDigits[0] !== '+') {
            phoneDigits = prefix + phoneDigits;
          } else {
            // // Reset phone digits if they don't start with the correct prefix.
            // // Undo the `<input/>` value change if it doesn't.
            if (countryMismatchDetected.current) ; else {
              // If it simply did `phoneDigits = prefix` here,
              // then it could have no effect when erasing phone number
              // via Backspace, because `phoneDigits` in `state` wouldn't change
              // as a result, because it was `prefix` and it became `prefix`,
              // so the component wouldn't rerender, and the user would be able
              // to erase the country calling code part, and that part is
              // assumed to be non-eraseable. That's why the component is
              // forcefully rerendered here.
              setPhoneDigits(prefix);
              setValueForPhoneDigits(undefined); // Force a re-render of the `<input/>` with previous `phoneDigits` value.

              return rerender();
            }
          }
        }
      } else {
        // Entering phone number either in "national" format
        // when `country` has been specified, or in "international" format
        // when `country` has been specified but `withCountryCallingCode` hasn't.
        // Therefore, `+` is not allowed.
        if (phoneDigits && phoneDigits[0] === '+') {
          // Remove the `+`.
          phoneDigits = phoneDigits.slice(1);
        }
      }
    } else if (!defaultCountry) {
      // Force a `+` in the beginning of a `value`
      // when no `country` and `defaultCountry` have been specified.
      if (phoneDigits && phoneDigits[0] !== '+') {
        // Prepend a `+`.
        phoneDigits = '+' + phoneDigits;
      }
    } // Convert `phoneDigits` to `value`.


    if (phoneDigits) {
      var asYouType = new AsYouType(country || defaultCountry, metadata);
      asYouType.input(country && international && !withCountryCallingCode ? "+".concat(getCountryCallingCode$2(country, metadata)).concat(phoneDigits) : phoneDigits);
      var phoneNumber = asYouType.getNumber(); // If it's a "possible" incomplete phone number.

      if (phoneNumber) {
        value = phoneNumber.number;
      }
    }

    setPhoneDigits(phoneDigits);
    setValueForPhoneDigits(value);
  }, [country, international, withCountryCallingCode, defaultCountry, metadata, setPhoneDigits, setValueForPhoneDigits, rerender, countryMismatchDetected]);
  return [phoneDigits, onSetPhoneDigits];
}
/**
 * Returns phone number input field value for a E.164 phone number `value`.
 * @param  {string} [value]
 * @param  {string} [country]
 * @param  {boolean} [international]
 * @param  {boolean} [withCountryCallingCode]
 * @param  {string} [defaultCountry]
 * @param  {boolean} [useNationalFormatForDefaultCountryValue]
 * @param  {object} metadata
 * @return {string}
 */

function getPhoneDigitsForValue(value, country, international, withCountryCallingCode, defaultCountry, useNationalFormatForDefaultCountryValue, metadata, onCountryMismatch) {
  if (country && international && withCountryCallingCode) {
    var prefix = getInternationalPhoneNumberPrefix(country, metadata);

    if (value) {
      if (value.indexOf(prefix) !== 0) {
        onCountryMismatch(value, country);
      }

      return value;
    }

    return prefix;
  }

  if (!value) {
    return '';
  }

  if (!country && !defaultCountry) {
    return value;
  }

  var asYouType = new AsYouType(undefined, metadata);
  asYouType.input(value);
  var phoneNumber = asYouType.getNumber();

  if (phoneNumber) {
    if (country) {
      if (phoneNumber.country && phoneNumber.country !== country) {
        onCountryMismatch(value, country, phoneNumber.country);
      } else if (phoneNumber.countryCallingCode !== getCountryCallingCode$2(country, metadata)) {
        onCountryMismatch(value, country);
      }

      if (international) {
        return phoneNumber.nationalNumber;
      }

      return parseDigits(phoneNumber.formatNational());
    } else {
      // `phoneNumber.countryCallingCode` is compared here  instead of
      // `phoneNumber.country`, because, for example, a person could have
      // previously input a phone number (in "national" format) that isn't
      // 100% valid for the `defaultCountry`, and if `phoneNumber.country`
      // was compared, then it wouldn't match, and such phone number
      // wouldn't be formatted as a "national" one, and instead would be
      // formatted as an "international" one, confusing the user.
      // Comparing `phoneNumber.countryCallingCode` works around such issues.
      //
      // Example: `defaultCountry="US"` and the `<input/>` is empty.
      // The user inputs: "222 333 4444", which gets formatted to "(222) 333-4444".
      // The user then clicks "Save", the page is refreshed, and the user sees
      // that the `<input/>` value is now "+1 222 333 4444" which confuses the user:
      // the user expected the `<input/>` value to be "(222) 333-4444", same as it
      // was when they've just typed it in. The cause of the issue is that "222 333 4444"
      // is not a valid national number for US, and `phoneNumber.country` is compared
      // instead of `phoneNumber.countryCallingCode`. After the `phoneNumber.country`
      // comparison is replaced with `phoneNumber.countryCallingCode` one, the issue
      // is no longer the case.
      //
      if (phoneNumber.countryCallingCode && phoneNumber.countryCallingCode === getCountryCallingCode$2(defaultCountry, metadata) && useNationalFormatForDefaultCountryValue) {
        return parseDigits(phoneNumber.formatNational());
      }

      return value;
    }
  } else {
    return '';
  }
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createInput(defaultMetadata) {
  function PhoneInput(_ref, ref) {
    var country = _ref.country,
        defaultCountry = _ref.defaultCountry,
        useNationalFormatForDefaultCountryValue = _ref.useNationalFormatForDefaultCountryValue,
        value = _ref.value,
        onChange = _ref.onChange,
        metadata = _ref.metadata,
        smartCaret = _ref.smartCaret,
        international = _ref.international,
        withCountryCallingCode = _ref.withCountryCallingCode,
        rest = _objectWithoutProperties$2(_ref, ["country", "defaultCountry", "useNationalFormatForDefaultCountryValue", "value", "onChange", "metadata", "smartCaret", "international", "withCountryCallingCode"]);

    // "Phone digits" includes not only "digits" but also a `+` sign.
    var _usePhoneDigits = usePhoneDigits({
      value: value,
      onChange: onChange,
      country: country,
      defaultCountry: defaultCountry,
      international: international,
      withCountryCallingCode: withCountryCallingCode,
      useNationalFormatForDefaultCountryValue: useNationalFormatForDefaultCountryValue,
      metadata: metadata
    }),
        _usePhoneDigits2 = _slicedToArray(_usePhoneDigits, 2),
        phoneDigits = _usePhoneDigits2[0],
        setPhoneDigits = _usePhoneDigits2[1];

    var InputComponent = smartCaret ? InputSmart : InputBasic;
    return React__default.createElement(InputComponent, _extends$2({}, rest, {
      ref: ref,
      metadata: metadata,
      international: international,
      withCountryCallingCode: withCountryCallingCode,
      country: country || defaultCountry,
      value: phoneDigits,
      onChange: setPhoneDigits
    }));
  }

  PhoneInput = React__default.forwardRef(PhoneInput);
  PhoneInput.propTypes = {
    /**
     * HTML `<input/>` `type` attribute.
     */
    type: PropTypes.string,

    /**
     * HTML `<input/>` `autocomplete` attribute.
     */
    autoComplete: PropTypes.string,

    /**
     * The phone number (in E.164 format).
     * Examples: `undefined`, `"+12"`, `"+12133734253"`.
     */
    value: PropTypes.string,

    /**
     * Updates the `value`.
     */
    onChange: PropTypes.func.isRequired,

    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (example: `(213) 373-4253`),
     * or as an international phone number without "country calling code"
     * if `international` property is passed (example: `213 373 4253`).
     * Example: "US".
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (example: `+1 213 373 4253`)
     */
    country: PropTypes.string,

    /**
     * A two-letter country code for formatting `value`
     * when a user inputs a national phone number (example: `(213) 373-4253`).
     * The user can still input a phone number in international format.
     * Example: "US".
     * `country` and `defaultCountry` properties are mutually exclusive.
     */
    defaultCountry: PropTypes.string,

    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: PropTypes.bool,

    /**
     * If `country` and `international` properties are set,
     * then by default it won't include "country calling code" in the input field.
     * To change that, pass `withCountryCallingCode` property,
     * and it will include "country calling code" in the input field.
     */
    withCountryCallingCode: PropTypes.bool,

    /**
     * The `<input/>` component.
     */
    inputComponent: PropTypes.elementType,

    /**
     * By default, the caret position is being "intelligently" managed
     * while a user inputs a phone number.
     * This "smart" caret behavior can be turned off
     * by passing `smartCaret={false}` property.
     * This is just an "escape hatch" for any possible caret position issues.
     */
    // Is `true` by default.
    smartCaret: PropTypes.bool.isRequired,

    /**
     * When `defaultCountry` is defined and the initial `value` corresponds to `defaultCountry`,
     * then the `value` will be formatted as a national phone number by default.
     * To format the initial `value` of `defaultCountry` as an international number instead
     * set `useNationalFormatForDefaultCountryValue` property to `true`.
     */
    useNationalFormatForDefaultCountryValue: PropTypes.bool.isRequired,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes.object.isRequired
  };
  PhoneInput.defaultProps = {
    /**
     * HTML `<input/>` `type="tel"`.
     */
    type: 'tel',

    /**
     * Remember (and autofill) the value as a phone number.
     */
    autoComplete: 'tel',

    /**
     * Set to `false` to use "basic" caret instead of the "smart" one.
     */
    smartCaret: true,

    /**
     * Set to `true` to force international phone number format
     * (without "country calling code") when `country` is specified.
     */
    // international: false,

    /**
     * Prefer national format when formatting E.164 phone number `value`
     * corresponding to `defaultCountry`.
     */
    useNationalFormatForDefaultCountryValue: true,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: defaultMetadata
  };
  return PhoneInput;
}
createInput();

function call(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments);
	args.push(metadata$1);
	return func.apply(this, args)
}

var PhoneInput$1 = createInput(metadata$1);

function getCountries() {
	return call(getCountries$1, arguments)
}

function getCountryCallingCode() {
	return call(getCountryCallingCode$2, arguments)
}

var _templateObject$h, _templateObject2$d, _templateObject3$8;
var StyledPhoneInput = styled(PhoneInput$1)(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral$1(["\n\t", ";\n"])), FormControlStyled);
var CountrySelectWrapper = styled.div(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral$1(["\n\tdisplay: flex;\n\talign-content: 'center';\n"])));
var StyledCountryOption = styled.div(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral$1(["\n\ttext-align: left;\n\tpadding: 5px 20px;\n\tcursor: pointer;\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.menuItemBackgroundHover;
});

var CountrySelect = function CountrySelect(props) {
  var country = props.country,
      rest = _objectWithoutProperties$c(props, ["country"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray$8(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var handleClick = function handleClick(country) {
    if (!props.disabled) {
      setOpen(false);
      props.onChange(country);
    }
  };

  var selected = country;
  return /*#__PURE__*/React__default.createElement(CountrySelectWrapper, null, /*#__PURE__*/React__default.createElement("div", {
    className: "react-phone-number-input__icon"
  }, !selected || selected === 'ZZ' || selected === 'MO' || selected === 'HK' || selected === 'TW' ? /*#__PURE__*/React__default.createElement(Globe, null) : /*#__PURE__*/React__default.createElement(FlagComp, {
    alt: selected,
    width: "22",
    height: "20",
    code: selected
  })), isOpen && !props.disabled ? /*#__PURE__*/React__default.createElement(OutsideClickHandler, {
    onOutsideClick: function onOutsideClick() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React__default.createElement(DropMenuPanel, _extends$g({}, rest, {
    maxHeight: "200px"
  }), getCountries().map(function (c) {
    return /*#__PURE__*/React__default.createElement(StyledCountryOption, _extends$g({}, rest, {
      key: c,
      val: c,
      onClick: function onClick() {
        return handleClick(c);
      }
    }), en[c], " + ", getCountryCallingCode(c));
  }))) : undefined, /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    icon: "caret-down",
    onClick: function onClick() {
      return setOpen(true);
    },
    size: 18
  }));
};

CountrySelect.defaultProps = {};
var Wrapper$t = withTheme(CountrySelect);

var PhoneInput = function PhoneInput(props) {
  var randomID = RandomID(6);

  props.label;
      var value = props.value,
      name = props.name,
      id = props.id,
      defaultCountry = props.defaultCountry,
      country = props.country,
      error = props.error;
      props.hint;
      props.required;
      var validationState = props.validationState;
      props.tooltip;
      var disabled = props.disabled;
      props.tooltipDelay;
      var onChange = props.onChange,
      parsePhone = props.parsePhone,
      rest = _objectWithoutProperties$c(props, ["label", "value", "name", "id", "defaultCountry", "country", "error", "hint", "required", "validationState", "tooltip", "disabled", "tooltipDelay", "onChange", "parsePhone"]);
  /** Parses the phone and returns the country */


  var parseCountry = function parseCountry(phone) {
    phone = "".concat(phone);
    var phoneObject = parsePhoneNumber("".concat(phone.charAt(0) !== '+' ? '+' : '').concat(phone));
    if (phoneObject) return phoneObject.country;
    return null;
  };

  var _useState = useState(parseCountry(value) || country || defaultCountry),
      _useState2 = _slicedToArray$8(_useState, 2),
      selectedCountry = _useState2[0],
      setSelectedCountry = _useState2[1];

  var handleCountrySelect = function handleCountrySelect(country) {
    setSelectedCountry(country);
    onChange("+".concat(getCountryCallingCode$1(country)));
  };

  var handlePhoneNumber = function handlePhoneNumber(v) {
    if (v) {
      var _country = parseCountry("".concat(v));

      setSelectedCountry(_country);
      var returnedPhone = v;

      if (v && parsePhone && parsePhoneNumber(v)) {
        var parsed = parsePhoneNumber(v);
        delete parsed.metadata;
        returnedPhone = parsed;
      }

      onChange(returnedPhone);
    }
  };

  var getValue = function getValue() {
    return _typeof$e(value) === 'object' ? value.number : value;
  };
  /**
   * Figure out an id to pass to the form label and aria-labelledby to the child input element
   */


  var componentId = name || id || randomID;
  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, _extends$g({}, props, {
    id: componentId
  }), /*#__PURE__*/React__default.createElement(InputGroup, null, /*#__PURE__*/React__default.createElement(InputPrepend, rest, /*#__PURE__*/React__default.createElement(Wrapper$t, _extends$g({}, rest, {
    country: selectedCountry,
    onChange: handleCountrySelect,
    disabled: disabled
  }))), /*#__PURE__*/React__default.createElement(StyledPhoneInput, _extends$g({}, rest, {
    "aria-labelledby": componentId,
    "aria-required": props.required ? 'true' : 'false',
    prefix: true,
    error: error || validationState === 'danger',
    isValid: validationState === 'success',
    "aria-invalid": error || validationState === 'danger' ? 'true' : 'false',
    value: getValue(),
    onChange: handlePhoneNumber,
    type: 'phone',
    disabled: disabled
  }))));
};

PhoneInput.propTypes = {
  /** Phone value containing Country, CountryCode and Phone */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Default selected country */
  defaultCountry: PropTypes.string,

  /** Selected country */
  country: PropTypes.string,

  /** fires when the the value of the field changes */
  onChange: PropTypes.func,

  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Returns the complete phone object including country and country Code */
  parsePhone: PropTypes.bool,

  /** Displays a small hint under the field */
  hint: PropTypes.string,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
PhoneInput.defaultProps = {
  value: '',
  defaultCountry: 'US',
  parsePhone: false
};
var Wrapper$s = compose$1(withTheme, withTransformers)(PhoneInput);

var _templateObject$g;
var StyledMaskedInput = styled(MaskedInput)(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral$1(["\n\t", ";\n"])), FormControlStyled);

var PriceInput = function PriceInput(props) {
  var randomID = RandomID(6);

  var name = props.name,
      id = props.id,
      includeThousandsSeparator = props.includeThousandsSeparator,
      thousandsSeparatorSymbol = props.thousandsSeparatorSymbol,
      allowDecimal = props.allowDecimal,
      decimalSymbol = props.decimalSymbol,
      decimalLimit = props.decimalLimit,
      integerLimit = props.integerLimit,
      allowNegative = props.allowNegative,
      allowLeadingZeroes = props.allowLeadingZeroes,
      currencyPrefix = props.currencyPrefix,
      currencySuffix = props.currencySuffix,
      includeCurrencyInText = props.includeCurrencyInText,
      onChange = props.onChange;
      props.onValueChange;
      var returnFormatted = props.returnFormatted,
      initialFocused = props.initialFocused,
      focused = props.focused,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      theme = props.theme,
      rest = _objectWithoutProperties$c(props, ["name", "id", "includeThousandsSeparator", "thousandsSeparatorSymbol", "allowDecimal", "decimalSymbol", "decimalLimit", "integerLimit", "allowNegative", "allowLeadingZeroes", "currencyPrefix", "currencySuffix", "includeCurrencyInText", "onChange", "onValueChange", "returnFormatted", "initialFocused", "focused", "onFocus", "onBlur", "theme"]);

  var _useState = useState(props.value || ''),
      _useState2 = _slicedToArray$8(_useState, 2),
      price = _useState2[0],
      setPrice = _useState2[1];

  var _useFocus = useFocus(initialFocused),
      _useFocus2 = _slicedToArray$8(_useFocus, 2),
      setFocus = _useFocus2[0],
      focusProps = _useFocus2[1];

  useEffect(function () {
    setFocus(focused);
  }, [focused]);
  useEffect(function () {
    var value = props.value;

    if (value !== undefined && Number(value) !== Number(price)) {
      setPrice("".concat(props.value));
    }
  }, [props.value]);
  useEffect(function () {
    // announce change
    if (price !== undefined && price !== '' && !isNaN(price)) {
      if (!returnFormatted) {
        var regex = new RegExp(thousandsSeparatorSymbol, 'g');
        var cleaned = "".concat(price).replace(regex, '');
        onChange(Number(cleaned));
      } else {
        onChange(price);
      }
    }
  }, [price]);
  var maskOptions = {
    prefix: includeCurrencyInText ? currencyPrefix : '',
    suffix: includeCurrencyInText ? currencySuffix : '',
    includeThousandsSeparator: includeThousandsSeparator,
    thousandsSeparatorSymbol: thousandsSeparatorSymbol,
    allowDecimal: allowDecimal,
    decimalSymbol: decimalSymbol,
    decimalLimit: decimalLimit,
    integerLimit: integerLimit,
    allowNegative: allowNegative,
    allowLeadingZeroes: allowLeadingZeroes
  };
  var priceMask = createNumberMask(maskOptions);

  var handleChange = function handleChange(e) {
    setPrice(e.target.value);
  };
  /**
   * Sets the focused value to true ir order add proper class to parent
   * @param  {event} event input event
   */


  var handleFocus = function handleFocus(event) {
    event.stopPropagation();
    onFocus(event.target.value);
  };
  /**
   * Sets the focused value to false
   * @param  {event} event input event
   */


  var handleBlur = function handleBlur(event) {
    event.stopPropagation();
    onBlur(event.target.value);
  };

  var CompWrapper = currencyPrefix || currencySuffix ? InputGroup : React__default.Fragment;
  /**
   * Figure out an id to pass to the form label and aria-labelledby to the child input element
   */

  var componentId = name || id || randomID;
  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, _extends$g({}, rest, {
    theme: theme,
    id: componentId
  }), /*#__PURE__*/React__default.createElement(CompWrapper, null, currencyPrefix && !includeCurrencyInText ? /*#__PURE__*/React__default.createElement(InputPrepend, {
    theme: theme,
    error: rest.error,
    disabled: rest.disabled
  }, currencyPrefix) : null, /*#__PURE__*/React__default.createElement(StyledMaskedInput, _extends$g({}, rest, focusProps, {
    id: name,
    value: price,
    "aria-labelledby": componentId,
    "aria-required": props.required ? 'true' : undefined,
    "aria-invalid": props.error || props.validationState === 'danger' ? 'true' : 'false',
    theme: theme,
    mask: priceMask,
    onChange: handleChange,
    prefix: currencyPrefix,
    suffix: currencySuffix,
    onFocus: handleFocus,
    onBlur: handleBlur
  })), currencySuffix && !includeCurrencyInText ? /*#__PURE__*/React__default.createElement(InputAppend, {
    theme: theme,
    error: rest.error,
    disabled: rest.disabled
  }, currencySuffix) : null));
};

PriceInput.propTypes = {
  /** Value to show when component renders */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** fires when the the value of the field changes */
  onChange: PropTypes.func,

  /** fires when the focus has left the field */
  onBlur: PropTypes.func,

  /** fires when field is in focus */
  onFocus: PropTypes.func,

  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** adds a red star to the label if set to true and no value exists */
  required: PropTypes.bool,

  /** Adds a tooltip to the label */
  tooltip: PropTypes.string,

  /** Delays in seconds for showing to the tooltip on mouseenter */
  tooltipDelay: PropTypes.number,

  /** Currency symbol code as prefix */
  currencyPrefix: PropTypes.string,

  /** Currency symbol code as suffix */
  currencySuffix: PropTypes.string,

  /** if true, the currency will be integrated with the number */
  includeCurrencyInText: PropTypes.bool,

  /** Thousands separator symbol */
  thousandsSeparatorSymbol: PropTypes.string,

  /** Controls whether to show thousands separator */
  includeThousandsSeparator: PropTypes.bool,

  /** Decimal separator symbol */
  decimalSymbol: PropTypes.string,

  /** Controls whether to show decimals */
  allowDecimal: PropTypes.bool,

  /** Number of decimals to show */
  decimalLimit: PropTypes.number,

  /** Max number of digits */
  integerLimit: PropTypes.number,

  /** Allow negative prices */
  allowNegative: PropTypes.bool,

  /** Allow negative prices */
  allowLeadingZeroes: PropTypes.bool,

  /** Whether to return the formatted price or interger only */
  returnFormatted: PropTypes.bool,

  /** Initialized and focused immediately */
  initialFocused: PropTypes.bool,

  /** Pass true to force focus to this field */
  focused: PropTypes.bool,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
PriceInput.defaultProps = {
  currencyPrefix: '',
  currencySuffix: '',
  includeCurrencyInText: false,
  thousandsSeparatorSymbol: ',',
  includeThousandsSeparator: true,
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 2,
  integerLimit: 10,
  allowNegative: false,
  allowLeadingZeroes: false,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {}
};
var Wrapper$r = compose$1(withTheme, withTransformers)(PriceInput);

var _templateObject$f, _templateObject2$c, _templateObject3$7, _templateObject4$6;

var getBackgroundColor = function getBackgroundColor(_ref) {
  var color = _ref.color,
      theme = _ref.theme,
      variation = _ref.variation;
  return color || theme[variation] || theme.primary;
};

var CompWrapper$2 = styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral$1(["\n\twidth: 100%;\n\theight: ", "px;\n\tposition: relative;\n\tmargin: 10px 0px;\n\tfont-family: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.progressBarHeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily;
});
var Track$1 = styled.div(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral$1(["\n\twidth: 100%;\n\theight: 100%;\n\tbackground: ", ";\n\tborder-radius: ", ";\n\toverflow: hidden;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.progressBarTrackColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.progressBarBorderRadius;
});
var Bar = styled.div(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral$1(["\n\tbackground: ", ";\n\twidth: ", "%;\n\theight: 100%;\n\ttransition: width 0.5s ease-in;\n\tbox-shadow: 0 0 5px 0px #777;\n"])), getBackgroundColor, function (_ref6) {
  var progress = _ref6.progress;
  return progress * 100 / 100;
});
var Label$3 = styled.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\tz-index: 1;\n\ttop: 50%;\n\tleft: ", "%;\n\ttransform: translateY(-50%);\n\tmargin-left: -40px;\n\tfont-size: 16px;\n\ttransition: all 0.5s ease-in;\n\tcolor: #fff;\n"])), function (_ref7) {
  var progress = _ref7.progress;
  return progress * 100 / 100;
});

function ProgressBar(props) {
  var theme = props.theme,
      progress = props.progress,
      variation = props.variation,
      showLabel = props.showLabel,
      color = props.color;
  return /*#__PURE__*/React__default.createElement(CompWrapper$2, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(Track$1, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(Bar, {
    theme: theme,
    variation: variation,
    progress: progress,
    color: color
  }), showLabel ? /*#__PURE__*/React__default.createElement(Label$3, {
    theme: theme,
    progress: progress
  }, progress, "%") : undefined));
}

ProgressBar.propTypes = {
  /** Progress percentage value 0-100 */
  progress: PropTypes.number,

  /** Defined the color of the bar 'primary', 'secondary', 'success', 'warning', 'danger','info', 'dark' */
  variation: PropTypes.oneOf(objectValues(variations)),

  /** Controls whether the percentage is shown or not */
  showLabel: PropTypes.bool,

  /** Specific color overriding the variation */
  color: PropTypes.string
};
ProgressBar.defaultProps = {
  progress: 0,
  variation: 'primary',
  showLabel: true
};
var Wrapper$q = withTheme(ProgressBar);

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$2(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$2(self); }

function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf$2(object); if (object === null) break; } return object; }

function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$2(subClass, superClass); }

function _setPrototypeOf$2(o, p) { _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$2(o, p); }

var enhancer = function enhancer(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_WrappedComponent) {
      _inherits$2(Progress, _WrappedComponent);

      function Progress() {
        _classCallCheck$2(this, Progress);

        return _possibleConstructorReturn$2(this, _getPrototypeOf$2(Progress).apply(this, arguments));
      }

      _createClass$2(Progress, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          var _this = this;

          var now = Date.now();
          var updated = false;
          Object.keys(this.paths).forEach(function (key) {
            var path = _this.paths[key];

            if (!path) {
              return;
            }

            updated = true;
            var pathStyle = path.style;
            pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';

            if (_this.prevTimeStamp && now - _this.prevTimeStamp < 100) {
              pathStyle.transitionDuration = '0s, 0s';
            }
          });

          if (updated) {
            this.prevTimeStamp = Date.now();
          }
        }
      }, {
        key: "render",
        value: function render() {
          return _get(_getPrototypeOf$2(Progress.prototype), "render", this).call(this);
        }
      }]);

      return Progress;
    }(WrappedComponent)
  );
};

var defaultProps = {
  className: '',
  percent: 0,
  prefixCls: 'rc-progress',
  strokeColor: '#2db7f5',
  strokeLinecap: 'round',
  strokeWidth: 1,
  style: {},
  trailColor: '#D9D9D9',
  trailWidth: 1
};
var mixedType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
var propTypes = {
  className: PropTypes.string,
  percent: PropTypes.oneOfType([mixedType, PropTypes.arrayOf(mixedType)]),
  prefixCls: PropTypes.string,
  strokeColor: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])), PropTypes.object]),
  strokeLinecap: PropTypes.oneOf(['butt', 'round', 'square']),
  strokeWidth: mixedType,
  style: PropTypes.object,
  trailColor: PropTypes.string,
  trailWidth: mixedType
};

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn$1(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$1(self); }

function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }

function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$1(subClass, superClass); }

function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Line =
/*#__PURE__*/
function (_Component) {
  _inherits$1(Line, _Component);

  function Line() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck$1(this, Line);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn$1(this, (_getPrototypeOf2 = _getPrototypeOf$1(Line)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty$1(_assertThisInitialized$1(_this), "paths", {});

    return _this;
  }

  _createClass$1(Line, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          percent = _this$props.percent,
          prefixCls = _this$props.prefixCls,
          strokeColor = _this$props.strokeColor,
          strokeLinecap = _this$props.strokeLinecap,
          strokeWidth = _this$props.strokeWidth,
          style = _this$props.style,
          trailColor = _this$props.trailColor,
          trailWidth = _this$props.trailWidth,
          transition = _this$props.transition,
          restProps = _objectWithoutProperties$1(_this$props, ["className", "percent", "prefixCls", "strokeColor", "strokeLinecap", "strokeWidth", "style", "trailColor", "trailWidth", "transition"]);

      delete restProps.gapPosition;
      var percentList = Array.isArray(percent) ? percent : [percent];
      var strokeColorList = Array.isArray(strokeColor) ? strokeColor : [strokeColor];
      var center = strokeWidth / 2;
      var right = 100 - strokeWidth / 2;
      var pathString = "M ".concat(strokeLinecap === 'round' ? center : 0, ",").concat(center, "\n           L ").concat(strokeLinecap === 'round' ? right : 100, ",").concat(center);
      var viewBoxString = "0 0 100 ".concat(strokeWidth);
      var stackPtg = 0;
      return React__default.createElement("svg", _extends$1({
        className: "".concat(prefixCls, "-line ").concat(className),
        viewBox: viewBoxString,
        preserveAspectRatio: "none",
        style: style
      }, restProps), React__default.createElement("path", {
        className: "".concat(prefixCls, "-line-trail"),
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: trailColor,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: "0"
      }), percentList.map(function (ptg, index) {
        var pathStyle = {
          strokeDasharray: "".concat(ptg, "px, 100px"),
          strokeDashoffset: "-".concat(stackPtg, "px"),
          transition: transition || 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear'
        };
        var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        stackPtg += ptg;
        return React__default.createElement("path", {
          key: index,
          className: "".concat(prefixCls, "-line-path"),
          d: pathString,
          strokeLinecap: strokeLinecap,
          stroke: color,
          strokeWidth: strokeWidth,
          fillOpacity: "0",
          ref: function ref(path) {
            _this2.paths[index] = path;
          },
          style: pathStyle
        });
      }));
    }
  }]);

  return Line;
}(Component);

Line.propTypes = propTypes;
Line.defaultProps = defaultProps;
var Line$1 = enhancer(Line);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var gradientSeed = 0;

function stripPercentToNumber(percent) {
  return +percent.replace('%', '');
}

function toArray(symArray) {
  return Array.isArray(symArray) ? symArray : [symArray];
}

function getPathStyles(offset, percent, strokeColor, strokeWidth) {
  var gapDegree = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var gapPosition = arguments.length > 5 ? arguments[5] : undefined;
  var radius = 50 - strokeWidth / 2;
  var beginPositionX = 0;
  var beginPositionY = -radius;
  var endPositionX = 0;
  var endPositionY = -2 * radius;

  switch (gapPosition) {
    case 'left':
      beginPositionX = -radius;
      beginPositionY = 0;
      endPositionX = 2 * radius;
      endPositionY = 0;
      break;

    case 'right':
      beginPositionX = radius;
      beginPositionY = 0;
      endPositionX = -2 * radius;
      endPositionY = 0;
      break;

    case 'bottom':
      beginPositionY = radius;
      endPositionY = 2 * radius;
      break;
  }

  var pathString = "M 50,50 m ".concat(beginPositionX, ",").concat(beginPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(endPositionX, ",").concat(-endPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(-endPositionX, ",").concat(endPositionY);
  var len = Math.PI * 2 * radius;
  var pathStyle = {
    stroke: strokeColor,
    strokeDasharray: "".concat(percent / 100 * (len - gapDegree), "px ").concat(len, "px"),
    strokeDashoffset: "-".concat(gapDegree / 2 + offset / 100 * (len - gapDegree), "px"),
    transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s' // eslint-disable-line

  };
  return {
    pathString: pathString,
    pathStyle: pathStyle
  };
}

var Circle =
/*#__PURE__*/
function (_Component) {
  _inherits(Circle, _Component);

  function Circle() {
    var _this;

    _classCallCheck(this, Circle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Circle).call(this));

    _defineProperty(_assertThisInitialized(_this), "paths", {});

    _defineProperty(_assertThisInitialized(_this), "gradientId", 0);

    _this.gradientId = gradientSeed;
    gradientSeed += 1;
    return _this;
  }

  _createClass(Circle, [{
    key: "getStokeList",
    value: function getStokeList() {
      var _this2 = this;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          percent = _this$props.percent,
          strokeColor = _this$props.strokeColor,
          strokeWidth = _this$props.strokeWidth,
          strokeLinecap = _this$props.strokeLinecap,
          gapDegree = _this$props.gapDegree,
          gapPosition = _this$props.gapPosition;
      var percentList = toArray(percent);
      var strokeColorList = toArray(strokeColor);
      var stackPtg = 0;
      return percentList.map(function (ptg, index) {
        var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        var stroke = Object.prototype.toString.call(color) === '[object Object]' ? "url(#".concat(prefixCls, "-gradient-").concat(_this2.gradientId, ")") : '';

        var _getPathStyles = getPathStyles(stackPtg, ptg, color, strokeWidth, gapDegree, gapPosition),
            pathString = _getPathStyles.pathString,
            pathStyle = _getPathStyles.pathStyle;

        stackPtg += ptg;
        return React__default.createElement("path", {
          key: index,
          className: "".concat(prefixCls, "-circle-path"),
          d: pathString,
          stroke: stroke,
          strokeLinecap: strokeLinecap,
          strokeWidth: ptg === 0 ? 0 : strokeWidth,
          fillOpacity: "0",
          style: pathStyle,
          ref: function ref(path) {
            _this2.paths[index] = path;
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          strokeWidth = _this$props2.strokeWidth,
          trailWidth = _this$props2.trailWidth,
          gapDegree = _this$props2.gapDegree,
          gapPosition = _this$props2.gapPosition,
          trailColor = _this$props2.trailColor,
          strokeLinecap = _this$props2.strokeLinecap,
          style = _this$props2.style,
          className = _this$props2.className,
          strokeColor = _this$props2.strokeColor,
          restProps = _objectWithoutProperties(_this$props2, ["prefixCls", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor"]);

      var _getPathStyles2 = getPathStyles(0, 100, trailColor, strokeWidth, gapDegree, gapPosition),
          pathString = _getPathStyles2.pathString,
          pathStyle = _getPathStyles2.pathStyle;

      delete restProps.percent;
      var strokeColorList = toArray(strokeColor);
      var gradient = strokeColorList.find(function (color) {
        return Object.prototype.toString.call(color) === '[object Object]';
      });
      return React__default.createElement("svg", _extends({
        className: "".concat(prefixCls, "-circle ").concat(className),
        viewBox: "0 0 100 100",
        style: style
      }, restProps), gradient && React__default.createElement("defs", null, React__default.createElement("linearGradient", {
        id: "".concat(prefixCls, "-gradient-").concat(this.gradientId),
        x1: "100%",
        y1: "0%",
        x2: "0%",
        y2: "0%"
      }, Object.keys(gradient).sort(function (a, b) {
        return stripPercentToNumber(a) - stripPercentToNumber(b);
      }).map(function (key, index) {
        return React__default.createElement("stop", {
          key: index,
          offset: key,
          stopColor: gradient[key]
        });
      }))), React__default.createElement("path", {
        className: "".concat(prefixCls, "-circle-trail"),
        d: pathString,
        stroke: trailColor,
        strokeLinecap: strokeLinecap,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: "0",
        style: pathStyle
      }), this.getStokeList().reverse());
    }
  }]);

  return Circle;
}(Component);

Circle.propTypes = _objectSpread({}, propTypes, {
  gapPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
});
Circle.defaultProps = _objectSpread({}, defaultProps, {
  gapPosition: 'top'
});
var Circle$1 = enhancer(Circle);

var _templateObject$e, _templateObject2$b;

var getColor$1 = function getColor(color, variation, theme) {
  return color || theme[variation] || theme.primary;
};

var getSize = function getSize(_ref) {
  var size = _ref.size;

  if (typeof size === 'number') {
    return "".concat(size, "px");
  }

  switch (size) {
    case 'large':
      return '80px';

    case 'small':
      return '40px';

    default:
      return '64px';
  }
};

var getFontSize = function getFontSize(_ref2) {
  var size = _ref2.size;

  if (typeof size === 'number') {
    size /= 4;
    if (size < 10) size = 10;
    if (size > 30) size = 30;
    return "".concat(size, "px");
  }

  switch (size) {
    case 'large':
      return '20px';

    case 'small':
      return '12px';

    default:
      return '16px';
  }
};

var CompWrapper$1 = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral$1(["\n\tposition: relative;\n\twidth: ", ";\n\theight: ", ";\n"])), getSize, getSize);
var Label$2 = styled.div(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\tfont-size: ", ";\n\tfont-family: ", ";\n\ttransition: all 0.25s ease-in;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n"])), getFontSize, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily;
});

function ProgressCircle(props) {
  var progress = props.progress;

  var getLineWidth = function getLineWidth() {
    switch (props.size) {
      case 'large':
        return 9;

      case 'small':
        return 4;

      default:
        return 6;
    }
  };

  return /*#__PURE__*/React__default.createElement(CompWrapper$1, props, /*#__PURE__*/React__default.createElement(Circle$1, {
    percent: progress,
    trailColor: props.theme.progressCircleTrackColor,
    strokeColor: getColor$1(props.color, props.variation, props.theme),
    trailWidth: getLineWidth(),
    strokeWidth: getLineWidth(),
    gapDegree: props.gapDegree,
    gapPosition: props.gapPosition
  }), props.showLabel ? /*#__PURE__*/React__default.createElement(Label$2, _extends$g({}, props, {
    progress: progress
  }), progress, "%") : undefined);
}

ProgressCircle.propTypes = {
  /** Size of the circle. Could be `xlarge`, `large`, `medium`, `small` or any size in pixels */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['xlarge', 'large', 'medium', 'small'])]),

  /** Progress percentage value 0-100 */
  progress: PropTypes.number,

  /** Defined the color of the bar 'primary', 'secondary', 'success', 'warning', 'danger','info', 'dark' */
  variation: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'dark']),

  /** Controls whether the percentage is shown or not */
  showLabel: PropTypes.bool,

  /** Controls whether the percentage is shown or not */
  labelPosition: PropTypes.oneOf(['left', 'right', 'floating']),

  /** Specific color overriding the variation */
  color: PropTypes.string
};
ProgressCircle.defaultProps = {
  labelPosition: 'right',
  progress: 0,
  variation: 'primary',
  showLabel: true
};
var Wrapper$p = withTheme(ProgressCircle);

function ProgressGauge(props) {
  return /*#__PURE__*/React__default.createElement(Wrapper$p, _extends$g({}, props, {
    trailWidth: 10,
    strokeWidth: 10,
    gapDegree: 75,
    gapPosition: 'bottom'
  }));
}

ProgressGauge.propTypes = {
  /** Size of the circle. Could be `xlarge`, `large`, `medium`, `small` or any size in pixels*/
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['xlarge', 'large', 'medium', 'small'])]),

  /** Progress percentage value 0-100 */
  progress: PropTypes.number,

  /** Defined the color of the bar 'primary', 'secondary', 'success', 'warning', 'danger','info', 'dark' */
  variation: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'dark']),

  /** Controls whether the percentage is shown or not */
  showLabel: PropTypes.bool,

  /** Controls whether the percentage is shown or not */
  labelPosition: PropTypes.oneOf(['left', 'right', 'floating']),

  /** Specific color overriding the variation */
  color: PropTypes.string
};
ProgressGauge.defaultProps = {
  labelPosition: 'right',
  progress: 0,
  variation: 'primary',
  showLabel: true
};
var Wrapper$o = withTheme(ProgressGauge);

var _templateObject$d, _templateObject2$a;

var getColor = function getColor(color, variation, theme) {
  return color || theme[variation] || theme.primary;
};

var getPadding = function getPadding(_ref) {
  var labelPosition = _ref.labelPosition;

  switch (labelPosition) {
    case 'right':
      return '10px 40px 10px 0px';

    case 'left':
      return '10px 0px 10px 40px';

    case 'floating':
      return '15px 0px';
  }
};

var CompWrapper = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral$1(["\n\tposition: relative;\n\tpadding: ", ";\n"])), getPadding);
var Label$1 = styled.div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\tfont-size: 14px;\n\tfont-family: ", ";\n\ttransition: all 0.5s ease-in;\n\n\t", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, function (_ref3) {
  var labelPosition = _ref3.labelPosition,
      progress = _ref3.progress;

  switch (labelPosition) {
    case 'right':
      return css$4(["top:50%;transform:translateY(-50%);right:0px;"]);

    case 'left':
      return css$4(["top:50%;transform:translateY(-50%);left:0px;"]);

    case 'floating':
      return css$4(["top:0;left:", "%;"], function () {
        return progress * 100 / 100;
      });
  }
});

function ProgressLine(props) {
  var progress = props.progress,
      theme = props.theme,
      rest = _objectWithoutProperties$c(props, ["progress", "theme"]);

  return /*#__PURE__*/React__default.createElement(CompWrapper, _extends$g({}, rest, {
    theme: theme
  }), /*#__PURE__*/React__default.createElement(Line$1, {
    percent: progress,
    trailColor: theme.progressLineTrackColor,
    strokeColor: getColor(rest.color, rest.variation, theme)
  }), props.showLabel ? /*#__PURE__*/React__default.createElement(Label$1, _extends$g({}, rest, {
    theme: theme,
    progress: progress
  }), progress, "%") : undefined);
}

ProgressLine.propTypes = {
  /** Progress percentage value 0-100 */
  progress: PropTypes.number,

  /** Defined the color of the bar 'primary', 'secondary', 'success', 'warning', 'danger','info', 'dark' */
  variation: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'dark']),

  /** Controls whether the percentage is shown or not */
  showLabel: PropTypes.bool,

  /** Controls whether the percentage is shown or not */
  labelPosition: PropTypes.oneOf(['left', 'right', 'floating']),

  /** Specific color overriding the variation */
  color: PropTypes.string
};
ProgressLine.defaultProps = {
  labelPosition: 'right',
  progress: 0,
  variation: 'primary',
  showLabel: true
};
var Wrapper$n = withTheme(ProgressLine);

var _templateObject$c, _templateObject2$9, _templateObject3$6, _templateObject4$5, _templateObject5$5;
var RTEWrapper = styled.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral$1(["\n\t.ql-container {\n\t\tbackground: ", ";\n\t\tborder-color: ", " !important;\n\t\tmin-height: 100px;\n\t\tborder-bottom-left-radius: ", ";\n\t\tborder-bottom-right-radius: ", ";\n\n\t\tdisplay: ", ";\n\n\t\t&.ql-disabled {\n\t\t\tbackground: ", ";\n\t\t}\n\t}\n\t.ql-html:after {\n\t\tcontent: '[HTML]';\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.richTextBackground;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.inputBorderColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius;
}, function (_ref5) {
  var showRaw = _ref5.showRaw;
  return showRaw ? 'none' : 'grid';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.inputBackgroundDisabled;
});
var RTEToolbar = styled(Wrapper$12)(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral$1(["\n\tbackground: ", ";\n\tborder-color: ", " !important;\n\tborder-top-left-radius: ", ";\n\tborder-top-right-radius: ", ";\n\n\tborder: 1px solid #ccc;\n\tbox-sizing: border-box;\n\tpadding: 8px;\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.richTextToolbarBackground;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.inputBorderColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.borderRadius;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.borderRadius;
});
var RTERaw = styled.textarea(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral$1(["\n\tdisplay: ", ";\n\tborder-bottom-left-radius: ", ";\n\tborder-bottom-right-radius: ", ";\n\tborder-color: ", " !important;\n\tfont-family: 'Courier';\n\tfont-size: 14px;\n\tz-index: 1;\n\ttop: 0px;\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 100px;\n\tbox-sizing: border-box;\n\toutline: none;\n\tpadding: ", " ", ";\n\n\t&:focus {\n\t\tborder-color: ", " !important;\n\t}\n"])), function (_ref11) {
  var showRaw = _ref11.showRaw;
  return showRaw ? 'block' : 'none';
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.borderRadius;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.borderRadius;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.inputBorderColor;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.inputPaddingY;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.inputPaddingX;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.inputFocusBorderColor;
});
var ToolbarButton = styled.button(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral$1(["\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tfloat: left;\n\theight: 24px;\n\tpadding: 3px 5px;\n\tmin-width: 28px;\n\tbox-sizing: border-box;\n\toutline: none;\n\tuser-select: none;\n\twhite-space: nowrap;\n\n\t&:hover {\n\t\tcolor: ", " !important;\n\t\t.ql-stroke {\n\t\t\tstroke: ", " !important;\n\t\t}\n\t\t.ql-fill {\n\t\t\tfill: ", " !important;\n\t\t}\n\t}\n\t&:focus {\n\t\tbox-shadow: ", ";\n\t}\n"])), function (_ref18) {
  var theme = _ref18.theme;
  return theme.primary;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.primary;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.primary;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.focusOuline;
});
var ToolbarSelect = styled.select(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral$1(["\n\twidth: 98px;\n\tcolor: #444;\n\tdisplay: inline-block;\n\tfloat: left;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\theight: 24px;\n\tposition: relative;\n\tvertical-align: middle;\n\tbox-sizing: border-box;\n\n\t.ql-picker-label {\n\t\tcursor: pointer;\n\t\tdisplay: inline-block;\n\t\theight: 100%;\n\t\tpadding-left: 8px;\n\t\tpadding-right: 2px;\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\tborder: 1px solid transparent;\n\t\tfont-weight: normal;\n\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t\tbox-shadow: ", ";\n\t\t}\n\n\t\t&:hover {\n\t\t\tcolor: ", " !important;\n\n\t\t\t.ql-stroke {\n\t\t\t\tstroke: ", " !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ql-header {\n\t\t&.ql-expanded {\n\t\t\tborder-color: #ccc;\n\t\t\tcolor: #ccc;\n\t\t\tz-index: 2;\n\t\t}\n\t}\n"])), function (_ref22) {
  var theme = _ref22.theme;
  return theme.focusOuline;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.primary;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.primary;
});

var Toolbar = function Toolbar(_ref) {
  var id = _ref.id,
      theme = _ref.theme,
      showSource = _ref.showSource,
      handleClickShowRaw = _ref.handleClickShowRaw;
  return /*#__PURE__*/React__default.createElement(RTEToolbar, {
    theme: theme,
    id: id,
    flexWrap: "wrap"
  }, /*#__PURE__*/React__default.createElement(ToolbarSelect, {
    className: "ql-header",
    defaultValue: "",
    onChange: function onChange(e) {
      return e.persist();
    },
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarSelect, {
    className: "ql-font",
    defaultValue: "",
    onChange: function onChange(e) {
      return e.persist();
    },
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-bold",
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-italic",
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-underline",
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-strike",
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-list",
    value: "ordered",
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-list",
    value: "bullet",
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-indent",
    value: "-1",
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-indent",
    value: "+1",
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-image",
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarSelect, {
    className: "ql-color",
    theme: theme
  }, /*#__PURE__*/React__default.createElement("option", {
    value: "red"
  }), /*#__PURE__*/React__default.createElement("option", {
    value: "green"
  }), /*#__PURE__*/React__default.createElement("option", {
    value: "blue"
  }), /*#__PURE__*/React__default.createElement("option", {
    value: "orange"
  }), /*#__PURE__*/React__default.createElement("option", {
    value: "violet"
  }), /*#__PURE__*/React__default.createElement("option", {
    value: "#d0d1d2"
  }), /*#__PURE__*/React__default.createElement("option", null)), /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-clean",
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-link",
    theme: theme
  }), showSource ? /*#__PURE__*/React__default.createElement(ToolbarButton, {
    className: "ql-getHTML",
    onClick: handleClickShowRaw,
    theme: theme
  }, "[HTML]") : undefined);
};

var RichTextEditor = function RichTextEditor(_ref2) {
  var value = _ref2.value,
      props = _objectWithoutProperties$c(_ref2, ["value"]);

  var _useState = useState(),
      _useState2 = _slicedToArray$8(_useState, 2),
      rawHtml = _useState2[0],
      setRawHtml = _useState2[1];

  var _useState3 = useState(value || ''),
      _useState4 = _slicedToArray$8(_useState3, 2),
      editorHtml = _useState4[0],
      setEditorHtml = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$8(_useState5, 2),
      showRaw = _useState6[0],
      setShowRaw = _useState6[1];

  var _useState7 = useState(RandomID(8, true)),
      _useState8 = _slicedToArray$8(_useState7, 1),
      toolbarId = _useState8[0];

  useEffect(function () {
    if (value) setEditorHtml(value);
  }, [value]);
  var wrapper = /*#__PURE__*/React__default.createRef();
  var quill = /*#__PURE__*/React__default.createRef();
  /** Normal content handlers */

  var handleChange = function handleChange(value) {
    if (value !== props.value) {
      setEditorHtml(value);
      if (props.onChange) props.onChange(value);
    }
  };

  var handleBlur = function handleBlur() {
    if (props.onBlur) props.onBlur(editorHtml);

    if (editorHtml !== value && props.onValueChange) {
      props.onValueChange(editorHtml);
    }
  };

  var handleFocus = function handleFocus() {
    if (props.onFocus) props.onFocus(editorHtml);
  };
  /** Raw html handlers */


  var handleChangeRaw = function handleChangeRaw(html) {
    setRawHtml(html);
    if (props.onChange) props.onChange(html);
  };

  var handleBlurRaw = function handleBlurRaw(html) {
    setRawHtml(html);
    if (props.onBlur) props.onBlur(html);
    if (html !== value && props.onValueChange) props.onValueChange(html);
  };

  var handleFocusRaw = function handleFocusRaw() {
    if (props.onFocus) props.onFocus(editorHtml);
  };

  var handleClickShowRaw = function handleClickShowRaw() {
    if (!props.disabled) {
      var isEditingRaw = showRaw;
      setShowRaw(!isEditingRaw);
      syncViews(isEditingRaw);
    }
  };

  var syncViews = function syncViews(fromRaw) {
    if (fromRaw) {
      setEditorHtml(rawHtml);
      quill.current.setEditorContents(quill.current.getEditor(), rawHtml);
    } else {
      setRawHtml(editorHtml);
    }
  };

  props.onValueChange;
      props.onChange;
      var placeholder = props.placeholder,
      showSource = props.showSource,
      rest = _objectWithoutProperties$c(props, ["onValueChange", "onChange", "placeholder", "showSource"]);

  return /*#__PURE__*/React__default.createElement(RTEWrapper, _extends$g({}, rest, {
    ref: wrapper,
    showRaw: showRaw
  }), /*#__PURE__*/React__default.createElement(BaseFieldWrapper, rest, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Toolbar, _extends$g({}, rest, {
    id: toolbarId,
    showSource: showSource,
    handleClickShowRaw: handleClickShowRaw
  })), /*#__PURE__*/React__default.createElement(ReactQuill, {
    ref: quill,
    value: editorHtml,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    placeholder: placeholder,
    formats: RichTextEditor.formats,
    bounds: wrapper.current,
    readOnly: rest.disabled,
    modules: {
      toolbar: {
        container: "#".concat(toolbarId)
      },
      clipboard: {
        matchVisual: true
      }
    }
  }), /*#__PURE__*/React__default.createElement(RTERaw, _extends$g({}, rest, {
    className: "raw-editor",
    onChange: function onChange(e) {
      return handleChangeRaw(e.target.value);
    },
    onBlur: function onBlur(e) {
      return handleBlurRaw(e.target.value);
    },
    onFocus: function onFocus(e) {
      return handleFocusRaw(e.target.value);
    },
    value: rawHtml,
    showRaw: showRaw
  })))));
};

RichTextEditor.formats = ['header', 'font', 'size', 'bold', 'italic', 'underline', 'list', 'bullet', 'indent', 'link', 'image', 'color'];
RichTextEditor.propTypes = {
  /** Value to show when component renders */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** fires when the the value of the field changes */
  onChange: PropTypes.func,

  /** if on value change is provided, the regular `onChange` event
   * will not fire on each character but only when the user hits enter or the component looses focus */
  onValueChange: PropTypes.func,

  /** fires when the focus has left the field */
  onBlur: PropTypes.func,

  /** fires when field is in focus */
  onFocus: PropTypes.func,

  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** adds a red star to the label if set to true and no value exists */
  required: PropTypes.bool,

  /** Adds a tooltip to the label */
  tooltip: PropTypes.string,

  /** Delays in seconds for showing to the tooltip on mouseenter */
  tooltipDelay: PropTypes.number,

  /** Disabled components and prevents input  */
  disabled: PropTypes.bool,

  /** Displays a small hint under the field */
  hint: PropTypes.string,

  /** Allows the users to edit HTML content */
  showSource: PropTypes.bool,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
RichTextEditor.defaultProps = {
  showSource: false
};
var Wrapper$m = compose$1(withTheme, withTransformers)(RichTextEditor);

var _templateObject$b;
var StyledRow$1 = styled(Wrapper$12)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral$1(["\n\t", " {\n\t\tposition: absolute;\n\t}\n"])), FormHintAndFeedback);

var _templateObject$a, _templateObject2$8;
var TimeIcon = styled(Wrapper$Z)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\tright: ", "px;\n\ttop: 50%;\n\tcursor: pointer;\n\ttransform: translateY(-50%);\n"])), function (_ref) {
  var showClearTime = _ref.showClearTime;
  return showClearTime ? 30 : 10;
});
var digitSize = 16;
var Digit = styled.div(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral$1(["\n\tcursor: pointer;\n\tfont-size: ", "px;\n\tfont-family: ", ";\n\tline-height: ", "px;\n\theight: 53px;\n\twidth: 50px;\n\tuser-select: none;\n\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n"])), digitSize, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, digitSize + 12, function (_ref3) {
  var theme = _ref3.theme;
  return theme.primary;
});

var Swipeable = bindKeyboard(virtualize(SwipeableViews));

var TimeDials = function TimeDials(_ref) {
  var time = _ref.time,
      onIncrease = _ref.onIncrease,
      onDecrease = _ref.onDecrease,
      rest = _objectWithoutProperties$c(_ref, ["time", "onIncrease", "onDecrease"]);

  var _useState = useState(0),
      _useState2 = _slicedToArray$8(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  var handleChange = function handleChange(index) {
    if (index < current) {
      onDecrease();
    } else {
      onIncrease();
    }

    setCurrent(index);
  };

  var slideRenderer = function slideRenderer(_ref2) {
    var key = _ref2.key;
    return /*#__PURE__*/React__default.createElement(Digit, _extends$g({}, rest, {
      key: key
    }), time);
  };

  return /*#__PURE__*/React__default.createElement(Wrapper$11, {
    textAlign: "center",
    style: {
      userSelect: 'none'
    }
  }, /*#__PURE__*/React__default.createElement(Wrapper$Z, _extends$g({}, rest, {
    icon: 'arrow-up',
    onClick: function onClick() {
      return handleChange(current - 1);
    },
    color: rest.theme.greyBlue
  })), /*#__PURE__*/React__default.createElement(Swipeable, {
    index: current,
    enableMouseEvents: true,
    containerStyle: {
      height: 50
    },
    slideRenderer: slideRenderer,
    axis: "y",
    onChangeIndex: handleChange
  }), /*#__PURE__*/React__default.createElement(Wrapper$Z, _extends$g({}, rest, {
    icon: 'arrow-down',
    onClick: function onClick(e) {
      e.stopPropagation();
      handleChange(current + 1);
    },
    color: rest.theme.greyBlue
  })));
};

var TimeDialsPanel = function TimeDialsPanel(_ref3) {
  var value = _ref3.value,
      onChange = _ref3.onChange,
      onClose = _ref3.onClose,
      is24h = _ref3.is24h,
      buttonLabel = _ref3.buttonLabel,
      min = _ref3.min,
      max = _ref3.max,
      rest = _objectWithoutProperties$c(_ref3, ["value", "onChange", "onClose", "is24h", "buttonLabel", "min", "max"]);

  var formatTime = function formatTime(t) {
    return moment("".concat(moment().format('YYYY-MM-DD'), " ").concat(t));
  };

  var _useState3 = useState(formatTime(value)),
      _useState4 = _slicedToArray$8(_useState3, 2),
      time = _useState4[0],
      setTime = _useState4[1];

  var maxTime = moment().set({
    h: max.split(':')[0],
    m: max.split(':')[1],
    s: 0
  });
  var minTime = moment().set({
    hour: min.split(':')[0],
    minute: min.split(':')[1],
    second: 0
  });

  var increment = function increment(digit) {
    var duration = moment.duration(_defineProperty$k({}, digit, 1));
    var newTime = moment(time).add(duration);

    if (newTime.isSameOrAfter(minTime) && newTime.isSameOrBefore(maxTime)) {
      setTime(newTime);
    }
  };

  var decrement = function decrement(digit) {
    var duration = moment.duration(_defineProperty$k({}, digit, 1));
    var newTime = moment(time).subtract(duration);

    if (newTime.format('HH:mm') === minTime.format('HH:mm') || newTime.isBetween(minTime, maxTime)) {
      setTime(newTime);
    }
  };

  var handleMeridiem = function handleMeridiem(value) {
    var duration = moment.duration({
      h: value
    });
    setTime(moment(time).add(duration));
  };

  var handleChange = function handleChange() {
    onChange(time);
    onClose();
  };

  useEffect(function () {
    setTime(formatTime(value));
  }, [value]);

  if (time.isValid()) {
    return /*#__PURE__*/React__default.createElement(DropMenuPanel, _extends$g({}, rest, {
      mt: "7px"
    }), /*#__PURE__*/React__default.createElement(Wrapper$12, {
      px: 4,
      py: 2
    }, /*#__PURE__*/React__default.createElement(TimeDials, _extends$g({}, rest, {
      time: time.format(is24h ? 'HH' : 'hh'),
      onIncrease: function onIncrease() {
        return increment('h');
      },
      onDecrease: function onDecrease() {
        return decrement('h');
      }
    })), /*#__PURE__*/React__default.createElement(TimeDials, _extends$g({}, rest, {
      time: time.format('mm'),
      onIncrease: function onIncrease() {
        return increment('m');
      },
      onDecrease: function onDecrease() {
        return decrement('m');
      }
    })), !is24h ? /*#__PURE__*/React__default.createElement(TimeDials, _extends$g({}, rest, {
      time: time.format('A'),
      onIncrease: function onIncrease() {
        return handleMeridiem(12);
      },
      onDecrease: function onDecrease() {
        return handleMeridiem(-12);
      }
    })) : undefined), /*#__PURE__*/React__default.createElement(Wrapper$11, {
      width: 1,
      textAlign: "center",
      mt: 3
    }, /*#__PURE__*/React__default.createElement(ButtonWrapper, _extends$g({}, rest, {
      size: "sm",
      variation: "primary",
      onClick: handleChange,
      tabIndex: -1
    }), buttonLabel)));
  } else {
    return null;
  }
};

TimeDialsPanel.defaultProps = {
  onChange: function onChange() {},
  onClose: function onClose() {},
  buttonLabel: 'Set time'
};
var Wrapper$l = withTheme(TimeDialsPanel);

var MERIDIEM_FORMAT = 'hh:mm A';
var HOURS_24_FORMAT = 'HH:mm';

var TimePicker = function TimePicker(props) {
  var id = props.id;
      props.label;
      var value = props.value;
      props.error;
      props.hint;
      props.className;
      props.required;
      props.validationState;
      props.tooltip;
      var disabled = props.disabled;
      props.tooltipDelay;
      var placeholder = props.placeholder,
      is24h = props.is24h,
      showClearTime = props.showClearTime,
      showOnFocus = props.showOnFocus,
      onChange = props.onChange;
      props.onValueChange;
      var onBlur = props.onBlur,
      min = props.min,
      max = props.max,
      rest = _objectWithoutProperties$c(props, ["id", "label", "value", "error", "hint", "className", "required", "validationState", "tooltip", "disabled", "tooltipDelay", "placeholder", "is24h", "showClearTime", "showOnFocus", "onChange", "onValueChange", "onBlur", "min", "max"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray$8(_useState, 2),
      time = _useState2[0],
      setTime = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$8(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var inputRef = useRef();
  useEffect(function () {
    if (time !== value) {
      setTime(value);
    }
  }, [value]);

  var togglePanel = function togglePanel(e) {
    setOpen(!open);
  };

  var handleClickOutside = function handleClickOutside(e) {
    setOpen(false);
  };

  var onTimeChange = function onTimeChange(timeVal) {
    if (timeVal instanceof moment) {
      timeVal = timeVal.format(HOURS_24_FORMAT);
    }

    setTime(timeVal);
    onChange(timeVal);
    onBlur(timeVal);
  };

  var clearDate = function clearDate() {
    if (!disabled) {
      setOpen(false);
      setTime('00:00');
      onChange('00:00');
      onBlur('00:00');
    }
  };

  var getMask = function getMask() {
    return "99:99".concat(!is24h ? ' aa' : '');
  };

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Enter') {
      onChange(time);
      setOpen(false);
    }
  };

  var customInput = function customInput(props) {
    if (showOnFocus) props.onFocus = function () {
      setOpen(true);
    };
    return /*#__PURE__*/React__default.createElement(InputMask, _extends$g({}, props, {
      mask: getMask(),
      name: "timeinput",
      onKeyPress: handleKeyPress
    }));
  };

  var getValue = function getValue() {
    var val = moment("".concat(moment().format('YYYY-MM-DD'), " ").concat(time), 'YYYY-MM-DD HH:mm');
    return val.isValid() ? val : time;
  };

  var getConstrain = function getConstrain() {
    if (min && max) {
      var momentMin = moment("".concat(moment().format('YYYY-MM-DD'), " ").concat(min));
      var momentMax = moment("".concat(moment().format('YYYY-MM-DD'), " ").concat(max));
      return {
        hours: {
          min: momentMin.hour(),
          max: momentMax.hour()
        },
        minutes: {
          min: momentMin.minute(),
          max: momentMax.minute()
        }
      };
    }
  };

  var handleTab = function handleTab(event) {
    if (event.key === 'Tab') {
      setOpen(false);
    }
  };

  var handleBlur = function handleBlur(event) {
    var isInputValid = moment("".concat(moment().format('YYYY-MM-DD'), " ").concat(event.target.value)).isValid();

    if (!isInputValid) {
      setTime(value);
      onChange('00:00');
      onBlur('00:00');
    } else {
      onBlur(time);
    }
  };

  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, _extends$g({}, props, {
    key: "".concat(id, "-time")
  }), /*#__PURE__*/React__default.createElement(DateTimeInputWrapper, {
    ref: inputRef
  }, /*#__PURE__*/React__default.createElement(DateTimeComp, _extends$g({}, rest, {
    renderInput: customInput,
    open: false,
    value: getValue(),
    inputProps: {
      placeholder: placeholder,
      disabled: disabled,
      onKeyDown: handleTab,
      onBlur: handleBlur,
      'aria-label': props['aria-label'] || props.label
    },
    onChange: onTimeChange,
    closeOnTab: true,
    dateFormat: false,
    timeFormat: is24h ? HOURS_24_FORMAT : MERIDIEM_FORMAT,
    timeConstraints: getConstrain()
  })), value && showClearTime ? /*#__PURE__*/React__default.createElement(DateTimeClearIcon, _extends$g({}, rest, {
    icon: "close",
    disabled: disabled,
    onClick: clearDate,
    size: 16,
    color: rest.theme.greyBlue
  })) : undefined, /*#__PURE__*/React__default.createElement(OutsideClickHandler, {
    onOutsideClick: handleClickOutside,
    disabled: !open
  }, /*#__PURE__*/React__default.createElement(TimeIcon, _extends$g({}, rest, {
    showClearTime: showClearTime,
    icon: "time",
    size: 16,
    color: rest.theme.greyBlue,
    onClick: togglePanel
  })), open ? /*#__PURE__*/React__default.createElement(Wrapper$l, _extends$g({}, rest, {
    value: time,
    is24h: is24h,
    timeConstraints: getConstrain(),
    onChange: onTimeChange,
    onClose: togglePanel,
    min: min,
    max: max
  })) : undefined)));
};

TimePicker.propTypes = {
  /** Time value in hh:mm format and MUST be in 24hours format. This does not affect the display */
  value: PropTypes.string,

  /** fires when the the value of the field changes */
  onChange: PropTypes.func,

  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Min hour allowed */
  min: PropTypes.string,

  /** Max hour allowed */
  max: PropTypes.string,

  /** Enable delete button */
  showClearTime: PropTypes.bool,

  /** Displays the time select popup */
  showOnFocus: PropTypes.bool,

  /** Input placeholder */
  placeholder: PropTypes.string,

  /** Controls the meridiem format */
  is24h: PropTypes.bool,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
TimePicker.defaultProps = {
  value: '00:00',
  min: '00:00',
  max: '23:59',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  showClearTime: true
};
TimePicker.displayName = 'TimePicker';
var Wrapper$k = compose$1(withTheme, withTransformers)(TimePicker);

var isEqual = function isEqual(value, other) {
  // Get the value type
  var type = Object.prototype.toString.call(value); // If the two objects are not the same type, return false

  if (type !== Object.prototype.toString.call(other)) return false; // If items are not an object or array, return false

  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false; // Compare the length of the length of the two items

  var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
  var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
  if (valueLen !== otherLen) return false; // Compare two items

  var compare = function compare(item1, item2) {
    // Get the object type
    var itemType = Object.prototype.toString.call(item1); // If an object or array, compare recursively

    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2)) return false;
    } // Otherwise, do a simple comparison
    else {
        // If the two items are not the same type, return false
        if (itemType !== Object.prototype.toString.call(item2)) return false; // Else if it's a function, convert to a string and compare
        // Otherwise, just compare

        if (itemType === '[object Function]') {
          if (item1.toString() !== item2.toString()) return false;
        } else {
          if (item1 !== item2) return false;
        }
      }
  }; // Compare properties


  if (type === '[object Array]') {
    for (var i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false;
    }
  } else {
    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        if (compare(value[key], other[key]) === false) return false;
      }
    }
  } // If nothing failed, return true


  return true;
};

function TimeRange(props) {
  props.label;
      var value = props.value,
      disabled = props.disabled;
      props.tooltip;
      props.tooltipDelay;
      props.hint;
      var theme = props.theme;
      props.error;
      props.required;
      props.validationState;
      var onChange = props.onChange,
      allowSlots = props.allowSlots,
      isAllDay = props.isAllDay,
      showAllDaySwitch = props.showAllDaySwitch,
      rest = _objectWithoutProperties$c(props, ["label", "value", "disabled", "tooltip", "tooltipDelay", "hint", "theme", "error", "required", "validationState", "onChange", "allowSlots", "isAllDay", "showAllDaySwitch"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray$8(_useState, 2),
      range = _useState2[0],
      setRange = _useState2[1];

  var _useState3 = useState(isAllDay),
      _useState4 = _slicedToArray$8(_useState3, 2),
      allDay = _useState4[0],
      setAllDay = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray$8(_useState5, 2),
      isOpen = _useState6[0],
      setOpen = _useState6[1];

  useEffect(function () {
    if (!isEqual(range, value)) {
      setRange(_toConsumableArray$2(value));
    }
  }, [value]);
  useEffect(function () {
    setAllDay(isAllDay);
  }, [isAllDay]);

  var _handleStart = function handleStart(time, index) {
    if (_typeof$e(time) === 'object') {
      time = time.target.value;
    }

    if (allowSlots) {
      range[index][0] = time;
    } else {
      range[0] = time;
    }

    setRange(range);
  };

  var _handleEnd = function handleEnd(time, index) {
    if (_typeof$e(time) === 'object') {
      time = time.target.value;
    }

    if (allowSlots) {
      range[index][1] = time;
    } else {
      range[1] = time;
    }

    setRange(range);
  };

  var handleAddSlot = function handleAddSlot() {
    var newValue = [].concat(_toConsumableArray$2(range), [['00:00', '00:00']]);
    setRange(newValue);
  };

  var handleRemoveSlot = function handleRemoveSlot(index) {
    range.splice(index, 1);
    setRange(_toConsumableArray$2(range));
  };

  var handleAllDay = function handleAllDay(isAllDay) {
    setAllDay(isAllDay);

    if (isAllDay) {
      onChange(allowSlots ? [['00:00', '00:00']] : ['00:00', '00:00']);
    }
  };

  var handleClosePopup = function handleClosePopup() {
    setOpen(false);
    onChange(range);
  };

  var getDisplayValue = function getDisplayValue() {
    if (allowSlots) {
      var displayString = '';
      range.map(function (slot) {
        if (displayString !== '') displayString += ', ';
        displayString += "".concat(slot[0], " - ").concat(slot[1]);
      });
      return displayString;
    }

    return "".concat(range[0], " - ").concat(range[1]);
  };

  var RangeComponent = function RangeComponent(_ref) {
    var index = _ref.index,
        value = _ref.value,
        handleStart = _ref.handleStart,
        handleEnd = _ref.handleEnd,
        rest = _objectWithoutProperties$c(_ref, ["index", "value", "handleStart", "handleEnd"]);

    return /*#__PURE__*/React__default.createElement(Wrapper$12, _extends$g({}, rest, {
      alignItems: "center"
    }), /*#__PURE__*/React__default.createElement(Wrapper$11, {
      pr: 2
    }, /*#__PURE__*/React__default.createElement(Wrapper$k, _extends$g({}, rest, {
      value: value[0],
      onBlur: handleStart,
      nested: true,
      disabled: disabled || allDay,
      id: "".concat(rest.id, "-start")
    }))), /*#__PURE__*/React__default.createElement(Wrapper$11, {
      pr: 2
    }, /*#__PURE__*/React__default.createElement(Wrapper$k, _extends$g({}, rest, {
      value: value[1],
      onBlur: handleEnd,
      nested: true,
      disabled: disabled || allDay,
      id: "".concat(rest.id, "-end")
    }))), /*#__PURE__*/React__default.createElement(Wrapper$11, {
      alignSelf: "flex-start",
      width: 30
    }, allowSlots && index > 0 && /*#__PURE__*/React__default.createElement(Wrapper$Z, {
      icon: "trash",
      size: 18,
      cursor: "pointer",
      onClick: function onClick() {
        return handleRemoveSlot(index);
      },
      mt: 1,
      color: disabled ? theme.greyBlue : theme.primary
    })));
  };

  var getTimeRangePopup = function getTimeRangePopup() {
    return /*#__PURE__*/React__default.createElement(DropMenuPanel, {
      theme: theme,
      style: {
        overflow: 'visible'
      }
    }, /*#__PURE__*/React__default.createElement(Wrapper$Z, {
      theme: theme,
      icon: "close",
      onClick: handleClosePopup,
      size: 20,
      color: "silver",
      style: {
        position: 'absolute',
        right: 10,
        top: 10
      }
    }), /*#__PURE__*/React__default.createElement(Wrapper$11, {
      p: 3
    }, /*#__PURE__*/React__default.createElement(Wrapper$12, {
      alignItems: "center"
    }, /*#__PURE__*/React__default.createElement(Wrapper$11, {
      width: 1 / 2,
      style: {
        fontSize: '13px'
      }
    }, props.labels.fromTime), /*#__PURE__*/React__default.createElement(Wrapper$11, {
      width: 1 / 2,
      style: {
        fontSize: '13px'
      }
    }, props.labels.toTime), /*#__PURE__*/React__default.createElement(Wrapper$11, {
      width: 30
    })), Array.isArray(value[0]) ? range.map(function (t, i) {
      return /*#__PURE__*/React__default.createElement(RangeComponent, _extends$g({}, rest, {
        theme: theme,
        index: i,
        key: i,
        mb: 1,
        value: t,
        handleStart: function handleStart(time) {
          return _handleStart(time, i);
        },
        handleEnd: function handleEnd(time) {
          return _handleEnd(time, i);
        }
      }));
    }) : /*#__PURE__*/React__default.createElement(RangeComponent, _extends$g({}, rest, {
      theme: theme,
      value: range,
      handleStart: _handleStart,
      handleEnd: _handleEnd
    })), /*#__PURE__*/React__default.createElement(Wrapper$12, {
      justifyContent: "space-between"
    }, /*#__PURE__*/React__default.createElement(Wrapper$11, null, allowSlots && /*#__PURE__*/React__default.createElement(ButtonWrapper, {
      onClick: handleAddSlot,
      variation: "link",
      size: "sm",
      theme: theme
    }, props.labels.addSlot)))));
  };

  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, props, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OutsideClickHandler, {
    onOutsideClick: handleClosePopup,
    disabled: !isOpen
  }, /*#__PURE__*/React__default.createElement(Wrapper$12, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(Wrapper$11, {
    flexGrow: 1,
    mr: 2,
    theme: theme
  }, /*#__PURE__*/React__default.createElement(Wrapper$x, _extends$g({}, rest, {
    theme: theme,
    value: getDisplayValue(),
    onFocus: function onFocus() {
      return setOpen(true);
    },
    readOnly: true,
    mb: 0,
    suffix: /*#__PURE__*/React__default.createElement(Wrapper$Z, {
      theme: theme,
      icon: "time",
      size: 18,
      disabled: disabled || allDay,
      onClick: function onClick() {
        return setOpen(!isOpen);
      },
      color: disabled ? theme.iconDisabledColor : theme.greyBlue,
      hoverColor: disabled ? theme.iconDisabledColor : theme.primary
    }),
    disabled: disabled || allDay
  }))), showAllDaySwitch ? /*#__PURE__*/React__default.createElement(Wrapper$11, {
    width: "180px",
    pt: "7px"
  }, /*#__PURE__*/React__default.createElement(Wrapper$R, {
    theme: theme,
    label: props.labels.allDay,
    nested: true,
    value: allDay,
    onChange: handleAllDay,
    horizontal: true,
    disabled: disabled
  })) : null), isOpen && !disabled && !allDay ? getTimeRangePopup() : null)));
}

TimeRange.propTypes = {
  /** Array of two time values e.g. ['08:00','18:00'] or Array of an array in case of `allowSlots` */
  value: PropTypes.array,

  /** Function called when either values changed */
  onChange: PropTypes.func,

  /** Allows setting mutiple sessions per range */
  allowSlots: PropTypes.bool,

  /** Passed labels for i18n */
  labels: PropTypes.shape({
    allDay: PropTypes.string,
    addSlot: PropTypes.string,
    fromTime: PropTypes.string,
    toTime: PropTypes.string
  }),

  /** Show all day switch */
  showAllDaySwitch: PropTypes.bool,

  /** Controls 24 hour format */
  is24h: PropTypes.bool,

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
TimeRange.defaultProps = {
  value: ['00:00', '00:00'],
  allowSlots: false,
  showAllDaySwitch: true,
  is24h: true,
  onChange: function onChange() {},
  labels: {
    allDay: 'All day',
    addSlot: 'Add slot',
    fromTime: 'From',
    toTime: 'To'
  }
};
TimeRange.displayName = 'TimeRange';
var Wrapper$j = compose$1(withTheme, withTransformers)(TimeRange);

var elms = ['width', 'm', 'mx', 'my', 'mr', 'ml', 'mt', 'mb', 'p', 'px', 'py', 'pr', 'pl', 'pt', 'pb', 'bg'];

function Row$3(props) {
  var containsInputElement = function containsInputElement() {
    var found = false;
    React__default.Children.map(props.children, function (child) {
      if (!child) return;
      child.type;
          child.props;
 // const comp = props.uiComponent ? props.uiComponent.prototype : type.prototype;
      // found = Elements.filter((e) => type.displayName === e.displayName);
    });
    return found;
  };

  return /*#__PURE__*/React__default.createElement(StyledRow$1, _extends$g({}, props, {
    pb: 3,
    containsInput: containsInputElement()
  }), React__default.Children.map(props.children, function (child, i) {
    if (child) {
      var childProps = _objectSpread2$2(_objectSpread2$2({}, child.props), {}, {
        theme: props.theme
      });

      var boxProps = {};
      Object.keys(childProps).map(function (key) {
        var inList = elms.find(function (attr) {
          return attr === key;
        });

        if (inList) {
          boxProps[key] = childProps[key];
          childProps[key] = undefined;
        }
      });
      return /*#__PURE__*/React__default.createElement(Wrapper$11, _extends$g({}, boxProps, {
        style: {
          boxSizing: 'border-box'
        },
        pr: props.spaceItems
      }), typeof child === 'string' ? child : /*#__PURE__*/React__default.cloneElement(child, childProps));
    }
  }));
}

Row$3.propTypes = {
  /** By default, children will be spaced out using this value. Can be px or number based on style-system space array */
  spaceItems: PropTypes.number,

  /** Whether to allow children to break to next line or not */
  justifyContent: PropTypes.oneOf(['flex-start', 'flow-end', 'center', 'space-between', 'space-around']),

  /** Aligns items vertically */
  alignContent: PropTypes.oneOf(['flex-start', 'flow-end', 'center', 'baseline', 'stretch'])
};
Row$3.defaultProps = {
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  alignItems: 'flex-end',
  spaceItems: 1
};
var Wrapper$i = withTheme(Row$3);

var _templateObject$9, _templateObject2$7, _templateObject3$5, _templateObject4$4, _templateObject5$4;
var Wrapper$h = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral$1(["\n\toverflow: hidden;\n\tdiv.sliding-panel-container.active {\n\t\ttransition: background 150ms ease-in-out;\n\t\t&:not(.click-through) {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t}\n\tdiv.sliding-panel-container.active .panel {\n\t\tbox-shadow: ", ";\n\t}\n\tdiv.panel-content {\n\t\toverflow: hidden;\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.sidepanelOverlayBgColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.cardShadow;
});
var ContentWrapper = styled.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral$1(["\n\tbackground-color: ", ";\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.sidepanelContentBgColor;
});
var ContentBody = styled.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral$1(["\n\tpadding: ", "px;\n\tpadding-top: 0px;\n\tbox-sizing: border-box;\n\toverflow: auto;\n\tfont-size: ", ";\n\tfont-family: ", ";\n\tmax-height: calc(100% - 20px);\n\theight: 100%;\n\toverflow: auto;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.space[5];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily;
});
var HeaderComp = styled.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral$1(["\n\tfont-size: 18px;\n\tfont-family: ", ";\n\tfont-weight: 600;\n\tbackground-color: ", ";\n\twidth: 100%;\n\tpadding: ", "px;\n\n\tbox-sizing: border-box;\n\tposition: relative;\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontFamily;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.sidepanelHeaderBgColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.space[5];
});
var CloseIconWrapper = styled.div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\ttop: ", "px;\n\tright: ", "px;\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.space[5];
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.space[5];
});

var Sidepanel = function Sidepanel(_ref) {
  var direction = _ref.direction,
      isOpen = _ref.isOpen,
      size = _ref.size,
      hideOnClickOutside = _ref.hideOnClickOutside,
      children = _ref.children,
      onClose = _ref.onClose,
      header = _ref.header,
      closeIcon = _ref.closeIcon;
      _ref.actions;
      var noBackdrop = _ref.noBackdrop,
      portalId = _ref.portalId,
      rest = _objectWithoutProperties$c(_ref, ["direction", "isOpen", "size", "hideOnClickOutside", "children", "onClose", "header", "closeIcon", "actions", "noBackdrop", "portalId"]);

  var handleClose = function handleClose() {
    if (onClose) {
      onClose();
    }
  };

  var handleBackgroundClicked = function handleBackgroundClicked() {
    if (hideOnClickOutside) handleClose();
  };

  var closeElm = typeof closeIcon === 'string' ? /*#__PURE__*/React__default.createElement(Wrapper$Z, _extends$g({}, rest, {
    icon: closeIcon,
    size: 22,
    color: "#CCC",
    onClick: onClose,
    cursor: "pointer"
  })) : /*#__PURE__*/React__default.cloneElement(closeIcon, {
    onClick: onClose
  });
  var Component = /*#__PURE__*/React__default.createElement(Wrapper$h, rest, /*#__PURE__*/React__default.createElement(SlidingPanel, {
    type: direction,
    isOpen: isOpen,
    size: size,
    backdropClicked: handleBackgroundClicked,
    noBackdrop: noBackdrop
  }, /*#__PURE__*/React__default.createElement(ContentWrapper, rest, header ? /*#__PURE__*/React__default.createElement(HeaderComp, rest, header, /*#__PURE__*/React__default.createElement(CloseIconWrapper, rest, closeElm)) : /*#__PURE__*/React__default.createElement(CloseIconWrapper, rest, closeElm), /*#__PURE__*/React__default.createElement(ContentBody, rest, children))));
  return portalId ? /*#__PURE__*/ReactDOM.createPortal(Component, document.getElementById(portalId)) : Component;
};

Sidepanel.propTypes = {
  /** Optional header to render in the upper section of the sidepanel content */
  header: PropTypes.node,

  /** To customize the close icon. If `string` is passed, the component will look in the available list of icons in the uikit */
  closeIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Controls the state of the Sidepanel */
  isOpen: PropTypes.bool,

  /** Fires when the Sidepanel is about to close */
  onClose: PropTypes.func,

  /** Sidepanel size in % of screen */
  size: PropTypes.number,

  /** Sidepanel position */
  direction: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),

  /** Closes the Sidepanel upon clicking the dark overlay */
  hideOnClickOutside: PropTypes.bool,

  /** Removes the glass overlay */
  noBackdrop: PropTypes.bool,

  /** If provided, the Sidepanel will be render the component inside that DOM element */
  portalId: PropTypes.string
};
Sidepanel.defaultProps = {
  isOpen: false,
  size: 35,
  direction: 'right',
  closeIcon: 'close',
  noBackdrop: false
};
var Wrapper$g = withTheme(Sidepanel);

var Track = function Track(props) {
  var _ref, _ref2;

  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      style = props.style;
  var length = props.length,
      offset = props.offset,
      reverse = props.reverse;

  if (length < 0) {
    reverse = !reverse;
    length = Math.abs(length);
    offset = 100 - offset;
  }

  var positonStyle = vertical ? (_ref = {}, _defineProperty$l(_ref, reverse ? 'top' : 'bottom', offset + '%'), _defineProperty$l(_ref, reverse ? 'bottom' : 'top', 'auto'), _defineProperty$l(_ref, 'height', length + '%'), _ref) : (_ref2 = {}, _defineProperty$l(_ref2, reverse ? 'right' : 'left', offset + '%'), _defineProperty$l(_ref2, reverse ? 'left' : 'right', 'auto'), _defineProperty$l(_ref2, 'width', length + '%'), _ref2);

  var elStyle = _extends$h({}, style, positonStyle);
  return included ? React__default.createElement('div', { className: className, style: elStyle }) : null;
};

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = ReactDOM.unstable_batchedUpdates ? function run(e) {
    ReactDOM.unstable_batchedUpdates(cb, e);
  } : cb;
  return addDOMEventListener(target, eventType, callback, option);
}

var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  warning$3(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
    return a - b;
  });
  if (dots && step) {
    for (var i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? _extends$h({}, dotStyle, _defineProperty$l({}, reverse ? 'top' : 'bottom', offset)) : _extends$h({}, dotStyle, _defineProperty$l({}, reverse ? 'right' : 'left', offset));
    if (isActived) {
      style = _extends$h({}, style, activeDotStyle);
    }

    var pointClassName = classNames$1((_classNames = {}, _defineProperty$l(_classNames, prefixCls + '-dot', true), _defineProperty$l(_classNames, prefixCls + '-dot-active', isActived), _defineProperty$l(_classNames, prefixCls + '-dot-reverse', reverse), _classNames));

    return React__default.createElement('span', { className: pointClassName, style: style, key: point });
  });

  return React__default.createElement(
    'div',
    { className: prefixCls + '-step' },
    elements
  );
};

var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min,
      onClickLabel = _ref.onClickLabel;

  var marksKeys = Object.keys(marks);

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = typeof markPoint === 'object' && !React__default.isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = classNames$1((_classNames = {}, _defineProperty$l(_classNames, className + '-text', true), _defineProperty$l(_classNames, className + '-text-active', isActive), _classNames));

    var bottomStyle = _defineProperty$l({
      marginBottom: '-50%'
    }, reverse ? 'top' : 'bottom', (point - min) / range * 100 + '%');

    var leftStyle = _defineProperty$l({
      transform: 'translateX(' + (reverse ? '50%' : '-50%') + ')',
      msTransform: 'translateX(' + (reverse ? '50%' : '-50%') + ')'
    }, reverse ? 'right' : 'left', (point - min) / range * 100 + '%');

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? _extends$h({}, style, markPoint.style) : style;
    return React__default.createElement(
      'span',
      {
        className: markClassName,
        style: markStyle,
        key: point,
        onMouseDown: function onMouseDown(e) {
          return onClickLabel(e, point);
        },
        onTouchStart: function onTouchStart(e) {
          return onClickLabel(e, point);
        }
      },
      markLabel
    );
  });

  return React__default.createElement(
    'div',
    { className: className },
    elements
  );
};

var Handle$1 = function (_React$Component) {
  _inherits$d(Handle, _React$Component);

  function Handle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$k(this, Handle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$d(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clickFocused: false
    }, _this.setHandleRef = function (node) {
      _this.handle = node;
    }, _this.handleMouseUp = function () {
      if (document.activeElement === _this.handle) {
        _this.setClickFocus(true);
      }
    }, _this.handleMouseDown = function () {
      // fix https://github.com/ant-design/ant-design/issues/15324
      _this.focus();
    }, _this.handleBlur = function () {
      _this.setClickFocus(false);
    }, _this.handleKeyDown = function () {
      _this.setClickFocus(false);
    }, _temp), _possibleConstructorReturn$d(_this, _ret);
  }

  _createClass$j(Handle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // mouseup won't trigger if mouse moved out of handle,
      // so we listen on document here.
      this.onMouseUpListener = addEventListenerWrap(document, 'mouseup', this.handleMouseUp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: 'setClickFocus',
    value: function setClickFocus(focused) {
      this.setState({ clickFocused: focused });
    }
  }, {
    key: 'clickFocus',
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.handle.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref2, _ref3;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          vertical = _props.vertical,
          reverse = _props.reverse,
          offset = _props.offset,
          style = _props.style,
          disabled = _props.disabled,
          min = _props.min,
          max = _props.max,
          value = _props.value,
          tabIndex = _props.tabIndex,
          ariaLabel = _props.ariaLabel,
          ariaLabelledBy = _props.ariaLabelledBy,
          ariaValueTextFormatter = _props.ariaValueTextFormatter,
          restProps = _objectWithoutProperties$d(_props, ['prefixCls', 'vertical', 'reverse', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex', 'ariaLabel', 'ariaLabelledBy', 'ariaValueTextFormatter']);

      var className = classNames$1(this.props.className, _defineProperty$l({}, prefixCls + '-handle-click-focused', this.state.clickFocused));
      var positionStyle = vertical ? (_ref2 = {}, _defineProperty$l(_ref2, reverse ? 'top' : 'bottom', offset + '%'), _defineProperty$l(_ref2, reverse ? 'bottom' : 'top', 'auto'), _defineProperty$l(_ref2, 'transform', reverse ? null : 'translateY(+50%)'), _ref2) : (_ref3 = {}, _defineProperty$l(_ref3, reverse ? 'right' : 'left', offset + '%'), _defineProperty$l(_ref3, reverse ? 'left' : 'right', 'auto'), _defineProperty$l(_ref3, 'transform', 'translateX(' + (reverse ? '+' : '-') + '50%)'), _ref3);
      var elStyle = _extends$h({}, style, positionStyle);

      var _tabIndex = tabIndex || 0;
      if (disabled || tabIndex === null) {
        _tabIndex = null;
      }

      var ariaValueText = void 0;
      if (ariaValueTextFormatter) {
        ariaValueText = ariaValueTextFormatter(value);
      }

      return React__default.createElement('div', _extends$h({
        ref: this.setHandleRef,
        tabIndex: _tabIndex
      }, restProps, {
        className: className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown

        // aria attribute
        , role: 'slider',
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': !!disabled,
        'aria-label': ariaLabel,
        'aria-labelledby': ariaLabelledBy,
        'aria-valuetext': ariaValueText
      }));
    }
  }]);

  return Handle;
}(React__default.Component);

function isEventFromHandle(e, handles) {
  try {
    return Object.keys(handles).some(function (key) {
      return e.target === findDOMNode$3(handles[key]);
    });
  } catch (error) {
    return false;
  }
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min,
      max = _ref2.max;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var maxSteps = Math.floor((max - min) / step);
    var steps = Math.min((val - min) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, _toConsumableArray$3(diffs)))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

function calculateNextValue(func, value, props) {
  var operations = {
    increase: function increase(a, b) {
      return a + b;
    },
    decrease: function decrease(a, b) {
      return a - b;
    }
  };

  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
  var keyToGet = Object.keys(props.marks)[indexToGet];

  if (props.step) {
    return operations[func](value, props.step);
  } else if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
    return props.marks[keyToGet];
  }
  return value;
}

function getKeyboardValueMutator(e, vertical, reverse) {
  var increase = 'increase';
  var decrease = 'decrease';
  var method = increase;
  switch (e.keyCode) {
    case KeyCode.UP:
      method = vertical && reverse ? decrease : increase;break;
    case KeyCode.RIGHT:
      method = !vertical && reverse ? decrease : increase;break;
    case KeyCode.DOWN:
      method = vertical && reverse ? increase : decrease;break;
    case KeyCode.LEFT:
      method = !vertical && reverse ? increase : decrease;break;

    case KeyCode.END:
      return function (value, props) {
        return props.max;
      };
    case KeyCode.HOME:
      return function (value, props) {
        return props.min;
      };
    case KeyCode.PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };
    case KeyCode.PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }
  return function (value, props) {
    return calculateNextValue(method, value, props);
  };
}

function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    _inherits$d(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      _classCallCheck$k(this, ComponentEnhancer);

      var _this = _possibleConstructorReturn$d(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = getMousePosition(isVertical, e);
        if (!isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.removeDocumentEvents();
        _this.onStart(position);
        _this.addDocumentMouseEvents();
      };

      _this.onTouchStart = function (e) {
        if (isNotTouchEvent(e)) return;

        var isVertical = _this.props.vertical;
        var position = getTouchPosition(isVertical, e);
        if (!isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        pauseEvent(e);
      };

      _this.onFocus = function (e) {
        var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            vertical = _this$props.vertical;

        if (isEventFromHandle(e, _this.handlesRefs)) {
          var handlePosition = getHandleCenterPosition(vertical, e.target);
          _this.dragOffset = 0;
          _this.onStart(handlePosition);
          pauseEvent(e);
          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        _this.onEnd();
        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseUp = function () {
        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = getMousePosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (isNotTouchEvent(e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = getTouchPosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && isEventFromHandle(e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.onClickMarkLabel = function (e, value) {
        e.stopPropagation();
        _this.onChange({ value: value });
        _this.setState({ value: value }, function () {
          return _this.onEnd(true);
        });
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      var step = props.step,
          max = props.max,
          min = props.min;

      var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
      warning$3(step && Math.floor(step) === step ? isPointDiffEven : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      _this.handlesRefs = {};
      return _this;
    }

    _createClass$j(ComponentEnhancer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // Snapshot testing cannot handle refs, so be sure to null-check this.
        this.document = this.sliderRef && this.sliderRef.ownerDocument;

        var _props = this.props,
            autoFocus = _props.autoFocus,
            disabled = _props.disabled;

        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (_get$1(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) _get$1(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: 'getSliderStart',
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var _props2 = this.props,
            vertical = _props2.vertical,
            reverse = _props2.reverse;

        var rect = slider.getBoundingClientRect();
        if (vertical) {
          return reverse ? rect.bottom : rect.top;
        }
        return window.pageXOffset + (reverse ? rect.right : rect.left);
      }
    }, {
      key: 'getSliderLength',
      value: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: 'addDocumentTouchEvents',
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = addEventListenerWrap(this.document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = addEventListenerWrap(this.document, 'touchend', this.onEnd);
      }
    }, {
      key: 'addDocumentMouseEvents',
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = addEventListenerWrap(this.document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = addEventListenerWrap(this.document, 'mouseup', this.onEnd);
      }
    }, {
      key: 'removeDocumentEvents',
      value: function removeDocumentEvents() {
        /* eslint-disable no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();

        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (!this.props.disabled) {
          this.handlesRefs[0].focus();
        }
      }
    }, {
      key: 'blur',
      value: function blur() {
        var _this2 = this;

        if (!this.props.disabled) {
          Object.keys(this.handlesRefs).forEach(function (key) {
            if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
              _this2.handlesRefs[key].blur();
            }
          });
        }
      }
    }, {
      key: 'calcValue',
      value: function calcValue(offset) {
        var _props3 = this.props,
            vertical = _props3.vertical,
            min = _props3.min,
            max = _props3.max;

        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: 'calcValueByPos',
      value: function calcValueByPos(position) {
        var sign = this.props.reverse ? -1 : +1;
        var pixelOffset = sign * (position - this.getSliderStart());
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: 'calcOffset',
      value: function calcOffset(value) {
        var _props4 = this.props,
            min = _props4.min,
            max = _props4.max;

        var ratio = (value - min) / (max - min);
        return Math.max(0, ratio * 100);
      }
    }, {
      key: 'saveHandle',
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _props5 = this.props,
            prefixCls = _props5.prefixCls,
            className = _props5.className,
            marks = _props5.marks,
            dots = _props5.dots,
            step = _props5.step,
            included = _props5.included,
            disabled = _props5.disabled,
            vertical = _props5.vertical,
            reverse = _props5.reverse,
            min = _props5.min,
            max = _props5.max,
            children = _props5.children,
            maximumTrackStyle = _props5.maximumTrackStyle,
            style = _props5.style,
            railStyle = _props5.railStyle,
            dotStyle = _props5.dotStyle,
            activeDotStyle = _props5.activeDotStyle;

        var _get$call = _get$1(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = classNames$1(prefixCls, (_classNames = {}, _defineProperty$l(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), _defineProperty$l(_classNames, prefixCls + '-disabled', disabled), _defineProperty$l(_classNames, prefixCls + '-vertical', vertical), _defineProperty$l(_classNames, className, className), _classNames));
        return React__default.createElement(
          'div',
          {
            ref: this.saveSlider,
            className: sliderClassName,
            onTouchStart: disabled ? noop : this.onTouchStart,
            onMouseDown: disabled ? noop : this.onMouseDown,
            onMouseUp: disabled ? noop : this.onMouseUp,
            onKeyDown: disabled ? noop : this.onKeyDown,
            onFocus: disabled ? noop : this.onFocus,
            onBlur: disabled ? noop : this.onBlur,
            style: style
          },
          React__default.createElement('div', {
            className: prefixCls + '-rail',
            style: _extends$h({}, maximumTrackStyle, railStyle)
          }),
          tracks,
          React__default.createElement(Steps, {
            prefixCls: prefixCls,
            vertical: vertical,
            reverse: reverse,
            marks: marks,
            dots: dots,
            step: step,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            dotStyle: dotStyle,
            activeDotStyle: activeDotStyle
          }),
          handles,
          React__default.createElement(Marks, {
            className: prefixCls + '-mark',
            onClickLabel: disabled ? noop : this.onClickMarkLabel,
            vertical: vertical,
            marks: marks,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            reverse: reverse
          }),
          children
        );
      }
    }]);

    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.defaultProps = _extends$h({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = _objectWithoutProperties$d(_ref, ['index']);

      delete restProps.dragging;
      if (restProps.value === null) {
        return null;
      }

      return React__default.createElement(Handle$1, _extends$h({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    reverse: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _temp;
}

var Slider$1 = function (_React$Component) {
  _inherits$d(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck$k(this, Slider);

    var _this = _possibleConstructorReturn$d(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.onEnd = function (force) {
      var dragging = _this.state.dragging;

      _this.removeDocumentEvents();
      if (dragging || force) {
        _this.props.onAfterChange(_this.getValue());
      }
      _this.setState({ dragging: false });
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };

    warning$3(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
    warning$3(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
    return _this;
  }

  _createClass$j(Slider, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }
      var _props = this.props,
          value = _props.value,
          onChange = _props.onChange;

      var theValue = value !== undefined ? value : prevState.value;
      var nextValue = this.trimAlignValue(theValue, this.props);
      if (nextValue !== prevState.value) {
        // eslint-disable-next-line
        this.setState({ value: nextValue });
        if (isValueOutOfRange(theValue, this.props)) {
          onChange(nextValue);
        }
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      var nextState = state.value > this.props.max ? _extends$h({}, state, { value: this.props.max }) : state;
      if (isNotControlled) {
        this.setState(nextState);
      }

      var changedValue = nextState.value;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      this.setState({ dragging: true });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      if (value === prevValue) return;

      this.prevMovedHandleIndex = 0;

      this.onChange({ value: value });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      pauseEvent(e);
      var oldValue = this.state.value;

      var value = this.calcValueByPos(position);
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;

      var valueMutator = getKeyboardValueMutator(e, vertical, reverse);
      if (valueMutator) {
        pauseEvent(e);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;

        this.onChange({ value: value });
        this.props.onAfterChange(value);
        this.onEnd();
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.props.min;
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      return this.state.value;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (v === null) {
        return null;
      }

      var mergedProps = _extends$h({}, this.props, nextProps);
      var val = ensureValueInRange(v, mergedProps);
      return ensureValuePrecision(val, mergedProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          prefixCls = _props3.prefixCls,
          vertical = _props3.vertical,
          included = _props3.included,
          disabled = _props3.disabled,
          minimumTrackStyle = _props3.minimumTrackStyle,
          trackStyle = _props3.trackStyle,
          handleStyle = _props3.handleStyle,
          tabIndex = _props3.tabIndex,
          ariaLabelForHandle = _props3.ariaLabelForHandle,
          ariaLabelledByForHandle = _props3.ariaLabelledByForHandle,
          ariaValueTextFormatterForHandle = _props3.ariaValueTextFormatterForHandle,
          min = _props3.min,
          max = _props3.max,
          startPoint = _props3.startPoint,
          reverse = _props3.reverse,
          handleGenerator = _props3.handle;
      var _state = this.state,
          value = _state.value,
          dragging = _state.dragging;

      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: prefixCls + '-handle',
        prefixCls: prefixCls,
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        reverse: reverse,
        index: 0,
        tabIndex: tabIndex,
        ariaLabel: ariaLabelForHandle,
        ariaLabelledBy: ariaLabelledByForHandle,
        ariaValueTextFormatter: ariaValueTextFormatterForHandle,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });

      var trackOffset = startPoint !== undefined ? this.calcOffset(startPoint) : 0;
      var _trackStyle = trackStyle[0] || trackStyle;
      var track = React__default.createElement(Track, {
        className: prefixCls + '-track',
        vertical: vertical,
        included: included,
        offset: trackOffset,
        reverse: reverse,
        length: offset - trackOffset,
        style: _extends$h({}, minimumTrackStyle, _trackStyle)
      });

      return { tracks: track, handles: handle };
    }
  }]);

  return Slider;
}(React__default.Component);

var Slider$2 = createSlider(Slider$1);

var _trimAlignValue = function _trimAlignValue(_ref) {
  var value = _ref.value,
      handle = _ref.handle,
      bounds = _ref.bounds,
      props = _ref.props;
  var allowCross = props.allowCross,
      pushable = props.pushable;

  var thershold = Number(pushable);
  var valInRange = ensureValueInRange(value, props);
  var valNotConflict = valInRange;
  if (!allowCross && handle != null && bounds !== undefined) {
    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
      valNotConflict = bounds[handle - 1] + thershold;
    }
    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
      valNotConflict = bounds[handle + 1] - thershold;
    }
  }
  return ensureValuePrecision(valNotConflict, props);
};

var Range$1 = function (_React$Component) {
  _inherits$d(Range, _React$Component);

  function Range(props) {
    _classCallCheck$k(this, Range);

    var _this = _possibleConstructorReturn$d(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

    _this.onEnd = function (force) {
      var handle = _this.state.handle;

      _this.removeDocumentEvents();

      if (handle !== null || force) {
        _this.props.onAfterChange(_this.getValue());
      }

      _this.setState({
        handle: null
      });
    };

    var count = props.count,
        min = props.min,
        max = props.max;

    var initialValue = Array.apply(undefined, _toConsumableArray$3(Array(count + 1))).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _trimAlignValue({
        value: v,
        handle: i,
        props: props
      });
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;

    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }

  _createClass$j(Range, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
        return;
      }
      if (this.props.min === prevProps.min && this.props.max === prevProps.max && shallowEqual(this.props.value, prevProps.value)) {
        return;
      }
      var _props = this.props,
          onChange = _props.onChange,
          value = _props.value;

      var currentValue = value || prevState.bounds;
      if (currentValue.some(function (v) {
        return isValueOutOfRange(v, _this2.props);
      })) {
        var newValues = currentValue.map(function (v) {
          return ensureValueInRange(v, _this2.props);
        });
        onChange(newValues);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      } else {
        var controlledState = {};

        ['handle', 'recent'].forEach(function (item) {
          if (state[item] !== undefined) {
            controlledState[item] = state[item];
          }
        });

        if (Object.keys(controlledState).length) {
          this.setState(controlledState);
        }
      }

      var data = _extends$h({}, this.state, state);
      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      var props = this.props;
      var state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);

      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });

      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue) return;

      var nextBounds = [].concat(_toConsumableArray$3(state.bounds));
      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({ bounds: nextBounds });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      pauseEvent(e);
      var state = this.state;

      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;

      this.moveTo(value);
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var _props2 = this.props,
          reverse = _props2.reverse,
          vertical = _props2.vertical;

      var valueMutator = getKeyboardValueMutator(e, vertical, reverse);

      if (valueMutator) {
        pauseEvent(e);
        var state = this.state,
            props = this.props;
        var bounds = state.bounds,
            handle = state.handle;

        var oldValue = bounds[handle === null ? state.recent : handle];
        var mutatedValue = valueMutator(oldValue, props);
        var value = _trimAlignValue({
          value: mutatedValue,
          handle: handle,
          bounds: state.bounds,
          props: props
        });
        if (value === oldValue) return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: 'getClosestBound',
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;

      var closestBound = 0;
      for (var i = 1; i < bounds.length - 1; ++i) {
        if (value >= bounds[i]) {
          closestBound = i;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }
      return closestBound;
    }
  }, {
    key: 'getBoundNeedMoving',
    value: function getBoundNeedMoving(value, closestBound) {
      var _state = this.state,
          bounds = _state.bounds,
          recent = _state.recent;

      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      var bounds = this.state.bounds;

      return bounds[bounds.length - 1];
    }

    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: 'getPoints',
    value: function getPoints() {
      var _props3 = this.props,
          marks = _props3.marks,
          step = _props3.step,
          min = _props3.min,
          max = _props3.max;

      var cache = this._getPointsCache;
      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = _extends$h({}, marks);
        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this._getPointsCache = { marks: marks, step: step, points: points };
      }
      return this._getPointsCache.points;
    }
  }, {
    key: 'moveTo',
    value: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;

      var state = this.state,
          props = this.props;

      var nextBounds = [].concat(_toConsumableArray$3(state.bounds));
      var handle = state.handle === null ? state.recent : state.handle;
      nextBounds[handle] = value;
      var nextHandle = handle;
      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }
      this.onChange({
        recent: nextHandle,
        handle: nextHandle,
        bounds: nextBounds
      });
      if (isFromKeyboardEvent) {
        // known problem: because setState is async,
        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
        // cause onBeforeChange and onAfterChange receive wrong value.
        // here use setState callback to hack，but not elegant
        this.props.onAfterChange(nextBounds);
        this.setState({}, function () {
          _this3.handlesRefs[nextHandle].focus();
        });
        this.onEnd();
      }
    }
  }, {
    key: 'pushSurroundingHandles',
    value: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var threshold = this.props.pushable;

      threshold = Number(threshold);

      var direction = 0;
      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }
      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: 'pushHandle',
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      // the handle was pushed enough to create the needed `amount` gap
      return true;
    }
  }, {
    key: 'pushHandleOnePoint',
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }
      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var threshold = this.props.pushable;

      var diffToNext = direction * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      }
      // push the handle
      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(value) {
      var _state2 = this.state,
          handle = _state2.handle,
          bounds = _state2.bounds;

      return _trimAlignValue({
        value: value,
        handle: handle,
        bounds: bounds,
        props: this.props
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state3 = this.state,
          handle = _state3.handle,
          bounds = _state3.bounds;
      var _props4 = this.props,
          prefixCls = _props4.prefixCls,
          vertical = _props4.vertical,
          included = _props4.included,
          disabled = _props4.disabled,
          min = _props4.min,
          max = _props4.max,
          reverse = _props4.reverse,
          handleGenerator = _props4.handle,
          trackStyle = _props4.trackStyle,
          handleStyle = _props4.handleStyle,
          tabIndex = _props4.tabIndex,
          ariaLabelGroupForHandles = _props4.ariaLabelGroupForHandles,
          ariaLabelledByGroupForHandles = _props4.ariaLabelledByGroupForHandles,
          ariaValueTextFormatterGroupForHandles = _props4.ariaValueTextFormatterGroupForHandles;


      var offsets = bounds.map(function (v) {
        return _this4.calcOffset(v);
      });

      var handleClassName = prefixCls + '-handle';
      var handles = bounds.map(function (v, i) {
        var _classNames;

        var _tabIndex = tabIndex[i] || 0;
        if (disabled || tabIndex[i] === null) {
          _tabIndex = null;
        }
        var dragging = handle === i;
        return handleGenerator({
          className: classNames$1((_classNames = {}, _defineProperty$l(_classNames, handleClassName, true), _defineProperty$l(_classNames, handleClassName + '-' + (i + 1), true), _defineProperty$l(_classNames, handleClassName + '-dragging', dragging), _classNames)),
          prefixCls: prefixCls,
          vertical: vertical,
          dragging: dragging,
          offset: offsets[i],
          value: v,
          index: i,
          tabIndex: _tabIndex,
          min: min,
          max: max,
          reverse: reverse,
          disabled: disabled,
          style: handleStyle[i],
          ref: function ref(h) {
            return _this4.saveHandle(i, h);
          },
          ariaLabel: ariaLabelGroupForHandles[i],
          ariaLabelledBy: ariaLabelledByGroupForHandles[i],
          ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i]
        });
      });

      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = classNames$1((_classNames2 = {}, _defineProperty$l(_classNames2, prefixCls + '-track', true), _defineProperty$l(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
        return React__default.createElement(Track, {
          className: trackClassName,
          vertical: vertical,
          reverse: reverse,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          style: trackStyle[index],
          key: i
        });
      });

      return { tracks: tracks, handles: handles };
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if ('value' in props || 'min' in props || 'max' in props) {
        var value = props.value || state.bounds;
        var nextBounds = value.map(function (v, i) {
          return _trimAlignValue({
            value: v,
            handle: i,
            bounds: state.bounds,
            props: props
          });
        });
        if (nextBounds.length === state.bounds.length && nextBounds.every(function (v, i) {
          return v === state.bounds[i];
        })) {
          return null;
        }
        return _extends$h({}, state, {
          bounds: nextBounds
        });
      }
      return null;
    }
  }]);

  return Range;
}(React__default.Component);

Range$1.displayName = 'Range';
Range$1.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  tabIndex: [],
  ariaLabelGroupForHandles: [],
  ariaLabelledByGroupForHandles: [],
  ariaValueTextFormatterGroupForHandles: []
};


var Range$2 = createSlider(Range$1);

var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

var Content = function Content(props) {
  var overlay = props.overlay,
      prefixCls = props.prefixCls,
      id = props.id,
      overlayInnerStyle = props.overlayInnerStyle;
  return React.createElement("div", {
    className: "".concat(prefixCls, "-inner"),
    id: id,
    role: "tooltip",
    style: overlayInnerStyle
  }, typeof overlay === 'function' ? overlay() : overlay);
};

var Tooltip = function Tooltip(props, ref) {
  var overlayClassName = props.overlayClassName,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? ['hover'] : _props$trigger,
      _props$mouseEnterDela = props.mouseEnterDelay,
      mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela,
      _props$mouseLeaveDela = props.mouseLeaveDelay,
      mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela,
      overlayStyle = props.overlayStyle,
      _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls,
      children = props.children,
      onVisibleChange = props.onVisibleChange,
      afterVisibleChange = props.afterVisibleChange,
      transitionName = props.transitionName,
      animation = props.animation,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'right' : _props$placement,
      _props$align = props.align,
      align = _props$align === void 0 ? {} : _props$align,
      _props$destroyTooltip = props.destroyTooltipOnHide,
      destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip,
      defaultVisible = props.defaultVisible,
      getTooltipContainer = props.getTooltipContainer,
      overlayInnerStyle = props.overlayInnerStyle,
      restProps = _objectWithoutProperties$b(props, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle"]);

  var domRef = useRef(null);
  useImperativeHandle(ref, function () {
    return domRef.current;
  });

  var extraProps = _objectSpread2$1({}, restProps);

  if ('visible' in props) {
    extraProps.popupVisible = props.visible;
  }

  var getPopupElement = function getPopupElement() {
    var _props$arrowContent = props.arrowContent,
        arrowContent = _props$arrowContent === void 0 ? null : _props$arrowContent,
        overlay = props.overlay,
        id = props.id;
    return [React.createElement("div", {
      className: "".concat(prefixCls, "-arrow"),
      key: "arrow"
    }, arrowContent), React.createElement(Content, {
      key: "content",
      prefixCls: prefixCls,
      id: id,
      overlay: overlay,
      overlayInnerStyle: overlayInnerStyle
    })];
  };

  var destroyTooltip = false;
  var autoDestroy = false;

  if (typeof destroyTooltipOnHide === 'boolean') {
    destroyTooltip = destroyTooltipOnHide;
  } else if (destroyTooltipOnHide && _typeof$d(destroyTooltipOnHide) === 'object') {
    var keepParent = destroyTooltipOnHide.keepParent;
    destroyTooltip = keepParent === true;
    autoDestroy = keepParent === false;
  }

  return React.createElement(Trigger, Object.assign({
    popupClassName: overlayClassName,
    prefixCls: prefixCls,
    popup: getPopupElement,
    action: trigger,
    builtinPlacements: placements,
    popupPlacement: placement,
    ref: domRef,
    popupAlign: align,
    getPopupContainer: getTooltipContainer,
    onPopupVisibleChange: onVisibleChange,
    afterPopupVisibleChange: afterVisibleChange,
    popupTransitionName: transitionName,
    popupAnimation: animation,
    defaultPopupVisible: defaultVisible,
    destroyPopupOnHide: destroyTooltip,
    autoDestroy: autoDestroy,
    mouseLeaveDelay: mouseLeaveDelay,
    popupStyle: overlayStyle,
    mouseEnterDelay: mouseEnterDelay
  }, extraProps), children);
};

var Tooltip$1 = forwardRef(Tooltip);

function createSliderWithTooltip(Component) {
  var _class, _temp2;

  return _temp2 = _class = function (_React$Component) {
    _inherits$d(ComponentWrapper, _React$Component);

    function ComponentWrapper() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$k(this, ComponentWrapper);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$d(this, (_ref = ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        visibles: {}
      }, _this.handleTooltipVisibleChange = function (index, visible) {
        _this.setState(function (prevState) {
          return {
            visibles: _extends$h({}, prevState.visibles, _defineProperty$l({}, index, visible))
          };
        });
      }, _this.handleWithTooltip = function (_ref2) {
        var value = _ref2.value,
            dragging = _ref2.dragging,
            index = _ref2.index,
            disabled = _ref2.disabled,
            restProps = _objectWithoutProperties$d(_ref2, ['value', 'dragging', 'index', 'disabled']);

        var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle,
            getTooltipContainer = _this$props.getTooltipContainer;

        var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === undefined ? 'rc-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === undefined ? 'top' : _tipProps$placement,
            _tipProps$visible = tipProps.visible,
            visible = _tipProps$visible === undefined ? false : _tipProps$visible,
            restTooltipProps = _objectWithoutProperties$d(tipProps, ['prefixCls', 'overlay', 'placement', 'visible']);

        var handleStyleWithIndex = void 0;
        if (Array.isArray(handleStyle)) {
          handleStyleWithIndex = handleStyle[index] || handleStyle[0];
        } else {
          handleStyleWithIndex = handleStyle;
        }

        return React__default.createElement(
          Tooltip$1,
          _extends$h({}, restTooltipProps, {
            getTooltipContainer: getTooltipContainer,
            prefixCls: prefixCls,
            overlay: overlay,
            placement: placement,
            visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
            key: index
          }),
          React__default.createElement(Handle$1, _extends$h({}, restProps, {
            style: _extends$h({}, handleStyleWithIndex),
            value: value,
            onMouseEnter: function onMouseEnter() {
              return _this.handleTooltipVisibleChange(index, true);
            },
            onMouseLeave: function onMouseLeave() {
              return _this.handleTooltipVisibleChange(index, false);
            }
          }))
        );
      }, _temp), _possibleConstructorReturn$d(_this, _ret);
    }

    _createClass$j(ComponentWrapper, [{
      key: 'render',
      value: function render() {
        return React__default.createElement(Component, _extends$h({}, this.props, { handle: this.handleWithTooltip }));
      }
    }]);

    return ComponentWrapper;
  }(React__default.Component), _class.defaultProps = {
    tipFormatter: function tipFormatter(value) {
      return value;
    },

    handleStyle: [{}],
    tipProps: {},
    getTooltipContainer: function getTooltipContainer(node) {
      return node.parentNode;
    }
  }, _temp2;
}

Slider$2.Range = Range$2;
Slider$2.Handle = Handle$1;
Slider$2.createSliderWithTooltip = createSliderWithTooltip;

var _templateObject$8, _templateObject2$6;
var StyledSliderWrapper = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral$1(["\n\tfont-family: ", ";\n\t.rc-slider:not(.rc-slider-vertical) {\n\t\tmargin: ", "px 0 ", "px;\n\t}\n\n\t.rc-slider {\n\t\tposition: relative;\n\t\theight: ", "px;\n\t\twidth: 100%;\n\t\tborder-radius: ", ";\n\t\tbackground-color: ", ";\n\n\t\t&-track {\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\theight: ", "px;\n\t\t\tborder-radius: ", ";\n\t\t\tbackground-color: ", ";\n\t\t}\n\n\t\t&-handle {\n\t\t\tposition: absolute;\n\t\t\tmargin-left: -", "px;\n\t\t\tmargin-top: -", "px;\n\t\t\twidth: ", "px;\n\t\t\theight: ", "px;\n\t\t\tcursor: pointer;\n\t\t\tborder: 2px solid ", ";\n\t\t\tbackground-color: #fff;\n\t\t\tborder-radius: 50%;\n\n\t\t\t&:hover {\n\t\t\t\tborder-color: ", ";\n\t\t\t}\n\t\t\t&-active {\n\t\t\t\t&:active {\n\t\t\t\t\tbackground: ", ";\n\t\t\t\t\tbox-shadow: 0 0 5px ", ";\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.tip-value {\n\t\t\t\tposition: absolute;\n\t\t\t\tmargin-top: -24px;\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: ", ";\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tbackground: ", ";\n\t\t\t\tcolor: ", ";\n\t\t\t\tfont-size: ", ";\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 10px;\n\t\t\t\tpadding: 5px;\n\t\t\t\tbox-sizing: border-box;\n\n\t\t\t\tborder-radius: 3px;\n\n\t\t\t\tlabel {\n\t\t\t\t\tmargin: 0px;\n\t\t\t\t}\n\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tborder: 5px solid transparent;\n\t\t\t\t\tborder-top-color: ", ";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tbottom: -10px;\n\t\t\t\t\twidth: 0px;\n\t\t\t\t\theight: 0px;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\tmargin-left: -5px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&-mark {\n\t\t\tposition: absolute;\n\t\t\ttop: 10px;\n\t\t\tleft: 0;\n\t\t\twidth: 100%;\n\t\t\tfont-size: 12px;\n\t\t}\n\n\t\t&-mark-text {\n\t\t\tposition: absolute;\n\t\t\tdisplay: inline-block;\n\t\t\tvertical-align: middle;\n\t\t\ttext-align: center;\n\t\t\tcursor: pointer;\n\t\t\tcolor: #999;\n\n\t\t\t&-active {\n\t\t\t\tcolor: #666;\n\t\t\t}\n\t\t}\n\n\t\t&-step {\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\theight: 4px;\n\t\t\tmargin: 5px 0;\n\t\t\tbackground: transparent;\n\t\t}\n\n\t\t&-dot {\n\t\t\tposition: absolute;\n\t\t\tmargin-top: -8px;\n\t\t\tmargin-left: -4px;\n\t\t\twidth: 8px;\n\t\t\theight: 8px;\n\t\t\tborder: 2px solid ", ";\n\t\t\tbackground-color: #fff;\n\t\t\tcursor: pointer;\n\t\t\tvertical-align: middle;\n\n\t\t\tborder-radius: 50%;\n\n\t\t\t&:first-child {\n\t\t\t\tmargin-left: -4px;\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\tmargin-left: -4px;\n\t\t\t}\n\t\t\t&-active {\n\t\t\t\tborder-color: ", ";\n\t\t\t}\n\t\t}\n\n\t\t&-disabled {\n\t\t\tbackground-color: ", ";\n\n\t\t\t.rc-slider-track {\n\t\t\t\tbackground-color: ", ";\n\t\t\t}\n\n\t\t\t.rc-slider-handle,\n\t\t\t.rc-slider-dot {\n\t\t\t\tborder-color: ", ";\n\t\t\t\tbackground-color: #fff;\n\t\t\t\tcursor: not-allowed;\n\t\t\t}\n\n\t\t\t.rc-slider-mark-text,\n\t\t\t.rc-slider-dot {\n\t\t\t\tcursor: not-allowed !important;\n\t\t\t}\n\t\t}\n\n\t\t.min-value,\n\t\t.max-value {\n\t\t\tcolor: ", ";\n\t\t\tfont-weight: 300;\n\t\t\tfont-size: 1rem;\n\t\t\tmargin-top: 10px;\n\t\t}\n\t\t.max-value {\n\t\t\tfloat: right;\n\t\t}\n\t}\n\n\t.slider.vertical {\n\t\theight: 240px;\n\t\tdisplay: flex;\n\t\tposition: relative;\n\n\t\t.rc-slider {\n\t\t\tmargin-left: 40px;\n\t\t\twidth: ", "px;\n\t\t\theight: 100%;\n\t\t\tmin-height: 100px;\n\t\t}\n\n\t\t.control-label {\n\t\t\tmargin-right: ", "px;\n\t\t}\n\n\t\t.min-value,\n\t\t.max-value {\n\t\t\tposition: absolute;\n\t\t\tleft: -15px;\n\t\t\ttext-align: right;\n\t\t}\n\t\t.min-value {\n\t\t\tbottom: 0px;\n\t\t\tmargin-bottom: -5px;\n\t\t}\n\t\t.max-value {\n\t\t\ttop: 0px;\n\t\t\tmargin-top: 0px;\n\t\t\tmargin-left: -15px;\n\t\t\tfloat: none;\n\t\t}\n\t\t.rc-slider-handle label {\n\t\t\twidth: auto;\n\t\t\tright: -20px;\n\t\t\tmargin-top: -6px;\n\t\t}\n\t}\n\t.rc-slider-handle {\n\t\t.tip-value {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&:hover .tip-value {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\t.rc-slider-vertical {\n\t\twidth: 4px;\n\t\theight: 100%;\n\t\t.rc-slider {\n\t\t\t&-track {\n\t\t\t\tbottom: 0;\n\t\t\t\twidth: 4px;\n\t\t\t}\n\n\t\t\t&-handle {\n\t\t\t\tposition: absolute;\n\t\t\t\tmargin-left: -4px;\n\t\t\t\tmargin-bottom: -7px;\n\t\t\t}\n\n\t\t\t&-mark {\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 10px;\n\t\t\t\theight: 100%;\n\t\t\t}\n\n\t\t\t&-step {\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 4px;\n\t\t\t}\n\n\t\t\t&-dot {\n\t\t\t\tleft: 2px;\n\t\t\t\tmargin-bottom: -4px;\n\t\t\t\t&:first-child {\n\t\t\t\t\tmargin-bottom: -4px;\n\t\t\t\t}\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: -4px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (props) {
  return props.theme.gutter / 2;
}, function (props) {
  return props.theme.gutter;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.sliderHeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.sliderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.sliderTrackBg;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.sliderHeight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.sliderRadius;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.sliderActiveColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.sliderHandleSize / 2;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.sliderHandleSize / 2;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.sliderHandleSize;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.sliderHandleSize;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.sliderActiveColor;
}, function (_ref13) {
  var theme = _ref13.theme;
  return tintColor(theme.sliderActiveColor, -10);
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.sliderNobColorHover;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.primary;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.dusk;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.sliderTipValueBackground;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.sliderTipValueColor;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontSize;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.sliderTipValueBackground;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.sliderTrackBg;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.sliderActiveColor;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.inputBackgroundDisabled;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.inputBackgroundDisabled;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.inputBackgroundDisabled;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.sliderValueColor;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.sliderHeight;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.gutter / 2;
});

var TooltipComp = function TooltipComp(props) {
  return /*#__PURE__*/React__default.createElement(Tooltip$1, _extends$g({
    prefixCls: props.className
  }, props), props.children);
};

var SliderTooltip = styled(TooltipComp)(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral$1(["\n    position: absolute;\n    &-content{\n        font-size: 0.85em;\n        font-family: ", ";\n        background-color: ", ";\n        color:  ", ";\n        border-radius: ", ";\n          box-shadow: 0 0 4px #d9d9d9;\n    }\n  \n    &-inner {\n      padding: 6px 2px;\n      min-width: 24px;\n      font-size: 11px;\n      line-height: 1;\n      color:  ", ";\n      text-align: center;\n      text-decoration: none;\n      background-color: ", ";\n      border-radius: ", ";\n      box-shadow: 0 0 4px #d9d9d9;\n    }\n  \n    &-arrow {\n      position: absolute;\n      width: 0;\n      height: 0;\n      border-color: transparent;\n      border-style: solid;\n    }\n  \n    &-placement-top &-arrow {\n      bottom: ", " - ", "px;\n      left: 50%;\n      margin-left: -", "px;\n      border-width: ", "px ", "px 0;\n      border-top-color: ", ";\n    }\n  }\n\n\n  .rc-slider-tooltip-inner{\n    background-color: ", ";\n    color: ", ";\n  \n    &:AFTER{\n      content:\"\";\n      position: absolute;\n      width: 0px;\n      height: 0px;\n      border: 5px solid transparent;\n      border-top: 4px solid ", ";\n      bottom: 0px;\n      left: 50%;\n      margin-left: -5px;\n    }\n"])), function (_ref29) {
  var theme = _ref29.theme;
  return theme.fontFamily;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.sliderTipValueBackground;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.sliderTipValueColor;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.borderRadius;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.sliderTipValueColor;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.sliderTipValueBackground;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.borderRadius;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.sliderTooltipDistance;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.sliderTooltipArrowWidth;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.sliderTooltipArrowWidth;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.sliderTooltipArrowWidth;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.sliderTooltipArrowWidth;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.sliderTooltipArrowColor;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.sliderTooltipBg;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.sliderTooltipColor;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.sliderTooltipBg;
});

var Range = Slider$2.Range;
var Handle = Slider$2.Handle;

var SliderHandle = function SliderHandle(props) {
  var params = props.params;
      props.formatter;
      props.prefix;
      var alwaysVisible = props.alwaysVisible,
      placement = props.placement,
      rest = _objectWithoutProperties$c(props, ["params", "formatter", "prefix", "alwaysVisible", "placement"]);

  var value = params.value,
      dragging = params.dragging,
      index = params.index,
      offset = params.offset,
      restProps = _objectWithoutProperties$c(params, ["value", "dragging", "index", "offset"]);

  return /*#__PURE__*/React__default.createElement(SliderTooltip, {
    theme: rest.theme,
    overlay: value,
    visible: alwaysVisible || dragging,
    overlayClassName: dragging ? 'dragging' : '',
    placement: placement || 'top',
    key: index
  }, /*#__PURE__*/React__default.createElement(Handle, _extends$g({
    value: value
  }, restProps, rest, {
    offset: offset
  })));
};

var SliderComponent = function SliderComponent(props) {
  return props.isRange ? /*#__PURE__*/React__default.createElement(Range, props) : /*#__PURE__*/React__default.createElement(Slider$2, props);
};

var Slider = function Slider(props) {
  var formatter = function formatter(val) {
    if (props.valueFormatter) return props.valueFormatter(val);

    if (props.prefix) {
      return props.prefix + val;
    }

    return val;
  };

  var getHandle = function getHandle(params, formatter, prefix, alwaysVisible, placement) {
    return /*#__PURE__*/React__default.createElement(SliderHandle, {
      params: params,
      formatter: formatter,
      prefix: prefix,
      alwaysVisible: alwaysVisible,
      placement: placement,
      key: RandomID(6),
      theme: props.theme
    });
  };

  props.label;
      var prefix = props.prefix;
      props.vertical;
      var range = props.range;
      props.className;
      var alwaysVisible = props.alwaysVisible,
      placement = props.placement,
      rest = _objectWithoutProperties$c(props, ["label", "prefix", "vertical", "range", "className", "alwaysVisible", "placement"]);

  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, props, /*#__PURE__*/React__default.createElement(StyledSliderWrapper, props, /*#__PURE__*/React__default.createElement(SliderComponent, _extends$g({}, rest, {
    isRange: range,
    handle: function handle(params) {
      return getHandle(params, formatter, prefix, alwaysVisible, placement);
    },
    onChange: props.onChange,
    onAfterChange: props.onValueChange
  }), /*#__PURE__*/React__default.createElement(Wrapper$12, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React__default.createElement(Wrapper$V, {
    className: "min-value",
    key: "1"
  }, formatter(range && props.value ? props.value[0] : props.min)), /*#__PURE__*/React__default.createElement(Wrapper$V, {
    key: "2"
  }, formatter(range && props.value ? props.value[1] : props.max))))));
};

Slider.propTypes = {
  alwaysVisible: PropTypes.bool,
  valueFormatter: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  step: PropTypes.number,
  marks: PropTypes.object
};
Slider.defaultProps = {};
var Wrapper$f = withTheme(Slider);

var STEP_STYLE = {
  TABS: 'tabs',
  CIRCLE: 'circle'
};
/**
 *
 * Step component that renders the title only
 */

var Step = function Step(props) {
  var title = props.title,
      rest = _objectWithoutProperties$c(props, ["title"]); // keeping title out of the props passed to the DOM elements


  return /*#__PURE__*/React__default.createElement(Step$1, rest, rest.icon ? /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    icon: rest.icon,
    size: 24,
    color: rest.active ? rest.theme.stepColorActive : rest.theme.stepColor
  }) : undefined, /*#__PURE__*/React__default.createElement(StepTitle, null, title));
};
/**
 *
 * Stepper component
 */


var Stepper = function Stepper(props) {
  var _useState = useState(props.step),
      _useState2 = _slicedToArray$8(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  useEffect(function () {
    return setIndex(props.step);
  }, [props]);

  var handleChangeIndex = function handleChangeIndex(i) {
    if (!props.controlled) {
      setIndex(i);
    }

    if (props.onStepChange) props.onStepChange(i);
  };

  if (props.layout === LAYOUT.ACCORDION) {
    return /*#__PURE__*/React__default.createElement(Wrapper$$, _extends$g({}, props, {
      onTabChange: props.onStepChange
    }));
  }

  return /*#__PURE__*/React__default.createElement(StepperContainer, _extends$g({}, props, {
    flexDirection: props.layout === LAYOUT.HORIZONTAL ? 'row' : 'column'
  }), /*#__PURE__*/React__default.createElement(Wrapper$11, {
    width: props.layout === LAYOUT.HORIZONTAL ? [1, 1 / 4, 1 / 5] : 1
  }, /*#__PURE__*/React__default.createElement(StepperWrapper$1, _extends$g({}, props, {
    flexDirection: props.layout === LAYOUT.HORIZONTAL ? 'column' : 'row'
  }), React__default.Children.map(props.children, function (child, i) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      id: i + 1,
      layout: props.layout,
      stepStyle: props.stepStyle,
      onClick: function onClick() {
        return handleChangeIndex(i);
      },
      active: i <= index,
      current: i === index
    });
  }))), /*#__PURE__*/React__default.createElement(StepsContentContainer, _extends$g({}, props, {
    width: props.layout === LAYOUT.HORIZONTAL ? [1, 3 / 4, 4 / 5] : 1
  }), /*#__PURE__*/React__default.createElement(SwipeableViews, {
    index: index,
    onChangeIndex: handleChangeIndex
  }, React__default.Children.map(props.children, function (child) {
    return /*#__PURE__*/React__default.createElement(StepContent, props, child.props.children);
  }))));
};

Step.propTypes = {
  /** Title to render on each Step */
  title: PropTypes.node.isRequired,

  /** When provided, the an icon will be created before the title */
  icon: PropTypes.string
};
Step.defaultProps = {};
Stepper.propTypes = {
  /** An integer representing the current step number (starts from 0) */
  step: PropTypes.number,

  /** Defines whether the component is allowed to move next or is controlled by the step value */
  controlled: PropTypes.bool,

  /** fired when next step is triggered from the tabs  */
  onStepChange: PropTypes.func,

  /** Changes the layout: Horizontal will display the steps alongside the content. */
  layout: PropTypes.oneOf(objectValues(LAYOUT)),
  // /** Animates the height of the content to expand/shrink to its content */
  stepStyle: PropTypes.oneOf(objectValues(STEP_STYLE))
};
Stepper.defaultProps = {
  step: 0,
  controlled: false,
  stepStyle: STEP_STYLE.TABS,
  layout: LAYOUT.HORIZONTAL
};
var StepperWrapper = withTheme(Stepper);
withTheme(Step);

var _templateObject$7, _templateObject2$5, _templateObject3$4, _templateObject4$3, _templateObject5$3, _templateObject6$3, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
var TableContainer = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral$1(["\n\tdisplay: inline-block;\n\twidth: ", ";\n"])), function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? '100%' : 'auto';
});
var TableOuterWrapper = styled.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral$1(["\n\tposition: relative;\n\tdisplay: ", ";\n\toverflow-y: ", ";\n\t", "\n\n\t&:AFTER {\n\t\tcontent: '';\n\t\tdisplay: table;\n\t}\n"])), function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return fullWidth ? 'block' : 'inline-block';
}, function (_ref3) {
  var responsive = _ref3.responsive;
  return responsive ? 'unset' : 'auto';
}, function (_ref4) {
  var bordered = _ref4.bordered;
  return bordered ? css$4(["border:1px solid ", ";border-radius:", ";"], function (_ref5) {
    var theme = _ref5.theme;
    return theme.tableBorderColor;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.borderRadius;
  }) : undefined;
});
var SimpleTableWrapper = styled.table(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral$1(["\n\tfont-family: ", ";\n\tborder-collapse: collapse;\n\twidth: ", ";\n\tborder: none;\n\tposition: relative;\n\ttable-layout: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontFamily;
}, function (_ref8) {
  var fullWidth = _ref8.fullWidth;
  return fullWidth ? '100%' : undefined;
}, function (_ref9) {
  var responsive = _ref9.responsive;
  return responsive ? 'fixed' : 'auto';
});
var TableHeaderRow = styled.tr(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral$1(["\n\tborder-bottom: 1px solid ", ";\n\n\t&:first-child {\n\t\t& th:first-child {\n\t\t\tborder-top-left-radius: ", ";\n\t\t}\n\t\t& th:last-child {\n\t\t\tborder-top-right-radius: ", ";\n\t\t}\n\t}\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.tableBorderColor;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.borderRadius;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.borderRadius;
});
var SimpleTableHead = styled.thead(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral$1(["\n\tbackground: ", ";\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.tableHeaderBackground;
});

var getHeadPadding = function getHeadPadding(_ref14) {
  var theme = _ref14.theme,
      isActionsColumn = _ref14.isActionsColumn;
  var paddingY = theme.tableHeaderCellPaddingY;
  var paddingX = theme.tableHeaderCellPaddingX;

  if (isActionsColumn) {
    paddingX = '6px';
  }

  return "".concat(paddingY, " ").concat(paddingX);
};

var getCellPadding = function getCellPadding(_ref15) {
  var theme = _ref15.theme,
      isEditable = _ref15.isEditable,
      isActionsColumn = _ref15.isActionsColumn;
  var paddingY = theme.tableCellPaddingY;
  var paddingX = theme.tableCellPaddingX;

  if (isActionsColumn) {
    paddingX = '6px';
  }

  if (isEditable) {
    paddingY = '4px';
  }

  return "".concat(paddingY, " ").concat(paddingX);
};

var StyledHeaderCell = styled.th(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral$1(["\n\tpadding: ", ";\n\ttext-align: ", ";\n\tfont-weight: normal;\n"])), getHeadPadding, function (_ref17) {
  var colSpan = _ref17.colSpan;
  return colSpan > 1 ? 'center' : 'left';
});
var StyledHeaderLabel = styled.label(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral$1(["\n\tcolor: ", ";\n\tfont-weight: ", ";\n\tfont-size: ", ";\n\tline-height: 1.55;\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: ", ";\n"])), function (_ref18) {
  var theme = _ref18.theme;
  return theme.tableHeaderColor;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.tableHeaderWeight;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.tableHeaderSize;
}, function (_ref21) {
  var isSortable = _ref21.isSortable;
  return isSortable ? 'pointer' : 'default';
});
var StyledCell = styled.td(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral$1(["\n\tpadding: ", ";\n\tfont-size: ", ";\n\tposition: relative;\n\tcursor: default;\n\toverflow: ", ";\n\tword-wrap: ", ";\n\twhite-space: ", ";\n\ttext-overflow: ellipsis;\n"])), getCellPadding, function (_ref22) {
  var theme = _ref22.theme;
  return theme.tableCellSize;
}, function (_ref23) {
  var isActionsCell = _ref23.isActionsCell,
      trim = _ref23.trim;
  return !isActionsCell && trim ? 'hidden' : 'visible';
}, function (_ref24) {
  var trim = _ref24.trim;
  return trim ? 'normal' : 'break-word';
}, function (_ref25) {
  var trim = _ref25.trim;
  return trim ? 'nowrap' : 'normal';
});
var StyledRow = styled.tr(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral$1(["\n\tborder-bottom: 1px solid ", ";\n\tcolor: ", ";\n\tbackground: ", ";\n\tposition: relative;\n\ttransition: all 0.25s linear;\n\n\t&:last-child {\n\t\t& td:first-child {\n\t\t\tborder-bottom-left-radius: ", ";\n\t\t}\n\t\t& td:last-child {\n\t\t\tborder-bottom-right-radius: ", ";\n\t\t}\n\t}\n\n\t", "\n\n\t&:HOVER {\n\t\tbackground: ", ";\n\t}\n\t", "\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.tableRowBorderColor;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.tableRowTextColor;
}, function (_ref28) {
  var selected = _ref28.selected,
      theme = _ref28.theme;
  return selected ? theme.tableRowSelectedColor : theme.tableRowDefaultBackground;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.borderRadius;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.borderRadius;
}, function (props) {
  return props.bordered ? css$4(["&:last-child{border-bottom:none;}"]) : undefined;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.tableRowHoverColor;
}, function (_ref32) {
  var isLoading = _ref32.isLoading;
  return isLoading && css$4(["opacity:0.4;"]);
});
var Loading = function Loading() {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-60%, 0%)'
    }
  }, /*#__PURE__*/React__default.createElement(Wrapper$U, null));
};
var StyledEditableCell = styled.input(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral$1(["\n\t", ";\n\tborder-color: transparent;\n\tbackground-color: transparent;\n\ttransition: all 0.25s linear;\n\n\t&:hover {\n\t\tborder-color: ", ";\n\t\tbackground-color: white;\n\t}\n\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmin-height: ", ";\n"])), FormControlStyled, function (_ref33) {
  var theme = _ref33.theme;
  return theme.inputBorderColor;
}, function (_ref34) {
  var theme = _ref34.theme;
  return "calc( ".concat(theme.inputHeight, " - 4px)");
});
styled.td(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral$1(["\n\t", "\n"])), function (_ref35) {
  var selected = _ref35.selected;
  return selected ? css$4(["background:", ";"], function (_ref36) {
    var theme = _ref36.theme;
    return theme.primary;
  }) : undefined;
});
var SortButtonsWrapper = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral$1(["\n\twidth: 12px;\n\tpadding-left: 4px;\n"])));
var PaginationLabel = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral$1(["\n\tfont-size: ", ";\n\tfont-family: ", ";\n\tfont-weight: ", ";\n\tcolor: ", ";\n\tpadding: 0px 5px;\n\t", "\n"])), function (_ref37) {
  var theme = _ref37.theme;
  return theme.fontSize;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.fontFamily;
}, function (_ref39) {
  var bold = _ref39.bold;
  return bold ? 600 : 400;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.textColor;
}, function (_ref41) {
  var disabled = _ref41.disabled;
  return disabled && css$4(["opacity:0.4;"]);
});
var PaginationWrapper = styled(Wrapper$12)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral$1(["\n\tpadding: 20px 0 10px;\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: ", ";\n\tfont-family: ", ";\n"])), function (_ref42) {
  var theme = _ref42.theme;
  return theme.fontSize;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.fontFamily;
});

var Paginator = function Paginator(_ref44) {
  var className = _ref44.className,
      props = _objectWithoutProperties$c(_ref44, ["className"]);

  return /*#__PURE__*/React__default.createElement(ReactPaginate, _extends$g({
    containerClassName: className
  }, props));
};

var StyledPagination = styled(Paginator)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral$1(["\n\tmargin: 0px;\n\tpadding: 0px;\n\tlist-style: none;\n\tdisplay: flex;\n\talign-items: center;\n\n\tli {\n\t\ta {\n\t\t\tcursor: pointer;\n\t\t\tdisplay: inline-block;\n\t\t\tvertical-align: middle;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder: 1px solid ", ";\n\t\t\tborder-radius: ", ";\n\t\t\tbackground: ", ";\n\t\t\tcolor: ", ";\n\t\t\theight: ", ";\n\t\t\tmin-width: ", ";\n\t\t\ttext-align: center;\n\t\t\tline-height: ", ";\n\t\t\tmargin: 0px 3px;\n\t\t\tpadding: 0px ", "px;\n\t\t\tuser-select: none;\n\t\t\t&:focus {\n\t\t\t\toutline: none;\n\t\t\t\tbox-shadow: ", ";\n\t\t\t}\n\t\t}\n\t\t& a:hover,\n\t\t&.active a {\n\t\t\tcolor: ", ";\n\t\t\tborder-color: ", ";\n\t\t\tsvg,\n\t\t\tuse {\n\t\t\t\tfill: ", ";\n\t\t\t}\n\t\t}\n\n\t\t&.disabled a {\n\t\t\tcolor: ", ";\n\t\t\tborder-color: ", ";\n\t\t\tfill: ", ";\n\t\t\tcursor: default;\n\t\t\tsvg,\n\t\t\tuse {\n\t\t\t\tcursor: default;\n\t\t\t\tfill: ", ";\n\t\t\t}\n\t\t\t&:focus {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\t\t}\n\t}\n"])), function (_ref45) {
  var theme = _ref45.theme;
  return theme.inputBorderColor;
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.borderRadius;
}, function (_ref47) {
  var theme = _ref47.theme;
  return theme.paginationButtonBackground;
}, function (_ref48) {
  var theme = _ref48.theme;
  return theme.paginationButtonColor;
}, function (_ref49) {
  var theme = _ref49.theme;
  return theme.inputHeight_normal;
}, function (_ref50) {
  var theme = _ref50.theme;
  return theme.inputHeight_normal;
}, function (_ref51) {
  var theme = _ref51.theme;
  return "".concat(parseInt(theme.inputHeight_normal) - 2, "px");
}, function (_ref52) {
  var theme = _ref52.theme;
  return theme.space[1];
}, function (_ref53) {
  var theme = _ref53.theme;
  return theme.focusOutline;
}, function (_ref54) {
  var theme = _ref54.theme,
      disabled = _ref54.disabled;
  return !disabled && theme.paginationButtonHover;
}, function (_ref55) {
  var theme = _ref55.theme,
      disabled = _ref55.disabled;
  return !disabled && theme.paginationButtonHover;
}, function (_ref56) {
  var theme = _ref56.theme,
      disabled = _ref56.disabled;
  return !disabled && theme.paginationButtonHover;
}, function (_ref57) {
  var theme = _ref57.theme;
  return theme.paginationButtonDisabled;
}, function (_ref58) {
  var theme = _ref58.theme;
  return theme.paginationButtonDisabled;
}, function (_ref59) {
  var theme = _ref59.theme;
  return theme.paginationButtonDisabled;
}, function (_ref60) {
  var theme = _ref60.theme;
  return theme.paginationButtonDisabled;
});

var TextEdit = function TextEdit(_ref) {
  var initialValue = _ref.cell.value,
      handleOnChange = _ref.handleOnChange,
      onBlur = _ref.onBlur;

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray$8(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var onChange = function onChange(val) {
    setValue(val);
  };

  useEffect(function () {
    setValue(initialValue);
  }, [initialValue]);
  return /*#__PURE__*/React__default.createElement(Wrapper$x, {
    value: value,
    onValueChange: handleOnChange,
    onChange: onChange,
    onBlur: onBlur,
    nested: true
  });
};

var DateEdit = function DateEdit(_ref) {
  var initialValue = _ref.cell.value;
      _ref.row.index;
      var _ref$column = _ref.column;
      _ref$column.id;
      var format = _ref$column.format,
      handleOnChange = _ref.handleOnChange;
      _ref.onBlur;
      _objectWithoutProperties$c(_ref, ["cell", "row", "column", "handleOnChange", "onBlur"]);

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray$8(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var onChange = function onChange(date) {
    setValue(date);
    handleOnChange(date);
  };

  useEffect(function () {
    setValue(initialValue);
  }, [initialValue]);
  return /*#__PURE__*/React__default.createElement(Wrapper$H, {
    value: value,
    onChange: onChange,
    nested: true,
    format: format,
    focused: true,
    withTime: true
  });
};

DateEdit.propTypes = {};

var OptionsEdit = function OptionsEdit(_ref) {
  var initialValue = _ref.cell.value;
      _ref.row.index;
      var _ref$column = _ref.column;
      _ref$column.id;
      _ref$column.options;
      var handleOnChange = _ref.handleOnChange,
      onBlur = _ref.onBlur,
      props = _objectWithoutProperties$c(_ref, ["cell", "row", "column", "handleOnChange", "onBlur"]);

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray$8(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var onChange = function onChange(val) {
    setValue(val);
    handleOnChange(val.value);
  };

  useEffect(function () {
    setValue(initialValue);
  }, [initialValue]);
  return /*#__PURE__*/React__default.createElement(Wrapper$S, _extends$g({}, props, {
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    nested: true,
    autoFocus: true
  }));
};

OptionsEdit.propTypes = {};

var AsyncEdit = function AsyncEdit(_ref) {
  var initialValue = _ref.cell.value;
      _ref.row;
      _ref.column;
      var handleOnChange = _ref.handleOnChange,
      onBlur = _ref.onBlur,
      props = _objectWithoutProperties$c(_ref, ["cell", "row", "column", "handleOnChange", "onBlur"]);

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray$8(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var onChange = function onChange(val) {
    setValue(val);
    handleOnChange(val.value);
  };

  useEffect(function () {
    if (typeof initialValue === 'string' || typeof initialValue === 'number') {
      initialValue = {
        value: initialValue,
        label: initialValue
      };
    }

    setValue(initialValue);
  }, [initialValue]);
  return /*#__PURE__*/React__default.createElement(Wrapper$O, _extends$g({}, props, {
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    nested: true,
    autoFocus: true
  }));
};

AsyncEdit.propTypes = {};

var EditableCell = function EditableCell(_ref) {
  _ref.data;
      _ref.headers;
      var onDataChange = _ref.onDataChange,
      props = _objectWithoutProperties$c(_ref, ["data", "headers", "onDataChange"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray$8(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var EditableComponent = null;

  switch (props.column.type) {
    case 'date':
      EditableComponent = DateEdit;
      break;

    case 'options':
      EditableComponent = OptionsEdit;
      break;

    case 'async':
      EditableComponent = AsyncEdit;
      break;

    default:
      EditableComponent = TextEdit;
      break;
  }

  var handleOnChange = function handleOnChange(value) {
    setActive(false);
    onDataChange(props.row.index, props.column.id, value);
  };

  return /*#__PURE__*/React__default.createElement("div", null, active ? /*#__PURE__*/React__default.createElement(EditableComponent, _extends$g({}, props, props.column.props, {
    handleOnChange: handleOnChange,
    onBlur: function onBlur() {
      setActive(false);
    },
    minWidth: 1
  })) : /*#__PURE__*/React__default.createElement(StyledEditableCell, {
    readOnly: true,
    theme: props.theme,
    onClick: function onClick() {
      return setActive(true);
    },
    onChange: function onChange() {},
    value: props.cell.value || ''
  }));
};

var Wrapper$e = withTheme(EditableCell);

var RowSelect = function RowSelect(_ref) {
  var checked = _ref.checked,
      _onChange = _ref.onChange,
      isLoading = _ref.isLoading,
      rest = _objectWithoutProperties$c(_ref, ["checked", "onChange", "isLoading"]);

  return /*#__PURE__*/React__default.createElement(Wrapper$Q, _extends$g({}, rest, {
    value: checked,
    onChange: function onChange(v, e) {
      return _onChange(e);
    },
    tabIndex: -1,
    disabled: isLoading
  }));
};

RowSelect.propTypes = {
  checked: PropTypes.bool,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func
};
RowSelect.defaultProps = {
  checked: false,
  isLoading: false,
  onChange: function onChange() {}
};

var useSelect = function useSelect(isSelectable, isLoading) {
  return function (hooks) {
    if (isSelectable) {
      hooks.visibleColumns.push(function (columns) {
        return [{
          id: 'selection',
          width: 36,
          Header: function Header(_ref) {
            var getToggleAllRowsSelectedProps = _ref.getToggleAllRowsSelectedProps;
            return /*#__PURE__*/React__default.createElement(RowSelect, _extends$g({}, getToggleAllRowsSelectedProps(), {
              isLoading: isLoading
            }));
          },
          Cell: function Cell(_ref2) {
            var row = _ref2.row;
            return /*#__PURE__*/React__default.createElement(RowSelect, _extends$g({}, row.getToggleRowSelectedProps(), {
              isLoading: isLoading,
              isSelected: row.isSelected
            }));
          },
          EditableCell: function EditableCell(_ref3) {
            var row = _ref3.row;
            return /*#__PURE__*/React__default.createElement(RowSelect, _extends$g({}, row.getToggleRowSelectedProps(), {
              isLoading: isLoading,
              isSelected: row.isSelected
            }));
          }
        }].concat(_toConsumableArray$2(columns));
      });
    }
  };
};

var ActionsCell = /*#__PURE__*/function (_React$Component) {
  _inherits$c(ActionsCell, _React$Component);

  var _super = _createSuper$b(ActionsCell);

  function ActionsCell() {
    var _this;

    _classCallCheck$j(this, ActionsCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$k(_assertThisInitialized$b(_this), "handleClick", function (item) {
      if (item.action) {
        var _this$props = _this.props,
            values = _this$props.values,
            index = _this$props.index,
            isSelected = _this$props.isSelected;
        item.action(values, index, isSelected);
      }
    });

    return _this;
  }

  _createClass$i(ActionsCell, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var mainActions = this.props.actions.filter(function (a) {
        return a.visible;
      });
      var otherActions = this.props.actions.filter(function (a) {
        return !a.visible;
      });
      var iconSize = 18;
      var theme = this.props.theme;
      return /*#__PURE__*/React__default.createElement(Wrapper$12, {
        alignItems: "center",
        justifyContent: "flex-end"
      }, mainActions.map(function (a, i) {
        if (a.isButton) {
          return /*#__PURE__*/React__default.createElement(ButtonWrapper, {
            key: i,
            icon: a.icon,
            variation: a.variation,
            onClick: function onClick() {
              return _this2.handleClick(a);
            },
            size: "sm",
            label: a.label,
            mb: 0
          });
        }

        return /*#__PURE__*/React__default.createElement(Wrapper$Z, {
          key: i,
          icon: a.icon,
          tooltip: a.label,
          color: theme.tableRowTextColor,
          onClick: function onClick() {
            return _this2.handleClick(a);
          },
          size: iconSize
        });
      }), otherActions.length ? /*#__PURE__*/React__default.createElement(Wrapper$I, {
        trigger: /*#__PURE__*/React__default.createElement(Wrapper$Z, {
          icon: "ellipses-v",
          color: theme.tableRowTextColor,
          size: iconSize
        }),
        direction: "left"
      }, otherActions.map(function (o, i) {
        return /*#__PURE__*/React__default.createElement(Wrapper$D, {
          onClick: function onClick() {
            return _this2.handleClick(o);
          },
          key: i
        }, /*#__PURE__*/React__default.createElement(Wrapper$12, {
          alignItems: "center"
        }, o.icon && /*#__PURE__*/React__default.createElement(Wrapper$Z, {
          icon: o.icon,
          tooltip: o.label,
          size: 16,
          color: theme.tableRowTextColor,
          mr: 1
        }), /*#__PURE__*/React__default.createElement(Wrapper$Y, {
          label: o.label,
          mb: 0
        })));
      })) : undefined);
    }
  }]);

  return ActionsCell;
}(React__default.Component);

ActionsCell.propTypes = {};

var useActions = function useActions(_ref) {
  var rowActions = _ref.rowActions,
      theme = _ref.theme;
  return function (hooks) {
    if (rowActions.length) {
      hooks.visibleColumns.push(function (columns) {
        return [].concat(_toConsumableArray$2(columns), [{
          id: 'actions',
          Cell: rowActions.length ? function (_ref2) {
            var _ref2$row = _ref2.row,
                original = _ref2$row.original,
                index = _ref2$row.index,
                isSelected = _ref2$row.isSelected;
            return /*#__PURE__*/React__default.createElement(ActionsCell, {
              theme: theme,
              values: original,
              index: index,
              isSelected: isSelected,
              actions: rowActions
            });
          } : /*#__PURE__*/React__default.createElement("span", null),
          EditableCell: rowActions.length ? function (_ref3) {
            var _ref3$row = _ref3.row,
                original = _ref3$row.original,
                index = _ref3$row.index,
                isSelected = _ref3$row.isSelected;
            return /*#__PURE__*/React__default.createElement(ActionsCell, {
              theme: theme,
              actions: rowActions,
              values: original,
              index: index,
              isSelected: isSelected
            });
          } : /*#__PURE__*/React__default.createElement("span", null)
        }]);
      });
    }
  };
};

function Pagination(props) {
  var show = props.show,
      total = props.total,
      pageSize = props.pageSize,
      pageSizes = props.pageSizes,
      showPageSize = props.showPageSize,
      showGoTo = props.showGoTo,
      setPageSize = props.setPageSize,
      pageIndex = props.pageIndex,
      gotoPage = props.gotoPage,
      totalLabel = props.totalLabel,
      pageLabel = props.pageLabel,
      gotoLabel = props.gotoLabel,
      theme = props.theme;
      props.fullWidth;
      var rest = _objectWithoutProperties$c(props, ["show", "total", "pageSize", "pageSizes", "showPageSize", "showGoTo", "setPageSize", "pageIndex", "gotoPage", "totalLabel", "pageLabel", "gotoLabel", "theme", "fullWidth"]);

  var pageCount = Math.ceil(total / pageSize);
  var pagesList = pageSizes.map(function (p) {
    return {
      value: p,
      label: "".concat(p, "/").concat(pageLabel)
    };
  });

  var handlePageSelect = function handlePageSelect(_ref) {
    var selected = _ref.selected;
    gotoPage(selected);
  };

  if (show) {
    return /*#__PURE__*/React__default.createElement(PaginationWrapper, {
      theme: theme
    }, /*#__PURE__*/React__default.createElement(PaginationLabel, {
      theme: theme,
      bold: true,
      disabled: rest.disabled
    }, "".concat(total, " ").concat(totalLabel)), /*#__PURE__*/React__default.createElement(StyledPagination, _extends$g({}, rest, {
      pageCount: pageCount,
      previousLabel: /*#__PURE__*/React__default.createElement(Wrapper$Z, {
        icon: "caret-left",
        size: 22,
        color: theme.paginationButtonColor,
        cursor: "pointer"
      }),
      nextLabel: /*#__PURE__*/React__default.createElement(Wrapper$Z, {
        icon: "caret-right",
        size: 22,
        color: theme.paginationButtonColor,
        cursor: "pointer"
      }),
      breakLabel: "...",
      hasNextPage: false,
      initialPage: pageIndex,
      forcePage: pageIndex,
      onPageChange: handlePageSelect,
      theme: theme,
      activeClassName: "active"
    })), showPageSize && /*#__PURE__*/React__default.createElement(Wrapper$S, {
      options: pagesList,
      value: pageSize,
      minWidth: "100px",
      width: "auto",
      mb: 0,
      mx: 1,
      size: "normal",
      transformOut: function transformOut(v) {
        return Number(v.value);
      },
      onChange: setPageSize,
      disabled: rest.disabled,
      isSearchable: false
    }), showGoTo && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PaginationLabel, {
      theme: theme,
      disabled: rest.disabled
    }, gotoLabel), /*#__PURE__*/React__default.createElement(Wrapper$x, {
      width: 50,
      size: "normal",
      type: "number",
      onChange: function onChange(v) {
        return handlePageSelect({
          selected: v - 1
        });
      },
      mb: 0,
      inputProps: {
        style: {
          textAlign: 'center'
        }
      },
      disabled: rest.disabled
    })));
  }

  return null;
}

Pagination.propTypes = _defineProperty$k({
  /* Controls whether to show the pagination or not */
  show: PropTypes.bool,

  /* Number of rows to display per page */
  pageSize: PropTypes.number,

  /* Array of page sizes */
  pageSizes: PropTypes.arrayOf(PropTypes.number),

  /* Allow user to change page size */
  showPageSize: PropTypes.bool,

  /* Show Go To field */
  showGoTo: PropTypes.bool,

  /** If provided, first button will be rendered and called to bring first page */
  onFirst: PropTypes.func,

  /** Custom label for the first page button */
  firstButtonLabel: PropTypes.string,

  /** If provided, last button will be rendered and called to bring last page */
  onLast: PropTypes.func,

  /** Custom label for the last page button */
  lastButtonLabel: PropTypes.string,

  /** Main function called when a page is called, Return the number of the page called */
  onPageSelect: PropTypes.func,

  /** The range of pages displayed */
  marginPagesDisplayed: PropTypes.number,

  /** The number of pages to display for margins */
  pageRangeDisplayed: PropTypes.number,

  /** The initial page selected */
  initialPage: PropTypes.number,

  /** Provided page from props */
  forcePage: PropTypes.number,

  /** Number of pages to render */
  pageCount: PropTypes.number,

  /** Total label */
  totalLabel: PropTypes.string,

  /** i18n for page size label */
  pageLabel: PropTypes.string,

  /** goto label */
  gotoLabel: PropTypes.string
}, "pageSizes", PropTypes.arrayOf(PropTypes.number));
Pagination.defaultProps = {
  show: true,
  marginPagesDisplayed: 2,
  pageRangeDisplayed: 3,
  initialPage: 0,
  pageLabel: 'page',
  totalLabel: 'Total results',
  gotoLabel: 'Go to',
  pageSize: 10,
  pageSizes: [10, 25, 50, 100],
  showPageSize: true,
  showGoTo: true
};
var Wrapper$d = withTheme(Pagination);

var _templateObject$6;
var Label = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral$1(["\n\tfont-family: ", ";\n\tfont-weight: ", ";\n\tfont-size: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.noDataFontSize;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.noDataColor;
});

function Empty(_ref4) {
  var theme = _ref4.theme,
      noDataLabel = _ref4.noDataLabel;
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: '50px 0px',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: '100px'
    }
  }, /*#__PURE__*/React__default.createElement("svg", {
    width: "184",
    height: "100%",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(24 31.67)"
  }, /*#__PURE__*/React__default.createElement("ellipse", {
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668",
    fill: "#f5f5f5",
    fillOpacity: 0.8
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "aeb8c2",
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "url(#linearGradient-1)",
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    transform: "translate(13.56)"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#f5f5f5",
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#dce0e6",
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: "#dce0e6",
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
  }), /*#__PURE__*/React__default.createElement("g", {
    fill: "#fff",
    transform: "translate(149.65 15.383)"
  }, /*#__PURE__*/React__default.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))))), /*#__PURE__*/React__default.createElement(Label, {
    theme: theme
  }, noDataLabel));
}

var _templateObject$5, _templateObject2$4, _templateObject3$3;
var ArrowBase = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral$1(["\n\theight: 0px;\n\twidth: 0px;\n\tborder: 5px solid transparent;\n"])));
var ArrowUp = styled(ArrowBase)(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral$1(["\n\tborder-top-width: 0px;\n\tborder-bottom-color: ", ";\n\tmargin-bottom: 2px;\n"])), function (_ref) {
  var theme = _ref.theme,
      active = _ref.active;
  return active ? theme.primary : '#ccc';
});
var ArrowDown = styled(ArrowBase)(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral$1(["\n\tmargin-top: 2px;\n\tborder-bottom-width: 0px;\n\tborder-top-color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme,
      active = _ref2.active;
  return active ? theme.primary : '#ccc';
});

function SortButtons(_ref3) {
  var isSorted = _ref3.isSorted,
      isSortedDesc = _ref3.isSortedDesc,
      theme = _ref3.theme;
  return /*#__PURE__*/React__default.createElement(SortButtonsWrapper, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(ArrowUp, {
    active: isSorted && !isSortedDesc,
    theme: theme
  }), /*#__PURE__*/React__default.createElement(ArrowDown, {
    active: isSorted && isSortedDesc,
    theme: theme
  }));
}

SortButtons.defaultProps = {};
var Wrapper$c = withTheme(SortButtons);

var _templateObject$4, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$2;
var shimmerAnim = keyframes$2(["0%{background-position:-468px 0}100%{background-position:468px 0}"]);
var Shimmer = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral$1(["\n\tanimation-duration: 1.8s;\n\tanimation-fill-mode: forwards;\n\tanimation-iteration-count: infinite;\n\tanimation-name: ", ";\n\tanimation-timing-function: linear;\n\tbackground: #f6f7f8;\n\tbackground: linear-gradient(to right, #fafafa 8%, #eaeaea 38%, #fafafa 54%);\n\tbackground-size: 1000px 640px;\n\tposition: relative;\n\theight: 24px;\n\twidth: 100%;\n\tborder-radius: 4px;\n\tbox-sizing: border-box;\n"])), shimmerAnim);
var LoadingWrapper = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral$1(["\n\twidth: 100%;\n\tborder-radius: ", ";\n\toverflow: hidden;\n\tborder: 1px solid ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme ? theme.borderRadius : '4px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme ? theme.tableBorderColor : '#ccc';
});
var Row$2 = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral$1(["\n\tdisplay: flex;\n\theight: 56px;\n\twidth: 100%;\n\tborder-bottom: 1px solid ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme ? theme.tableBorderColor : '#ccc';
});
var Head = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral$1(["\n\tbackground: ", ";\n\theight: 100%;\n\twidth: 100%;\n\tpadding: 16px;\n\tbox-sizing: border-box;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme ? theme.grey300 : '#ccc';
});
var Title = styled.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral$1(["\n\tbackground: ", ";\n\theight: 20px;\n\twidth: 100%;\n\tborder-radius: 4px;\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme ? theme.grey100 : '#efefef';
});
var Cell$1 = styled.div(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral$1(["\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 16px;\n\tbox-sizing: border-box;\n"])));

var TableLoading = function TableLoading(_ref6) {
  var columns = _ref6.columns,
      rows = _ref6.rows,
      theme = _ref6.theme;
  return /*#__PURE__*/React__default.createElement(LoadingWrapper, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(Row$2, {
    theme: theme
  }, _toConsumableArray$2(Array(columns)).map(function (c, i) {
    return /*#__PURE__*/React__default.createElement(Head, {
      key: "".concat(i),
      theme: theme
    }, /*#__PURE__*/React__default.createElement(Title, {
      theme: theme
    }));
  })), _toConsumableArray$2(Array(rows)).map(function (r, j) {
    return /*#__PURE__*/React__default.createElement(Row$2, {
      key: "".concat(j),
      theme: theme
    }, _toConsumableArray$2(Array(columns)).map(function (c, i) {
      return /*#__PURE__*/React__default.createElement(Cell$1, {
        key: "".concat(i, "-").concat(j),
        theme: theme
      }, /*#__PURE__*/React__default.createElement(Shimmer, {
        theme: theme
      }));
    }));
  }));
};

TableLoading.defaultProps = {
  columns: 5,
  rows: 5
};
var Wrapper$b = withTheme(TableLoading);

var Cell = /*#__PURE__*/React__default.memo(function (props) {
  var trim = props.trim,
      render = props.render,
      isEditable = props.isEditable;
      props.selectChange;
      var rest = _objectWithoutProperties$c(props, ["trim", "render", "isEditable", "selectChange"]);

  return /*#__PURE__*/React__default.createElement(StyledCell, _extends$g({}, rest, {
    isEditable: isEditable,
    trim: trim
  }), render(isEditable ? 'EditableCell' : 'Cell'));
});

var Row = function Row(props) {
  var cells = props.cells,
      isEditable = props.isEditable,
      trim = props.trim,
      data = props.data,
      _onClick = props.onClick,
      rest = _objectWithoutProperties$c(props, ["cells", "isEditable", "trim", "data", "onClick"]);

  var getCells = React__default.useCallback(function () {
    return cells.map(function (cell, i) {
      var cellProps = cell.getCellProps();
      var isActionsCell = cellProps.key.indexOf('_actions') > 0;
      return /*#__PURE__*/React__default.createElement(Cell, _extends$g({}, cellProps, {
        onClick: function onClick(e) {
          return _onClick(e, data);
        },
        theme: rest.theme,
        render: cell.render,
        trim: trim,
        isEditable: isEditable,
        isActionsCell: isActionsCell,
        selectChange: rest.selected,
        isSelectionColumn: cell.column.id === 'selection'
      }));
    });
  }, [cells]);
  return /*#__PURE__*/React__default.createElement(StyledRow, rest, getCells());
};

var Row$1 = /*#__PURE__*/React__default.memo(Row);

var ALIGNMENT = {
  left: "flex-start",
  center: "center",
  right: "flex-end"
};

function Table(props) {
  var data = props.data,
      total = props.total,
      fullWidth = props.fullWidth,
      bordered = props.bordered,
      currentPage = props.pageIndex,
      isEditable = props.isEditable,
      isSelectable = props.isSelectable,
      onRowSelect = props.onRowSelect,
      onRowClick = props.onRowClick,
      onDataChange = props.onDataChange,
      fetchData = props.fetchData,
      sort = props.sort,
      onSort = props.onSort,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      labels = props.labels,
      responsive = props.responsive,
      tableWrapper = props.tableWrapper,
      theme = props.theme,
      trim = props.trim,
      customRowStyles = props.customRowStyles,
      paginationOptions = props.paginationOptions;
  var columns = React__default.useMemo(function () {
    return props.columns;
  }, [props.columns]);
  var _paginationOptions$pa = paginationOptions.pageSize,
      rowsPerPage = _paginationOptions$pa === void 0 ? 10 : _paginationOptions$pa,
      paginationAlign = paginationOptions.align;
  var isInitialized = data !== undefined;
  var defaultColumn = {
    EditableCell: Wrapper$e,
    width: "auto"
  };
  var totalRows = total || data.length;

  var getPageCount = function getPageCount() {
    return Math.ceil(totalRows / rowsPerPage);
  };

  var _useTable = useTable({
    columns: columns,
    data: data,
    defaultColumn: defaultColumn,
    initialState: {
      pageIndex: currentPage,
      pageSize: rowsPerPage
    },
    manualPagination: isInitialized && totalRows > data.length,
    pageCount: getPageCount(),
    manualSortBy: !!onSort,
    onDataChange: onDataChange
  }, useSortBy, usePagination, useRowSelect, useSelect(isSelectable, isLoading), useActions(props)),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups;
      _useTable.rows;
      var page = _useTable.page,
      prepareRow = _useTable.prepareRow,
      selectedFlatRows = _useTable.selectedFlatRows,
      _useTable$state = _useTable.state,
      selectedRowIds = _useTable$state.selectedRowIds,
      pageIndex = _useTable$state.pageIndex,
      pageSize = _useTable$state.pageSize,
      sortBy = _useTable$state.sortBy,
      stateProps = _objectWithoutProperties$c(_useTable$state, ["selectedRowIds", "pageIndex", "pageSize", "sortBy"]),
      setPageSize = _useTable.setPageSize,
      rest = _objectWithoutProperties$c(_useTable, ["getTableProps", "getTableBodyProps", "headerGroups", "rows", "page", "prepareRow", "selectedFlatRows", "state", "setPageSize"]);
  /**
   * Fetch data if controlled table
   */


  useEffect(function () {
    if (fetchData) {
      fetchData(pageIndex, pageSize);
    }
  }, [pageIndex, pageSize]);
  /**
   * Announce sort
   *  */

  useEffect(function () {
    if (onSort) onSort(sortBy);
  }, [sortBy]);
  /**
   * Announce selected rows
   *  */

  useEffect(function () {
    onRowSelect(selectedFlatRows.map(function (row) {
      return row.original;
    }));
  }, [selectedRowIds]);
  /**
   * Fired when table is editable and data is changed
   */

  var handleRowClick = function handleRowClick(event, rowData) {
    if (!isEditable && event.target.getAttribute("role") === "cell") {
      onRowClick(rowData);
    }
  };
  /**
   * Table properties
   */


  var tableProps = _objectSpread2$2(_objectSpread2$2({}, getTableProps()), {}, {
    theme: theme,
    fullWidth: fullWidth,
    responsive: responsive
  });
  /**
   * Header properties
   */


  var headerCellProps = function headerCellProps(column) {
    return _objectSpread2$2(_objectSpread2$2({}, column.getHeaderProps(column.sort ? column.getSortByToggleProps() : undefined)), {}, {
      theme: theme,
      isSelectionColumn: column.id.indexOf("selection") >= 0,
      isActionsColumn: column.id === "actions",
      width: column.width
    });
  };
  /**
   * Row properties
   */


  var rowProps = function rowProps(row, index) {
    return _objectSpread2$2(_objectSpread2$2({}, row.getRowProps()), {}, {
      theme: theme,
      bordered: props.bordered,
      selected: selectedRowIds[index],
      isLoading: isLoading
    });
  };

  var CompWrapper = tableWrapper ? function (children) {
    return /*#__PURE__*/React__default.cloneElement(tableWrapper, children);
  } : React__default.Fragment;
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    fullWidth: fullWidth
  }, /*#__PURE__*/React__default.createElement(CompWrapper, null, /*#__PURE__*/React__default.createElement(TableOuterWrapper, {
    theme: theme,
    fullWidth: fullWidth,
    bordered: bordered,
    responsive: responsive
  }, /*#__PURE__*/React__default.createElement(SimpleTableWrapper, tableProps, /*#__PURE__*/React__default.createElement(SimpleTableHead, {
    theme: theme
  }, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/React__default.createElement(TableHeaderRow, _extends$g({
      theme: theme
    }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) {
      var controlledSort = sort.filter(function (c) {
        return c.id === column.id;
      })[0];
      var isSortable = column.sort || controlledSort;
      var isSorted = column.isSorted || controlledSort;
      var isSortedDesc = controlledSort ? controlledSort.desc : column.isSortedDesc;
      return /*#__PURE__*/React__default.createElement(StyledHeaderCell, headerCellProps(column), /*#__PURE__*/React__default.createElement(StyledHeaderLabel, {
        theme: theme,
        isSortable: isSortable
      }, column.render("Header"), isSortable ? /*#__PURE__*/React__default.createElement(Wrapper$c, {
        theme: theme,
        isSorted: isSorted,
        isSortedDesc: isSortedDesc
      }) : null));
    }));
  })), /*#__PURE__*/React__default.createElement("tbody", getTableBodyProps(), page.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React__default.createElement(Row$1, _extends$g({}, rowProps(row, i), {
      key: "row-".concat(i),
      style: customRowStyles(row),
      isEditable: isEditable,
      cells: row.cells,
      data: _objectSpread2$2({
        index: row.id
      }, row.values),
      trim: trim,
      onClick: handleRowClick
    }));
  }))), isLoading && /*#__PURE__*/React__default.createElement(Loading, null), !page.length ? /*#__PURE__*/React__default.createElement(Empty, {
    theme: theme,
    noDataLabel: labels.noDataLabel
  }) : undefined)), /*#__PURE__*/React__default.createElement(Wrapper$12, {
    justifyContent: ALIGNMENT[paginationAlign]
  }, /*#__PURE__*/React__default.createElement(Wrapper$d, _extends$g({}, rest, stateProps, paginationOptions, {
    pageIndex: pageIndex,
    setPageSize: setPageSize,
    total: totalRows,
    theme: theme,
    disabled: isLoading,
    fullWidth: fullWidth
  }))));
}

Table.propTypes = {
  /** Columns definitions for the table. */
  columns: PropTypes.arrayOf(PropTypes.shape({
    Header: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
    accessor: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({})),
    type: PropTypes.oneOf(["text", "options", "date", "async"]),
    options: PropTypes.any
  })).isRequired,

  /** Data list of objects */
  data: PropTypes.arrayOf(PropTypes.shape({})),

  /** Actions performed for individual rows, like view, edit, etc... */
  rowActions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    visible: PropTypes.bool,
    isButton: PropTypes.bool,
    icon: PropTypes.string,
    action: PropTypes.func
  })),

  /** Toggles ability to edit the cells in the table */
  isEditable: PropTypes.bool,

  /** Alow users to select rows */
  isSelectable: PropTypes.bool,

  /** Fired when user clicks on on any Row in non-edit mode */
  onRowClick: PropTypes.func,

  /** Displays a border around the table which to make look like a card */
  bordered: PropTypes.bool,

  /** Stretch table to full width */
  fullWidth: PropTypes.bool,

  /** When table pagination is controlled (e.g. server side pagination), this method is called each time a user navigates the table (also when the page size is changed) */
  fetchData: PropTypes.func,

  /** Fired when data is changed in the table (whether a user changes a value in the table or deletes rows) */
  onDataChange: PropTypes.func,

  /* Fired when at least one row is selected. Return list of rows selected */
  onRowSelect: PropTypes.func,

  /** In case of controlled sort, this param tells the table which columns are sorted */
  sort: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    desc: PropTypes.bool
  })),

  /* triggered when user tries to sort a sortable column (any column that has sort = true). If excluded, then table will try to automatically sort */
  onSort: PropTypes.func,

  /* Options for controlling how pagination works */
  paginationOptions: PropTypes.shape({
    /* Controls whether to show the pagination or not */
    show: PropTypes.bool,

    /* Number of rows to display per page */
    pageSize: PropTypes.number,

    /* Array of page sizes */
    pageSizes: PropTypes.arrayOf(PropTypes.number),

    /* Allow user to change page size */
    showPageSize: PropTypes.bool,

    /* Show Go To field */
    showGoTo: PropTypes.bool,

    /* Horizontal alignment under table */
    align: PropTypes.oneOf(Object.keys(ALIGNMENT))
  }),

  /* Current page index */
  pageIndex: PropTypes.number,

  /* Total number of results (determines how many pages to display) */
  total: PropTypes.number,

  /* controls column resizing according to limited space. If false, it stop at the min width required/specified */
  responsive: PropTypes.bool,

  /* Shows a loading circle while new data is being fetched */
  isLoading: PropTypes.bool,

  /* Trims text in each cell and displays ellipses */
  trim: PropTypes.bool,

  /* Any node element passed here would wrap the table component (e.g. Card, or custom styled div, etc...) */
  tableWrapper: PropTypes.node,
  labels: PropTypes.shape({
    pageLabel: PropTypes.string,
    totalLabel: PropTypes.string,
    gotoLabel: PropTypes.string,
    noDataLabel: PropTypes.string
  }),

  /* Custom styles to apply to rows. Each row will request this function based on its data */
  customRowStyles: PropTypes.func
};
Table.defaultProps = {
  paginationOptions: {
    show: true,
    pageSize: 10,
    pageSizes: [10, 25, 50, 100],
    showPageSize: true,
    showGoTo: true,
    align: ALIGNMENT.right
  },
  pageIndex: 0,
  total: 0,
  data: undefined,
  bordered: true,
  fullWidth: true,
  rowActions: [],
  responsive: true,
  sort: [],
  onRowSelect: function onRowSelect() {},
  onDataChange: function onDataChange() {},
  onRowClick: function onRowClick() {},
  onSort: function onSort() {},
  isEditable: false,
  isSelectable: false,
  isLoading: false,
  fetchData: undefined,
  trim: true,
  labels: {
    noDataLabel: "No data"
  },
  customRowStyles: function customRowStyles() {}
};
var TableWithLoading = /*#__PURE__*/React__default.memo(function (props) {
  return props.data ? /*#__PURE__*/React__default.createElement(Table, props) : /*#__PURE__*/React__default.createElement(Wrapper$b, {
    columns: props.columns.length
  });
});
var Wrapper$a = /*#__PURE__*/React__default.memo(withTheme(TableWithLoading));

var _templateObject$3, _templateObject2$2, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1;
var TabsComponentWrapper = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral$1(["\n\twidth: 100%;\n\tbackground: ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
      background = _ref.background;
  return background || theme.tabsBackground;
});
var TabItemsContainer = styled(Wrapper$12)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral$1(["\n\tborder-bottom: ", " solid ", ";\n\tposition: relative;\n\tfont-weight: 600;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.tabsBorderWidth;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.tabsBorderColor;
});
var TabHighlighter = styled.em(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral$1(["\n\tbackground: ", ";\n\tposition: absolute;\n\tbottom: -1px;\n\tdisplay: block;\n\twidth: 100%;\n\tleft: 0;\n\theight: ", ";\n\ttransition: all 0.2s easeInOut;\n"])), function (_ref4) {
  var theme = _ref4.theme,
      disabled = _ref4.disabled;
  return disabled ? theme.grey300 : theme.tabHighlightColor || theme.primary;
}, function (_ref5) {
  var selected = _ref5.selected;
  return selected ? '2px' : '0px';
});
var TabWrapper = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral$1(["\n\tfont-family: ", ";\n\tdisplay: inline-block;\n\tline-height: 30px;\n\tmargin-right: ", "px;\n\tposition: relative;\n\tcursor: ", ";\n\n\t.icontab {\n\t\tbackground-position: left 0;\n\t\tbackground-repeat: no-repeat;\n\t\tpadding-left: 44px;\n\t}\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.tabSpace;
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled ? 'default' : 'pointer';
});
var TabsContent = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral$1(["\n\tfont-size: ", ";\n\tfont-family: ", ";\n\tpadding-top: ", "px;\n\toutline: none;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSize;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontFamily;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.tabContentPadding;
});

var getTabColor = function getTabColor(_ref12) {
  var theme = _ref12.theme,
      selected = _ref12.selected,
      disabled = _ref12.disabled;
  if (disabled) return theme.inputLabelColorDisabled;
  if (selected && !disabled) return theme.tabItemColorSelected || theme.primary;
  return theme.tabItemColor;
};

var TabItem = styled.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral$1(["\n\tfont-size: ", ";\n\tcolor: ", ";\n\twhite-space: nowrap;\n\tpadding: 0px ", "px;\n\tuser-select: none;\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.tabFontSize;
}, getTabColor, function (_ref14) {
  var theme = _ref14.theme;
  return theme.space[2];
});

var Tab = function Tab(props) {
  var getBackgroundImage = function getBackgroundImage() {
    if (props.icon) {
      var selectedIcon = props.iconSelected ? props.iconSelected : props.icon;
      return props.selected ? {
        backgroundImage: "url('".concat(selectedIcon, "')")
      } : {
        backgroundImage: "url('".concat(props.icon, "')")
      };
    }
  };

  var handleClick = function handleClick(e) {
    props.onClick(e, props.index, props.eventKey);
  };

  var title = props.title;
      props.index;
      props.value;
      var className = props.className,
      rest = _objectWithoutProperties$c(props, ["title", "index", "value", "className"]);

  var bgImage = getBackgroundImage();
  return /*#__PURE__*/React__default.createElement(TabItem, _extends$g({}, rest, {
    className: classNames$1(className, {
      icontab: getBackgroundImage()
    }),
    onClick: handleClick,
    style: bgImage
  }), title, /*#__PURE__*/React__default.createElement(TabHighlighter, {
    theme: props.theme,
    disabled: rest.disabled,
    selected: props.selected
  }));
};

Tab.propTypes = {
  /** String or component to render in the title */
  title: PropTypes.oneOfType([PropTypes.string]),

  /** Node components to render as tab content */
  children: PropTypes.node,

  /** value returned for the `onSelect` function assigned on the parent component  */
  eventKey: PropTypes.any
};
Tab.defaultProps = {};
var Wrapper$9 = withTheme(Tab);

var transition = {
  duration: 350,
  ease: 'easeInOut'
};
var TabsContainer = posed.div({
  enter: {
    applyAtStart: {
      display: 'block'
    },
    opacity: 1,
    delay: 400,
    transition: transition
  },
  exit: {
    opacity: 0,
    applyAtEnd: {
      display: 'none'
    },
    transition: {
      duration: 150,
      ease: 'easeInOut'
    }
  }
});

var Tabs = function Tabs(_ref) {
  var id = _ref.id,
      selected = _ref.selected,
      disabled = _ref.disabled,
      onSelect = _ref.onSelect,
      children = _ref.children,
      rest = _objectWithoutProperties$c(_ref, ["id", "selected", "disabled", "onSelect", "children"]);

  var _useState = useState(selected ? selected - 1 : 0),
      _useState2 = _slicedToArray$8(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  useEffect(function () {
    if (selected !== undefined && selected !== current) {
      setCurrent(selected - 1);
    }
  }, [selected]);

  var selectTab = function selectTab(e, index, value) {
    if (!disabled) {
      if (onSelect) {
        onSelect(index + 1, value);
      }

      setCurrent(index);
    }
  };

  var componentId = id || RandomID(6);

  var renderTabs = function renderTabs() {
    var tabs = React__default.Children.map(children, function (element, i) {
      var tab = /*#__PURE__*/React__default.cloneElement(element, {
        key: i,
        className: "tab tab-".concat(i).concat(i === selected ? ' active' : ''),
        index: i,
        id: "tab-".concat(componentId, "-").concat(i),
        onClick: selectTab,
        disabled: disabled,
        selected: current === i
      });
      return /*#__PURE__*/React__default.createElement(TabWrapper, _extends$g({}, rest, {
        role: "tab",
        "aria-selected": i === selected ? 'true' : 'false'
      }), tab);
    });
    return tabs;
  };

  var renderTabContent = function renderTabContent() {
    return React__default.Children.toArray(children).map(function (child, i) {
      return /*#__PURE__*/React__default.createElement(TabsContainer, {
        key: i,
        pose: current === i ? 'enter' : 'exit',
        style: {
          outline: 'none'
        }
      }, /*#__PURE__*/React__default.createElement(TabsContent, _extends$g({}, rest, {
        role: "tabpanel",
        tabIndex: 0,
        "aria-labelledby": "tab-".concat(componentId, "-").concat(current)
      }), child.props.children));
    });
  };

  return /*#__PURE__*/React__default.createElement(TabsComponentWrapper, rest, /*#__PURE__*/React__default.createElement(TabItemsContainer, _extends$g({}, rest, {
    role: "tablist"
  }), renderTabs()), renderTabContent());
};

Tabs.propTypes = {
  /** Component id */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Index of the selected tab */
  selected: PropTypes.number,

  /** Function called when tab is selected */
  onSelect: PropTypes.func,

  /** Tabs contents */
  children: PropTypes.any.isRequired,
  className: PropTypes.string,

  /** Whether to animate height of tab if content is long */
  animateHeight: PropTypes.bool
};
Tabs.defaultProps = {
  selected: 0,
  className: '',
  animateHeight: true
};
var Wrapper$8 = withTheme(Tabs);

var Textarea = function Textarea(props) {
  return /*#__PURE__*/React__default.createElement(Wrapper$x, _extends$g({}, props, {
    isTextarea: true,
    rows: props.minRows
  }));
};
Textarea.propTypes = {
  /**Text to display as form element caption */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Value to show when component renders  */
  value: PropTypes.string,

  /** fires when the the value of the field changes  */
  onChange: PropTypes.func,

  /** fires when the focus has left the field  */
  onBlur: PropTypes.func,

  /** fires when field is in focus  */
  onFocus: PropTypes.func,

  /** adds a red star to the label if set to true and no value exists  */
  required: PropTypes.bool,

  /** Adds a tooltip to the label  */
  tooltip: PropTypes.string,

  /** Delays in seconds for showing to the tooltip on mouseenter  */
  tooltipDelay: PropTypes.number,

  /** Disabled components and prevents input  */
  disabled: PropTypes.bool,

  /** Affects the border color   */
  validationState: PropTypes.oneOf(['', 'success', 'danger']),

  /** Automatically resize the height of the textarea to fit content  */
  autoHeight: PropTypes.bool,

  /** Sets the height of the textarea to this minimum number of rows. if `autoHeight` is true, this is the initial height */
  minRows: PropTypes.number
};
Textarea.defaultProps = {
  onChange: function onChange() {},
  minRows: 4,
  autoHeight: true
};

function TimeSchedule(props) {
  props.id;
      props.label;
      props.tooltip;
      props.tooltipDelay;
      props.hint;
      props.error;
      var value = props.value;
      props.required;
      props.validationState;
      var onChange = props.onChange,
      theme = props.theme,
      labels = props.labels,
      allowSlots = props.allowSlots,
      rest = _objectWithoutProperties$c(props, ["id", "label", "tooltip", "tooltipDelay", "hint", "error", "value", "required", "validationState", "onChange", "theme", "labels", "allowSlots"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray$8(_useState, 2),
      schedule = _useState2[0],
      setSchedule = _useState2[1];

  var _useState3 = useState(props.isWeekly),
      _useState4 = _slicedToArray$8(_useState3, 2),
      isWeekly = _useState4[0],
      setWeekly = _useState4[1];

  var _useState5 = useState(props.weeklyRange),
      _useState6 = _slicedToArray$8(_useState5, 2),
      weeklyRange = _useState6[0],
      setWeeklyRange = _useState6[1];

  useEffect(function () {
    if (!isEqual(value, schedule)) {
      setSchedule(_objectSpread2$2({}, value));
    }
  }, [value]);

  var handleWeeklyChecked = function handleWeeklyChecked(checked) {
    setWeekly(checked);

    if (checked) {
      setWeeklyRange(allowSlots ? [['00:00', '00:00']] : ['00:00', '00:00']);
    }
  };

  var handleWeeklyChange = function handleWeeklyChange(range) {
    var newSchedule = schedule;
    Object.keys(schedule).map(function (k) {
      return newSchedule[k] = range;
    });
    setWeeklyRange(range);
    setSchedule(newSchedule);
    onChange(newSchedule);
  };

  var handleDayChange = function handleDayChange(day, range) {
    var newSchedule = schedule;
    newSchedule[day] = range;
    setSchedule(newSchedule);
    onChange(newSchedule);
  };

  var handleDayChecked = function handleDayChecked(day, checked) {
    var newSchedule = schedule;

    if (checked) {
      var _value = [props.min || '00:00', props.max || '00:00'];
      newSchedule[day] = props.allowSlots ? [_value] : _value;
    } else {
      newSchedule[day] = [];
    }

    setSchedule(newSchedule);
    onChange(newSchedule);
  };

  var getDays = function getDays() {
    return Object.keys(schedule).map(function (k) {
      var value = schedule[k].length ? schedule[k] : allowSlots ? [['00:00', '00:00']] : ['00:00', '00:00'];
      var active = schedule[k].length > 0;
      var enabled = !isWeekly;
      return /*#__PURE__*/React__default.createElement(Wrapper$12, {
        key: k,
        theme: theme
      }, /*#__PURE__*/React__default.createElement(Wrapper$11, {
        width: 1 / 4,
        theme: theme,
        pt: 1
      }, /*#__PURE__*/React__default.createElement(Wrapper$Q, {
        theme: theme,
        label: labels[k],
        value: !isWeekly && active,
        onChange: function onChange(checked) {
          return handleDayChecked(k, checked);
        },
        disabled: !enabled,
        horizontal: true
      })), /*#__PURE__*/React__default.createElement(Wrapper$11, {
        flexGrow: 1,
        theme: theme
      }, /*#__PURE__*/React__default.createElement(Wrapper$j, _extends$g({}, rest, {
        theme: theme,
        value: value,
        disabled: !enabled || !active,
        onChange: function onChange(range) {
          return handleDayChange(k, range);
        },
        allowSlots: props.allowSlots,
        isAllDay: enabled && active && (JSON.stringify(value) === JSON.stringify(['00:00', '00:00']) || JSON.stringify(value) === JSON.stringify([['00:00', '00:00']]))
      }))));
    });
  };

  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, props, props.allowWeeklySelect ? /*#__PURE__*/React__default.createElement(Wrapper$12, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(Wrapper$11, {
    width: 1 / 4,
    theme: theme,
    pt: 1
  }, /*#__PURE__*/React__default.createElement(Wrapper$Q, {
    label: labels.weekly,
    value: isWeekly,
    onChange: handleWeeklyChecked,
    horizontal: true,
    theme: theme
  })), /*#__PURE__*/React__default.createElement(Wrapper$11, {
    flexGrow: 1,
    theme: theme
  }, /*#__PURE__*/React__default.createElement(Wrapper$j, {
    value: weeklyRange,
    disabled: !isWeekly,
    onChange: handleWeeklyChange,
    allowSlots: allowSlots,
    theme: theme,
    isAllDay: isWeekly && (JSON.stringify(weeklyRange) === JSON.stringify(['00:00', '00:00']) || JSON.stringify(weeklyRange) === JSON.stringify([['00:00', '00:00']]))
  }))) : undefined, getDays());
}

TimeSchedule.propTypes = {
  /** Component value is a object listing week days. Each day value is an array of start-end strings, or an array of slots */
  value: PropTypes.shape({
    monday: PropTypes.array,
    tuesday: PropTypes.array,
    wednesday: PropTypes.array,
    thursday: PropTypes.array,
    friday: PropTypes.array,
    saturday: PropTypes.array,
    sunday: PropTypes.array
  }),

  /** Displays a `Weekly` selector on top */
  allowWeeklySelect: PropTypes.bool,

  /** Passed value for isWeekly */
  isWeekly: PropTypes.bool,

  /** Weekly range value */
  weeklyRange: PropTypes.array,

  /** Allows selecting several slots per day */
  allowSlots: PropTypes.bool,

  /** Passed labels for i18n */
  labels: PropTypes.shape({
    weekly: PropTypes.string,
    monday: PropTypes.string,
    tuesday: PropTypes.string,
    wednesday: PropTypes.string,
    thursday: PropTypes.string,
    friday: PropTypes.string,
    saturday: PropTypes.string,
    sunday: PropTypes.string
  }),

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
TimeSchedule.defaultProps = {
  value: {
    monday: [['00:00', '00:00']],
    tuesday: [['00:00', '00:00']],
    wednesday: [['00:00', '00:00']],
    thursday: [['00:00', '00:00']],
    friday: [['00:00', '00:00']],
    saturday: [['00:00', '00:00']],
    sunday: [['00:00', '00:00']]
  },
  allowWeeklySelect: true,
  allowSlots: true,
  isWeekly: true,
  weeklyRange: [['08:00', '22:00']],
  labels: {
    weekly: 'Weekly',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  onChange: function onChange() {}
};
var Wrapper$7 = compose$1(withTheme, withTransformers)(TimeSchedule);

var _templateObject$2, _templateObject2$1;
var StyledToggleGroup = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral$1(["\n\t", ";\n\t", ";\n"])), space, layout);
var StyledToggleButton = styled.button(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral$1(["\n\tdisplay: inline-block;\n\theight: ", ";\n\tpadding: ", ";\n\tborder: 1px solid ", ";\n\tcolor: ", ";\n\tbackground: ", ";\n\toutline: none;\n\tcursor: pointer;\n\n\t&:first-child {\n\t\tborder-top-left-radius: ", ";\n\t\tborder-bottom-left-radius: ", ";\n\t}\n\t&:last-child {\n\t\tborder-top-right-radius: ", ";\n\t\tborder-bottom-right-radius: ", ";\n\t\tborder-right-width: ", ";\n\t}\n\n\t", "\n\n\t", "\n"])), getHeight, getPadding$1, function (_ref) {
  var theme = _ref.theme;
  return theme.toggleButtonBorder;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.toggleButtonColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.toggleButtonBg;
}, function (props) {
  return props.theme.toggleButtonBorderRadius;
}, function (props) {
  return props.theme.toggleButtonBorderRadius;
}, function (props) {
  return props.theme.toggleButtonBorderRadius;
}, function (props) {
  return props.theme.toggleButtonBorderRadius;
}, function (props) {
  return props.theme.toggleButtonBorderWidth;
}, function (_ref4) {
  var theme = _ref4.theme,
      selected = _ref4.selected;
  return selected && css$4(["background:", ";border-color:", ";color:", ";"], theme.toggleButtonBgSelected, theme.toggleButtonBorderSelected || theme.primary, theme.toggleButtonColorSelected || theme.primary);
}, function (_ref5) {
  var theme = _ref5.theme,
      disabled = _ref5.disabled,
      selected = _ref5.selected;
  return disabled && css$4(["background:", ";border-color:", ";color:", ";cursor:not-allowed;"], selected ? theme.toggleButtonBgSelectedDisabled : theme.toggleButtonBgDisabled, selected ? theme.toggleButtonBorderSelectedDisabled : theme.toggleButtonBorderDisabled, selected ? theme.toggleButtonColorSelectedDisabled : theme.toggleButtonColorDisabled);
});

var ToggleGroup = function ToggleGroup(props) {
  var children = props.children,
      onChange = props.onChange,
      selected = props.selected,
      disabled = props.disabled,
      rest = _objectWithoutProperties$c(props, ["children", "onChange", "selected", "disabled"]);

  var _useState = useState(selected || children[0].props.value),
      _useState2 = _slicedToArray$8(_useState, 2),
      selectedButton = _useState2[0],
      setSelected = _useState2[1];

  useEffect(function () {
    if (selected) setSelected(selected);
  }, [selected]);

  var handleChildClick = function handleChildClick(value) {
    setSelected(value);
    onChange(value);
  };

  return /*#__PURE__*/React__default.createElement(StyledToggleGroup, _extends$g({}, rest, {
    disabled: disabled
  }), React__default.Children.map(children, function (child) {
    var childProps = {};

    if ( /*#__PURE__*/React__default.isValidElement(child)) {
      childProps = {
        onClick: handleChildClick,
        selected: selectedButton === child.props.value,
        size: props.size,
        disabled: disabled
      };
    }

    return /*#__PURE__*/React__default.cloneElement(child, childProps);
  }));
};

ToggleGroup.propTypes = {
  /** the value of the selected child */
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Children buttons */
  children: PropTypes.any.isRequired,

  /** fired when one of the child buttons is clicked */
  onChange: PropTypes.func,
  size: PropTypes.string,
  disabled: PropTypes.bool
};
ToggleGroup.defaultProps = {
  selected: 0,
  onChange: function onChange() {},
  size: 'large'
};
var Wrapper$6 = withTheme(ToggleGroup);

var ToggleButton = function ToggleButton(props) {
  var label = props.label,
      children = props.children,
      value = props.value,
      onClick = props.onClick,
      rest = _objectWithoutProperties$c(props, ["label", "children", "value", "onClick"]);

  var handleClick = function handleClick() {
    onClick(value);
  };

  return /*#__PURE__*/React__default.createElement(StyledToggleButton, _extends$g({}, rest, {
    onClick: handleClick
  }), label, children);
};

ToggleButton.propTypes = {
  /** Toggle button label, can any node element that react could render */
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.number]).isRequired,

  /** Is the value returned when this toggle is selected */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /** Function to call when toggle button is clicked  */
  onClick: PropTypes.func,

  /** Additional className */
  className: PropTypes.string
};
ToggleButton.defaultProps = {
  label: '',
  value: ''
};
var Wrapper$5 = withTheme(ToggleButton);

var UnitInput = function UnitInput(props) {
  var value = props.value,
      units = props.units,
      onChange = props.onChange;
      props.className;
      var validationState = props.validationState;
      props.onValueChange;
      var rest = _objectWithoutProperties$c(props, ["value", "units", "onChange", "className", "validationState", "onValueChange"]);

  var sanitize = function sanitize(e) {
    var charCode = e.which ? e.which : e.keyCode;

    if (charCode > 31 && charCode !== 46 && charCode !== 44 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
      return false;
    }

    return true;
  };

  var handleValueChange = function handleValueChange(e) {
    onChange({
      value: e.target.value,
      unit: value.unit
    });
  };

  var handleUnitChange = function handleUnitChange(unit) {
    onChange({
      value: value.value,
      unit: unit.value
    });
  };

  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, rest, /*#__PURE__*/React__default.createElement(Wrapper$12, null, /*#__PURE__*/React__default.createElement(DropMenuInput, _extends$g({}, rest, {
    value: value.value,
    "aria-label": props.label,
    error: rest.error || validationState === 'danger',
    onKeyPress: sanitize,
    onChange: handleValueChange,
    isValid: validationState === 'success'
  })), /*#__PURE__*/React__default.createElement(Wrapper$C, _extends$g({}, rest, {
    units: units,
    value: value.unit,
    onChange: handleUnitChange
  }))));
};

UnitInput.propTypes = {
  /** Field label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** List of options showing next to the input */
  units: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,

  /** Value of this field in shape of {value, unit} */
  value: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    unit: PropTypes.string.isRequired
  }),

  /** function that transforms the passed value TO the component */
  transformIn: PropTypes.func,

  /** function that transforms the value received FROM the component */
  transformOut: PropTypes.func
};
UnitInput.defaultProps = {
  units: [{
    value: 'lb',
    label: 'LB'
  }, {
    value: 'kg',
    label: 'KG'
  }],
  value: {
    value: '',
    unit: 'kg'
  },
  onChange: function onChange() {}
};
var Wrapper$4 = compose$1(withTheme, withTransformers)(UnitInput);

var FILE_STATUS = {
  uploading: 'uploading',
  // file is being uploaded w/o percentage
  edit: 'edit',
  // file is either uploaded is pending and can be removed
  readOnly: 'readOnly',
  // file meta is meant only for display
  pending: 'pending' // file selected and ready to upload

};

var _templateObject$1, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
var DropArea = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral$1(["\n\tfont-size: 14px;\n\tfont-family: ", ";\n\tline-height: 1.2em;\n\tpadding: ", "px;\n\tborder-radius: ", ";\n\tmargin-bottom: 12px;\n\n\t", "\n\ttext-align: center;\n\tbox-sizing: border-box;\n\ttransition: all 0.3s ease-in-out;\n\tbackground: ", ";\n\tcursor: ", ";\n\tcolor: ", ";s\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space[3];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var isImageUpload = _ref4.isImageUpload,
      theme = _ref4.theme;
  return isImageUpload ? css$4(["width:140px;height:140px;box-sizing:border-box;border-radius:", ";border:1px solid ", ";display:flex;flex-direction:column;justify-content:center;"], function (_ref5) {
    var isCircle = _ref5.isCircle;
    return isCircle ? '100%' : theme.borderRadius;
  }, theme.grey200) : css$4(["border:1px dashed ", ";"], theme.grey200);
}, function (_ref6) {
  var theme = _ref6.theme,
      active = _ref6.active;
  return active ? theme.light : theme.white;
}, function (_ref7) {
  var active = _ref7.active;
  return active ? 'copy' : 'pointer';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.textColor;
});
var Placeholder = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral$1(["\n\tpadding-top: ", "px;\n\tcolor: ", ";\n\tfont-family: ", ";\n\tfont-size: 12px;\n\tline-height: 1.3em;\n\tpointer-events: none;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.space[1];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.textColor;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontFamily;
});
var FileInput = styled.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral$1(["\n\tposition: absolute;\n\tvisibility: hidden;\n\toutline: none;\n\tleft: 0;\n"])));
var DropAriaPlaceholder = styled.label(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral$1(["\n\tcolor: ", ";\n\tcursor: inherit;\n\tuser-select: none;\n\tposition: relative;\n\tfont-family: ", ";\n\n\t", "\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.color;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontFamily;
}, function (_ref14) {
  var isImageUpload = _ref14.isImageUpload,
      theme = _ref14.theme;
  return isImageUpload ? css$4(["color:", ";"], theme.primary) : undefined;
});
var FileWrapper = styled(Wrapper$12)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral$1(["\n\tfont-family: ", ";\n\tmargin-right: 10px;\n\tmargin-bottom: 10px;\n\ttransition: all 0.25s linear;\n\n\t", "\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontFamily;
}, function (_ref16) {
  var isImageUpload = _ref16.isImageUpload;
  return isImageUpload ? css$4(["display:inline-block;vertical-align:middle;margin-right:10px;margin-bottom:10px;"]) : css$4(["border:1px dashed ", ";border-radius:", ";padding:", "px;background:", ";"], function (_ref17) {
    var theme = _ref17.theme;
    return theme.grey200;
  }, function (_ref18) {
    var theme = _ref18.theme;
    return theme.borderRadius;
  }, function (_ref19) {
    var theme = _ref19.theme;
    return theme.space[2];
  }, function (_ref20) {
    var theme = _ref20.theme,
        disabled = _ref20.disabled;
    return disabled ? theme.inputBackgroundDisabled : theme.white;
  });
});
var FileName = styled(Wrapper$12)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral$1(["\n\tfont-size: 14px;\n\tfont-family: ", ";\n\tcolor: #999;\n\tline-height: 1.5em;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tpadding-right: 10px;\n\talign-items: center;\n\tjustify-content: center;\n"])), function (_ref21) {
  var theme = _ref21.theme;
  return theme.fontFamily;
});
var FileMeta = styled(Wrapper$12)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral$1(["\n\tfont-size: 12px;\n\tfont-family: ", ";\n\tcolor: #999;\n\tline-height: 1em;\n\talign-items: center;\n"])), function (_ref22) {
  var theme = _ref22.theme;
  return theme.fontFamily;
});
styled(FileMeta)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral$1(["\n\tfont-size: 12px;\n\tfont-family: ", ";\n\tcolor: #999;\n\tline-height: 1em;\n\tpadding-right: 10px;\n\tdisplay: inline-block;\n\tcolor: ", ";\n"])), function (_ref23) {
  var theme = _ref23.theme;
  return theme.fontFamily;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.error;
});
var ControlsWrapper = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral$1([""])));
styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral$1(["\n\tbackground: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: ", ";\n\toverflow: ", ";\n"])), function (_ref25) {
  var theme = _ref25.theme;
  return theme.offWhite;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.grey400;
}, function (_ref27) {
  var isCircle = _ref27.isCircle;
  return isCircle ? '100%' : '3px';
}, function (_ref28) {
  var isCircle = _ref28.isCircle;
  return isCircle ? 'hidden' : 'visible';
});
var UploadControls = function UploadControls(_ref29) {
  var endpoint = _ref29.endpoint,
      theme = _ref29.theme,
      _ref29$percentage = _ref29.percentage,
      percentage = _ref29$percentage === void 0 ? 12 : _ref29$percentage,
      status = _ref29.status,
      onCancel = _ref29.onCancel,
      onUpload = _ref29.onUpload,
      onDelete = _ref29.onDelete;
      _objectWithoutProperties$c(_ref29, ["endpoint", "theme", "percentage", "status", "onCancel", "onUpload", "onDelete"]);

  var comp = null;

  switch (status) {
    case FILE_STATUS.uploading:
      if (percentage === undefined) {
        comp = /*#__PURE__*/React__default.createElement(Wrapper$U, {
          size: "25px",
          theme: theme
        }, /*#__PURE__*/React__default.createElement(Wrapper$Z, {
          theme: theme,
          icon: "close",
          size: 16,
          color: theme.error,
          hoverColor: theme.error,
          onClick: onCancel
        }));
      } else {
        comp = /*#__PURE__*/React__default.createElement(Wrapper$p, {
          progress: 12,
          size: 25
        });
      }

      break;

    case FILE_STATUS.edit:
      comp = /*#__PURE__*/React__default.createElement(Wrapper$Z, {
        theme: theme,
        icon: "trash",
        size: 20,
        color: theme.error,
        hoverColor: theme.error,
        onClick: onDelete
      });
      break;

    case FILE_STATUS.pending:
      comp = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Wrapper$Z, {
        theme: theme,
        icon: "trash",
        size: 18,
        color: theme.error,
        hoverColor: theme.error,
        onClick: onDelete,
        mr: 1
      }), endpoint && /*#__PURE__*/React__default.createElement(Wrapper$Z, {
        theme: theme,
        icon: "upload-cloud",
        size: 18,
        onClick: onUpload
      }));
      break;
  }

  return /*#__PURE__*/React__default.createElement(ControlsWrapper, {
    theme: theme
  }, comp);
};

var upload = function upload(endpoint, headers, filesParam, files, progressCb, success, error) {
  var CancelToken = Axios.CancelToken;
  var source = CancelToken.source();
  var config = {
    headers: headers,
    onUploadProgress: function onUploadProgress(progressEvent) {
      var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
      progressCb(percentCompleted);
    },
    cancelToken: source.token
  };
  var data = new FormData();
  data.append(filesParam, files);
  Axios.post(endpoint, data, config).then(function (res) {
    success(res.data);
  })["catch"](function (err) {
    error(err);
  });
  return source;
};

var _FileComponent$propTy;
/**
 *
 * File Component
 */

var FileComponent = function FileComponent(_ref) {
  var index = _ref.index,
      file = _ref.file,
      fileIcon = _ref.fileIcon,
      onDelete = _ref.onDelete,
      onCancel = _ref.onCancel,
      onUploadRequest = _ref.onUploadRequest,
      onUploadSuccess = _ref.onUploadSuccess,
      uploadOnSelect = _ref.uploadOnSelect;
      _ref.individualUpload;
      var endpoint = _ref.endpoint,
      filesParam = _ref.filesParam,
      disabled = _ref.disabled,
      multi = _ref.multi,
      onUploadError = _ref.onUploadError,
      props = _objectWithoutProperties$c(_ref, ["index", "file", "fileIcon", "onDelete", "onCancel", "onUploadRequest", "onUploadSuccess", "uploadOnSelect", "individualUpload", "endpoint", "filesParam", "disabled", "multi", "onUploadError"]);

  var _useState = useState(typeof file === 'string' ? file : null),
      _useState2 = _slicedToArray$8(_useState, 2),
      image = _useState2[0],
      setImage = _useState2[1];

  var _useState3 = useState(FILE_STATUS.pending),
      _useState4 = _slicedToArray$8(_useState3, 2),
      status = _useState4[0],
      setStatus = _useState4[1];

  var _useState5 = useState(props.progress),
      _useState6 = _slicedToArray$8(_useState5, 2),
      progress = _useState6[0],
      setProgress = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray$8(_useState7, 2),
      request = _useState8[0],
      setRequest = _useState8[1];

  useEffect(function () {
    if (file && file instanceof File && status === FILE_STATUS.pending && uploadOnSelect && endpoint) {
      // check if the file is actually a file
      handleUpload(file);
    }
  }, []);
  useEffect(function () {
    if (typeof file === 'string') {
      setImage(file);
    }
  }, [file]);

  if (file && file.type && file.type.split('/')[0] === 'image') {
    var reader = new FileReader();

    reader.onload = function (e) {
      setImage(e.target.result);
    };

    reader.readAsDataURL(file);
  }

  var handleUploadSuccess = function handleUploadSuccess(res) {
    if (!disabled) {
      setStatus(FILE_STATUS.edit);
      if (onUploadSuccess) onUploadSuccess(res);
    }
  };

  var handleUploadError = function handleUploadError(err) {
    setStatus(FILE_STATUS.edit);
    if (onUploadError) onUploadError(err);
  };

  var handleUpload = function handleUpload(file) {
    if (!disabled) {
      setStatus(FILE_STATUS.uploading);

      if (uploadOnSelect) {
        var req = upload(endpoint, props.headers, filesParam, file, function (progress) {
          return setProgress(progress);
        }, handleUploadSuccess, handleUploadError);
        setRequest(req);
      } else if (onUploadRequest) onUploadRequest(file);
    }
  };

  var handleCancel = function handleCancel() {
    setStatus(FILE_STATUS.pending);
    if (request) request.cancel();
    if (onCancel) onCancel(file);
  };

  var handleDelete = function handleDelete() {
    if (!disabled) {
      if (onDelete) onDelete(index);
    }
  };

  file.size;
      var fileProps = _objectWithoutProperties$c(file, ["size"]);

  return /*#__PURE__*/React__default.createElement(FileWrapper, _extends$g({}, props, fileProps, {
    disabled: disabled
  }), props.isImageUpload ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default.createElement(Wrapper$N, {
    size: 140,
    src: image,
    shape: props.isCircle ? 'circle' : 'rounded',
    bgColor: "#FFF"
  }), /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    icon: "trash",
    size: 26,
    color: "#FFF",
    onClick: handleDelete,
    hoverColor: "#FFF",
    bg: props.theme.error,
    borderRadius: "50%",
    p: 1,
    position: "absolute",
    bottom: 1,
    right: 1
  })) : /*#__PURE__*/React__default.createElement(Wrapper$12, {
    flexDirection: multi ? 'row' : 'column',
    alignItems: "center",
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(Wrapper$11, null, image ? /*#__PURE__*/React__default.createElement(Image, {
    src: image,
    width: 40,
    height: 40
  }) : /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    theme: props.theme,
    icon: fileIcon,
    size: multi ? 20 : 35,
    style: {
      marginRight: '10px'
    },
    color: disabled ? props.theme.inputLabelColorDisabled : props.theme.primary,
    hoverColor: disabled ? props.theme.inputLabelColorDisabled : props.theme.primary
  })), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FileName, _extends$g({}, props, {
    width: 1,
    justifyContent: multi ? 'flex-start' : 'center'
  }), /*#__PURE__*/React__default.createElement(Wrapper$11, {
    pr: 1,
    width: multi ? 1 : 'auto'
  }, file.name), !disabled && status !== 'readOnly' ? /*#__PURE__*/React__default.createElement(UploadControls, _extends$g({}, props, {
    onUpload: handleUpload,
    onDelete: handleDelete,
    onCancel: handleCancel,
    percentage: progress,
    status: status
  })) : undefined))));
};

FileComponent.propTypes = (_FileComponent$propTy = {
  /** Upload endpoint API. Required if the component will take care of the upload process. */
  endpoint: PropTypes.string,

  /** Specify the parameter in the request that will contain files */
  filesParam: PropTypes.string,

  /** Additional Headers added to the upload request */
  headers: PropTypes.object,

  /** Controls how files are uploaded to the endpoint. When true, each file will be uploaded separately showing progress and allow individual cancel */
  individualUpload: PropTypes.bool,

  /** Controls when the files will be uploaded. If true, then the upload request to the endpoint will be fired when user selects the files */
  uploadOnSelect: PropTypes.bool,

  /** fires when the the value of the field changes */
  onChange: PropTypes.func,

  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** adds a red star to the label if set to true and no value exists */
  required: PropTypes.bool,

  /** Allows uploading multiple files */
  multi: PropTypes.bool,

  /** Fired when all files are uploaded to the endpoint. Returns the results of the endpoint */
  onUploadSuccess: PropTypes.func,

  /** Fired when upload is triggered manually by user */
  onUploadRequest: PropTypes.func,

  /** Fired if the an error code is received from the endpoint when uploading files */
  onUploadError: PropTypes.func
}, _defineProperty$k(_FileComponent$propTy, "onChange", PropTypes.func), _defineProperty$k(_FileComponent$propTy, "status", PropTypes.oneOf(['edit', 'uploading', 'readOnly'])), _defineProperty$k(_FileComponent$propTy, "fileIcon", PropTypes.string), _FileComponent$propTy);
FileComponent.defaultProps = {
  status: 'uploading',
  filesParam: 'files',
  fileIcon: 'document',
  instantUpload: false,
  multi: true,
  disabled: false,
  fileTypes: '*',
  placeholder: 'Drag files here or click to browse',
  limitSize: 0
};
var Wrapper$3 = withTheme(FileComponent);

var DragFiles = function DragFiles(_ref) {
  var disabled = _ref.disabled,
      onChange = _ref.onChange,
      isImageUpload = _ref.isImageUpload,
      theme = _ref.theme,
      icon = _ref.icon,
      placeholder = _ref.placeholder,
      multi = _ref.multi,
      accept = _ref.accept,
      isCircle = _ref.isCircle;
      _objectWithoutProperties$c(_ref, ["disabled", "onChange", "isImageUpload", "theme", "icon", "placeholder", "multi", "accept", "isCircle"]);

  var uploadID = RandomID(6);

  var _useState = useState(false),
      _useState2 = _slicedToArray$8(_useState, 2),
      isActive = _useState2[0],
      setActive = _useState2[1];

  var handleDragEnter = function handleDragEnter(event) {
    event.preventDefault();

    if (!disabled) {
      setActive(true);
    }
  };

  var handleDragLeave = function handleDragLeave(event) {
    event.preventDefault();

    if (!disabled) {
      setActive(false);
    }
  };

  var handleDragOver = function handleDragOver(event) {
    if (!disabled) {
      event.preventDefault();
    }
  };

  var handleDrop = function handleDrop(event) {
    event.preventDefault();

    if (!disabled) {
      setActive(false);
      var dropped = event.dataTransfer ? event.dataTransfer.files : null;
      if (onChange) onChange(dropped);
    }
  };

  var handleFileSelect = function handleFileSelect(e) {
    e.preventDefault();

    if (!disabled) {
      setActive(false);
      if (onChange) onChange(e.target.files);
    }
  };

  return /*#__PURE__*/React__default.createElement(DropAriaPlaceholder, {
    htmlFor: uploadID,
    onDrop: handleDrop,
    onDragLeave: handleDragLeave,
    onDragEnter: handleDragEnter,
    onDragOver: handleDragOver
  }, /*#__PURE__*/React__default.createElement(DropArea, {
    theme: theme,
    isImageUpload: isImageUpload,
    active: isActive,
    isCircle: isCircle
  }, /*#__PURE__*/React__default.createElement(Wrapper$Z, {
    theme: theme,
    icon: icon,
    size: 24,
    cursor: "pointer",
    style: {
      display: isImageUpload ? 'block' : 'inline-block',
      margin: isImageUpload ? '0 auto' : '0 5px 0 0',
      pointerEvents: 'none'
    }
  }), /*#__PURE__*/React__default.createElement(Placeholder, {
    theme: theme
  }, placeholder), /*#__PURE__*/React__default.createElement(FileInput, {
    type: "file",
    name: "files",
    id: uploadID,
    onChange: handleFileSelect,
    multiple: multi,
    accept: accept
  })));
};

var Wrapper$2 = withTheme(DragFiles);

var _FileUpload$propTypes;
/**
 *
 * Upload Component
 */

var FileUpload = function FileUpload(props) {
  var value = props.value;
      props.type;
      props.required;
      var disabled = props.disabled,
      multi = props.multi,
      onChange = props.onChange;
      props.onFileRemove;
      props.onUploadRequest;
      var endpoint = props.endpoint,
      uploadOnSelect = props.uploadOnSelect;
      props.onUploadSuccess;
      props.onUploadError;
      props.onFilesRemove;
      var placeholder = props.placeholder,
      limitSize = props.limitSize,
      limitError = props.limitError,
      accept = props.accept,
      rest = _objectWithoutProperties$c(props, ["value", "type", "required", "disabled", "multi", "onChange", "onFileRemove", "onUploadRequest", "endpoint", "uploadOnSelect", "onUploadSuccess", "onUploadError", "onFilesRemove", "placeholder", "limitSize", "limitError", "accept"]);

  var _useState = useState(value ? Array.isArray(value) ? value : [value] : []),
      _useState2 = _slicedToArray$8(_useState, 2),
      files = _useState2[0],
      setFiles = _useState2[1];

  var _useState3 = useState(rest.error),
      _useState4 = _slicedToArray$8(_useState3, 2),
      selectError = _useState4[0],
      setSelectionError = _useState4[1];

  useEffect(function () {
    setFiles(Array.isArray(value) ? value : [value]);
  }, [value]);
  useEffect(function () {
    setSelectionError(rest.error);
  }, [rest.error]);

  var handleFiles = function handleFiles(selected) {
    var filesArr = Object.keys(selected).map(function (k) {
      return selected[k];
    });
    var filesExceeded = [];
    var filesAccepted = [];

    if (limitSize) {
      filesArr.map(function (file) {
        if (file.size > limitSize) {
          filesExceeded.push(file);
        } else {
          filesAccepted.push(file);
        }
      });

      if (filesExceeded.length) {
        setSelectionError(limitError);
      }
    } else {
      filesAccepted = filesArr;
    }

    var newList = [].concat(_toConsumableArray$2(files), _toConsumableArray$2(filesAccepted));
    setFiles(newList);
    if (onChange) onChange(multi ? newList : newList[0]);
  };

  var handleDelete = function handleDelete(index) {
    if (!props.multi) {
      setFiles([]);
      if (onChange) onChange();
    } else {
      var list = files;
      list.splice(index, 1);
      setFiles(_toConsumableArray$2(list));
      if (onChange) onChange(list);
    }
  };

  return /*#__PURE__*/React__default.createElement(BaseFieldWrapper, _extends$g({}, rest, {
    error: selectError
  }), /*#__PURE__*/React__default.createElement(Wrapper$12, {
    flexDirection: rest.isImageUpload ? 'row' : 'column',
    flexWrap: "wrap"
  }, disabled || !multi && files.length && files[0] ? undefined : /*#__PURE__*/React__default.createElement(Wrapper$2, _extends$g({}, rest, {
    placeholder: placeholder,
    icon: rest.isImageUpload ? 'camera' : 'upload-cloud',
    accept: accept || (rest.isImageUpload ? 'image/*' : '*'),
    onChange: handleFiles,
    multi: multi
  })), files.map(function (file, i) {
    return file ? /*#__PURE__*/React__default.createElement(Wrapper$3, _extends$g({}, rest, {
      multi: multi,
      disabled: disabled,
      key: i,
      index: i,
      file: file,
      filesParam: props.filesParam,
      endpoint: endpoint,
      uploadOnSelect: uploadOnSelect,
      onDelete: handleDelete,
      onUploadRequest: props.onUploadRequest,
      onUploadSuccess: props.onUploadSuccess,
      onUploadError: props.onUploadError
    })) : undefined;
  })));
};

FileUpload.propTypes = (_FileUpload$propTypes = {
  /** Upload endpoint API. Required if the component will take care of the upload process. */
  endpoint: PropTypes.string,

  /** Specify the parameter in the request that will contain files */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string, PropTypes.object]),

  /** Specify the parameter in the request that will contain files */
  filesParam: PropTypes.string,

  /** Additional Headers added to the upload request */
  headers: PropTypes.object,

  /** Controls how files are uploaded to the endpoint. When true, each file will be uploaded separately showing progress and allow individual cancel */
  individualUpload: PropTypes.bool,

  /** Controls when the files will be uploaded. If true, then the upload request to the endpoint will be fired when user selects the files */
  uploadOnSelect: PropTypes.bool,

  /** fires when the the value of the field changes */
  onChange: PropTypes.func,

  /** Field Label */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** adds a red star to the label if set to true and no value exists */
  required: PropTypes.bool,

  /** Disabled the component */
  disabled: PropTypes.bool,

  /** Allows uploading multiple files */
  multi: PropTypes.bool,

  /** Fired when all files are uploaded to the endpoint. Returns the results of the endpoint */
  onUploadSuccess: PropTypes.func,

  /** Fired when upload is triggered manually by user */
  onUploadRequest: PropTypes.func,

  /** Fired if the an error code is received from the endpoint when uploading files */
  onUploadError: PropTypes.func
}, _defineProperty$k(_FileUpload$propTypes, "onChange", PropTypes.func), _defineProperty$k(_FileUpload$propTypes, "status", PropTypes.oneOf(['edit', 'uploading', 'readOnly'])), _defineProperty$k(_FileUpload$propTypes, "fileIcon", PropTypes.string), _defineProperty$k(_FileUpload$propTypes, "isCircle", PropTypes.bool), _defineProperty$k(_FileUpload$propTypes, "placeholder", PropTypes.string), _defineProperty$k(_FileUpload$propTypes, "imageUrl", PropTypes.string), _defineProperty$k(_FileUpload$propTypes, "isImageUpload", PropTypes.bool), _defineProperty$k(_FileUpload$propTypes, "limitSize", PropTypes.number), _FileUpload$propTypes);
FileUpload.defaultProps = {
  value: [],
  status: 'uploading',
  filesParam: 'files',
  fileIcon: 'document',
  instantUpload: true,
  multi: false,
  disabled: false,
  uploadOnSelect: false,
  placeholder: 'Drag files here or click to browse',
  changeLabel: 'Change',
  limitSize: 0,
  limitError: 'File too large to upload'
};
var Wrapper$1 = withTheme(FileUpload);

var _templateObject;
var GlobalStyles = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral$1(["\n  \n    ", "\n  \n    html, body{\n        height: 100%;\n        width: 100%;\n        font-family: 'Open Sans';\n        font-size: ", ";\n        font-weight: ", ";\n    }\n    html, body, div, span, applet, object, iframe,\n    h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n    a, abbr, acronym, address, big, cite, code,\n    del, dfn, em, img, ins, kbd, q, s, samp,\n    small, strike, strong, sub, sup, tt, var,\n    b, u, i, center,\n    dl, dt, dd, ol, ul, li,\n    fieldset, form, label, legend,\n    table, caption, tbody, tfoot, thead, tr, th, td,\n    article, aside, canvas, details, embed,\n    figure, figcaption, footer, header, hgroup,\n    menu, nav, output, ruby, section, summary,\n    time, mark, audio, video {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        vertical-align: baseline;\n    }\n\n    :focus {\n        outline: 0;\n    }\n\n    article, aside, details, figcaption, figure,\n    footer, header, hgroup, menu, nav, section {\n        display: block;\n    }\n\n    body {\n        line-height: 1;\n    }\n\n    ol, ul {\n        list-style: none;\n    }\n\n    blockquote, q {\n        quotes: none;\n    }\n\n    blockquote:before, blockquote:after,\n    q:before, q:after {\n        content: '';\n        content: none;\n    }\n\n    table {\n        border-collapse: collapse;\n        border-spacing: 0;\n    }\n\n    input[type=search]::-webkit-search-cancel-button,\n    input[type=search]::-webkit-search-decoration,\n    input[type=search]::-webkit-search-results-button,\n    input[type=search]::-webkit-search-results-decoration {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n    }\n\n    input[type=search] {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        -webkit-box-sizing: content-box;\n        -moz-box-sizing: content-box;\n        box-sizing: content-box;\n    }\n\n    textarea {\n        overflow: auto;\n        vertical-align: top;\n        resize: vertical;\n    }\n\n    audio,\n    canvas,\n    video {\n        display: inline-block;\n        *display: inline;\n        *zoom: 1;\n        max-width: 100%;\n    }\n\n    audio:not([controls]) {\n        display: none;\n        height: 0;\n    }\n\n    [hidden] {\n        display: none;\n    }\n\n    html {\n        font-size: 100%;\n        -webkit-text-size-adjust: 100%;\n        -ms-text-size-adjust: 100%;\n    }\n    a{\n        color: ", ";\n        text-decoration: ", ";\n    }\n    a:focus {\n        outline: thin dotted;\n    }\n\n    a:active,\n    a:hover {\n        outline: 0;\n    }\n\n    img {\n        border: 0;\n        -ms-interpolation-mode: bicubic;\n    }\n\n    figure {\n        margin: 0;\n    }\n\n    form {\n        margin: 0;\n    }\n\n    fieldset {\n        border: 1px solid #c0c0c0;\n        margin: 0 2px;\n        padding: 0.35em 0.625em 0.75em;\n    }\n\n    legend {\n        border: 0;\n        padding: 0;\n        white-space: normal;\n        *margin-left: -7px; \n    }\n\n    button,\n    input,\n    select,\n    textarea {\n        font-size: 100%;\n        margin: 0;\n        vertical-align: baseline; \n        *vertical-align: middle; \n    }\n\n    button,\n    input {\n        line-height: normal;\n    }\n\n    button,\n    select {\n        text-transform: none;\n    }\n\n    button,\n    html input[type=\"button\"],\n    input[type=\"reset\"],\n    input[type=\"submit\"] {\n        -webkit-appearance: button;\n        cursor: pointer; \n        overflow: visible;\n    }\n\n    button[disabled],\n    html input[disabled] {\n        cursor: default;\n    }\n\n    input[type=\"checkbox\"],\n    input[type=\"radio\"] {\n        box-sizing: border-box;\n        padding: 0;\n    }\n\n    input[type=\"search\"] {\n        -webkit-appearance: textfield;\n        -moz-box-sizing: content-box;\n        -webkit-box-sizing: content-box;\n        box-sizing: content-box;\n    }\n\n    input[type=\"search\"]::-webkit-search-cancel-button,\n    input[type=\"search\"]::-webkit-search-decoration {\n        -webkit-appearance: none;\n    }\n\n    button::-moz-focus-inner,\n    input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n    }\n\n    textarea {\n        overflow: auto;\n        vertical-align: top;\n    }\n\n    table {\n        border-collapse: collapse;\n        border-spacing: 0;\n    }\n\n    html,\n    button,\n    input,\n    select,\n    textarea {\n        color: #222;\n    }\n\n\n    ::-moz-selection {\n        background: #b3d4fc;\n        text-shadow: none;\n    }\n\n    ::selection {\n        background: #b3d4fc;\n        text-shadow: none;\n    }\n\n    img {\n        vertical-align: middle;\n    }\n\n    fieldset {\n        border: 0;\n        margin: 0;\n        padding: 0;\n    }\n\n    textarea {\n        resize: vertical;\n    }\n\n    .chromeframe {\n        margin: 0.2em 0;\n        background: #ccc;\n        color: #000;\n        padding: 0.2em 0;\n    }\n\n    *{\n        font-family: ", ";\n        font-size: ", ";\n\n        &, &:BEFORE, &:AFTER{\n        box-sizing: border-box;\n        }\n    }\n\n    h1,.h1{ font-size: calc(", " * 2.25)}\n    h2,.h2{ font-size: calc(", " * 2)}\n    h3,.h3{ font-size: calc(", " * 1.75)}\n    h4,.h4{ font-size: calc(", " * 1.5)}\n    h5,.h5{ font-size: calc(", " * 1.25)}\n    h6,.h6{ font-size: ", " }\n\n    h1,.h1,\n    h2,.h2,\n    h3,.h3,\n    h4,.h4,\n    h5,.h5,\n    h6,.h6{ \n        margin-top: 1.2em;\n        margin-bottom: 0.5em;\n    }\n\n    h2,.h2{ font-weight: 600;}\n    h3,.h3,\n    h4,.h4,\n    h5,.h5,\n    h6,.h6{ font-weight: normal}\n"])), function (props) {
  return props.font ? css$4(["", ";"], function (props) {
    return props.font;
  }) : css$4(["@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700&display=swap');@import url('https://fonts.googleapis.com/css?family=Rajdhani:300,700&display=swap');"]);
}, function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizeBase;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeight;
}, theme.anchorColor || theme.primary, theme.anchorTextDecoration, theme.fontFamily, theme.fontSize, theme.fontSizeBase, theme.fontSizeBase, theme.fontSizeBase, theme.fontSizeBase, theme.fontSizeBase, theme.fontSizeBase);
var Wrapper = withTheme(GlobalStyles);

export { Wrapper$$ as Accordion, Wrapper$X as Address, Wrapper$W as Alert, Wrapper$O as AsyncAutocomplete, Wrapper$N as Avatar, Wrapper$11 as Box, ButtonWrapper as Button, Wrapper$M as ButtonsToolbar, Wrapper$L as Card, Wrapper$Q as Checkbox, Wrapper$K as Chip, Wrapper$U as CircularLoader, Wrapper$J as CollapsingPanel, Wrapper$I as CustomDropList, Wrapper$H as DatePicker, Wrapper$G as DateRangePicker, Wrapper$F as DigitInput, Wrapper$B as Dimensions, Wrapper$S as DropList, Wrapper$C as DropdownButton, ErrorFocus, Wrapper$1 as FileUpload, Flag, Wrapper$12 as Flex, Wrapper$Y as FormLabel, FormStack, FormikHOC, Wrapper as GlobalStyles, Wrapper$A as Grid, Wrapper$Z as Icon, Image, Wrapper$y as ImageSlider, Wrapper$x as InputField, Wrapper$V as Label, Layout, Wrapper$T as LinearLoader, Wrapper$E as Menu, Wrapper$D as MenuItem, Wrapper$w as Modal, Notify as Notification, Wrapper$u as OptionsList, Wrapper$d as Pagination, Wrapper$s as PhoneInput, Wrapper$r as PriceInput, Wrapper$q as ProgressBar, Wrapper$p as ProgressCircle, Wrapper$o as ProgressGauge, Wrapper$n as ProgressLine, Wrapper$v as RadioButton, Wrapper$m as RichTextEditor, Wrapper$i as Row, Wrapper$P as SelectDropList, Wrapper$g as Sidepanel, Wrapper$f as Slider, StepperWrapper as Stepper, Wrapper$R as Switch, Wrapper$9 as Tab, Wrapper$a as Table, Wrapper$8 as Tabs, Textarea, ThemeContext$1 as ThemeContext, Wrapper$k as TimePicker, Wrapper$j as TimeRange, Wrapper$7 as TimeSchedule, Wrapper$5 as ToggleButton, Wrapper$6 as ToggleGroup, Wrapper$_ as Tooltip, Wrapper$4 as UnitInput, hexToRgb, invert, isDark, isLight, opacity, theme, tintColor, withData };
//# sourceMappingURL=index.es.js.map
